import { b as __assign, _ as __read, g as __rest, e as __awaiter, f as __generator, a as __spreadArray, h as _tslib } from './_tslib-7a01aab4.js';
import React, { useEffect, Fragment, useState, useMemo, useCallback, useRef, useLayoutEffect, useDebugValue, createElement, useContext, createContext, PureComponent, useTransition, memo } from 'react';
import { observer } from 'mobx-react-lite';
import { c as classNames } from './index-e609ebf3.js';
import { TranslationContext } from './shared/contexts/TranslationContext.js';
import './shared/contexts/StoreContext.js';
import './shared/core/enums/GameSpecificTypes.js';
import { UpdatedFreeBetDataItemKeys } from './shared/core/enums/MaxPayoutDataTypes.js';
import { MessageTypes } from './shared/core/enums/Chat.js';
import { GameModes } from './shared/core/enums/GameModes.js';
import { IconTypes } from './shared/core/enums/IconTypes.js';
import './shared/core/enums/BetStatus.js';
import './shared/core/enums/PopupTypes.js';
import './shared/core/enums/ApiVersion.js';
import './shared/core/enums/RoundStatus.js';
import { FreeBetsStatus } from './shared/core/enums/FreeBetsStatus.js';
import './shared/core/enums/SocketEvents.js';
import { TranslationKeys } from './shared/core/enums/TranslationKeys.js';
import './shared/core/enums/TimeoutMaxValue.js';
import { ApiServiceTypes } from './shared/core/enums/ApiServiceTypes.js';
import './shared/core/enums/EnvironmentTypes.js';
import './shared/core/enums/DefaultQueryValues.js';
import './shared/core/enums/FreeBetWinningType.js';
import { DefaultQueryParams } from './shared/core/enums/DefaultQueryParams.js';
import { betHistoryPagingDisable, BetHistoryFilterTypes } from './shared/core/enums/BetHistoryFilterTypes.js';
import { GameTheme, GameThemeNames, GameThemeTKeys } from './shared/core/enums/GameThemeTypes.js';
import './shared/core/enums/RequestStatus.js';
import './shared/core/enums/FetchDefaultPaths.js';
import { BetErrorMessages, notificationByResponseCode, BetResponseCode, BetResponseCodeForHideNotification, responseType } from './shared/core/enums/ResponseCodes.js';
import { o as betStore, D as userInfoStore, $ as gameConfigStore, w as lobbyStore, i as iframeService, y as platformMessageStore, r as popupStore, N as applicationStore, Q as userSettingsStore, p as parseNumberByPrecision, H as freeChipsStore, W as tableBetHistoryStore, K as statisticsStore, Y as profileAvatarStore, n as chatService, t as toFixed, m as multiply, z as freeBetStore, _ as loadingStore, a2 as betDataStore, e as environmentBuilder } from './validateBalanceOnBet-af4f4a9b.js';
import { chatStore } from './shared/core/store/chatStore.js';
import './shared/core/store/wageringStore.js';
import { roundInfoStore } from './shared/core/store/roundInfoStore.js';
import './shared/core/store/userCountStore.js';
import { gameResultStore } from './shared/core/store/gameResultStore.js';
import './shared/core/store/resultHashStore.js';
import { userWinCountStore } from './shared/core/store/userWinBetsStore.js';
import { notificationStore } from './shared/core/store/notificationStore.js';
import './shared/core/store/selectedResultInfoStore.js';
import { inputValidationStore } from './shared/core/store/forCrashGame/inputValidationStore.js';
import './shared/core/store/forCrashGame/totalBetStore.js';
import './shared/core/store/forCrashGame/resultReportStore.js';
import { gameStore } from './shared/core/store/forCrashGame/gameStore.js';
import { getAmountWithCurrency } from './shared/core/helpers/getAmountWithCurrency.js';
import './shared/core/services/liveConnection/types.js';
import 'axios';
import './shared/core/services/sound/types.js';
import './shared/core/services/sound/SoundService.js';
import './shared/core/services/sound/defaultSounds.js';
import './shared/core/services/api/types.js';
import { ApiServices } from './shared/core/services/ApiServices.js';
import { m as moment, D as DATE_FORMATS, g as getLocaleTimeWithMoment, a as getStartEndDay } from './momentFormat-e9197995.js';
import './shared/core/polyfill.js';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from './shared/hooks/useTranslation.js';
import './shared/core/enums/additionalInputValueChangingButtons.js';
import './shared/providers/storeProvider.js';
import './shared/containers/underMaintenanceContainer/index.js';
import './shared/containers/platformMessagesWrapper/index.js';
import { LobbyRoomWinner } from './table-line/table-components/lobby/web/lobbyRoomWinner/index.js';
import { maskName } from './shared/core/helpers/maskName.js';
import { exchangeAmountByRate } from './shared/core/helpers/exchangeAmountByRate.js';
import './shared/containers/localStoragePupUpWrapper/index.js';
import './shared/containers/gameDrawingWrapper/index.js';
import { getTranslationsWithRetry, getFileByName } from './shared/core/helpers/getDataHelper.js';
import { useAssetsLoadedState } from './shared/hooks/useAssetsLoadedState.js';
import { useDisableFullScreenShortcuts } from './shared/hooks/useDisableFullScreenShortcuts.js';
import { TableSlider } from './table-line/table-components/lobby/web/slider/index.js';
import { convertAmount } from './shared/core/helpers/convertAmount.js';
import { bogLineMinOdd, numPadTypes } from './shared/core/enums/BogLineGameConfig.js';
import { isMobile } from './shared/core/helpers/isMobile.js';
import { getLocaleTime } from './shared/core/helpers/getLocaleTime.js';
import './shared/containers/renderOdd/index.js';
import { FreeBetInfo } from './shared/components/free-bets/free-bet-info/index.js';
import { FreeBetsList } from './shared/components/free-bets/free-bets-list/index.js';
import { setTranslationValues } from './shared/core/helpers/setTranslationValues.js';
import { useClickOutside } from './shared/hooks/useClickOutside.js';
import { UserBlockFreeBet } from './shared/components/user-block/user-block-free-bet/index.js';
import { GameTypeLoading } from './shared/components/game-type-loading/index.js';
import SnowFlakes from './bog-line/components/snowFlakes/index.js';
import './bog-line/components/grids/common/pop-up-wr-component/index.js';
import './bog-line/components/list/list-item-with-image/index.js';
import { parseQuery } from './shared/core/helpers/parseQuery.js';
import { List } from './bog-line/components/list/list/index.js';
import { ListHeader } from './bog-line/components/list/list-header/index.js';
import { ListHeaderItem } from './bog-line/components/list/list-item-header/index.js';
import { ListBody } from './bog-line/components/list/list-body/index.js';
import './bog-line/components/loading/component/index.js';
import 'react-dom';
import { AboutHash } from './bog-line/components/popups/aboutHash.js';
import { copyToClipboard } from './shared/core/helpers/copyToClipboard.js';
import { rtlLanguages } from './shared/core/helpers/rtlCheckerAndSetter.js';
import { useOpenBetHistory } from './shared/hooks/useOpenBetHistory.js';
import { ColBodyInner } from './bog-line/components/grids/common/column-body-inner/index.js';
import { ColBodyInnerBottomWr } from './bog-line/components/grids/common/column-body-inner-bottom-wr/index.js';
import { ColBodyInnerTopWr } from './bog-line/components/grids/common/column-body-inner-top-wr/index.js';
import { Tabs } from './bog-line/components/tabs/tabs/index.js';
import { TabItem } from './bog-line/components/tabs/tab-item/index.js';
import { ColHeaderBlock } from './bog-line/components/grids/common/column-header-block/index.js';
import { ColHeaderBlockInner } from './bog-line/components/grids/common/column-header-block-inner/index.js';
import { IconBlock } from './bog-line/components/icon-block/index.js';
import { isIOS } from './shared/core/helpers/isIOS.js';
import { useOutsideClick } from './shared/hooks/useOutsideClick.js';
import { ColHeader } from './bog-line/components/grids/common/column-header/index.js';
import ChatActions from './bog-line/components/chat/chatActions/index.js';
import { HorizontalScroll } from './shared/containers/horizontalScrollWrapper/index.js';
import { a as getAugmentedNamespace } from './_commonjsHelpers-17aad09c.js';
import ChatLoader from './bog-line/components/chat/chatLoader/index.js';
import { ListHeaderFilter } from './bog-line/components/list/list-header-filter/index.js';
import { ListFilterHeaderItem } from './bog-line/components/list/list-item-header-filter/index.js';
import { WebGameColumn } from './bog-line/components/grids/web/game/column/index.js';
import { WebGameColumnInner } from './bog-line/components/grids/web/game/column-inner/index.js';
import { WebGameColMiddleWr } from './bog-line/components/grids/web/game/column-middle-wr/index.js';
import { WebGameColHeaderWr } from './bog-line/components/grids/web/game/column-header-wr/index.js';
import { UserInfo } from './bog-line/components/user-block/user-info/index.js';
import { UserContent } from './bog-line/components/user-block/user-content/index.js';
import { PlayForRealButton as PlayForRealButton$1 } from './bog-line/components/play-for-real-button/index.js';
import { WebGameColBodyWr } from './bog-line/components/grids/web/game/column-body/index.js';
import { checkScrollToBottom } from './shared/core/helpers/checkScrollToBottom.js';
import { GameScenes } from './shared/core/enums/GameSceneCodes.js';
import { NavItem } from './bog-line/components/navigation/nav-item/index.js';
import { NavRow } from './bog-line/components/navigation/nav-row/index.js';
import { MobileGameMainCont } from './bog-line/components/grids/mobile/game/main-cont/index.js';
import { MobileGameColumn } from './bog-line/components/grids/mobile/game/column/index.js';
import { ConnectionPopup } from './bog-line/components/notifications/connection-pop-up/index.js';
import { generateUId } from './shared/core/helpers/generateUId.js';
import { NumPadWr } from './shared/containers/bettingPart/numPadWr.js';
import { BetSectionsAvia } from './shared/containers/bettingPart/betingPartAvia.js';
import { LogoImg } from './table-line/table-components/header/web/logoImg/index.js';
import { NotificationTypeComponent } from './table-line/table-components/notification/notification-type-component/index.js';
import { NotificationWr } from './table-line/table-components/notification/notification-wr/index.js';
import { FullScreenWrapper } from './shared/containers/fullScreenWrapper/index.js';
import { FooterUserInfoColumn } from './table-line/table-components/footer/web/footerUserInfoColumn/index.js';
import { TableLoading } from './table-line/table-components/loading/index.js';
import { SettingRowColumn } from './table-line/table-components/setting/settingRowColumn/index.js';
import { RightSideIcon } from './table-line/table-components/rightSide/rightSideIcon/index.js';
import { MobileNavigationRow } from './table-line/table-components/rightSide/mobileNavigationRow/index.js';
import { AccordionItem } from './table-line/table-components/accordion/accordionItem.js';
import { PopUps } from './table-line/t_types/enums/PopupTypes.js';
import { cleanGameTypeIdFromQuery } from './shared/core/helpers/cleanGameTypeIdFromQuery.js';
import { useLobbyStore } from './shared/hooks/useLobbyStore.js';
import { useUserInfoStore } from './shared/hooks/useUserInfoStore.js';
import './table-line/t_types/enums/BetResponseCode.js';
import './table-line/t_types/enums/BetErrorMessages.js';
import './table-line/t_types/enums/NotificationByResponseCode.js';
import { FreeChipPopupActions, FreeChipNames } from './table-line/t_types/enums/FreeChipTypes.js';
import { SettingButton } from './table-line/table-components/lobby/web/settingsButton/index.js';
import { HeaderWr } from './table-line/table-components/header/web/headerWr/index.js';
import { HeaderColumn } from './table-line/table-components/header/web/headerColumn/index.js';
import { FairnessButton } from './table-line/table-components/header/web/fairnessButton/index.js';
import { GameControllerTypes } from './table-line/t_types/enums/GameControllerTypes.js';
import { GameControllersWr } from './table-line/table-components/gameController/gameControllersWr/index.js';
import { GameControllersHead } from './table-line/table-components/gameController/gameControllersHead/index.js';
import { GameControllersContent } from './table-line/table-components/gameController/gameControllersContent/index.js';
import { GAME_CONTROLLER_TYPES } from './shared/core/enums/gameControllerTypes.js';
import { GameControllersFooter } from './table-line/table-components/gameController/gameControllersFooter/index.js';
import { useRoundInfoStore } from './shared/hooks/useRoundInfoStore.js';
import { useUserCountStore } from './shared/hooks/useUserCountStore.js';
import { useApplicationStore } from './shared/hooks/useApplicationStore.js';
import { MobileStructureBottom } from './table-line/table-components/grids/mobile/structureBottom/index.js';
import { MobileFooterWr } from './table-line/table-components/footer/mobile/footer-wr/index.js';
import { MobileFooterColumn } from './table-line/table-components/footer/mobile/footer-column/index.js';
import { MobileUserBalanceAndTotalBet } from './table-line/table-components/footer/mobile/userBalanceAndTotalBet/index.js';
import { FooterInfoSpan } from './table-line/table-components/footer/web/footerInfoSpan/index.js';
import { FooterInfo } from './table-line/table-components/footer/web/footerInfo/index.js';
import { FooterColumn } from './table-line/table-components/footer/web/footerColumn/index.js';
import { FooterUserInfo } from './table-line/table-components/footer/web/footerUserInfo/index.js';
import { FooterContainer } from './table-line/table-components/footer/web/footerContainer/index.js';
import { UserBalanceAndTotalBetAmount } from './table-line/table-components/footer/web/userBalanceAndTotalBetAmount/index.js';
import { PlayForRealButtonHolder } from './table-line/table-components/footer/web/playForRealButtonHolder/index.js';
import { SettingsWr } from './table-line/table-components/setting/settingWr/index.js';
import { SettingRow } from './table-line/table-components/setting/settingRow/index.js';
import { OverlayLabel } from './table-line/table-components/overlay/overlayLabel/index.js';
import { OverlayLabels } from './table-line/table-components/overlay/overlayLabels/index.js';
import { OverlayList } from './table-line/table-components/overlay/overlayListWr/index.js';
import { OverlayItem } from './table-line/table-components/overlay/overlayItem/index.js';
import { OverlayItemContent } from './table-line/table-components/overlay/overlayItemContent/index.js';
import { OverlayFooter } from './table-line/table-components/overlay/overlayFooter/index.js';
import { MobileStructureTop } from './table-line/table-components/grids/mobile/structureTop/index.js';
import { MobileGameId } from './table-line/table-components/header/mobile/gameId/index.js';
import { MobileHeaderWr } from './table-line/table-components/header/mobile/headerWr/index.js';
import { MobileHeaderLogo } from './table-line/table-components/header/mobile/headerLogo/index.js';
import { MobileHeaderColumn } from './table-line/table-components/header/mobile/headerColumn/index.js';
import { MobileFairnessButton } from './table-line/table-components/header/mobile/fairnessButton/index.js';
import { MobilePlayForRealButtonHolder } from './table-line/table-components/header/mobile/playForRealButtonHolder/index.js';
import { abbreviateNumber } from './shared/core/helpers/abbreviateNumber.js';
import { MobileMinMaxBet } from './table-line/table-components/header/mobile/minMaxBet/index.js';
import { usePopupStore } from './shared/hooks/usePopUpStore.js';
import { TableConnectionPopUp } from './table-line/table-components/notification/connectionPopUp/index.js';
import { useSelectedResultInfoStore } from './shared/hooks/useSelectedResultInfoStore.js';
import { useInfiniteScroll } from './shared/hooks/useInfiniteScroll.js';
import { Accordion } from './table-line/table-components/accordion/accordion.js';
import { translateMonth } from './shared/core/helpers/translateMonth.js';

var CurrentWinners = observer(function (_a) {
    var _b = _a.imgSrc, imgSrc = _b === void 0 ? '' : _b;
    var currentWinners = betStore.currentWinners;
    var currencySymbolOrCode = userInfoStore.currencySymbolOrCode;
    var t = useTranslation();
    return (React.createElement(React.Fragment, null, currentWinners.map(function (bet, i) { return (React.createElement(LobbyRoomWinner, { key: bet.id, playerIdText: "".concat(t(TranslationKeys.PlayerId), ": ").concat(maskName(bet.playerExternalId)), betAmountText: "".concat(t(TranslationKeys.Bet), ": ").concat(exchangeAmountByRate(bet).amount, " ").concat(currencySymbolOrCode), imgSrc: imgSrc, winAmountText: "".concat(t(TranslationKeys.Win), ": ").concat(exchangeAmountByRate(bet).winAmount, "  ").concat(currencySymbolOrCode, " ") })); })));
});

var ChangeGameTypeSection = observer(function (_a) {
    var _b = _a.iconName, iconName = _b === void 0 ? 'lobby2' : _b;
    var limits = gameConfigStore.limits;
    var currencySymbolOrCode = userInfoStore.currencySymbolOrCode;
    var setIsShowLobbySelectGameType = lobbyStore.setIsShowLobbySelectGameType;
    var t = useTranslation();
    return (React.createElement("div", { className: 'pgc-web-head-left-cont', onClick: function () { return setIsShowLobbySelectGameType(true); } },
        React.createElement("div", { className: 'pgc-web-head-left-cont-inner' },
            React.createElement("div", { className: 'pgc-left-lobby-around' },
                React.createElement("div", { className: 'pgc-left-lobby-around-inner' },
                    React.createElement("i", { className: "icon-".concat(iconName) }))),
            React.createElement("div", { className: 'pgc-head-text-cont' },
                React.createElement("p", { className: 'pgc-m-game-bet-txt' },
                    t(TranslationKeys.Min),
                    " - ",
                    t(TranslationKeys.Max)),
                React.createElement("p", { className: 'pgc-m-game-bet-txt-num' }, limits === null || limits === void 0 ? void 0 :
                    limits.minBet,
                    " - ", limits === null || limits === void 0 ? void 0 :
                    limits.maxBet,
                    " ",
                    currencySymbolOrCode)))));
});

var MobileLobbyHeader = observer(function (_a) {
    var gameLogo = _a.gameLogo;
    var t = useTranslation();
    var userId = userInfoStore.userId, balance = userInfoStore.balance, currencySymbolOrCode = userInfoStore.currencySymbolOrCode;
    return (React.createElement("div", { className: 'pgc-m-lobby-head' },
        React.createElement("button", { className: 'pgc-m-lobby-back', onClick: function () { return iframeService.exitGame(); } },
            React.createElement("i", { className: 'icon-arrow-left' })),
        gameLogo && React.createElement(LogoImg, { src: gameLogo }),
        userId && (React.createElement("div", { className: 'pgc-m-balance' },
            React.createElement("span", { className: 'pgc-m-balance-name' }, t(TranslationKeys.Balance)),
            React.createElement("p", { className: 'pgc-m-balance-money' },
                React.createElement("span", null, convertAmount(balance)),
                React.createElement("span", null, currencySymbolOrCode))))));
});

var LobbyTimer = observer(function (_a) {
    var gameTypeId = _a.gameTypeId;
    var t = useTranslation();
    var roundState = lobbyStore.lobbyDurationsByGameTypeId;
    return (React.createElement("div", { className: 'pgc-lotto-lobby-countdown' }, roundState[gameTypeId] > 0
        ? React.createElement("span", { className: 'pgc-lobby-countdown-timer' }, moment(roundState[gameTypeId] * 1000).format('mm:ss'))
        : React.createElement("span", { className: 'pgc-lobby-countdown-txt' },
            " ",
            t('ONGOING'))));
});

var LobbyRoom = function (_a) {
    var activeUsersCount = _a.activeUsersCount, minBetText = _a.minBetText, minBetAmount = _a.minBetAmount, maxBetText = _a.maxBetText, isShowRoundState = _a.isShowRoundState; _a.maxWinAmount; var maxBetAmount = _a.maxBetAmount, playNowText = _a.playNowText, isShowPlayDemo = _a.isShowPlayDemo, btnValue = _a.btnValue, onClick = _a.onClick, playDemoText = _a.playDemoText, currencyCode = _a.currencyCode, name = _a.name, bgImage = _a.bgImage, hasVideo = _a.hasVideo, isShowPlayNow = _a.isShowPlayNow, isShowGameTypeName = _a.isShowGameTypeName;
    return (React.createElement("div", { className: 'pgc-lobby-room' },
        hasVideo ? (React.createElement("video", { src: bgImage, autoPlay: true, loop: true, muted: true, className: 'pgc-lobby-room-img', playsInline: true })) : (React.createElement("img", { src: bgImage, alt: '', className: 'pgc-lobby-room-img' })),
        React.createElement("div", { className: 'pgc-room-head' },
            React.createElement("p", { className: 'pgc-room-name' }, isShowGameTypeName ? name : ''),
            React.createElement("div", { className: 'pgc-room-users-count' }, activeUsersCount ? (React.createElement(React.Fragment, null,
                React.createElement("i", { className: 'icon-user' }),
                React.createElement("span", null, activeUsersCount))) : null)),
        React.createElement("div", { className: 'pgc-room-center' },
            React.createElement("div", { className: 'room-money' }),
            isShowRoundState && React.createElement(LobbyTimer, { gameTypeId: btnValue })),
        React.createElement("div", { className: 'pgc-room-bottom' },
            React.createElement("div", { className: 'pgc-room-buttons' },
                isShowPlayDemo && (React.createElement("button", { className: 'pgc-button type-1', value: btnValue, onClick: onClick, name: "".concat(name, "_demo") }, playDemoText)),
                isShowPlayNow && (React.createElement("button", { className: "pgc-button type-2 ".concat(name.split(' ').join('-').toLowerCase()), value: btnValue, onClick: onClick, name: name }, playNowText))),
            React.createElement("div", { className: 'pgc-room-info-row' },
                React.createElement("div", { className: 'pgc-room-info-column' },
                    React.createElement("span", { className: 'pgc-room-info-max-min-text' },
                        minBetText,
                        "/",
                        maxBetText),
                    React.createElement("span", { className: 'pgc-room-info-max-min-money' },
                        minBetAmount,
                        " / ",
                        maxBetAmount,
                        " ",
                        currencyCode))))));
};

var CoreBetErrorMessages$1, CoreNotificationByResponseCode$1, CoreBetResponseCode$1;
var extractNotificationCode = function (notificationCode) {
    if (typeof notificationCode === 'number') {
        return notificationCode;
    }
    if (notificationCode !== null && typeof notificationCode === 'object' && notificationCode.responseCode) {
        return notificationCode.responseCode;
    }
    return null;
};
var TableBetNotification = observer(function (_a) {
    var _b = _a.translationValues, translationValues = _b === void 0 ? {} : _b, _c = _a.AdditionalErrorMessages, AdditionalErrorMessages = _c === void 0 ? {} : _c, _d = _a.AdditionalNotificationByResponseCode, AdditionalNotificationByResponseCode = _d === void 0 ? {} : _d, _e = _a.AdditionalResponseCode, AdditionalResponseCode = _e === void 0 ? {} : _e, callbackForNotificationIconClick = _a.callbackForNotificationIconClick;
    var codeData = notificationStore.notificationCode, operatorErrorMessage = notificationStore.operatorErrorMessage;
    var notificationCode = extractNotificationCode(codeData);
    var isShowAllNotification = platformMessageStore.isShowAllNotification, operatorCode = platformMessageStore.operatorCode, isDoBetResultValidated = platformMessageStore.isDoBetResultValidated, isUsedBogLineComponents = platformMessageStore.isUsedBogLineComponents;
    var underMaintenanceSeconds = popupStore.underMaintenanceSeconds, underMaintenance = popupStore.underMaintenance;
    var isBogLine = applicationStore.isBogLine;
    var t = useTranslation();
    CoreBetErrorMessages$1 = __assign(__assign({}, BetErrorMessages), AdditionalErrorMessages);
    CoreNotificationByResponseCode$1 = __assign(__assign({}, notificationByResponseCode), AdditionalNotificationByResponseCode);
    CoreBetResponseCode$1 = __assign(__assign({}, BetResponseCode), AdditionalResponseCode);
    var isShowNotification = (isShowAllNotification && notificationCode !== null) ||
        (!isShowAllNotification &&
            notificationCode !== null &&
            !BetResponseCodeForHideNotification.includes(notificationCode));
    var handleIconClick = function () {
        if (isBogLine && !isUsedBogLineComponents) {
            if (CoreNotificationByResponseCode$1[CoreBetResponseCode$1[notificationCode]] === 'error') {
                notificationStore.setNotificationType(null);
            }
            callbackForNotificationIconClick && callbackForNotificationIconClick();
        }
    };
    useEffect(function () {
        if (!isShowAllNotification && notificationCode !== null && isDoBetResultValidated) {
            iframeService.sendErrorReceived({
                errorCode: operatorCode || notificationCode,
                errorMessage: t(CoreBetErrorMessages$1[CoreBetResponseCode$1[notificationCode]], __assign({}, translationValues)),
            });
            platformMessageStore.setIsDoBetResultValidated(false);
            platformMessageStore.setOperatorCode(null);
        }
    }, [operatorCode, isShowAllNotification, notificationCode, isDoBetResultValidated]);
    useEffect(function () {
        notificationStore.clearNotificationTimerId();
        notificationStore.notTimerId = setTimeout(function () {
            notificationStore.resetNotificationType();
        }, 3000);
    }, [notificationCode]);
    return ((isShowNotification || underMaintenance || operatorErrorMessage) && (React.createElement(NotificationWr, null,
        isShowAllNotification && !!operatorErrorMessage && (React.createElement(NotificationTypeComponent, { handleIconClick: function () { return notificationStore.resetOperatorErrorMessage(); }, type: notificationByResponseCode.GeneralError, message: operatorErrorMessage })),
        isShowNotification && (React.createElement(NotificationTypeComponent, { handleIconClick: handleIconClick, type: CoreNotificationByResponseCode$1[CoreBetResponseCode$1[notificationCode]], message: t(CoreBetErrorMessages$1[CoreBetResponseCode$1[notificationCode]], __assign({}, translationValues)) })),
        underMaintenance ? (React.createElement(NotificationTypeComponent, { type: notificationByResponseCode.MaintenanceTable, message: t(CoreBetErrorMessages$1[CoreBetResponseCode$1[CoreBetResponseCode$1.UnderMaintenanceNote]], __assign(__assign({}, translationValues), { value: "".concat(underMaintenanceSeconds) })) })) : null)));
});

// @ts-ignore
var MainWr = observer(function (_a) {
    var children = _a.children;
    var gameThemeConfigs = userSettingsStore.gameThemeConfigs;
    return (React.createElement(FullScreenWrapper, null,
        gameThemeConfigs.isEnabled && GameTheme[gameThemeConfigs.themeType] === GameThemeNames.Winter ? (React.createElement(SnowFlakes, null)) : null,
        React.createElement("div", { className: 'pgc-main-wrapper' }, children)));
});

var RoundId = function (_a) {
    var id = _a.id;
    var t = useTranslation();
    return (React.createElement(Fragment, null,
        React.createElement(FooterInfoSpan, { text: t(TranslationKeys.RoundId) }),
        React.createElement(FooterInfoSpan, { text: id, lessOpacity: true })));
};

var CurrentTime = function () {
    var _a = __read(useState(getLocaleTime()), 2), currentTime = _a[0], setCurrentTime = _a[1];
    var t = useTranslation();
    useEffect(function () {
        var intervalId = setInterval(function () {
            setCurrentTime(getLocaleTime());
        }, 1000);
        return function () {
            clearInterval(intervalId);
        };
    }, []);
    return (React.createElement(Fragment, null,
        React.createElement(FooterInfoSpan, { text: "".concat(t(TranslationKeys.Time), ":") }),
        React.createElement(FooterInfoSpan, { text: currentTime, lessOpacity: true })));
};

var PlayingUsersCount = function (_a) {
    var count = _a.count;
    useTranslation();
    return (React.createElement(FooterUserInfoColumn.Div, null,
        React.createElement(FooterUserInfoColumn.Icon, null),
        React.createElement(FooterUserInfoColumn.Span, { text: "".concat(count ? count : '') })));
};

var OverlayItemHeader = function (_a) {
    var title = _a.title, columns = _a.columns, onClose = _a.onClose;
    var t = useTranslation();
    return (React.createElement("div", { className: 'pgc-overlay-head' },
        React.createElement("div", { className: 'pgc-overlay-top-row' },
            React.createElement("div", { className: 'pgc-overlay-top-row-first-block' },
                React.createElement("i", { className: 'icon-results' })),
            React.createElement("p", { className: 'pgc-overlay-text' }, title),
            React.createElement("div", { onClick: onClose, className: 'pgc-overlay-top-row-close-block' },
                React.createElement("i", { className: 'icon-close' }))),
        React.createElement("div", { className: 'pgc-overlay-types' }, columns.map(function (colName) { return (React.createElement("span", { key: colName, className: 'pgc-overlay-types-text' }, t(colName))); }))));
};

var TablePopUpWr = observer(function (_a) {
    var isConnectionPopup = _a.isConnectionPopup, _b = _a.isShowCloseIcon, isShowCloseIcon = _b === void 0 ? true : _b, children = _a.children, _c = _a.title, title = _c === void 0 ? 'pop-up title' : _c; __rest(_a, ["isConnectionPopup", "isShowCloseIcon", "children", "title"]);
    var close = popupStore.close;
    var t = useTranslation();
    return (React.createElement("div", { className: "pgc-popup-container ".concat(isConnectionPopup ? 'connection-popup' : '') },
        React.createElement("div", { className: 'pgc-popup-content' },
            React.createElement("div", { className: 'pgc-popup-head' },
                React.createElement("h3", { className: 'pgc-popup-name' }, t(title)),
                isShowCloseIcon && (React.createElement("button", { className: 'pgc-popup-close', onClick: close },
                    React.createElement("i", { className: 'icon-close' })))),
            React.createElement("div", { className: 'pgc-popup-section' },
                React.createElement("div", { className: 'pgc-popup-scrollable-container' }, children)))));
});

var TableMobileNavigation = function (_a) {
    var t = _a.t, onClose = _a.onClose, children = _a.children;
    return (React.createElement("div", { className: 'pgc-mobile-navigation' },
        React.createElement("div", { className: 'pgc-top-mobile-navigation' },
            React.createElement("div", { className: 'pgc-mobile-navigation-row' },
                React.createElement("div", { className: 'pgc-mobile-navigation-title' },
                    React.createElement("p", null, t(TranslationKeys.Menu))),
                React.createElement("div", { className: 'pgc-mobile-navigation-icon-b', onClick: onClose },
                    React.createElement("i", { className: 'icon-close' })))),
        React.createElement("div", { className: 'pgc-bottom-mobile-navigation' },
            React.createElement("div", { className: 'pgc-popup-scrollable-container' },
                React.createElement("div", { className: 'pgc-nav-rows-wrapper' }, children)))));
};

var RightSideHolder = observer(function (_a) {
    var navigationItems = _a.navigationItems, _b = _a.hasLobby, hasLobby = _b === void 0 ? true : _b;
    var _c = __read(useState(false), 2), activeOverlay = _c[0], setActiveOverlay = _c[1];
    var t = useTranslation();
    var isOpenOddsSection = platformMessageStore.isOpenOddsSection;
    var isShowSideBarButton = gameConfigStore.isShowSideBarButton;
    var setIsShowLobbySelectGameType = lobbyStore.setIsShowLobbySelectGameType;
    var handleOnClose = function () {
        setActiveOverlay(false);
    };
    useEffect(function () {
        var payTableOption = navigationItems.find(function (item) { return item.isPayTable; });
        if (payTableOption) {
            if (isOpenOddsSection) {
                // @ts-ignore
                payTableOption.onClick();
            }
            else {
                handleOnClose();
            }
        }
        // else {
        //   if (isOpenOddsSection) {
        //     platformMessageStore.setIsOpenGameHelpSection(true);
        //   }
        // }
    }, [navigationItems, isOpenOddsSection]);
    return (React.createElement("div", { className: 'pgc-right-side-holder' },
        activeOverlay && (React.createElement(TableMobileNavigation, { t: t, onClose: handleOnClose },
            React.createElement(MobileNavigationRow, { key: TranslationKeys.Home, name: TranslationKeys.Home, icon: 'icon-home1', isDisabled: false, onClick: function () { return iframeService.exitGame(); } }),
            hasLobby && isShowSideBarButton && (React.createElement(MobileNavigationRow, { key: TranslationKeys.GameTypes, name: TranslationKeys.GameTypes, icon: 'icon-lobby2', isDisabled: false, onClick: function () { return setIsShowLobbySelectGameType(true); } })),
            navigationItems.map(function (_a) {
                var icon = _a.icon, name = _a.name, isDisabled = _a.isDisabled, onClick = _a.onClick;
                return (React.createElement(MobileNavigationRow, { key: name, name: name, icon: icon, isDisabled: isDisabled, onClick: isDisabled ? function () { } : onClick }));
            }))),
        React.createElement(RightSideIcon, { setActiveOverlay: setActiveOverlay })));
});

var FairnessFormGroupWr = function (_a) {
    var t = _a.t, checkKeyValue = _a.checkKeyValue, isShowCopyIcon = _a.isShowCopyIcon, checkSaltValue = _a.checkSaltValue, checkHashValue = _a.checkHashValue, handleCheckHash = _a.handleCheckHash, setCheckSaltValue = _a.setCheckSaltValue, setCheckKeyValue = _a.setCheckKeyValue, isShowCheckButton = _a.isShowCheckButton, isDisabled = _a.isDisabled, isShowAboutHash = _a.isShowAboutHash, handleShowAboutHash = _a.handleShowAboutHash, AboutHashComp = _a.aboutHashComp, toggle = _a.toggle, scrollRef = _a.scrollRef;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'pgc-form-wr-holder' },
            React.createElement("div", { className: 'pgc-form-wr' },
                React.createElement("div", { className: 'pgc-form-input-holder' },
                    isShowCopyIcon && (React.createElement("div", { onClick: function () {
                            setCheckKeyValue(checkKeyValue);
                            copyToClipboard(checkKeyValue);
                        }, className: 'pgc-input-copy' },
                        React.createElement("i", { className: "icon-copy" }))),
                    React.createElement("input", { className: 'pgc-form-input', type: 'text', placeholder: ' ', readOnly: isDisabled, value: checkKeyValue, title: t("KEY" /* TKeys.KEY */), onChange: function (_a) {
                            var value = _a.target.value;
                            return setCheckKeyValue(value);
                        } }),
                    React.createElement("span", { className: 'pgc-form-label' }, t("KEY" /* TKeys.KEY */))),
                React.createElement("div", { className: 'pgc-form-input-holder' },
                    isShowCopyIcon && (React.createElement("div", { onClick: function () {
                            setCheckSaltValue(checkSaltValue);
                            copyToClipboard(checkSaltValue);
                        }, className: 'pgc-input-copy' },
                        React.createElement("i", { className: "icon-copy" }))),
                    React.createElement("input", { className: 'pgc-form-input', placeholder: ' ', type: 'text', readOnly: isDisabled, title: t("SALT" /* TKeys.SALT */), value: checkSaltValue, onChange: function (_a) {
                            var value = _a.target.value;
                            return setCheckSaltValue(value);
                        } }),
                    React.createElement("span", { className: 'pgc-form-label' }, t("SALT" /* TKeys.SALT */)))),
            React.createElement("div", { className: 'pgc-form-wr' },
                React.createElement("div", { className: 'pgc-form-input-holder' },
                    isShowCopyIcon && (React.createElement("div", { onClick: function () {
                            copyToClipboard(checkHashValue);
                        }, className: 'pgc-input-copy' },
                        React.createElement("i", { className: "icon-copy" }))),
                    React.createElement("input", { className: 'pgc-form-input', type: 'text', disabled: true, placeholder: ' ', title: t("HASH_CODE" /* TKeys.HASH_CODE */), value: checkHashValue }),
                    React.createElement("span", { className: 'pgc-form-label' }, t("HASH_CODE" /* TKeys.HASH_CODE */)))),
            isShowCheckButton && (React.createElement("div", { className: 'pgc-form-btn-holder' },
                React.createElement("button", { className: 'pgc-form-check-button', disabled: !(checkKeyValue && checkSaltValue), onClick: handleCheckHash }, t('CHECK')))),
            isShowAboutHash && (React.createElement("button", { className: 'pgc-about-hash-button', onClick: handleShowAboutHash }, t("ABOUT_HASH_CODE" /* TKeys.ABOUT_HASH_CODE */)))),
        toggle ? React.createElement(AboutHashComp, { scrollRef: scrollRef }) : null));
};

var TableUsersWinBets = observer(function () {
    var currencySymbolOrCode = userInfoStore.currencySymbolOrCode, precision = userInfoStore.precision;
    var userWiningBets = userWinCountStore.userWiningBets;
    var t = useTranslation();
    var total = useMemo(function () {
        return (userWiningBets &&
            userWiningBets.reduce(function (acc, bet) {
                acc += exchangeAmountByRate(bet).winAmount;
                return acc;
            }, 0));
    }, [userWiningBets]);
    return (React.createElement(React.Fragment, null, userWiningBets && (React.createElement("div", { className: 'pgc-winner-list-wrapper' },
        React.createElement("div", { className: 'pgc-winner-list-content-wrapper' },
            React.createElement("div", { className: 'pgc-winner-list-content-inner' },
                React.createElement("div", { className: 'pgc-winner-list-content-holder' },
                    React.createElement("div", { className: 'pgc-winner-list-header' },
                        React.createElement("p", { className: 'pgc-winner-list-header-col type-1' }, userWiningBets.length),
                        React.createElement("div", { className: 'pgc-winner-list-header-icon' },
                            React.createElement("i", { className: 'icon-users' })),
                        React.createElement("p", { className: 'pgc-winner-list-header-col type-1' }, t('WON')),
                        React.createElement("p", { className: 'pgc-winner-list-header-col type-2' },
                            parseNumberByPrecision(1, total, +precision),
                            " ",
                            currencySymbolOrCode)),
                    userWiningBets.map(function (bet) { return (React.createElement(UserWinBet, { exchangeBet: exchangeAmountByRate(bet), precision: precision, currencySymbolOrCode: currencySymbolOrCode, userId: bet.userId, t: t, key: bet.id })); }))))))));
});
var UserWinBet = function (_a) {
    var exchangeBet = _a.exchangeBet, userId = _a.userId, t = _a.t, currencySymbolOrCode = _a.currencySymbolOrCode, precision = _a.precision;
    return (React.createElement("div", { className: 'pgc-winner-list-row-inner' },
        React.createElement("p", { className: 'pgc-winner-list-row-item' },
            parseNumberByPrecision(1, exchangeBet.winAmount, precision),
            " ",
            currencySymbolOrCode,
            ' '),
        React.createElement("p", { className: 'pgc-winner-list-row-item' }, t('ID')),
        React.createElement("p", { className: 'pgc-winner-list-row-item' }, maskName(userId))));
};

var LobbyRoomRow = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: isMobile() ? 'pgc-m-lobby-room-wr' : 'pgc-lobby-rooms-row' }, children);
};

var LobbyRoomsContainer = observer(function (_a) {
    var hasVideo = _a.hasVideo, isShowRoundState = _a.isShowRoundState, lobbyRoomImages = _a.lobbyRoomImages, isShowGameTypeName = _a.isShowGameTypeName;
    var t = useTranslation();
    var navigate = useNavigate();
    var _b = useLocation(), pathname = _b.pathname, search = _b.search;
    var setIsDemo = applicationStore.setIsDemo, isGuest = applicationStore.isGuest, isTestPlatform = applicationStore.isTestPlatform, setAlreadyRedirectedToGame = applicationStore.setAlreadyRedirectedToGame, alreadyRedirectedToGame = applicationStore.alreadyRedirectedToGame, isAuthenticated = applicationStore.isAuthenticated, isAuthDataReceived = applicationStore.isAuthDataReceived;
    var _c = useLobbyStore(), hasDemo = _c.hasDemo, gameTypes = _c.gameTypes, setRoomName = _c.setRoomName;
    var _d = useUserInfoStore(), currencySymbolOrCode = _d.currencySymbolOrCode, userId = _d.userId;
    var setGameTypeId = gameConfigStore.setGameTypeId, isSkipLobby = gameConfigStore.isSkipLobby, setIsSkipLobby = gameConfigStore.setIsSkipLobby;
    var _e = parseQuery(window.location.search), _f = DefaultQueryParams.RealModeSwitcher, hasRealModeSwitcher = _e[_f], _g = DefaultQueryParams.Mode, mode = _e[_g];
    useEffect(function () {
        if (isAuthDataReceived) {
            if (isSkipLobby) {
                setIsDemo(!isAuthenticated);
                setAlreadyRedirectedToGame(true);
                navigate("".concat(pathname, "game").concat(search));
            }
            else {
                setGameTypeId(null);
                setIsDemo(!isAuthenticated);
                var newQuerySearch = cleanGameTypeIdFromQuery(search);
                navigate("".concat(pathname).concat(newQuerySearch));
            }
        }
    }, [isSkipLobby, isAuthenticated, search, navigate, pathname, isAuthDataReceived]);
    useEffect(function () {
        var _a, _b;
        if (mode === GameModes.Fun && !alreadyRedirectedToGame && gameTypes && gameTypes.length && !isSkipLobby) {
            setRoomName(((_a = gameTypes[0]) === null || _a === void 0 ? void 0 : _a.room) || ((_b = gameTypes[0]) === null || _b === void 0 ? void 0 : _b.name));
            setIsSkipLobby(true);
            setAlreadyRedirectedToGame(true);
            setIsDemo(true);
            var updatedSearch = "".concat(search, "&gameTypeId=").concat(gameTypes[0].gameTypeId);
            navigate("".concat(pathname, "game").concat(updatedSearch));
        }
    }, [isSkipLobby, gameTypes, pathname, setIsSkipLobby, alreadyRedirectedToGame, search]);
    var play = useCallback(function (ev) {
        var roomName = ev.target.name.split('_demo')[0];
        if (ev.target.name.includes('demo')) {
            setIsDemo(true);
            setRoomName(roomName);
            setGameTypeId(+ev.target.value);
            navigate("".concat(pathname, "game").concat(search, "&gameTypeId=").concat(ev.target.value, "&roomName=").concat(roomName));
        }
        else if (userId || isGuest) {
            setIsDemo(false);
            setRoomName(roomName);
            setGameTypeId(+ev.target.value);
            navigate("".concat(pathname, "game").concat(search, "&gameTypeId=").concat(ev.target.value, "&roomName=").concat(roomName));
        }
        else {
            iframeService.sendLoginCheck();
        }
    }, [navigate, search, userId]);
    return (React.createElement(LobbyRoomRow, null, gameTypes.map(function (_a) {
        var maxWin = _a.maxWin, minBet = _a.minBet, maxBet = _a.maxBet, gameTypeId = _a.gameTypeId, room = _a.room, name = _a.name, activeUsersCount = _a.activeUsersCount;
        return (React.createElement(LobbyRoom, { onClick: play, key: gameTypeId, hasVideo: hasVideo, name: room || name, btnValue: gameTypeId, minBetText: t('MIN'), maxBetText: t('MAX'), playDemoText: t('DEMO'), playNowText: t('PLAY_NOW'), maxWinText: t('MAXIMUM_WIN'), currencyCode: currencySymbolOrCode, isShowRoundState: isShowRoundState, maxBetAmount: convertAmount(maxBet), maxWinAmount: convertAmount(maxWin), minBetAmount: convertAmount(minBet), isShowGameTypeName: isShowGameTypeName, activeUsersCount: activeUsersCount !== 0 ? activeUsersCount : null, bgImage: lobbyRoomImages && lobbyRoomImages[(room || name).replace(/\s/g, '').toLowerCase()], isShowPlayDemo: Number(hasRealModeSwitcher) ? mode === GameModes.Fun : hasDemo, isShowPlayNow: Number(hasRealModeSwitcher) ? mode === GameModes.Real : !isTestPlatform }));
    })));
});

var FreeChipsWinPopup = observer(function () {
    var freeChipPopupName = freeChipsStore.freeChipPopupName, freeChipAwardedOrEnded = freeChipsStore.freeChipAwardedOrEnded, sendClaimFreeBet = freeChipsStore.sendClaimFreeBet, setActiveFreeChip = freeChipsStore.setActiveFreeChip, setFreeChipInLobby = freeChipsStore.setFreeChipInLobby;
    var currencySymbolOrCode = userInfoStore.currencySymbolOrCode;
    var gameTypes = lobbyStore.gameTypes, setRoomName = lobbyStore.setRoomName;
    var setGameTypeId = gameConfigStore.setGameTypeId;
    var setIsDemo = applicationStore.setIsDemo;
    var _a = useLocation(), pathname = _a.pathname, search = _a.search;
    var navigate = useNavigate();
    var t = useTranslation();
    var preferredGameType = useMemo(function () {
        if (gameTypes && freeChipAwardedOrEnded) {
            return gameTypes.find(function (item) { return freeChipAwardedOrEnded.amount <= item.maxBet && freeChipAwardedOrEnded.amount >= item.minBet; });
        }
        return null;
    }, [gameTypes, freeChipAwardedOrEnded]);
    var handleSendClaimFreeBet = useCallback(function (type) {
        if (type === FreeChipPopupActions.USE_NOW && preferredGameType) {
            var room_1 = preferredGameType.room, gameTypeId_1 = preferredGameType.gameTypeId;
            sendClaimFreeBet({
                freeChip: freeChipAwardedOrEnded,
                actionType: type,
                callBack: function () {
                    setFreeChipInLobby(freeChipAwardedOrEnded);
                    setIsDemo(false);
                    setRoomName(room_1);
                    setGameTypeId(gameTypeId_1);
                    navigate("".concat(pathname, "game").concat(search, "&gameTypeId=").concat(gameTypeId_1, "&roomName=").concat(room_1));
                },
            });
        }
        else {
            sendClaimFreeBet({ freeChip: freeChipAwardedOrEnded, actionType: FreeChipPopupActions.USE_LATER });
        }
    }, [
        freeChipAwardedOrEnded,
        navigate,
        pathname,
        preferredGameType,
        search,
        sendClaimFreeBet,
        setActiveFreeChip,
        setGameTypeId,
        setIsDemo,
        setRoomName,
    ]);
    if (freeChipPopupName !== FreeChipNames.freeChipWin && !preferredGameType) {
        return null;
    }
    return (React.createElement("div", { className: 'pgc-free-chips-win-popup' },
        React.createElement("div", { className: 'pgc-free-chips-win-content' },
            React.createElement("h3", { className: 'pgc-f-c-text-gr pgc-free-chips-win-title' }, t("FREE_CHIP" /* TKeys.FREE_CHIP */)),
            React.createElement("p", { className: 'pgc-free-chips-win-info' },
                t('CONGRATULATIONS', { value: freeChipAwardedOrEnded.count }),
                React.createElement("span", { className: 'congrats' }, t("CONGRATULATIONS" /* TKeys.CONGRATULATIONS */)),
                t("YOU_GOT_FREE_CHIP" /* TKeys.YOU_GOT_FREE_CHIP */, { value: freeChipAwardedOrEnded.count })),
            React.createElement("p", { className: 'pgc-f-c-text-gr pgc-free-chips-win-money' },
                freeChipAwardedOrEnded.amount,
                " ",
                currencySymbolOrCode),
            React.createElement("p", { className: 'pgc-free-chips-win-date' },
                t("YOU_CAN_USE_IT" /* TKeys.YOU_CAN_USE_IT */),
                " ",
                moment(freeChipAwardedOrEnded.expireDate).format(DATE_FORMATS.CALENDAR_DATE)),
            React.createElement("button", { className: 'pgc-free-chips-win-use-now', onClick: function () { return handleSendClaimFreeBet(FreeChipPopupActions.USE_NOW); } }, t("USE_NOW" /* TKeys.USE_NOW */)),
            React.createElement("button", { className: 'pgc-free-chips-win-use-later', onClick: function () { return handleSendClaimFreeBet(FreeChipPopupActions.USE_LATER); } }, t("USE_LATER" /* TKeys.USE_LATER */)))));
});

var GameControllers = observer(function (_a) {
    var controllerType = _a.controllerType, popupRef = _a.popupRef, selectedHistoryRow = _a.selectedHistoryRow, setSelectedHistoryRow = _a.setSelectedHistoryRow, GameControllerComponent = _a.gameControllerComponent, setGameControllerType = _a.setGameControllerType, additionalContent = _a.additionalContent, hasScrollToBottom = _a.hasScrollToBottom;
    var t = useTranslation();
    var currencySymbolOrCode = userInfoStore.currencySymbolOrCode;
    var isOpenBetHistorySection = platformMessageStore.isOpenBetHistorySection, setIsOpenBetHistorySection = platformMessageStore.setIsOpenBetHistorySection;
    var goBack = function (e) {
        e.stopPropagation();
        setSelectedHistoryRow(null);
    };
    useEffect(function () {
        if (isMobile()) {
            if (platformMessageStore.isOpenBetHistorySection) {
                setGameControllerType(GAME_CONTROLLER_TYPES.HISTORY);
            }
            if (controllerType !== GAME_CONTROLLER_TYPES.HISTORY && platformMessageStore.isOpenBetHistorySection) {
                setIsOpenBetHistorySection(false);
            }
        }
    }, [isMobile(), isOpenBetHistorySection]);
    var handleClosePopUp = function () {
        setIsOpenBetHistorySection(false);
        setGameControllerType(null);
    };
    return (React.createElement(GameControllersWr, { gameControllerType: controllerType, popupRef: popupRef }, controllerType ? (React.createElement(React.Fragment, null,
        React.createElement(GameControllersHead, null,
            selectedHistoryRow && (React.createElement("button", { className: 'selected-history-pagination-button back-button', onClick: goBack },
                React.createElement("i", { className: 'icon-arrow-left' }))),
            isMobile() && React.createElement("i", { className: "icon-".concat(controllerType) }),
            React.createElement(GameControllersHead.Span, { forCurrency: controllerType === GAME_CONTROLLER_TYPES.HISTORY, text: "".concat(t("".concat(TranslationKeys.Game, "_").concat(controllerType && controllerType.toUpperCase())), " ").concat(controllerType === GAME_CONTROLLER_TYPES.HISTORY ? "(".concat(currencySymbolOrCode, ")") : '') }),
            React.createElement("button", { className: 'pgc-popup-close', onClick: handleClosePopUp },
                React.createElement("i", { className: 'icon-close' }))),
        React.createElement(GameControllersContent, null,
            React.createElement(GameControllersContent.ScrollableContainer, { hasScrollToBottom: hasScrollToBottom }, GameControllerComponent)),
        additionalContent && React.createElement(GameControllersFooter, null, additionalContent))) : null));
});

var Header = observer(function (_a) {
    var lobbyPath = _a.lobbyPath, logoSrc = _a.logoSrc, gameControllerComponents = _a.gameControllerComponents, selectedHistoryRow = _a.selectedHistoryRow, setSelectedHistoryRow = _a.setSelectedHistoryRow, _b = _a.isVideo, isVideo = _b === void 0 ? false : _b, _c = _a.isChangedIcon, isChangedIcon = _c === void 0 ? false : _c, _d = _a.isShowFairness, isShowFairness = _d === void 0 ? true : _d, _e = _a.isShowGameTypes, isShowGameTypes = _e === void 0 ? true : _e, _f = _a.isShowSound, isShowSound = _f === void 0 ? true : _f, _g = _a.isShowRules, isShowRules = _g === void 0 ? true : _g, _h = _a.isShowFullScreen, isShowFullScreen = _h === void 0 ? true : _h, onToggleVideo = _a.onToggleVideo, videoClassName = _a.videoClassName, hasFreeBets = _a.hasFreeBets;
    var _j = __read(useState(null), 2), gameControllerType = _j[0], setGameControllerType = _j[1];
    var setIsMusicOnAndIsSoundOn = userSettingsStore.setIsMusicOnAndIsSoundOn, isMusicOn = userSettingsStore.isMusicOn, isSoundOn = userSettingsStore.isSoundOn, isFullScreen = userSettingsStore.isFullScreen, setIsFullScreen = userSettingsStore.setIsFullScreen, toggleFullscreen = userSettingsStore.toggleFullscreen, allowFullScreen = userSettingsStore.allowFullScreen;
    var isSkipLobby = gameConfigStore.isSkipLobby, setIsSkipLobby = gameConfigStore.setIsSkipLobby, isShowSideBarButton = gameConfigStore.isShowSideBarButton, sideBarButtonNotificationCount = gameConfigStore.sideBarButtonNotificationCount;
    var isOpenBetHistorySection = platformMessageStore.isOpenBetHistorySection, setIsOpenBetHistorySection = platformMessageStore.setIsOpenBetHistorySection, setIsOpenGameHelpSection = platformMessageStore.setIsOpenGameHelpSection, isOpenGameHelpSection = platformMessageStore.isOpenGameHelpSection;
    var isDemo = applicationStore.isDemo;
    var userId = userInfoStore.userId;
    var open = popupStore.open;
    var navigate = useNavigate();
    var search = useLocation().search;
    var popupRef = useRef();
    var handleClick = useCallback(function (e) {
        // @ts-ignore
        if (popupRef.current && !popupRef.current.contains(e.target)) {
            setIsOpenBetHistorySection(false);
            setIsOpenGameHelpSection(false);
            setGameControllerType(null);
        }
    }, [popupRef]);
    useEffect(function () {
        setIsFullScreen(!!document.fullscreenElement || window.innerHeight === screen.height);
    }, []);
    useEffect(function () {
        document.addEventListener('click', handleClick);
        return function () {
            document.removeEventListener('click', handleClick);
        };
    }, []);
    var handleClickSettingsButton = function (e, type) {
        e.stopPropagation();
        if (gameControllerType === type) {
            setGameControllerType(null);
        }
        else {
            setGameControllerType(type);
        }
    };
    var handleLobbyClick = function () {
        setIsSkipLobby(false);
        navigate("".concat(lobbyPath).concat(search));
    };
    var handleHistoryClick = function (e) { return (!userId ? function () { } : handleClickSettingsButton(e, GameControllerTypes.History)); };
    var handleHelpClick = function (e) { return handleClickSettingsButton(e, GameControllerTypes.Help); };
    var handleSettingsClick = function (e) { return handleClickSettingsButton(e, GameControllerTypes.Settings); };
    var onToggleMusicAndSound = function () { return setIsMusicOnAndIsSoundOn(); };
    var openFairness = function () { return open({ name: PopUps.Fairness }); };
    useEffect(function () {
        if (isOpenBetHistorySection) {
            setGameControllerType(GameControllerTypes.History);
        }
        else {
            setGameControllerType(null);
        }
    }, [isOpenBetHistorySection]);
    useEffect(function () {
        if (isOpenGameHelpSection) {
            setGameControllerType(GameControllerTypes.Help);
        }
        else {
            setGameControllerType(null);
        }
    }, [isOpenGameHelpSection]);
    var GameControllerComponent = useMemo(function () {
        var component = gameControllerComponents[gameControllerType];
        if (component) {
            return component;
        }
        return null;
    }, [gameControllerType]);
    var FreeBetParentWrapper = useCallback(function (_a) {
        var children = _a.children;
        return (React.createElement(SettingButton, { iconName: GameControllerTypes.Video, onClick: onToggleVideo, videoClassName: videoClassName, isShowIcon: false, forFreeBets: true }, children));
    }, [onToggleVideo]);
    return (React.createElement(HeaderWr, null,
        logoSrc && React.createElement(LogoImg, { src: logoSrc }),
        lobbyPath || isShowFairness ? (React.createElement(HeaderColumn, null,
            lobbyPath && !isSkipLobby && React.createElement(SettingButton, { iconName: 'lobby', onClick: handleLobbyClick }),
            isSkipLobby && isShowGameTypes && React.createElement(ChangeGameTypeSection, null),
            isShowFairness && React.createElement(FairnessButton, { onClick: openFairness }))) : (React.createElement("div", null)),
        React.createElement(HeaderColumn, { popupRef: popupRef },
            hasFreeBets && React.createElement(FreeBetsWrapper, { parentWrapper: FreeBetParentWrapper }),
            isVideo && (React.createElement(SettingButton, { iconName: GameControllerTypes.Video, onClick: onToggleVideo, videoClassName: videoClassName })),
            isShowSound && (React.createElement(SettingButton, { iconName: isSoundOn || isMusicOn
                    ? isChangedIcon
                        ? 'sound'
                        : GameControllerTypes.Music
                    : isChangedIcon
                        ? 'mute'
                        : GameControllerTypes.Mute, onClick: onToggleMusicAndSound })),
            React.createElement(SettingButton, { iconName: GameControllerTypes.History, onClick: handleHistoryClick, isActive: GameControllerTypes.History === gameControllerType, isDisabled: !userId || isDemo }),
            isShowRules && (React.createElement(SettingButton, { iconName: GameControllerTypes.Info, onClick: handleHelpClick, isActive: GameControllerTypes.Help === gameControllerType })),
            React.createElement(SettingButton, { iconName: GameControllerTypes.Settings, onClick: handleSettingsClick, isActive: GameControllerTypes.Settings === gameControllerType }),
            allowFullScreen && isShowFullScreen && (React.createElement(SettingButton, { iconName: !isFullScreen ? GameControllerTypes.FullScreen : GameControllerTypes.FullScreenOut, onClick: toggleFullscreen })),
            isShowSideBarButton && (React.createElement(SettingButton, { forPlatformSideBar: true, iconName: GameControllerTypes.PlatformSideBar, onClick: function () { return iframeService.sendOpenSidebar(); } }, !!sideBarButtonNotificationCount && (React.createElement("span", { className: classNames('side-bar-notifications', sideBarButtonNotificationCount.toString().length >= 2 ? 'small' : '') }, sideBarButtonNotificationCount))))),
        React.createElement(GameControllers, { popupRef: popupRef, controllerType: gameControllerType, selectedHistoryRow: selectedHistoryRow, setSelectedHistoryRow: setSelectedHistoryRow, gameControllerComponent: GameControllerComponent, setGameControllerType: setGameControllerType })));
});

var MobileFooter = observer(function (_a) {
    var lastWin = _a.lastWin, centerBlock = _a.centerBlock, totalBet = _a.totalBet, balance = _a.balance, t = _a.t, isDemo = _a.isDemo, isShowBalanceWin = _a.isShowBalanceWin, currencySymbolOrCode = _a.currencySymbolOrCode;
    return (React.createElement(MobileStructureBottom, null,
        React.createElement(MobileFooterWr, { isShowBalanceWin: isShowBalanceWin },
            React.createElement(MobileFooterColumn, { position: 'left' },
                React.createElement(MobileUserBalanceAndTotalBet, { label: t(TranslationKeys.Balance), value: balance, currency: isDemo ? 'FUN' : currencySymbolOrCode })),
            React.createElement(MobileFooterColumn, { position: 'center' }, centerBlock),
            React.createElement(MobileFooterColumn, { position: 'right' },
                React.createElement(MobileUserBalanceAndTotalBet, { label: t(lastWin ? TranslationKeys.LastWin : TranslationKeys.TotalBet), currency: isDemo ? 'FUN' : currencySymbolOrCode, value: lastWin ? lastWin : totalBet })))));
});

var PlayForRealButton = function (_a) {
    var t = _a.t, demoSwitcherAdditionalFunction = _a.demoSwitcherAdditionalFunction;
    return (React.createElement("button", { className: 'pgc-play-for-real-btn', title: t(TranslationKeys.PlayForReal), onClick: function () { return applicationStore.demoSwitcher(demoSwitcherAdditionalFunction); } }, t(TranslationKeys.PlayForReal)));
};

var WebFooter = observer(function (_a) {
    var t = _a.t, isDemo = _a.isDemo, lastWin = _a.lastWin, balance = _a.balance, roundId = _a.roundId, isGuest = _a.isGuest, totalBet = _a.totalBet, isShowBalanceWin = _a.isShowBalanceWin, usersCount = _a.usersCount, isTestPlatform = _a.isTestPlatform, additionalCountChecker = _a.additionalCountChecker, currencySymbolOrCode = _a.currencySymbolOrCode, demoSwitcherAdditionalFunction = _a.demoSwitcherAdditionalFunction;
    var _b = parseQuery(window.location.search), _c = DefaultQueryParams.RealModeSwitcher, hasRealModeSwitcher = _b[_c];
    return (React.createElement(FooterContainer, null,
        React.createElement(FooterColumn, { className: 'left' },
            React.createElement(FooterInfo, null,
                React.createElement(CurrentTime, null))),
        React.createElement(FooterColumn, { className: 'center' },
            React.createElement(FooterUserInfo, { isShowBalanceWin: isShowBalanceWin },
                React.createElement(FooterUserInfoColumn, { className: 'left' },
                    React.createElement(UserBalanceAndTotalBetAmount, { label: t(TranslationKeys.Balance), value: balance, currency: isDemo ? 'FUN' : currencySymbolOrCode })),
                React.createElement(FooterUserInfoColumn, { className: 'center' },
                    ((!isDemo && !isGuest) || isTestPlatform) && additionalCountChecker && (React.createElement(PlayingUsersCount, { count: usersCount })),
                    !Number(hasRealModeSwitcher) && (isDemo || isGuest) && !isTestPlatform && (React.createElement(PlayForRealButtonHolder, null,
                        React.createElement(PlayForRealButton, { t: t, demoSwitcherAdditionalFunction: demoSwitcherAdditionalFunction })))),
                React.createElement(FooterUserInfoColumn, { className: 'right' },
                    React.createElement(UserBalanceAndTotalBetAmount, { label: t(lastWin ? TranslationKeys.LastWin : TranslationKeys.TotalBet), value: lastWin ? lastWin : totalBet, currency: isDemo ? 'FUN' : currencySymbolOrCode })))),
        React.createElement(FooterColumn, { className: 'right' },
            React.createElement(FooterInfo, { flexEnd: true },
                React.createElement(RoundId, { id: roundId })))));
});

var TableFooter = observer(function (_a) {
    var totalBet = _a.totalBet, lastWin = _a.lastWin, centerBlock = _a.centerBlock, demoSwitcherAdditionalFunction = _a.demoSwitcherAdditionalFunction, _b = _a.additionalCountChecker, additionalCountChecker = _b === void 0 ? true : _b, _c = _a.isShowBalanceWin, isShowBalanceWin = _c === void 0 ? false : _c;
    var t = useTranslation();
    var roundId = useRoundInfoStore().roundId;
    var usersCount = useUserCountStore().usersCount;
    var _d = useApplicationStore(), isDemo = _d.isDemo, isGuest = _d.isGuest, isTestPlatform = _d.isTestPlatform;
    var _e = useUserInfoStore(), currencySymbolOrCode = _e.currencySymbolOrCode, balance = _e.balance;
    return isMobile() ? (React.createElement(MobileFooter, { t: t, isDemo: isDemo, lastWin: lastWin, totalBet: totalBet, centerBlock: centerBlock, isShowBalanceWin: isShowBalanceWin, balance: convertAmount(balance), currencySymbolOrCode: currencySymbolOrCode })) : (React.createElement(WebFooter, { t: t, isShowBalanceWin: isShowBalanceWin, isDemo: isDemo, roundId: roundId, isGuest: isGuest, lastWin: lastWin, totalBet: totalBet, usersCount: usersCount, isTestPlatform: isTestPlatform, balance: convertAmount(balance), currencySymbolOrCode: currencySymbolOrCode, additionalCountChecker: additionalCountChecker, demoSwitcherAdditionalFunction: demoSwitcherAdditionalFunction }));
});

var Settings = observer(function (_a) {
    var children = _a.children, hasAnimation = _a.hasAnimation, hasHalfCashOut = _a.hasHalfCashOut;
    var t = useTranslation();
    var isMusicOn = userSettingsStore.isMusicOn, isSoundOn = userSettingsStore.isSoundOn, soundVolume = userSettingsStore.soundVolume, musicVolume = userSettingsStore.musicVolume, isHalfCashOutOn = userSettingsStore.isHalfCashOutOn, gameThemeConfigs = userSettingsStore.gameThemeConfigs, setGameThemeTypeEnabledState = userSettingsStore.setGameThemeTypeEnabledState, setMusicVolume = userSettingsStore.setMusicVolume, setSoundVolume = userSettingsStore.setSoundVolume, setIsSoundOn = userSettingsStore.setIsSoundOn, setIsMusicOn = userSettingsStore.setIsMusicOn, isAnimationOn = userSettingsStore.isAnimationOn, setIsAnimationOn = userSettingsStore.setIsAnimationOn, setIsHalfCashOutOn = userSettingsStore.setIsHalfCashOutOn;
    var _b = parseQuery(window.location.search), _c = DefaultQueryParams.Theme, themeName = _b[_c];
    var toggleGameTheme = useCallback(function () {
        setGameThemeTypeEnabledState();
    }, []);
    var toggleIsHalfCashOut = useCallback(function () {
        setIsHalfCashOutOn();
    }, []);
    var toggleAnimation = function () {
        setIsAnimationOn();
    };
    var changeSoundVolume = function (volume) {
        setSoundVolume(volume);
    };
    var changeMusicVolume = function (volume) {
        setMusicVolume(volume);
    };
    var toggleSound = function () {
        setIsSoundOn();
    };
    var toggleMusic = function () {
        setIsMusicOn();
    };
    useEffect(function () {
        if (hasHalfCashOut) {
            gameConfigStore.setIsGameHasHalfCashOut(hasHalfCashOut);
        }
    }, [hasHalfCashOut]);
    return (React.createElement(SettingsWr, null,
        hasAnimation && (React.createElement(SettingRow, null,
            React.createElement(SettingRowColumn, { position: 'left' },
                React.createElement(SettingRowColumn.Span, { text: t('ANIMATIONS') })),
            React.createElement(SettingRowColumn, { position: 'right', onClick: toggleAnimation },
                React.createElement(SettingRowColumn.Switcher, { isChecked: isAnimationOn })))),
        React.createElement(SettingRow, null,
            React.createElement(SettingRowColumn, { position: 'left' },
                React.createElement(SettingRowColumn.Span, { text: t('MUSIC') })),
            React.createElement(SettingRowColumn, { position: 'right' },
                isIOS() ? (React.createElement(SettingRowColumn.Switcher, { handler: toggleMusic, isChecked: isMusicOn })) : (React.createElement(SettingRowColumn.Range, { value: musicVolume, width: musicVolume * 100, rangeColorType: 'type-1', handler: function (e) { return changeMusicVolume(+e.target.value); } })),
                React.createElement(SettingRowColumn.Icon, { iconName: isMusicOn ? 'icon-music' : 'icon-music-off', onClick: toggleMusic }))),
        React.createElement(SettingRow, null,
            React.createElement(SettingRowColumn, { position: 'left' },
                React.createElement(SettingRowColumn.Span, { text: t('SOUNDS') })),
            React.createElement(SettingRowColumn, { position: 'right' },
                isIOS() ? (React.createElement(SettingRowColumn.Switcher, { handler: toggleSound, isChecked: isSoundOn })) : (React.createElement(SettingRowColumn.Range, { value: soundVolume, width: soundVolume * 100, rangeColorType: 'type-2', handler: function (e) { return changeSoundVolume(+e.target.value); } })),
                React.createElement(SettingRowColumn.Icon, { iconName: isSoundOn ? 'icon-sound' : 'icon-mute', onClick: toggleSound }))),
        themeName && !!GameTheme[themeName] && (React.createElement(SettingRow, null,
            React.createElement(SettingRowColumn, { position: 'left' },
                React.createElement(SettingRowColumn.Span, { text: t(GameThemeTKeys[themeName]) })),
            React.createElement(SettingRowColumn, { position: 'right', onClick: toggleGameTheme },
                React.createElement(SettingRowColumn.Switcher, { isChecked: gameThemeConfigs.isEnabled })))),
        hasHalfCashOut && (React.createElement(SettingRow, null,
            React.createElement(SettingRowColumn, { position: 'left' },
                React.createElement(SettingRowColumn.Span, { text: t(TranslationKeys.HalfCashOut) })),
            React.createElement(SettingRowColumn, { position: 'right', onClick: toggleIsHalfCashOut },
                React.createElement(SettingRowColumn.Switcher, { isChecked: isHalfCashOutOn })))),
        children));
});

var OverlayContainer = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, position = _a.position, children = _a.children, settingsRef = _a.settingsRef, payoutsColumns = _a.payoutsColumns, activeOverlay = _a.activeOverlay, AdditionalResults = _a.additionalResults, additionalTitle = _a.additionalTitle, hasScrollToBottom = _a.hasScrollToBottom;
    var t = useTranslation();
    return (React.createElement(OverlayItem, { isOpen: isOpen, settingsRef: settingsRef }, isOpen ? (React.createElement(React.Fragment, null,
        React.createElement(OverlayItemHeader, { onClose: onClose, title: t(payoutsColumns.title), columns: payoutsColumns.data }),
        React.createElement(OverlayItemContent, { hasScrollToBottom: hasScrollToBottom, onClose: onClose, position: position, isOpen: isOpen }, children),
        AdditionalResults && (React.createElement(OverlayFooter, { title: additionalTitle, activeOverlay: activeOverlay },
            React.createElement(AdditionalResults, null))))) : null));
};

var OVERLAY_TYPES = {
    Results: 'results',
    PayoutAndLimits: 'payoutAndLimits',
};
var Sidebar = observer(function (_a) {
    var _b = _a.position, position = _b === void 0 ? 'left' : _b, payoutsColumns = _a.payoutsColumns, resultsColumns = _a.resultsColumns, LimitsPayoutsWr = _a.limitsPayoutsWr, Results = _a.results, additionalResults = _a.additionalResults, additionalTitle = _a.additionalTitle, hasScrollToBottom = _a.hasScrollToBottom;
    var _c = __read(useState(null), 2), activeOverlay = _c[0], setActiveOverlay = _c[1];
    var t = useTranslation();
    var resultsRef = useRef();
    var payoutAndLimitsRef = useRef();
    var isShowLobbySelectGameType = lobbyStore.isShowLobbySelectGameType;
    var _d = __read(useOutsideClick(resultsRef, isShowLobbySelectGameType), 2), openedResults = _d[0], handleClickResults = _d[1];
    var _e = __read(useOutsideClick(payoutAndLimitsRef, isShowLobbySelectGameType), 2), openedPayouts = _e[0], handleClickPayouts = _e[1];
    var isOpenOddsSection = platformMessageStore.isOpenOddsSection;
    var changeActiveOverlay = function (overlayType) {
        if (OVERLAY_TYPES.PayoutAndLimits === overlayType) {
            handleClickPayouts();
        }
        else {
            handleClickResults();
        }
        setActiveOverlay(overlayType);
    };
    var closeResultsOverlay = function () {
        handleClickResults();
        setActiveOverlay(null);
    };
    var closePayoutsOverlay = function () {
        if (activeOverlay === OVERLAY_TYPES.PayoutAndLimits) {
            handleClickPayouts();
            setActiveOverlay(null);
        }
    };
    useEffect(function () {
        if (payoutsColumns) {
            if (isOpenOddsSection) {
                changeActiveOverlay(OVERLAY_TYPES.PayoutAndLimits);
            }
            else {
                closePayoutsOverlay();
            }
        }
    }, [isOpenOddsSection, payoutsColumns]);
    return (React.createElement(OverlayList, { position: position, labels: React.createElement(OverlayLabels, null,
            payoutsColumns && (React.createElement(OverlayLabel, { text: (payoutsColumns === null || payoutsColumns === void 0 ? void 0 : payoutsColumns.overLayName) ? t(payoutsColumns.overLayName) : t('LIMITS_AND_PAYOUTS'), onClick: function () { return changeActiveOverlay(OVERLAY_TYPES.PayoutAndLimits); } })),
            resultsColumns && (React.createElement(OverlayLabel, { text: t('RESULTS'), onClick: function () { return changeActiveOverlay(OVERLAY_TYPES.Results); } }))) },
        payoutsColumns && (React.createElement(OverlayContainer, { activeOverlay: activeOverlay, settingsRef: payoutAndLimitsRef, payoutsColumns: payoutsColumns, onClose: closePayoutsOverlay, isOpen: isMobile()
                ? activeOverlay === OVERLAY_TYPES.PayoutAndLimits
                : activeOverlay === OVERLAY_TYPES.PayoutAndLimits && openedPayouts, position: position },
            React.createElement(LimitsPayoutsWr, null))),
        resultsColumns && (React.createElement(OverlayContainer, { hasScrollToBottom: hasScrollToBottom, activeOverlay: activeOverlay, settingsRef: resultsRef, payoutsColumns: resultsColumns, onClose: closeResultsOverlay, isOpen: isMobile()
                ? activeOverlay === OVERLAY_TYPES.Results
                : activeOverlay === OVERLAY_TYPES.Results && openedResults, position: position, additionalResults: additionalResults, additionalTitle: additionalTitle },
            React.createElement(Results, null)))));
});

var MobileChangeGameTypeSection = observer(function (_a) {
    var isShowGameTypes = _a.isShowGameTypes, isShowMinMax = _a.isShowMinMax, isShowPlayForRealBtn = _a.isShowPlayForRealBtn;
    var limits = gameConfigStore.limits, isShowSideBarButton = gameConfigStore.isShowSideBarButton, sideBarButtonNotificationCount = gameConfigStore.sideBarButtonNotificationCount;
    var currencySymbolOrCode = userInfoStore.currencySymbolOrCode;
    var setIsShowLobbySelectGameType = lobbyStore.setIsShowLobbySelectGameType;
    var t = useTranslation();
    return (React.createElement("div", { className: 'pgc-new-lobby-container' },
        !isShowPlayForRealBtn && isShowMinMax && (React.createElement(MobileMinMaxBet, { currency: currencySymbolOrCode, min: abbreviateNumber(limits === null || limits === void 0 ? void 0 : limits.minBet), max: abbreviateNumber(limits === null || limits === void 0 ? void 0 : limits.maxBet), text: "".concat(t(TranslationKeys.Min), " - ").concat(t(TranslationKeys.Max)) })),
        (isShowGameTypes || isShowSideBarButton) && (React.createElement("div", { className: "pgc-mobile-lobby-parent ".concat(isShowSideBarButton ? 'platform-side-bar' : ''), onClick: function () { return (isShowSideBarButton ? iframeService.sendOpenSidebar() : setIsShowLobbySelectGameType(true)); } },
            React.createElement("div", { className: 'pgc-mobile-lobby-inner' },
                React.createElement("div", { className: 'pgc-mobile-lobby-round' },
                    !!sideBarButtonNotificationCount && isShowSideBarButton && (React.createElement("span", { className: classNames('side-bar-notifications', sideBarButtonNotificationCount.toString().length >= 2 ? 'small' : '') }, sideBarButtonNotificationCount)),
                    React.createElement("i", { className: "icon-".concat(isShowSideBarButton ? GameControllerTypes.PlatformSideBar : 'lobby2') })))))));
});

var TableMobileHeader = observer(function (_a) {
    var logoSrc = _a.logoSrc, _b = _a.isShowFairness, isShowFairness = _b === void 0 ? true : _b, _c = _a.isShowMinMax, isShowMinMax = _c === void 0 ? true : _c, demoSwitcherAdditionalFunction = _a.demoSwitcherAdditionalFunction, hasFreeBets = _a.hasFreeBets, _d = _a.isShowGameTypes, isShowGameTypes = _d === void 0 ? true : _d;
    var t = useTranslation();
    var open = popupStore.open;
    var roundId = roundInfoStore.roundId;
    var isDemo = applicationStore.isDemo;
    var _e = parseQuery(window.location.search), _f = DefaultQueryParams.RealModeSwitcher, hasRealModeSwitcher = _e[_f];
    var openFairness = function () { return open({ name: PopUps.Fairness }); };
    return (React.createElement(MobileStructureTop, null,
        React.createElement(MobileHeaderWr, null,
            React.createElement(MobileHeaderColumn, { position: 'left' },
                isShowFairness && React.createElement(MobileFairnessButton, { onClick: openFairness }),
                React.createElement(MobileGameId, { text: t("ROUND_ID" /* TKeys.ROUND_ID */), id: roundId })),
            React.createElement(MobileHeaderColumn, { position: 'center' },
                React.createElement(MobileHeaderLogo, { src: logoSrc })),
            React.createElement(MobileHeaderColumn, { position: 'right' },
                hasFreeBets && React.createElement(FreeBetsWrapper, null),
                React.createElement(MobileChangeGameTypeSection, { isShowGameTypes: isShowGameTypes, isShowPlayForRealBtn: !Number(hasRealModeSwitcher) && isDemo, isShowMinMax: isShowMinMax }),
                !Number(hasRealModeSwitcher) && isDemo && (React.createElement(MobilePlayForRealButtonHolder, null,
                    React.createElement(PlayForRealButton, { t: t, demoSwitcherAdditionalFunction: demoSwitcherAdditionalFunction })))))));
});

// import { RouterPaths } from '../../t_types/enums/RouterPaths';
var TableConnectionPopupsWr = observer(function () {
    var reconnect = usePopupStore().reconnect;
    var isShowAllNotification = platformMessageStore.isShowAllNotification;
    var t = useTranslation();
    // setGameIsOpen, isBogLine
    // const navigate = useNavigate();
    // const { search } = useLocation();
    if (reconnect) {
        return (React.createElement(TableConnectionPopUp
        // title={t(
        //   gameIsOpen
        //     ? TranslationKeys.SessionInterrupted
        //     : connectionError
        //     ? TranslationKeys.YourConnectionLost
        //     : TranslationKeys.PleaseWait
        // )}
        // subTitle={t(
        //   gameIsOpen
        //     ? TranslationKeys.SessionWasInterrupted
        //     : connectionError
        //     ? TranslationKeys.PleaseRefreshPage
        //     : TranslationKeys.Reconnect
        // )}
        , { 
            // title={t(
            //   gameIsOpen
            //     ? TranslationKeys.SessionInterrupted
            //     : connectionError
            //     ? TranslationKeys.YourConnectionLost
            //     : TranslationKeys.PleaseWait
            // )}
            // subTitle={t(
            //   gameIsOpen
            //     ? TranslationKeys.SessionWasInterrupted
            //     : connectionError
            //     ? TranslationKeys.PleaseRefreshPage
            //     : TranslationKeys.Reconnect
            // )}
            title: t(TranslationKeys.PleaseWait), subTitle: t(TranslationKeys.Reconnect), isShowAllNotification: isShowAllNotification, btnText: t(TranslationKeys.Ok), isReconnecting: true, onClick: function () {
                // if (gameIsOpen && isBogLine) {
                //   navigate(`${RouterPaths.lobby}${search}`);
                //   popupStore.close(e);
                //   setGameIsOpen(false);
                // } else {
                iframeService.sendReload();
                // }
            } }));
    }
    return null;
});

var TablePopUpContainer = observer(function (_a) {
    var popupMap = _a.popupMap;
    var _b = usePopupStore(), popupName = _b.popupName, reconnect = _b.reconnect;
    var CurrentPopup = useMemo(function () {
        if (reconnect) {
            return { Component: TableConnectionPopupsWr, title: '' };
        }
        if (!popupName) {
            return null;
        }
        return { Component: popupMap[popupName].component, title: popupMap[popupName].title };
    }, [popupMap, popupName, reconnect]);
    if (!CurrentPopup) {
        return null;
    }
    return (React.createElement(TablePopUpWr, { title: CurrentPopup.title, isConnectionPopup: reconnect || popupName === PopUps.Reconnect, isShowCloseIcon: popupName !== PopUps.Reconnect },
        React.createElement(CurrentPopup.Component, null)));
});

var FairnessFormGroup = observer(function (_a) {
    var isCheckResult = _a.isCheckResult, isShowAboutHash = _a.isShowAboutHash, aboutHashComp = _a.aboutHashComp;
    var scrollRef = useRef(null);
    var _b = __read(useState(false), 2), toggle = _b[0], setToggle = _b[1];
    var _c = __read(useState(''), 2), checkKeyValue = _c[0], setCheckKeyValue = _c[1];
    var _d = __read(useState(''), 2), checkSaltValue = _d[0], setCheckSaltValue = _d[1];
    var _e = __read(useState(''), 2), checkHashValue = _e[0], setCheckHashValue = _e[1];
    var _f = useSelectedResultInfoStore().selectedResultInfo, resultKey = _f.resultKey, resultSalt = _f.resultSalt, resultHash = _f.resultHash;
    var t = useTranslation();
    var handleCheckHash = function () { return __awaiter(void 0, void 0, void 0, function () {
        var postData, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    postData = {
                        resultIdentityString: checkKeyValue,
                        salt: checkSaltValue,
                    };
                    return [4 /*yield*/, ApiServices.get(ApiServiceTypes.RoundsService).checkResultHash(postData)];
                case 1:
                    response = _a.sent();
                    setCheckHashValue(response.data.result);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        setToggle(false);
    }, []);
    useEffect(function () {
        if (toggle && scrollRef.current) {
            scrollRef.current.scrollIntoView();
        }
    }, [toggle]);
    var handleShowAboutHash = function () {
        setToggle(function (prev) { return !prev; });
    };
    return (React.createElement(React.Fragment, null,
        isCheckResult && (React.createElement(FairnessFormGroupWr, { t: t, isDisabled: true, isShowCopyIcon: true, checkKeyValue: resultKey, checkSaltValue: resultSalt, checkHashValue: resultHash, handleCheckHash: handleCheckHash, setCheckKeyValue: setCheckKeyValue, setCheckSaltValue: setCheckSaltValue })),
        React.createElement(FairnessFormGroupWr, { t: t, toggle: toggle, isShowCheckButton: true, scrollRef: scrollRef, checkKeyValue: checkKeyValue, aboutHashComp: aboutHashComp, checkSaltValue: checkSaltValue, checkHashValue: checkHashValue, isShowAboutHash: isShowAboutHash, handleCheckHash: handleCheckHash, setCheckKeyValue: setCheckKeyValue, setCheckSaltValue: setCheckSaltValue, handleShowAboutHash: handleShowAboutHash })));
});

var BetHistoryHeader = function () {
    var t = useTranslation();
    return (React.createElement("div", null,
        React.createElement("div", { className: 'game-history-header' },
            React.createElement("div", { className: 'game-history-row header' },
                React.createElement(AccordionItem.Column, null,
                    React.createElement(AccordionItem.Title, { text: t("ROUND_ID" /* TKeys.ROUND_ID */) })),
                React.createElement(AccordionItem.Column, null,
                    React.createElement(AccordionItem.Title, { text: "".concat(t("DATE" /* TKeys.DATE */)) })),
                React.createElement(AccordionItem.Column, null,
                    React.createElement(AccordionItem.Title, { text: t("BET" /* TKeys.BET */) })),
                React.createElement(AccordionItem.Column, null,
                    React.createElement(AccordionItem.Title, { text: "".concat(t("WIN" /* TKeys.WIN */)) }))))));
};

var CONTESTS_TAKE = 30;
var BetHistoryContent = observer(function (_a) {
    var onHistoryRowClick = _a.onHistoryRowClick;
    var onInfiniteScrollDown = useInfiniteScroll().onInfiniteScrollDown;
    var firstStep = tableBetHistoryStore.firstStep, secondStep = tableBetHistoryStore.secondStep, getFirstStep = tableBetHistoryStore.getFirstStep, getSecondStep = tableBetHistoryStore.getSecondStep, showRoundBet = tableBetHistoryStore.showRoundBet;
    var roundId = roundInfoStore.roundId;
    var isBogLine = applicationStore.isBogLine;
    var t = useTranslation();
    var _b = firstStep.data, firstStepData = _b.items, count = _b.count, pending = firstStep.pending;
    var secondStepData = secondStep.data;
    var headerClick = function (item) {
        getSecondStep({
            key: item.date,
            date: getStartEndDay(item.date),
        });
    };
    var rowClick = function (_a, date, e) {
        var id = _a.id, roundId = _a.roundId;
        e.stopPropagation();
        onHistoryRowClick(id ? id : roundId, date);
    };
    var handleOnScroll = function (event) {
        onInfiniteScrollDown(event, function () {
            getFirstStep({
                skip: firstStepData.length,
                take: CONTESTS_TAKE,
                concat: true,
            });
        }, [!pending, firstStepData.length < count]);
    };
    return (React.createElement("div", { className: 'game-history-content' },
        React.createElement(Accordion, { multiple: true, onScroll: handleOnScroll }, firstStepData &&
            firstStepData.map(function (row) {
                var _a;
                return (React.createElement(AccordionItem, { key: row.date, id: "row-".concat(row.date) },
                    React.createElement(AccordionItem.Header, { className: 'game-history-row', onClose: function () { return headerClick(row); } },
                        React.createElement(AccordionItem.Column, null,
                            React.createElement(AccordionItem.Icon, { iconName: 'game-history-r-c-icon' })),
                        React.createElement(AccordionItem.Column, null,
                            React.createElement(AccordionItem.Title, { text: translateMonth(row.date, DATE_FORMATS.CHART_II) })),
                        React.createElement(AccordionItem.Column, null,
                            React.createElement(AccordionItem.Title, { text: row.totalBetsAmount, type: 'money' })),
                        React.createElement(AccordionItem.Column, null,
                            React.createElement(AccordionItem.Title, { text: row.totalBetsWinAmount, type: 'money' }))),
                    React.createElement(AccordionItem.Panel, { className: 'game-history-hidden-content' }, secondStepData &&
                        ((_a = secondStepData[row.date]) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                            if (!showRoundBet && item.roundId === roundId) {
                                return null;
                            }
                            return (React.createElement(AccordionItem.Row, { key: "".concat(item.roundId, "_").concat(item.date), onClick: function (e) {
                                    e.stopPropagation();
                                    rowClick(item, row.date, e);
                                } },
                                React.createElement(AccordionItem.Column, null,
                                    React.createElement(AccordionItem.Title, { text: item.roundId })),
                                React.createElement(AccordionItem.Column, null,
                                    React.createElement(AccordionItem.Title, { text: getLocaleTimeWithMoment(item.date) })),
                                React.createElement(AccordionItem.Column, null,
                                    React.createElement(AccordionItem.Title, { text: item.freeBetId && isBogLine ? t(TranslationKeys.FreeBet) : item.amount })),
                                React.createElement(AccordionItem.Column, null,
                                    React.createElement(AccordionItem.Title, { text: item.winAmount }))));
                        })))));
            }))));
});

var SelectedRowWr = observer(function (_a) {
    var onPaginationChange = _a.onPaginationChange, disablePaging = _a.disablePaging, setDisablePaging = _a.setDisablePaging, hasReplay = _a.hasReplay, InnerComponent = _a.innerComponent;
    var getThirdStep = tableBetHistoryStore.getThirdStep, thirdStep = tableBetHistoryStore.thirdStep, setSelectedHistoryRow = tableBetHistoryStore.setSelectedHistoryRow, selectedHistoryRow = tableBetHistoryStore.selectedHistoryRow, fetchParamNames = tableBetHistoryStore.fetchParamNames, removeThirdStep = tableBetHistoryStore.removeThirdStep;
    var thirdStepData = thirdStep.data, pending = thirdStep.pending;
    var t = useTranslation();
    useEffect(function () {
        return function () {
            removeThirdStep();
            setDisablePaging(null);
            setSelectedHistoryRow(null);
        };
    }, []);
    useEffect(function () {
        var _a;
        getThirdStep((_a = {},
            _a[fetchParamNames.Id] = selectedHistoryRow,
            _a));
    }, [selectedHistoryRow, fetchParamNames]);
    if (pending) {
        return React.createElement("div", null);
    }
    if (!thirdStepData.roundId) {
        return null;
    }
    var handleReplayClick = function () {
        if (thirdStepData && thirdStepData.id) {
            ApiServices.get(ApiServiceTypes.UsersService)
                .getReplayUrl({ betId: thirdStepData.id })
                .then(function (response) {
                var result = response.data.result;
                if (result && result.replayUrl) {
                    window.open(result.replayUrl);
                }
            })
                .catch(function (error) {
                console.error('replay click', error);
            });
        }
    };
    var beforeBetBalance = thirdStepData.beforeBetBalance, betFinishedBalance = thirdStepData.betFinishedBalance;
    return (React.createElement("div", { className: 'pgc-game-history-info-holder' },
        React.createElement("div", { className: 'pgc-game-history-info-holder-top' },
            React.createElement("div", { className: 'pgc-game-history-info-top-row' },
                hasReplay && (React.createElement("p", { className: 'pgc-game-history-info-top-row-replay-btn', onClick: function () { return handleReplayClick(); } },
                    React.createElement("i", { className: "icon-".concat(IconTypes.Replay) }))),
                React.createElement("div", { className: 'pgc-game-history-info-top-row-item' },
                    React.createElement("div", { className: 'pgc-game-history-info-top-row-item-inner' },
                        React.createElement("p", { className: 'pgc-game-history-info-top-row-item-text-id' }, t("ROUND_ID" /* TKeys.ROUND_ID */)),
                        React.createElement("p", { className: 'pgc-game-history-info-top-row-item-number-id' }, thirdStepData.roundId))),
                React.createElement("div", { className: 'pgc-game-history-info-top-row-item' },
                    React.createElement("div", { className: 'pgc-game-history-info-top-row-item-inner' },
                        React.createElement("p", { className: 'pgc-game-history-info-top-row-item-text-id' }, t("GAME_RESOLVED" /* TKeys.GAME_RESOLVED */)),
                        React.createElement("p", { className: 'pgc-game-history-info-top-row-item-number-id' },
                            translateMonth(thirdStepData.date, DATE_FORMATS.CHART_II),
                            ' ',
                            getLocaleTimeWithMoment(thirdStepData.date)))),
                React.createElement("div", { className: 'pgc-game-history-info-top-row-btns-wrp' },
                    React.createElement("div", { className: "pgc-game-history-info-top-row-btn ".concat(disablePaging === betHistoryPagingDisable.PREV || disablePaging === betHistoryPagingDisable.ALL
                            ? 'disabled'
                            : ''), onClick: function (e) {
                            e.stopPropagation();
                            onPaginationChange(betHistoryPagingDisable.PREV);
                        } },
                        React.createElement("i", { className: 'icon-double-arrow-left' })),
                    React.createElement("div", { className: "pgc-game-history-info-top-row-btn ".concat(disablePaging === betHistoryPagingDisable.NEXT || disablePaging === betHistoryPagingDisable.ALL
                            ? 'disabled'
                            : ''), onClick: function (e) {
                            e.stopPropagation();
                            onPaginationChange(betHistoryPagingDisable.NEXT);
                        } },
                        React.createElement("i", { className: 'icon-double-arrow-right' })))),
            beforeBetBalance || betFinishedBalance ? (React.createElement("div", { className: 'pgc-game-history-info-balance' },
                React.createElement("div", { className: 'pgc-game-history-info-balance-column' },
                    React.createElement("span", { className: 'pgc-game-history-info-balance-title' }, t(TranslationKeys.BalanceBefore)),
                    React.createElement("div", { className: 'pgc-game-history-info-balance-data' },
                        React.createElement("span", { className: 'pgc-game-history-info-balance-data-txt' }, getAmountWithCurrency({ amount: convertAmount(beforeBetBalance) }) || ''))),
                React.createElement("div", { className: 'pgc-game-history-info-balance-column' },
                    React.createElement("span", { className: 'pgc-game-history-info-balance-title' }, t(TranslationKeys.BalanceAfter)),
                    React.createElement("div", { className: 'pgc-game-history-info-balance-data' },
                        React.createElement("span", { className: 'pgc-game-history-info-balance-data-txt' }, getAmountWithCurrency({ amount: convertAmount(betFinishedBalance) }) || ''))))) : (React.createElement(React.Fragment, null))),
        React.createElement(InnerComponent, null)));
});

var BetHistory = observer(function (_a) {
    var SelectedRow = _a.selectedRow, hasReplay = _a.hasReplay;
    var _b = __read(useState(null), 2), disablePaging = _b[0], setDisablePaging = _b[1];
    var firstStep = tableBetHistoryStore.firstStep, secondStep = tableBetHistoryStore.secondStep, getFirstStep = tableBetHistoryStore.getFirstStep, selectedHistoryRow = tableBetHistoryStore.selectedHistoryRow, setSelectedHistoryRow = tableBetHistoryStore.setSelectedHistoryRow, queryState = tableBetHistoryStore.queryState;
    var firstStepData = firstStep.data.items;
    var secondStepData = secondStep.data;
    var _c = __read(useState({
        firstStepIndex: 0,
        secondStepIndex: 0,
    }), 2), paginationState = _c[0], setPaginationState = _c[1];
    useEffect(function () {
        getFirstStep(queryState);
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d;
        var firstStepIndex = paginationState.firstStepIndex, secondStepIndex = paginationState.secondStepIndex;
        if (secondStepIndex === 0) {
            if (secondStepIndex + 1 ===
                (secondStepData[(_a = firstStepData[firstStepIndex]) === null || _a === void 0 ? void 0 : _a.date] &&
                    secondStepData[(_b = firstStepData[firstStepIndex]) === null || _b === void 0 ? void 0 : _b.date].length)) {
                setDisablePaging(betHistoryPagingDisable.ALL);
                return;
            }
            setDisablePaging(betHistoryPagingDisable.PREV);
            return;
        }
        if (secondStepIndex + 1 ===
            (secondStepData[(_c = firstStepData[firstStepIndex]) === null || _c === void 0 ? void 0 : _c.date] &&
                secondStepData[(_d = firstStepData[firstStepIndex]) === null || _d === void 0 ? void 0 : _d.date].length)) {
            setDisablePaging(betHistoryPagingDisable.NEXT);
            return;
        }
        setDisablePaging(null);
    }, [paginationState]);
    var handleHistoryRowClick = function (id, date) {
        var secondStepIndex = secondStepData[date].findIndex(function (item) { return item.id === id || item.roundId === id; });
        var firstStepIndex = firstStepData.findIndex(function (item) { return item.date === date; });
        setSelectedHistoryRow(id);
        setPaginationState({
            firstStepIndex: firstStepIndex,
            secondStepIndex: secondStepIndex,
        });
    };
    var handleChangePagination = function (direction) {
        var firstStepIndex = paginationState.firstStepIndex, secondStepIndex = paginationState.secondStepIndex;
        var date = firstStepData[firstStepIndex].date;
        if (secondStepData[date]) {
            var secondData = secondStepData[date];
            if (secondStepIndex - 1 < 0 && direction === betHistoryPagingDisable.PREV) {
                return;
            }
            if (secondStepIndex + 1 === secondData.length && direction === betHistoryPagingDisable.NEXT) {
                return;
            }
            setDisablePaging(null);
            setPaginationState(function (prev) { return ({
                firstStepIndex: prev.firstStepIndex,
                secondStepIndex: direction === betHistoryPagingDisable.NEXT ? prev.secondStepIndex + 1 : prev.secondStepIndex - 1,
            }); });
            setSelectedHistoryRow(secondData[direction === betHistoryPagingDisable.NEXT ? secondStepIndex + 1 : secondStepIndex - 1].id ||
                secondData[direction === betHistoryPagingDisable.NEXT ? secondStepIndex + 1 : secondStepIndex - 1].roundId);
        }
    };
    return (React.createElement(React.Fragment, null,
        selectedHistoryRow && (React.createElement(SelectedRowWr, { hasReplay: hasReplay, setDisablePaging: setDisablePaging, innerComponent: SelectedRow, disablePaging: disablePaging, onPaginationChange: handleChangePagination })),
        React.createElement("div", { className: "game-history ".concat(selectedHistoryRow ? 'pgc-game-visibility-hidden' : '') },
            React.createElement(BetHistoryHeader, null),
            React.createElement(BetHistoryContent, { onHistoryRowClick: handleHistoryRowClick }))));
});

var ChipsContainer = observer(function (_a) {
    var quickBets = _a.quickBets, selectedChip = _a.selectedChip, chipsImages = _a.chipsImages, handleSelectChips = _a.handleSelectChips, isFavoriteBet = _a.isFavoriteBet, _b = _a.isFreeChip, isFreeChip = _b === void 0 ? false : _b;
    var balance = userInfoStore.balance;
    var ref = useRef();
    var memoChip = useMemo(function () {
        return (React.createElement(React.Fragment, null, quickBets &&
            quickBets.map(function (_a, index) {
                var chip = _a.chip, color = _a.color;
                return (React.createElement(Fragment, { key: color },
                    React.createElement("div", { className: "pgc-bet-chip\n                    ".concat(!isFavoriteBet && (chip > balance || isFreeChip) ? 'disabled' : '', "\n                    ").concat(color, "\n                    ").concat(chip === selectedChip && !isFreeChip ? 'active' : '', "\n                    ").concat(abbreviateNumber(chip).toString().length > 3 ? '' : 'large', "\n              "), onClick: function () { return handleSelectChips(chip); } },
                        React.createElement("div", { className: 'pgc-chip-number' },
                            React.createElement("span", { className: 'pgc-chip-number-text' }, abbreviateNumber(chip)))),
                    isFreeChip && index === 2 ? (React.createElement("div", { className: "pgc-bet-chip free-chip active\n                    ".concat(abbreviateNumber(selectedChip).toString().length > 3 ? '' : 'large', "\n              ") },
                        React.createElement("div", { className: 'pgc-chip-number' },
                            React.createElement("span", { className: 'pgc-chip-number-text' }, abbreviateNumber(selectedChip))))) : null));
            })));
    }, [selectedChip, quickBets, balance, chipsImages, isFreeChip]);
    return (React.createElement("div", { className: 'pgc-bet-chips', ref: ref }, memoChip));
});

var intervalId;
var SliderWrapper = observer(function (_a) {
    _a.isBogLine; var _b = _a.slidersData, slidersData = _b === void 0 ? [] : _b, _c = _a.slideDuration, slideDuration = _c === void 0 ? 4000 : _c;
    var storeSliderBanners = lobbyStore.sliderBanners;
    var sliderBanners = storeSliderBanners && storeSliderBanners.length ? storeSliderBanners : slidersData;
    var _d = __read(useState(null), 2), isActiveSlider = _d[0], setIsActiveSlider = _d[1];
    useLayoutEffect(function () {
        sliderBanners.forEach(function (item) {
            if (item.isVideo) {
                var media_1 = new Audio(item.url);
                media_1.onloadedmetadata = function () {
                    item.videDuration = media_1.duration * 1000;
                };
            }
        });
    }, [sliderBanners]);
    useEffect(function () {
        setIsActiveSlider(sliderBanners === null || sliderBanners === void 0 ? void 0 : sliderBanners.find(function (item) { return item.isActive; }));
    }, [sliderBanners]);
    useEffect(function () {
        var data = __spreadArray([], __read(sliderBanners), false);
        if (data.length > 1) {
            var maxLength_1 = data.length;
            var currentIndex_1 = sliderBanners.findIndex(function (item) { return item.id === (isActiveSlider === null || isActiveSlider === void 0 ? void 0 : isActiveSlider.id); });
            var videDuration_1 = null;
            if (currentIndex_1 >= 0) {
                intervalId = setTimeout(function run() {
                    videDuration_1 = null;
                    data[currentIndex_1].isActive = true;
                    currentIndex_1++;
                    if (currentIndex_1 >= maxLength_1) {
                        currentIndex_1 = 0;
                    }
                    if (data[currentIndex_1] && data[currentIndex_1].isVideo) {
                        videDuration_1 = data[currentIndex_1].videDuration;
                    }
                    setIsActiveSlider(data[currentIndex_1]);
                    intervalId = setTimeout(run, videDuration_1 || slideDuration);
                }, isActiveSlider && isActiveSlider.videDuration ? isActiveSlider.videDuration : slideDuration);
            }
        }
        return function () {
            clearTimeout(intervalId);
        };
    }, [isActiveSlider]);
    return sliderBanners && sliderBanners.length ? (React.createElement(TableSlider, null, sliderBanners.map(function (banner) { return (React.createElement(TableSlider.ItemsWr, { isActive: banner.id === (isActiveSlider === null || isActiveSlider === void 0 ? void 0 : isActiveSlider.id), isPrev: banner.isActive ? false : banner.isPrev, key: banner.id }, banner.isVideo ? (React.createElement(TableSlider.VideoItem, { src: banner.url })) : (React.createElement(TableSlider.ImgItem, { src: banner.url, imgAlt: 'banner' })))); }))) : (React.createElement(React.Fragment, null));
});

var delay = 1000;
var Timer = function () {
    var _a = __read(useState(getLocaleTime()), 2), currentTime = _a[0], setCurrentTime = _a[1];
    var Time = IconTypes.Time;
    useEffect(function () {
        var intervalId = setTimeout(function tick() {
            setCurrentTime(getLocaleTime());
            intervalId = setTimeout(tick, delay);
        }, delay);
        return function () {
            clearInterval(intervalId);
        };
    }, []);
    return (React.createElement("div", { className: 'timer-holder' },
        React.createElement("i", { className: "ui-lib-".concat(Time) }),
        React.createElement("span", { title: currentTime, className: 'timer' }, currentTime)));
};

var WebGameMainCont = observer(function (_a) {
    var _b = _a.isShowTime, isShowTime = _b === void 0 ? true : _b, _c = _a.hasDemoPopup, hasDemoPopup = _c === void 0 ? true : _c, _d = _a.hasLobby, hasLobby = _d === void 0 ? true : _d, _e = _a.hasGameTypeLoading, hasGameTypeLoading = _e === void 0 ? true : _e, isShowIconTag = _a.isShowIconTag, lobbyLogoImageSrc = _a.lobbyLogoImageSrc, demoSwitcherAdditionalFunction = _a.demoSwitcherAdditionalFunction, playForRealPopupImgSrc = _a.playForRealPopupImgSrc, isShowBogLineLobby = _a.isShowBogLineLobby, hasCustomSideBar = _a.hasCustomSideBar, children = _a.children;
    var gameThemeConfigs = userSettingsStore.gameThemeConfigs;
    var sideBarButtonNotificationCount = gameConfigStore.sideBarButtonNotificationCount, isShowSideBarButton = gameConfigStore.isShowSideBarButton;
    return (React.createElement(React.Fragment, null,
        gameThemeConfigs.isEnabled && GameTheme[gameThemeConfigs.themeType] === GameThemeNames.Winter ? (React.createElement(SnowFlakes, null)) : null,
        React.createElement("div", { className: 'for-main-wrapper-holder' },
            React.createElement("div", { className: 'main-wrapper-holder' },
                React.createElement("div", { className: 'main-wrapper' },
                    children,
                    isShowTime && React.createElement(Timer, null))),
            hasCustomSideBar && isShowSideBarButton && (React.createElement("div", { className: 'side-bar' },
                !!sideBarButtonNotificationCount && (React.createElement("span", { className: classNames('side-bar-notifications', sideBarButtonNotificationCount.toString().length >= 2 ? 'small' : '') }, sideBarButtonNotificationCount)),
                React.createElement("div", { className: 'side-bar-icon-block' },
                    React.createElement("i", { className: "ui-lib-".concat(IconTypes.PlatformSideBar) }))))),
        hasDemoPopup && (React.createElement(PlayForRealPopup, { demoSwitcherAdditionalFunction: demoSwitcherAdditionalFunction, popupLogo: playForRealPopupImgSrc, forBogLine: true })),
        hasLobby && (React.createElement(LobbyWrapper, { lobbyLogoImageSrc: lobbyLogoImageSrc, isShowBogLineLobby: isShowBogLineLobby, isShowIconTag: isShowIconTag })),
        hasGameTypeLoading && React.createElement(GameTypeLoading, null)));
});

/**
 * @param {HTMLElement} children
 * @param {string} types - "" | "from-left" | "from-right"
 * @param {string} size - "is-full" | "is-small"
 */
var PopupWr = observer(function (_a) {
    var _b;
    _a.children; var popupLeftTabs = _a.popupLeftTabs, popupRightWithSpecificData = _a.popupRightWithSpecificData, _c = _a.title, title = _c === void 0 ? 'pop-up title' : _c, isShowCloseIcon = _a.isShowCloseIcon, popupRef = _a.popupRef, hasReplay = _a.hasReplay;
    var popupName = popupStore.popupName, isFromBetHistory = popupStore.isFromBetHistory, currentData = popupStore.currentData;
    var scrollableContainerRef = useRef();
    var initialActivePopupTab = popupName || popupLeftTabs.find(function (item) { return item.isDefault; }).uniqueId || ((_b = popupLeftTabs[0]) === null || _b === void 0 ? void 0 : _b.uniqueId);
    var _d = __read(useState(initialActivePopupTab), 2), selectedPopupTabId = _d[0], setSelectedPopupTabId = _d[1];
    var close = popupStore.close;
    var _e = popupRightWithSpecificData[selectedPopupTabId] || {}, _f = _e.popupRestProps, _g = _f === void 0 ? {} : _f, _h = _g.from, from = _h === void 0 ? 'from-left' : _h, _j = _g.size, size = _j === void 0 ? 'is-small' : _j, _k = _g.withoutTabSection, withoutTabSection = _k === void 0 ? false : _k, component = _e.component;
    useEffect(function () {
        var _a;
        if ((scrollableContainerRef === null || scrollableContainerRef === void 0 ? void 0 : scrollableContainerRef.current) && selectedPopupTabId) {
            // @ts-ignore
            (_a = scrollableContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: 0, behavior: 'instant' });
        }
    }, [scrollableContainerRef, selectedPopupTabId]);
    var handleReplayClick = function () {
        if (currentData) {
            ApiServices.get(ApiServiceTypes.UsersService)
                // originalId is backend bet id, it's need when have custom parser in game
                .getReplayUrl({ betId: currentData.originalId || currentData.id })
                .then(function (response) {
                var result = response.data.result;
                if (result && result.replayUrl) {
                    window.open(result.replayUrl);
                }
            })
                .catch(function (error) {
                console.error('replay click', error);
            });
        }
    };
    return (React.createElement("div", { className: "core-popup-wr ".concat(size, " ").concat(from) },
        React.createElement("div", { className: 'core-popup-wr-inner', ref: popupRef },
            !withoutTabSection && (React.createElement("div", { className: 'core-popup-inner-left' },
                React.createElement("div", { className: 'core-popup-inner-left-inner' },
                    React.createElement("div", { className: 'core-popup-inner-left-inside' },
                        React.createElement("div", { className: 'core-popup-inner-left-tab-wrp' }, popupLeftTabs.map(function (_a) {
                            var tabTitle = _a.title, uniqueId = _a.uniqueId;
                            return (React.createElement("div", { key: uniqueId, className: "core-popup-inner-left-tab-item ".concat(selectedPopupTabId === uniqueId ? 'active' : ''), onClick: function () { return setSelectedPopupTabId(uniqueId); } },
                                React.createElement("p", { className: 'core-popup-inner-left-tab-txt' }, tabTitle),
                                React.createElement("span", { className: 'core-popup-inner-left-tab-active' })));
                        })))))),
            React.createElement("div", { className: 'core-popup-inner-right' },
                React.createElement("div", { className: 'core-popup-inner-right-content' },
                    React.createElement("div", { className: 'top-core-popup-wr-inner' },
                        React.createElement("div", { className: 'top-core-popup-wr-inner-row' },
                            React.createElement("p", { className: 'top-core-popup-wr-inner-row-txt' }, title),
                            hasReplay && isFromBetHistory && (React.createElement("p", { className: 'top-core-popup-wr-inner-row-replay', onClick: function () { return handleReplayClick(); } },
                                React.createElement("i", { className: "ui-lib-".concat(IconTypes.Replay) }))),
                            isShowCloseIcon && (React.createElement("div", { className: 'popup-close-block', onClick: close },
                                React.createElement("div", { className: 'popup-close-block-inner' },
                                    React.createElement("i", { className: "ui-lib-".concat(IconTypes.CloseX) })))))),
                    React.createElement("div", { className: 'bottom-core-popup-wr-inner' },
                        React.createElement("div", { className: 'bottom-core-popup-content' },
                            React.createElement("div", { className: 'scrollable-container', ref: scrollableContainerRef },
                                React.createElement("div", { className: 'bottom-core-popup-content-block' }, component)))))))));
});

var SettingsBlockComponent = function (_a) {
    var children = _a.children, settingsBlockRef = _a.settingsBlockRef, rest = __rest(_a, ["children", "settingsBlockRef"]);
    return (React.createElement("div", __assign({ className: 'settings-block-wr', onClick: function (e) { return e.stopPropagation(); }, ref: settingsBlockRef }, rest),
        React.createElement("div", { className: 'settings-block' },
            React.createElement("div", { className: 'small-coordinator' },
                React.createElement("svg", { className: 'avatars-popover-arrow-svg', viewBox: '0 0 18 13', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
                    React.createElement("path", { className: 'avatars-popover-arrow-svg-path', d: 'M0.900542 12.75L0.900162 12.75C0.779742 12.7502 0.662114 12.7185 0.560146 12.6591C0.458241 12.5997 0.376363 12.5153 0.322373 12.4158C0.268431 12.3165 0.24406 12.2055 0.251224 12.0948C0.258389 11.984 0.296909 11.8764 0.363584 11.7839L0.363828 11.7835L8.4639 0.496959C8.57563 0.341634 8.77792 0.25 9.00156 0.25C9.22522 0.25 9.42711 0.341628 9.53836 0.496701L9.53839 0.496741L17.638 11.7827C17.6381 11.7829 17.6383 11.7831 17.6384 11.7832C17.7042 11.876 17.7421 11.9834 17.7489 12.0939C17.7557 12.2046 17.7311 12.3155 17.6772 12.4147C17.6232 12.5141 17.5414 12.5985 17.4397 12.658C17.3381 12.7175 17.2208 12.7496 17.1005 12.75C17.1004 12.75 17.1003 12.75 17.1002 12.75L0.900542 12.75Z', fillOpacity: '1', stroke: 'url(#arrow-svg-gradient)', strokeWidth: '0.5' }),
                    React.createElement("defs", null,
                        React.createElement("linearGradient", { id: 'arrow-svg-gradient', x1: '9', y1: '0', x2: '9', y2: '13', gradientUnits: 'userSpaceOnUse' },
                            React.createElement("stop", { className: 'arrow-svg-gradient-stop' }),
                            React.createElement("stop", { className: 'arrow-svg-gradient-stop', offset: '1', stopOpacity: '0' }))))),
            React.createElement("div", { className: 'settings-block-inner' },
                React.createElement("div", { className: 'settings-block-inner-content' }, children)))));
};
var Row = function (_a) {
    var text = _a.text, isChecked = _a.isChecked, handler = _a.handler, _b = _a.index, index = _b === void 0 ? "".concat(text, "-").concat(Math.random()) : _b, isModeSwitcher = _a.isModeSwitcher, switcherIconType = _a.switcherIconType;
    var settingsRowClassnames = classNames('settings-block-row', {
        mode: isModeSwitcher,
    });
    return (React.createElement("div", { className: settingsRowClassnames },
        React.createElement(SettingsBlock.RowInput, { isChecked: isChecked, handler: handler, index: index }),
        React.createElement(SettingsBlock.RowInputLabel, { text: text, index: index }),
        React.createElement("div", { className: 'settings-selection-block' },
            React.createElement("div", { className: 'settings-selection-block-inner' }, switcherIconType && React.createElement("i", { className: "ui-lib-".concat(switcherIconType) })))));
};
var RangeRow = function (_a) {
    var rangeTitle = _a.rangeTitle, _b = _a.iconName, iconName = _b === void 0 ? IconTypes.VolumeUp : _b, _c = _a.width, width = _c === void 0 ? 0 : _c, handler = _a.handler; _a.isChecked; var onChange = _a.onChange, value = _a.value, _e = _a.min, min = _e === void 0 ? 0 : _e, _f = _a.max, max = _f === void 0 ? 1 : _f, _g = _a.step, step = _g === void 0 ? 0.1 : _g;
    return (React.createElement("div", { className: 'settings-block-row' },
        React.createElement("div", { className: 's-bl-row-range-wrp' },
            React.createElement("p", { className: 'inp-range-title' }, rangeTitle),
            React.createElement("div", { className: 'f-c-min-max-line' },
                React.createElement("input", { type: 'range', className: 'inp-range', value: value, min: min, max: max, step: step, onChange: onChange }),
                React.createElement("div", { className: 'f-c-min-max-line-ins', style: { width: "".concat(width, "%") } }),
                React.createElement("div", { className: 'f-c-min-max-line-circle-wrp' },
                    React.createElement("div", { className: 'f-c-min-max-line-circle-cont' },
                        React.createElement("div", { className: 'f-c-min-max-line-circle', style: { left: "".concat(width, "%") } },
                            React.createElement("div", { className: 'f-c-min-max-line-circle-holder' },
                                React.createElement("i", { className: "ui-lib-".concat(iconName), onClick: handler })))))))));
};
var RowInputLabel = function (_a) {
    var text = _a.text, index = _a.index;
    return (React.createElement("label", { className: 'settings-block-row-lbl', htmlFor: "checkbox".concat(index) },
        React.createElement("p", { className: 'settings-block-row-txt', title: text }, text)));
};
var RowInput = function (_a) {
    var isChecked = _a.isChecked, handler = _a.handler, index = _a.index;
    return (React.createElement("input", { className: 'select-checkbox', id: "checkbox".concat(index), type: 'checkbox', checked: isChecked, onChange: handler }));
};
var EditRow = function (_a) {
    var text = _a.text, handler = _a.handler, _b = _a.iconName, iconName = _b === void 0 ? IconTypes.Edit : _b;
    return (React.createElement("div", { className: 'settings-block-row' },
        React.createElement("div", { className: 'settings-avatars' },
            React.createElement("p", { className: 'settings-avatars-heading', title: text }, text),
            React.createElement("div", { className: 'settings-avatars-btn', onClick: handler },
                React.createElement("i", { className: "ui-lib-".concat(iconName) })))));
};
var MobileHeading = function (_a) {
    var text = _a.text;
    return React.createElement("div", { className: 'settings-block-heading' }, text);
};
var SettingsBlock = Object.assign(SettingsBlockComponent, {
    Row: Row,
    RangeRow: RangeRow,
    RowInput: RowInput,
    EditRow: EditRow,
    RowInputLabel: RowInputLabel,
    MobileHeading: MobileHeading,
});

var UserId = observer(function (_a) {
    _a.children;
    var playerExternalId = userInfoStore.playerExternalId;
    var isDemo = applicationStore.isDemo;
    var _b = parseQuery(window.location.search), _c = DefaultQueryParams.HidePlayerId, hidePlayerId = _b[_c];
    return !isDemo ? (React.createElement("div", { className: 'user-balance', title: "ID: ".concat(Number(hidePlayerId) ? maskName(playerExternalId) : playerExternalId) },
        "ID: ",
        Number(hidePlayerId) ? maskName(playerExternalId) : playerExternalId)) : (React.createElement(React.Fragment, null));
});

var UserBalance = observer(function (_a) {
    var userBalanceAdditionalChildren = _a.userBalanceAdditionalChildren;
    var balance = userInfoStore.balance;
    return (React.createElement("div", { className: 'user-balance-amount', title: getAmountWithCurrency({ amount: convertAmount(balance) }) },
        userBalanceAdditionalChildren,
        getAmountWithCurrency({ amount: convertAmount(balance) })));
});

/**
 *
 * @param children - PASS FROM PARENT CHILDREN COMPONENT IF NEED ADDITIONAL HEADER COMPONENT!IMPORTANT
 * @param headerNames
 * @param results
 * @param renderResultItem
 * @param keyExtractor
 * @constructor
 */
var GameResults = observer(function (_a) {
    var children = _a.children, headerNames = _a.headerNames, renderResultItem = _a.renderResultItem;
    var gameResults = gameResultStore.gameResults;
    var t = useTranslation();
    return (React.createElement(List, null,
        children,
        React.createElement(ListHeader, null, headerNames.map(function (name) { return (React.createElement(ListHeaderItem, { key: name, title: t(name) }, t(name))); })),
        React.createElement(ListBody, null, gameResults.map(function (result, index, list) { return renderResultItem(result, index, list); }))));
});

/**
 *
 * @param children - PASS FROM PARENT CHILDREN COMPONENT IF NEED ADDITIONAL HEADER COMPONENT!IMPORTANT
 * @param headerNames
 * @param results
 * @param renderResultItem
 * @param keyExtractor
 * @constructor
 */
var GameHighestResults = observer(function (_a) {
    var children = _a.children, headerNames = _a.headerNames; _a.results; var renderResultItem = _a.renderResultItem;
    var highestOddsData = statisticsStore.highestOddsData, getHttpStatistics = statisticsStore.getHttpStatistics;
    var t = useTranslation();
    useEffect(function () {
        if (!(highestOddsData === null || highestOddsData === void 0 ? void 0 : highestOddsData.length)) {
            getHttpStatistics();
        }
    }, []);
    return (React.createElement(List, null,
        children,
        React.createElement(ListHeader, null, headerNames.map(function (name) { return (React.createElement(ListHeaderItem, { key: name, title: t(name) }, t(name))); })),
        React.createElement(ListBody, null, highestOddsData === null || highestOddsData === void 0 ? void 0 : highestOddsData.map(function (result, index, list) { return renderResultItem(result, index, list); }))));
});

var leftContainerFooterInitialActiveTabIndex = 0;
var LeftContainerFooter = observer(function (_a) {
    var tabs = _a.tabs, tabContainers = _a.tabContainers, onTabChange = _a.onTabChange;
    var _b = __read(useState(leftContainerFooterInitialActiveTabIndex), 2), activeTabIndex = _b[0], setActiveTabIndex = _b[1];
    var gameTypeId = gameConfigStore.gameTypeId;
    var handleTabChange = useOpenBetHistory({ tabs: tabs, onTabChange: onTabChange, setActiveTabIndex: setActiveTabIndex }).handleTabChange;
    var t = useTranslation();
    useEffect(function () {
        handleTabChange(leftContainerFooterInitialActiveTabIndex);
    }, [gameTypeId]);
    return (React.createElement(ColBodyInner, null,
        (tabs === null || tabs === void 0 ? void 0 : tabs.length) && (React.createElement(ColBodyInnerTopWr, null,
            React.createElement(Tabs, { activeIndex: activeTabIndex }, tabs.map(function (item, index) { return (React.createElement(TabItem, { onClick: function () { return handleTabChange(index); }, text: t(item.name), key: "".concat(index, "_").concat(item.name) })); })))),
        React.createElement(ColBodyInnerBottomWr, null, tabContainers[activeTabIndex])));
});

var rangeMinValue = 0;
var rangeMaxValue = 1;
var rangeStepValue = 0.1;
var SettingsContainer = observer(function (_a) {
    var hasLobby = _a.hasLobby, haveDarkMode = _a.haveDarkMode, hasAvatarsBlock = _a.hasAvatarsBlock, hasMusicControllerRow = _a.hasMusicControllerRow, hasSoundControllerRow = _a.hasSoundControllerRow, hasHalfCashOut = _a.hasHalfCashOut, hasAnimation = _a.hasAnimation, hasMobileInfoPopUp = _a.hasMobileInfoPopUp, handleChangeGameType = _a.handleChangeGameType, settingsBlockRefInParent = _a.settingsBlockRefInParent, isSettingsBlockOpenedFromParent = _a.isSettingsBlockOpenedFromParent, isFreeBetBlockOpenedFromSettings = _a.isFreeBetBlockOpenedFromSettings, setIsFreeBetBlockOpenedFromSettings = _a.setIsFreeBetBlockOpenedFromSettings;
    var t = useTranslation();
    var isMusicOn = userSettingsStore.isMusicOn, isSoundOn = userSettingsStore.isSoundOn, musicVolume = userSettingsStore.musicVolume, soundVolume = userSettingsStore.soundVolume, isDarkModeOn = userSettingsStore.isDarkModeOn, isAnimationOn = userSettingsStore.isAnimationOn, gameThemeConfigs = userSettingsStore.gameThemeConfigs, isHalfCashOutOn = userSettingsStore.isHalfCashOutOn, setIsMusicOn = userSettingsStore.setIsMusicOn, setMusicVolume = userSettingsStore.setMusicVolume, setIsSoundOn = userSettingsStore.setIsSoundOn, setSoundVolume = userSettingsStore.setSoundVolume, setIsDarkModeOn = userSettingsStore.setIsDarkModeOn, setGameThemeTypeEnabledState = userSettingsStore.setGameThemeTypeEnabledState, setIsAnimationOn = userSettingsStore.setIsAnimationOn, setIsHalfCashOutOn = userSettingsStore.setIsHalfCashOutOn;
    var settingsRef = useRef();
    var _b = __read(useOutsideClick(settingsBlockRefInParent || settingsRef), 2), opened = _b[0], handleClick = _b[1];
    var playerExternalId = userInfoStore.playerExternalId;
    var isDemo = applicationStore.isDemo;
    var _c = __read(useState(false), 2), isAvatarsBlockOpenedFromParent = _c[0], setIsAvatarsBlockOpenedFromParent = _c[1];
    var query = parseQuery(window.location.search);
    var toggleMusic = useCallback(function () {
        setIsMusicOn();
    }, []);
    var changeMusic = useCallback(function (_a) {
        var value = _a.target.value;
        setMusicVolume(value);
    }, []);
    var toggleSound = useCallback(function () {
        setIsSoundOn();
    }, []);
    var changeSound = useCallback(function (_a) {
        var value = _a.target.value;
        setSoundVolume(value);
    }, []);
    var toggleAnimationOn = useCallback(function () {
        setIsAnimationOn();
    }, []);
    var openInfoPupUp = useCallback(function () {
        popupStore.open();
        handleClick();
    }, []);
    var toggleDarkMode = useCallback(function (arg) {
        arg.target.checked
            ? document.documentElement.classList.add('dark')
            : document.documentElement.classList.remove('dark');
        setIsDarkModeOn();
    }, []);
    var toggleGameTheme = useCallback(function () {
        setGameThemeTypeEnabledState();
    }, []);
    var halfCashOutToggle = useCallback(function () {
        setIsHalfCashOutOn();
    }, []);
    useEffect(function () {
        if (hasHalfCashOut) {
            gameConfigStore.setIsGameHasHalfCashOut(hasHalfCashOut);
        }
    }, [hasHalfCashOut]);
    return (React.createElement(React.Fragment, null,
        isMobile() && (React.createElement(UserBlockImage, { t: t, onClick: handleClick, winterModeActive: gameThemeConfigs.isEnabled && GameTheme[gameThemeConfigs.themeType] === GameThemeNames.Winter, hasAvatarsBlock: hasAvatarsBlock, isAvatarsBlockOpenedFromParent: isAvatarsBlockOpenedFromParent, setIsAvatarsBlockOpenedFromParent: setIsAvatarsBlockOpenedFromParent })),
        !isAvatarsBlockOpenedFromParent &&
            !isFreeBetBlockOpenedFromSettings &&
            (isSettingsBlockOpenedFromParent || opened) && (React.createElement(SettingsBlock, { settingsBlockRef: !!settingsBlockRefInParent ? null : settingsRef },
            isMobile() && !isDemo && (React.createElement(SettingsBlock.MobileHeading, { text: "ID: ".concat(Number(query[DefaultQueryParams.HidePlayerId]) ? maskName(playerExternalId) : playerExternalId) })),
            isMobile() && hasLobby && (React.createElement(SettingsBlock.EditRow, { text: t(TranslationKeys.GameTypes), iconName: IconTypes.Lobby, handler: function () { return handleChangeGameType(); } })),
            isIOS() ? (React.createElement(React.Fragment, null,
                hasMusicControllerRow && (React.createElement(SettingsBlock.Row, { switcherIconType: isMusicOn ? IconTypes.MusicOn : IconTypes.MusicOff, text: t(TranslationKeys.Music), handler: toggleMusic, isChecked: isMusicOn })),
                hasSoundControllerRow && (React.createElement(SettingsBlock.Row, { switcherIconType: isSoundOn ? IconTypes.VolumeUp : IconTypes.VolumeOff, text: t(TranslationKeys.Sound), handler: toggleSound, isChecked: isSoundOn })))) : (React.createElement(React.Fragment, null,
                hasMusicControllerRow && (React.createElement(SettingsBlock.RangeRow, { min: rangeMinValue, max: rangeMaxValue, step: rangeStepValue, value: musicVolume, isChecked: isMusicOn, handler: toggleMusic, onChange: changeMusic, width: musicVolume * 100, iconName: isMusicOn ? IconTypes.MusicOn : IconTypes.MusicOff, rangeTitle: t(TranslationKeys.Music) })),
                hasSoundControllerRow && (React.createElement(SettingsBlock.RangeRow, { min: rangeMinValue, max: rangeMaxValue, step: rangeStepValue, value: soundVolume, handler: toggleSound, isChecked: isSoundOn, onChange: changeSound, width: soundVolume * 100, iconName: isSoundOn ? IconTypes.VolumeUp : IconTypes.VolumeOff, rangeTitle: t(TranslationKeys.Sound) })))),
            hasAnimation && (React.createElement(SettingsBlock.Row, { text: t(TranslationKeys.Animations), handler: toggleAnimationOn, isChecked: isAnimationOn })),
            !!GameTheme[query[DefaultQueryParams.Theme]] && (React.createElement(SettingsBlock.Row, { text: t(GameThemeTKeys[query[DefaultQueryParams.Theme]]), handler: toggleGameTheme, isChecked: gameThemeConfigs.isEnabled })),
            haveDarkMode && (React.createElement(SettingsBlock.Row, { isModeSwitcher: true, handler: toggleDarkMode, isChecked: isDarkModeOn, text: t(TranslationKeys.BlackMode), switcherIconType: IconTypes.Mode })),
            hasMobileInfoPopUp && (React.createElement(SettingsBlock.EditRow, { text: t(TranslationKeys.Info), handler: openInfoPupUp, iconName: IconTypes.Info })),
            hasAvatarsBlock && (React.createElement(SettingsBlock.EditRow, { text: t(TranslationKeys.Avatars), handler: function () { return setIsAvatarsBlockOpenedFromParent(function (prev) { return !prev; }); } })),
            isMobile() && hasFreeBetsOrAtLeastOneFreeBetNotExpired(true) && (React.createElement(SettingsBlock.EditRow, { iconName: IconTypes.Gift, text: t(TranslationKeys.FreeBets), handler: function () { return setIsFreeBetBlockOpenedFromSettings(true); } })),
            hasHalfCashOut && (React.createElement(SettingsBlock.Row, { text: t(TranslationKeys.HalfCashOut), handler: halfCashOutToggle, isChecked: isHalfCashOutOn }))))));
});

var CollapsibleListComponentsType;
(function (CollapsibleListComponentsType) {
    CollapsibleListComponentsType[CollapsibleListComponentsType["FreeBets"] = 0] = "FreeBets";
    CollapsibleListComponentsType[CollapsibleListComponentsType["Settings"] = 1] = "Settings";
})(CollapsibleListComponentsType || (CollapsibleListComponentsType = {}));
var TopCollapsibleSettingsWrapper = observer(function (_a) {
    var haveDarkMode = _a.haveDarkMode, hasAnimation = _a.hasAnimation, hasHalfCashOut = _a.hasHalfCashOut, hasSoundControllerRow = _a.hasSoundControllerRow, hasMusicControllerRow = _a.hasMusicControllerRow, isCollapsibleSettingsListOpened = _a.isCollapsibleSettingsListOpened, setIsCollapsibleSettingsListOpened = _a.setIsCollapsibleSettingsListOpened;
    var _b = __read(useState(null), 2), collapsibleComponentsType = _b[0], mainSetCollapsibleComponentsType = _b[1];
    var _c = __read(useClickOutside(), 2), collapsibleSettingsListRef = _c[0], hasCollapsibleSettingsListClickedOutside = _c[1];
    var setCollapsibleComponentsType = function (type) {
        mainSetCollapsibleComponentsType(type === collapsibleComponentsType ? null : type);
    };
    useEffect(function () {
        if (hasCollapsibleSettingsListClickedOutside) {
            setIsCollapsibleSettingsListOpened(false);
            setCollapsibleComponentsType(null);
        }
    }, [hasCollapsibleSettingsListClickedOutside]);
    var handleSettingListCollapse = useCallback(function (e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setIsCollapsibleSettingsListOpened(function (prevState) {
            if (prevState) {
                setCollapsibleComponentsType(null);
            }
            return !prevState;
        });
    }, []);
    var collapsibleListComponents = useMemo(function () {
        var _a;
        return _a = {},
            _a[CollapsibleListComponentsType.FreeBets] = (React.createElement(FreeBetsWrapper, { isFromSettings: true, isOpenedFromParentComponent: collapsibleComponentsType === CollapsibleListComponentsType.FreeBets, changeIsOpenedFromParentComponent: function () { return setCollapsibleComponentsType(null); } })),
            _a[CollapsibleListComponentsType.Settings] = (React.createElement(SettingsContainer, { hasHalfCashOut: hasHalfCashOut, haveDarkMode: haveDarkMode, hasAnimation: hasAnimation, hasMusicControllerRow: hasMusicControllerRow, isSettingsBlockOpenedFromParent: collapsibleComponentsType === CollapsibleListComponentsType.Settings, hasSoundControllerRow: hasSoundControllerRow })),
            _a;
    }, [
        haveDarkMode,
        hasAnimation,
        hasHalfCashOut,
        hasSoundControllerRow,
        hasMusicControllerRow,
        collapsibleComponentsType,
    ]);
    return (React.createElement(ColHeaderBlock, { isIconBlock: true, colHeaderBlockRef: collapsibleSettingsListRef },
        React.createElement(ColHeaderBlockInner, { onClick: handleSettingListCollapse },
            React.createElement(IconBlock, { iconType: IconTypes.Dot })),
        React.createElement(CollapsibleSettingsList, { isShowFreeBetIcon: hasFreeBetsOrAtLeastOneFreeBetNotExpired(true), isFreeBetsBlockOpened: collapsibleComponentsType === CollapsibleListComponentsType.FreeBets, isSettingsBlockOpened: collapsibleComponentsType === CollapsibleListComponentsType.Settings, isCollapsibleSettingsListOpened: isCollapsibleSettingsListOpened, setCollapsibleFreeBetComponentsType: function () {
                return setCollapsibleComponentsType(CollapsibleListComponentsType.FreeBets);
            }, setCollapsibleSettingComponentsType: function () {
                return setCollapsibleComponentsType(CollapsibleListComponentsType.Settings);
            } }, (collapsibleComponentsType || collapsibleComponentsType === 0) &&
            collapsibleListComponents[collapsibleComponentsType])));
});

var LeftContainerHeader = observer(function (_a) {
    var hasAnimation = _a.hasAnimation, hasHalfCashOut = _a.hasHalfCashOut, _b = _a.hasSoundControllerRow, hasSoundControllerRow = _b === void 0 ? true : _b, _c = _a.hasMusicControllerRow, hasMusicControllerRow = _c === void 0 ? true : _c, haveDarkMode = _a.haveDarkMode;
    var isRepliedGame = platformMessageStore.isRepliedGame;
    var _d = __read(useState(false), 2), isCollapsibleSettingsListOpened = _d[0], setIsCollapsibleSettingsListOpened = _d[1];
    var handleChangeGameType = useCallback(function () {
        lobbyStore.setIsShowLobbySelectGameType(true);
    }, []);
    return (React.createElement(ColHeader, null,
        React.createElement(ColHeaderBlock, { isIconBlock: true },
            React.createElement(ColHeaderBlockInner, { isLeft: true, onClick: handleChangeGameType },
                React.createElement(IconBlock, { iconType: IconTypes.Lobby }))),
        React.createElement(ColHeaderBlock, { isNeedSetOpacityClass: isCollapsibleSettingsListOpened }, !isRepliedGame && React.createElement(LimitsBlock, null)),
        React.createElement(TopCollapsibleSettingsWrapper, { hasHalfCashOut: hasHalfCashOut, haveDarkMode: haveDarkMode, hasAnimation: hasAnimation, hasMusicControllerRow: hasMusicControllerRow, hasSoundControllerRow: hasSoundControllerRow, isCollapsibleSettingsListOpened: isCollapsibleSettingsListOpened, setIsCollapsibleSettingsListOpened: setIsCollapsibleSettingsListOpened })));
});

var ChatHeader = function (_a) {
    var onClick = _a.onClick, isOpen = _a.isOpen, isExpanded = _a.isExpanded, setIsExpanded = _a.setIsExpanded, unReadCount = _a.unReadCount, t = _a.t;
    var Chat = TranslationKeys.Chat;
    return (React.createElement("div", { className: 'chat-top' },
        React.createElement("div", { className: 'chat-header' },
            isOpen && (React.createElement("button", { className: 'chat-header-action chat-header-action-left', type: 'button', onClick: function () { return setIsExpanded(!isExpanded); } },
                React.createElement("i", { className: "ui-lib-".concat(IconTypes.Expand) }))),
            React.createElement("div", { className: 'chat-header-title' },
                t(Chat),
                React.createElement("span", { className: 'chat-count' }, unReadCount ? " (".concat(unReadCount, ")") : '')),
            React.createElement("button", { className: 'chat-header-action chat-header-action-right', type: 'button', onClick: onClick },
                React.createElement("i", { className: "ui-lib-".concat(IconTypes.ChevronUp) })),
            React.createElement("div", { className: 'chat-resize-action', onClick: onClick }))));
};

var ChatFooter = function (_a) {
    var t = _a.t, message = _a.message, isMobile = _a.isMobile, giphyOpened = _a.giphyOpened, giphyButtonRef = _a.giphyButtonRef, emojiButtonRef = _a.emojiButtonRef, setGiphyOpened = _a.setGiphyOpened, handleMessageSend = _a.handleMessageSend, emojiPickerOpened = _a.emojiPickerOpened, isTypingNotAllowed = _a.isTypingNotAllowed, handleMessageTyping = _a.handleMessageTyping, setEmojiPickerOpened = _a.setEmojiPickerOpened, handleMessageSendOnEnter = _a.handleMessageSendOnEnter;
    var Conversation = TranslationKeys.Conversation;
    return (React.createElement("div", { className: 'chat-footer' }, !isTypingNotAllowed && (React.createElement("div", { className: 'chat-conversation-holder' },
        React.createElement("div", { className: 'chat-conversation' },
            React.createElement("div", { className: 'chat-textarea' },
                React.createElement("textarea", { id: '', name: '', value: message, className: "".concat(emojiPickerOpened || giphyOpened ? 'active' : '', " "), placeholder: t(Conversation), onChange: handleMessageTyping, onKeyPress: handleMessageSendOnEnter }),
                React.createElement(ChatActions, { isArrow: true, isMobile: isMobile, giphyOpened: giphyOpened, emojiButtonRef: emojiButtonRef, giphyButtonRef: giphyButtonRef, setGiphyOpened: setGiphyOpened, emojiPickerOpened: emojiPickerOpened, handleMessageSend: handleMessageSend, isTypingNotAllowed: isTypingNotAllowed, setEmojiPickerOpened: setEmojiPickerOpened })))))));
};

var QuickMessages = function (_a) {
    var isMobile = _a.isMobile, sendMessage = _a.sendMessage, giphyOpened = _a.giphyOpened, setGiphyOpened = _a.setGiphyOpened, giphyButtonRef = _a.giphyButtonRef, emojiButtonRef = _a.emojiButtonRef, quickMessagesList = _a.quickMessagesList, emojiPickerOpened = _a.emojiPickerOpened, handleMessageSend = _a.handleMessageSend, isTypingNotAllowed = _a.isTypingNotAllowed, setEmojiPickerOpened = _a.setEmojiPickerOpened;
    var setIsQuickWordsScrolling = chatStore.setIsQuickWordsScrolling;
    var t = useTranslation();
    return (React.createElement("div", { className: "chat-quick-messages ".concat(isTypingNotAllowed ? '' : 'typing-allowed') },
        React.createElement(HorizontalScroll, { setIsScrollingFalse: function () {
                setTimeout(function () {
                    setIsQuickWordsScrolling(false);
                }, 0);
            }, onMouseUpAdditionalFunction: function () { return setIsQuickWordsScrolling(false); }, onMouseDownAdditionalFunction: function () { return setIsQuickWordsScrolling(true); }, onMouseMoveAdditionalFunction: function () { return setIsQuickWordsScrolling(true); }, additionalClassNames: 'chat-quick-messages-inside chat-q-mes-inner' }, (quickMessagesList === null || quickMessagesList === void 0 ? void 0 : quickMessagesList.length) ? (quickMessagesList.map(function (message) { return (React.createElement("div", { className: 'chat-quick-message', onClick: function () { return sendMessage(message, MessageTypes.QuickWord); }, key: message },
            React.createElement("p", { className: 'chat-quick-message-txt' }, t(message)))); })) : (React.createElement(React.Fragment, null))),
        isTypingNotAllowed && (React.createElement(ChatActions, { isMobile: isMobile, giphyOpened: giphyOpened, emojiButtonRef: emojiButtonRef, giphyButtonRef: giphyButtonRef, setGiphyOpened: setGiphyOpened, emojiPickerOpened: emojiPickerOpened, handleMessageSend: handleMessageSend, isTypingNotAllowed: isTypingNotAllowed, setEmojiPickerOpened: setEmojiPickerOpened }))));
};

var UserMessage = function (_a) {
    var type = _a.type, scrollRef = _a.scrollRef, message = _a.message, avatarId = _a.avatarId, userName = _a.userName, messageType = _a.messageType, allowToSetRef = _a.allowToSetRef;
    var t = useTranslation();
    return (React.createElement("div", __assign({ className: "chat-message-outer ".concat(type) }, (allowToSetRef && scrollRef ? { ref: scrollRef } : {})),
        React.createElement("div", { className: 'chat-message' },
            React.createElement("div", { className: 'chat-user-image-holder' },
                React.createElement("div", { className: "chat-user-image ".concat(avatarId ? "av-".concat(avatarId) : 'default') })),
            React.createElement("div", { className: 'chat-user-content' },
                React.createElement("p", { className: 'chat-user-info' }, userName),
                +messageType === MessageTypes.Gif ? (React.createElement("img", { src: message, alt: 'gif' })) : (React.createElement("p", { className: 'chat-user-message' }, +messageType === MessageTypes.QuickWord ? t(message) : message))))));
};

var UserMessageList = function (_a) {
    var messages = _a.messages, userId = _a.userId, isOpenChat = _a.isOpenChat, avatarId = _a.avatarId;
    var scrollRef = useRef(null);
    var _b = __read(useState(true), 2), isInitial = _b[0], setIsInitial = _b[1];
    useEffect(function () {
        if (messages && messages.length && scrollRef && scrollRef.current && isInitial) {
            scrollRef.current.scrollIntoView();
            setIsInitial(false);
        }
    }, [scrollRef, isInitial, messages]);
    useEffect(function () {
        if (messages && messages.length && scrollRef && scrollRef.current) {
            var isMyMessage = +messages[messages.length - 1].userId === +userId;
            if (isMyMessage) {
                scrollRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [messages, scrollRef, isOpenChat, userId]);
    return (React.createElement("div", { className: 'chat-list' }, !!messages.length &&
        messages.map(function (_a, index) {
            var additionalData = _a.additionalData, content = _a.content, messageOwnerUserId = _a.userId, type = _a.type;
            return (React.createElement(UserMessage, { key: index, message: content, messageType: type, scrollRef: scrollRef, userName: maskName(messageOwnerUserId), allowToSetRef: index === messages.length - 1, type: "".concat(Number(userId) === Number(messageOwnerUserId) ? 'sent' : 'received', " "), avatarId: Number(userId) === Number(messageOwnerUserId) ? avatarId : additionalData }));
        })));
};

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $c770c458706daa72$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


var $fb96b826c0c5f37a$var$n, $fb96b826c0c5f37a$export$41c562ebe57d11e2, $fb96b826c0c5f37a$var$u, $fb96b826c0c5f37a$var$t, $fb96b826c0c5f37a$var$r, $fb96b826c0c5f37a$var$o, $fb96b826c0c5f37a$var$e = {}, $fb96b826c0c5f37a$var$c = [], $fb96b826c0c5f37a$var$s = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $fb96b826c0c5f37a$var$a(n1, l1) {
    for(var u1 in l1)n1[u1] = l1[u1];
    return n1;
}
function $fb96b826c0c5f37a$var$h(n2) {
    var l2 = n2.parentNode;
    l2 && l2.removeChild(n2);
}
function $fb96b826c0c5f37a$export$c8a8987d4410bf2d(l3, u2, i1) {
    var t1, r1, o1, f1 = {};
    for(o1 in u2)"key" == o1 ? t1 = u2[o1] : "ref" == o1 ? r1 = u2[o1] : f1[o1] = u2[o1];
    if (arguments.length > 2 && (f1.children = arguments.length > 3 ? $fb96b826c0c5f37a$var$n.call(arguments, 2) : i1), "function" == typeof l3 && null != l3.defaultProps) for(o1 in l3.defaultProps)void 0 === f1[o1] && (f1[o1] = l3.defaultProps[o1]);
    return $fb96b826c0c5f37a$var$y(l3, f1, t1, r1, null);
}
function $fb96b826c0c5f37a$var$y(n3, i2, t2, r2, o2) {
    var f2 = {
        type: n3,
        props: i2,
        key: t2,
        ref: r2,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o2 ? ++$fb96b826c0c5f37a$var$u : o2
    };
    return null == o2 && null != $fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode && $fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode(f2), f2;
}
function $fb96b826c0c5f37a$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $fb96b826c0c5f37a$export$ffb0004e005737fa(n4) {
    return n4.children;
}
function $fb96b826c0c5f37a$export$16fa2f45be04daa8(n5, l4) {
    this.props = n5, this.context = l4;
}
function $fb96b826c0c5f37a$var$k(n6, l5) {
    if (null == l5) return n6.__ ? $fb96b826c0c5f37a$var$k(n6.__, n6.__.__k.indexOf(n6) + 1) : null;
    for(var u3; l5 < n6.__k.length; l5++)if (null != (u3 = n6.__k[l5]) && null != u3.__e) return u3.__e;
    return "function" == typeof n6.type ? $fb96b826c0c5f37a$var$k(n6) : null;
}
function $fb96b826c0c5f37a$var$b(n7) {
    var l6, u4;
    if (null != (n7 = n7.__) && null != n7.__c) {
        for(n7.__e = n7.__c.base = null, l6 = 0; l6 < n7.__k.length; l6++)if (null != (u4 = n7.__k[l6]) && null != u4.__e) {
            n7.__e = n7.__c.base = u4.__e;
            break;
        }
        return $fb96b826c0c5f37a$var$b(n7);
    }
}
function $fb96b826c0c5f37a$var$m(n8) {
    (!n8.__d && (n8.__d = !0) && $fb96b826c0c5f37a$var$t.push(n8) && !$fb96b826c0c5f37a$var$g.__r++ || $fb96b826c0c5f37a$var$o !== $fb96b826c0c5f37a$export$41c562ebe57d11e2.debounceRendering) && (($fb96b826c0c5f37a$var$o = $fb96b826c0c5f37a$export$41c562ebe57d11e2.debounceRendering) || $fb96b826c0c5f37a$var$r)($fb96b826c0c5f37a$var$g);
}
function $fb96b826c0c5f37a$var$g() {
    for(var n9; $fb96b826c0c5f37a$var$g.__r = $fb96b826c0c5f37a$var$t.length;)n9 = $fb96b826c0c5f37a$var$t.sort(function(n10, l7) {
        return n10.__v.__b - l7.__v.__b;
    }), $fb96b826c0c5f37a$var$t = [], n9.some(function(n11) {
        var l8, u5, i3, t3, r3, o3;
        n11.__d && (r3 = (t3 = (l8 = n11).__v).__e, (o3 = l8.__P) && (u5 = [], (i3 = $fb96b826c0c5f37a$var$a({}, t3)).__v = t3.__v + 1, $fb96b826c0c5f37a$var$j(o3, t3, i3, l8.__n, void 0 !== o3.ownerSVGElement, null != t3.__h ? [
            r3
        ] : null, u5, null == r3 ? $fb96b826c0c5f37a$var$k(t3) : r3, t3.__h), $fb96b826c0c5f37a$var$z(u5, t3), t3.__e != r3 && $fb96b826c0c5f37a$var$b(t3)));
    });
}
function $fb96b826c0c5f37a$var$w(n12, l9, u6, i4, t4, r4, o4, f3, s1, a1) {
    var h1, v1, p1, _1, b1, m1, g1, w1 = i4 && i4.__k || $fb96b826c0c5f37a$var$c, A1 = w1.length;
    for(u6.__k = [], h1 = 0; h1 < l9.length; h1++)if (null != (_1 = u6.__k[h1] = null == (_1 = l9[h1]) || "boolean" == typeof _1 ? null : "string" == typeof _1 || "number" == typeof _1 || "bigint" == typeof _1 ? $fb96b826c0c5f37a$var$y(null, _1, null, null, _1) : Array.isArray(_1) ? $fb96b826c0c5f37a$var$y($fb96b826c0c5f37a$export$ffb0004e005737fa, {
        children: _1
    }, null, null, null) : _1.__b > 0 ? $fb96b826c0c5f37a$var$y(_1.type, _1.props, _1.key, null, _1.__v) : _1)) {
        if (_1.__ = u6, _1.__b = u6.__b + 1, null === (p1 = w1[h1]) || p1 && _1.key == p1.key && _1.type === p1.type) w1[h1] = void 0;
        else for(v1 = 0; v1 < A1; v1++){
            if ((p1 = w1[v1]) && _1.key == p1.key && _1.type === p1.type) {
                w1[v1] = void 0;
                break;
            }
            p1 = null;
        }
        $fb96b826c0c5f37a$var$j(n12, _1, p1 = p1 || $fb96b826c0c5f37a$var$e, t4, r4, o4, f3, s1, a1), b1 = _1.__e, (v1 = _1.ref) && p1.ref != v1 && (g1 || (g1 = []), p1.ref && g1.push(p1.ref, null, _1), g1.push(v1, _1.__c || b1, _1)), null != b1 ? (null == m1 && (m1 = b1), "function" == typeof _1.type && _1.__k === p1.__k ? _1.__d = s1 = $fb96b826c0c5f37a$var$x(_1, s1, n12) : s1 = $fb96b826c0c5f37a$var$P(n12, _1, p1, w1, b1, s1), "function" == typeof u6.type && (u6.__d = s1)) : s1 && p1.__e == s1 && s1.parentNode != n12 && (s1 = $fb96b826c0c5f37a$var$k(p1));
    }
    for(u6.__e = m1, h1 = A1; h1--;)null != w1[h1] && ("function" == typeof u6.type && null != w1[h1].__e && w1[h1].__e == u6.__d && (u6.__d = $fb96b826c0c5f37a$var$k(i4, h1 + 1)), $fb96b826c0c5f37a$var$N(w1[h1], w1[h1]));
    if (g1) for(h1 = 0; h1 < g1.length; h1++)$fb96b826c0c5f37a$var$M(g1[h1], g1[++h1], g1[++h1]);
}
function $fb96b826c0c5f37a$var$x(n13, l10, u7) {
    for(var i5, t5 = n13.__k, r5 = 0; t5 && r5 < t5.length; r5++)(i5 = t5[r5]) && (i5.__ = n13, l10 = "function" == typeof i5.type ? $fb96b826c0c5f37a$var$x(i5, l10, u7) : $fb96b826c0c5f37a$var$P(u7, i5, i5, t5, i5.__e, l10));
    return l10;
}
function $fb96b826c0c5f37a$export$47e4c5b300681277(n14, l11) {
    return l11 = l11 || [], null == n14 || "boolean" == typeof n14 || (Array.isArray(n14) ? n14.some(function(n15) {
        $fb96b826c0c5f37a$export$47e4c5b300681277(n15, l11);
    }) : l11.push(n14)), l11;
}
function $fb96b826c0c5f37a$var$P(n16, l12, u8, i6, t6, r6) {
    var o5, f4, e1;
    if (void 0 !== l12.__d) o5 = l12.__d, l12.__d = void 0;
    else if (null == u8 || t6 != r6 || null == t6.parentNode) n: if (null == r6 || r6.parentNode !== n16) n16.appendChild(t6), o5 = null;
    else {
        for(f4 = r6, e1 = 0; (f4 = f4.nextSibling) && e1 < i6.length; e1 += 2)if (f4 == t6) break n;
        n16.insertBefore(t6, r6), o5 = r6;
    }
    return void 0 !== o5 ? o5 : t6.nextSibling;
}
function $fb96b826c0c5f37a$var$C(n17, l13, u9, i7, t7) {
    var r7;
    for(r7 in u9)"children" === r7 || "key" === r7 || r7 in l13 || $fb96b826c0c5f37a$var$H(n17, r7, null, u9[r7], i7);
    for(r7 in l13)t7 && "function" != typeof l13[r7] || "children" === r7 || "key" === r7 || "value" === r7 || "checked" === r7 || u9[r7] === l13[r7] || $fb96b826c0c5f37a$var$H(n17, r7, l13[r7], u9[r7], i7);
}
function $fb96b826c0c5f37a$var$$(n18, l14, u10) {
    "-" === l14[0] ? n18.setProperty(l14, u10) : n18[l14] = null == u10 ? "" : "number" != typeof u10 || $fb96b826c0c5f37a$var$s.test(l14) ? u10 : u10 + "px";
}
function $fb96b826c0c5f37a$var$H(n19, l15, u11, i8, t8) {
    var r8;
    n: if ("style" === l15) {
        if ("string" == typeof u11) n19.style.cssText = u11;
        else {
            if ("string" == typeof i8 && (n19.style.cssText = i8 = ""), i8) for(l15 in i8)u11 && l15 in u11 || $fb96b826c0c5f37a$var$$(n19.style, l15, "");
            if (u11) for(l15 in u11)i8 && u11[l15] === i8[l15] || $fb96b826c0c5f37a$var$$(n19.style, l15, u11[l15]);
        }
    } else if ("o" === l15[0] && "n" === l15[1]) r8 = l15 !== (l15 = l15.replace(/Capture$/, "")), l15 = l15.toLowerCase() in n19 ? l15.toLowerCase().slice(2) : l15.slice(2), n19.l || (n19.l = {}), n19.l[l15 + r8] = u11, u11 ? i8 || n19.addEventListener(l15, r8 ? $fb96b826c0c5f37a$var$T : $fb96b826c0c5f37a$var$I, r8) : n19.removeEventListener(l15, r8 ? $fb96b826c0c5f37a$var$T : $fb96b826c0c5f37a$var$I, r8);
    else if ("dangerouslySetInnerHTML" !== l15) {
        if (t8) l15 = l15.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
        else if ("href" !== l15 && "list" !== l15 && "form" !== l15 && "tabIndex" !== l15 && "download" !== l15 && l15 in n19) try {
            n19[l15] = null == u11 ? "" : u11;
            break n;
        } catch (n) {}
        "function" == typeof u11 || (null != u11 && (!1 !== u11 || "a" === l15[0] && "r" === l15[1]) ? n19.setAttribute(l15, u11) : n19.removeAttribute(l15));
    }
}
function $fb96b826c0c5f37a$var$I(n20) {
    this.l[n20.type + !1]($fb96b826c0c5f37a$export$41c562ebe57d11e2.event ? $fb96b826c0c5f37a$export$41c562ebe57d11e2.event(n20) : n20);
}
function $fb96b826c0c5f37a$var$T(n21) {
    this.l[n21.type + !0]($fb96b826c0c5f37a$export$41c562ebe57d11e2.event ? $fb96b826c0c5f37a$export$41c562ebe57d11e2.event(n21) : n21);
}
function $fb96b826c0c5f37a$var$j(n22, u12, i9, t9, r9, o6, f5, e2, c1) {
    var s2, h2, v2, y1, p2, k1, b2, m2, g2, x1, A2, P1 = u12.type;
    if (void 0 !== u12.constructor) return null;
    null != i9.__h && (c1 = i9.__h, e2 = u12.__e = i9.__e, u12.__h = null, o6 = [
        e2
    ]), (s2 = $fb96b826c0c5f37a$export$41c562ebe57d11e2.__b) && s2(u12);
    try {
        n: if ("function" == typeof P1) {
            if (m2 = u12.props, g2 = (s2 = P1.contextType) && t9[s2.__c], x1 = s2 ? g2 ? g2.props.value : s2.__ : t9, i9.__c ? b2 = (h2 = u12.__c = i9.__c).__ = h2.__E : ("prototype" in P1 && P1.prototype.render ? u12.__c = h2 = new P1(m2, x1) : (u12.__c = h2 = new $fb96b826c0c5f37a$export$16fa2f45be04daa8(m2, x1), h2.constructor = P1, h2.render = $fb96b826c0c5f37a$var$O), g2 && g2.sub(h2), h2.props = m2, h2.state || (h2.state = {}), h2.context = x1, h2.__n = t9, v2 = h2.__d = !0, h2.__h = []), null == h2.__s && (h2.__s = h2.state), null != P1.getDerivedStateFromProps && (h2.__s == h2.state && (h2.__s = $fb96b826c0c5f37a$var$a({}, h2.__s)), $fb96b826c0c5f37a$var$a(h2.__s, P1.getDerivedStateFromProps(m2, h2.__s))), y1 = h2.props, p2 = h2.state, v2) null == P1.getDerivedStateFromProps && null != h2.componentWillMount && h2.componentWillMount(), null != h2.componentDidMount && h2.__h.push(h2.componentDidMount);
            else {
                if (null == P1.getDerivedStateFromProps && m2 !== y1 && null != h2.componentWillReceiveProps && h2.componentWillReceiveProps(m2, x1), !h2.__e && null != h2.shouldComponentUpdate && !1 === h2.shouldComponentUpdate(m2, h2.__s, x1) || u12.__v === i9.__v) {
                    h2.props = m2, h2.state = h2.__s, u12.__v !== i9.__v && (h2.__d = !1), h2.__v = u12, u12.__e = i9.__e, u12.__k = i9.__k, u12.__k.forEach(function(n23) {
                        n23 && (n23.__ = u12);
                    }), h2.__h.length && f5.push(h2);
                    break n;
                }
                null != h2.componentWillUpdate && h2.componentWillUpdate(m2, h2.__s, x1), null != h2.componentDidUpdate && h2.__h.push(function() {
                    h2.componentDidUpdate(y1, p2, k1);
                });
            }
            h2.context = x1, h2.props = m2, h2.state = h2.__s, (s2 = $fb96b826c0c5f37a$export$41c562ebe57d11e2.__r) && s2(u12), h2.__d = !1, h2.__v = u12, h2.__P = n22, s2 = h2.render(h2.props, h2.state, h2.context), h2.state = h2.__s, null != h2.getChildContext && (t9 = $fb96b826c0c5f37a$var$a($fb96b826c0c5f37a$var$a({}, t9), h2.getChildContext())), v2 || null == h2.getSnapshotBeforeUpdate || (k1 = h2.getSnapshotBeforeUpdate(y1, p2)), A2 = null != s2 && s2.type === $fb96b826c0c5f37a$export$ffb0004e005737fa && null == s2.key ? s2.props.children : s2, $fb96b826c0c5f37a$var$w(n22, Array.isArray(A2) ? A2 : [
                A2
            ], u12, i9, t9, r9, o6, f5, e2, c1), h2.base = u12.__e, u12.__h = null, h2.__h.length && f5.push(h2), b2 && (h2.__E = h2.__ = null), h2.__e = !1;
        } else null == o6 && u12.__v === i9.__v ? (u12.__k = i9.__k, u12.__e = i9.__e) : u12.__e = $fb96b826c0c5f37a$var$L(i9.__e, u12, i9, t9, r9, o6, f5, c1);
        (s2 = $fb96b826c0c5f37a$export$41c562ebe57d11e2.diffed) && s2(u12);
    } catch (n24) {
        u12.__v = null, (c1 || null != o6) && (u12.__e = e2, u12.__h = !!c1, o6[o6.indexOf(e2)] = null), $fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n24, u12, i9);
    }
}
function $fb96b826c0c5f37a$var$z(n25, u13) {
    $fb96b826c0c5f37a$export$41c562ebe57d11e2.__c && $fb96b826c0c5f37a$export$41c562ebe57d11e2.__c(u13, n25), n25.some(function(u14) {
        try {
            n25 = u14.__h, u14.__h = [], n25.some(function(n26) {
                n26.call(u14);
            });
        } catch (n27) {
            $fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n27, u14.__v);
        }
    });
}
function $fb96b826c0c5f37a$var$L(l16, u15, i10, t10, r10, o7, f6, c2) {
    var s3, a2, v3, y2 = i10.props, p3 = u15.props, d1 = u15.type, _2 = 0;
    if ("svg" === d1 && (r10 = !0), null != o7) {
        for(; _2 < o7.length; _2++)if ((s3 = o7[_2]) && "setAttribute" in s3 == !!d1 && (d1 ? s3.localName === d1 : 3 === s3.nodeType)) {
            l16 = s3, o7[_2] = null;
            break;
        }
    }
    if (null == l16) {
        if (null === d1) return document.createTextNode(p3);
        l16 = r10 ? document.createElementNS("http://www.w3.org/2000/svg", d1) : document.createElement(d1, p3.is && p3), o7 = null, c2 = !1;
    }
    if (null === d1) y2 === p3 || c2 && l16.data === p3 || (l16.data = p3);
    else {
        if (o7 = o7 && $fb96b826c0c5f37a$var$n.call(l16.childNodes), a2 = (y2 = i10.props || $fb96b826c0c5f37a$var$e).dangerouslySetInnerHTML, v3 = p3.dangerouslySetInnerHTML, !c2) {
            if (null != o7) for(y2 = {}, _2 = 0; _2 < l16.attributes.length; _2++)y2[l16.attributes[_2].name] = l16.attributes[_2].value;
            (v3 || a2) && (v3 && (a2 && v3.__html == a2.__html || v3.__html === l16.innerHTML) || (l16.innerHTML = v3 && v3.__html || ""));
        }
        if ($fb96b826c0c5f37a$var$C(l16, p3, y2, r10, c2), v3) u15.__k = [];
        else if (_2 = u15.props.children, $fb96b826c0c5f37a$var$w(l16, Array.isArray(_2) ? _2 : [
            _2
        ], u15, i10, t10, r10 && "foreignObject" !== d1, o7, f6, o7 ? o7[0] : i10.__k && $fb96b826c0c5f37a$var$k(i10, 0), c2), null != o7) for(_2 = o7.length; _2--;)null != o7[_2] && $fb96b826c0c5f37a$var$h(o7[_2]);
        c2 || ("value" in p3 && void 0 !== (_2 = p3.value) && (_2 !== y2.value || _2 !== l16.value || "progress" === d1 && !_2) && $fb96b826c0c5f37a$var$H(l16, "value", _2, y2.value, !1), "checked" in p3 && void 0 !== (_2 = p3.checked) && _2 !== l16.checked && $fb96b826c0c5f37a$var$H(l16, "checked", _2, y2.checked, !1));
    }
    return l16;
}
function $fb96b826c0c5f37a$var$M(n28, u16, i11) {
    try {
        "function" == typeof n28 ? n28(u16) : n28.current = u16;
    } catch (n29) {
        $fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n29, i11);
    }
}
function $fb96b826c0c5f37a$var$N(n30, u17, i12) {
    var t11, r11;
    if ($fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount && $fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount(n30), (t11 = n30.ref) && (t11.current && t11.current !== n30.__e || $fb96b826c0c5f37a$var$M(t11, null, u17)), null != (t11 = n30.__c)) {
        if (t11.componentWillUnmount) try {
            t11.componentWillUnmount();
        } catch (n31) {
            $fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n31, u17);
        }
        t11.base = t11.__P = null;
    }
    if (t11 = n30.__k) for(r11 = 0; r11 < t11.length; r11++)t11[r11] && $fb96b826c0c5f37a$var$N(t11[r11], u17, "function" != typeof n30.type);
    i12 || null == n30.__e || $fb96b826c0c5f37a$var$h(n30.__e), n30.__e = n30.__d = void 0;
}
function $fb96b826c0c5f37a$var$O(n32, l, u18) {
    return this.constructor(n32, u18);
}
function $fb96b826c0c5f37a$export$b3890eb0ae9dca99(u19, i13, t12) {
    var r12, o8, f7;
    $fb96b826c0c5f37a$export$41c562ebe57d11e2.__ && $fb96b826c0c5f37a$export$41c562ebe57d11e2.__(u19, i13), o8 = (r12 = "function" == typeof t12) ? null : t12 && t12.__k || i13.__k, f7 = [], $fb96b826c0c5f37a$var$j(i13, u19 = (!r12 && t12 || i13).__k = $fb96b826c0c5f37a$export$c8a8987d4410bf2d($fb96b826c0c5f37a$export$ffb0004e005737fa, null, [
        u19
    ]), o8 || $fb96b826c0c5f37a$var$e, $fb96b826c0c5f37a$var$e, void 0 !== i13.ownerSVGElement, !r12 && t12 ? [
        t12
    ] : o8 ? null : i13.firstChild ? $fb96b826c0c5f37a$var$n.call(i13.childNodes) : null, f7, !r12 && t12 ? t12 : o8 ? o8.__e : i13.firstChild, r12), $fb96b826c0c5f37a$var$z(f7, u19);
}
$fb96b826c0c5f37a$var$n = $fb96b826c0c5f37a$var$c.slice, $fb96b826c0c5f37a$export$41c562ebe57d11e2 = {
    __e: function(n39, l22) {
        for(var u23, i16, t14; l22 = l22.__;)if ((u23 = l22.__c) && !u23.__) try {
            if ((i16 = u23.constructor) && null != i16.getDerivedStateFromError && (u23.setState(i16.getDerivedStateFromError(n39)), t14 = u23.__d), null != u23.componentDidCatch && (u23.componentDidCatch(n39), t14 = u23.__d), t14) return u23.__E = u23;
        } catch (l23) {
            n39 = l23;
        }
        throw n39;
    }
}, $fb96b826c0c5f37a$var$u = 0, $fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype.setState = function(n41, l24) {
    var u24;
    u24 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $fb96b826c0c5f37a$var$a({}, this.state), "function" == typeof n41 && (n41 = n41($fb96b826c0c5f37a$var$a({}, u24), this.props)), n41 && $fb96b826c0c5f37a$var$a(u24, n41), null != n41 && this.__v && (l24 && this.__h.push(l24), $fb96b826c0c5f37a$var$m(this));
}, $fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype.forceUpdate = function(n42) {
    this.__v && (this.__e = !0, n42 && this.__h.push(n42), $fb96b826c0c5f37a$var$m(this));
}, $fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype.render = $fb96b826c0c5f37a$export$ffb0004e005737fa, $fb96b826c0c5f37a$var$t = [], $fb96b826c0c5f37a$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $fb96b826c0c5f37a$var$g.__r = 0;



var $bd9dd35321b03dd4$var$o = 0;
function $bd9dd35321b03dd4$export$34b9dba7ce09269b(_1, e1, n, t, f) {
    var l, s, u = {};
    for(s in e1)"ref" == s ? l = e1[s] : u[s] = e1[s];
    var a = {
        type: _1,
        props: u,
        key: n,
        ref: l,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: --$bd9dd35321b03dd4$var$o,
        __source: t,
        __self: f
    };
    if ("function" == typeof _1 && (l = _1.defaultProps)) for(s in l)void 0 === u[s] && (u[s] = l[s]);
    return ($fb96b826c0c5f37a$export$41c562ebe57d11e2).vnode && ($fb96b826c0c5f37a$export$41c562ebe57d11e2).vnode(a), a;
}



function $f72b75cf796873c7$var$set(key, value) {
    try {
        window.localStorage[`emoji-mart.${key}`] = JSON.stringify(value);
    } catch (error) {}
}
function $f72b75cf796873c7$var$get(key) {
    try {
        const value = window.localStorage[`emoji-mart.${key}`];
        if (value) return JSON.parse(value);
    } catch (error) {}
}
var $f72b75cf796873c7$export$2e2bcd8739ae039 = {
    set: $f72b75cf796873c7$var$set,
    get: $f72b75cf796873c7$var$get
};


const $c84d045dcc34faf5$var$CACHE = new Map();
const $c84d045dcc34faf5$var$VERSIONS = [
    {
        v: 15,
        emoji: "\uD83E\uDEE8"
    },
    {
        v: 14,
        emoji: "\uD83E\uDEE0"
    },
    {
        v: 13.1,
        emoji: "\uD83D\uDE36\u200D\uD83C\uDF2B\uFE0F"
    },
    {
        v: 13,
        emoji: "\uD83E\uDD78"
    },
    {
        v: 12.1,
        emoji: "\uD83E\uDDD1\u200D\uD83E\uDDB0"
    },
    {
        v: 12,
        emoji: "\uD83E\uDD71"
    },
    {
        v: 11,
        emoji: "\uD83E\uDD70"
    },
    {
        v: 5,
        emoji: "\uD83E\uDD29"
    },
    {
        v: 4,
        emoji: "\uD83D\uDC71\u200D\u2640\uFE0F"
    },
    {
        v: 3,
        emoji: "\uD83E\uDD23"
    },
    {
        v: 2,
        emoji: "\uD83D\uDC4B\uD83C\uDFFB"
    },
    {
        v: 1,
        emoji: "\uD83D\uDE43"
    }, 
];
function $c84d045dcc34faf5$var$latestVersion() {
    for (const { v: v , emoji: emoji  } of $c84d045dcc34faf5$var$VERSIONS){
        if ($c84d045dcc34faf5$var$isSupported(emoji)) return v;
    }
}
function $c84d045dcc34faf5$var$noCountryFlags() {
    if ($c84d045dcc34faf5$var$isSupported("\uD83C\uDDE8\uD83C\uDDE6")) return false;
    return true;
}
function $c84d045dcc34faf5$var$isSupported(emoji) {
    if ($c84d045dcc34faf5$var$CACHE.has(emoji)) return $c84d045dcc34faf5$var$CACHE.get(emoji);
    const supported = $c84d045dcc34faf5$var$isEmojiSupported(emoji);
    $c84d045dcc34faf5$var$CACHE.set(emoji, supported);
    return supported;
}
// https://github.com/koala-interactive/is-emoji-supported
const $c84d045dcc34faf5$var$isEmojiSupported = (()=>{
    let ctx = null;
    try {
        if (!navigator.userAgent.includes("jsdom")) ctx = document.createElement("canvas").getContext("2d", {
            willReadFrequently: true
        });
    } catch  {}
    // Not in browser env
    if (!ctx) return ()=>false;
    const CANVAS_HEIGHT = 25;
    const CANVAS_WIDTH = 20;
    const textSize = Math.floor(CANVAS_HEIGHT / 2);
    // Initialize convas context
    ctx.font = textSize + "px Arial, Sans-Serif";
    ctx.textBaseline = "top";
    ctx.canvas.width = CANVAS_WIDTH * 2;
    ctx.canvas.height = CANVAS_HEIGHT;
    return (unicode)=>{
        ctx.clearRect(0, 0, CANVAS_WIDTH * 2, CANVAS_HEIGHT);
        // Draw in red on the left
        ctx.fillStyle = "#FF0000";
        ctx.fillText(unicode, 0, 22);
        // Draw in blue on right
        ctx.fillStyle = "#0000FF";
        ctx.fillText(unicode, CANVAS_WIDTH, 22);
        const a = ctx.getImageData(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT).data;
        const count = a.length;
        let i = 0;
        // Search the first visible pixel
        for(; i < count && !a[i + 3]; i += 4);
        // No visible pixel
        if (i >= count) return false;
        // Emoji has immutable color, so we check the color of the emoji in two different colors
        // the result show be the same.
        const x = CANVAS_WIDTH + i / 4 % CANVAS_WIDTH;
        const y = Math.floor(i / 4 / CANVAS_WIDTH);
        const b = ctx.getImageData(x, y, 1, 1).data;
        if (a[i] !== b[0] || a[i + 2] !== b[2]) return false;
        // Some emojis are a contraction of different ones, so if it's not
        // supported, it will show multiple characters
        if (ctx.measureText(unicode).width >= CANVAS_WIDTH) return false;
        // Supported
        return true;
    };
})();
var $c84d045dcc34faf5$export$2e2bcd8739ae039 = {
    latestVersion: $c84d045dcc34faf5$var$latestVersion,
    noCountryFlags: $c84d045dcc34faf5$var$noCountryFlags
};



const $b22cfd0a55410b4f$var$DEFAULTS = [
    "+1",
    "grinning",
    "kissing_heart",
    "heart_eyes",
    "laughing",
    "stuck_out_tongue_winking_eye",
    "sweat_smile",
    "joy",
    "scream",
    "disappointed",
    "unamused",
    "weary",
    "sob",
    "sunglasses",
    "heart", 
];
let $b22cfd0a55410b4f$var$Index = null;
function $b22cfd0a55410b4f$var$add(emoji) {
    $b22cfd0a55410b4f$var$Index || ($b22cfd0a55410b4f$var$Index = ($f72b75cf796873c7$export$2e2bcd8739ae039).get("frequently") || {});
    const emojiId = emoji.id || emoji;
    if (!emojiId) return;
    $b22cfd0a55410b4f$var$Index[emojiId] || ($b22cfd0a55410b4f$var$Index[emojiId] = 0);
    $b22cfd0a55410b4f$var$Index[emojiId] += 1;
    ($f72b75cf796873c7$export$2e2bcd8739ae039).set("last", emojiId);
    ($f72b75cf796873c7$export$2e2bcd8739ae039).set("frequently", $b22cfd0a55410b4f$var$Index);
}
function $b22cfd0a55410b4f$var$get({ maxFrequentRows: maxFrequentRows , perLine: perLine  }) {
    if (!maxFrequentRows) return [];
    $b22cfd0a55410b4f$var$Index || ($b22cfd0a55410b4f$var$Index = ($f72b75cf796873c7$export$2e2bcd8739ae039).get("frequently"));
    let emojiIds = [];
    if (!$b22cfd0a55410b4f$var$Index) {
        $b22cfd0a55410b4f$var$Index = {};
        for(let i in $b22cfd0a55410b4f$var$DEFAULTS.slice(0, perLine)){
            const emojiId = $b22cfd0a55410b4f$var$DEFAULTS[i];
            $b22cfd0a55410b4f$var$Index[emojiId] = perLine - i;
            emojiIds.push(emojiId);
        }
        return emojiIds;
    }
    const max = maxFrequentRows * perLine;
    const last = ($f72b75cf796873c7$export$2e2bcd8739ae039).get("last");
    for(let emojiId in $b22cfd0a55410b4f$var$Index)emojiIds.push(emojiId);
    emojiIds.sort((a, b)=>{
        const aScore = $b22cfd0a55410b4f$var$Index[b];
        const bScore = $b22cfd0a55410b4f$var$Index[a];
        if (aScore == bScore) return a.localeCompare(b);
        return aScore - bScore;
    });
    if (emojiIds.length > max) {
        const removedIds = emojiIds.slice(max);
        emojiIds = emojiIds.slice(0, max);
        for (let removedId of removedIds){
            if (removedId == last) continue;
            delete $b22cfd0a55410b4f$var$Index[removedId];
        }
        if (last && emojiIds.indexOf(last) == -1) {
            delete $b22cfd0a55410b4f$var$Index[emojiIds[emojiIds.length - 1]];
            emojiIds.splice(-1, 1, last);
        }
        ($f72b75cf796873c7$export$2e2bcd8739ae039).set("frequently", $b22cfd0a55410b4f$var$Index);
    }
    return emojiIds;
}
var $b22cfd0a55410b4f$export$2e2bcd8739ae039 = {
    add: $b22cfd0a55410b4f$var$add,
    get: $b22cfd0a55410b4f$var$get,
    DEFAULTS: $b22cfd0a55410b4f$var$DEFAULTS
};


var $8d50d93417ef682a$exports = {};
$8d50d93417ef682a$exports = JSON.parse('{"search":"Search","search_no_results_1":"Oh no!","search_no_results_2":"That emoji couldn\u2019t be found","pick":"Pick an emoji\u2026","add_custom":"Add custom emoji","categories":{"activity":"Activity","custom":"Custom","flags":"Flags","foods":"Food & Drink","frequent":"Frequently used","nature":"Animals & Nature","objects":"Objects","people":"Smileys & People","places":"Travel & Places","search":"Search Results","symbols":"Symbols"},"skins":{"1":"Default","2":"Light","3":"Medium-Light","4":"Medium","5":"Medium-Dark","6":"Dark","choose":"Choose default skin tone"}}');


var $b247ea80b67298d5$export$2e2bcd8739ae039 = {
    autoFocus: {
        value: false
    },
    dynamicWidth: {
        value: false
    },
    emojiButtonColors: {
        value: null
    },
    emojiButtonRadius: {
        value: "100%"
    },
    emojiButtonSize: {
        value: 36
    },
    emojiSize: {
        value: 24
    },
    emojiVersion: {
        value: 15,
        choices: [
            1,
            2,
            3,
            4,
            5,
            11,
            12,
            12.1,
            13,
            13.1,
            14,
            15
        ]
    },
    exceptEmojis: {
        value: []
    },
    icons: {
        value: "auto",
        choices: [
            "auto",
            "outline",
            "solid"
        ]
    },
    locale: {
        value: "en",
        choices: [
            "en",
            "ar",
            "be",
            "cs",
            "de",
            "es",
            "fa",
            "fi",
            "fr",
            "hi",
            "it",
            "ja",
            "ko",
            "nl",
            "pl",
            "pt",
            "ru",
            "sa",
            "tr",
            "uk",
            "vi",
            "zh", 
        ]
    },
    maxFrequentRows: {
        value: 4
    },
    navPosition: {
        value: "top",
        choices: [
            "top",
            "bottom",
            "none"
        ]
    },
    noCountryFlags: {
        value: false
    },
    noResultsEmoji: {
        value: null
    },
    perLine: {
        value: 9
    },
    previewEmoji: {
        value: null
    },
    previewPosition: {
        value: "bottom",
        choices: [
            "top",
            "bottom",
            "none"
        ]
    },
    searchPosition: {
        value: "sticky",
        choices: [
            "sticky",
            "static",
            "none"
        ]
    },
    set: {
        value: "native",
        choices: [
            "native",
            "apple",
            "facebook",
            "google",
            "twitter"
        ]
    },
    skin: {
        value: 1,
        choices: [
            1,
            2,
            3,
            4,
            5,
            6
        ]
    },
    skinTonePosition: {
        value: "preview",
        choices: [
            "preview",
            "search",
            "none"
        ]
    },
    theme: {
        value: "auto",
        choices: [
            "auto",
            "light",
            "dark"
        ]
    },
    // Data
    categories: null,
    categoryIcons: null,
    custom: null,
    data: null,
    i18n: null,
    // Callbacks
    getImageURL: null,
    getSpritesheetURL: null,
    onAddCustomEmoji: null,
    onClickOutside: null,
    onEmojiSelect: null,
    // Deprecated
    stickySearch: {
        deprecated: true,
        value: true
    }
};



let $7adb23b0109cc36a$export$dbe3113d60765c1a = null;
let $7adb23b0109cc36a$export$2d0294657ab35f1b = null;
const $7adb23b0109cc36a$var$fetchCache = {};
async function $7adb23b0109cc36a$var$fetchJSON(src) {
    if ($7adb23b0109cc36a$var$fetchCache[src]) return $7adb23b0109cc36a$var$fetchCache[src];
    const response = await fetch(src);
    const json = await response.json();
    $7adb23b0109cc36a$var$fetchCache[src] = json;
    return json;
}
let $7adb23b0109cc36a$var$promise = null;
let $7adb23b0109cc36a$var$initCallback = null;
let $7adb23b0109cc36a$var$initialized = false;
function $7adb23b0109cc36a$export$2cd8252107eb640b(options, { caller: caller  } = {}) {
    $7adb23b0109cc36a$var$promise || ($7adb23b0109cc36a$var$promise = new Promise((resolve)=>{
        $7adb23b0109cc36a$var$initCallback = resolve;
    }));
    if (options) $7adb23b0109cc36a$var$_init(options);
    else if (caller && !$7adb23b0109cc36a$var$initialized) console.warn(`\`${caller}\` requires data to be initialized first. Promise will be pending until \`init\` is called.`);
    return $7adb23b0109cc36a$var$promise;
}
async function $7adb23b0109cc36a$var$_init(props) {
    $7adb23b0109cc36a$var$initialized = true;
    let { emojiVersion: emojiVersion , set: set , locale: locale  } = props;
    emojiVersion || (emojiVersion = ($b247ea80b67298d5$export$2e2bcd8739ae039).emojiVersion.value);
    set || (set = ($b247ea80b67298d5$export$2e2bcd8739ae039).set.value);
    locale || (locale = ($b247ea80b67298d5$export$2e2bcd8739ae039).locale.value);
    if (!$7adb23b0109cc36a$export$2d0294657ab35f1b) {
        $7adb23b0109cc36a$export$2d0294657ab35f1b = (typeof props.data === "function" ? await props.data() : props.data) || await $7adb23b0109cc36a$var$fetchJSON(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/sets/${emojiVersion}/${set}.json`);
        $7adb23b0109cc36a$export$2d0294657ab35f1b.emoticons = {};
        $7adb23b0109cc36a$export$2d0294657ab35f1b.natives = {};
        $7adb23b0109cc36a$export$2d0294657ab35f1b.categories.unshift({
            id: "frequent",
            emojis: []
        });
        for(const alias in $7adb23b0109cc36a$export$2d0294657ab35f1b.aliases){
            const emojiId = $7adb23b0109cc36a$export$2d0294657ab35f1b.aliases[alias];
            const emoji = $7adb23b0109cc36a$export$2d0294657ab35f1b.emojis[emojiId];
            if (!emoji) continue;
            emoji.aliases || (emoji.aliases = []);
            emoji.aliases.push(alias);
        }
        $7adb23b0109cc36a$export$2d0294657ab35f1b.originalCategories = $7adb23b0109cc36a$export$2d0294657ab35f1b.categories;
    } else $7adb23b0109cc36a$export$2d0294657ab35f1b.categories = $7adb23b0109cc36a$export$2d0294657ab35f1b.categories.filter((c)=>{
        const isCustom = !!c.name;
        if (!isCustom) return true;
        return false;
    });
    $7adb23b0109cc36a$export$dbe3113d60765c1a = (typeof props.i18n === "function" ? await props.i18n() : props.i18n) || (locale == "en" ? ((/*@__PURE__*/$parcel$interopDefault($8d50d93417ef682a$exports))) : await $7adb23b0109cc36a$var$fetchJSON(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/i18n/${locale}.json`));
    if (props.custom) for(let i in props.custom){
        i = parseInt(i);
        const category = props.custom[i];
        const prevCategory = props.custom[i - 1];
        if (!category.emojis || !category.emojis.length) continue;
        category.id || (category.id = `custom_${i + 1}`);
        category.name || (category.name = $7adb23b0109cc36a$export$dbe3113d60765c1a.categories.custom);
        if (prevCategory && !category.icon) category.target = prevCategory.target || prevCategory;
        $7adb23b0109cc36a$export$2d0294657ab35f1b.categories.push(category);
        for (const emoji of category.emojis)$7adb23b0109cc36a$export$2d0294657ab35f1b.emojis[emoji.id] = emoji;
    }
    if (props.categories) $7adb23b0109cc36a$export$2d0294657ab35f1b.categories = $7adb23b0109cc36a$export$2d0294657ab35f1b.originalCategories.filter((c)=>{
        return props.categories.indexOf(c.id) != -1;
    }).sort((c1, c2)=>{
        const i1 = props.categories.indexOf(c1.id);
        const i2 = props.categories.indexOf(c2.id);
        return i1 - i2;
    });
    let latestVersionSupport = null;
    let noCountryFlags = null;
    if (set == "native") {
        latestVersionSupport = ($c84d045dcc34faf5$export$2e2bcd8739ae039).latestVersion();
        noCountryFlags = props.noCountryFlags || ($c84d045dcc34faf5$export$2e2bcd8739ae039).noCountryFlags();
    }
    let categoryIndex = $7adb23b0109cc36a$export$2d0294657ab35f1b.categories.length;
    let resetSearchIndex = false;
    while(categoryIndex--){
        const category = $7adb23b0109cc36a$export$2d0294657ab35f1b.categories[categoryIndex];
        if (category.id == "frequent") {
            let { maxFrequentRows: maxFrequentRows , perLine: perLine  } = props;
            maxFrequentRows = maxFrequentRows >= 0 ? maxFrequentRows : ($b247ea80b67298d5$export$2e2bcd8739ae039).maxFrequentRows.value;
            perLine || (perLine = ($b247ea80b67298d5$export$2e2bcd8739ae039).perLine.value);
            category.emojis = ($b22cfd0a55410b4f$export$2e2bcd8739ae039).get({
                maxFrequentRows: maxFrequentRows,
                perLine: perLine
            });
        }
        if (!category.emojis || !category.emojis.length) {
            $7adb23b0109cc36a$export$2d0294657ab35f1b.categories.splice(categoryIndex, 1);
            continue;
        }
        const { categoryIcons: categoryIcons  } = props;
        if (categoryIcons) {
            const icon = categoryIcons[category.id];
            if (icon && !category.icon) category.icon = icon;
        }
        let emojiIndex = category.emojis.length;
        while(emojiIndex--){
            const emojiId = category.emojis[emojiIndex];
            const emoji = emojiId.id ? emojiId : $7adb23b0109cc36a$export$2d0294657ab35f1b.emojis[emojiId];
            const ignore = ()=>{
                category.emojis.splice(emojiIndex, 1);
            };
            if (!emoji || props.exceptEmojis && props.exceptEmojis.includes(emoji.id)) {
                ignore();
                continue;
            }
            if (latestVersionSupport && emoji.version > latestVersionSupport) {
                ignore();
                continue;
            }
            if (noCountryFlags && category.id == "flags") {
                if (!($e6eae5155b87f591$export$bcb25aa587e9cb13).includes(emoji.id)) {
                    ignore();
                    continue;
                }
            }
            if (!emoji.search) {
                resetSearchIndex = true;
                emoji.search = "," + [
                    [
                        emoji.id,
                        false
                    ],
                    [
                        emoji.name,
                        true
                    ],
                    [
                        emoji.keywords,
                        false
                    ],
                    [
                        emoji.emoticons,
                        false
                    ], 
                ].map(([strings, split])=>{
                    if (!strings) return;
                    return (Array.isArray(strings) ? strings : [
                        strings
                    ]).map((string)=>{
                        return (split ? string.split(/[-|_|\s]+/) : [
                            string
                        ]).map((s)=>s.toLowerCase());
                    }).flat();
                }).flat().filter((a)=>a && a.trim()).join(",");
                if (emoji.emoticons) for (const emoticon of emoji.emoticons){
                    if ($7adb23b0109cc36a$export$2d0294657ab35f1b.emoticons[emoticon]) continue;
                    $7adb23b0109cc36a$export$2d0294657ab35f1b.emoticons[emoticon] = emoji.id;
                }
                let skinIndex = 0;
                for (const skin of emoji.skins){
                    if (!skin) continue;
                    skinIndex++;
                    const { native: native  } = skin;
                    if (native) {
                        $7adb23b0109cc36a$export$2d0294657ab35f1b.natives[native] = emoji.id;
                        emoji.search += `,${native}`;
                    }
                    const skinShortcodes = skinIndex == 1 ? "" : `:skin-tone-${skinIndex}:`;
                    skin.shortcodes = `:${emoji.id}:${skinShortcodes}`;
                }
            }
        }
    }
    if (resetSearchIndex) ($c4d155af13ad4d4b$export$2e2bcd8739ae039).reset();
    $7adb23b0109cc36a$var$initCallback();
}
function $7adb23b0109cc36a$export$75fe5f91d452f94b(props, defaultProps, element) {
    props || (props = {});
    const _props = {};
    for(let k in defaultProps)_props[k] = $7adb23b0109cc36a$export$88c9ddb45cea7241(k, props, defaultProps, element);
    return _props;
}
function $7adb23b0109cc36a$export$88c9ddb45cea7241(propName, props, defaultProps, element) {
    const defaults = defaultProps[propName];
    let value = element && element.getAttribute(propName) || (props[propName] != null && props[propName] != undefined ? props[propName] : null);
    if (!defaults) return value;
    if (value != null && defaults.value && typeof defaults.value != typeof value) {
        if (typeof defaults.value == "boolean") value = value == "false" ? false : true;
        else value = defaults.value.constructor(value);
    }
    if (defaults.transform && value) value = defaults.transform(value);
    if (value == null || defaults.choices && defaults.choices.indexOf(value) == -1) value = defaults.value;
    return value;
}


const $c4d155af13ad4d4b$var$SHORTCODES_REGEX = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
let $c4d155af13ad4d4b$var$Pool = null;
function $c4d155af13ad4d4b$var$get(emojiId) {
    if (emojiId.id) return emojiId;
    return ($7adb23b0109cc36a$export$2d0294657ab35f1b).emojis[emojiId] || ($7adb23b0109cc36a$export$2d0294657ab35f1b).emojis[($7adb23b0109cc36a$export$2d0294657ab35f1b).aliases[emojiId]] || ($7adb23b0109cc36a$export$2d0294657ab35f1b).emojis[($7adb23b0109cc36a$export$2d0294657ab35f1b).natives[emojiId]];
}
function $c4d155af13ad4d4b$var$reset() {
    $c4d155af13ad4d4b$var$Pool = null;
}
async function $c4d155af13ad4d4b$var$search(value, { maxResults: maxResults , caller: caller  } = {}) {
    if (!value || !value.trim().length) return null;
    maxResults || (maxResults = 90);
    await ($7adb23b0109cc36a$export$2cd8252107eb640b)(null, {
        caller: caller || "SearchIndex.search"
    });
    const values = value.toLowerCase().replace(/(\w)-/, "$1 ").split(/[\s|,]+/).filter((word, i, words)=>{
        return word.trim() && words.indexOf(word) == i;
    });
    if (!values.length) return;
    let pool = $c4d155af13ad4d4b$var$Pool || ($c4d155af13ad4d4b$var$Pool = Object.values(($7adb23b0109cc36a$export$2d0294657ab35f1b).emojis));
    let results, scores;
    for (const value1 of values){
        if (!pool.length) break;
        results = [];
        scores = {};
        for (const emoji of pool){
            if (!emoji.search) continue;
            const score = emoji.search.indexOf(`,${value1}`);
            if (score == -1) continue;
            results.push(emoji);
            scores[emoji.id] || (scores[emoji.id] = 0);
            scores[emoji.id] += emoji.id == value1 ? 0 : score + 1;
        }
        pool = results;
    }
    if (results.length < 2) return results;
    results.sort((a, b)=>{
        const aScore = scores[a.id];
        const bScore = scores[b.id];
        if (aScore == bScore) return a.id.localeCompare(b.id);
        return aScore - bScore;
    });
    if (results.length > maxResults) results = results.slice(0, maxResults);
    return results;
}
var $c4d155af13ad4d4b$export$2e2bcd8739ae039 = {
    search: $c4d155af13ad4d4b$var$search,
    get: $c4d155af13ad4d4b$var$get,
    reset: $c4d155af13ad4d4b$var$reset,
    SHORTCODES_REGEX: $c4d155af13ad4d4b$var$SHORTCODES_REGEX
};


const $e6eae5155b87f591$export$bcb25aa587e9cb13 = [
    "checkered_flag",
    "crossed_flags",
    "pirate_flag",
    "rainbow-flag",
    "transgender_flag",
    "triangular_flag_on_post",
    "waving_black_flag",
    "waving_white_flag", 
];


function $693b183b0a78708f$export$9cb4719e2e525b7a(a, b) {
    return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index)=>val == b[index]);
}
async function $693b183b0a78708f$export$e772c8ff12451969(frames = 1) {
    for(let _ in [
        ...Array(frames).keys()
    ])await new Promise(requestAnimationFrame);
}
function $693b183b0a78708f$export$d10ac59fbe52a745(emoji, { skinIndex: skinIndex = 0  } = {}) {
    const skin = emoji.skins[skinIndex] || (()=>{
        skinIndex = 0;
        return emoji.skins[skinIndex];
    })();
    const emojiData = {
        id: emoji.id,
        name: emoji.name,
        native: skin.native,
        unified: skin.unified,
        keywords: emoji.keywords,
        shortcodes: skin.shortcodes || emoji.shortcodes
    };
    if (emoji.skins.length > 1) emojiData.skin = skinIndex + 1;
    if (skin.src) emojiData.src = skin.src;
    if (emoji.aliases && emoji.aliases.length) emojiData.aliases = emoji.aliases;
    if (emoji.emoticons && emoji.emoticons.length) emojiData.emoticons = emoji.emoticons;
    return emojiData;
}





const $fcccfb36ed0cde68$var$categories = {
    activity: {
        outline: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
            })
        }),
        solid: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                d: "M16.17 337.5c0 44.98 7.565 83.54 13.98 107.9C35.22 464.3 50.46 496 174.9 496c9.566 0 19.59-.4707 29.84-1.271L17.33 307.3C16.53 317.6 16.17 327.7 16.17 337.5zM495.8 174.5c0-44.98-7.565-83.53-13.98-107.9c-4.688-17.54-18.34-31.23-36.04-35.95C435.5 27.91 392.9 16 337 16c-9.564 0-19.59 .4707-29.84 1.271l187.5 187.5C495.5 194.4 495.8 184.3 495.8 174.5zM26.77 248.8l236.3 236.3c142-36.1 203.9-150.4 222.2-221.1L248.9 26.87C106.9 62.96 45.07 177.2 26.77 248.8zM256 335.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L164.7 283.3C161.6 280.2 160 276.1 160 271.1c0-8.529 6.865-16 16-16c4.095 0 8.189 1.562 11.31 4.688l64.01 64C254.4 327.8 256 331.9 256 335.1zM304 287.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L212.7 235.3C209.6 232.2 208 228.1 208 223.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01C302.5 279.8 304 283.9 304 287.1zM256 175.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01c3.125 3.125 4.688 7.219 4.688 11.31c0 9.133-7.468 16-16 16c-4.094 0-8.189-1.562-11.31-4.688l-64.01-64.01C257.6 184.2 256 180.1 256 175.1z"
            })
        })
    },
    custom: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512",
        children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
            d: "M417.1 368c-5.937 10.27-16.69 16-27.75 16c-5.422 0-10.92-1.375-15.97-4.281L256 311.4V448c0 17.67-14.33 32-31.1 32S192 465.7 192 448V311.4l-118.3 68.29C68.67 382.6 63.17 384 57.75 384c-11.06 0-21.81-5.734-27.75-16c-8.828-15.31-3.594-34.88 11.72-43.72L159.1 256L41.72 187.7C26.41 178.9 21.17 159.3 29.1 144C36.63 132.5 49.26 126.7 61.65 128.2C65.78 128.7 69.88 130.1 73.72 132.3L192 200.6V64c0-17.67 14.33-32 32-32S256 46.33 256 64v136.6l118.3-68.29c3.838-2.213 7.939-3.539 12.07-4.051C398.7 126.7 411.4 132.5 417.1 144c8.828 15.31 3.594 34.88-11.72 43.72L288 256l118.3 68.28C421.6 333.1 426.8 352.7 417.1 368z"
        })
    }),
    flags: {
        outline: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
            })
        }),
        solid: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                d: "M64 496C64 504.8 56.75 512 48 512h-32C7.25 512 0 504.8 0 496V32c0-17.75 14.25-32 32-32s32 14.25 32 32V496zM476.3 0c-6.365 0-13.01 1.35-19.34 4.233c-45.69 20.86-79.56 27.94-107.8 27.94c-59.96 0-94.81-31.86-163.9-31.87C160.9 .3055 131.6 4.867 96 15.75v350.5c32-9.984 59.87-14.1 84.85-14.1c73.63 0 124.9 31.78 198.6 31.78c31.91 0 68.02-5.971 111.1-23.09C504.1 355.9 512 344.4 512 332.1V30.73C512 11.1 495.3 0 476.3 0z"
            })
        })
    },
    foods: {
        outline: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
            })
        }),
        solid: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                d: "M481.9 270.1C490.9 279.1 496 291.3 496 304C496 316.7 490.9 328.9 481.9 337.9C472.9 346.9 460.7 352 448 352H64C51.27 352 39.06 346.9 30.06 337.9C21.06 328.9 16 316.7 16 304C16 291.3 21.06 279.1 30.06 270.1C39.06 261.1 51.27 256 64 256H448C460.7 256 472.9 261.1 481.9 270.1zM475.3 388.7C478.3 391.7 480 395.8 480 400V416C480 432.1 473.3 449.3 461.3 461.3C449.3 473.3 432.1 480 416 480H96C79.03 480 62.75 473.3 50.75 461.3C38.74 449.3 32 432.1 32 416V400C32 395.8 33.69 391.7 36.69 388.7C39.69 385.7 43.76 384 48 384H464C468.2 384 472.3 385.7 475.3 388.7zM50.39 220.8C45.93 218.6 42.03 215.5 38.97 211.6C35.91 207.7 33.79 203.2 32.75 198.4C31.71 193.5 31.8 188.5 32.99 183.7C54.98 97.02 146.5 32 256 32C365.5 32 457 97.02 479 183.7C480.2 188.5 480.3 193.5 479.2 198.4C478.2 203.2 476.1 207.7 473 211.6C469.1 215.5 466.1 218.6 461.6 220.8C457.2 222.9 452.3 224 447.3 224H64.67C59.73 224 54.84 222.9 50.39 220.8zM372.7 116.7C369.7 119.7 368 123.8 368 128C368 131.2 368.9 134.3 370.7 136.9C372.5 139.5 374.1 141.6 377.9 142.8C380.8 143.1 384 144.3 387.1 143.7C390.2 143.1 393.1 141.6 395.3 139.3C397.6 137.1 399.1 134.2 399.7 131.1C400.3 128 399.1 124.8 398.8 121.9C397.6 118.1 395.5 116.5 392.9 114.7C390.3 112.9 387.2 111.1 384 111.1C379.8 111.1 375.7 113.7 372.7 116.7V116.7zM244.7 84.69C241.7 87.69 240 91.76 240 96C240 99.16 240.9 102.3 242.7 104.9C244.5 107.5 246.1 109.6 249.9 110.8C252.8 111.1 256 112.3 259.1 111.7C262.2 111.1 265.1 109.6 267.3 107.3C269.6 105.1 271.1 102.2 271.7 99.12C272.3 96.02 271.1 92.8 270.8 89.88C269.6 86.95 267.5 84.45 264.9 82.7C262.3 80.94 259.2 79.1 256 79.1C251.8 79.1 247.7 81.69 244.7 84.69V84.69zM116.7 116.7C113.7 119.7 112 123.8 112 128C112 131.2 112.9 134.3 114.7 136.9C116.5 139.5 118.1 141.6 121.9 142.8C124.8 143.1 128 144.3 131.1 143.7C134.2 143.1 137.1 141.6 139.3 139.3C141.6 137.1 143.1 134.2 143.7 131.1C144.3 128 143.1 124.8 142.8 121.9C141.6 118.1 139.5 116.5 136.9 114.7C134.3 112.9 131.2 111.1 128 111.1C123.8 111.1 119.7 113.7 116.7 116.7L116.7 116.7z"
            })
        })
    },
    frequent: {
        outline: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: [
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                    d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
                }),
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
                })
            ]
        }),
        solid: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                d: "M256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512zM232 256C232 264 236 271.5 242.7 275.1L338.7 339.1C349.7 347.3 364.6 344.3 371.1 333.3C379.3 322.3 376.3 307.4 365.3 300L280 243.2V120C280 106.7 269.3 96 255.1 96C242.7 96 231.1 106.7 231.1 120L232 256z"
            })
        })
    },
    nature: {
        outline: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: [
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                    d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
                }),
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                    d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
                })
            ]
        }),
        solid: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 576 512",
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                d: "M332.7 19.85C334.6 8.395 344.5 0 356.1 0C363.6 0 370.6 3.52 375.1 9.502L392 32H444.1C456.8 32 469.1 37.06 478.1 46.06L496 64H552C565.3 64 576 74.75 576 88V112C576 156.2 540.2 192 496 192H426.7L421.6 222.5L309.6 158.5L332.7 19.85zM448 64C439.2 64 432 71.16 432 80C432 88.84 439.2 96 448 96C456.8 96 464 88.84 464 80C464 71.16 456.8 64 448 64zM416 256.1V480C416 497.7 401.7 512 384 512H352C334.3 512 320 497.7 320 480V364.8C295.1 377.1 268.8 384 240 384C211.2 384 184 377.1 160 364.8V480C160 497.7 145.7 512 128 512H96C78.33 512 64 497.7 64 480V249.8C35.23 238.9 12.64 214.5 4.836 183.3L.9558 167.8C-3.331 150.6 7.094 133.2 24.24 128.1C41.38 124.7 58.76 135.1 63.05 152.2L66.93 167.8C70.49 182 83.29 191.1 97.97 191.1H303.8L416 256.1z"
            })
        })
    },
    objects: {
        outline: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: [
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                    d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
                }),
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                    d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
                })
            ]
        }),
        solid: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 384 512",
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                d: "M112.1 454.3c0 6.297 1.816 12.44 5.284 17.69l17.14 25.69c5.25 7.875 17.17 14.28 26.64 14.28h61.67c9.438 0 21.36-6.401 26.61-14.28l17.08-25.68c2.938-4.438 5.348-12.37 5.348-17.7L272 415.1h-160L112.1 454.3zM191.4 .0132C89.44 .3257 16 82.97 16 175.1c0 44.38 16.44 84.84 43.56 115.8c16.53 18.84 42.34 58.23 52.22 91.45c.0313 .25 .0938 .5166 .125 .7823h160.2c.0313-.2656 .0938-.5166 .125-.7823c9.875-33.22 35.69-72.61 52.22-91.45C351.6 260.8 368 220.4 368 175.1C368 78.61 288.9-.2837 191.4 .0132zM192 96.01c-44.13 0-80 35.89-80 79.1C112 184.8 104.8 192 96 192S80 184.8 80 176c0-61.76 50.25-111.1 112-111.1c8.844 0 16 7.159 16 16S200.8 96.01 192 96.01z"
            })
        })
    },
    people: {
        outline: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: [
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
                }),
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                    d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
                })
            ]
        }),
        solid: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                d: "M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM256 432C332.1 432 396.2 382 415.2 314.1C419.1 300.4 407.8 288 393.6 288H118.4C104.2 288 92.92 300.4 96.76 314.1C115.8 382 179.9 432 256 432V432zM176.4 160C158.7 160 144.4 174.3 144.4 192C144.4 209.7 158.7 224 176.4 224C194 224 208.4 209.7 208.4 192C208.4 174.3 194 160 176.4 160zM336.4 224C354 224 368.4 209.7 368.4 192C368.4 174.3 354 160 336.4 160C318.7 160 304.4 174.3 304.4 192C304.4 209.7 318.7 224 336.4 224z"
            })
        })
    },
    places: {
        outline: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: [
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                    d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
                }),
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                    d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
                })
            ]
        }),
        solid: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                d: "M39.61 196.8L74.8 96.29C88.27 57.78 124.6 32 165.4 32H346.6C387.4 32 423.7 57.78 437.2 96.29L472.4 196.8C495.6 206.4 512 229.3 512 256V448C512 465.7 497.7 480 480 480H448C430.3 480 416 465.7 416 448V400H96V448C96 465.7 81.67 480 64 480H32C14.33 480 0 465.7 0 448V256C0 229.3 16.36 206.4 39.61 196.8V196.8zM109.1 192H402.9L376.8 117.4C372.3 104.6 360.2 96 346.6 96H165.4C151.8 96 139.7 104.6 135.2 117.4L109.1 192zM96 256C78.33 256 64 270.3 64 288C64 305.7 78.33 320 96 320C113.7 320 128 305.7 128 288C128 270.3 113.7 256 96 256zM416 320C433.7 320 448 305.7 448 288C448 270.3 433.7 256 416 256C398.3 256 384 270.3 384 288C384 305.7 398.3 320 416 320z"
            })
        })
    },
    symbols: {
        outline: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
            })
        }),
        solid: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
                d: "M500.3 7.251C507.7 13.33 512 22.41 512 31.1V175.1C512 202.5 483.3 223.1 447.1 223.1C412.7 223.1 383.1 202.5 383.1 175.1C383.1 149.5 412.7 127.1 447.1 127.1V71.03L351.1 90.23V207.1C351.1 234.5 323.3 255.1 287.1 255.1C252.7 255.1 223.1 234.5 223.1 207.1C223.1 181.5 252.7 159.1 287.1 159.1V63.1C287.1 48.74 298.8 35.61 313.7 32.62L473.7 .6198C483.1-1.261 492.9 1.173 500.3 7.251H500.3zM74.66 303.1L86.5 286.2C92.43 277.3 102.4 271.1 113.1 271.1H174.9C185.6 271.1 195.6 277.3 201.5 286.2L213.3 303.1H239.1C266.5 303.1 287.1 325.5 287.1 351.1V463.1C287.1 490.5 266.5 511.1 239.1 511.1H47.1C21.49 511.1-.0019 490.5-.0019 463.1V351.1C-.0019 325.5 21.49 303.1 47.1 303.1H74.66zM143.1 359.1C117.5 359.1 95.1 381.5 95.1 407.1C95.1 434.5 117.5 455.1 143.1 455.1C170.5 455.1 191.1 434.5 191.1 407.1C191.1 381.5 170.5 359.1 143.1 359.1zM440.3 367.1H496C502.7 367.1 508.6 372.1 510.1 378.4C513.3 384.6 511.6 391.7 506.5 396L378.5 508C372.9 512.1 364.6 513.3 358.6 508.9C352.6 504.6 350.3 496.6 353.3 489.7L391.7 399.1H336C329.3 399.1 323.4 395.9 321 389.6C318.7 383.4 320.4 376.3 325.5 371.1L453.5 259.1C459.1 255 467.4 254.7 473.4 259.1C479.4 263.4 481.6 271.4 478.7 278.3L440.3 367.1zM116.7 219.1L19.85 119.2C-8.112 90.26-6.614 42.31 24.85 15.34C51.82-8.137 93.26-3.642 118.2 21.83L128.2 32.32L137.7 21.83C162.7-3.642 203.6-8.137 231.6 15.34C262.6 42.31 264.1 90.26 236.1 119.2L139.7 219.1C133.2 225.6 122.7 225.6 116.7 219.1H116.7z"
            })
        })
    }
};
const $fcccfb36ed0cde68$var$search = {
    loupe: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
            d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
        })
    }),
    delete: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
            d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
        })
    })
};
var $fcccfb36ed0cde68$export$2e2bcd8739ae039 = {
    categories: $fcccfb36ed0cde68$var$categories,
    search: $fcccfb36ed0cde68$var$search
};





function $254755d3f438722f$export$2e2bcd8739ae039(props) {
    let { id: id , skin: skin , emoji: emoji  } = props;
    if (props.shortcodes) {
        const matches = props.shortcodes.match(($c4d155af13ad4d4b$export$2e2bcd8739ae039).SHORTCODES_REGEX);
        if (matches) {
            id = matches[1];
            if (matches[2]) skin = matches[2];
        }
    }
    emoji || (emoji = ($c4d155af13ad4d4b$export$2e2bcd8739ae039).get(id || props.native));
    if (!emoji) return props.fallback;
    const emojiSkin = emoji.skins[skin - 1] || emoji.skins[0];
    const imageSrc = emojiSkin.src || (props.set != "native" && !props.spritesheet ? typeof props.getImageURL === "function" ? props.getImageURL(props.set, emojiSkin.unified) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${props.set}@15.0.1/img/${props.set}/64/${emojiSkin.unified}.png` : undefined);
    const spritesheetSrc = typeof props.getSpritesheetURL === "function" ? props.getSpritesheetURL(props.set) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${props.set}@15.0.1/img/${props.set}/sheets-256/64.png`;
    return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
        class: "emoji-mart-emoji",
        "data-emoji-set": props.set,
        children: imageSrc ? /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("img", {
            style: {
                maxWidth: props.size || "1em",
                maxHeight: props.size || "1em",
                display: "inline-block"
            },
            alt: emojiSkin.native || emojiSkin.shortcodes,
            src: imageSrc
        }) : props.set == "native" ? /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
            style: {
                fontSize: props.size,
                fontFamily: '"EmojiMart", "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "Android Emoji"'
            },
            children: emojiSkin.native
        }) : /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
            style: {
                display: "block",
                width: props.size,
                height: props.size,
                backgroundImage: `url(${spritesheetSrc})`,
                backgroundSize: `${100 * ($7adb23b0109cc36a$export$2d0294657ab35f1b).sheet.cols}% ${100 * ($7adb23b0109cc36a$export$2d0294657ab35f1b).sheet.rows}%`,
                backgroundPosition: `${100 / (($7adb23b0109cc36a$export$2d0294657ab35f1b).sheet.cols - 1) * emojiSkin.x}% ${100 / (($7adb23b0109cc36a$export$2d0294657ab35f1b).sheet.rows - 1) * emojiSkin.y}%`
            }
        })
    });
}







const $6f57cc9cd54c5aaa$var$WindowHTMLElement = typeof window !== "undefined" && window.HTMLElement ? window.HTMLElement : Object;
class $6f57cc9cd54c5aaa$export$2e2bcd8739ae039 extends $6f57cc9cd54c5aaa$var$WindowHTMLElement {
    static get observedAttributes() {
        return Object.keys(this.Props);
    }
    update(props = {}) {
        for(let k in props)this.attributeChangedCallback(k, null, props[k]);
    }
    attributeChangedCallback(attr, _, newValue) {
        if (!this.component) return;
        const value = ($7adb23b0109cc36a$export$88c9ddb45cea7241)(attr, {
            [attr]: newValue
        }, this.constructor.Props, this);
        if (this.component.componentWillReceiveProps) this.component.componentWillReceiveProps({
            [attr]: value
        });
        else {
            this.component.props[attr] = value;
            this.component.forceUpdate();
        }
    }
    disconnectedCallback() {
        this.disconnected = true;
        if (this.component && this.component.unregister) this.component.unregister();
    }
    constructor(props = {}){
        super();
        this.props = props;
        if (props.parent || props.ref) {
            let ref = null;
            const parent = props.parent || (ref = props.ref && props.ref.current);
            if (ref) ref.innerHTML = "";
            if (parent) parent.appendChild(this);
        }
    }
}



class $26f27c338a96b1a6$export$2e2bcd8739ae039 extends ($6f57cc9cd54c5aaa$export$2e2bcd8739ae039) {
    setShadow() {
        this.attachShadow({
            mode: "open"
        });
    }
    injectStyles(styles) {
        if (!styles) return;
        const style = document.createElement("style");
        style.textContent = styles;
        this.shadowRoot.insertBefore(style, this.shadowRoot.firstChild);
    }
    constructor(props, { styles: styles  } = {}){
        super(props);
        this.setShadow();
        this.injectStyles(styles);
    }
}






var $3d90f6e46fb2dd47$export$2e2bcd8739ae039 = {
    fallback: "",
    id: "",
    native: "",
    shortcodes: "",
    size: {
        value: "",
        transform: (value)=>{
            // If the value is a number, then we assume it’s a pixel value.
            if (!/\D/.test(value)) return `${value}px`;
            return value;
        }
    },
    // Shared
    set: ($b247ea80b67298d5$export$2e2bcd8739ae039).set,
    skin: ($b247ea80b67298d5$export$2e2bcd8739ae039).skin
};


class $331b4160623139bf$export$2e2bcd8739ae039 extends ($6f57cc9cd54c5aaa$export$2e2bcd8739ae039) {
    async connectedCallback() {
        const props = ($7adb23b0109cc36a$export$75fe5f91d452f94b)(this.props, ($3d90f6e46fb2dd47$export$2e2bcd8739ae039), this);
        props.element = this;
        props.ref = (component)=>{
            this.component = component;
        };
        await ($7adb23b0109cc36a$export$2cd8252107eb640b)();
        if (this.disconnected) return;
        ($fb96b826c0c5f37a$export$b3890eb0ae9dca99)(/*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)(($254755d3f438722f$export$2e2bcd8739ae039), {
            ...props
        }), this);
    }
    constructor(props){
        super(props);
    }
}
($c770c458706daa72$export$2e2bcd8739ae039)($331b4160623139bf$export$2e2bcd8739ae039, "Props", ($3d90f6e46fb2dd47$export$2e2bcd8739ae039));
if (typeof customElements !== "undefined" && !customElements.get("em-emoji")) customElements.define("em-emoji", $331b4160623139bf$export$2e2bcd8739ae039);






var $1a9a8ef576b7773d$var$r, $1a9a8ef576b7773d$var$i = [], $1a9a8ef576b7773d$var$c = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__b, $1a9a8ef576b7773d$var$f = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__r, $1a9a8ef576b7773d$var$e = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).diffed, $1a9a8ef576b7773d$var$a = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__c, $1a9a8ef576b7773d$var$v = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).unmount;
function $1a9a8ef576b7773d$var$x() {
    var t6;
    for($1a9a8ef576b7773d$var$i.sort(function(n11, t7) {
        return n11.__v.__b - t7.__v.__b;
    }); t6 = $1a9a8ef576b7773d$var$i.pop();)if (t6.__P) try {
        t6.__H.__h.forEach($1a9a8ef576b7773d$var$g), t6.__H.__h.forEach($1a9a8ef576b7773d$var$j), t6.__H.__h = [];
    } catch (u4) {
        t6.__H.__h = [], ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__e(u4, t6.__v);
    }
}
($fb96b826c0c5f37a$export$41c562ebe57d11e2).__b = function(n12) {
    $1a9a8ef576b7773d$var$c && $1a9a8ef576b7773d$var$c(n12);
}, ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__r = function(n13) {
    $1a9a8ef576b7773d$var$f && $1a9a8ef576b7773d$var$f(n13);
    var r8 = (n13.__c).__H;
    r8 && (r8.__h.forEach($1a9a8ef576b7773d$var$g), r8.__h.forEach($1a9a8ef576b7773d$var$j), r8.__h = []);
}, ($fb96b826c0c5f37a$export$41c562ebe57d11e2).diffed = function(t8) {
    $1a9a8ef576b7773d$var$e && $1a9a8ef576b7773d$var$e(t8);
    var o6 = t8.__c;
    o6 && o6.__H && o6.__H.__h.length && (1 !== $1a9a8ef576b7773d$var$i.push(o6) && $1a9a8ef576b7773d$var$r === ($fb96b826c0c5f37a$export$41c562ebe57d11e2).requestAnimationFrame || (($1a9a8ef576b7773d$var$r = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).requestAnimationFrame) || function(n14) {
        var t9, u5 = function() {
            clearTimeout(r9), $1a9a8ef576b7773d$var$b && cancelAnimationFrame(t9), setTimeout(n14);
        }, r9 = setTimeout(u5, 100);
        $1a9a8ef576b7773d$var$b && (t9 = requestAnimationFrame(u5));
    })($1a9a8ef576b7773d$var$x));
}, ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__c = function(t10, u6) {
    u6.some(function(t11) {
        try {
            t11.__h.forEach($1a9a8ef576b7773d$var$g), t11.__h = t11.__h.filter(function(n15) {
                return !n15.__ || $1a9a8ef576b7773d$var$j(n15);
            });
        } catch (r10) {
            u6.some(function(n16) {
                n16.__h && (n16.__h = []);
            }), u6 = [], ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__e(r10, t11.__v);
        }
    }), $1a9a8ef576b7773d$var$a && $1a9a8ef576b7773d$var$a(t10, u6);
}, ($fb96b826c0c5f37a$export$41c562ebe57d11e2).unmount = function(t12) {
    $1a9a8ef576b7773d$var$v && $1a9a8ef576b7773d$var$v(t12);
    var u7, r11 = t12.__c;
    r11 && r11.__H && (r11.__H.__.forEach(function(n17) {
        try {
            $1a9a8ef576b7773d$var$g(n17);
        } catch (n18) {
            u7 = n18;
        }
    }), u7 && ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__e(u7, r11.__v));
};
var $1a9a8ef576b7773d$var$b = "function" == typeof requestAnimationFrame;
function $1a9a8ef576b7773d$var$g(n19) {
    var r12 = n19.__c;
    "function" == typeof r12 && (n19.__c = void 0, r12());
}
function $1a9a8ef576b7773d$var$j(n20) {
    n20.__c = n20.__();
}





function $dc040a17866866fa$var$S(n1, t1) {
    for(var e1 in t1)n1[e1] = t1[e1];
    return n1;
}
function $dc040a17866866fa$var$C(n2, t2) {
    for(var e2 in n2)if ("__source" !== e2 && !(e2 in t2)) return !0;
    for(var r1 in t2)if ("__source" !== r1 && n2[r1] !== t2[r1]) return !0;
    return !1;
}
function $dc040a17866866fa$export$221d75b3f55bb0bd(n3) {
    this.props = n3;
}
($dc040a17866866fa$export$221d75b3f55bb0bd.prototype = new ($fb96b826c0c5f37a$export$16fa2f45be04daa8)).isPureReactComponent = !0, $dc040a17866866fa$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n6, t5) {
    return $dc040a17866866fa$var$C(this.props, n6) || $dc040a17866866fa$var$C(this.state, t5);
};
var $dc040a17866866fa$var$w = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__b;
($fb96b826c0c5f37a$export$41c562ebe57d11e2).__b = function(n7) {
    n7.type && n7.type.__f && n7.ref && (n7.props.ref = n7.ref, n7.ref = null), $dc040a17866866fa$var$w && $dc040a17866866fa$var$w(n7);
};
var $dc040a17866866fa$var$A = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__e;
($fb96b826c0c5f37a$export$41c562ebe57d11e2).__e = function(n12, t10, e6) {
    if (n12.then) {
        for(var r5, u1 = t10; u1 = u1.__;)if ((r5 = u1.__c) && r5.__c) return null == t10.__e && (t10.__e = e6.__e, t10.__k = e6.__k), r5.__c(n12, t10);
    }
    $dc040a17866866fa$var$A(n12, t10, e6);
};
var $dc040a17866866fa$var$O = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).unmount;
function $dc040a17866866fa$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $dc040a17866866fa$var$U(n13) {
    var t11 = n13.__.__c;
    return t11 && t11.__e && t11.__e(n13);
}
function $dc040a17866866fa$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
($fb96b826c0c5f37a$export$41c562ebe57d11e2).unmount = function(n17) {
    var t13 = n17.__c;
    t13 && t13.__R && t13.__R(), t13 && !0 === n17.__h && (n17.type = null), $dc040a17866866fa$var$O && $dc040a17866866fa$var$O(n17);
}, ($dc040a17866866fa$export$74bf444e3cd11ea5.prototype = new ($fb96b826c0c5f37a$export$16fa2f45be04daa8)).__c = function(n18, t14) {
    var e8 = t14.__c, r7 = this;
    null == r7.t && (r7.t = []), r7.t.push(e8);
    var u4 = $dc040a17866866fa$var$U(r7.__v), o1 = !1, i1 = function() {
        o1 || (o1 = !0, e8.__R = null, u4 ? u4(l1) : l1());
    };
    e8.__R = i1;
    var l1 = function() {
        if (!--r7.__u) {
            if (r7.state.__e) {
                var n19 = r7.state.__e;
                r7.__v.__k[0] = function n22(t17, e9, r8) {
                    return t17 && (t17.__v = null, t17.__k = t17.__k && t17.__k.map(function(t18) {
                        return n22(t18, e9, r8);
                    }), t17.__c && t17.__c.__P === e9 && (t17.__e && r8.insertBefore(t17.__e, t17.__d), t17.__c.__e = !0, t17.__c.__P = r8)), t17;
                }(n19, n19.__c.__P, n19.__c.__O);
            }
            var t15;
            for(r7.setState({
                __e: r7.__b = null
            }); t15 = r7.t.pop();)t15.forceUpdate();
        }
    }, c1 = !0 === t14.__h;
    (r7.__u++) || c1 || r7.setState({
        __e: r7.__b = r7.__v.__k[0]
    }), n18.then(i1, i1);
}, $dc040a17866866fa$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $dc040a17866866fa$export$74bf444e3cd11ea5.prototype.render = function(n23, t19) {
    if (this.__b) {
        if (this.__v.__k) {
            var e10 = document.createElement("div"), r9 = this.__v.__k[0].__c;
            this.__v.__k[0] = function n24(t20, e13, r12) {
                return t20 && (t20.__c && t20.__c.__H && (t20.__c.__H.__.forEach(function(n25) {
                    "function" == typeof n25.__c && n25.__c();
                }), t20.__c.__H = null), null != (t20 = $dc040a17866866fa$var$S({}, t20)).__c && (t20.__c.__P === r12 && (t20.__c.__P = e13), t20.__c = null), t20.__k = t20.__k && t20.__k.map(function(t21) {
                    return n24(t21, e13, r12);
                })), t20;
            }(this.__b, e10, r9.__O = r9.__P);
        }
        this.__b = null;
    }
    var u5 = t19.__e && ($fb96b826c0c5f37a$export$c8a8987d4410bf2d)(($fb96b826c0c5f37a$export$ffb0004e005737fa), null, n23.fallback);
    return u5 && (u5.__h = null), [
        ($fb96b826c0c5f37a$export$c8a8987d4410bf2d)(($fb96b826c0c5f37a$export$ffb0004e005737fa), null, t19.__e ? null : n23.children),
        u5
    ];
};
var $dc040a17866866fa$var$T = function(n26, t22, e14) {
    if (++e14[1] === e14[0] && n26.o.delete(t22), n26.props.revealOrder && ("t" !== n26.props.revealOrder[0] || !n26.o.size)) for(e14 = n26.u; e14;){
        for(; e14.length > 3;)e14.pop()();
        if (e14[1] < e14[0]) break;
        n26.u = e14 = e14[2];
    }
};
($dc040a17866866fa$export$998bcd577473dd93.prototype = new ($fb96b826c0c5f37a$export$16fa2f45be04daa8)).__e = function(n33) {
    var t25 = this, e16 = $dc040a17866866fa$var$U(t25.__v), r13 = t25.o.get(n33);
    return r13[0]++, function(u6) {
        var o2 = function() {
            t25.props.revealOrder ? (r13.push(u6), $dc040a17866866fa$var$T(t25, n33, r13)) : u6();
        };
        e16 ? e16(o2) : o2();
    };
}, $dc040a17866866fa$export$998bcd577473dd93.prototype.render = function(n34) {
    this.u = null, this.o = new Map;
    var t26 = ($fb96b826c0c5f37a$export$47e4c5b300681277)(n34.children);
    n34.revealOrder && "b" === n34.revealOrder[0] && t26.reverse();
    for(var e17 = t26.length; e17--;)this.o.set(t26[e17], this.u = [
        1,
        0,
        this.u
    ]);
    return n34.children;
}, $dc040a17866866fa$export$998bcd577473dd93.prototype.componentDidUpdate = $dc040a17866866fa$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n35 = this;
    this.o.forEach(function(t27, e18) {
        $dc040a17866866fa$var$T(n35, e18, t27);
    });
};
var $dc040a17866866fa$var$j = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $dc040a17866866fa$var$P = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $dc040a17866866fa$var$V = "undefined" != typeof document, $dc040a17866866fa$var$z = function(n36) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n36);
};
($fb96b826c0c5f37a$export$16fa2f45be04daa8).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(n39) {
    Object.defineProperty(($fb96b826c0c5f37a$export$16fa2f45be04daa8).prototype, n39, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + n39];
        },
        set: function(t30) {
            Object.defineProperty(this, n39, {
                configurable: !0,
                writable: !0,
                value: t30
            });
        }
    });
});
var $dc040a17866866fa$var$H = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).event;
function $dc040a17866866fa$var$Z() {}
function $dc040a17866866fa$var$Y() {
    return this.cancelBubble;
}
function $dc040a17866866fa$var$q() {
    return this.defaultPrevented;
}
($fb96b826c0c5f37a$export$41c562ebe57d11e2).event = function(n40) {
    return $dc040a17866866fa$var$H && (n40 = $dc040a17866866fa$var$H(n40)), n40.persist = $dc040a17866866fa$var$Z, n40.isPropagationStopped = $dc040a17866866fa$var$Y, n40.isDefaultPrevented = $dc040a17866866fa$var$q, n40.nativeEvent = n40;
};
var $dc040a17866866fa$var$J = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $dc040a17866866fa$var$K = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).vnode;
($fb96b826c0c5f37a$export$41c562ebe57d11e2).vnode = function(n41) {
    var t31 = n41.type, e21 = n41.props, r14 = e21;
    if ("string" == typeof t31) {
        var u7 = -1 === t31.indexOf("-");
        for(var o3 in r14 = {}, e21){
            var i2 = e21[o3];
            $dc040a17866866fa$var$V && "children" === o3 && "noscript" === t31 || "value" === o3 && "defaultValue" in e21 && null == i2 || ("defaultValue" === o3 && "value" in e21 && null == e21.value ? o3 = "value" : "download" === o3 && !0 === i2 ? i2 = "" : /ondoubleclick/i.test(o3) ? o3 = "ondblclick" : /^onchange(textarea|input)/i.test(o3 + t31) && !$dc040a17866866fa$var$z(e21.type) ? o3 = "oninput" : /^onfocus$/i.test(o3) ? o3 = "onfocusin" : /^onblur$/i.test(o3) ? o3 = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp)/.test(o3) ? o3 = o3.toLowerCase() : u7 && $dc040a17866866fa$var$P.test(o3) ? o3 = o3.replace(/[A-Z0-9]/, "-$&").toLowerCase() : null === i2 && (i2 = void 0), r14[o3] = i2);
        }
        "select" == t31 && r14.multiple && Array.isArray(r14.value) && (r14.value = ($fb96b826c0c5f37a$export$47e4c5b300681277)(e21.children).forEach(function(n42) {
            n42.props.selected = -1 != r14.value.indexOf(n42.props.value);
        })), "select" == t31 && null != r14.defaultValue && (r14.value = ($fb96b826c0c5f37a$export$47e4c5b300681277)(e21.children).forEach(function(n43) {
            n43.props.selected = r14.multiple ? -1 != r14.defaultValue.indexOf(n43.props.value) : r14.defaultValue == n43.props.value;
        })), n41.props = r14, e21.class != e21.className && ($dc040a17866866fa$var$J.enumerable = "className" in e21, null != e21.className && (r14.class = e21.className), Object.defineProperty(r14, "className", $dc040a17866866fa$var$J));
    }
    n41.$$typeof = $dc040a17866866fa$var$j, $dc040a17866866fa$var$K && $dc040a17866866fa$var$K(n41);
};
var $dc040a17866866fa$var$Q = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__r;
($fb96b826c0c5f37a$export$41c562ebe57d11e2).__r = function(n44) {
    $dc040a17866866fa$var$Q && $dc040a17866866fa$var$Q(n44), n44.__c;
};




const $ec8c39fdad15601a$var$THEME_ICONS = {
    light: "outline",
    dark: "solid"
};
class $ec8c39fdad15601a$export$2e2bcd8739ae039 extends ($dc040a17866866fa$export$221d75b3f55bb0bd) {
    renderIcon(category) {
        const { icon: icon  } = category;
        if (icon) {
            if (icon.svg) return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
                class: "flex",
                dangerouslySetInnerHTML: {
                    __html: icon.svg
                }
            });
            if (icon.src) return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("img", {
                src: icon.src
            });
        }
        const categoryIcons = ($fcccfb36ed0cde68$export$2e2bcd8739ae039).categories[category.id] || ($fcccfb36ed0cde68$export$2e2bcd8739ae039).categories.custom;
        const style = this.props.icons == "auto" ? $ec8c39fdad15601a$var$THEME_ICONS[this.props.theme] : this.props.icons;
        return categoryIcons[style] || categoryIcons;
    }
    render() {
        let selectedCategoryIndex = null;
        return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("nav", {
            id: "nav",
            class: "padding",
            "data-position": this.props.position,
            dir: this.props.dir,
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                class: "flex relative",
                children: [
                    this.categories.map((category, i)=>{
                        const title = category.name || ($7adb23b0109cc36a$export$dbe3113d60765c1a).categories[category.id];
                        const selected = !this.props.unfocused && category.id == this.state.categoryId;
                        if (selected) selectedCategoryIndex = i;
                        return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("button", {
                            "aria-label": title,
                            "aria-selected": selected || undefined,
                            title: title,
                            type: "button",
                            class: "flex flex-grow flex-center",
                            onMouseDown: (e)=>e.preventDefault(),
                            onClick: ()=>{
                                this.props.onClick({
                                    category: category,
                                    i: i
                                });
                            },
                            children: this.renderIcon(category)
                        });
                    }),
                    /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                        class: "bar",
                        style: {
                            width: `${100 / this.categories.length}%`,
                            opacity: selectedCategoryIndex == null ? 0 : 1,
                            transform: this.props.dir === "rtl" ? `scaleX(-1) translateX(${selectedCategoryIndex * 100}%)` : `translateX(${selectedCategoryIndex * 100}%)`
                        }
                    })
                ]
            })
        });
    }
    constructor(){
        super();
        this.categories = ($7adb23b0109cc36a$export$2d0294657ab35f1b).categories.filter((category)=>{
            return !category.target;
        });
        this.state = {
            categoryId: this.categories[0].id
        };
    }
}





class $e0d4dda61265ff1e$export$2e2bcd8739ae039 extends ($dc040a17866866fa$export$221d75b3f55bb0bd) {
    shouldComponentUpdate(nextProps) {
        for(let k in nextProps){
            if (k == "children") continue;
            if (nextProps[k] != this.props[k]) return true;
        }
        return false;
    }
    render() {
        return this.props.children;
    }
}




const $89bd6bb200cc8fef$var$Performance = {
    rowsPerRender: 10
};
class $89bd6bb200cc8fef$export$2e2bcd8739ae039 extends ($fb96b826c0c5f37a$export$16fa2f45be04daa8) {
    getInitialState(props = this.props) {
        return {
            skin: ($f72b75cf796873c7$export$2e2bcd8739ae039).get("skin") || props.skin,
            theme: this.initTheme(props.theme)
        };
    }
    componentWillMount() {
        this.dir = ($7adb23b0109cc36a$export$dbe3113d60765c1a).rtl ? "rtl" : "ltr";
        this.refs = {
            menu: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)(),
            navigation: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)(),
            scroll: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)(),
            search: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)(),
            searchInput: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)(),
            skinToneButton: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)(),
            skinToneRadio: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)()
        };
        this.initGrid();
        if (this.props.stickySearch == false && this.props.searchPosition == "sticky") {
            console.warn("[EmojiMart] Deprecation warning: `stickySearch` has been renamed `searchPosition`.");
            this.props.searchPosition = "static";
        }
    }
    componentDidMount() {
        this.register();
        this.shadowRoot = this.base.parentNode;
        if (this.props.autoFocus) {
            const { searchInput: searchInput  } = this.refs;
            if (searchInput.current) searchInput.current.focus();
        }
    }
    componentWillReceiveProps(nextProps) {
        this.nextState || (this.nextState = {});
        for(const k1 in nextProps)this.nextState[k1] = nextProps[k1];
        clearTimeout(this.nextStateTimer);
        this.nextStateTimer = setTimeout(()=>{
            let requiresGridReset = false;
            for(const k in this.nextState){
                this.props[k] = this.nextState[k];
                if (k === "custom" || k === "categories") requiresGridReset = true;
            }
            delete this.nextState;
            const nextState = this.getInitialState();
            if (requiresGridReset) return this.reset(nextState);
            this.setState(nextState);
        });
    }
    componentWillUnmount() {
        this.unregister();
    }
    async reset(nextState = {}) {
        await ($7adb23b0109cc36a$export$2cd8252107eb640b)(this.props);
        this.initGrid();
        this.unobserve();
        this.setState(nextState, ()=>{
            this.observeCategories();
            this.observeRows();
        });
    }
    register() {
        document.addEventListener("click", this.handleClickOutside);
        this.observe();
    }
    unregister() {
        document.removeEventListener("click", this.handleClickOutside);
        this.darkMedia?.removeEventListener("change", this.darkMediaCallback);
        this.unobserve();
    }
    observe() {
        this.observeCategories();
        this.observeRows();
    }
    unobserve({ except: except = []  } = {}) {
        if (!Array.isArray(except)) except = [
            except
        ];
        for (const observer of this.observers){
            if (except.includes(observer)) continue;
            observer.disconnect();
        }
        this.observers = [].concat(except);
    }
    initGrid() {
        const { categories: categories  } = ($7adb23b0109cc36a$export$2d0294657ab35f1b);
        this.refs.categories = new Map();
        const navKey = ($7adb23b0109cc36a$export$2d0294657ab35f1b).categories.map((category)=>category.id).join(",");
        if (this.navKey && this.navKey != navKey) this.refs.scroll.current && (this.refs.scroll.current.scrollTop = 0);
        this.navKey = navKey;
        this.grid = [];
        this.grid.setsize = 0;
        const addRow = (rows, category)=>{
            const row = [];
            row.__categoryId = category.id;
            row.__index = rows.length;
            this.grid.push(row);
            const rowIndex = this.grid.length - 1;
            const rowRef = rowIndex % $89bd6bb200cc8fef$var$Performance.rowsPerRender ? {} : ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)();
            rowRef.index = rowIndex;
            rowRef.posinset = this.grid.setsize + 1;
            rows.push(rowRef);
            return row;
        };
        for (let category1 of categories){
            const rows = [];
            let row = addRow(rows, category1);
            for (let emoji of category1.emojis){
                if (row.length == this.getPerLine()) row = addRow(rows, category1);
                this.grid.setsize += 1;
                row.push(emoji);
            }
            this.refs.categories.set(category1.id, {
                root: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)(),
                rows: rows
            });
        }
    }
    initTheme(theme) {
        if (theme != "auto") return theme;
        if (!this.darkMedia) {
            this.darkMedia = matchMedia("(prefers-color-scheme: dark)");
            if (this.darkMedia.media.match(/^not/)) return "light";
            this.darkMedia.addEventListener("change", this.darkMediaCallback);
        }
        return this.darkMedia.matches ? "dark" : "light";
    }
    initDynamicPerLine(props = this.props) {
        if (!props.dynamicWidth) return;
        const { element: element , emojiButtonSize: emojiButtonSize  } = props;
        const calculatePerLine = ()=>{
            const { width: width  } = element.getBoundingClientRect();
            return Math.floor(width / emojiButtonSize);
        };
        const observer = new ResizeObserver(()=>{
            this.unobserve({
                except: observer
            });
            this.setState({
                perLine: calculatePerLine()
            }, ()=>{
                this.initGrid();
                this.forceUpdate(()=>{
                    this.observeCategories();
                    this.observeRows();
                });
            });
        });
        observer.observe(element);
        this.observers.push(observer);
        return calculatePerLine();
    }
    getPerLine() {
        return this.state.perLine || this.props.perLine;
    }
    getEmojiByPos([p1, p2]) {
        const grid = this.state.searchResults || this.grid;
        const emoji = grid[p1] && grid[p1][p2];
        if (!emoji) return;
        return ($c4d155af13ad4d4b$export$2e2bcd8739ae039).get(emoji);
    }
    observeCategories() {
        const navigation = this.refs.navigation.current;
        if (!navigation) return;
        const visibleCategories = new Map();
        const setFocusedCategory = (categoryId)=>{
            if (categoryId != navigation.state.categoryId) navigation.setState({
                categoryId: categoryId
            });
        };
        const observerOptions = {
            root: this.refs.scroll.current,
            threshold: [
                0.0,
                1.0
            ]
        };
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries){
                const id = entry.target.dataset.id;
                visibleCategories.set(id, entry.intersectionRatio);
            }
            const ratios = [
                ...visibleCategories
            ];
            for (const [id, ratio] of ratios)if (ratio) {
                setFocusedCategory(id);
                break;
            }
        }, observerOptions);
        for (const { root: root  } of this.refs.categories.values())observer.observe(root.current);
        this.observers.push(observer);
    }
    observeRows() {
        const visibleRows = {
            ...this.state.visibleRows
        };
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries){
                const index = parseInt(entry.target.dataset.index);
                if (entry.isIntersecting) visibleRows[index] = true;
                else delete visibleRows[index];
            }
            this.setState({
                visibleRows: visibleRows
            });
        }, {
            root: this.refs.scroll.current,
            rootMargin: `${this.props.emojiButtonSize * ($89bd6bb200cc8fef$var$Performance.rowsPerRender + 5)}px 0px ${this.props.emojiButtonSize * $89bd6bb200cc8fef$var$Performance.rowsPerRender}px`
        });
        for (const { rows: rows  } of this.refs.categories.values()){
            for (const row of rows)if (row.current) observer.observe(row.current);
        }
        this.observers.push(observer);
    }
    preventDefault(e) {
        e.preventDefault();
    }
    unfocusSearch() {
        const input = this.refs.searchInput.current;
        if (!input) return;
        input.blur();
    }
    navigate({ e: e , input: input , left: left , right: right , up: up , down: down  }) {
        const grid = this.state.searchResults || this.grid;
        if (!grid.length) return;
        let [p1, p2] = this.state.pos;
        const pos = (()=>{
            if (p1 == 0) {
                if (p2 == 0 && !e.repeat && (left || up)) return null;
            }
            if (p1 == -1) {
                if (!e.repeat && (right || down) && input.selectionStart == input.value.length) return [
                    0,
                    0
                ];
                return null;
            }
            if (left || right) {
                let row = grid[p1];
                const increment = left ? -1 : 1;
                p2 += increment;
                if (!row[p2]) {
                    p1 += increment;
                    row = grid[p1];
                    if (!row) {
                        p1 = left ? 0 : grid.length - 1;
                        p2 = left ? 0 : grid[p1].length - 1;
                        return [
                            p1,
                            p2
                        ];
                    }
                    p2 = left ? row.length - 1 : 0;
                }
                return [
                    p1,
                    p2
                ];
            }
            if (up || down) {
                p1 += up ? -1 : 1;
                const row = grid[p1];
                if (!row) {
                    p1 = up ? 0 : grid.length - 1;
                    p2 = up ? 0 : grid[p1].length - 1;
                    return [
                        p1,
                        p2
                    ];
                }
                if (!row[p2]) p2 = row.length - 1;
                return [
                    p1,
                    p2
                ];
            }
        })();
        if (pos) e.preventDefault();
        else {
            if (this.state.pos[0] > -1) this.setState({
                pos: [
                    -1,
                    -1
                ]
            });
            return;
        }
        this.setState({
            pos: pos,
            keyboard: true
        }, ()=>{
            this.scrollTo({
                row: pos[0]
            });
        });
    }
    scrollTo({ categoryId: categoryId , row: row  }) {
        const grid = this.state.searchResults || this.grid;
        if (!grid.length) return;
        const scroll = this.refs.scroll.current;
        const scrollRect = scroll.getBoundingClientRect();
        let scrollTop = 0;
        if (row >= 0) categoryId = grid[row].__categoryId;
        if (categoryId) {
            const ref = this.refs[categoryId] || this.refs.categories.get(categoryId).root;
            const categoryRect = ref.current.getBoundingClientRect();
            scrollTop = categoryRect.top - (scrollRect.top - scroll.scrollTop) + 1;
        }
        if (row >= 0) {
            if (!row) scrollTop = 0;
            else {
                const rowIndex = grid[row].__index;
                const rowTop = scrollTop + rowIndex * this.props.emojiButtonSize;
                const rowBot = rowTop + this.props.emojiButtonSize + this.props.emojiButtonSize * 0.88;
                if (rowTop < scroll.scrollTop) scrollTop = rowTop;
                else if (rowBot > scroll.scrollTop + scrollRect.height) scrollTop = rowBot - scrollRect.height;
                else return;
            }
        }
        this.ignoreMouse();
        scroll.scrollTop = scrollTop;
    }
    ignoreMouse() {
        this.mouseIsIgnored = true;
        clearTimeout(this.ignoreMouseTimer);
        this.ignoreMouseTimer = setTimeout(()=>{
            delete this.mouseIsIgnored;
        }, 100);
    }
    handleEmojiOver(pos) {
        if (this.mouseIsIgnored || this.state.showSkins) return;
        this.setState({
            pos: pos || [
                -1,
                -1
            ],
            keyboard: false
        });
    }
    handleEmojiClick({ e: e , emoji: emoji , pos: pos  }) {
        if (!this.props.onEmojiSelect) return;
        if (!emoji && pos) emoji = this.getEmojiByPos(pos);
        if (emoji) {
            const emojiData = ($693b183b0a78708f$export$d10ac59fbe52a745)(emoji, {
                skinIndex: this.state.skin - 1
            });
            if (this.props.maxFrequentRows) ($b22cfd0a55410b4f$export$2e2bcd8739ae039).add(emojiData, this.props);
            this.props.onEmojiSelect(emojiData, e);
        }
    }
    closeSkins() {
        if (!this.state.showSkins) return;
        this.setState({
            showSkins: null,
            tempSkin: null
        });
        this.base.removeEventListener("click", this.handleBaseClick);
        this.base.removeEventListener("keydown", this.handleBaseKeydown);
    }
    handleSkinMouseOver(tempSkin) {
        this.setState({
            tempSkin: tempSkin
        });
    }
    handleSkinClick(skin) {
        this.ignoreMouse();
        this.closeSkins();
        this.setState({
            skin: skin,
            tempSkin: null
        });
        ($f72b75cf796873c7$export$2e2bcd8739ae039).set("skin", skin);
    }
    renderNav() {
        return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)(($ec8c39fdad15601a$export$2e2bcd8739ae039), {
            ref: this.refs.navigation,
            icons: this.props.icons,
            theme: this.state.theme,
            dir: this.dir,
            unfocused: !!this.state.searchResults,
            position: this.props.navPosition,
            onClick: this.handleCategoryClick
        }, this.navKey);
    }
    renderPreview() {
        const emoji = this.getEmojiByPos(this.state.pos);
        const noSearchResults = this.state.searchResults && !this.state.searchResults.length;
        return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
            id: "preview",
            class: "flex flex-middle",
            dir: this.dir,
            "data-position": this.props.previewPosition,
            children: [
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                    class: "flex flex-middle flex-grow",
                    children: [
                        /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                            class: "flex flex-auto flex-middle flex-center",
                            style: {
                                height: this.props.emojiButtonSize,
                                fontSize: this.props.emojiButtonSize
                            },
                            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)(($254755d3f438722f$export$2e2bcd8739ae039), {
                                emoji: emoji,
                                id: noSearchResults ? this.props.noResultsEmoji || "cry" : this.props.previewEmoji || (this.props.previewPosition == "top" ? "point_down" : "point_up"),
                                set: this.props.set,
                                size: this.props.emojiButtonSize,
                                skin: this.state.tempSkin || this.state.skin,
                                spritesheet: true,
                                getSpritesheetURL: this.props.getSpritesheetURL
                            })
                        }),
                        /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                            class: `margin-${this.dir[0]}`,
                            children: emoji || noSearchResults ? /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                                class: `padding-${this.dir[2]} align-${this.dir[0]}`,
                                children: [
                                    /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                                        class: "preview-title ellipsis",
                                        children: emoji ? emoji.name : ($7adb23b0109cc36a$export$dbe3113d60765c1a).search_no_results_1
                                    }),
                                    /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                                        class: "preview-subtitle ellipsis color-c",
                                        children: emoji ? emoji.skins[0].shortcodes : ($7adb23b0109cc36a$export$dbe3113d60765c1a).search_no_results_2
                                    })
                                ]
                            }) : /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                                class: "preview-placeholder color-c",
                                children: ($7adb23b0109cc36a$export$dbe3113d60765c1a).pick
                            })
                        })
                    ]
                }),
                !emoji && this.props.skinTonePosition == "preview" && this.renderSkinToneButton()
            ]
        });
    }
    renderEmojiButton(emoji, { pos: pos , posinset: posinset , grid: grid  }) {
        const size = this.props.emojiButtonSize;
        const skin = this.state.tempSkin || this.state.skin;
        const emojiSkin = emoji.skins[skin - 1] || emoji.skins[0];
        const native = emojiSkin.native;
        const selected = ($693b183b0a78708f$export$9cb4719e2e525b7a)(this.state.pos, pos);
        const key = pos.concat(emoji.id).join("");
        return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)(($e0d4dda61265ff1e$export$2e2bcd8739ae039), {
            selected: selected,
            skin: skin,
            size: size,
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("button", {
                "aria-label": native,
                "aria-selected": selected || undefined,
                "aria-posinset": posinset,
                "aria-setsize": grid.setsize,
                "data-keyboard": this.state.keyboard,
                title: this.props.previewPosition == "none" ? emoji.name : undefined,
                type: "button",
                class: "flex flex-center flex-middle",
                tabindex: "-1",
                onClick: (e)=>this.handleEmojiClick({
                        e: e,
                        emoji: emoji
                    }),
                onMouseEnter: ()=>this.handleEmojiOver(pos),
                onMouseLeave: ()=>this.handleEmojiOver(),
                style: {
                    width: this.props.emojiButtonSize,
                    height: this.props.emojiButtonSize,
                    fontSize: this.props.emojiSize,
                    lineHeight: 0
                },
                children: [
                    /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                        "aria-hidden": "true",
                        class: "background",
                        style: {
                            borderRadius: this.props.emojiButtonRadius,
                            backgroundColor: this.props.emojiButtonColors ? this.props.emojiButtonColors[(posinset - 1) % this.props.emojiButtonColors.length] : undefined
                        }
                    }),
                    /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)(($254755d3f438722f$export$2e2bcd8739ae039), {
                        emoji: emoji,
                        set: this.props.set,
                        size: this.props.emojiSize,
                        skin: skin,
                        spritesheet: true,
                        getSpritesheetURL: this.props.getSpritesheetURL
                    })
                ]
            })
        }, key);
    }
    renderSearch() {
        const renderSkinTone = this.props.previewPosition == "none" || this.props.skinTonePosition == "search";
        return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
            children: [
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                    class: "spacer"
                }),
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                    class: "flex flex-middle",
                    children: [
                        /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                            class: "search relative flex-grow",
                            children: [
                                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("input", {
                                    type: "search",
                                    ref: this.refs.searchInput,
                                    placeholder: ($7adb23b0109cc36a$export$dbe3113d60765c1a).search,
                                    onClick: this.handleSearchClick,
                                    onInput: this.handleSearchInput,
                                    onKeyDown: this.handleSearchKeyDown,
                                    autoComplete: "off"
                                }),
                                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
                                    class: "icon loupe flex",
                                    children: ($fcccfb36ed0cde68$export$2e2bcd8739ae039).search.loupe
                                }),
                                this.state.searchResults && /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("button", {
                                    title: "Clear",
                                    "aria-label": "Clear",
                                    type: "button",
                                    class: "icon delete flex",
                                    onClick: this.clearSearch,
                                    onMouseDown: this.preventDefault,
                                    children: ($fcccfb36ed0cde68$export$2e2bcd8739ae039).search.delete
                                })
                            ]
                        }),
                        renderSkinTone && this.renderSkinToneButton()
                    ]
                })
            ]
        });
    }
    renderSearchResults() {
        const { searchResults: searchResults  } = this.state;
        if (!searchResults) return null;
        return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
            class: "category",
            ref: this.refs.search,
            children: [
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                    class: `sticky padding-small align-${this.dir[0]}`,
                    children: ($7adb23b0109cc36a$export$dbe3113d60765c1a).categories.search
                }),
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                    children: !searchResults.length ? /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                        class: `padding-small align-${this.dir[0]}`,
                        children: this.props.onAddCustomEmoji && /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("a", {
                            onClick: this.props.onAddCustomEmoji,
                            children: ($7adb23b0109cc36a$export$dbe3113d60765c1a).add_custom
                        })
                    }) : searchResults.map((row, i)=>{
                        return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                            class: "flex",
                            children: row.map((emoji, ii)=>{
                                return this.renderEmojiButton(emoji, {
                                    pos: [
                                        i,
                                        ii
                                    ],
                                    posinset: i * this.props.perLine + ii + 1,
                                    grid: searchResults
                                });
                            })
                        });
                    })
                })
            ]
        });
    }
    renderCategories() {
        const { categories: categories  } = ($7adb23b0109cc36a$export$2d0294657ab35f1b);
        const hidden = !!this.state.searchResults;
        const perLine = this.getPerLine();
        return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
            style: {
                visibility: hidden ? "hidden" : undefined,
                display: hidden ? "none" : undefined,
                height: "100%"
            },
            children: categories.map((category)=>{
                const { root: root , rows: rows  } = this.refs.categories.get(category.id);
                return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                    "data-id": category.target ? category.target.id : category.id,
                    class: "category",
                    ref: root,
                    children: [
                        /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                            class: `sticky padding-small align-${this.dir[0]}`,
                            children: category.name || ($7adb23b0109cc36a$export$dbe3113d60765c1a).categories[category.id]
                        }),
                        /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                            class: "relative",
                            style: {
                                height: rows.length * this.props.emojiButtonSize
                            },
                            children: rows.map((row, i)=>{
                                const targetRow = row.index - row.index % $89bd6bb200cc8fef$var$Performance.rowsPerRender;
                                const visible = this.state.visibleRows[targetRow];
                                const ref = "current" in row ? row : undefined;
                                if (!visible && !ref) return null;
                                const start = i * perLine;
                                const end = start + perLine;
                                const emojiIds = category.emojis.slice(start, end);
                                if (emojiIds.length < perLine) emojiIds.push(...new Array(perLine - emojiIds.length));
                                return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                                    "data-index": row.index,
                                    ref: ref,
                                    class: "flex row",
                                    style: {
                                        top: i * this.props.emojiButtonSize
                                    },
                                    children: visible && emojiIds.map((emojiId, ii)=>{
                                        if (!emojiId) return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                                            style: {
                                                width: this.props.emojiButtonSize,
                                                height: this.props.emojiButtonSize
                                            }
                                        });
                                        const emoji = ($c4d155af13ad4d4b$export$2e2bcd8739ae039).get(emojiId);
                                        return this.renderEmojiButton(emoji, {
                                            pos: [
                                                row.index,
                                                ii
                                            ],
                                            posinset: row.posinset + ii,
                                            grid: this.grid
                                        });
                                    })
                                }, row.index);
                            })
                        })
                    ]
                });
            })
        });
    }
    renderSkinToneButton() {
        if (this.props.skinTonePosition == "none") return null;
        return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
            class: "flex flex-auto flex-center flex-middle",
            style: {
                position: "relative",
                width: this.props.emojiButtonSize,
                height: this.props.emojiButtonSize
            },
            children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("button", {
                type: "button",
                ref: this.refs.skinToneButton,
                class: "skin-tone-button flex flex-auto flex-center flex-middle",
                "aria-selected": this.state.showSkins ? "" : undefined,
                "aria-label": ($7adb23b0109cc36a$export$dbe3113d60765c1a).skins.choose,
                title: ($7adb23b0109cc36a$export$dbe3113d60765c1a).skins.choose,
                onClick: this.openSkins,
                style: {
                    width: this.props.emojiSize,
                    height: this.props.emojiSize
                },
                children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
                    class: `skin-tone skin-tone-${this.state.skin}`
                })
            })
        });
    }
    renderLiveRegion() {
        const emoji = this.getEmojiByPos(this.state.pos);
        const contents = emoji ? emoji.name : "";
        return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
            "aria-live": "polite",
            class: "sr-only",
            children: contents
        });
    }
    renderSkins() {
        const skinToneButton = this.refs.skinToneButton.current;
        const skinToneButtonRect = skinToneButton.getBoundingClientRect();
        const baseRect = this.base.getBoundingClientRect();
        const position = {};
        if (this.dir == "ltr") position.right = baseRect.right - skinToneButtonRect.right - 3;
        else position.left = skinToneButtonRect.left - baseRect.left - 3;
        if (this.props.previewPosition == "bottom" && this.props.skinTonePosition == "preview") position.bottom = baseRect.bottom - skinToneButtonRect.top + 6;
        else {
            position.top = skinToneButtonRect.bottom - baseRect.top + 3;
            position.bottom = "auto";
        }
        return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
            ref: this.refs.menu,
            role: "radiogroup",
            dir: this.dir,
            "aria-label": ($7adb23b0109cc36a$export$dbe3113d60765c1a).skins.choose,
            class: "menu hidden",
            "data-position": position.top ? "top" : "bottom",
            style: position,
            children: [
                ...Array(6).keys()
            ].map((i)=>{
                const skin = i + 1;
                const checked = this.state.skin == skin;
                return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                    children: [
                        /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("input", {
                            type: "radio",
                            name: "skin-tone",
                            value: skin,
                            "aria-label": ($7adb23b0109cc36a$export$dbe3113d60765c1a).skins[skin],
                            ref: checked ? this.refs.skinToneRadio : null,
                            defaultChecked: checked,
                            onChange: ()=>this.handleSkinMouseOver(skin),
                            onKeyDown: (e)=>{
                                if (e.code == "Enter" || e.code == "Space" || e.code == "Tab") {
                                    e.preventDefault();
                                    this.handleSkinClick(skin);
                                }
                            }
                        }),
                        /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("button", {
                            "aria-hidden": "true",
                            tabindex: "-1",
                            onClick: ()=>this.handleSkinClick(skin),
                            onMouseEnter: ()=>this.handleSkinMouseOver(skin),
                            onMouseLeave: ()=>this.handleSkinMouseOver(),
                            class: "option flex flex-grow flex-middle",
                            children: [
                                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
                                    class: `skin-tone skin-tone-${skin}`
                                }),
                                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
                                    class: "margin-small-lr",
                                    children: ($7adb23b0109cc36a$export$dbe3113d60765c1a).skins[skin]
                                })
                            ]
                        })
                    ]
                });
            })
        });
    }
    render() {
        const lineWidth = this.props.perLine * this.props.emojiButtonSize;
        return /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("section", {
            id: "root",
            class: "flex flex-column",
            dir: this.dir,
            style: {
                width: this.props.dynamicWidth ? "100%" : `calc(${lineWidth}px + (var(--padding) + var(--sidebar-width)))`
            },
            "data-emoji-set": this.props.set,
            "data-theme": this.state.theme,
            "data-menu": this.state.showSkins ? "" : undefined,
            children: [
                this.props.previewPosition == "top" && this.renderPreview(),
                this.props.navPosition == "top" && this.renderNav(),
                this.props.searchPosition == "sticky" && /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                    class: "padding-lr",
                    children: this.renderSearch()
                }),
                /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                    ref: this.refs.scroll,
                    class: "scroll flex-grow padding-lr",
                    children: /*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                        style: {
                            width: this.props.dynamicWidth ? "100%" : lineWidth,
                            height: "100%"
                        },
                        children: [
                            this.props.searchPosition == "static" && this.renderSearch(),
                            this.renderSearchResults(),
                            this.renderCategories()
                        ]
                    })
                }),
                this.props.navPosition == "bottom" && this.renderNav(),
                this.props.previewPosition == "bottom" && this.renderPreview(),
                this.state.showSkins && this.renderSkins(),
                this.renderLiveRegion()
            ]
        });
    }
    constructor(props){
        super();
        ($c770c458706daa72$export$2e2bcd8739ae039)(this, "darkMediaCallback", ()=>{
            if (this.props.theme != "auto") return;
            this.setState({
                theme: this.darkMedia.matches ? "dark" : "light"
            });
        });
        ($c770c458706daa72$export$2e2bcd8739ae039)(this, "handleClickOutside", (e)=>{
            const { element: element  } = this.props;
            if (e.target != element) {
                if (this.state.showSkins) this.closeSkins();
                if (this.props.onClickOutside) this.props.onClickOutside(e);
            }
        });
        ($c770c458706daa72$export$2e2bcd8739ae039)(this, "handleBaseClick", (e)=>{
            if (!this.state.showSkins) return;
            if (!e.target.closest(".menu")) {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.closeSkins();
            }
        });
        ($c770c458706daa72$export$2e2bcd8739ae039)(this, "handleBaseKeydown", (e)=>{
            if (!this.state.showSkins) return;
            if (e.key == "Escape") {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.closeSkins();
            }
        });
        ($c770c458706daa72$export$2e2bcd8739ae039)(this, "handleSearchClick", ()=>{
            const emoji = this.getEmojiByPos(this.state.pos);
            if (!emoji) return;
            this.setState({
                pos: [
                    -1,
                    -1
                ]
            });
        });
        ($c770c458706daa72$export$2e2bcd8739ae039)(this, "handleSearchInput", async ()=>{
            const input = this.refs.searchInput.current;
            if (!input) return;
            const { value: value  } = input;
            const searchResults = await ($c4d155af13ad4d4b$export$2e2bcd8739ae039).search(value);
            const afterRender = ()=>{
                if (!this.refs.scroll.current) return;
                this.refs.scroll.current.scrollTop = 0;
            };
            if (!searchResults) return this.setState({
                searchResults: searchResults,
                pos: [
                    -1,
                    -1
                ]
            }, afterRender);
            const pos = input.selectionStart == input.value.length ? [
                0,
                0
            ] : [
                -1,
                -1
            ];
            const grid = [];
            grid.setsize = searchResults.length;
            let row = null;
            for (let emoji of searchResults){
                if (!grid.length || row.length == this.getPerLine()) {
                    row = [];
                    row.__categoryId = "search";
                    row.__index = grid.length;
                    grid.push(row);
                }
                row.push(emoji);
            }
            this.ignoreMouse();
            this.setState({
                searchResults: grid,
                pos: pos
            }, afterRender);
        });
        ($c770c458706daa72$export$2e2bcd8739ae039)(this, "handleSearchKeyDown", (e)=>{
            // const specialKey = e.altKey || e.ctrlKey || e.metaKey
            const input = e.currentTarget;
            e.stopImmediatePropagation();
            switch(e.key){
                case "ArrowLeft":
                    // if (specialKey) return
                    // e.preventDefault()
                    this.navigate({
                        e: e,
                        input: input,
                        left: true
                    });
                    break;
                case "ArrowRight":
                    // if (specialKey) return
                    // e.preventDefault()
                    this.navigate({
                        e: e,
                        input: input,
                        right: true
                    });
                    break;
                case "ArrowUp":
                    // if (specialKey) return
                    // e.preventDefault()
                    this.navigate({
                        e: e,
                        input: input,
                        up: true
                    });
                    break;
                case "ArrowDown":
                    // if (specialKey) return
                    // e.preventDefault()
                    this.navigate({
                        e: e,
                        input: input,
                        down: true
                    });
                    break;
                case "Enter":
                    e.preventDefault();
                    this.handleEmojiClick({
                        e: e,
                        pos: this.state.pos
                    });
                    break;
                case "Escape":
                    e.preventDefault();
                    if (this.state.searchResults) this.clearSearch();
                    else this.unfocusSearch();
                    break;
            }
        });
        ($c770c458706daa72$export$2e2bcd8739ae039)(this, "clearSearch", ()=>{
            const input = this.refs.searchInput.current;
            if (!input) return;
            input.value = "";
            input.focus();
            this.handleSearchInput();
        });
        ($c770c458706daa72$export$2e2bcd8739ae039)(this, "handleCategoryClick", ({ category: category , i: i  })=>{
            this.scrollTo(i == 0 ? {
                row: -1
            } : {
                categoryId: category.id
            });
        });
        ($c770c458706daa72$export$2e2bcd8739ae039)(this, "openSkins", (e)=>{
            const { currentTarget: currentTarget  } = e;
            const rect = currentTarget.getBoundingClientRect();
            this.setState({
                showSkins: rect
            }, async ()=>{
                // Firefox requires 2 frames for the transition to consistenly work
                await ($693b183b0a78708f$export$e772c8ff12451969)(2);
                const menu = this.refs.menu.current;
                if (!menu) return;
                menu.classList.remove("hidden");
                this.refs.skinToneRadio.current.focus();
                this.base.addEventListener("click", this.handleBaseClick, true);
                this.base.addEventListener("keydown", this.handleBaseKeydown, true);
            });
        });
        this.observers = [];
        this.state = {
            pos: [
                -1,
                -1
            ],
            perLine: this.initDynamicPerLine(props),
            visibleRows: {
                0: true
            },
            ...this.getInitialState(props)
        };
    }
}









class $efa000751917694d$export$2e2bcd8739ae039 extends ($26f27c338a96b1a6$export$2e2bcd8739ae039) {
    async connectedCallback() {
        const props = ($7adb23b0109cc36a$export$75fe5f91d452f94b)(this.props, ($b247ea80b67298d5$export$2e2bcd8739ae039), this);
        props.element = this;
        props.ref = (component)=>{
            this.component = component;
        };
        await ($7adb23b0109cc36a$export$2cd8252107eb640b)(props);
        if (this.disconnected) return;
        ($fb96b826c0c5f37a$export$b3890eb0ae9dca99)(/*#__PURE__*/ ($bd9dd35321b03dd4$export$34b9dba7ce09269b)(($89bd6bb200cc8fef$export$2e2bcd8739ae039), {
            ...props
        }), this.shadowRoot);
    }
    constructor(props){
        super(props, {
            styles: ((/*@__PURE__*/$parcel$interopDefault($329d53ba9fd7125f$exports)))
        });
    }
}
($c770c458706daa72$export$2e2bcd8739ae039)($efa000751917694d$export$2e2bcd8739ae039, "Props", ($b247ea80b67298d5$export$2e2bcd8739ae039));
if (typeof customElements !== "undefined" && !customElements.get("em-emoji-picker")) customElements.define("em-emoji-picker", $efa000751917694d$export$2e2bcd8739ae039);


var $329d53ba9fd7125f$exports = {};
$329d53ba9fd7125f$exports = ":host {\n  width: min-content;\n  height: 435px;\n  min-height: 230px;\n  border-radius: var(--border-radius);\n  box-shadow: var(--shadow);\n  --border-radius: 10px;\n  --category-icon-size: 18px;\n  --font-family: -apple-system, BlinkMacSystemFont, \"Helvetica Neue\", sans-serif;\n  --font-size: 15px;\n  --preview-placeholder-size: 21px;\n  --preview-title-size: 1.1em;\n  --preview-subtitle-size: .9em;\n  --shadow-color: 0deg 0% 0%;\n  --shadow: .3px .5px 2.7px hsl(var(--shadow-color) / .14), .4px .8px 1px -3.2px hsl(var(--shadow-color) / .14), 1px 2px 2.5px -4.5px hsl(var(--shadow-color) / .14);\n  display: flex;\n}\n\n[data-theme=\"light\"] {\n  --em-rgb-color: var(--rgb-color, 34, 36, 39);\n  --em-rgb-accent: var(--rgb-accent, 34, 102, 237);\n  --em-rgb-background: var(--rgb-background, 255, 255, 255);\n  --em-rgb-input: var(--rgb-input, 255, 255, 255);\n  --em-color-border: var(--color-border, rgba(0, 0, 0, .05));\n  --em-color-border-over: var(--color-border-over, rgba(0, 0, 0, .1));\n}\n\n[data-theme=\"dark\"] {\n  --em-rgb-color: var(--rgb-color, 222, 222, 221);\n  --em-rgb-accent: var(--rgb-accent, 58, 130, 247);\n  --em-rgb-background: var(--rgb-background, 21, 22, 23);\n  --em-rgb-input: var(--rgb-input, 0, 0, 0);\n  --em-color-border: var(--color-border, rgba(255, 255, 255, .1));\n  --em-color-border-over: var(--color-border-over, rgba(255, 255, 255, .2));\n}\n\n#root {\n  --color-a: rgb(var(--em-rgb-color));\n  --color-b: rgba(var(--em-rgb-color), .65);\n  --color-c: rgba(var(--em-rgb-color), .45);\n  --padding: 12px;\n  --padding-small: calc(var(--padding) / 2);\n  --sidebar-width: 16px;\n  --duration: 225ms;\n  --duration-fast: 125ms;\n  --duration-instant: 50ms;\n  --easing: cubic-bezier(.4, 0, .2, 1);\n  width: 100%;\n  text-align: left;\n  border-radius: var(--border-radius);\n  background-color: rgb(var(--em-rgb-background));\n  position: relative;\n}\n\n@media (prefers-reduced-motion) {\n  #root {\n    --duration: 0;\n    --duration-fast: 0;\n    --duration-instant: 0;\n  }\n}\n\n#root[data-menu] button {\n  cursor: auto;\n}\n\n#root[data-menu] .menu button {\n  cursor: pointer;\n}\n\n:host, #root, input, button {\n  color: rgb(var(--em-rgb-color));\n  font-family: var(--font-family);\n  font-size: var(--font-size);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: normal;\n}\n\n*, :before, :after {\n  box-sizing: border-box;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n}\n\n.relative {\n  position: relative;\n}\n\n.flex {\n  display: flex;\n}\n\n.flex-auto {\n  flex: none;\n}\n\n.flex-center {\n  justify-content: center;\n}\n\n.flex-column {\n  flex-direction: column;\n}\n\n.flex-grow {\n  flex: auto;\n}\n\n.flex-middle {\n  align-items: center;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.padding {\n  padding: var(--padding);\n}\n\n.padding-t {\n  padding-top: var(--padding);\n}\n\n.padding-lr {\n  padding-left: var(--padding);\n  padding-right: var(--padding);\n}\n\n.padding-r {\n  padding-right: var(--padding);\n}\n\n.padding-small {\n  padding: var(--padding-small);\n}\n\n.padding-small-b {\n  padding-bottom: var(--padding-small);\n}\n\n.padding-small-lr {\n  padding-left: var(--padding-small);\n  padding-right: var(--padding-small);\n}\n\n.margin {\n  margin: var(--padding);\n}\n\n.margin-r {\n  margin-right: var(--padding);\n}\n\n.margin-l {\n  margin-left: var(--padding);\n}\n\n.margin-small-l {\n  margin-left: var(--padding-small);\n}\n\n.margin-small-lr {\n  margin-left: var(--padding-small);\n  margin-right: var(--padding-small);\n}\n\n.align-l {\n  text-align: left;\n}\n\n.align-r {\n  text-align: right;\n}\n\n.color-a {\n  color: var(--color-a);\n}\n\n.color-b {\n  color: var(--color-b);\n}\n\n.color-c {\n  color: var(--color-c);\n}\n\n.ellipsis {\n  white-space: nowrap;\n  max-width: 100%;\n  width: auto;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.sr-only {\n  width: 1px;\n  height: 1px;\n  position: absolute;\n  top: auto;\n  left: -10000px;\n  overflow: hidden;\n}\n\na {\n  cursor: pointer;\n  color: rgb(var(--em-rgb-accent));\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n.spacer {\n  height: 10px;\n}\n\n[dir=\"rtl\"] .scroll {\n  padding-left: 0;\n  padding-right: var(--padding);\n}\n\n.scroll {\n  padding-right: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.scroll::-webkit-scrollbar {\n  width: var(--sidebar-width);\n  height: var(--sidebar-width);\n}\n\n.scroll::-webkit-scrollbar-track {\n  border: 0;\n}\n\n.scroll::-webkit-scrollbar-button {\n  width: 0;\n  height: 0;\n  display: none;\n}\n\n.scroll::-webkit-scrollbar-corner {\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.scroll::-webkit-scrollbar-thumb {\n  min-height: 20%;\n  min-height: 65px;\n  border: 4px solid rgb(var(--em-rgb-background));\n  border-radius: 8px;\n}\n\n.scroll::-webkit-scrollbar-thumb:hover {\n  background-color: var(--em-color-border-over) !important;\n}\n\n.scroll:hover::-webkit-scrollbar-thumb {\n  background-color: var(--em-color-border);\n}\n\n.sticky {\n  z-index: 1;\n  background-color: rgba(var(--em-rgb-background), .9);\n  -webkit-backdrop-filter: blur(4px);\n  backdrop-filter: blur(4px);\n  font-weight: 500;\n  position: sticky;\n  top: -1px;\n}\n\n[dir=\"rtl\"] .search input[type=\"search\"] {\n  padding: 10px 2.2em 10px 2em;\n}\n\n[dir=\"rtl\"] .search .loupe {\n  left: auto;\n  right: .7em;\n}\n\n[dir=\"rtl\"] .search .delete {\n  left: .7em;\n  right: auto;\n}\n\n.search {\n  z-index: 2;\n  position: relative;\n}\n\n.search input, .search button {\n  font-size: calc(var(--font-size)  - 1px);\n}\n\n.search input[type=\"search\"] {\n  width: 100%;\n  background-color: var(--em-color-border);\n  transition-duration: var(--duration);\n  transition-property: background-color, box-shadow;\n  transition-timing-function: var(--easing);\n  border: 0;\n  border-radius: 10px;\n  outline: 0;\n  padding: 10px 2em 10px 2.2em;\n  display: block;\n}\n\n.search input[type=\"search\"]::-ms-input-placeholder {\n  color: inherit;\n  opacity: .6;\n}\n\n.search input[type=\"search\"]::placeholder {\n  color: inherit;\n  opacity: .6;\n}\n\n.search input[type=\"search\"], .search input[type=\"search\"]::-webkit-search-decoration, .search input[type=\"search\"]::-webkit-search-cancel-button, .search input[type=\"search\"]::-webkit-search-results-button, .search input[type=\"search\"]::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n}\n\n.search input[type=\"search\"]:focus {\n  background-color: rgb(var(--em-rgb-input));\n  box-shadow: inset 0 0 0 1px rgb(var(--em-rgb-accent)), 0 1px 3px rgba(65, 69, 73, .2);\n}\n\n.search .icon {\n  z-index: 1;\n  color: rgba(var(--em-rgb-color), .7);\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.search .loupe {\n  pointer-events: none;\n  left: .7em;\n}\n\n.search .delete {\n  right: .7em;\n}\n\nsvg {\n  fill: currentColor;\n  width: 1em;\n  height: 1em;\n}\n\nbutton {\n  -webkit-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n  cursor: pointer;\n  color: currentColor;\n  background-color: rgba(0, 0, 0, 0);\n  border: 0;\n}\n\n#nav {\n  z-index: 2;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  padding-right: var(--sidebar-width);\n  position: relative;\n}\n\n#nav button {\n  color: var(--color-b);\n  transition: color var(--duration) var(--easing);\n}\n\n#nav button:hover {\n  color: var(--color-a);\n}\n\n#nav svg, #nav img {\n  width: var(--category-icon-size);\n  height: var(--category-icon-size);\n}\n\n#nav[dir=\"rtl\"] .bar {\n  left: auto;\n  right: 0;\n}\n\n#nav .bar {\n  width: 100%;\n  height: 3px;\n  background-color: rgb(var(--em-rgb-accent));\n  transition: transform var(--duration) var(--easing);\n  border-radius: 3px 3px 0 0;\n  position: absolute;\n  bottom: -12px;\n  left: 0;\n}\n\n#nav button[aria-selected] {\n  color: rgb(var(--em-rgb-accent));\n}\n\n#preview {\n  z-index: 2;\n  padding: calc(var(--padding)  + 4px) var(--padding);\n  padding-right: var(--sidebar-width);\n  position: relative;\n}\n\n#preview .preview-placeholder {\n  font-size: var(--preview-placeholder-size);\n}\n\n#preview .preview-title {\n  font-size: var(--preview-title-size);\n}\n\n#preview .preview-subtitle {\n  font-size: var(--preview-subtitle-size);\n}\n\n#nav:before, #preview:before {\n  content: \"\";\n  height: 2px;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n\n#nav[data-position=\"top\"]:before, #preview[data-position=\"top\"]:before {\n  background: linear-gradient(to bottom, var(--em-color-border), transparent);\n  top: 100%;\n}\n\n#nav[data-position=\"bottom\"]:before, #preview[data-position=\"bottom\"]:before {\n  background: linear-gradient(to top, var(--em-color-border), transparent);\n  bottom: 100%;\n}\n\n.category:last-child {\n  min-height: calc(100% + 1px);\n}\n\n.category button {\n  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, sans-serif;\n  position: relative;\n}\n\n.category button > * {\n  position: relative;\n}\n\n.category button .background {\n  opacity: 0;\n  background-color: var(--em-color-border);\n  transition: opacity var(--duration-fast) var(--easing) var(--duration-instant);\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.category button:hover .background {\n  transition-duration: var(--duration-instant);\n  transition-delay: 0s;\n}\n\n.category button[aria-selected] .background {\n  opacity: 1;\n}\n\n.category button[data-keyboard] .background {\n  transition: none;\n}\n\n.row {\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.skin-tone-button {\n  border: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 100%;\n}\n\n.skin-tone-button:hover {\n  border-color: var(--em-color-border);\n}\n\n.skin-tone-button:active .skin-tone {\n  transform: scale(.85) !important;\n}\n\n.skin-tone-button .skin-tone {\n  transition: transform var(--duration) var(--easing);\n}\n\n.skin-tone-button[aria-selected] {\n  background-color: var(--em-color-border);\n  border-top-color: rgba(0, 0, 0, .05);\n  border-bottom-color: rgba(0, 0, 0, 0);\n  border-left-width: 0;\n  border-right-width: 0;\n}\n\n.skin-tone-button[aria-selected] .skin-tone {\n  transform: scale(.9);\n}\n\n.menu {\n  z-index: 2;\n  white-space: nowrap;\n  border: 1px solid var(--em-color-border);\n  background-color: rgba(var(--em-rgb-background), .9);\n  -webkit-backdrop-filter: blur(4px);\n  backdrop-filter: blur(4px);\n  transition-property: opacity, transform;\n  transition-duration: var(--duration);\n  transition-timing-function: var(--easing);\n  border-radius: 10px;\n  padding: 4px;\n  position: absolute;\n  box-shadow: 1px 1px 5px rgba(0, 0, 0, .05);\n}\n\n.menu.hidden {\n  opacity: 0;\n}\n\n.menu[data-position=\"bottom\"] {\n  transform-origin: 100% 100%;\n}\n\n.menu[data-position=\"bottom\"].hidden {\n  transform: scale(.9)rotate(-3deg)translateY(5%);\n}\n\n.menu[data-position=\"top\"] {\n  transform-origin: 100% 0;\n}\n\n.menu[data-position=\"top\"].hidden {\n  transform: scale(.9)rotate(3deg)translateY(-5%);\n}\n\n.menu input[type=\"radio\"] {\n  clip: rect(0 0 0 0);\n  width: 1px;\n  height: 1px;\n  border: 0;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  overflow: hidden;\n}\n\n.menu input[type=\"radio\"]:checked + .option {\n  box-shadow: 0 0 0 2px rgb(var(--em-rgb-accent));\n}\n\n.option {\n  width: 100%;\n  border-radius: 6px;\n  padding: 4px 6px;\n}\n\n.option:hover {\n  color: #fff;\n  background-color: rgb(var(--em-rgb-accent));\n}\n\n.skin-tone {\n  width: 16px;\n  height: 16px;\n  border-radius: 100%;\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n}\n\n.skin-tone:after {\n  content: \"\";\n  mix-blend-mode: overlay;\n  background: linear-gradient(rgba(255, 255, 255, .2), rgba(0, 0, 0, 0));\n  border: 1px solid rgba(0, 0, 0, .8);\n  border-radius: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  box-shadow: inset 0 -2px 3px #000, inset 0 1px 2px #fff;\n}\n\n.skin-tone-1 {\n  background-color: #ffc93a;\n}\n\n.skin-tone-2 {\n  background-color: #ffdab7;\n}\n\n.skin-tone-3 {\n  background-color: #e7b98f;\n}\n\n.skin-tone-4 {\n  background-color: #c88c61;\n}\n\n.skin-tone-5 {\n  background-color: #a46134;\n}\n\n.skin-tone-6 {\n  background-color: #5d4437;\n}\n\n[data-index] {\n  justify-content: space-between;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone:after {\n  box-shadow: none;\n  border-color: rgba(0, 0, 0, .5);\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-1 {\n  background-color: #fade72;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-2 {\n  background-color: #f3dfd0;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-3 {\n  background-color: #eed3a8;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-4 {\n  background-color: #cfad8d;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-5 {\n  background-color: #a8805d;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-6 {\n  background-color: #765542;\n}\n\n[data-emoji-set=\"google\"] .skin-tone:after {\n  box-shadow: inset 0 0 2px 2px rgba(0, 0, 0, .4);\n}\n\n[data-emoji-set=\"google\"] .skin-tone-1 {\n  background-color: #f5c748;\n}\n\n[data-emoji-set=\"google\"] .skin-tone-2 {\n  background-color: #f1d5aa;\n}\n\n[data-emoji-set=\"google\"] .skin-tone-3 {\n  background-color: #d4b48d;\n}\n\n[data-emoji-set=\"google\"] .skin-tone-4 {\n  background-color: #aa876b;\n}\n\n[data-emoji-set=\"google\"] .skin-tone-5 {\n  background-color: #916544;\n}\n\n[data-emoji-set=\"google\"] .skin-tone-6 {\n  background-color: #61493f;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone:after {\n  border-color: rgba(0, 0, 0, .4);\n  box-shadow: inset 0 -2px 3px #000, inset 0 1px 4px #fff;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-1 {\n  background-color: #f5c748;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-2 {\n  background-color: #f1d5aa;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-3 {\n  background-color: #d4b48d;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-4 {\n  background-color: #aa876b;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-5 {\n  background-color: #916544;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-6 {\n  background-color: #61493f;\n}\n\n";

function $e5534fc185f7111e$export$2e2bcd8739ae039(props) {
    const ref = (useRef)(null);
    const instance = (useRef)(null);
    if (instance.current) instance.current.update(props);
    (useEffect)(()=>{
        instance.current = new ($efa000751917694d$export$2e2bcd8739ae039)({
            ...props,
            ref: ref
        });
        return ()=>{
            instance.current = null;
        };
    }, []);
    return /*#__PURE__*/ (React).createElement("div", {
        ref: ref
    });
}

var categories = [
	{
		id: "people",
		emojis: [
			"grinning",
			"smiley",
			"smile",
			"grin",
			"laughing",
			"sweat_smile",
			"rolling_on_the_floor_laughing",
			"joy",
			"slightly_smiling_face",
			"upside_down_face",
			"melting_face",
			"wink",
			"blush",
			"innocent",
			"smiling_face_with_3_hearts",
			"heart_eyes",
			"star-struck",
			"kissing_heart",
			"kissing",
			"relaxed",
			"kissing_closed_eyes",
			"kissing_smiling_eyes",
			"smiling_face_with_tear",
			"yum",
			"stuck_out_tongue",
			"stuck_out_tongue_winking_eye",
			"zany_face",
			"stuck_out_tongue_closed_eyes",
			"money_mouth_face",
			"hugging_face",
			"face_with_hand_over_mouth",
			"face_with_open_eyes_and_hand_over_mouth",
			"face_with_peeking_eye",
			"shushing_face",
			"thinking_face",
			"saluting_face",
			"zipper_mouth_face",
			"face_with_raised_eyebrow",
			"neutral_face",
			"expressionless",
			"no_mouth",
			"dotted_line_face",
			"face_in_clouds",
			"smirk",
			"unamused",
			"face_with_rolling_eyes",
			"grimacing",
			"face_exhaling",
			"lying_face",
			"shaking_face",
			"relieved",
			"pensive",
			"sleepy",
			"drooling_face",
			"sleeping",
			"mask",
			"face_with_thermometer",
			"face_with_head_bandage",
			"nauseated_face",
			"face_vomiting",
			"sneezing_face",
			"hot_face",
			"cold_face",
			"woozy_face",
			"dizzy_face",
			"face_with_spiral_eyes",
			"exploding_head",
			"face_with_cowboy_hat",
			"partying_face",
			"disguised_face",
			"sunglasses",
			"nerd_face",
			"face_with_monocle",
			"confused",
			"face_with_diagonal_mouth",
			"worried",
			"slightly_frowning_face",
			"white_frowning_face",
			"open_mouth",
			"hushed",
			"astonished",
			"flushed",
			"pleading_face",
			"face_holding_back_tears",
			"frowning",
			"anguished",
			"fearful",
			"cold_sweat",
			"disappointed_relieved",
			"cry",
			"sob",
			"scream",
			"confounded",
			"persevere",
			"disappointed",
			"sweat",
			"weary",
			"tired_face",
			"yawning_face",
			"triumph",
			"rage",
			"angry",
			"face_with_symbols_on_mouth",
			"smiling_imp",
			"imp",
			"skull",
			"skull_and_crossbones",
			"hankey",
			"clown_face",
			"japanese_ogre",
			"japanese_goblin",
			"ghost",
			"alien",
			"space_invader",
			"wave",
			"raised_back_of_hand",
			"raised_hand_with_fingers_splayed",
			"hand",
			"spock-hand",
			"rightwards_hand",
			"leftwards_hand",
			"palm_down_hand",
			"palm_up_hand",
			"leftwards_pushing_hand",
			"rightwards_pushing_hand",
			"ok_hand",
			"pinched_fingers",
			"pinching_hand",
			"v",
			"crossed_fingers",
			"hand_with_index_finger_and_thumb_crossed",
			"i_love_you_hand_sign",
			"the_horns",
			"call_me_hand",
			"point_left",
			"point_right",
			"point_up_2",
			"middle_finger",
			"point_down",
			"point_up",
			"index_pointing_at_the_viewer",
			"+1",
			"-1",
			"fist",
			"facepunch",
			"left-facing_fist",
			"right-facing_fist",
			"clap",
			"raised_hands",
			"heart_hands",
			"open_hands",
			"palms_up_together",
			"handshake",
			"pray",
			"writing_hand",
			"nail_care",
			"selfie",
			"muscle",
			"mechanical_arm",
			"mechanical_leg",
			"leg",
			"foot",
			"ear",
			"ear_with_hearing_aid",
			"nose",
			"brain",
			"anatomical_heart",
			"lungs",
			"tooth",
			"bone",
			"eyes",
			"eye",
			"tongue",
			"lips",
			"biting_lip",
			"baby",
			"child",
			"boy",
			"girl",
			"adult",
			"person_with_blond_hair",
			"man",
			"bearded_person",
			"man_with_beard",
			"woman_with_beard",
			"red_haired_man",
			"curly_haired_man",
			"white_haired_man",
			"bald_man",
			"woman",
			"red_haired_woman",
			"red_haired_person",
			"curly_haired_woman",
			"curly_haired_person",
			"white_haired_woman",
			"white_haired_person",
			"bald_woman",
			"bald_person",
			"blond-haired-woman",
			"blond-haired-man",
			"older_adult",
			"older_man",
			"older_woman",
			"person_frowning",
			"man-frowning",
			"woman-frowning",
			"person_with_pouting_face",
			"man-pouting",
			"woman-pouting",
			"no_good",
			"man-gesturing-no",
			"woman-gesturing-no",
			"ok_woman",
			"man-gesturing-ok",
			"woman-gesturing-ok",
			"information_desk_person",
			"man-tipping-hand",
			"woman-tipping-hand",
			"raising_hand",
			"man-raising-hand",
			"woman-raising-hand",
			"deaf_person",
			"deaf_man",
			"deaf_woman",
			"bow",
			"man-bowing",
			"woman-bowing",
			"face_palm",
			"man-facepalming",
			"woman-facepalming",
			"shrug",
			"man-shrugging",
			"woman-shrugging",
			"health_worker",
			"male-doctor",
			"female-doctor",
			"student",
			"male-student",
			"female-student",
			"teacher",
			"male-teacher",
			"female-teacher",
			"judge",
			"male-judge",
			"female-judge",
			"farmer",
			"male-farmer",
			"female-farmer",
			"cook",
			"male-cook",
			"female-cook",
			"mechanic",
			"male-mechanic",
			"female-mechanic",
			"factory_worker",
			"male-factory-worker",
			"female-factory-worker",
			"office_worker",
			"male-office-worker",
			"female-office-worker",
			"scientist",
			"male-scientist",
			"female-scientist",
			"technologist",
			"male-technologist",
			"female-technologist",
			"singer",
			"male-singer",
			"female-singer",
			"artist",
			"male-artist",
			"female-artist",
			"pilot",
			"male-pilot",
			"female-pilot",
			"astronaut",
			"male-astronaut",
			"female-astronaut",
			"firefighter",
			"male-firefighter",
			"female-firefighter",
			"cop",
			"male-police-officer",
			"female-police-officer",
			"sleuth_or_spy",
			"male-detective",
			"female-detective",
			"guardsman",
			"male-guard",
			"female-guard",
			"ninja",
			"construction_worker",
			"male-construction-worker",
			"female-construction-worker",
			"person_with_crown",
			"prince",
			"princess",
			"man_with_turban",
			"man-wearing-turban",
			"woman-wearing-turban",
			"man_with_gua_pi_mao",
			"person_with_headscarf",
			"person_in_tuxedo",
			"man_in_tuxedo",
			"woman_in_tuxedo",
			"bride_with_veil",
			"man_with_veil",
			"woman_with_veil",
			"pregnant_woman",
			"pregnant_man",
			"pregnant_person",
			"breast-feeding",
			"woman_feeding_baby",
			"man_feeding_baby",
			"person_feeding_baby",
			"angel",
			"santa",
			"mrs_claus",
			"mx_claus",
			"superhero",
			"male_superhero",
			"female_superhero",
			"supervillain",
			"male_supervillain",
			"female_supervillain",
			"mage",
			"male_mage",
			"female_mage",
			"fairy",
			"male_fairy",
			"female_fairy",
			"vampire",
			"male_vampire",
			"female_vampire",
			"merperson",
			"merman",
			"mermaid",
			"elf",
			"male_elf",
			"female_elf",
			"genie",
			"male_genie",
			"female_genie",
			"zombie",
			"male_zombie",
			"female_zombie",
			"troll",
			"massage",
			"man-getting-massage",
			"woman-getting-massage",
			"haircut",
			"man-getting-haircut",
			"woman-getting-haircut",
			"walking",
			"man-walking",
			"woman-walking",
			"standing_person",
			"man_standing",
			"woman_standing",
			"kneeling_person",
			"man_kneeling",
			"woman_kneeling",
			"person_with_probing_cane",
			"man_with_probing_cane",
			"woman_with_probing_cane",
			"person_in_motorized_wheelchair",
			"man_in_motorized_wheelchair",
			"woman_in_motorized_wheelchair",
			"person_in_manual_wheelchair",
			"man_in_manual_wheelchair",
			"woman_in_manual_wheelchair",
			"runner",
			"man-running",
			"woman-running",
			"dancer",
			"man_dancing",
			"man_in_business_suit_levitating",
			"dancers",
			"men-with-bunny-ears-partying",
			"women-with-bunny-ears-partying",
			"person_in_steamy_room",
			"man_in_steamy_room",
			"woman_in_steamy_room",
			"person_climbing",
			"man_climbing",
			"woman_climbing",
			"fencer",
			"horse_racing",
			"skier",
			"snowboarder",
			"golfer",
			"man-golfing",
			"woman-golfing",
			"surfer",
			"man-surfing",
			"woman-surfing",
			"rowboat",
			"man-rowing-boat",
			"woman-rowing-boat",
			"swimmer",
			"man-swimming",
			"woman-swimming",
			"person_with_ball",
			"man-bouncing-ball",
			"woman-bouncing-ball",
			"weight_lifter",
			"man-lifting-weights",
			"woman-lifting-weights",
			"bicyclist",
			"man-biking",
			"woman-biking",
			"mountain_bicyclist",
			"man-mountain-biking",
			"woman-mountain-biking",
			"person_doing_cartwheel",
			"man-cartwheeling",
			"woman-cartwheeling",
			"wrestlers",
			"man-wrestling",
			"woman-wrestling",
			"water_polo",
			"man-playing-water-polo",
			"woman-playing-water-polo",
			"handball",
			"man-playing-handball",
			"woman-playing-handball",
			"juggling",
			"man-juggling",
			"woman-juggling",
			"person_in_lotus_position",
			"man_in_lotus_position",
			"woman_in_lotus_position",
			"bath",
			"sleeping_accommodation",
			"people_holding_hands",
			"two_women_holding_hands",
			"man_and_woman_holding_hands",
			"two_men_holding_hands",
			"couplekiss",
			"woman-kiss-man",
			"man-kiss-man",
			"woman-kiss-woman",
			"couple_with_heart",
			"woman-heart-man",
			"man-heart-man",
			"woman-heart-woman",
			"family",
			"man-woman-boy",
			"man-woman-girl",
			"man-woman-girl-boy",
			"man-woman-boy-boy",
			"man-woman-girl-girl",
			"man-man-boy",
			"man-man-girl",
			"man-man-girl-boy",
			"man-man-boy-boy",
			"man-man-girl-girl",
			"woman-woman-boy",
			"woman-woman-girl",
			"woman-woman-girl-boy",
			"woman-woman-boy-boy",
			"woman-woman-girl-girl",
			"man-boy",
			"man-boy-boy",
			"man-girl",
			"man-girl-boy",
			"man-girl-girl",
			"woman-boy",
			"woman-boy-boy",
			"woman-girl",
			"woman-girl-boy",
			"woman-girl-girl",
			"speaking_head_in_silhouette",
			"bust_in_silhouette",
			"busts_in_silhouette",
			"people_hugging",
			"footprints",
			"robot_face",
			"smiley_cat",
			"smile_cat",
			"joy_cat",
			"heart_eyes_cat",
			"smirk_cat",
			"kissing_cat",
			"scream_cat",
			"crying_cat_face",
			"pouting_cat",
			"see_no_evil",
			"hear_no_evil",
			"speak_no_evil",
			"love_letter",
			"cupid",
			"gift_heart",
			"sparkling_heart",
			"heartpulse",
			"heartbeat",
			"revolving_hearts",
			"two_hearts",
			"heart_decoration",
			"heavy_heart_exclamation_mark_ornament",
			"broken_heart",
			"heart_on_fire",
			"mending_heart",
			"heart",
			"pink_heart",
			"orange_heart",
			"yellow_heart",
			"green_heart",
			"blue_heart",
			"light_blue_heart",
			"purple_heart",
			"brown_heart",
			"black_heart",
			"grey_heart",
			"white_heart",
			"kiss",
			"100",
			"anger",
			"boom",
			"dizzy",
			"sweat_drops",
			"dash",
			"hole",
			"speech_balloon",
			"eye-in-speech-bubble",
			"left_speech_bubble",
			"right_anger_bubble",
			"thought_balloon",
			"zzz"
		]
	},
	{
		id: "nature",
		emojis: [
			"monkey_face",
			"monkey",
			"gorilla",
			"orangutan",
			"dog",
			"dog2",
			"guide_dog",
			"service_dog",
			"poodle",
			"wolf",
			"fox_face",
			"raccoon",
			"cat",
			"cat2",
			"black_cat",
			"lion_face",
			"tiger",
			"tiger2",
			"leopard",
			"horse",
			"moose",
			"donkey",
			"racehorse",
			"unicorn_face",
			"zebra_face",
			"deer",
			"bison",
			"cow",
			"ox",
			"water_buffalo",
			"cow2",
			"pig",
			"pig2",
			"boar",
			"pig_nose",
			"ram",
			"sheep",
			"goat",
			"dromedary_camel",
			"camel",
			"llama",
			"giraffe_face",
			"elephant",
			"mammoth",
			"rhinoceros",
			"hippopotamus",
			"mouse",
			"mouse2",
			"rat",
			"hamster",
			"rabbit",
			"rabbit2",
			"chipmunk",
			"beaver",
			"hedgehog",
			"bat",
			"bear",
			"polar_bear",
			"koala",
			"panda_face",
			"sloth",
			"otter",
			"skunk",
			"kangaroo",
			"badger",
			"feet",
			"turkey",
			"chicken",
			"rooster",
			"hatching_chick",
			"baby_chick",
			"hatched_chick",
			"bird",
			"penguin",
			"dove_of_peace",
			"eagle",
			"duck",
			"swan",
			"owl",
			"dodo",
			"feather",
			"flamingo",
			"peacock",
			"parrot",
			"wing",
			"black_bird",
			"goose",
			"frog",
			"crocodile",
			"turtle",
			"lizard",
			"snake",
			"dragon_face",
			"dragon",
			"sauropod",
			"t-rex",
			"whale",
			"whale2",
			"dolphin",
			"seal",
			"fish",
			"tropical_fish",
			"blowfish",
			"shark",
			"octopus",
			"shell",
			"coral",
			"jellyfish",
			"snail",
			"butterfly",
			"bug",
			"ant",
			"bee",
			"beetle",
			"ladybug",
			"cricket",
			"cockroach",
			"spider",
			"spider_web",
			"scorpion",
			"mosquito",
			"fly",
			"worm",
			"microbe",
			"bouquet",
			"cherry_blossom",
			"white_flower",
			"lotus",
			"rosette",
			"rose",
			"wilted_flower",
			"hibiscus",
			"sunflower",
			"blossom",
			"tulip",
			"hyacinth",
			"seedling",
			"potted_plant",
			"evergreen_tree",
			"deciduous_tree",
			"palm_tree",
			"cactus",
			"ear_of_rice",
			"herb",
			"shamrock",
			"four_leaf_clover",
			"maple_leaf",
			"fallen_leaf",
			"leaves",
			"empty_nest",
			"nest_with_eggs",
			"mushroom"
		]
	},
	{
		id: "foods",
		emojis: [
			"grapes",
			"melon",
			"watermelon",
			"tangerine",
			"lemon",
			"banana",
			"pineapple",
			"mango",
			"apple",
			"green_apple",
			"pear",
			"peach",
			"cherries",
			"strawberry",
			"blueberries",
			"kiwifruit",
			"tomato",
			"olive",
			"coconut",
			"avocado",
			"eggplant",
			"potato",
			"carrot",
			"corn",
			"hot_pepper",
			"bell_pepper",
			"cucumber",
			"leafy_green",
			"broccoli",
			"garlic",
			"onion",
			"peanuts",
			"beans",
			"chestnut",
			"ginger_root",
			"pea_pod",
			"bread",
			"croissant",
			"baguette_bread",
			"flatbread",
			"pretzel",
			"bagel",
			"pancakes",
			"waffle",
			"cheese_wedge",
			"meat_on_bone",
			"poultry_leg",
			"cut_of_meat",
			"bacon",
			"hamburger",
			"fries",
			"pizza",
			"hotdog",
			"sandwich",
			"taco",
			"burrito",
			"tamale",
			"stuffed_flatbread",
			"falafel",
			"egg",
			"fried_egg",
			"shallow_pan_of_food",
			"stew",
			"fondue",
			"bowl_with_spoon",
			"green_salad",
			"popcorn",
			"butter",
			"salt",
			"canned_food",
			"bento",
			"rice_cracker",
			"rice_ball",
			"rice",
			"curry",
			"ramen",
			"spaghetti",
			"sweet_potato",
			"oden",
			"sushi",
			"fried_shrimp",
			"fish_cake",
			"moon_cake",
			"dango",
			"dumpling",
			"fortune_cookie",
			"takeout_box",
			"crab",
			"lobster",
			"shrimp",
			"squid",
			"oyster",
			"icecream",
			"shaved_ice",
			"ice_cream",
			"doughnut",
			"cookie",
			"birthday",
			"cake",
			"cupcake",
			"pie",
			"chocolate_bar",
			"candy",
			"lollipop",
			"custard",
			"honey_pot",
			"baby_bottle",
			"glass_of_milk",
			"coffee",
			"teapot",
			"tea",
			"sake",
			"champagne",
			"wine_glass",
			"cocktail",
			"tropical_drink",
			"beer",
			"beers",
			"clinking_glasses",
			"tumbler_glass",
			"pouring_liquid",
			"cup_with_straw",
			"bubble_tea",
			"beverage_box",
			"mate_drink",
			"ice_cube",
			"chopsticks",
			"knife_fork_plate",
			"fork_and_knife",
			"spoon",
			"hocho",
			"jar",
			"amphora"
		]
	},
	{
		id: "activity",
		emojis: [
			"jack_o_lantern",
			"christmas_tree",
			"fireworks",
			"sparkler",
			"firecracker",
			"sparkles",
			"balloon",
			"tada",
			"confetti_ball",
			"tanabata_tree",
			"bamboo",
			"dolls",
			"flags",
			"wind_chime",
			"rice_scene",
			"red_envelope",
			"ribbon",
			"gift",
			"reminder_ribbon",
			"admission_tickets",
			"ticket",
			"medal",
			"trophy",
			"sports_medal",
			"first_place_medal",
			"second_place_medal",
			"third_place_medal",
			"soccer",
			"baseball",
			"softball",
			"basketball",
			"volleyball",
			"football",
			"rugby_football",
			"tennis",
			"flying_disc",
			"bowling",
			"cricket_bat_and_ball",
			"field_hockey_stick_and_ball",
			"ice_hockey_stick_and_puck",
			"lacrosse",
			"table_tennis_paddle_and_ball",
			"badminton_racquet_and_shuttlecock",
			"boxing_glove",
			"martial_arts_uniform",
			"goal_net",
			"golf",
			"ice_skate",
			"fishing_pole_and_fish",
			"diving_mask",
			"running_shirt_with_sash",
			"ski",
			"sled",
			"curling_stone",
			"dart",
			"yo-yo",
			"kite",
			"gun",
			"8ball",
			"crystal_ball",
			"magic_wand",
			"video_game",
			"joystick",
			"slot_machine",
			"game_die",
			"jigsaw",
			"teddy_bear",
			"pinata",
			"mirror_ball",
			"nesting_dolls",
			"spades",
			"hearts",
			"diamonds",
			"clubs",
			"chess_pawn",
			"black_joker",
			"mahjong",
			"flower_playing_cards",
			"performing_arts",
			"frame_with_picture",
			"art",
			"thread",
			"sewing_needle",
			"yarn",
			"knot"
		]
	},
	{
		id: "places",
		emojis: [
			"earth_africa",
			"earth_americas",
			"earth_asia",
			"globe_with_meridians",
			"world_map",
			"japan",
			"compass",
			"snow_capped_mountain",
			"mountain",
			"volcano",
			"mount_fuji",
			"camping",
			"beach_with_umbrella",
			"desert",
			"desert_island",
			"national_park",
			"stadium",
			"classical_building",
			"building_construction",
			"bricks",
			"rock",
			"wood",
			"hut",
			"house_buildings",
			"derelict_house_building",
			"house",
			"house_with_garden",
			"office",
			"post_office",
			"european_post_office",
			"hospital",
			"bank",
			"hotel",
			"love_hotel",
			"convenience_store",
			"school",
			"department_store",
			"factory",
			"japanese_castle",
			"european_castle",
			"wedding",
			"tokyo_tower",
			"statue_of_liberty",
			"church",
			"mosque",
			"hindu_temple",
			"synagogue",
			"shinto_shrine",
			"kaaba",
			"fountain",
			"tent",
			"foggy",
			"night_with_stars",
			"cityscape",
			"sunrise_over_mountains",
			"sunrise",
			"city_sunset",
			"city_sunrise",
			"bridge_at_night",
			"hotsprings",
			"carousel_horse",
			"playground_slide",
			"ferris_wheel",
			"roller_coaster",
			"barber",
			"circus_tent",
			"steam_locomotive",
			"railway_car",
			"bullettrain_side",
			"bullettrain_front",
			"train2",
			"metro",
			"light_rail",
			"station",
			"tram",
			"monorail",
			"mountain_railway",
			"train",
			"bus",
			"oncoming_bus",
			"trolleybus",
			"minibus",
			"ambulance",
			"fire_engine",
			"police_car",
			"oncoming_police_car",
			"taxi",
			"oncoming_taxi",
			"car",
			"oncoming_automobile",
			"blue_car",
			"pickup_truck",
			"truck",
			"articulated_lorry",
			"tractor",
			"racing_car",
			"racing_motorcycle",
			"motor_scooter",
			"manual_wheelchair",
			"motorized_wheelchair",
			"auto_rickshaw",
			"bike",
			"scooter",
			"skateboard",
			"roller_skate",
			"busstop",
			"motorway",
			"railway_track",
			"oil_drum",
			"fuelpump",
			"wheel",
			"rotating_light",
			"traffic_light",
			"vertical_traffic_light",
			"octagonal_sign",
			"construction",
			"anchor",
			"ring_buoy",
			"boat",
			"canoe",
			"speedboat",
			"passenger_ship",
			"ferry",
			"motor_boat",
			"ship",
			"airplane",
			"small_airplane",
			"airplane_departure",
			"airplane_arriving",
			"parachute",
			"seat",
			"helicopter",
			"suspension_railway",
			"mountain_cableway",
			"aerial_tramway",
			"satellite",
			"rocket",
			"flying_saucer",
			"bellhop_bell",
			"luggage",
			"hourglass",
			"hourglass_flowing_sand",
			"watch",
			"alarm_clock",
			"stopwatch",
			"timer_clock",
			"mantelpiece_clock",
			"clock12",
			"clock1230",
			"clock1",
			"clock130",
			"clock2",
			"clock230",
			"clock3",
			"clock330",
			"clock4",
			"clock430",
			"clock5",
			"clock530",
			"clock6",
			"clock630",
			"clock7",
			"clock730",
			"clock8",
			"clock830",
			"clock9",
			"clock930",
			"clock10",
			"clock1030",
			"clock11",
			"clock1130",
			"new_moon",
			"waxing_crescent_moon",
			"first_quarter_moon",
			"moon",
			"full_moon",
			"waning_gibbous_moon",
			"last_quarter_moon",
			"waning_crescent_moon",
			"crescent_moon",
			"new_moon_with_face",
			"first_quarter_moon_with_face",
			"last_quarter_moon_with_face",
			"thermometer",
			"sunny",
			"full_moon_with_face",
			"sun_with_face",
			"ringed_planet",
			"star",
			"star2",
			"stars",
			"milky_way",
			"cloud",
			"partly_sunny",
			"thunder_cloud_and_rain",
			"mostly_sunny",
			"barely_sunny",
			"partly_sunny_rain",
			"rain_cloud",
			"snow_cloud",
			"lightning",
			"tornado",
			"fog",
			"wind_blowing_face",
			"cyclone",
			"rainbow",
			"closed_umbrella",
			"umbrella",
			"umbrella_with_rain_drops",
			"umbrella_on_ground",
			"zap",
			"snowflake",
			"snowman",
			"snowman_without_snow",
			"comet",
			"fire",
			"droplet",
			"ocean"
		]
	},
	{
		id: "objects",
		emojis: [
			"eyeglasses",
			"dark_sunglasses",
			"goggles",
			"lab_coat",
			"safety_vest",
			"necktie",
			"shirt",
			"jeans",
			"scarf",
			"gloves",
			"coat",
			"socks",
			"dress",
			"kimono",
			"sari",
			"one-piece_swimsuit",
			"briefs",
			"shorts",
			"bikini",
			"womans_clothes",
			"folding_hand_fan",
			"purse",
			"handbag",
			"pouch",
			"shopping_bags",
			"school_satchel",
			"thong_sandal",
			"mans_shoe",
			"athletic_shoe",
			"hiking_boot",
			"womans_flat_shoe",
			"high_heel",
			"sandal",
			"ballet_shoes",
			"boot",
			"hair_pick",
			"crown",
			"womans_hat",
			"tophat",
			"mortar_board",
			"billed_cap",
			"military_helmet",
			"helmet_with_white_cross",
			"prayer_beads",
			"lipstick",
			"ring",
			"gem",
			"mute",
			"speaker",
			"sound",
			"loud_sound",
			"loudspeaker",
			"mega",
			"postal_horn",
			"bell",
			"no_bell",
			"musical_score",
			"musical_note",
			"notes",
			"studio_microphone",
			"level_slider",
			"control_knobs",
			"microphone",
			"headphones",
			"radio",
			"saxophone",
			"accordion",
			"guitar",
			"musical_keyboard",
			"trumpet",
			"violin",
			"banjo",
			"drum_with_drumsticks",
			"long_drum",
			"maracas",
			"flute",
			"iphone",
			"calling",
			"phone",
			"telephone_receiver",
			"pager",
			"fax",
			"battery",
			"low_battery",
			"electric_plug",
			"computer",
			"desktop_computer",
			"printer",
			"keyboard",
			"three_button_mouse",
			"trackball",
			"minidisc",
			"floppy_disk",
			"cd",
			"dvd",
			"abacus",
			"movie_camera",
			"film_frames",
			"film_projector",
			"clapper",
			"tv",
			"camera",
			"camera_with_flash",
			"video_camera",
			"vhs",
			"mag",
			"mag_right",
			"candle",
			"bulb",
			"flashlight",
			"izakaya_lantern",
			"diya_lamp",
			"notebook_with_decorative_cover",
			"closed_book",
			"book",
			"green_book",
			"blue_book",
			"orange_book",
			"books",
			"notebook",
			"ledger",
			"page_with_curl",
			"scroll",
			"page_facing_up",
			"newspaper",
			"rolled_up_newspaper",
			"bookmark_tabs",
			"bookmark",
			"label",
			"moneybag",
			"coin",
			"yen",
			"dollar",
			"euro",
			"pound",
			"money_with_wings",
			"credit_card",
			"receipt",
			"chart",
			"email",
			"e-mail",
			"incoming_envelope",
			"envelope_with_arrow",
			"outbox_tray",
			"inbox_tray",
			"package",
			"mailbox",
			"mailbox_closed",
			"mailbox_with_mail",
			"mailbox_with_no_mail",
			"postbox",
			"ballot_box_with_ballot",
			"pencil2",
			"black_nib",
			"lower_left_fountain_pen",
			"lower_left_ballpoint_pen",
			"lower_left_paintbrush",
			"lower_left_crayon",
			"memo",
			"briefcase",
			"file_folder",
			"open_file_folder",
			"card_index_dividers",
			"date",
			"calendar",
			"spiral_note_pad",
			"spiral_calendar_pad",
			"card_index",
			"chart_with_upwards_trend",
			"chart_with_downwards_trend",
			"bar_chart",
			"clipboard",
			"pushpin",
			"round_pushpin",
			"paperclip",
			"linked_paperclips",
			"straight_ruler",
			"triangular_ruler",
			"scissors",
			"card_file_box",
			"file_cabinet",
			"wastebasket",
			"lock",
			"unlock",
			"lock_with_ink_pen",
			"closed_lock_with_key",
			"key",
			"old_key",
			"hammer",
			"axe",
			"pick",
			"hammer_and_pick",
			"hammer_and_wrench",
			"dagger_knife",
			"crossed_swords",
			"bomb",
			"boomerang",
			"bow_and_arrow",
			"shield",
			"carpentry_saw",
			"wrench",
			"screwdriver",
			"nut_and_bolt",
			"gear",
			"compression",
			"scales",
			"probing_cane",
			"link",
			"chains",
			"hook",
			"toolbox",
			"magnet",
			"ladder",
			"alembic",
			"test_tube",
			"petri_dish",
			"dna",
			"microscope",
			"telescope",
			"satellite_antenna",
			"syringe",
			"drop_of_blood",
			"pill",
			"adhesive_bandage",
			"crutch",
			"stethoscope",
			"x-ray",
			"door",
			"elevator",
			"mirror",
			"window",
			"bed",
			"couch_and_lamp",
			"chair",
			"toilet",
			"plunger",
			"shower",
			"bathtub",
			"mouse_trap",
			"razor",
			"lotion_bottle",
			"safety_pin",
			"broom",
			"basket",
			"roll_of_paper",
			"bucket",
			"soap",
			"bubbles",
			"toothbrush",
			"sponge",
			"fire_extinguisher",
			"shopping_trolley",
			"smoking",
			"coffin",
			"headstone",
			"funeral_urn",
			"nazar_amulet",
			"hamsa",
			"moyai",
			"placard",
			"identification_card"
		]
	},
	{
		id: "symbols",
		emojis: [
			"atm",
			"put_litter_in_its_place",
			"potable_water",
			"wheelchair",
			"mens",
			"womens",
			"restroom",
			"baby_symbol",
			"wc",
			"passport_control",
			"customs",
			"baggage_claim",
			"left_luggage",
			"warning",
			"children_crossing",
			"no_entry",
			"no_entry_sign",
			"no_bicycles",
			"no_smoking",
			"do_not_litter",
			"non-potable_water",
			"no_pedestrians",
			"no_mobile_phones",
			"underage",
			"radioactive_sign",
			"biohazard_sign",
			"arrow_up",
			"arrow_upper_right",
			"arrow_right",
			"arrow_lower_right",
			"arrow_down",
			"arrow_lower_left",
			"arrow_left",
			"arrow_upper_left",
			"arrow_up_down",
			"left_right_arrow",
			"leftwards_arrow_with_hook",
			"arrow_right_hook",
			"arrow_heading_up",
			"arrow_heading_down",
			"arrows_clockwise",
			"arrows_counterclockwise",
			"back",
			"end",
			"on",
			"soon",
			"top",
			"place_of_worship",
			"atom_symbol",
			"om_symbol",
			"star_of_david",
			"wheel_of_dharma",
			"yin_yang",
			"latin_cross",
			"orthodox_cross",
			"star_and_crescent",
			"peace_symbol",
			"menorah_with_nine_branches",
			"six_pointed_star",
			"khanda",
			"aries",
			"taurus",
			"gemini",
			"cancer",
			"leo",
			"virgo",
			"libra",
			"scorpius",
			"sagittarius",
			"capricorn",
			"aquarius",
			"pisces",
			"ophiuchus",
			"twisted_rightwards_arrows",
			"repeat",
			"repeat_one",
			"arrow_forward",
			"fast_forward",
			"black_right_pointing_double_triangle_with_vertical_bar",
			"black_right_pointing_triangle_with_double_vertical_bar",
			"arrow_backward",
			"rewind",
			"black_left_pointing_double_triangle_with_vertical_bar",
			"arrow_up_small",
			"arrow_double_up",
			"arrow_down_small",
			"arrow_double_down",
			"double_vertical_bar",
			"black_square_for_stop",
			"black_circle_for_record",
			"eject",
			"cinema",
			"low_brightness",
			"high_brightness",
			"signal_strength",
			"wireless",
			"vibration_mode",
			"mobile_phone_off",
			"female_sign",
			"male_sign",
			"transgender_symbol",
			"heavy_multiplication_x",
			"heavy_plus_sign",
			"heavy_minus_sign",
			"heavy_division_sign",
			"heavy_equals_sign",
			"infinity",
			"bangbang",
			"interrobang",
			"question",
			"grey_question",
			"grey_exclamation",
			"exclamation",
			"wavy_dash",
			"currency_exchange",
			"heavy_dollar_sign",
			"medical_symbol",
			"recycle",
			"fleur_de_lis",
			"trident",
			"name_badge",
			"beginner",
			"o",
			"white_check_mark",
			"ballot_box_with_check",
			"heavy_check_mark",
			"x",
			"negative_squared_cross_mark",
			"curly_loop",
			"loop",
			"part_alternation_mark",
			"eight_spoked_asterisk",
			"eight_pointed_black_star",
			"sparkle",
			"copyright",
			"registered",
			"tm",
			"hash",
			"keycap_star",
			"zero",
			"one",
			"two",
			"three",
			"four",
			"five",
			"six",
			"seven",
			"eight",
			"nine",
			"keycap_ten",
			"capital_abcd",
			"abcd",
			"1234",
			"symbols",
			"abc",
			"a",
			"ab",
			"b",
			"cl",
			"cool",
			"free",
			"information_source",
			"id",
			"m",
			"new",
			"ng",
			"o2",
			"ok",
			"parking",
			"sos",
			"up",
			"vs",
			"koko",
			"sa",
			"u6708",
			"u6709",
			"u6307",
			"ideograph_advantage",
			"u5272",
			"u7121",
			"u7981",
			"accept",
			"u7533",
			"u5408",
			"u7a7a",
			"congratulations",
			"secret",
			"u55b6",
			"u6e80",
			"red_circle",
			"large_orange_circle",
			"large_yellow_circle",
			"large_green_circle",
			"large_blue_circle",
			"large_purple_circle",
			"large_brown_circle",
			"black_circle",
			"white_circle",
			"large_red_square",
			"large_orange_square",
			"large_yellow_square",
			"large_green_square",
			"large_blue_square",
			"large_purple_square",
			"large_brown_square",
			"black_large_square",
			"white_large_square",
			"black_medium_square",
			"white_medium_square",
			"black_medium_small_square",
			"white_medium_small_square",
			"black_small_square",
			"white_small_square",
			"large_orange_diamond",
			"large_blue_diamond",
			"small_orange_diamond",
			"small_blue_diamond",
			"small_red_triangle",
			"small_red_triangle_down",
			"diamond_shape_with_a_dot_inside",
			"radio_button",
			"white_square_button",
			"black_square_button"
		]
	},
	{
		id: "flags",
		emojis: [
			"checkered_flag",
			"cn",
			"crossed_flags",
			"de",
			"es",
			"flag-ac",
			"flag-ad",
			"flag-ae",
			"flag-af",
			"flag-ag",
			"flag-ai",
			"flag-al",
			"flag-am",
			"flag-ao",
			"flag-aq",
			"flag-ar",
			"flag-as",
			"flag-at",
			"flag-au",
			"flag-aw",
			"flag-ax",
			"flag-az",
			"flag-ba",
			"flag-bb",
			"flag-bd",
			"flag-be",
			"flag-bf",
			"flag-bg",
			"flag-bh",
			"flag-bi",
			"flag-bj",
			"flag-bl",
			"flag-bm",
			"flag-bn",
			"flag-bo",
			"flag-bq",
			"flag-br",
			"flag-bs",
			"flag-bt",
			"flag-bv",
			"flag-bw",
			"flag-by",
			"flag-bz",
			"flag-ca",
			"flag-cc",
			"flag-cd",
			"flag-cf",
			"flag-cg",
			"flag-ch",
			"flag-ci",
			"flag-ck",
			"flag-cl",
			"flag-cm",
			"flag-co",
			"flag-cp",
			"flag-cr",
			"flag-cu",
			"flag-cv",
			"flag-cw",
			"flag-cx",
			"flag-cy",
			"flag-cz",
			"flag-dg",
			"flag-dj",
			"flag-dk",
			"flag-dm",
			"flag-do",
			"flag-dz",
			"flag-ea",
			"flag-ec",
			"flag-ee",
			"flag-eg",
			"flag-eh",
			"flag-england",
			"flag-er",
			"flag-et",
			"flag-eu",
			"flag-fi",
			"flag-fj",
			"flag-fk",
			"flag-fm",
			"flag-fo",
			"flag-ga",
			"flag-gd",
			"flag-ge",
			"flag-gf",
			"flag-gg",
			"flag-gh",
			"flag-gi",
			"flag-gl",
			"flag-gm",
			"flag-gn",
			"flag-gp",
			"flag-gq",
			"flag-gr",
			"flag-gs",
			"flag-gt",
			"flag-gu",
			"flag-gw",
			"flag-gy",
			"flag-hk",
			"flag-hm",
			"flag-hn",
			"flag-hr",
			"flag-ht",
			"flag-hu",
			"flag-ic",
			"flag-id",
			"flag-ie",
			"flag-il",
			"flag-im",
			"flag-in",
			"flag-io",
			"flag-iq",
			"flag-ir",
			"flag-is",
			"flag-je",
			"flag-jm",
			"flag-jo",
			"flag-ke",
			"flag-kg",
			"flag-kh",
			"flag-ki",
			"flag-km",
			"flag-kn",
			"flag-kp",
			"flag-kw",
			"flag-ky",
			"flag-kz",
			"flag-la",
			"flag-lb",
			"flag-lc",
			"flag-li",
			"flag-lk",
			"flag-lr",
			"flag-ls",
			"flag-lt",
			"flag-lu",
			"flag-lv",
			"flag-ly",
			"flag-ma",
			"flag-mc",
			"flag-md",
			"flag-me",
			"flag-mf",
			"flag-mg",
			"flag-mh",
			"flag-mk",
			"flag-ml",
			"flag-mm",
			"flag-mn",
			"flag-mo",
			"flag-mp",
			"flag-mq",
			"flag-mr",
			"flag-ms",
			"flag-mt",
			"flag-mu",
			"flag-mv",
			"flag-mw",
			"flag-mx",
			"flag-my",
			"flag-mz",
			"flag-na",
			"flag-nc",
			"flag-ne",
			"flag-nf",
			"flag-ng",
			"flag-ni",
			"flag-nl",
			"flag-no",
			"flag-np",
			"flag-nr",
			"flag-nu",
			"flag-nz",
			"flag-om",
			"flag-pa",
			"flag-pe",
			"flag-pf",
			"flag-pg",
			"flag-ph",
			"flag-pk",
			"flag-pl",
			"flag-pm",
			"flag-pn",
			"flag-pr",
			"flag-ps",
			"flag-pt",
			"flag-pw",
			"flag-py",
			"flag-qa",
			"flag-re",
			"flag-ro",
			"flag-rs",
			"flag-rw",
			"flag-sa",
			"flag-sb",
			"flag-sc",
			"flag-scotland",
			"flag-sd",
			"flag-se",
			"flag-sg",
			"flag-sh",
			"flag-si",
			"flag-sj",
			"flag-sk",
			"flag-sl",
			"flag-sm",
			"flag-sn",
			"flag-so",
			"flag-sr",
			"flag-ss",
			"flag-st",
			"flag-sv",
			"flag-sx",
			"flag-sy",
			"flag-sz",
			"flag-ta",
			"flag-tc",
			"flag-td",
			"flag-tf",
			"flag-tg",
			"flag-th",
			"flag-tj",
			"flag-tk",
			"flag-tl",
			"flag-tm",
			"flag-tn",
			"flag-to",
			"flag-tr",
			"flag-tt",
			"flag-tv",
			"flag-tw",
			"flag-tz",
			"flag-ua",
			"flag-ug",
			"flag-um",
			"flag-un",
			"flag-uy",
			"flag-uz",
			"flag-va",
			"flag-vc",
			"flag-ve",
			"flag-vg",
			"flag-vi",
			"flag-vn",
			"flag-vu",
			"flag-wales",
			"flag-wf",
			"flag-ws",
			"flag-xk",
			"flag-ye",
			"flag-yt",
			"flag-za",
			"flag-zm",
			"flag-zw",
			"fr",
			"gb",
			"it",
			"jp",
			"kr",
			"pirate_flag",
			"rainbow-flag",
			"ru",
			"transgender_flag",
			"triangular_flag_on_post",
			"us",
			"waving_black_flag",
			"waving_white_flag"
		]
	}
];
var emojis = {
	"100": {
		id: "100",
		name: "Hundred Points",
		keywords: [
			"100",
			"score",
			"perfect",
			"numbers",
			"century",
			"exam",
			"quiz",
			"test",
			"pass"
		],
		skins: [
			{
				unified: "1f4af",
				native: "💯"
			}
		],
		version: 1
	},
	"1234": {
		id: "1234",
		name: "Input Numbers",
		keywords: [
			"1234",
			"blue",
			"square",
			"1",
			"2",
			"3",
			"4"
		],
		skins: [
			{
				unified: "1f522",
				native: "🔢"
			}
		],
		version: 1
	},
	grinning: {
		id: "grinning",
		name: "Grinning Face",
		emoticons: [
			":D"
		],
		keywords: [
			"smile",
			"happy",
			"joy",
			":D",
			"grin"
		],
		skins: [
			{
				unified: "1f600",
				native: "😀"
			}
		],
		version: 1
	},
	smiley: {
		id: "smiley",
		name: "Grinning Face with Big Eyes",
		emoticons: [
			":)",
			"=)",
			"=-)"
		],
		keywords: [
			"smiley",
			"happy",
			"joy",
			"haha",
			":D",
			":)",
			"smile",
			"funny"
		],
		skins: [
			{
				unified: "1f603",
				native: "😃"
			}
		],
		version: 1
	},
	smile: {
		id: "smile",
		name: "Grinning Face with Smiling Eyes",
		emoticons: [
			":)",
			"C:",
			"c:",
			":D",
			":-D"
		],
		keywords: [
			"smile",
			"happy",
			"joy",
			"funny",
			"haha",
			"laugh",
			"like",
			":D",
			":)"
		],
		skins: [
			{
				unified: "1f604",
				native: "😄"
			}
		],
		version: 1
	},
	grin: {
		id: "grin",
		name: "Beaming Face with Smiling Eyes",
		keywords: [
			"grin",
			"happy",
			"smile",
			"joy",
			"kawaii"
		],
		skins: [
			{
				unified: "1f601",
				native: "😁"
			}
		],
		version: 1
	},
	laughing: {
		id: "laughing",
		name: "Grinning Squinting Face",
		emoticons: [
			":>",
			":->"
		],
		keywords: [
			"laughing",
			"satisfied",
			"happy",
			"joy",
			"lol",
			"haha",
			"glad",
			"XD",
			"laugh"
		],
		skins: [
			{
				unified: "1f606",
				native: "😆"
			}
		],
		version: 1
	},
	sweat_smile: {
		id: "sweat_smile",
		name: "Grinning Face with Sweat",
		keywords: [
			"smile",
			"hot",
			"happy",
			"laugh",
			"relief"
		],
		skins: [
			{
				unified: "1f605",
				native: "😅"
			}
		],
		version: 1
	},
	rolling_on_the_floor_laughing: {
		id: "rolling_on_the_floor_laughing",
		name: "Rolling on the Floor Laughing",
		keywords: [
			"face",
			"lol",
			"haha",
			"rofl"
		],
		skins: [
			{
				unified: "1f923",
				native: "🤣"
			}
		],
		version: 3
	},
	joy: {
		id: "joy",
		name: "Face with Tears of Joy",
		keywords: [
			"cry",
			"weep",
			"happy",
			"happytears",
			"haha"
		],
		skins: [
			{
				unified: "1f602",
				native: "😂"
			}
		],
		version: 1
	},
	slightly_smiling_face: {
		id: "slightly_smiling_face",
		name: "Slightly Smiling Face",
		emoticons: [
			":)",
			"(:",
			":-)"
		],
		keywords: [
			"smile"
		],
		skins: [
			{
				unified: "1f642",
				native: "🙂"
			}
		],
		version: 1
	},
	upside_down_face: {
		id: "upside_down_face",
		name: "Upside-Down Face",
		keywords: [
			"upside",
			"down",
			"flipped",
			"silly",
			"smile"
		],
		skins: [
			{
				unified: "1f643",
				native: "🙃"
			}
		],
		version: 1
	},
	melting_face: {
		id: "melting_face",
		name: "Melting Face",
		keywords: [
			"hot",
			"heat"
		],
		skins: [
			{
				unified: "1fae0",
				native: "🫠"
			}
		],
		version: 14
	},
	wink: {
		id: "wink",
		name: "Winking Face",
		emoticons: [
			";)",
			";-)"
		],
		keywords: [
			"wink",
			"happy",
			"mischievous",
			"secret",
			";)",
			"smile",
			"eye"
		],
		skins: [
			{
				unified: "1f609",
				native: "😉"
			}
		],
		version: 1
	},
	blush: {
		id: "blush",
		name: "Smiling Face with Smiling Eyes",
		emoticons: [
			":)"
		],
		keywords: [
			"blush",
			"smile",
			"happy",
			"flushed",
			"crush",
			"embarrassed",
			"shy",
			"joy"
		],
		skins: [
			{
				unified: "1f60a",
				native: "😊"
			}
		],
		version: 1
	},
	innocent: {
		id: "innocent",
		name: "Smiling Face with Halo",
		keywords: [
			"innocent",
			"angel",
			"heaven"
		],
		skins: [
			{
				unified: "1f607",
				native: "😇"
			}
		],
		version: 1
	},
	smiling_face_with_3_hearts: {
		id: "smiling_face_with_3_hearts",
		name: "Smiling Face with Hearts",
		keywords: [
			"3",
			"love",
			"like",
			"affection",
			"valentines",
			"infatuation",
			"crush",
			"adore"
		],
		skins: [
			{
				unified: "1f970",
				native: "🥰"
			}
		],
		version: 11
	},
	heart_eyes: {
		id: "heart_eyes",
		name: "Smiling Face with Heart-Eyes",
		keywords: [
			"heart",
			"eyes",
			"love",
			"like",
			"affection",
			"valentines",
			"infatuation",
			"crush"
		],
		skins: [
			{
				unified: "1f60d",
				native: "😍"
			}
		],
		version: 1
	},
	"star-struck": {
		id: "star-struck",
		name: "Star-Struck",
		keywords: [
			"star",
			"struck",
			"grinning",
			"face",
			"with",
			"eyes",
			"smile",
			"starry"
		],
		skins: [
			{
				unified: "1f929",
				native: "🤩"
			}
		],
		version: 5
	},
	kissing_heart: {
		id: "kissing_heart",
		name: "Face Blowing a Kiss",
		emoticons: [
			":*",
			":-*"
		],
		keywords: [
			"kissing",
			"heart",
			"love",
			"like",
			"affection",
			"valentines",
			"infatuation"
		],
		skins: [
			{
				unified: "1f618",
				native: "😘"
			}
		],
		version: 1
	},
	kissing: {
		id: "kissing",
		name: "Kissing Face",
		keywords: [
			"love",
			"like",
			"3",
			"valentines",
			"infatuation",
			"kiss"
		],
		skins: [
			{
				unified: "1f617",
				native: "😗"
			}
		],
		version: 1
	},
	relaxed: {
		id: "relaxed",
		name: "Smiling Face",
		keywords: [
			"relaxed",
			"blush",
			"massage",
			"happiness"
		],
		skins: [
			{
				unified: "263a-fe0f",
				native: "☺️"
			}
		],
		version: 1
	},
	kissing_closed_eyes: {
		id: "kissing_closed_eyes",
		name: "Kissing Face with Closed Eyes",
		keywords: [
			"love",
			"like",
			"affection",
			"valentines",
			"infatuation",
			"kiss"
		],
		skins: [
			{
				unified: "1f61a",
				native: "😚"
			}
		],
		version: 1
	},
	kissing_smiling_eyes: {
		id: "kissing_smiling_eyes",
		name: "Kissing Face with Smiling Eyes",
		keywords: [
			"affection",
			"valentines",
			"infatuation",
			"kiss"
		],
		skins: [
			{
				unified: "1f619",
				native: "😙"
			}
		],
		version: 1
	},
	smiling_face_with_tear: {
		id: "smiling_face_with_tear",
		name: "Smiling Face with Tear",
		keywords: [
			"sad",
			"cry",
			"pretend"
		],
		skins: [
			{
				unified: "1f972",
				native: "🥲"
			}
		],
		version: 13
	},
	yum: {
		id: "yum",
		name: "Face Savoring Food",
		keywords: [
			"yum",
			"happy",
			"joy",
			"tongue",
			"smile",
			"silly",
			"yummy",
			"nom",
			"delicious",
			"savouring"
		],
		skins: [
			{
				unified: "1f60b",
				native: "😋"
			}
		],
		version: 1
	},
	stuck_out_tongue: {
		id: "stuck_out_tongue",
		name: "Face with Tongue",
		emoticons: [
			":p",
			":-p",
			":P",
			":-P",
			":b",
			":-b"
		],
		keywords: [
			"stuck",
			"out",
			"prank",
			"childish",
			"playful",
			"mischievous",
			"smile"
		],
		skins: [
			{
				unified: "1f61b",
				native: "😛"
			}
		],
		version: 1
	},
	stuck_out_tongue_winking_eye: {
		id: "stuck_out_tongue_winking_eye",
		name: "Winking Face with Tongue",
		emoticons: [
			";p",
			";-p",
			";b",
			";-b",
			";P",
			";-P"
		],
		keywords: [
			"stuck",
			"out",
			"eye",
			"prank",
			"childish",
			"playful",
			"mischievous",
			"smile",
			"wink"
		],
		skins: [
			{
				unified: "1f61c",
				native: "😜"
			}
		],
		version: 1
	},
	zany_face: {
		id: "zany_face",
		name: "Zany Face",
		keywords: [
			"grinning",
			"with",
			"one",
			"large",
			"and",
			"small",
			"eye",
			"goofy",
			"crazy"
		],
		skins: [
			{
				unified: "1f92a",
				native: "🤪"
			}
		],
		version: 5
	},
	stuck_out_tongue_closed_eyes: {
		id: "stuck_out_tongue_closed_eyes",
		name: "Squinting Face with Tongue",
		keywords: [
			"stuck",
			"out",
			"closed",
			"eyes",
			"prank",
			"playful",
			"mischievous",
			"smile"
		],
		skins: [
			{
				unified: "1f61d",
				native: "😝"
			}
		],
		version: 1
	},
	money_mouth_face: {
		id: "money_mouth_face",
		name: "Money-Mouth Face",
		keywords: [
			"money",
			"mouth",
			"rich",
			"dollar"
		],
		skins: [
			{
				unified: "1f911",
				native: "🤑"
			}
		],
		version: 1
	},
	hugging_face: {
		id: "hugging_face",
		name: "Hugging Face",
		keywords: [
			"smile",
			"hug"
		],
		skins: [
			{
				unified: "1f917",
				native: "🤗"
			}
		],
		version: 1
	},
	face_with_hand_over_mouth: {
		id: "face_with_hand_over_mouth",
		name: "Face with Hand over Mouth",
		keywords: [
			"smiling",
			"eyes",
			"and",
			"covering",
			"whoops",
			"shock",
			"surprise"
		],
		skins: [
			{
				unified: "1f92d",
				native: "🤭"
			}
		],
		version: 5
	},
	face_with_open_eyes_and_hand_over_mouth: {
		id: "face_with_open_eyes_and_hand_over_mouth",
		name: "Face with Open Eyes and Hand over Mouth",
		keywords: [
			"silence",
			"secret",
			"shock",
			"surprise"
		],
		skins: [
			{
				unified: "1fae2",
				native: "🫢"
			}
		],
		version: 14
	},
	face_with_peeking_eye: {
		id: "face_with_peeking_eye",
		name: "Face with Peeking Eye",
		keywords: [
			"scared",
			"frightening",
			"embarrassing",
			"shy"
		],
		skins: [
			{
				unified: "1fae3",
				native: "🫣"
			}
		],
		version: 14
	},
	shushing_face: {
		id: "shushing_face",
		name: "Shushing Face",
		keywords: [
			"with",
			"finger",
			"covering",
			"closed",
			"lips",
			"quiet",
			"shhh"
		],
		skins: [
			{
				unified: "1f92b",
				native: "🤫"
			}
		],
		version: 5
	},
	thinking_face: {
		id: "thinking_face",
		name: "Thinking Face",
		keywords: [
			"hmmm",
			"think",
			"consider"
		],
		skins: [
			{
				unified: "1f914",
				native: "🤔"
			}
		],
		version: 1
	},
	saluting_face: {
		id: "saluting_face",
		name: "Saluting Face",
		keywords: [
			"respect",
			"salute"
		],
		skins: [
			{
				unified: "1fae1",
				native: "🫡"
			}
		],
		version: 14
	},
	zipper_mouth_face: {
		id: "zipper_mouth_face",
		name: "Zipper-Mouth Face",
		keywords: [
			"zipper",
			"mouth",
			"sealed",
			"secret"
		],
		skins: [
			{
				unified: "1f910",
				native: "🤐"
			}
		],
		version: 1
	},
	face_with_raised_eyebrow: {
		id: "face_with_raised_eyebrow",
		name: "Face with Raised Eyebrow",
		keywords: [
			"one",
			"distrust",
			"scepticism",
			"disapproval",
			"disbelief",
			"surprise"
		],
		skins: [
			{
				unified: "1f928",
				native: "🤨"
			}
		],
		version: 5
	},
	neutral_face: {
		id: "neutral_face",
		name: "Neutral Face",
		emoticons: [
			":|",
			":-|"
		],
		keywords: [
			"indifference",
			"meh",
			":",
			""
		],
		skins: [
			{
				unified: "1f610",
				native: "😐"
			}
		],
		version: 1
	},
	expressionless: {
		id: "expressionless",
		name: "Expressionless Face",
		emoticons: [
			"-_-"
		],
		keywords: [
			"indifferent",
			"-",
			"",
			"meh",
			"deadpan"
		],
		skins: [
			{
				unified: "1f611",
				native: "😑"
			}
		],
		version: 1
	},
	no_mouth: {
		id: "no_mouth",
		name: "Face Without Mouth",
		keywords: [
			"no",
			"hellokitty"
		],
		skins: [
			{
				unified: "1f636",
				native: "😶"
			}
		],
		version: 1
	},
	dotted_line_face: {
		id: "dotted_line_face",
		name: "Dotted Line Face",
		keywords: [
			"invisible",
			"lonely",
			"isolation",
			"depression"
		],
		skins: [
			{
				unified: "1fae5",
				native: "🫥"
			}
		],
		version: 14
	},
	face_in_clouds: {
		id: "face_in_clouds",
		name: "Face in Clouds",
		keywords: [
			"shower",
			"steam",
			"dream"
		],
		skins: [
			{
				unified: "1f636-200d-1f32b-fe0f",
				native: "😶‍🌫️"
			}
		],
		version: 13.1
	},
	smirk: {
		id: "smirk",
		name: "Smirking Face",
		keywords: [
			"smirk",
			"smile",
			"mean",
			"prank",
			"smug",
			"sarcasm"
		],
		skins: [
			{
				unified: "1f60f",
				native: "😏"
			}
		],
		version: 1
	},
	unamused: {
		id: "unamused",
		name: "Unamused Face",
		emoticons: [
			":("
		],
		keywords: [
			"indifference",
			"bored",
			"straight",
			"serious",
			"sarcasm",
			"unimpressed",
			"skeptical",
			"dubious",
			"side",
			"eye"
		],
		skins: [
			{
				unified: "1f612",
				native: "😒"
			}
		],
		version: 1
	},
	face_with_rolling_eyes: {
		id: "face_with_rolling_eyes",
		name: "Face with Rolling Eyes",
		keywords: [
			"eyeroll",
			"frustrated"
		],
		skins: [
			{
				unified: "1f644",
				native: "🙄"
			}
		],
		version: 1
	},
	grimacing: {
		id: "grimacing",
		name: "Grimacing Face",
		keywords: [
			"grimace",
			"teeth"
		],
		skins: [
			{
				unified: "1f62c",
				native: "😬"
			}
		],
		version: 1
	},
	face_exhaling: {
		id: "face_exhaling",
		name: "Face Exhaling",
		keywords: [
			"relieve",
			"relief",
			"tired",
			"sigh"
		],
		skins: [
			{
				unified: "1f62e-200d-1f4a8",
				native: "😮‍💨"
			}
		],
		version: 13.1
	},
	lying_face: {
		id: "lying_face",
		name: "Lying Face",
		keywords: [
			"lie",
			"pinocchio"
		],
		skins: [
			{
				unified: "1f925",
				native: "🤥"
			}
		],
		version: 3
	},
	shaking_face: {
		id: "shaking_face",
		name: "Shaking Face",
		keywords: [
			"dizzy",
			"shock",
			"blurry",
			"earthquake"
		],
		skins: [
			{
				unified: "1fae8",
				native: "🫨"
			}
		],
		version: 15
	},
	relieved: {
		id: "relieved",
		name: "Relieved Face",
		keywords: [
			"relaxed",
			"phew",
			"massage",
			"happiness"
		],
		skins: [
			{
				unified: "1f60c",
				native: "😌"
			}
		],
		version: 1
	},
	pensive: {
		id: "pensive",
		name: "Pensive Face",
		keywords: [
			"sad",
			"depressed",
			"upset"
		],
		skins: [
			{
				unified: "1f614",
				native: "😔"
			}
		],
		version: 1
	},
	sleepy: {
		id: "sleepy",
		name: "Sleepy Face",
		keywords: [
			"tired",
			"rest",
			"nap"
		],
		skins: [
			{
				unified: "1f62a",
				native: "😪"
			}
		],
		version: 1
	},
	drooling_face: {
		id: "drooling_face",
		name: "Drooling Face",
		keywords: [
		],
		skins: [
			{
				unified: "1f924",
				native: "🤤"
			}
		],
		version: 3
	},
	sleeping: {
		id: "sleeping",
		name: "Sleeping Face",
		keywords: [
			"tired",
			"sleepy",
			"night",
			"zzz"
		],
		skins: [
			{
				unified: "1f634",
				native: "😴"
			}
		],
		version: 1
	},
	mask: {
		id: "mask",
		name: "Face with Medical Mask",
		keywords: [
			"sick",
			"ill",
			"disease",
			"covid"
		],
		skins: [
			{
				unified: "1f637",
				native: "😷"
			}
		],
		version: 1
	},
	face_with_thermometer: {
		id: "face_with_thermometer",
		name: "Face with Thermometer",
		keywords: [
			"sick",
			"temperature",
			"cold",
			"fever",
			"covid"
		],
		skins: [
			{
				unified: "1f912",
				native: "🤒"
			}
		],
		version: 1
	},
	face_with_head_bandage: {
		id: "face_with_head_bandage",
		name: "Face with Head-Bandage",
		keywords: [
			"head",
			"bandage",
			"injured",
			"clumsy",
			"hurt"
		],
		skins: [
			{
				unified: "1f915",
				native: "🤕"
			}
		],
		version: 1
	},
	nauseated_face: {
		id: "nauseated_face",
		name: "Nauseated Face",
		keywords: [
			"vomit",
			"gross",
			"green",
			"sick",
			"throw",
			"up",
			"ill"
		],
		skins: [
			{
				unified: "1f922",
				native: "🤢"
			}
		],
		version: 3
	},
	face_vomiting: {
		id: "face_vomiting",
		name: "Face Vomiting",
		keywords: [
			"with",
			"open",
			"mouth",
			"sick"
		],
		skins: [
			{
				unified: "1f92e",
				native: "🤮"
			}
		],
		version: 5
	},
	sneezing_face: {
		id: "sneezing_face",
		name: "Sneezing Face",
		keywords: [
			"gesundheit",
			"sneeze",
			"sick",
			"allergy"
		],
		skins: [
			{
				unified: "1f927",
				native: "🤧"
			}
		],
		version: 3
	},
	hot_face: {
		id: "hot_face",
		name: "Hot Face",
		keywords: [
			"feverish",
			"heat",
			"red",
			"sweating"
		],
		skins: [
			{
				unified: "1f975",
				native: "🥵"
			}
		],
		version: 11
	},
	cold_face: {
		id: "cold_face",
		name: "Cold Face",
		keywords: [
			"blue",
			"freezing",
			"frozen",
			"frostbite",
			"icicles"
		],
		skins: [
			{
				unified: "1f976",
				native: "🥶"
			}
		],
		version: 11
	},
	woozy_face: {
		id: "woozy_face",
		name: "Woozy Face",
		keywords: [
			"dizzy",
			"intoxicated",
			"tipsy",
			"wavy"
		],
		skins: [
			{
				unified: "1f974",
				native: "🥴"
			}
		],
		version: 11
	},
	dizzy_face: {
		id: "dizzy_face",
		name: "Dizzy Face",
		keywords: [
			"spent",
			"unconscious",
			"xox"
		],
		skins: [
			{
				unified: "1f635",
				native: "😵"
			}
		],
		version: 1
	},
	face_with_spiral_eyes: {
		id: "face_with_spiral_eyes",
		name: "Face with Spiral Eyes",
		keywords: [
			"sick",
			"ill",
			"confused",
			"nauseous",
			"nausea"
		],
		skins: [
			{
				unified: "1f635-200d-1f4ab",
				native: "😵‍💫"
			}
		],
		version: 13.1
	},
	exploding_head: {
		id: "exploding_head",
		name: "Exploding Head",
		keywords: [
			"shocked",
			"face",
			"with",
			"mind",
			"blown"
		],
		skins: [
			{
				unified: "1f92f",
				native: "🤯"
			}
		],
		version: 5
	},
	face_with_cowboy_hat: {
		id: "face_with_cowboy_hat",
		name: "Cowboy Hat Face",
		keywords: [
			"with",
			"cowgirl"
		],
		skins: [
			{
				unified: "1f920",
				native: "🤠"
			}
		],
		version: 3
	},
	partying_face: {
		id: "partying_face",
		name: "Partying Face",
		keywords: [
			"celebration",
			"woohoo"
		],
		skins: [
			{
				unified: "1f973",
				native: "🥳"
			}
		],
		version: 11
	},
	disguised_face: {
		id: "disguised_face",
		name: "Disguised Face",
		keywords: [
			"pretent",
			"brows",
			"glasses",
			"moustache"
		],
		skins: [
			{
				unified: "1f978",
				native: "🥸"
			}
		],
		version: 13
	},
	sunglasses: {
		id: "sunglasses",
		name: "Smiling Face with Sunglasses",
		emoticons: [
			"8)"
		],
		keywords: [
			"cool",
			"smile",
			"summer",
			"beach",
			"sunglass"
		],
		skins: [
			{
				unified: "1f60e",
				native: "😎"
			}
		],
		version: 1
	},
	nerd_face: {
		id: "nerd_face",
		name: "Nerd Face",
		keywords: [
			"nerdy",
			"geek",
			"dork"
		],
		skins: [
			{
				unified: "1f913",
				native: "🤓"
			}
		],
		version: 1
	},
	face_with_monocle: {
		id: "face_with_monocle",
		name: "Face with Monocle",
		keywords: [
			"stuffy",
			"wealthy"
		],
		skins: [
			{
				unified: "1f9d0",
				native: "🧐"
			}
		],
		version: 5
	},
	confused: {
		id: "confused",
		name: "Confused Face",
		emoticons: [
			":\\",
			":-\\",
			":/",
			":-/"
		],
		keywords: [
			"indifference",
			"huh",
			"weird",
			"hmmm",
			":/"
		],
		skins: [
			{
				unified: "1f615",
				native: "😕"
			}
		],
		version: 1
	},
	face_with_diagonal_mouth: {
		id: "face_with_diagonal_mouth",
		name: "Face with Diagonal Mouth",
		keywords: [
			"skeptic",
			"confuse",
			"frustrated",
			"indifferent"
		],
		skins: [
			{
				unified: "1fae4",
				native: "🫤"
			}
		],
		version: 14
	},
	worried: {
		id: "worried",
		name: "Worried Face",
		keywords: [
			"concern",
			"nervous",
			":("
		],
		skins: [
			{
				unified: "1f61f",
				native: "😟"
			}
		],
		version: 1
	},
	slightly_frowning_face: {
		id: "slightly_frowning_face",
		name: "Slightly Frowning Face",
		keywords: [
			"disappointed",
			"sad",
			"upset"
		],
		skins: [
			{
				unified: "1f641",
				native: "🙁"
			}
		],
		version: 1
	},
	white_frowning_face: {
		id: "white_frowning_face",
		name: "Frowning Face",
		keywords: [
			"white",
			"sad",
			"upset",
			"frown"
		],
		skins: [
			{
				unified: "2639-fe0f",
				native: "☹️"
			}
		],
		version: 1
	},
	open_mouth: {
		id: "open_mouth",
		name: "Face with Open Mouth",
		emoticons: [
			":o",
			":-o",
			":O",
			":-O"
		],
		keywords: [
			"surprise",
			"impressed",
			"wow",
			"whoa",
			":O"
		],
		skins: [
			{
				unified: "1f62e",
				native: "😮"
			}
		],
		version: 1
	},
	hushed: {
		id: "hushed",
		name: "Hushed Face",
		keywords: [
			"woo",
			"shh"
		],
		skins: [
			{
				unified: "1f62f",
				native: "😯"
			}
		],
		version: 1
	},
	astonished: {
		id: "astonished",
		name: "Astonished Face",
		keywords: [
			"xox",
			"surprised",
			"poisoned"
		],
		skins: [
			{
				unified: "1f632",
				native: "😲"
			}
		],
		version: 1
	},
	flushed: {
		id: "flushed",
		name: "Flushed Face",
		keywords: [
			"blush",
			"shy",
			"flattered"
		],
		skins: [
			{
				unified: "1f633",
				native: "😳"
			}
		],
		version: 1
	},
	pleading_face: {
		id: "pleading_face",
		name: "Pleading Face",
		keywords: [
			"begging",
			"mercy",
			"cry",
			"tears",
			"sad",
			"grievance"
		],
		skins: [
			{
				unified: "1f97a",
				native: "🥺"
			}
		],
		version: 11
	},
	face_holding_back_tears: {
		id: "face_holding_back_tears",
		name: "Face Holding Back Tears",
		keywords: [
			"touched",
			"gratitude",
			"cry"
		],
		skins: [
			{
				unified: "1f979",
				native: "🥹"
			}
		],
		version: 14
	},
	frowning: {
		id: "frowning",
		name: "Frowning Face with Open Mouth",
		keywords: [
			"aw",
			"what"
		],
		skins: [
			{
				unified: "1f626",
				native: "😦"
			}
		],
		version: 1
	},
	anguished: {
		id: "anguished",
		name: "Anguished Face",
		emoticons: [
			"D:"
		],
		keywords: [
			"stunned",
			"nervous"
		],
		skins: [
			{
				unified: "1f627",
				native: "😧"
			}
		],
		version: 1
	},
	fearful: {
		id: "fearful",
		name: "Fearful Face",
		keywords: [
			"scared",
			"terrified",
			"nervous"
		],
		skins: [
			{
				unified: "1f628",
				native: "😨"
			}
		],
		version: 1
	},
	cold_sweat: {
		id: "cold_sweat",
		name: "Anxious Face with Sweat",
		keywords: [
			"cold",
			"nervous"
		],
		skins: [
			{
				unified: "1f630",
				native: "😰"
			}
		],
		version: 1
	},
	disappointed_relieved: {
		id: "disappointed_relieved",
		name: "Sad but Relieved Face",
		keywords: [
			"disappointed",
			"phew",
			"sweat",
			"nervous"
		],
		skins: [
			{
				unified: "1f625",
				native: "😥"
			}
		],
		version: 1
	},
	cry: {
		id: "cry",
		name: "Crying Face",
		emoticons: [
			":'("
		],
		keywords: [
			"cry",
			"tears",
			"sad",
			"depressed",
			"upset",
			":'("
		],
		skins: [
			{
				unified: "1f622",
				native: "😢"
			}
		],
		version: 1
	},
	sob: {
		id: "sob",
		name: "Loudly Crying Face",
		emoticons: [
			":'("
		],
		keywords: [
			"sob",
			"cry",
			"tears",
			"sad",
			"upset",
			"depressed"
		],
		skins: [
			{
				unified: "1f62d",
				native: "😭"
			}
		],
		version: 1
	},
	scream: {
		id: "scream",
		name: "Face Screaming in Fear",
		keywords: [
			"scream",
			"munch",
			"scared",
			"omg"
		],
		skins: [
			{
				unified: "1f631",
				native: "😱"
			}
		],
		version: 1
	},
	confounded: {
		id: "confounded",
		name: "Confounded Face",
		keywords: [
			"confused",
			"sick",
			"unwell",
			"oops",
			":S"
		],
		skins: [
			{
				unified: "1f616",
				native: "😖"
			}
		],
		version: 1
	},
	persevere: {
		id: "persevere",
		name: "Persevering Face",
		keywords: [
			"persevere",
			"sick",
			"no",
			"upset",
			"oops"
		],
		skins: [
			{
				unified: "1f623",
				native: "😣"
			}
		],
		version: 1
	},
	disappointed: {
		id: "disappointed",
		name: "Disappointed Face",
		emoticons: [
			"):",
			":(",
			":-("
		],
		keywords: [
			"sad",
			"upset",
			"depressed",
			":("
		],
		skins: [
			{
				unified: "1f61e",
				native: "😞"
			}
		],
		version: 1
	},
	sweat: {
		id: "sweat",
		name: "Face with Cold Sweat",
		keywords: [
			"downcast",
			"hot",
			"sad",
			"tired",
			"exercise"
		],
		skins: [
			{
				unified: "1f613",
				native: "😓"
			}
		],
		version: 1
	},
	weary: {
		id: "weary",
		name: "Weary Face",
		keywords: [
			"tired",
			"sleepy",
			"sad",
			"frustrated",
			"upset"
		],
		skins: [
			{
				unified: "1f629",
				native: "😩"
			}
		],
		version: 1
	},
	tired_face: {
		id: "tired_face",
		name: "Tired Face",
		keywords: [
			"sick",
			"whine",
			"upset",
			"frustrated"
		],
		skins: [
			{
				unified: "1f62b",
				native: "😫"
			}
		],
		version: 1
	},
	yawning_face: {
		id: "yawning_face",
		name: "Yawning Face",
		keywords: [
			"tired",
			"sleepy"
		],
		skins: [
			{
				unified: "1f971",
				native: "🥱"
			}
		],
		version: 12
	},
	triumph: {
		id: "triumph",
		name: "Face with Look of Triumph",
		keywords: [
			"steam",
			"from",
			"nose",
			"gas",
			"phew",
			"proud",
			"pride"
		],
		skins: [
			{
				unified: "1f624",
				native: "😤"
			}
		],
		version: 1
	},
	rage: {
		id: "rage",
		name: "Pouting Face",
		keywords: [
			"rage",
			"angry",
			"mad",
			"hate",
			"despise"
		],
		skins: [
			{
				unified: "1f621",
				native: "😡"
			}
		],
		version: 1
	},
	angry: {
		id: "angry",
		name: "Angry Face",
		emoticons: [
			">:(",
			">:-("
		],
		keywords: [
			"mad",
			"annoyed",
			"frustrated"
		],
		skins: [
			{
				unified: "1f620",
				native: "😠"
			}
		],
		version: 1
	},
	face_with_symbols_on_mouth: {
		id: "face_with_symbols_on_mouth",
		name: "Face with Symbols on Mouth",
		keywords: [
			"serious",
			"covering",
			"swearing",
			"cursing",
			"cussing",
			"profanity",
			"expletive"
		],
		skins: [
			{
				unified: "1f92c",
				native: "🤬"
			}
		],
		version: 5
	},
	smiling_imp: {
		id: "smiling_imp",
		name: "Smiling Face with Horns",
		keywords: [
			"imp",
			"devil"
		],
		skins: [
			{
				unified: "1f608",
				native: "😈"
			}
		],
		version: 1
	},
	imp: {
		id: "imp",
		name: "Imp",
		keywords: [
			"angry",
			"face",
			"with",
			"horns",
			"devil"
		],
		skins: [
			{
				unified: "1f47f",
				native: "👿"
			}
		],
		version: 1
	},
	skull: {
		id: "skull",
		name: "Skull",
		keywords: [
			"dead",
			"skeleton",
			"creepy",
			"death"
		],
		skins: [
			{
				unified: "1f480",
				native: "💀"
			}
		],
		version: 1
	},
	skull_and_crossbones: {
		id: "skull_and_crossbones",
		name: "Skull and Crossbones",
		keywords: [
			"poison",
			"danger",
			"deadly",
			"scary",
			"death",
			"pirate",
			"evil"
		],
		skins: [
			{
				unified: "2620-fe0f",
				native: "☠️"
			}
		],
		version: 1
	},
	hankey: {
		id: "hankey",
		name: "Pile of Poo",
		keywords: [
			"hankey",
			"poop",
			"shit",
			"shitface",
			"fail",
			"turd"
		],
		skins: [
			{
				unified: "1f4a9",
				native: "💩"
			}
		],
		version: 1
	},
	clown_face: {
		id: "clown_face",
		name: "Clown Face",
		keywords: [
		],
		skins: [
			{
				unified: "1f921",
				native: "🤡"
			}
		],
		version: 3
	},
	japanese_ogre: {
		id: "japanese_ogre",
		name: "Ogre",
		keywords: [
			"japanese",
			"monster",
			"red",
			"mask",
			"halloween",
			"scary",
			"creepy",
			"devil",
			"demon"
		],
		skins: [
			{
				unified: "1f479",
				native: "👹"
			}
		],
		version: 1
	},
	japanese_goblin: {
		id: "japanese_goblin",
		name: "Goblin",
		keywords: [
			"japanese",
			"red",
			"evil",
			"mask",
			"monster",
			"scary",
			"creepy"
		],
		skins: [
			{
				unified: "1f47a",
				native: "👺"
			}
		],
		version: 1
	},
	ghost: {
		id: "ghost",
		name: "Ghost",
		keywords: [
			"halloween",
			"spooky",
			"scary"
		],
		skins: [
			{
				unified: "1f47b",
				native: "👻"
			}
		],
		version: 1
	},
	alien: {
		id: "alien",
		name: "Alien",
		keywords: [
			"UFO",
			"paul",
			"weird",
			"outer",
			"space"
		],
		skins: [
			{
				unified: "1f47d",
				native: "👽"
			}
		],
		version: 1
	},
	space_invader: {
		id: "space_invader",
		name: "Alien Monster",
		keywords: [
			"space",
			"invader",
			"game",
			"arcade",
			"play"
		],
		skins: [
			{
				unified: "1f47e",
				native: "👾"
			}
		],
		version: 1
	},
	robot_face: {
		id: "robot_face",
		name: "Robot",
		keywords: [
			"face",
			"computer",
			"machine",
			"bot"
		],
		skins: [
			{
				unified: "1f916",
				native: "🤖"
			}
		],
		version: 1
	},
	smiley_cat: {
		id: "smiley_cat",
		name: "Grinning Cat",
		keywords: [
			"smiley",
			"animal",
			"cats",
			"happy",
			"smile"
		],
		skins: [
			{
				unified: "1f63a",
				native: "😺"
			}
		],
		version: 1
	},
	smile_cat: {
		id: "smile_cat",
		name: "Grinning Cat with Smiling Eyes",
		keywords: [
			"smile",
			"animal",
			"cats"
		],
		skins: [
			{
				unified: "1f638",
				native: "😸"
			}
		],
		version: 1
	},
	joy_cat: {
		id: "joy_cat",
		name: "Cat with Tears of Joy",
		keywords: [
			"animal",
			"cats",
			"haha",
			"happy"
		],
		skins: [
			{
				unified: "1f639",
				native: "😹"
			}
		],
		version: 1
	},
	heart_eyes_cat: {
		id: "heart_eyes_cat",
		name: "Smiling Cat with Heart-Eyes",
		keywords: [
			"heart",
			"eyes",
			"animal",
			"love",
			"like",
			"affection",
			"cats",
			"valentines"
		],
		skins: [
			{
				unified: "1f63b",
				native: "😻"
			}
		],
		version: 1
	},
	smirk_cat: {
		id: "smirk_cat",
		name: "Cat with Wry Smile",
		keywords: [
			"smirk",
			"animal",
			"cats"
		],
		skins: [
			{
				unified: "1f63c",
				native: "😼"
			}
		],
		version: 1
	},
	kissing_cat: {
		id: "kissing_cat",
		name: "Kissing Cat",
		keywords: [
			"animal",
			"cats",
			"kiss"
		],
		skins: [
			{
				unified: "1f63d",
				native: "😽"
			}
		],
		version: 1
	},
	scream_cat: {
		id: "scream_cat",
		name: "Weary Cat",
		keywords: [
			"scream",
			"animal",
			"cats",
			"munch",
			"scared"
		],
		skins: [
			{
				unified: "1f640",
				native: "🙀"
			}
		],
		version: 1
	},
	crying_cat_face: {
		id: "crying_cat_face",
		name: "Crying Cat",
		keywords: [
			"face",
			"animal",
			"tears",
			"weep",
			"sad",
			"cats",
			"upset",
			"cry"
		],
		skins: [
			{
				unified: "1f63f",
				native: "😿"
			}
		],
		version: 1
	},
	pouting_cat: {
		id: "pouting_cat",
		name: "Pouting Cat",
		keywords: [
			"animal",
			"cats"
		],
		skins: [
			{
				unified: "1f63e",
				native: "😾"
			}
		],
		version: 1
	},
	see_no_evil: {
		id: "see_no_evil",
		name: "See-No-Evil Monkey",
		keywords: [
			"see",
			"no",
			"evil",
			"animal",
			"nature",
			"haha"
		],
		skins: [
			{
				unified: "1f648",
				native: "🙈"
			}
		],
		version: 1
	},
	hear_no_evil: {
		id: "hear_no_evil",
		name: "Hear-No-Evil Monkey",
		keywords: [
			"hear",
			"no",
			"evil",
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f649",
				native: "🙉"
			}
		],
		version: 1
	},
	speak_no_evil: {
		id: "speak_no_evil",
		name: "Speak-No-Evil Monkey",
		keywords: [
			"speak",
			"no",
			"evil",
			"animal",
			"nature",
			"omg"
		],
		skins: [
			{
				unified: "1f64a",
				native: "🙊"
			}
		],
		version: 1
	},
	love_letter: {
		id: "love_letter",
		name: "Love Letter",
		keywords: [
			"email",
			"like",
			"affection",
			"envelope",
			"valentines"
		],
		skins: [
			{
				unified: "1f48c",
				native: "💌"
			}
		],
		version: 1
	},
	cupid: {
		id: "cupid",
		name: "Heart with Arrow",
		keywords: [
			"cupid",
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f498",
				native: "💘"
			}
		],
		version: 1
	},
	gift_heart: {
		id: "gift_heart",
		name: "Heart with Ribbon",
		keywords: [
			"gift",
			"love",
			"valentines"
		],
		skins: [
			{
				unified: "1f49d",
				native: "💝"
			}
		],
		version: 1
	},
	sparkling_heart: {
		id: "sparkling_heart",
		name: "Sparkling Heart",
		keywords: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f496",
				native: "💖"
			}
		],
		version: 1
	},
	heartpulse: {
		id: "heartpulse",
		name: "Growing Heart",
		keywords: [
			"heartpulse",
			"like",
			"love",
			"affection",
			"valentines",
			"pink"
		],
		skins: [
			{
				unified: "1f497",
				native: "💗"
			}
		],
		version: 1
	},
	heartbeat: {
		id: "heartbeat",
		name: "Beating Heart",
		keywords: [
			"heartbeat",
			"love",
			"like",
			"affection",
			"valentines",
			"pink"
		],
		skins: [
			{
				unified: "1f493",
				native: "💓"
			}
		],
		version: 1
	},
	revolving_hearts: {
		id: "revolving_hearts",
		name: "Revolving Hearts",
		keywords: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f49e",
				native: "💞"
			}
		],
		version: 1
	},
	two_hearts: {
		id: "two_hearts",
		name: "Two Hearts",
		keywords: [
			"love",
			"like",
			"affection",
			"valentines",
			"heart"
		],
		skins: [
			{
				unified: "1f495",
				native: "💕"
			}
		],
		version: 1
	},
	heart_decoration: {
		id: "heart_decoration",
		name: "Heart Decoration",
		keywords: [
			"purple",
			"square",
			"love",
			"like"
		],
		skins: [
			{
				unified: "1f49f",
				native: "💟"
			}
		],
		version: 1
	},
	heavy_heart_exclamation_mark_ornament: {
		id: "heavy_heart_exclamation_mark_ornament",
		name: "Heart Exclamation",
		keywords: [
			"heavy",
			"mark",
			"ornament",
			"decoration",
			"love"
		],
		skins: [
			{
				unified: "2763-fe0f",
				native: "❣️"
			}
		],
		version: 1
	},
	broken_heart: {
		id: "broken_heart",
		name: "Broken Heart",
		emoticons: [
			"</3"
		],
		keywords: [
			"sad",
			"sorry",
			"break",
			"heartbreak"
		],
		skins: [
			{
				unified: "1f494",
				native: "💔"
			}
		],
		version: 1
	},
	heart_on_fire: {
		id: "heart_on_fire",
		name: "Heart on Fire",
		keywords: [
			"passionate",
			"enthusiastic"
		],
		skins: [
			{
				unified: "2764-fe0f-200d-1f525",
				native: "❤️‍🔥"
			}
		],
		version: 13.1
	},
	mending_heart: {
		id: "mending_heart",
		name: "Mending Heart",
		keywords: [
			"broken",
			"bandage",
			"wounded"
		],
		skins: [
			{
				unified: "2764-fe0f-200d-1fa79",
				native: "❤️‍🩹"
			}
		],
		version: 13.1
	},
	heart: {
		id: "heart",
		name: "Red Heart",
		emoticons: [
			"<3"
		],
		keywords: [
			"love",
			"like",
			"valentines"
		],
		skins: [
			{
				unified: "2764-fe0f",
				native: "❤️"
			}
		],
		version: 1
	},
	pink_heart: {
		id: "pink_heart",
		name: "Pink Heart",
		keywords: [
			"valentines"
		],
		skins: [
			{
				unified: "1fa77",
				native: "🩷"
			}
		],
		version: 15
	},
	orange_heart: {
		id: "orange_heart",
		name: "Orange Heart",
		keywords: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f9e1",
				native: "🧡"
			}
		],
		version: 5
	},
	yellow_heart: {
		id: "yellow_heart",
		name: "Yellow Heart",
		emoticons: [
			"<3"
		],
		keywords: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f49b",
				native: "💛"
			}
		],
		version: 1
	},
	green_heart: {
		id: "green_heart",
		name: "Green Heart",
		emoticons: [
			"<3"
		],
		keywords: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f49a",
				native: "💚"
			}
		],
		version: 1
	},
	blue_heart: {
		id: "blue_heart",
		name: "Blue Heart",
		emoticons: [
			"<3"
		],
		keywords: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f499",
				native: "💙"
			}
		],
		version: 1
	},
	light_blue_heart: {
		id: "light_blue_heart",
		name: "Light Blue Heart",
		keywords: [
			"ice",
			"baby"
		],
		skins: [
			{
				unified: "1fa75",
				native: "🩵"
			}
		],
		version: 15
	},
	purple_heart: {
		id: "purple_heart",
		name: "Purple Heart",
		emoticons: [
			"<3"
		],
		keywords: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f49c",
				native: "💜"
			}
		],
		version: 1
	},
	brown_heart: {
		id: "brown_heart",
		name: "Brown Heart",
		keywords: [
			"coffee"
		],
		skins: [
			{
				unified: "1f90e",
				native: "🤎"
			}
		],
		version: 12
	},
	black_heart: {
		id: "black_heart",
		name: "Black Heart",
		keywords: [
			"evil"
		],
		skins: [
			{
				unified: "1f5a4",
				native: "🖤"
			}
		],
		version: 3
	},
	grey_heart: {
		id: "grey_heart",
		name: "Grey Heart",
		keywords: [
			"silver",
			"monochrome"
		],
		skins: [
			{
				unified: "1fa76",
				native: "🩶"
			}
		],
		version: 15
	},
	white_heart: {
		id: "white_heart",
		name: "White Heart",
		keywords: [
			"pure"
		],
		skins: [
			{
				unified: "1f90d",
				native: "🤍"
			}
		],
		version: 12
	},
	kiss: {
		id: "kiss",
		name: "Kiss Mark",
		keywords: [
			"face",
			"lips",
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f48b",
				native: "💋"
			}
		],
		version: 1
	},
	anger: {
		id: "anger",
		name: "Anger Symbol",
		keywords: [
			"angry",
			"mad"
		],
		skins: [
			{
				unified: "1f4a2",
				native: "💢"
			}
		],
		version: 1
	},
	boom: {
		id: "boom",
		name: "Collision",
		keywords: [
			"boom",
			"bomb",
			"explode",
			"explosion",
			"blown"
		],
		skins: [
			{
				unified: "1f4a5",
				native: "💥"
			}
		],
		version: 1
	},
	dizzy: {
		id: "dizzy",
		name: "Dizzy",
		keywords: [
			"star",
			"sparkle",
			"shoot",
			"magic"
		],
		skins: [
			{
				unified: "1f4ab",
				native: "💫"
			}
		],
		version: 1
	},
	sweat_drops: {
		id: "sweat_drops",
		name: "Sweat Droplets",
		keywords: [
			"drops",
			"water",
			"drip",
			"oops"
		],
		skins: [
			{
				unified: "1f4a6",
				native: "💦"
			}
		],
		version: 1
	},
	dash: {
		id: "dash",
		name: "Dash Symbol",
		keywords: [
			"dashing",
			"away",
			"wind",
			"air",
			"fast",
			"shoo",
			"fart",
			"smoke",
			"puff"
		],
		skins: [
			{
				unified: "1f4a8",
				native: "💨"
			}
		],
		version: 1
	},
	hole: {
		id: "hole",
		name: "Hole",
		keywords: [
			"embarrassing"
		],
		skins: [
			{
				unified: "1f573-fe0f",
				native: "🕳️"
			}
		],
		version: 1
	},
	speech_balloon: {
		id: "speech_balloon",
		name: "Speech Balloon",
		keywords: [
			"bubble",
			"words",
			"message",
			"talk",
			"chatting"
		],
		skins: [
			{
				unified: "1f4ac",
				native: "💬"
			}
		],
		version: 1
	},
	"eye-in-speech-bubble": {
		id: "eye-in-speech-bubble",
		name: "Eye in Speech Bubble",
		keywords: [
			"in-speech-bubble",
			"info"
		],
		skins: [
			{
				unified: "1f441-fe0f-200d-1f5e8-fe0f",
				native: "👁️‍🗨️"
			}
		],
		version: 2
	},
	left_speech_bubble: {
		id: "left_speech_bubble",
		name: "Left Speech Bubble",
		keywords: [
			"words",
			"message",
			"talk",
			"chatting"
		],
		skins: [
			{
				unified: "1f5e8-fe0f",
				native: "🗨️"
			}
		],
		version: 2
	},
	right_anger_bubble: {
		id: "right_anger_bubble",
		name: "Right Anger Bubble",
		keywords: [
			"caption",
			"speech",
			"thinking",
			"mad"
		],
		skins: [
			{
				unified: "1f5ef-fe0f",
				native: "🗯️"
			}
		],
		version: 1
	},
	thought_balloon: {
		id: "thought_balloon",
		name: "Thought Balloon",
		keywords: [
			"bubble",
			"cloud",
			"speech",
			"thinking",
			"dream"
		],
		skins: [
			{
				unified: "1f4ad",
				native: "💭"
			}
		],
		version: 1
	},
	zzz: {
		id: "zzz",
		name: "Zzz",
		keywords: [
			"sleepy",
			"tired",
			"dream"
		],
		skins: [
			{
				unified: "1f4a4",
				native: "💤"
			}
		],
		version: 1
	},
	wave: {
		id: "wave",
		name: "Waving Hand",
		keywords: [
			"wave",
			"hands",
			"gesture",
			"goodbye",
			"solong",
			"farewell",
			"hello",
			"hi",
			"palm"
		],
		skins: [
			{
				unified: "1f44b",
				native: "👋"
			},
			{
				unified: "1f44b-1f3fb",
				native: "👋🏻"
			},
			{
				unified: "1f44b-1f3fc",
				native: "👋🏼"
			},
			{
				unified: "1f44b-1f3fd",
				native: "👋🏽"
			},
			{
				unified: "1f44b-1f3fe",
				native: "👋🏾"
			},
			{
				unified: "1f44b-1f3ff",
				native: "👋🏿"
			}
		],
		version: 1
	},
	raised_back_of_hand: {
		id: "raised_back_of_hand",
		name: "Raised Back of Hand",
		keywords: [
			"fingers",
			"backhand"
		],
		skins: [
			{
				unified: "1f91a",
				native: "🤚"
			},
			{
				unified: "1f91a-1f3fb",
				native: "🤚🏻"
			},
			{
				unified: "1f91a-1f3fc",
				native: "🤚🏼"
			},
			{
				unified: "1f91a-1f3fd",
				native: "🤚🏽"
			},
			{
				unified: "1f91a-1f3fe",
				native: "🤚🏾"
			},
			{
				unified: "1f91a-1f3ff",
				native: "🤚🏿"
			}
		],
		version: 3
	},
	raised_hand_with_fingers_splayed: {
		id: "raised_hand_with_fingers_splayed",
		name: "Hand with Fingers Splayed",
		keywords: [
			"raised",
			"palm"
		],
		skins: [
			{
				unified: "1f590-fe0f",
				native: "🖐️"
			},
			{
				unified: "1f590-1f3fb",
				native: "🖐🏻"
			},
			{
				unified: "1f590-1f3fc",
				native: "🖐🏼"
			},
			{
				unified: "1f590-1f3fd",
				native: "🖐🏽"
			},
			{
				unified: "1f590-1f3fe",
				native: "🖐🏾"
			},
			{
				unified: "1f590-1f3ff",
				native: "🖐🏿"
			}
		],
		version: 1
	},
	hand: {
		id: "hand",
		name: "Raised Hand",
		keywords: [
			"fingers",
			"stop",
			"highfive",
			"high",
			"five",
			"palm",
			"ban"
		],
		skins: [
			{
				unified: "270b",
				native: "✋"
			},
			{
				unified: "270b-1f3fb",
				native: "✋🏻"
			},
			{
				unified: "270b-1f3fc",
				native: "✋🏼"
			},
			{
				unified: "270b-1f3fd",
				native: "✋🏽"
			},
			{
				unified: "270b-1f3fe",
				native: "✋🏾"
			},
			{
				unified: "270b-1f3ff",
				native: "✋🏿"
			}
		],
		version: 1
	},
	"spock-hand": {
		id: "spock-hand",
		name: "Vulcan Salute",
		keywords: [
			"spock",
			"hand",
			"fingers",
			"star",
			"trek"
		],
		skins: [
			{
				unified: "1f596",
				native: "🖖"
			},
			{
				unified: "1f596-1f3fb",
				native: "🖖🏻"
			},
			{
				unified: "1f596-1f3fc",
				native: "🖖🏼"
			},
			{
				unified: "1f596-1f3fd",
				native: "🖖🏽"
			},
			{
				unified: "1f596-1f3fe",
				native: "🖖🏾"
			},
			{
				unified: "1f596-1f3ff",
				native: "🖖🏿"
			}
		],
		version: 1
	},
	rightwards_hand: {
		id: "rightwards_hand",
		name: "Rightwards Hand",
		keywords: [
			"palm",
			"offer"
		],
		skins: [
			{
				unified: "1faf1",
				native: "🫱"
			},
			{
				unified: "1faf1-1f3fb",
				native: "🫱🏻"
			},
			{
				unified: "1faf1-1f3fc",
				native: "🫱🏼"
			},
			{
				unified: "1faf1-1f3fd",
				native: "🫱🏽"
			},
			{
				unified: "1faf1-1f3fe",
				native: "🫱🏾"
			},
			{
				unified: "1faf1-1f3ff",
				native: "🫱🏿"
			}
		],
		version: 14
	},
	leftwards_hand: {
		id: "leftwards_hand",
		name: "Leftwards Hand",
		keywords: [
			"palm",
			"offer"
		],
		skins: [
			{
				unified: "1faf2",
				native: "🫲"
			},
			{
				unified: "1faf2-1f3fb",
				native: "🫲🏻"
			},
			{
				unified: "1faf2-1f3fc",
				native: "🫲🏼"
			},
			{
				unified: "1faf2-1f3fd",
				native: "🫲🏽"
			},
			{
				unified: "1faf2-1f3fe",
				native: "🫲🏾"
			},
			{
				unified: "1faf2-1f3ff",
				native: "🫲🏿"
			}
		],
		version: 14
	},
	palm_down_hand: {
		id: "palm_down_hand",
		name: "Palm Down Hand",
		keywords: [
			"drop"
		],
		skins: [
			{
				unified: "1faf3",
				native: "🫳"
			},
			{
				unified: "1faf3-1f3fb",
				native: "🫳🏻"
			},
			{
				unified: "1faf3-1f3fc",
				native: "🫳🏼"
			},
			{
				unified: "1faf3-1f3fd",
				native: "🫳🏽"
			},
			{
				unified: "1faf3-1f3fe",
				native: "🫳🏾"
			},
			{
				unified: "1faf3-1f3ff",
				native: "🫳🏿"
			}
		],
		version: 14
	},
	palm_up_hand: {
		id: "palm_up_hand",
		name: "Palm Up Hand",
		keywords: [
			"lift",
			"offer",
			"demand"
		],
		skins: [
			{
				unified: "1faf4",
				native: "🫴"
			},
			{
				unified: "1faf4-1f3fb",
				native: "🫴🏻"
			},
			{
				unified: "1faf4-1f3fc",
				native: "🫴🏼"
			},
			{
				unified: "1faf4-1f3fd",
				native: "🫴🏽"
			},
			{
				unified: "1faf4-1f3fe",
				native: "🫴🏾"
			},
			{
				unified: "1faf4-1f3ff",
				native: "🫴🏿"
			}
		],
		version: 14
	},
	leftwards_pushing_hand: {
		id: "leftwards_pushing_hand",
		name: "Leftwards Pushing Hand",
		keywords: [
			"highfive",
			"high",
			"five",
			"pressing",
			"stop"
		],
		skins: [
			{
				unified: "1faf7",
				native: "🫷"
			},
			{
				unified: "1faf7-1f3fb",
				native: "🫷🏻"
			},
			{
				unified: "1faf7-1f3fc",
				native: "🫷🏼"
			},
			{
				unified: "1faf7-1f3fd",
				native: "🫷🏽"
			},
			{
				unified: "1faf7-1f3fe",
				native: "🫷🏾"
			},
			{
				unified: "1faf7-1f3ff",
				native: "🫷🏿"
			}
		],
		version: 15
	},
	rightwards_pushing_hand: {
		id: "rightwards_pushing_hand",
		name: "Rightwards Pushing Hand",
		keywords: [
			"highfive",
			"high",
			"five",
			"pressing",
			"stop"
		],
		skins: [
			{
				unified: "1faf8",
				native: "🫸"
			},
			{
				unified: "1faf8-1f3fb",
				native: "🫸🏻"
			},
			{
				unified: "1faf8-1f3fc",
				native: "🫸🏼"
			},
			{
				unified: "1faf8-1f3fd",
				native: "🫸🏽"
			},
			{
				unified: "1faf8-1f3fe",
				native: "🫸🏾"
			},
			{
				unified: "1faf8-1f3ff",
				native: "🫸🏿"
			}
		],
		version: 15
	},
	ok_hand: {
		id: "ok_hand",
		name: "Ok Hand",
		keywords: [
			"fingers",
			"limbs",
			"perfect",
			"okay"
		],
		skins: [
			{
				unified: "1f44c",
				native: "👌"
			},
			{
				unified: "1f44c-1f3fb",
				native: "👌🏻"
			},
			{
				unified: "1f44c-1f3fc",
				native: "👌🏼"
			},
			{
				unified: "1f44c-1f3fd",
				native: "👌🏽"
			},
			{
				unified: "1f44c-1f3fe",
				native: "👌🏾"
			},
			{
				unified: "1f44c-1f3ff",
				native: "👌🏿"
			}
		],
		version: 1
	},
	pinched_fingers: {
		id: "pinched_fingers",
		name: "Pinched Fingers",
		keywords: [
			"size",
			"tiny",
			"small"
		],
		skins: [
			{
				unified: "1f90c",
				native: "🤌"
			},
			{
				unified: "1f90c-1f3fb",
				native: "🤌🏻"
			},
			{
				unified: "1f90c-1f3fc",
				native: "🤌🏼"
			},
			{
				unified: "1f90c-1f3fd",
				native: "🤌🏽"
			},
			{
				unified: "1f90c-1f3fe",
				native: "🤌🏾"
			},
			{
				unified: "1f90c-1f3ff",
				native: "🤌🏿"
			}
		],
		version: 13
	},
	pinching_hand: {
		id: "pinching_hand",
		name: "Pinching Hand",
		keywords: [
			"tiny",
			"small",
			"size"
		],
		skins: [
			{
				unified: "1f90f",
				native: "🤏"
			},
			{
				unified: "1f90f-1f3fb",
				native: "🤏🏻"
			},
			{
				unified: "1f90f-1f3fc",
				native: "🤏🏼"
			},
			{
				unified: "1f90f-1f3fd",
				native: "🤏🏽"
			},
			{
				unified: "1f90f-1f3fe",
				native: "🤏🏾"
			},
			{
				unified: "1f90f-1f3ff",
				native: "🤏🏿"
			}
		],
		version: 12
	},
	v: {
		id: "v",
		name: "Victory Hand",
		keywords: [
			"v",
			"fingers",
			"ohyeah",
			"peace",
			"two"
		],
		skins: [
			{
				unified: "270c-fe0f",
				native: "✌️"
			},
			{
				unified: "270c-1f3fb",
				native: "✌🏻"
			},
			{
				unified: "270c-1f3fc",
				native: "✌🏼"
			},
			{
				unified: "270c-1f3fd",
				native: "✌🏽"
			},
			{
				unified: "270c-1f3fe",
				native: "✌🏾"
			},
			{
				unified: "270c-1f3ff",
				native: "✌🏿"
			}
		],
		version: 1
	},
	crossed_fingers: {
		id: "crossed_fingers",
		name: "Crossed Fingers",
		keywords: [
			"hand",
			"with",
			"index",
			"and",
			"middle",
			"good",
			"lucky"
		],
		skins: [
			{
				unified: "1f91e",
				native: "🤞"
			},
			{
				unified: "1f91e-1f3fb",
				native: "🤞🏻"
			},
			{
				unified: "1f91e-1f3fc",
				native: "🤞🏼"
			},
			{
				unified: "1f91e-1f3fd",
				native: "🤞🏽"
			},
			{
				unified: "1f91e-1f3fe",
				native: "🤞🏾"
			},
			{
				unified: "1f91e-1f3ff",
				native: "🤞🏿"
			}
		],
		version: 3
	},
	hand_with_index_finger_and_thumb_crossed: {
		id: "hand_with_index_finger_and_thumb_crossed",
		name: "Hand with Index Finger and Thumb Crossed",
		keywords: [
			"heart",
			"love",
			"money",
			"expensive"
		],
		skins: [
			{
				unified: "1faf0",
				native: "🫰"
			},
			{
				unified: "1faf0-1f3fb",
				native: "🫰🏻"
			},
			{
				unified: "1faf0-1f3fc",
				native: "🫰🏼"
			},
			{
				unified: "1faf0-1f3fd",
				native: "🫰🏽"
			},
			{
				unified: "1faf0-1f3fe",
				native: "🫰🏾"
			},
			{
				unified: "1faf0-1f3ff",
				native: "🫰🏿"
			}
		],
		version: 14
	},
	i_love_you_hand_sign: {
		id: "i_love_you_hand_sign",
		name: "Love-You Gesture",
		keywords: [
			"i",
			"love",
			"you",
			"hand",
			"sign",
			"fingers"
		],
		skins: [
			{
				unified: "1f91f",
				native: "🤟"
			},
			{
				unified: "1f91f-1f3fb",
				native: "🤟🏻"
			},
			{
				unified: "1f91f-1f3fc",
				native: "🤟🏼"
			},
			{
				unified: "1f91f-1f3fd",
				native: "🤟🏽"
			},
			{
				unified: "1f91f-1f3fe",
				native: "🤟🏾"
			},
			{
				unified: "1f91f-1f3ff",
				native: "🤟🏿"
			}
		],
		version: 5
	},
	the_horns: {
		id: "the_horns",
		name: "Sign of the Horns",
		keywords: [
			"hand",
			"fingers",
			"evil",
			"eye",
			"rock",
			"on"
		],
		skins: [
			{
				unified: "1f918",
				native: "🤘"
			},
			{
				unified: "1f918-1f3fb",
				native: "🤘🏻"
			},
			{
				unified: "1f918-1f3fc",
				native: "🤘🏼"
			},
			{
				unified: "1f918-1f3fd",
				native: "🤘🏽"
			},
			{
				unified: "1f918-1f3fe",
				native: "🤘🏾"
			},
			{
				unified: "1f918-1f3ff",
				native: "🤘🏿"
			}
		],
		version: 1
	},
	call_me_hand: {
		id: "call_me_hand",
		name: "Call Me Hand",
		keywords: [
			"hands",
			"gesture",
			"shaka"
		],
		skins: [
			{
				unified: "1f919",
				native: "🤙"
			},
			{
				unified: "1f919-1f3fb",
				native: "🤙🏻"
			},
			{
				unified: "1f919-1f3fc",
				native: "🤙🏼"
			},
			{
				unified: "1f919-1f3fd",
				native: "🤙🏽"
			},
			{
				unified: "1f919-1f3fe",
				native: "🤙🏾"
			},
			{
				unified: "1f919-1f3ff",
				native: "🤙🏿"
			}
		],
		version: 3
	},
	point_left: {
		id: "point_left",
		name: "Backhand Index Pointing Left",
		keywords: [
			"point",
			"direction",
			"fingers",
			"hand"
		],
		skins: [
			{
				unified: "1f448",
				native: "👈"
			},
			{
				unified: "1f448-1f3fb",
				native: "👈🏻"
			},
			{
				unified: "1f448-1f3fc",
				native: "👈🏼"
			},
			{
				unified: "1f448-1f3fd",
				native: "👈🏽"
			},
			{
				unified: "1f448-1f3fe",
				native: "👈🏾"
			},
			{
				unified: "1f448-1f3ff",
				native: "👈🏿"
			}
		],
		version: 1
	},
	point_right: {
		id: "point_right",
		name: "Backhand Index Pointing Right",
		keywords: [
			"point",
			"fingers",
			"hand",
			"direction"
		],
		skins: [
			{
				unified: "1f449",
				native: "👉"
			},
			{
				unified: "1f449-1f3fb",
				native: "👉🏻"
			},
			{
				unified: "1f449-1f3fc",
				native: "👉🏼"
			},
			{
				unified: "1f449-1f3fd",
				native: "👉🏽"
			},
			{
				unified: "1f449-1f3fe",
				native: "👉🏾"
			},
			{
				unified: "1f449-1f3ff",
				native: "👉🏿"
			}
		],
		version: 1
	},
	point_up_2: {
		id: "point_up_2",
		name: "Backhand Index Pointing Up",
		keywords: [
			"point",
			"2",
			"fingers",
			"hand",
			"direction"
		],
		skins: [
			{
				unified: "1f446",
				native: "👆"
			},
			{
				unified: "1f446-1f3fb",
				native: "👆🏻"
			},
			{
				unified: "1f446-1f3fc",
				native: "👆🏼"
			},
			{
				unified: "1f446-1f3fd",
				native: "👆🏽"
			},
			{
				unified: "1f446-1f3fe",
				native: "👆🏾"
			},
			{
				unified: "1f446-1f3ff",
				native: "👆🏿"
			}
		],
		version: 1
	},
	middle_finger: {
		id: "middle_finger",
		name: "Middle Finger",
		keywords: [
			"reversed",
			"hand",
			"with",
			"extended",
			"fingers",
			"rude",
			"flipping"
		],
		skins: [
			{
				unified: "1f595",
				native: "🖕"
			},
			{
				unified: "1f595-1f3fb",
				native: "🖕🏻"
			},
			{
				unified: "1f595-1f3fc",
				native: "🖕🏼"
			},
			{
				unified: "1f595-1f3fd",
				native: "🖕🏽"
			},
			{
				unified: "1f595-1f3fe",
				native: "🖕🏾"
			},
			{
				unified: "1f595-1f3ff",
				native: "🖕🏿"
			}
		],
		version: 1
	},
	point_down: {
		id: "point_down",
		name: "Backhand Index Pointing Down",
		keywords: [
			"point",
			"fingers",
			"hand",
			"direction"
		],
		skins: [
			{
				unified: "1f447",
				native: "👇"
			},
			{
				unified: "1f447-1f3fb",
				native: "👇🏻"
			},
			{
				unified: "1f447-1f3fc",
				native: "👇🏼"
			},
			{
				unified: "1f447-1f3fd",
				native: "👇🏽"
			},
			{
				unified: "1f447-1f3fe",
				native: "👇🏾"
			},
			{
				unified: "1f447-1f3ff",
				native: "👇🏿"
			}
		],
		version: 1
	},
	point_up: {
		id: "point_up",
		name: "Index Pointing Up",
		keywords: [
			"point",
			"hand",
			"fingers",
			"direction"
		],
		skins: [
			{
				unified: "261d-fe0f",
				native: "☝️"
			},
			{
				unified: "261d-1f3fb",
				native: "☝🏻"
			},
			{
				unified: "261d-1f3fc",
				native: "☝🏼"
			},
			{
				unified: "261d-1f3fd",
				native: "☝🏽"
			},
			{
				unified: "261d-1f3fe",
				native: "☝🏾"
			},
			{
				unified: "261d-1f3ff",
				native: "☝🏿"
			}
		],
		version: 1
	},
	index_pointing_at_the_viewer: {
		id: "index_pointing_at_the_viewer",
		name: "Index Pointing at the Viewer",
		keywords: [
			"you",
			"recruit"
		],
		skins: [
			{
				unified: "1faf5",
				native: "🫵"
			},
			{
				unified: "1faf5-1f3fb",
				native: "🫵🏻"
			},
			{
				unified: "1faf5-1f3fc",
				native: "🫵🏼"
			},
			{
				unified: "1faf5-1f3fd",
				native: "🫵🏽"
			},
			{
				unified: "1faf5-1f3fe",
				native: "🫵🏾"
			},
			{
				unified: "1faf5-1f3ff",
				native: "🫵🏿"
			}
		],
		version: 14
	},
	"+1": {
		id: "+1",
		name: "Thumbs Up",
		keywords: [
			"+1",
			"thumbsup",
			"yes",
			"awesome",
			"good",
			"agree",
			"accept",
			"cool",
			"hand",
			"like"
		],
		skins: [
			{
				unified: "1f44d",
				native: "👍"
			},
			{
				unified: "1f44d-1f3fb",
				native: "👍🏻"
			},
			{
				unified: "1f44d-1f3fc",
				native: "👍🏼"
			},
			{
				unified: "1f44d-1f3fd",
				native: "👍🏽"
			},
			{
				unified: "1f44d-1f3fe",
				native: "👍🏾"
			},
			{
				unified: "1f44d-1f3ff",
				native: "👍🏿"
			}
		],
		version: 1
	},
	"-1": {
		id: "-1",
		name: "Thumbs Down",
		keywords: [
			"-1",
			"thumbsdown",
			"no",
			"dislike",
			"hand"
		],
		skins: [
			{
				unified: "1f44e",
				native: "👎"
			},
			{
				unified: "1f44e-1f3fb",
				native: "👎🏻"
			},
			{
				unified: "1f44e-1f3fc",
				native: "👎🏼"
			},
			{
				unified: "1f44e-1f3fd",
				native: "👎🏽"
			},
			{
				unified: "1f44e-1f3fe",
				native: "👎🏾"
			},
			{
				unified: "1f44e-1f3ff",
				native: "👎🏿"
			}
		],
		version: 1
	},
	fist: {
		id: "fist",
		name: "Raised Fist",
		keywords: [
			"fingers",
			"hand",
			"grasp"
		],
		skins: [
			{
				unified: "270a",
				native: "✊"
			},
			{
				unified: "270a-1f3fb",
				native: "✊🏻"
			},
			{
				unified: "270a-1f3fc",
				native: "✊🏼"
			},
			{
				unified: "270a-1f3fd",
				native: "✊🏽"
			},
			{
				unified: "270a-1f3fe",
				native: "✊🏾"
			},
			{
				unified: "270a-1f3ff",
				native: "✊🏿"
			}
		],
		version: 1
	},
	facepunch: {
		id: "facepunch",
		name: "Oncoming Fist",
		keywords: [
			"facepunch",
			"punch",
			"angry",
			"violence",
			"hit",
			"attack",
			"hand"
		],
		skins: [
			{
				unified: "1f44a",
				native: "👊"
			},
			{
				unified: "1f44a-1f3fb",
				native: "👊🏻"
			},
			{
				unified: "1f44a-1f3fc",
				native: "👊🏼"
			},
			{
				unified: "1f44a-1f3fd",
				native: "👊🏽"
			},
			{
				unified: "1f44a-1f3fe",
				native: "👊🏾"
			},
			{
				unified: "1f44a-1f3ff",
				native: "👊🏿"
			}
		],
		version: 1
	},
	"left-facing_fist": {
		id: "left-facing_fist",
		name: "Left-Facing Fist",
		keywords: [
			"left",
			"facing",
			"hand",
			"fistbump"
		],
		skins: [
			{
				unified: "1f91b",
				native: "🤛"
			},
			{
				unified: "1f91b-1f3fb",
				native: "🤛🏻"
			},
			{
				unified: "1f91b-1f3fc",
				native: "🤛🏼"
			},
			{
				unified: "1f91b-1f3fd",
				native: "🤛🏽"
			},
			{
				unified: "1f91b-1f3fe",
				native: "🤛🏾"
			},
			{
				unified: "1f91b-1f3ff",
				native: "🤛🏿"
			}
		],
		version: 3
	},
	"right-facing_fist": {
		id: "right-facing_fist",
		name: "Right-Facing Fist",
		keywords: [
			"right",
			"facing",
			"hand",
			"fistbump"
		],
		skins: [
			{
				unified: "1f91c",
				native: "🤜"
			},
			{
				unified: "1f91c-1f3fb",
				native: "🤜🏻"
			},
			{
				unified: "1f91c-1f3fc",
				native: "🤜🏼"
			},
			{
				unified: "1f91c-1f3fd",
				native: "🤜🏽"
			},
			{
				unified: "1f91c-1f3fe",
				native: "🤜🏾"
			},
			{
				unified: "1f91c-1f3ff",
				native: "🤜🏿"
			}
		],
		version: 3
	},
	clap: {
		id: "clap",
		name: "Clapping Hands",
		keywords: [
			"clap",
			"praise",
			"applause",
			"congrats",
			"yay"
		],
		skins: [
			{
				unified: "1f44f",
				native: "👏"
			},
			{
				unified: "1f44f-1f3fb",
				native: "👏🏻"
			},
			{
				unified: "1f44f-1f3fc",
				native: "👏🏼"
			},
			{
				unified: "1f44f-1f3fd",
				native: "👏🏽"
			},
			{
				unified: "1f44f-1f3fe",
				native: "👏🏾"
			},
			{
				unified: "1f44f-1f3ff",
				native: "👏🏿"
			}
		],
		version: 1
	},
	raised_hands: {
		id: "raised_hands",
		name: "Raising Hands",
		keywords: [
			"raised",
			"gesture",
			"hooray",
			"yea",
			"celebration"
		],
		skins: [
			{
				unified: "1f64c",
				native: "🙌"
			},
			{
				unified: "1f64c-1f3fb",
				native: "🙌🏻"
			},
			{
				unified: "1f64c-1f3fc",
				native: "🙌🏼"
			},
			{
				unified: "1f64c-1f3fd",
				native: "🙌🏽"
			},
			{
				unified: "1f64c-1f3fe",
				native: "🙌🏾"
			},
			{
				unified: "1f64c-1f3ff",
				native: "🙌🏿"
			}
		],
		version: 1
	},
	heart_hands: {
		id: "heart_hands",
		name: "Heart Hands",
		keywords: [
			"love",
			"appreciation",
			"support"
		],
		skins: [
			{
				unified: "1faf6",
				native: "🫶"
			},
			{
				unified: "1faf6-1f3fb",
				native: "🫶🏻"
			},
			{
				unified: "1faf6-1f3fc",
				native: "🫶🏼"
			},
			{
				unified: "1faf6-1f3fd",
				native: "🫶🏽"
			},
			{
				unified: "1faf6-1f3fe",
				native: "🫶🏾"
			},
			{
				unified: "1faf6-1f3ff",
				native: "🫶🏿"
			}
		],
		version: 14
	},
	open_hands: {
		id: "open_hands",
		name: "Open Hands",
		keywords: [
			"fingers",
			"butterfly"
		],
		skins: [
			{
				unified: "1f450",
				native: "👐"
			},
			{
				unified: "1f450-1f3fb",
				native: "👐🏻"
			},
			{
				unified: "1f450-1f3fc",
				native: "👐🏼"
			},
			{
				unified: "1f450-1f3fd",
				native: "👐🏽"
			},
			{
				unified: "1f450-1f3fe",
				native: "👐🏾"
			},
			{
				unified: "1f450-1f3ff",
				native: "👐🏿"
			}
		],
		version: 1
	},
	palms_up_together: {
		id: "palms_up_together",
		name: "Palms Up Together",
		keywords: [
			"hands",
			"gesture",
			"cupped",
			"prayer"
		],
		skins: [
			{
				unified: "1f932",
				native: "🤲"
			},
			{
				unified: "1f932-1f3fb",
				native: "🤲🏻"
			},
			{
				unified: "1f932-1f3fc",
				native: "🤲🏼"
			},
			{
				unified: "1f932-1f3fd",
				native: "🤲🏽"
			},
			{
				unified: "1f932-1f3fe",
				native: "🤲🏾"
			},
			{
				unified: "1f932-1f3ff",
				native: "🤲🏿"
			}
		],
		version: 5
	},
	handshake: {
		id: "handshake",
		name: "Handshake",
		keywords: [
			"agreement",
			"shake"
		],
		skins: [
			{
				unified: "1f91d",
				native: "🤝"
			},
			{
				unified: "1f91d-1f3fb",
				native: "🤝🏻"
			},
			{
				unified: "1f91d-1f3fc",
				native: "🤝🏼"
			},
			{
				unified: "1f91d-1f3fd",
				native: "🤝🏽"
			},
			{
				unified: "1f91d-1f3fe",
				native: "🤝🏾"
			},
			{
				unified: "1f91d-1f3ff",
				native: "🤝🏿"
			}
		],
		version: 3
	},
	pray: {
		id: "pray",
		name: "Folded Hands",
		keywords: [
			"pray",
			"please",
			"hope",
			"wish",
			"namaste",
			"highfive",
			"high",
			"five",
			"thank",
			"you",
			"thanks",
			"appreciate"
		],
		skins: [
			{
				unified: "1f64f",
				native: "🙏"
			},
			{
				unified: "1f64f-1f3fb",
				native: "🙏🏻"
			},
			{
				unified: "1f64f-1f3fc",
				native: "🙏🏼"
			},
			{
				unified: "1f64f-1f3fd",
				native: "🙏🏽"
			},
			{
				unified: "1f64f-1f3fe",
				native: "🙏🏾"
			},
			{
				unified: "1f64f-1f3ff",
				native: "🙏🏿"
			}
		],
		version: 1
	},
	writing_hand: {
		id: "writing_hand",
		name: "Writing Hand",
		keywords: [
			"lower",
			"left",
			"ballpoint",
			"pen",
			"stationery",
			"write",
			"compose"
		],
		skins: [
			{
				unified: "270d-fe0f",
				native: "✍️"
			},
			{
				unified: "270d-1f3fb",
				native: "✍🏻"
			},
			{
				unified: "270d-1f3fc",
				native: "✍🏼"
			},
			{
				unified: "270d-1f3fd",
				native: "✍🏽"
			},
			{
				unified: "270d-1f3fe",
				native: "✍🏾"
			},
			{
				unified: "270d-1f3ff",
				native: "✍🏿"
			}
		],
		version: 1
	},
	nail_care: {
		id: "nail_care",
		name: "Nail Polish",
		keywords: [
			"care",
			"beauty",
			"manicure",
			"finger",
			"fashion"
		],
		skins: [
			{
				unified: "1f485",
				native: "💅"
			},
			{
				unified: "1f485-1f3fb",
				native: "💅🏻"
			},
			{
				unified: "1f485-1f3fc",
				native: "💅🏼"
			},
			{
				unified: "1f485-1f3fd",
				native: "💅🏽"
			},
			{
				unified: "1f485-1f3fe",
				native: "💅🏾"
			},
			{
				unified: "1f485-1f3ff",
				native: "💅🏿"
			}
		],
		version: 1
	},
	selfie: {
		id: "selfie",
		name: "Selfie",
		keywords: [
			"camera",
			"phone"
		],
		skins: [
			{
				unified: "1f933",
				native: "🤳"
			},
			{
				unified: "1f933-1f3fb",
				native: "🤳🏻"
			},
			{
				unified: "1f933-1f3fc",
				native: "🤳🏼"
			},
			{
				unified: "1f933-1f3fd",
				native: "🤳🏽"
			},
			{
				unified: "1f933-1f3fe",
				native: "🤳🏾"
			},
			{
				unified: "1f933-1f3ff",
				native: "🤳🏿"
			}
		],
		version: 3
	},
	muscle: {
		id: "muscle",
		name: "Flexed Biceps",
		keywords: [
			"muscle",
			"arm",
			"flex",
			"hand",
			"summer",
			"strong"
		],
		skins: [
			{
				unified: "1f4aa",
				native: "💪"
			},
			{
				unified: "1f4aa-1f3fb",
				native: "💪🏻"
			},
			{
				unified: "1f4aa-1f3fc",
				native: "💪🏼"
			},
			{
				unified: "1f4aa-1f3fd",
				native: "💪🏽"
			},
			{
				unified: "1f4aa-1f3fe",
				native: "💪🏾"
			},
			{
				unified: "1f4aa-1f3ff",
				native: "💪🏿"
			}
		],
		version: 1
	},
	mechanical_arm: {
		id: "mechanical_arm",
		name: "Mechanical Arm",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9be",
				native: "🦾"
			}
		],
		version: 12
	},
	mechanical_leg: {
		id: "mechanical_leg",
		name: "Mechanical Leg",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9bf",
				native: "🦿"
			}
		],
		version: 12
	},
	leg: {
		id: "leg",
		name: "Leg",
		keywords: [
			"kick",
			"limb"
		],
		skins: [
			{
				unified: "1f9b5",
				native: "🦵"
			},
			{
				unified: "1f9b5-1f3fb",
				native: "🦵🏻"
			},
			{
				unified: "1f9b5-1f3fc",
				native: "🦵🏼"
			},
			{
				unified: "1f9b5-1f3fd",
				native: "🦵🏽"
			},
			{
				unified: "1f9b5-1f3fe",
				native: "🦵🏾"
			},
			{
				unified: "1f9b5-1f3ff",
				native: "🦵🏿"
			}
		],
		version: 11
	},
	foot: {
		id: "foot",
		name: "Foot",
		keywords: [
			"kick",
			"stomp"
		],
		skins: [
			{
				unified: "1f9b6",
				native: "🦶"
			},
			{
				unified: "1f9b6-1f3fb",
				native: "🦶🏻"
			},
			{
				unified: "1f9b6-1f3fc",
				native: "🦶🏼"
			},
			{
				unified: "1f9b6-1f3fd",
				native: "🦶🏽"
			},
			{
				unified: "1f9b6-1f3fe",
				native: "🦶🏾"
			},
			{
				unified: "1f9b6-1f3ff",
				native: "🦶🏿"
			}
		],
		version: 11
	},
	ear: {
		id: "ear",
		name: "Ear",
		keywords: [
			"face",
			"hear",
			"sound",
			"listen"
		],
		skins: [
			{
				unified: "1f442",
				native: "👂"
			},
			{
				unified: "1f442-1f3fb",
				native: "👂🏻"
			},
			{
				unified: "1f442-1f3fc",
				native: "👂🏼"
			},
			{
				unified: "1f442-1f3fd",
				native: "👂🏽"
			},
			{
				unified: "1f442-1f3fe",
				native: "👂🏾"
			},
			{
				unified: "1f442-1f3ff",
				native: "👂🏿"
			}
		],
		version: 1
	},
	ear_with_hearing_aid: {
		id: "ear_with_hearing_aid",
		name: "Ear with Hearing Aid",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9bb",
				native: "🦻"
			},
			{
				unified: "1f9bb-1f3fb",
				native: "🦻🏻"
			},
			{
				unified: "1f9bb-1f3fc",
				native: "🦻🏼"
			},
			{
				unified: "1f9bb-1f3fd",
				native: "🦻🏽"
			},
			{
				unified: "1f9bb-1f3fe",
				native: "🦻🏾"
			},
			{
				unified: "1f9bb-1f3ff",
				native: "🦻🏿"
			}
		],
		version: 12
	},
	nose: {
		id: "nose",
		name: "Nose",
		keywords: [
			"smell",
			"sniff"
		],
		skins: [
			{
				unified: "1f443",
				native: "👃"
			},
			{
				unified: "1f443-1f3fb",
				native: "👃🏻"
			},
			{
				unified: "1f443-1f3fc",
				native: "👃🏼"
			},
			{
				unified: "1f443-1f3fd",
				native: "👃🏽"
			},
			{
				unified: "1f443-1f3fe",
				native: "👃🏾"
			},
			{
				unified: "1f443-1f3ff",
				native: "👃🏿"
			}
		],
		version: 1
	},
	brain: {
		id: "brain",
		name: "Brain",
		keywords: [
			"smart",
			"intelligent"
		],
		skins: [
			{
				unified: "1f9e0",
				native: "🧠"
			}
		],
		version: 5
	},
	anatomical_heart: {
		id: "anatomical_heart",
		name: "Anatomical Heart",
		keywords: [
			"health",
			"heartbeat"
		],
		skins: [
			{
				unified: "1fac0",
				native: "🫀"
			}
		],
		version: 13
	},
	lungs: {
		id: "lungs",
		name: "Lungs",
		keywords: [
			"breathe"
		],
		skins: [
			{
				unified: "1fac1",
				native: "🫁"
			}
		],
		version: 13
	},
	tooth: {
		id: "tooth",
		name: "Tooth",
		keywords: [
			"teeth",
			"dentist"
		],
		skins: [
			{
				unified: "1f9b7",
				native: "🦷"
			}
		],
		version: 11
	},
	bone: {
		id: "bone",
		name: "Bone",
		keywords: [
			"skeleton"
		],
		skins: [
			{
				unified: "1f9b4",
				native: "🦴"
			}
		],
		version: 11
	},
	eyes: {
		id: "eyes",
		name: "Eyes",
		keywords: [
			"look",
			"watch",
			"stalk",
			"peek",
			"see"
		],
		skins: [
			{
				unified: "1f440",
				native: "👀"
			}
		],
		version: 1
	},
	eye: {
		id: "eye",
		name: "Eye",
		keywords: [
			"face",
			"look",
			"see",
			"watch",
			"stare"
		],
		skins: [
			{
				unified: "1f441-fe0f",
				native: "👁️"
			}
		],
		version: 1
	},
	tongue: {
		id: "tongue",
		name: "Tongue",
		keywords: [
			"mouth",
			"playful"
		],
		skins: [
			{
				unified: "1f445",
				native: "👅"
			}
		],
		version: 1
	},
	lips: {
		id: "lips",
		name: "Mouth",
		keywords: [
			"lips",
			"kiss"
		],
		skins: [
			{
				unified: "1f444",
				native: "👄"
			}
		],
		version: 1
	},
	biting_lip: {
		id: "biting_lip",
		name: "Biting Lip",
		keywords: [
			"flirt",
			"sexy",
			"pain",
			"worry"
		],
		skins: [
			{
				unified: "1fae6",
				native: "🫦"
			}
		],
		version: 14
	},
	baby: {
		id: "baby",
		name: "Baby",
		keywords: [
			"child",
			"boy",
			"girl",
			"toddler"
		],
		skins: [
			{
				unified: "1f476",
				native: "👶"
			},
			{
				unified: "1f476-1f3fb",
				native: "👶🏻"
			},
			{
				unified: "1f476-1f3fc",
				native: "👶🏼"
			},
			{
				unified: "1f476-1f3fd",
				native: "👶🏽"
			},
			{
				unified: "1f476-1f3fe",
				native: "👶🏾"
			},
			{
				unified: "1f476-1f3ff",
				native: "👶🏿"
			}
		],
		version: 1
	},
	child: {
		id: "child",
		name: "Child",
		keywords: [
			"gender",
			"neutral",
			"young"
		],
		skins: [
			{
				unified: "1f9d2",
				native: "🧒"
			},
			{
				unified: "1f9d2-1f3fb",
				native: "🧒🏻"
			},
			{
				unified: "1f9d2-1f3fc",
				native: "🧒🏼"
			},
			{
				unified: "1f9d2-1f3fd",
				native: "🧒🏽"
			},
			{
				unified: "1f9d2-1f3fe",
				native: "🧒🏾"
			},
			{
				unified: "1f9d2-1f3ff",
				native: "🧒🏿"
			}
		],
		version: 5
	},
	boy: {
		id: "boy",
		name: "Boy",
		keywords: [
			"man",
			"male",
			"guy",
			"teenager"
		],
		skins: [
			{
				unified: "1f466",
				native: "👦"
			},
			{
				unified: "1f466-1f3fb",
				native: "👦🏻"
			},
			{
				unified: "1f466-1f3fc",
				native: "👦🏼"
			},
			{
				unified: "1f466-1f3fd",
				native: "👦🏽"
			},
			{
				unified: "1f466-1f3fe",
				native: "👦🏾"
			},
			{
				unified: "1f466-1f3ff",
				native: "👦🏿"
			}
		],
		version: 1
	},
	girl: {
		id: "girl",
		name: "Girl",
		keywords: [
			"female",
			"woman",
			"teenager"
		],
		skins: [
			{
				unified: "1f467",
				native: "👧"
			},
			{
				unified: "1f467-1f3fb",
				native: "👧🏻"
			},
			{
				unified: "1f467-1f3fc",
				native: "👧🏼"
			},
			{
				unified: "1f467-1f3fd",
				native: "👧🏽"
			},
			{
				unified: "1f467-1f3fe",
				native: "👧🏾"
			},
			{
				unified: "1f467-1f3ff",
				native: "👧🏿"
			}
		],
		version: 1
	},
	adult: {
		id: "adult",
		name: "Adult",
		keywords: [
			"person",
			"gender",
			"neutral"
		],
		skins: [
			{
				unified: "1f9d1",
				native: "🧑"
			},
			{
				unified: "1f9d1-1f3fb",
				native: "🧑🏻"
			},
			{
				unified: "1f9d1-1f3fc",
				native: "🧑🏼"
			},
			{
				unified: "1f9d1-1f3fd",
				native: "🧑🏽"
			},
			{
				unified: "1f9d1-1f3fe",
				native: "🧑🏾"
			},
			{
				unified: "1f9d1-1f3ff",
				native: "🧑🏿"
			}
		],
		version: 5
	},
	person_with_blond_hair: {
		id: "person_with_blond_hair",
		name: "Person Blond Hair",
		keywords: [
			"with",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f471",
				native: "👱"
			},
			{
				unified: "1f471-1f3fb",
				native: "👱🏻"
			},
			{
				unified: "1f471-1f3fc",
				native: "👱🏼"
			},
			{
				unified: "1f471-1f3fd",
				native: "👱🏽"
			},
			{
				unified: "1f471-1f3fe",
				native: "👱🏾"
			},
			{
				unified: "1f471-1f3ff",
				native: "👱🏿"
			}
		],
		version: 1
	},
	man: {
		id: "man",
		name: "Man",
		keywords: [
			"mustache",
			"father",
			"dad",
			"guy",
			"classy",
			"sir",
			"moustache"
		],
		skins: [
			{
				unified: "1f468",
				native: "👨"
			},
			{
				unified: "1f468-1f3fb",
				native: "👨🏻"
			},
			{
				unified: "1f468-1f3fc",
				native: "👨🏼"
			},
			{
				unified: "1f468-1f3fd",
				native: "👨🏽"
			},
			{
				unified: "1f468-1f3fe",
				native: "👨🏾"
			},
			{
				unified: "1f468-1f3ff",
				native: "👨🏿"
			}
		],
		version: 1
	},
	bearded_person: {
		id: "bearded_person",
		name: "Person Beard",
		keywords: [
			"bearded",
			"man",
			"bewhiskered"
		],
		skins: [
			{
				unified: "1f9d4",
				native: "🧔"
			},
			{
				unified: "1f9d4-1f3fb",
				native: "🧔🏻"
			},
			{
				unified: "1f9d4-1f3fc",
				native: "🧔🏼"
			},
			{
				unified: "1f9d4-1f3fd",
				native: "🧔🏽"
			},
			{
				unified: "1f9d4-1f3fe",
				native: "🧔🏾"
			},
			{
				unified: "1f9d4-1f3ff",
				native: "🧔🏿"
			}
		],
		version: 5
	},
	man_with_beard: {
		id: "man_with_beard",
		name: "Man: Beard",
		keywords: [
			"man",
			"with",
			"facial",
			"hair"
		],
		skins: [
			{
				unified: "1f9d4-200d-2642-fe0f",
				native: "🧔‍♂️"
			},
			{
				unified: "1f9d4-1f3fb-200d-2642-fe0f",
				native: "🧔🏻‍♂️"
			},
			{
				unified: "1f9d4-1f3fc-200d-2642-fe0f",
				native: "🧔🏼‍♂️"
			},
			{
				unified: "1f9d4-1f3fd-200d-2642-fe0f",
				native: "🧔🏽‍♂️"
			},
			{
				unified: "1f9d4-1f3fe-200d-2642-fe0f",
				native: "🧔🏾‍♂️"
			},
			{
				unified: "1f9d4-1f3ff-200d-2642-fe0f",
				native: "🧔🏿‍♂️"
			}
		],
		version: 13.1
	},
	woman_with_beard: {
		id: "woman_with_beard",
		name: "Woman: Beard",
		keywords: [
			"woman",
			"with",
			"facial",
			"hair"
		],
		skins: [
			{
				unified: "1f9d4-200d-2640-fe0f",
				native: "🧔‍♀️"
			},
			{
				unified: "1f9d4-1f3fb-200d-2640-fe0f",
				native: "🧔🏻‍♀️"
			},
			{
				unified: "1f9d4-1f3fc-200d-2640-fe0f",
				native: "🧔🏼‍♀️"
			},
			{
				unified: "1f9d4-1f3fd-200d-2640-fe0f",
				native: "🧔🏽‍♀️"
			},
			{
				unified: "1f9d4-1f3fe-200d-2640-fe0f",
				native: "🧔🏾‍♀️"
			},
			{
				unified: "1f9d4-1f3ff-200d-2640-fe0f",
				native: "🧔🏿‍♀️"
			}
		],
		version: 13.1
	},
	red_haired_man: {
		id: "red_haired_man",
		name: "Man: Red Hair",
		keywords: [
			"haired",
			"man",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f468-200d-1f9b0",
				native: "👨‍🦰"
			},
			{
				unified: "1f468-1f3fb-200d-1f9b0",
				native: "👨🏻‍🦰"
			},
			{
				unified: "1f468-1f3fc-200d-1f9b0",
				native: "👨🏼‍🦰"
			},
			{
				unified: "1f468-1f3fd-200d-1f9b0",
				native: "👨🏽‍🦰"
			},
			{
				unified: "1f468-1f3fe-200d-1f9b0",
				native: "👨🏾‍🦰"
			},
			{
				unified: "1f468-1f3ff-200d-1f9b0",
				native: "👨🏿‍🦰"
			}
		],
		version: 11
	},
	curly_haired_man: {
		id: "curly_haired_man",
		name: "Man: Curly Hair",
		keywords: [
			"haired",
			"man",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f468-200d-1f9b1",
				native: "👨‍🦱"
			},
			{
				unified: "1f468-1f3fb-200d-1f9b1",
				native: "👨🏻‍🦱"
			},
			{
				unified: "1f468-1f3fc-200d-1f9b1",
				native: "👨🏼‍🦱"
			},
			{
				unified: "1f468-1f3fd-200d-1f9b1",
				native: "👨🏽‍🦱"
			},
			{
				unified: "1f468-1f3fe-200d-1f9b1",
				native: "👨🏾‍🦱"
			},
			{
				unified: "1f468-1f3ff-200d-1f9b1",
				native: "👨🏿‍🦱"
			}
		],
		version: 11
	},
	white_haired_man: {
		id: "white_haired_man",
		name: "Man: White Hair",
		keywords: [
			"haired",
			"man",
			"old",
			"elder"
		],
		skins: [
			{
				unified: "1f468-200d-1f9b3",
				native: "👨‍🦳"
			},
			{
				unified: "1f468-1f3fb-200d-1f9b3",
				native: "👨🏻‍🦳"
			},
			{
				unified: "1f468-1f3fc-200d-1f9b3",
				native: "👨🏼‍🦳"
			},
			{
				unified: "1f468-1f3fd-200d-1f9b3",
				native: "👨🏽‍🦳"
			},
			{
				unified: "1f468-1f3fe-200d-1f9b3",
				native: "👨🏾‍🦳"
			},
			{
				unified: "1f468-1f3ff-200d-1f9b3",
				native: "👨🏿‍🦳"
			}
		],
		version: 11
	},
	bald_man: {
		id: "bald_man",
		name: "Man: Bald",
		keywords: [
			"man",
			"hairless"
		],
		skins: [
			{
				unified: "1f468-200d-1f9b2",
				native: "👨‍🦲"
			},
			{
				unified: "1f468-1f3fb-200d-1f9b2",
				native: "👨🏻‍🦲"
			},
			{
				unified: "1f468-1f3fc-200d-1f9b2",
				native: "👨🏼‍🦲"
			},
			{
				unified: "1f468-1f3fd-200d-1f9b2",
				native: "👨🏽‍🦲"
			},
			{
				unified: "1f468-1f3fe-200d-1f9b2",
				native: "👨🏾‍🦲"
			},
			{
				unified: "1f468-1f3ff-200d-1f9b2",
				native: "👨🏿‍🦲"
			}
		],
		version: 11
	},
	woman: {
		id: "woman",
		name: "Woman",
		keywords: [
			"female",
			"girls",
			"lady"
		],
		skins: [
			{
				unified: "1f469",
				native: "👩"
			},
			{
				unified: "1f469-1f3fb",
				native: "👩🏻"
			},
			{
				unified: "1f469-1f3fc",
				native: "👩🏼"
			},
			{
				unified: "1f469-1f3fd",
				native: "👩🏽"
			},
			{
				unified: "1f469-1f3fe",
				native: "👩🏾"
			},
			{
				unified: "1f469-1f3ff",
				native: "👩🏿"
			}
		],
		version: 1
	},
	red_haired_woman: {
		id: "red_haired_woman",
		name: "Woman: Red Hair",
		keywords: [
			"haired",
			"woman",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f469-200d-1f9b0",
				native: "👩‍🦰"
			},
			{
				unified: "1f469-1f3fb-200d-1f9b0",
				native: "👩🏻‍🦰"
			},
			{
				unified: "1f469-1f3fc-200d-1f9b0",
				native: "👩🏼‍🦰"
			},
			{
				unified: "1f469-1f3fd-200d-1f9b0",
				native: "👩🏽‍🦰"
			},
			{
				unified: "1f469-1f3fe-200d-1f9b0",
				native: "👩🏾‍🦰"
			},
			{
				unified: "1f469-1f3ff-200d-1f9b0",
				native: "👩🏿‍🦰"
			}
		],
		version: 11
	},
	red_haired_person: {
		id: "red_haired_person",
		name: "Person: Red Hair",
		keywords: [
			"haired",
			"person",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f9b0",
				native: "🧑‍🦰"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f9b0",
				native: "🧑🏻‍🦰"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f9b0",
				native: "🧑🏼‍🦰"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f9b0",
				native: "🧑🏽‍🦰"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f9b0",
				native: "🧑🏾‍🦰"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f9b0",
				native: "🧑🏿‍🦰"
			}
		],
		version: 12.1
	},
	curly_haired_woman: {
		id: "curly_haired_woman",
		name: "Woman: Curly Hair",
		keywords: [
			"haired",
			"woman",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f469-200d-1f9b1",
				native: "👩‍🦱"
			},
			{
				unified: "1f469-1f3fb-200d-1f9b1",
				native: "👩🏻‍🦱"
			},
			{
				unified: "1f469-1f3fc-200d-1f9b1",
				native: "👩🏼‍🦱"
			},
			{
				unified: "1f469-1f3fd-200d-1f9b1",
				native: "👩🏽‍🦱"
			},
			{
				unified: "1f469-1f3fe-200d-1f9b1",
				native: "👩🏾‍🦱"
			},
			{
				unified: "1f469-1f3ff-200d-1f9b1",
				native: "👩🏿‍🦱"
			}
		],
		version: 11
	},
	curly_haired_person: {
		id: "curly_haired_person",
		name: "Person: Curly Hair",
		keywords: [
			"haired",
			"person",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f9b1",
				native: "🧑‍🦱"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f9b1",
				native: "🧑🏻‍🦱"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f9b1",
				native: "🧑🏼‍🦱"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f9b1",
				native: "🧑🏽‍🦱"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f9b1",
				native: "🧑🏾‍🦱"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f9b1",
				native: "🧑🏿‍🦱"
			}
		],
		version: 12.1
	},
	white_haired_woman: {
		id: "white_haired_woman",
		name: "Woman: White Hair",
		keywords: [
			"haired",
			"woman",
			"old",
			"elder"
		],
		skins: [
			{
				unified: "1f469-200d-1f9b3",
				native: "👩‍🦳"
			},
			{
				unified: "1f469-1f3fb-200d-1f9b3",
				native: "👩🏻‍🦳"
			},
			{
				unified: "1f469-1f3fc-200d-1f9b3",
				native: "👩🏼‍🦳"
			},
			{
				unified: "1f469-1f3fd-200d-1f9b3",
				native: "👩🏽‍🦳"
			},
			{
				unified: "1f469-1f3fe-200d-1f9b3",
				native: "👩🏾‍🦳"
			},
			{
				unified: "1f469-1f3ff-200d-1f9b3",
				native: "👩🏿‍🦳"
			}
		],
		version: 11
	},
	white_haired_person: {
		id: "white_haired_person",
		name: "Person: White Hair",
		keywords: [
			"haired",
			"person",
			"elder",
			"old"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f9b3",
				native: "🧑‍🦳"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f9b3",
				native: "🧑🏻‍🦳"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f9b3",
				native: "🧑🏼‍🦳"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f9b3",
				native: "🧑🏽‍🦳"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f9b3",
				native: "🧑🏾‍🦳"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f9b3",
				native: "🧑🏿‍🦳"
			}
		],
		version: 12.1
	},
	bald_woman: {
		id: "bald_woman",
		name: "Woman: Bald",
		keywords: [
			"woman",
			"hairless"
		],
		skins: [
			{
				unified: "1f469-200d-1f9b2",
				native: "👩‍🦲"
			},
			{
				unified: "1f469-1f3fb-200d-1f9b2",
				native: "👩🏻‍🦲"
			},
			{
				unified: "1f469-1f3fc-200d-1f9b2",
				native: "👩🏼‍🦲"
			},
			{
				unified: "1f469-1f3fd-200d-1f9b2",
				native: "👩🏽‍🦲"
			},
			{
				unified: "1f469-1f3fe-200d-1f9b2",
				native: "👩🏾‍🦲"
			},
			{
				unified: "1f469-1f3ff-200d-1f9b2",
				native: "👩🏿‍🦲"
			}
		],
		version: 11
	},
	bald_person: {
		id: "bald_person",
		name: "Person: Bald",
		keywords: [
			"person",
			"hairless"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f9b2",
				native: "🧑‍🦲"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f9b2",
				native: "🧑🏻‍🦲"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f9b2",
				native: "🧑🏼‍🦲"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f9b2",
				native: "🧑🏽‍🦲"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f9b2",
				native: "🧑🏾‍🦲"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f9b2",
				native: "🧑🏿‍🦲"
			}
		],
		version: 12.1
	},
	"blond-haired-woman": {
		id: "blond-haired-woman",
		name: "Woman: Blond Hair",
		keywords: [
			"haired-woman",
			"woman",
			"female",
			"girl",
			"blonde",
			"person"
		],
		skins: [
			{
				unified: "1f471-200d-2640-fe0f",
				native: "👱‍♀️"
			},
			{
				unified: "1f471-1f3fb-200d-2640-fe0f",
				native: "👱🏻‍♀️"
			},
			{
				unified: "1f471-1f3fc-200d-2640-fe0f",
				native: "👱🏼‍♀️"
			},
			{
				unified: "1f471-1f3fd-200d-2640-fe0f",
				native: "👱🏽‍♀️"
			},
			{
				unified: "1f471-1f3fe-200d-2640-fe0f",
				native: "👱🏾‍♀️"
			},
			{
				unified: "1f471-1f3ff-200d-2640-fe0f",
				native: "👱🏿‍♀️"
			}
		],
		version: 4
	},
	"blond-haired-man": {
		id: "blond-haired-man",
		name: "Man: Blond Hair",
		keywords: [
			"haired-man",
			"man",
			"male",
			"boy",
			"blonde",
			"guy",
			"person"
		],
		skins: [
			{
				unified: "1f471-200d-2642-fe0f",
				native: "👱‍♂️"
			},
			{
				unified: "1f471-1f3fb-200d-2642-fe0f",
				native: "👱🏻‍♂️"
			},
			{
				unified: "1f471-1f3fc-200d-2642-fe0f",
				native: "👱🏼‍♂️"
			},
			{
				unified: "1f471-1f3fd-200d-2642-fe0f",
				native: "👱🏽‍♂️"
			},
			{
				unified: "1f471-1f3fe-200d-2642-fe0f",
				native: "👱🏾‍♂️"
			},
			{
				unified: "1f471-1f3ff-200d-2642-fe0f",
				native: "👱🏿‍♂️"
			}
		],
		version: 4
	},
	older_adult: {
		id: "older_adult",
		name: "Older Adult",
		keywords: [
			"person",
			"human",
			"elder",
			"senior",
			"gender",
			"neutral"
		],
		skins: [
			{
				unified: "1f9d3",
				native: "🧓"
			},
			{
				unified: "1f9d3-1f3fb",
				native: "🧓🏻"
			},
			{
				unified: "1f9d3-1f3fc",
				native: "🧓🏼"
			},
			{
				unified: "1f9d3-1f3fd",
				native: "🧓🏽"
			},
			{
				unified: "1f9d3-1f3fe",
				native: "🧓🏾"
			},
			{
				unified: "1f9d3-1f3ff",
				native: "🧓🏿"
			}
		],
		version: 5
	},
	older_man: {
		id: "older_man",
		name: "Old Man",
		keywords: [
			"older",
			"human",
			"male",
			"men",
			"elder",
			"senior"
		],
		skins: [
			{
				unified: "1f474",
				native: "👴"
			},
			{
				unified: "1f474-1f3fb",
				native: "👴🏻"
			},
			{
				unified: "1f474-1f3fc",
				native: "👴🏼"
			},
			{
				unified: "1f474-1f3fd",
				native: "👴🏽"
			},
			{
				unified: "1f474-1f3fe",
				native: "👴🏾"
			},
			{
				unified: "1f474-1f3ff",
				native: "👴🏿"
			}
		],
		version: 1
	},
	older_woman: {
		id: "older_woman",
		name: "Old Woman",
		keywords: [
			"older",
			"human",
			"female",
			"women",
			"lady",
			"elder",
			"senior"
		],
		skins: [
			{
				unified: "1f475",
				native: "👵"
			},
			{
				unified: "1f475-1f3fb",
				native: "👵🏻"
			},
			{
				unified: "1f475-1f3fc",
				native: "👵🏼"
			},
			{
				unified: "1f475-1f3fd",
				native: "👵🏽"
			},
			{
				unified: "1f475-1f3fe",
				native: "👵🏾"
			},
			{
				unified: "1f475-1f3ff",
				native: "👵🏿"
			}
		],
		version: 1
	},
	person_frowning: {
		id: "person_frowning",
		name: "Person Frowning",
		keywords: [
			"worried"
		],
		skins: [
			{
				unified: "1f64d",
				native: "🙍"
			},
			{
				unified: "1f64d-1f3fb",
				native: "🙍🏻"
			},
			{
				unified: "1f64d-1f3fc",
				native: "🙍🏼"
			},
			{
				unified: "1f64d-1f3fd",
				native: "🙍🏽"
			},
			{
				unified: "1f64d-1f3fe",
				native: "🙍🏾"
			},
			{
				unified: "1f64d-1f3ff",
				native: "🙍🏿"
			}
		],
		version: 1
	},
	"man-frowning": {
		id: "man-frowning",
		name: "Man Frowning",
		keywords: [
			"male",
			"boy",
			"sad",
			"depressed",
			"discouraged",
			"unhappy"
		],
		skins: [
			{
				unified: "1f64d-200d-2642-fe0f",
				native: "🙍‍♂️"
			},
			{
				unified: "1f64d-1f3fb-200d-2642-fe0f",
				native: "🙍🏻‍♂️"
			},
			{
				unified: "1f64d-1f3fc-200d-2642-fe0f",
				native: "🙍🏼‍♂️"
			},
			{
				unified: "1f64d-1f3fd-200d-2642-fe0f",
				native: "🙍🏽‍♂️"
			},
			{
				unified: "1f64d-1f3fe-200d-2642-fe0f",
				native: "🙍🏾‍♂️"
			},
			{
				unified: "1f64d-1f3ff-200d-2642-fe0f",
				native: "🙍🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-frowning": {
		id: "woman-frowning",
		name: "Woman Frowning",
		keywords: [
			"female",
			"girl",
			"sad",
			"depressed",
			"discouraged",
			"unhappy"
		],
		skins: [
			{
				unified: "1f64d-200d-2640-fe0f",
				native: "🙍‍♀️"
			},
			{
				unified: "1f64d-1f3fb-200d-2640-fe0f",
				native: "🙍🏻‍♀️"
			},
			{
				unified: "1f64d-1f3fc-200d-2640-fe0f",
				native: "🙍🏼‍♀️"
			},
			{
				unified: "1f64d-1f3fd-200d-2640-fe0f",
				native: "🙍🏽‍♀️"
			},
			{
				unified: "1f64d-1f3fe-200d-2640-fe0f",
				native: "🙍🏾‍♀️"
			},
			{
				unified: "1f64d-1f3ff-200d-2640-fe0f",
				native: "🙍🏿‍♀️"
			}
		],
		version: 4
	},
	person_with_pouting_face: {
		id: "person_with_pouting_face",
		name: "Person Pouting",
		keywords: [
			"with",
			"face",
			"upset"
		],
		skins: [
			{
				unified: "1f64e",
				native: "🙎"
			},
			{
				unified: "1f64e-1f3fb",
				native: "🙎🏻"
			},
			{
				unified: "1f64e-1f3fc",
				native: "🙎🏼"
			},
			{
				unified: "1f64e-1f3fd",
				native: "🙎🏽"
			},
			{
				unified: "1f64e-1f3fe",
				native: "🙎🏾"
			},
			{
				unified: "1f64e-1f3ff",
				native: "🙎🏿"
			}
		],
		version: 1
	},
	"man-pouting": {
		id: "man-pouting",
		name: "Man Pouting",
		keywords: [
			"male",
			"boy"
		],
		skins: [
			{
				unified: "1f64e-200d-2642-fe0f",
				native: "🙎‍♂️"
			},
			{
				unified: "1f64e-1f3fb-200d-2642-fe0f",
				native: "🙎🏻‍♂️"
			},
			{
				unified: "1f64e-1f3fc-200d-2642-fe0f",
				native: "🙎🏼‍♂️"
			},
			{
				unified: "1f64e-1f3fd-200d-2642-fe0f",
				native: "🙎🏽‍♂️"
			},
			{
				unified: "1f64e-1f3fe-200d-2642-fe0f",
				native: "🙎🏾‍♂️"
			},
			{
				unified: "1f64e-1f3ff-200d-2642-fe0f",
				native: "🙎🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-pouting": {
		id: "woman-pouting",
		name: "Woman Pouting",
		keywords: [
			"female",
			"girl"
		],
		skins: [
			{
				unified: "1f64e-200d-2640-fe0f",
				native: "🙎‍♀️"
			},
			{
				unified: "1f64e-1f3fb-200d-2640-fe0f",
				native: "🙎🏻‍♀️"
			},
			{
				unified: "1f64e-1f3fc-200d-2640-fe0f",
				native: "🙎🏼‍♀️"
			},
			{
				unified: "1f64e-1f3fd-200d-2640-fe0f",
				native: "🙎🏽‍♀️"
			},
			{
				unified: "1f64e-1f3fe-200d-2640-fe0f",
				native: "🙎🏾‍♀️"
			},
			{
				unified: "1f64e-1f3ff-200d-2640-fe0f",
				native: "🙎🏿‍♀️"
			}
		],
		version: 4
	},
	no_good: {
		id: "no_good",
		name: "Person Gesturing No",
		keywords: [
			"good",
			"decline"
		],
		skins: [
			{
				unified: "1f645",
				native: "🙅"
			},
			{
				unified: "1f645-1f3fb",
				native: "🙅🏻"
			},
			{
				unified: "1f645-1f3fc",
				native: "🙅🏼"
			},
			{
				unified: "1f645-1f3fd",
				native: "🙅🏽"
			},
			{
				unified: "1f645-1f3fe",
				native: "🙅🏾"
			},
			{
				unified: "1f645-1f3ff",
				native: "🙅🏿"
			}
		],
		version: 1
	},
	"man-gesturing-no": {
		id: "man-gesturing-no",
		name: "Man Gesturing No",
		keywords: [
			"gesturing-no",
			"male",
			"boy",
			"nope"
		],
		skins: [
			{
				unified: "1f645-200d-2642-fe0f",
				native: "🙅‍♂️"
			},
			{
				unified: "1f645-1f3fb-200d-2642-fe0f",
				native: "🙅🏻‍♂️"
			},
			{
				unified: "1f645-1f3fc-200d-2642-fe0f",
				native: "🙅🏼‍♂️"
			},
			{
				unified: "1f645-1f3fd-200d-2642-fe0f",
				native: "🙅🏽‍♂️"
			},
			{
				unified: "1f645-1f3fe-200d-2642-fe0f",
				native: "🙅🏾‍♂️"
			},
			{
				unified: "1f645-1f3ff-200d-2642-fe0f",
				native: "🙅🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-gesturing-no": {
		id: "woman-gesturing-no",
		name: "Woman Gesturing No",
		keywords: [
			"gesturing-no",
			"female",
			"girl",
			"nope"
		],
		skins: [
			{
				unified: "1f645-200d-2640-fe0f",
				native: "🙅‍♀️"
			},
			{
				unified: "1f645-1f3fb-200d-2640-fe0f",
				native: "🙅🏻‍♀️"
			},
			{
				unified: "1f645-1f3fc-200d-2640-fe0f",
				native: "🙅🏼‍♀️"
			},
			{
				unified: "1f645-1f3fd-200d-2640-fe0f",
				native: "🙅🏽‍♀️"
			},
			{
				unified: "1f645-1f3fe-200d-2640-fe0f",
				native: "🙅🏾‍♀️"
			},
			{
				unified: "1f645-1f3ff-200d-2640-fe0f",
				native: "🙅🏿‍♀️"
			}
		],
		version: 4
	},
	ok_woman: {
		id: "ok_woman",
		name: "Person Gesturing Ok",
		keywords: [
			"woman",
			"agree"
		],
		skins: [
			{
				unified: "1f646",
				native: "🙆"
			},
			{
				unified: "1f646-1f3fb",
				native: "🙆🏻"
			},
			{
				unified: "1f646-1f3fc",
				native: "🙆🏼"
			},
			{
				unified: "1f646-1f3fd",
				native: "🙆🏽"
			},
			{
				unified: "1f646-1f3fe",
				native: "🙆🏾"
			},
			{
				unified: "1f646-1f3ff",
				native: "🙆🏿"
			}
		],
		version: 1
	},
	"man-gesturing-ok": {
		id: "man-gesturing-ok",
		name: "Man Gesturing Ok",
		keywords: [
			"gesturing-ok",
			"men",
			"boy",
			"male",
			"blue",
			"human"
		],
		skins: [
			{
				unified: "1f646-200d-2642-fe0f",
				native: "🙆‍♂️"
			},
			{
				unified: "1f646-1f3fb-200d-2642-fe0f",
				native: "🙆🏻‍♂️"
			},
			{
				unified: "1f646-1f3fc-200d-2642-fe0f",
				native: "🙆🏼‍♂️"
			},
			{
				unified: "1f646-1f3fd-200d-2642-fe0f",
				native: "🙆🏽‍♂️"
			},
			{
				unified: "1f646-1f3fe-200d-2642-fe0f",
				native: "🙆🏾‍♂️"
			},
			{
				unified: "1f646-1f3ff-200d-2642-fe0f",
				native: "🙆🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-gesturing-ok": {
		id: "woman-gesturing-ok",
		name: "Woman Gesturing Ok",
		keywords: [
			"gesturing-ok",
			"women",
			"girl",
			"female",
			"pink",
			"human"
		],
		skins: [
			{
				unified: "1f646-200d-2640-fe0f",
				native: "🙆‍♀️"
			},
			{
				unified: "1f646-1f3fb-200d-2640-fe0f",
				native: "🙆🏻‍♀️"
			},
			{
				unified: "1f646-1f3fc-200d-2640-fe0f",
				native: "🙆🏼‍♀️"
			},
			{
				unified: "1f646-1f3fd-200d-2640-fe0f",
				native: "🙆🏽‍♀️"
			},
			{
				unified: "1f646-1f3fe-200d-2640-fe0f",
				native: "🙆🏾‍♀️"
			},
			{
				unified: "1f646-1f3ff-200d-2640-fe0f",
				native: "🙆🏿‍♀️"
			}
		],
		version: 4
	},
	information_desk_person: {
		id: "information_desk_person",
		name: "Person Tipping Hand",
		keywords: [
			"information",
			"desk"
		],
		skins: [
			{
				unified: "1f481",
				native: "💁"
			},
			{
				unified: "1f481-1f3fb",
				native: "💁🏻"
			},
			{
				unified: "1f481-1f3fc",
				native: "💁🏼"
			},
			{
				unified: "1f481-1f3fd",
				native: "💁🏽"
			},
			{
				unified: "1f481-1f3fe",
				native: "💁🏾"
			},
			{
				unified: "1f481-1f3ff",
				native: "💁🏿"
			}
		],
		version: 1
	},
	"man-tipping-hand": {
		id: "man-tipping-hand",
		name: "Man Tipping Hand",
		keywords: [
			"tipping-hand",
			"male",
			"boy",
			"human",
			"information"
		],
		skins: [
			{
				unified: "1f481-200d-2642-fe0f",
				native: "💁‍♂️"
			},
			{
				unified: "1f481-1f3fb-200d-2642-fe0f",
				native: "💁🏻‍♂️"
			},
			{
				unified: "1f481-1f3fc-200d-2642-fe0f",
				native: "💁🏼‍♂️"
			},
			{
				unified: "1f481-1f3fd-200d-2642-fe0f",
				native: "💁🏽‍♂️"
			},
			{
				unified: "1f481-1f3fe-200d-2642-fe0f",
				native: "💁🏾‍♂️"
			},
			{
				unified: "1f481-1f3ff-200d-2642-fe0f",
				native: "💁🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-tipping-hand": {
		id: "woman-tipping-hand",
		name: "Woman Tipping Hand",
		keywords: [
			"tipping-hand",
			"female",
			"girl",
			"human",
			"information"
		],
		skins: [
			{
				unified: "1f481-200d-2640-fe0f",
				native: "💁‍♀️"
			},
			{
				unified: "1f481-1f3fb-200d-2640-fe0f",
				native: "💁🏻‍♀️"
			},
			{
				unified: "1f481-1f3fc-200d-2640-fe0f",
				native: "💁🏼‍♀️"
			},
			{
				unified: "1f481-1f3fd-200d-2640-fe0f",
				native: "💁🏽‍♀️"
			},
			{
				unified: "1f481-1f3fe-200d-2640-fe0f",
				native: "💁🏾‍♀️"
			},
			{
				unified: "1f481-1f3ff-200d-2640-fe0f",
				native: "💁🏿‍♀️"
			}
		],
		version: 4
	},
	raising_hand: {
		id: "raising_hand",
		name: "Person Raising Hand",
		keywords: [
			"question"
		],
		skins: [
			{
				unified: "1f64b",
				native: "🙋"
			},
			{
				unified: "1f64b-1f3fb",
				native: "🙋🏻"
			},
			{
				unified: "1f64b-1f3fc",
				native: "🙋🏼"
			},
			{
				unified: "1f64b-1f3fd",
				native: "🙋🏽"
			},
			{
				unified: "1f64b-1f3fe",
				native: "🙋🏾"
			},
			{
				unified: "1f64b-1f3ff",
				native: "🙋🏿"
			}
		],
		version: 1
	},
	"man-raising-hand": {
		id: "man-raising-hand",
		name: "Man Raising Hand",
		keywords: [
			"raising-hand",
			"male",
			"boy"
		],
		skins: [
			{
				unified: "1f64b-200d-2642-fe0f",
				native: "🙋‍♂️"
			},
			{
				unified: "1f64b-1f3fb-200d-2642-fe0f",
				native: "🙋🏻‍♂️"
			},
			{
				unified: "1f64b-1f3fc-200d-2642-fe0f",
				native: "🙋🏼‍♂️"
			},
			{
				unified: "1f64b-1f3fd-200d-2642-fe0f",
				native: "🙋🏽‍♂️"
			},
			{
				unified: "1f64b-1f3fe-200d-2642-fe0f",
				native: "🙋🏾‍♂️"
			},
			{
				unified: "1f64b-1f3ff-200d-2642-fe0f",
				native: "🙋🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-raising-hand": {
		id: "woman-raising-hand",
		name: "Woman Raising Hand",
		keywords: [
			"raising-hand",
			"female",
			"girl"
		],
		skins: [
			{
				unified: "1f64b-200d-2640-fe0f",
				native: "🙋‍♀️"
			},
			{
				unified: "1f64b-1f3fb-200d-2640-fe0f",
				native: "🙋🏻‍♀️"
			},
			{
				unified: "1f64b-1f3fc-200d-2640-fe0f",
				native: "🙋🏼‍♀️"
			},
			{
				unified: "1f64b-1f3fd-200d-2640-fe0f",
				native: "🙋🏽‍♀️"
			},
			{
				unified: "1f64b-1f3fe-200d-2640-fe0f",
				native: "🙋🏾‍♀️"
			},
			{
				unified: "1f64b-1f3ff-200d-2640-fe0f",
				native: "🙋🏿‍♀️"
			}
		],
		version: 4
	},
	deaf_person: {
		id: "deaf_person",
		name: "Deaf Person",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9cf",
				native: "🧏"
			},
			{
				unified: "1f9cf-1f3fb",
				native: "🧏🏻"
			},
			{
				unified: "1f9cf-1f3fc",
				native: "🧏🏼"
			},
			{
				unified: "1f9cf-1f3fd",
				native: "🧏🏽"
			},
			{
				unified: "1f9cf-1f3fe",
				native: "🧏🏾"
			},
			{
				unified: "1f9cf-1f3ff",
				native: "🧏🏿"
			}
		],
		version: 12
	},
	deaf_man: {
		id: "deaf_man",
		name: "Deaf Man",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9cf-200d-2642-fe0f",
				native: "🧏‍♂️"
			},
			{
				unified: "1f9cf-1f3fb-200d-2642-fe0f",
				native: "🧏🏻‍♂️"
			},
			{
				unified: "1f9cf-1f3fc-200d-2642-fe0f",
				native: "🧏🏼‍♂️"
			},
			{
				unified: "1f9cf-1f3fd-200d-2642-fe0f",
				native: "🧏🏽‍♂️"
			},
			{
				unified: "1f9cf-1f3fe-200d-2642-fe0f",
				native: "🧏🏾‍♂️"
			},
			{
				unified: "1f9cf-1f3ff-200d-2642-fe0f",
				native: "🧏🏿‍♂️"
			}
		],
		version: 12
	},
	deaf_woman: {
		id: "deaf_woman",
		name: "Deaf Woman",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9cf-200d-2640-fe0f",
				native: "🧏‍♀️"
			},
			{
				unified: "1f9cf-1f3fb-200d-2640-fe0f",
				native: "🧏🏻‍♀️"
			},
			{
				unified: "1f9cf-1f3fc-200d-2640-fe0f",
				native: "🧏🏼‍♀️"
			},
			{
				unified: "1f9cf-1f3fd-200d-2640-fe0f",
				native: "🧏🏽‍♀️"
			},
			{
				unified: "1f9cf-1f3fe-200d-2640-fe0f",
				native: "🧏🏾‍♀️"
			},
			{
				unified: "1f9cf-1f3ff-200d-2640-fe0f",
				native: "🧏🏿‍♀️"
			}
		],
		version: 12
	},
	bow: {
		id: "bow",
		name: "Person Bowing",
		keywords: [
			"bow",
			"respectiful"
		],
		skins: [
			{
				unified: "1f647",
				native: "🙇"
			},
			{
				unified: "1f647-1f3fb",
				native: "🙇🏻"
			},
			{
				unified: "1f647-1f3fc",
				native: "🙇🏼"
			},
			{
				unified: "1f647-1f3fd",
				native: "🙇🏽"
			},
			{
				unified: "1f647-1f3fe",
				native: "🙇🏾"
			},
			{
				unified: "1f647-1f3ff",
				native: "🙇🏿"
			}
		],
		version: 1
	},
	"man-bowing": {
		id: "man-bowing",
		name: "Man Bowing",
		keywords: [
			"male",
			"boy"
		],
		skins: [
			{
				unified: "1f647-200d-2642-fe0f",
				native: "🙇‍♂️"
			},
			{
				unified: "1f647-1f3fb-200d-2642-fe0f",
				native: "🙇🏻‍♂️"
			},
			{
				unified: "1f647-1f3fc-200d-2642-fe0f",
				native: "🙇🏼‍♂️"
			},
			{
				unified: "1f647-1f3fd-200d-2642-fe0f",
				native: "🙇🏽‍♂️"
			},
			{
				unified: "1f647-1f3fe-200d-2642-fe0f",
				native: "🙇🏾‍♂️"
			},
			{
				unified: "1f647-1f3ff-200d-2642-fe0f",
				native: "🙇🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-bowing": {
		id: "woman-bowing",
		name: "Woman Bowing",
		keywords: [
			"female",
			"girl"
		],
		skins: [
			{
				unified: "1f647-200d-2640-fe0f",
				native: "🙇‍♀️"
			},
			{
				unified: "1f647-1f3fb-200d-2640-fe0f",
				native: "🙇🏻‍♀️"
			},
			{
				unified: "1f647-1f3fc-200d-2640-fe0f",
				native: "🙇🏼‍♀️"
			},
			{
				unified: "1f647-1f3fd-200d-2640-fe0f",
				native: "🙇🏽‍♀️"
			},
			{
				unified: "1f647-1f3fe-200d-2640-fe0f",
				native: "🙇🏾‍♀️"
			},
			{
				unified: "1f647-1f3ff-200d-2640-fe0f",
				native: "🙇🏿‍♀️"
			}
		],
		version: 4
	},
	face_palm: {
		id: "face_palm",
		name: "Face Palm",
		keywords: [
			"person",
			"facepalming",
			"disappointed"
		],
		skins: [
			{
				unified: "1f926",
				native: "🤦"
			},
			{
				unified: "1f926-1f3fb",
				native: "🤦🏻"
			},
			{
				unified: "1f926-1f3fc",
				native: "🤦🏼"
			},
			{
				unified: "1f926-1f3fd",
				native: "🤦🏽"
			},
			{
				unified: "1f926-1f3fe",
				native: "🤦🏾"
			},
			{
				unified: "1f926-1f3ff",
				native: "🤦🏿"
			}
		],
		version: 3
	},
	"man-facepalming": {
		id: "man-facepalming",
		name: "Man Facepalming",
		keywords: [
			"male",
			"boy",
			"disbelief"
		],
		skins: [
			{
				unified: "1f926-200d-2642-fe0f",
				native: "🤦‍♂️"
			},
			{
				unified: "1f926-1f3fb-200d-2642-fe0f",
				native: "🤦🏻‍♂️"
			},
			{
				unified: "1f926-1f3fc-200d-2642-fe0f",
				native: "🤦🏼‍♂️"
			},
			{
				unified: "1f926-1f3fd-200d-2642-fe0f",
				native: "🤦🏽‍♂️"
			},
			{
				unified: "1f926-1f3fe-200d-2642-fe0f",
				native: "🤦🏾‍♂️"
			},
			{
				unified: "1f926-1f3ff-200d-2642-fe0f",
				native: "🤦🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-facepalming": {
		id: "woman-facepalming",
		name: "Woman Facepalming",
		keywords: [
			"female",
			"girl",
			"disbelief"
		],
		skins: [
			{
				unified: "1f926-200d-2640-fe0f",
				native: "🤦‍♀️"
			},
			{
				unified: "1f926-1f3fb-200d-2640-fe0f",
				native: "🤦🏻‍♀️"
			},
			{
				unified: "1f926-1f3fc-200d-2640-fe0f",
				native: "🤦🏼‍♀️"
			},
			{
				unified: "1f926-1f3fd-200d-2640-fe0f",
				native: "🤦🏽‍♀️"
			},
			{
				unified: "1f926-1f3fe-200d-2640-fe0f",
				native: "🤦🏾‍♀️"
			},
			{
				unified: "1f926-1f3ff-200d-2640-fe0f",
				native: "🤦🏿‍♀️"
			}
		],
		version: 4
	},
	shrug: {
		id: "shrug",
		name: "Shrug",
		keywords: [
			"person",
			"shrugging",
			"regardless"
		],
		skins: [
			{
				unified: "1f937",
				native: "🤷"
			},
			{
				unified: "1f937-1f3fb",
				native: "🤷🏻"
			},
			{
				unified: "1f937-1f3fc",
				native: "🤷🏼"
			},
			{
				unified: "1f937-1f3fd",
				native: "🤷🏽"
			},
			{
				unified: "1f937-1f3fe",
				native: "🤷🏾"
			},
			{
				unified: "1f937-1f3ff",
				native: "🤷🏿"
			}
		],
		version: 3
	},
	"man-shrugging": {
		id: "man-shrugging",
		name: "Man Shrugging",
		keywords: [
			"male",
			"boy",
			"confused",
			"indifferent",
			"doubt"
		],
		skins: [
			{
				unified: "1f937-200d-2642-fe0f",
				native: "🤷‍♂️"
			},
			{
				unified: "1f937-1f3fb-200d-2642-fe0f",
				native: "🤷🏻‍♂️"
			},
			{
				unified: "1f937-1f3fc-200d-2642-fe0f",
				native: "🤷🏼‍♂️"
			},
			{
				unified: "1f937-1f3fd-200d-2642-fe0f",
				native: "🤷🏽‍♂️"
			},
			{
				unified: "1f937-1f3fe-200d-2642-fe0f",
				native: "🤷🏾‍♂️"
			},
			{
				unified: "1f937-1f3ff-200d-2642-fe0f",
				native: "🤷🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-shrugging": {
		id: "woman-shrugging",
		name: "Woman Shrugging",
		keywords: [
			"female",
			"girl",
			"confused",
			"indifferent",
			"doubt"
		],
		skins: [
			{
				unified: "1f937-200d-2640-fe0f",
				native: "🤷‍♀️"
			},
			{
				unified: "1f937-1f3fb-200d-2640-fe0f",
				native: "🤷🏻‍♀️"
			},
			{
				unified: "1f937-1f3fc-200d-2640-fe0f",
				native: "🤷🏼‍♀️"
			},
			{
				unified: "1f937-1f3fd-200d-2640-fe0f",
				native: "🤷🏽‍♀️"
			},
			{
				unified: "1f937-1f3fe-200d-2640-fe0f",
				native: "🤷🏾‍♀️"
			},
			{
				unified: "1f937-1f3ff-200d-2640-fe0f",
				native: "🤷🏿‍♀️"
			}
		],
		version: 4
	},
	health_worker: {
		id: "health_worker",
		name: "Health Worker",
		keywords: [
			"hospital"
		],
		skins: [
			{
				unified: "1f9d1-200d-2695-fe0f",
				native: "🧑‍⚕️"
			},
			{
				unified: "1f9d1-1f3fb-200d-2695-fe0f",
				native: "🧑🏻‍⚕️"
			},
			{
				unified: "1f9d1-1f3fc-200d-2695-fe0f",
				native: "🧑🏼‍⚕️"
			},
			{
				unified: "1f9d1-1f3fd-200d-2695-fe0f",
				native: "🧑🏽‍⚕️"
			},
			{
				unified: "1f9d1-1f3fe-200d-2695-fe0f",
				native: "🧑🏾‍⚕️"
			},
			{
				unified: "1f9d1-1f3ff-200d-2695-fe0f",
				native: "🧑🏿‍⚕️"
			}
		],
		version: 12.1
	},
	"male-doctor": {
		id: "male-doctor",
		name: "Man Health Worker",
		keywords: [
			"male",
			"doctor",
			"nurse",
			"therapist",
			"healthcare",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-2695-fe0f",
				native: "👨‍⚕️"
			},
			{
				unified: "1f468-1f3fb-200d-2695-fe0f",
				native: "👨🏻‍⚕️"
			},
			{
				unified: "1f468-1f3fc-200d-2695-fe0f",
				native: "👨🏼‍⚕️"
			},
			{
				unified: "1f468-1f3fd-200d-2695-fe0f",
				native: "👨🏽‍⚕️"
			},
			{
				unified: "1f468-1f3fe-200d-2695-fe0f",
				native: "👨🏾‍⚕️"
			},
			{
				unified: "1f468-1f3ff-200d-2695-fe0f",
				native: "👨🏿‍⚕️"
			}
		],
		version: 4
	},
	"female-doctor": {
		id: "female-doctor",
		name: "Woman Health Worker",
		keywords: [
			"female",
			"doctor",
			"nurse",
			"therapist",
			"healthcare",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-2695-fe0f",
				native: "👩‍⚕️"
			},
			{
				unified: "1f469-1f3fb-200d-2695-fe0f",
				native: "👩🏻‍⚕️"
			},
			{
				unified: "1f469-1f3fc-200d-2695-fe0f",
				native: "👩🏼‍⚕️"
			},
			{
				unified: "1f469-1f3fd-200d-2695-fe0f",
				native: "👩🏽‍⚕️"
			},
			{
				unified: "1f469-1f3fe-200d-2695-fe0f",
				native: "👩🏾‍⚕️"
			},
			{
				unified: "1f469-1f3ff-200d-2695-fe0f",
				native: "👩🏿‍⚕️"
			}
		],
		version: 4
	},
	student: {
		id: "student",
		name: "Student",
		keywords: [
			"learn"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f393",
				native: "🧑‍🎓"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f393",
				native: "🧑🏻‍🎓"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f393",
				native: "🧑🏼‍🎓"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f393",
				native: "🧑🏽‍🎓"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f393",
				native: "🧑🏾‍🎓"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f393",
				native: "🧑🏿‍🎓"
			}
		],
		version: 12.1
	},
	"male-student": {
		id: "male-student",
		name: "Man Student",
		keywords: [
			"male",
			"graduate",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f393",
				native: "👨‍🎓"
			},
			{
				unified: "1f468-1f3fb-200d-1f393",
				native: "👨🏻‍🎓"
			},
			{
				unified: "1f468-1f3fc-200d-1f393",
				native: "👨🏼‍🎓"
			},
			{
				unified: "1f468-1f3fd-200d-1f393",
				native: "👨🏽‍🎓"
			},
			{
				unified: "1f468-1f3fe-200d-1f393",
				native: "👨🏾‍🎓"
			},
			{
				unified: "1f468-1f3ff-200d-1f393",
				native: "👨🏿‍🎓"
			}
		],
		version: 4
	},
	"female-student": {
		id: "female-student",
		name: "Woman Student",
		keywords: [
			"female",
			"graduate",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f393",
				native: "👩‍🎓"
			},
			{
				unified: "1f469-1f3fb-200d-1f393",
				native: "👩🏻‍🎓"
			},
			{
				unified: "1f469-1f3fc-200d-1f393",
				native: "👩🏼‍🎓"
			},
			{
				unified: "1f469-1f3fd-200d-1f393",
				native: "👩🏽‍🎓"
			},
			{
				unified: "1f469-1f3fe-200d-1f393",
				native: "👩🏾‍🎓"
			},
			{
				unified: "1f469-1f3ff-200d-1f393",
				native: "👩🏿‍🎓"
			}
		],
		version: 4
	},
	teacher: {
		id: "teacher",
		name: "Teacher",
		keywords: [
			"professor"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f3eb",
				native: "🧑‍🏫"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f3eb",
				native: "🧑🏻‍🏫"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f3eb",
				native: "🧑🏼‍🏫"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f3eb",
				native: "🧑🏽‍🏫"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f3eb",
				native: "🧑🏾‍🏫"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f3eb",
				native: "🧑🏿‍🏫"
			}
		],
		version: 12.1
	},
	"male-teacher": {
		id: "male-teacher",
		name: "Man Teacher",
		keywords: [
			"male",
			"instructor",
			"professor",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f3eb",
				native: "👨‍🏫"
			},
			{
				unified: "1f468-1f3fb-200d-1f3eb",
				native: "👨🏻‍🏫"
			},
			{
				unified: "1f468-1f3fc-200d-1f3eb",
				native: "👨🏼‍🏫"
			},
			{
				unified: "1f468-1f3fd-200d-1f3eb",
				native: "👨🏽‍🏫"
			},
			{
				unified: "1f468-1f3fe-200d-1f3eb",
				native: "👨🏾‍🏫"
			},
			{
				unified: "1f468-1f3ff-200d-1f3eb",
				native: "👨🏿‍🏫"
			}
		],
		version: 4
	},
	"female-teacher": {
		id: "female-teacher",
		name: "Woman Teacher",
		keywords: [
			"female",
			"instructor",
			"professor",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f3eb",
				native: "👩‍🏫"
			},
			{
				unified: "1f469-1f3fb-200d-1f3eb",
				native: "👩🏻‍🏫"
			},
			{
				unified: "1f469-1f3fc-200d-1f3eb",
				native: "👩🏼‍🏫"
			},
			{
				unified: "1f469-1f3fd-200d-1f3eb",
				native: "👩🏽‍🏫"
			},
			{
				unified: "1f469-1f3fe-200d-1f3eb",
				native: "👩🏾‍🏫"
			},
			{
				unified: "1f469-1f3ff-200d-1f3eb",
				native: "👩🏿‍🏫"
			}
		],
		version: 4
	},
	judge: {
		id: "judge",
		name: "Judge",
		keywords: [
			"law"
		],
		skins: [
			{
				unified: "1f9d1-200d-2696-fe0f",
				native: "🧑‍⚖️"
			},
			{
				unified: "1f9d1-1f3fb-200d-2696-fe0f",
				native: "🧑🏻‍⚖️"
			},
			{
				unified: "1f9d1-1f3fc-200d-2696-fe0f",
				native: "🧑🏼‍⚖️"
			},
			{
				unified: "1f9d1-1f3fd-200d-2696-fe0f",
				native: "🧑🏽‍⚖️"
			},
			{
				unified: "1f9d1-1f3fe-200d-2696-fe0f",
				native: "🧑🏾‍⚖️"
			},
			{
				unified: "1f9d1-1f3ff-200d-2696-fe0f",
				native: "🧑🏿‍⚖️"
			}
		],
		version: 12.1
	},
	"male-judge": {
		id: "male-judge",
		name: "Man Judge",
		keywords: [
			"male",
			"justice",
			"court",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-2696-fe0f",
				native: "👨‍⚖️"
			},
			{
				unified: "1f468-1f3fb-200d-2696-fe0f",
				native: "👨🏻‍⚖️"
			},
			{
				unified: "1f468-1f3fc-200d-2696-fe0f",
				native: "👨🏼‍⚖️"
			},
			{
				unified: "1f468-1f3fd-200d-2696-fe0f",
				native: "👨🏽‍⚖️"
			},
			{
				unified: "1f468-1f3fe-200d-2696-fe0f",
				native: "👨🏾‍⚖️"
			},
			{
				unified: "1f468-1f3ff-200d-2696-fe0f",
				native: "👨🏿‍⚖️"
			}
		],
		version: 4
	},
	"female-judge": {
		id: "female-judge",
		name: "Woman Judge",
		keywords: [
			"female",
			"justice",
			"court",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-2696-fe0f",
				native: "👩‍⚖️"
			},
			{
				unified: "1f469-1f3fb-200d-2696-fe0f",
				native: "👩🏻‍⚖️"
			},
			{
				unified: "1f469-1f3fc-200d-2696-fe0f",
				native: "👩🏼‍⚖️"
			},
			{
				unified: "1f469-1f3fd-200d-2696-fe0f",
				native: "👩🏽‍⚖️"
			},
			{
				unified: "1f469-1f3fe-200d-2696-fe0f",
				native: "👩🏾‍⚖️"
			},
			{
				unified: "1f469-1f3ff-200d-2696-fe0f",
				native: "👩🏿‍⚖️"
			}
		],
		version: 4
	},
	farmer: {
		id: "farmer",
		name: "Farmer",
		keywords: [
			"crops"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f33e",
				native: "🧑‍🌾"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f33e",
				native: "🧑🏻‍🌾"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f33e",
				native: "🧑🏼‍🌾"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f33e",
				native: "🧑🏽‍🌾"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f33e",
				native: "🧑🏾‍🌾"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f33e",
				native: "🧑🏿‍🌾"
			}
		],
		version: 12.1
	},
	"male-farmer": {
		id: "male-farmer",
		name: "Man Farmer",
		keywords: [
			"male",
			"rancher",
			"gardener",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f33e",
				native: "👨‍🌾"
			},
			{
				unified: "1f468-1f3fb-200d-1f33e",
				native: "👨🏻‍🌾"
			},
			{
				unified: "1f468-1f3fc-200d-1f33e",
				native: "👨🏼‍🌾"
			},
			{
				unified: "1f468-1f3fd-200d-1f33e",
				native: "👨🏽‍🌾"
			},
			{
				unified: "1f468-1f3fe-200d-1f33e",
				native: "👨🏾‍🌾"
			},
			{
				unified: "1f468-1f3ff-200d-1f33e",
				native: "👨🏿‍🌾"
			}
		],
		version: 4
	},
	"female-farmer": {
		id: "female-farmer",
		name: "Woman Farmer",
		keywords: [
			"female",
			"rancher",
			"gardener",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f33e",
				native: "👩‍🌾"
			},
			{
				unified: "1f469-1f3fb-200d-1f33e",
				native: "👩🏻‍🌾"
			},
			{
				unified: "1f469-1f3fc-200d-1f33e",
				native: "👩🏼‍🌾"
			},
			{
				unified: "1f469-1f3fd-200d-1f33e",
				native: "👩🏽‍🌾"
			},
			{
				unified: "1f469-1f3fe-200d-1f33e",
				native: "👩🏾‍🌾"
			},
			{
				unified: "1f469-1f3ff-200d-1f33e",
				native: "👩🏿‍🌾"
			}
		],
		version: 4
	},
	cook: {
		id: "cook",
		name: "Cook",
		keywords: [
			"food",
			"kitchen",
			"culinary"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f373",
				native: "🧑‍🍳"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f373",
				native: "🧑🏻‍🍳"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f373",
				native: "🧑🏼‍🍳"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f373",
				native: "🧑🏽‍🍳"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f373",
				native: "🧑🏾‍🍳"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f373",
				native: "🧑🏿‍🍳"
			}
		],
		version: 12.1
	},
	"male-cook": {
		id: "male-cook",
		name: "Man Cook",
		keywords: [
			"male",
			"chef",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f373",
				native: "👨‍🍳"
			},
			{
				unified: "1f468-1f3fb-200d-1f373",
				native: "👨🏻‍🍳"
			},
			{
				unified: "1f468-1f3fc-200d-1f373",
				native: "👨🏼‍🍳"
			},
			{
				unified: "1f468-1f3fd-200d-1f373",
				native: "👨🏽‍🍳"
			},
			{
				unified: "1f468-1f3fe-200d-1f373",
				native: "👨🏾‍🍳"
			},
			{
				unified: "1f468-1f3ff-200d-1f373",
				native: "👨🏿‍🍳"
			}
		],
		version: 4
	},
	"female-cook": {
		id: "female-cook",
		name: "Woman Cook",
		keywords: [
			"female",
			"chef",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f373",
				native: "👩‍🍳"
			},
			{
				unified: "1f469-1f3fb-200d-1f373",
				native: "👩🏻‍🍳"
			},
			{
				unified: "1f469-1f3fc-200d-1f373",
				native: "👩🏼‍🍳"
			},
			{
				unified: "1f469-1f3fd-200d-1f373",
				native: "👩🏽‍🍳"
			},
			{
				unified: "1f469-1f3fe-200d-1f373",
				native: "👩🏾‍🍳"
			},
			{
				unified: "1f469-1f3ff-200d-1f373",
				native: "👩🏿‍🍳"
			}
		],
		version: 4
	},
	mechanic: {
		id: "mechanic",
		name: "Mechanic",
		keywords: [
			"worker",
			"technician"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f527",
				native: "🧑‍🔧"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f527",
				native: "🧑🏻‍🔧"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f527",
				native: "🧑🏼‍🔧"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f527",
				native: "🧑🏽‍🔧"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f527",
				native: "🧑🏾‍🔧"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f527",
				native: "🧑🏿‍🔧"
			}
		],
		version: 12.1
	},
	"male-mechanic": {
		id: "male-mechanic",
		name: "Man Mechanic",
		keywords: [
			"male",
			"plumber",
			"human",
			"wrench"
		],
		skins: [
			{
				unified: "1f468-200d-1f527",
				native: "👨‍🔧"
			},
			{
				unified: "1f468-1f3fb-200d-1f527",
				native: "👨🏻‍🔧"
			},
			{
				unified: "1f468-1f3fc-200d-1f527",
				native: "👨🏼‍🔧"
			},
			{
				unified: "1f468-1f3fd-200d-1f527",
				native: "👨🏽‍🔧"
			},
			{
				unified: "1f468-1f3fe-200d-1f527",
				native: "👨🏾‍🔧"
			},
			{
				unified: "1f468-1f3ff-200d-1f527",
				native: "👨🏿‍🔧"
			}
		],
		version: 4
	},
	"female-mechanic": {
		id: "female-mechanic",
		name: "Woman Mechanic",
		keywords: [
			"female",
			"plumber",
			"human",
			"wrench"
		],
		skins: [
			{
				unified: "1f469-200d-1f527",
				native: "👩‍🔧"
			},
			{
				unified: "1f469-1f3fb-200d-1f527",
				native: "👩🏻‍🔧"
			},
			{
				unified: "1f469-1f3fc-200d-1f527",
				native: "👩🏼‍🔧"
			},
			{
				unified: "1f469-1f3fd-200d-1f527",
				native: "👩🏽‍🔧"
			},
			{
				unified: "1f469-1f3fe-200d-1f527",
				native: "👩🏾‍🔧"
			},
			{
				unified: "1f469-1f3ff-200d-1f527",
				native: "👩🏿‍🔧"
			}
		],
		version: 4
	},
	factory_worker: {
		id: "factory_worker",
		name: "Factory Worker",
		keywords: [
			"labor"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f3ed",
				native: "🧑‍🏭"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f3ed",
				native: "🧑🏻‍🏭"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f3ed",
				native: "🧑🏼‍🏭"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f3ed",
				native: "🧑🏽‍🏭"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f3ed",
				native: "🧑🏾‍🏭"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f3ed",
				native: "🧑🏿‍🏭"
			}
		],
		version: 12.1
	},
	"male-factory-worker": {
		id: "male-factory-worker",
		name: "Man Factory Worker",
		keywords: [
			"male",
			"factory-worker",
			"assembly",
			"industrial",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f3ed",
				native: "👨‍🏭"
			},
			{
				unified: "1f468-1f3fb-200d-1f3ed",
				native: "👨🏻‍🏭"
			},
			{
				unified: "1f468-1f3fc-200d-1f3ed",
				native: "👨🏼‍🏭"
			},
			{
				unified: "1f468-1f3fd-200d-1f3ed",
				native: "👨🏽‍🏭"
			},
			{
				unified: "1f468-1f3fe-200d-1f3ed",
				native: "👨🏾‍🏭"
			},
			{
				unified: "1f468-1f3ff-200d-1f3ed",
				native: "👨🏿‍🏭"
			}
		],
		version: 4
	},
	"female-factory-worker": {
		id: "female-factory-worker",
		name: "Woman Factory Worker",
		keywords: [
			"female",
			"factory-worker",
			"assembly",
			"industrial",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f3ed",
				native: "👩‍🏭"
			},
			{
				unified: "1f469-1f3fb-200d-1f3ed",
				native: "👩🏻‍🏭"
			},
			{
				unified: "1f469-1f3fc-200d-1f3ed",
				native: "👩🏼‍🏭"
			},
			{
				unified: "1f469-1f3fd-200d-1f3ed",
				native: "👩🏽‍🏭"
			},
			{
				unified: "1f469-1f3fe-200d-1f3ed",
				native: "👩🏾‍🏭"
			},
			{
				unified: "1f469-1f3ff-200d-1f3ed",
				native: "👩🏿‍🏭"
			}
		],
		version: 4
	},
	office_worker: {
		id: "office_worker",
		name: "Office Worker",
		keywords: [
			"business"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f4bc",
				native: "🧑‍💼"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f4bc",
				native: "🧑🏻‍💼"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f4bc",
				native: "🧑🏼‍💼"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f4bc",
				native: "🧑🏽‍💼"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f4bc",
				native: "🧑🏾‍💼"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f4bc",
				native: "🧑🏿‍💼"
			}
		],
		version: 12.1
	},
	"male-office-worker": {
		id: "male-office-worker",
		name: "Man Office Worker",
		keywords: [
			"male",
			"office-worker",
			"business",
			"manager",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f4bc",
				native: "👨‍💼"
			},
			{
				unified: "1f468-1f3fb-200d-1f4bc",
				native: "👨🏻‍💼"
			},
			{
				unified: "1f468-1f3fc-200d-1f4bc",
				native: "👨🏼‍💼"
			},
			{
				unified: "1f468-1f3fd-200d-1f4bc",
				native: "👨🏽‍💼"
			},
			{
				unified: "1f468-1f3fe-200d-1f4bc",
				native: "👨🏾‍💼"
			},
			{
				unified: "1f468-1f3ff-200d-1f4bc",
				native: "👨🏿‍💼"
			}
		],
		version: 4
	},
	"female-office-worker": {
		id: "female-office-worker",
		name: "Woman Office Worker",
		keywords: [
			"female",
			"office-worker",
			"business",
			"manager",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f4bc",
				native: "👩‍💼"
			},
			{
				unified: "1f469-1f3fb-200d-1f4bc",
				native: "👩🏻‍💼"
			},
			{
				unified: "1f469-1f3fc-200d-1f4bc",
				native: "👩🏼‍💼"
			},
			{
				unified: "1f469-1f3fd-200d-1f4bc",
				native: "👩🏽‍💼"
			},
			{
				unified: "1f469-1f3fe-200d-1f4bc",
				native: "👩🏾‍💼"
			},
			{
				unified: "1f469-1f3ff-200d-1f4bc",
				native: "👩🏿‍💼"
			}
		],
		version: 4
	},
	scientist: {
		id: "scientist",
		name: "Scientist",
		keywords: [
			"chemistry"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f52c",
				native: "🧑‍🔬"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f52c",
				native: "🧑🏻‍🔬"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f52c",
				native: "🧑🏼‍🔬"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f52c",
				native: "🧑🏽‍🔬"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f52c",
				native: "🧑🏾‍🔬"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f52c",
				native: "🧑🏿‍🔬"
			}
		],
		version: 12.1
	},
	"male-scientist": {
		id: "male-scientist",
		name: "Man Scientist",
		keywords: [
			"male",
			"biologist",
			"chemist",
			"engineer",
			"physicist",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f52c",
				native: "👨‍🔬"
			},
			{
				unified: "1f468-1f3fb-200d-1f52c",
				native: "👨🏻‍🔬"
			},
			{
				unified: "1f468-1f3fc-200d-1f52c",
				native: "👨🏼‍🔬"
			},
			{
				unified: "1f468-1f3fd-200d-1f52c",
				native: "👨🏽‍🔬"
			},
			{
				unified: "1f468-1f3fe-200d-1f52c",
				native: "👨🏾‍🔬"
			},
			{
				unified: "1f468-1f3ff-200d-1f52c",
				native: "👨🏿‍🔬"
			}
		],
		version: 4
	},
	"female-scientist": {
		id: "female-scientist",
		name: "Woman Scientist",
		keywords: [
			"female",
			"biologist",
			"chemist",
			"engineer",
			"physicist",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f52c",
				native: "👩‍🔬"
			},
			{
				unified: "1f469-1f3fb-200d-1f52c",
				native: "👩🏻‍🔬"
			},
			{
				unified: "1f469-1f3fc-200d-1f52c",
				native: "👩🏼‍🔬"
			},
			{
				unified: "1f469-1f3fd-200d-1f52c",
				native: "👩🏽‍🔬"
			},
			{
				unified: "1f469-1f3fe-200d-1f52c",
				native: "👩🏾‍🔬"
			},
			{
				unified: "1f469-1f3ff-200d-1f52c",
				native: "👩🏿‍🔬"
			}
		],
		version: 4
	},
	technologist: {
		id: "technologist",
		name: "Technologist",
		keywords: [
			"computer"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f4bb",
				native: "🧑‍💻"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f4bb",
				native: "🧑🏻‍💻"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f4bb",
				native: "🧑🏼‍💻"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f4bb",
				native: "🧑🏽‍💻"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f4bb",
				native: "🧑🏾‍💻"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f4bb",
				native: "🧑🏿‍💻"
			}
		],
		version: 12.1
	},
	"male-technologist": {
		id: "male-technologist",
		name: "Man Technologist",
		keywords: [
			"male",
			"coder",
			"developer",
			"engineer",
			"programmer",
			"software",
			"human",
			"laptop",
			"computer"
		],
		skins: [
			{
				unified: "1f468-200d-1f4bb",
				native: "👨‍💻"
			},
			{
				unified: "1f468-1f3fb-200d-1f4bb",
				native: "👨🏻‍💻"
			},
			{
				unified: "1f468-1f3fc-200d-1f4bb",
				native: "👨🏼‍💻"
			},
			{
				unified: "1f468-1f3fd-200d-1f4bb",
				native: "👨🏽‍💻"
			},
			{
				unified: "1f468-1f3fe-200d-1f4bb",
				native: "👨🏾‍💻"
			},
			{
				unified: "1f468-1f3ff-200d-1f4bb",
				native: "👨🏿‍💻"
			}
		],
		version: 4
	},
	"female-technologist": {
		id: "female-technologist",
		name: "Woman Technologist",
		keywords: [
			"female",
			"coder",
			"developer",
			"engineer",
			"programmer",
			"software",
			"human",
			"laptop",
			"computer"
		],
		skins: [
			{
				unified: "1f469-200d-1f4bb",
				native: "👩‍💻"
			},
			{
				unified: "1f469-1f3fb-200d-1f4bb",
				native: "👩🏻‍💻"
			},
			{
				unified: "1f469-1f3fc-200d-1f4bb",
				native: "👩🏼‍💻"
			},
			{
				unified: "1f469-1f3fd-200d-1f4bb",
				native: "👩🏽‍💻"
			},
			{
				unified: "1f469-1f3fe-200d-1f4bb",
				native: "👩🏾‍💻"
			},
			{
				unified: "1f469-1f3ff-200d-1f4bb",
				native: "👩🏿‍💻"
			}
		],
		version: 4
	},
	singer: {
		id: "singer",
		name: "Singer",
		keywords: [
			"song",
			"artist",
			"performer"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f3a4",
				native: "🧑‍🎤"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f3a4",
				native: "🧑🏻‍🎤"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f3a4",
				native: "🧑🏼‍🎤"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f3a4",
				native: "🧑🏽‍🎤"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f3a4",
				native: "🧑🏾‍🎤"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f3a4",
				native: "🧑🏿‍🎤"
			}
		],
		version: 12.1
	},
	"male-singer": {
		id: "male-singer",
		name: "Man Singer",
		keywords: [
			"male",
			"rockstar",
			"entertainer",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f3a4",
				native: "👨‍🎤"
			},
			{
				unified: "1f468-1f3fb-200d-1f3a4",
				native: "👨🏻‍🎤"
			},
			{
				unified: "1f468-1f3fc-200d-1f3a4",
				native: "👨🏼‍🎤"
			},
			{
				unified: "1f468-1f3fd-200d-1f3a4",
				native: "👨🏽‍🎤"
			},
			{
				unified: "1f468-1f3fe-200d-1f3a4",
				native: "👨🏾‍🎤"
			},
			{
				unified: "1f468-1f3ff-200d-1f3a4",
				native: "👨🏿‍🎤"
			}
		],
		version: 4
	},
	"female-singer": {
		id: "female-singer",
		name: "Woman Singer",
		keywords: [
			"female",
			"rockstar",
			"entertainer",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f3a4",
				native: "👩‍🎤"
			},
			{
				unified: "1f469-1f3fb-200d-1f3a4",
				native: "👩🏻‍🎤"
			},
			{
				unified: "1f469-1f3fc-200d-1f3a4",
				native: "👩🏼‍🎤"
			},
			{
				unified: "1f469-1f3fd-200d-1f3a4",
				native: "👩🏽‍🎤"
			},
			{
				unified: "1f469-1f3fe-200d-1f3a4",
				native: "👩🏾‍🎤"
			},
			{
				unified: "1f469-1f3ff-200d-1f3a4",
				native: "👩🏿‍🎤"
			}
		],
		version: 4
	},
	artist: {
		id: "artist",
		name: "Artist",
		keywords: [
			"painting",
			"draw",
			"creativity"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f3a8",
				native: "🧑‍🎨"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f3a8",
				native: "🧑🏻‍🎨"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f3a8",
				native: "🧑🏼‍🎨"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f3a8",
				native: "🧑🏽‍🎨"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f3a8",
				native: "🧑🏾‍🎨"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f3a8",
				native: "🧑🏿‍🎨"
			}
		],
		version: 12.1
	},
	"male-artist": {
		id: "male-artist",
		name: "Man Artist",
		keywords: [
			"male",
			"painter",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f3a8",
				native: "👨‍🎨"
			},
			{
				unified: "1f468-1f3fb-200d-1f3a8",
				native: "👨🏻‍🎨"
			},
			{
				unified: "1f468-1f3fc-200d-1f3a8",
				native: "👨🏼‍🎨"
			},
			{
				unified: "1f468-1f3fd-200d-1f3a8",
				native: "👨🏽‍🎨"
			},
			{
				unified: "1f468-1f3fe-200d-1f3a8",
				native: "👨🏾‍🎨"
			},
			{
				unified: "1f468-1f3ff-200d-1f3a8",
				native: "👨🏿‍🎨"
			}
		],
		version: 4
	},
	"female-artist": {
		id: "female-artist",
		name: "Woman Artist",
		keywords: [
			"female",
			"painter",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f3a8",
				native: "👩‍🎨"
			},
			{
				unified: "1f469-1f3fb-200d-1f3a8",
				native: "👩🏻‍🎨"
			},
			{
				unified: "1f469-1f3fc-200d-1f3a8",
				native: "👩🏼‍🎨"
			},
			{
				unified: "1f469-1f3fd-200d-1f3a8",
				native: "👩🏽‍🎨"
			},
			{
				unified: "1f469-1f3fe-200d-1f3a8",
				native: "👩🏾‍🎨"
			},
			{
				unified: "1f469-1f3ff-200d-1f3a8",
				native: "👩🏿‍🎨"
			}
		],
		version: 4
	},
	pilot: {
		id: "pilot",
		name: "Pilot",
		keywords: [
			"fly",
			"plane",
			"airplane"
		],
		skins: [
			{
				unified: "1f9d1-200d-2708-fe0f",
				native: "🧑‍✈️"
			},
			{
				unified: "1f9d1-1f3fb-200d-2708-fe0f",
				native: "🧑🏻‍✈️"
			},
			{
				unified: "1f9d1-1f3fc-200d-2708-fe0f",
				native: "🧑🏼‍✈️"
			},
			{
				unified: "1f9d1-1f3fd-200d-2708-fe0f",
				native: "🧑🏽‍✈️"
			},
			{
				unified: "1f9d1-1f3fe-200d-2708-fe0f",
				native: "🧑🏾‍✈️"
			},
			{
				unified: "1f9d1-1f3ff-200d-2708-fe0f",
				native: "🧑🏿‍✈️"
			}
		],
		version: 12.1
	},
	"male-pilot": {
		id: "male-pilot",
		name: "Man Pilot",
		keywords: [
			"male",
			"aviator",
			"plane",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-2708-fe0f",
				native: "👨‍✈️"
			},
			{
				unified: "1f468-1f3fb-200d-2708-fe0f",
				native: "👨🏻‍✈️"
			},
			{
				unified: "1f468-1f3fc-200d-2708-fe0f",
				native: "👨🏼‍✈️"
			},
			{
				unified: "1f468-1f3fd-200d-2708-fe0f",
				native: "👨🏽‍✈️"
			},
			{
				unified: "1f468-1f3fe-200d-2708-fe0f",
				native: "👨🏾‍✈️"
			},
			{
				unified: "1f468-1f3ff-200d-2708-fe0f",
				native: "👨🏿‍✈️"
			}
		],
		version: 4
	},
	"female-pilot": {
		id: "female-pilot",
		name: "Woman Pilot",
		keywords: [
			"female",
			"aviator",
			"plane",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-2708-fe0f",
				native: "👩‍✈️"
			},
			{
				unified: "1f469-1f3fb-200d-2708-fe0f",
				native: "👩🏻‍✈️"
			},
			{
				unified: "1f469-1f3fc-200d-2708-fe0f",
				native: "👩🏼‍✈️"
			},
			{
				unified: "1f469-1f3fd-200d-2708-fe0f",
				native: "👩🏽‍✈️"
			},
			{
				unified: "1f469-1f3fe-200d-2708-fe0f",
				native: "👩🏾‍✈️"
			},
			{
				unified: "1f469-1f3ff-200d-2708-fe0f",
				native: "👩🏿‍✈️"
			}
		],
		version: 4
	},
	astronaut: {
		id: "astronaut",
		name: "Astronaut",
		keywords: [
			"outerspace"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f680",
				native: "🧑‍🚀"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f680",
				native: "🧑🏻‍🚀"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f680",
				native: "🧑🏼‍🚀"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f680",
				native: "🧑🏽‍🚀"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f680",
				native: "🧑🏾‍🚀"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f680",
				native: "🧑🏿‍🚀"
			}
		],
		version: 12.1
	},
	"male-astronaut": {
		id: "male-astronaut",
		name: "Man Astronaut",
		keywords: [
			"male",
			"space",
			"rocket",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f680",
				native: "👨‍🚀"
			},
			{
				unified: "1f468-1f3fb-200d-1f680",
				native: "👨🏻‍🚀"
			},
			{
				unified: "1f468-1f3fc-200d-1f680",
				native: "👨🏼‍🚀"
			},
			{
				unified: "1f468-1f3fd-200d-1f680",
				native: "👨🏽‍🚀"
			},
			{
				unified: "1f468-1f3fe-200d-1f680",
				native: "👨🏾‍🚀"
			},
			{
				unified: "1f468-1f3ff-200d-1f680",
				native: "👨🏿‍🚀"
			}
		],
		version: 4
	},
	"female-astronaut": {
		id: "female-astronaut",
		name: "Woman Astronaut",
		keywords: [
			"female",
			"space",
			"rocket",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f680",
				native: "👩‍🚀"
			},
			{
				unified: "1f469-1f3fb-200d-1f680",
				native: "👩🏻‍🚀"
			},
			{
				unified: "1f469-1f3fc-200d-1f680",
				native: "👩🏼‍🚀"
			},
			{
				unified: "1f469-1f3fd-200d-1f680",
				native: "👩🏽‍🚀"
			},
			{
				unified: "1f469-1f3fe-200d-1f680",
				native: "👩🏾‍🚀"
			},
			{
				unified: "1f469-1f3ff-200d-1f680",
				native: "👩🏿‍🚀"
			}
		],
		version: 4
	},
	firefighter: {
		id: "firefighter",
		name: "Firefighter",
		keywords: [
			"fire"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f692",
				native: "🧑‍🚒"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f692",
				native: "🧑🏻‍🚒"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f692",
				native: "🧑🏼‍🚒"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f692",
				native: "🧑🏽‍🚒"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f692",
				native: "🧑🏾‍🚒"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f692",
				native: "🧑🏿‍🚒"
			}
		],
		version: 12.1
	},
	"male-firefighter": {
		id: "male-firefighter",
		name: "Man Firefighter",
		keywords: [
			"male",
			"fireman",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f692",
				native: "👨‍🚒"
			},
			{
				unified: "1f468-1f3fb-200d-1f692",
				native: "👨🏻‍🚒"
			},
			{
				unified: "1f468-1f3fc-200d-1f692",
				native: "👨🏼‍🚒"
			},
			{
				unified: "1f468-1f3fd-200d-1f692",
				native: "👨🏽‍🚒"
			},
			{
				unified: "1f468-1f3fe-200d-1f692",
				native: "👨🏾‍🚒"
			},
			{
				unified: "1f468-1f3ff-200d-1f692",
				native: "👨🏿‍🚒"
			}
		],
		version: 4
	},
	"female-firefighter": {
		id: "female-firefighter",
		name: "Woman Firefighter",
		keywords: [
			"female",
			"fireman",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f692",
				native: "👩‍🚒"
			},
			{
				unified: "1f469-1f3fb-200d-1f692",
				native: "👩🏻‍🚒"
			},
			{
				unified: "1f469-1f3fc-200d-1f692",
				native: "👩🏼‍🚒"
			},
			{
				unified: "1f469-1f3fd-200d-1f692",
				native: "👩🏽‍🚒"
			},
			{
				unified: "1f469-1f3fe-200d-1f692",
				native: "👩🏾‍🚒"
			},
			{
				unified: "1f469-1f3ff-200d-1f692",
				native: "👩🏿‍🚒"
			}
		],
		version: 4
	},
	cop: {
		id: "cop",
		name: "Police Officer",
		keywords: [
			"cop"
		],
		skins: [
			{
				unified: "1f46e",
				native: "👮"
			},
			{
				unified: "1f46e-1f3fb",
				native: "👮🏻"
			},
			{
				unified: "1f46e-1f3fc",
				native: "👮🏼"
			},
			{
				unified: "1f46e-1f3fd",
				native: "👮🏽"
			},
			{
				unified: "1f46e-1f3fe",
				native: "👮🏾"
			},
			{
				unified: "1f46e-1f3ff",
				native: "👮🏿"
			}
		],
		version: 1
	},
	"male-police-officer": {
		id: "male-police-officer",
		name: "Man Police Officer",
		keywords: [
			"male",
			"police-officer",
			"law",
			"legal",
			"enforcement",
			"arrest",
			"911"
		],
		skins: [
			{
				unified: "1f46e-200d-2642-fe0f",
				native: "👮‍♂️"
			},
			{
				unified: "1f46e-1f3fb-200d-2642-fe0f",
				native: "👮🏻‍♂️"
			},
			{
				unified: "1f46e-1f3fc-200d-2642-fe0f",
				native: "👮🏼‍♂️"
			},
			{
				unified: "1f46e-1f3fd-200d-2642-fe0f",
				native: "👮🏽‍♂️"
			},
			{
				unified: "1f46e-1f3fe-200d-2642-fe0f",
				native: "👮🏾‍♂️"
			},
			{
				unified: "1f46e-1f3ff-200d-2642-fe0f",
				native: "👮🏿‍♂️"
			}
		],
		version: 4
	},
	"female-police-officer": {
		id: "female-police-officer",
		name: "Woman Police Officer",
		keywords: [
			"female",
			"police-officer",
			"law",
			"legal",
			"enforcement",
			"arrest",
			"911"
		],
		skins: [
			{
				unified: "1f46e-200d-2640-fe0f",
				native: "👮‍♀️"
			},
			{
				unified: "1f46e-1f3fb-200d-2640-fe0f",
				native: "👮🏻‍♀️"
			},
			{
				unified: "1f46e-1f3fc-200d-2640-fe0f",
				native: "👮🏼‍♀️"
			},
			{
				unified: "1f46e-1f3fd-200d-2640-fe0f",
				native: "👮🏽‍♀️"
			},
			{
				unified: "1f46e-1f3fe-200d-2640-fe0f",
				native: "👮🏾‍♀️"
			},
			{
				unified: "1f46e-1f3ff-200d-2640-fe0f",
				native: "👮🏿‍♀️"
			}
		],
		version: 4
	},
	sleuth_or_spy: {
		id: "sleuth_or_spy",
		name: "Detective",
		keywords: [
			"sleuth",
			"or",
			"spy",
			"human"
		],
		skins: [
			{
				unified: "1f575-fe0f",
				native: "🕵️"
			},
			{
				unified: "1f575-1f3fb",
				native: "🕵🏻"
			},
			{
				unified: "1f575-1f3fc",
				native: "🕵🏼"
			},
			{
				unified: "1f575-1f3fd",
				native: "🕵🏽"
			},
			{
				unified: "1f575-1f3fe",
				native: "🕵🏾"
			},
			{
				unified: "1f575-1f3ff",
				native: "🕵🏿"
			}
		],
		version: 1
	},
	"male-detective": {
		id: "male-detective",
		name: "Man Detective",
		keywords: [
			"male",
			"crime"
		],
		skins: [
			{
				unified: "1f575-fe0f-200d-2642-fe0f",
				native: "🕵️‍♂️"
			},
			{
				unified: "1f575-1f3fb-200d-2642-fe0f",
				native: "🕵🏻‍♂️"
			},
			{
				unified: "1f575-1f3fc-200d-2642-fe0f",
				native: "🕵🏼‍♂️"
			},
			{
				unified: "1f575-1f3fd-200d-2642-fe0f",
				native: "🕵🏽‍♂️"
			},
			{
				unified: "1f575-1f3fe-200d-2642-fe0f",
				native: "🕵🏾‍♂️"
			},
			{
				unified: "1f575-1f3ff-200d-2642-fe0f",
				native: "🕵🏿‍♂️"
			}
		],
		version: 4
	},
	"female-detective": {
		id: "female-detective",
		name: "Woman Detective",
		keywords: [
			"female",
			"human",
			"spy"
		],
		skins: [
			{
				unified: "1f575-fe0f-200d-2640-fe0f",
				native: "🕵️‍♀️"
			},
			{
				unified: "1f575-1f3fb-200d-2640-fe0f",
				native: "🕵🏻‍♀️"
			},
			{
				unified: "1f575-1f3fc-200d-2640-fe0f",
				native: "🕵🏼‍♀️"
			},
			{
				unified: "1f575-1f3fd-200d-2640-fe0f",
				native: "🕵🏽‍♀️"
			},
			{
				unified: "1f575-1f3fe-200d-2640-fe0f",
				native: "🕵🏾‍♀️"
			},
			{
				unified: "1f575-1f3ff-200d-2640-fe0f",
				native: "🕵🏿‍♀️"
			}
		],
		version: 4
	},
	guardsman: {
		id: "guardsman",
		name: "Guard",
		keywords: [
			"guardsman",
			"protect"
		],
		skins: [
			{
				unified: "1f482",
				native: "💂"
			},
			{
				unified: "1f482-1f3fb",
				native: "💂🏻"
			},
			{
				unified: "1f482-1f3fc",
				native: "💂🏼"
			},
			{
				unified: "1f482-1f3fd",
				native: "💂🏽"
			},
			{
				unified: "1f482-1f3fe",
				native: "💂🏾"
			},
			{
				unified: "1f482-1f3ff",
				native: "💂🏿"
			}
		],
		version: 1
	},
	"male-guard": {
		id: "male-guard",
		name: "Man Guard",
		keywords: [
			"male",
			"uk",
			"gb",
			"british",
			"guy",
			"royal"
		],
		skins: [
			{
				unified: "1f482-200d-2642-fe0f",
				native: "💂‍♂️"
			},
			{
				unified: "1f482-1f3fb-200d-2642-fe0f",
				native: "💂🏻‍♂️"
			},
			{
				unified: "1f482-1f3fc-200d-2642-fe0f",
				native: "💂🏼‍♂️"
			},
			{
				unified: "1f482-1f3fd-200d-2642-fe0f",
				native: "💂🏽‍♂️"
			},
			{
				unified: "1f482-1f3fe-200d-2642-fe0f",
				native: "💂🏾‍♂️"
			},
			{
				unified: "1f482-1f3ff-200d-2642-fe0f",
				native: "💂🏿‍♂️"
			}
		],
		version: 4
	},
	"female-guard": {
		id: "female-guard",
		name: "Woman Guard",
		keywords: [
			"female",
			"uk",
			"gb",
			"british",
			"royal"
		],
		skins: [
			{
				unified: "1f482-200d-2640-fe0f",
				native: "💂‍♀️"
			},
			{
				unified: "1f482-1f3fb-200d-2640-fe0f",
				native: "💂🏻‍♀️"
			},
			{
				unified: "1f482-1f3fc-200d-2640-fe0f",
				native: "💂🏼‍♀️"
			},
			{
				unified: "1f482-1f3fd-200d-2640-fe0f",
				native: "💂🏽‍♀️"
			},
			{
				unified: "1f482-1f3fe-200d-2640-fe0f",
				native: "💂🏾‍♀️"
			},
			{
				unified: "1f482-1f3ff-200d-2640-fe0f",
				native: "💂🏿‍♀️"
			}
		],
		version: 4
	},
	ninja: {
		id: "ninja",
		name: "Ninja",
		keywords: [
			"ninjutsu",
			"skills",
			"japanese"
		],
		skins: [
			{
				unified: "1f977",
				native: "🥷"
			},
			{
				unified: "1f977-1f3fb",
				native: "🥷🏻"
			},
			{
				unified: "1f977-1f3fc",
				native: "🥷🏼"
			},
			{
				unified: "1f977-1f3fd",
				native: "🥷🏽"
			},
			{
				unified: "1f977-1f3fe",
				native: "🥷🏾"
			},
			{
				unified: "1f977-1f3ff",
				native: "🥷🏿"
			}
		],
		version: 13
	},
	construction_worker: {
		id: "construction_worker",
		name: "Construction Worker",
		keywords: [
			"labor",
			"build"
		],
		skins: [
			{
				unified: "1f477",
				native: "👷"
			},
			{
				unified: "1f477-1f3fb",
				native: "👷🏻"
			},
			{
				unified: "1f477-1f3fc",
				native: "👷🏼"
			},
			{
				unified: "1f477-1f3fd",
				native: "👷🏽"
			},
			{
				unified: "1f477-1f3fe",
				native: "👷🏾"
			},
			{
				unified: "1f477-1f3ff",
				native: "👷🏿"
			}
		],
		version: 1
	},
	"male-construction-worker": {
		id: "male-construction-worker",
		name: "Man Construction Worker",
		keywords: [
			"male",
			"construction-worker",
			"human",
			"wip",
			"guy",
			"build",
			"labor"
		],
		skins: [
			{
				unified: "1f477-200d-2642-fe0f",
				native: "👷‍♂️"
			},
			{
				unified: "1f477-1f3fb-200d-2642-fe0f",
				native: "👷🏻‍♂️"
			},
			{
				unified: "1f477-1f3fc-200d-2642-fe0f",
				native: "👷🏼‍♂️"
			},
			{
				unified: "1f477-1f3fd-200d-2642-fe0f",
				native: "👷🏽‍♂️"
			},
			{
				unified: "1f477-1f3fe-200d-2642-fe0f",
				native: "👷🏾‍♂️"
			},
			{
				unified: "1f477-1f3ff-200d-2642-fe0f",
				native: "👷🏿‍♂️"
			}
		],
		version: 4
	},
	"female-construction-worker": {
		id: "female-construction-worker",
		name: "Woman Construction Worker",
		keywords: [
			"female",
			"construction-worker",
			"human",
			"wip",
			"build",
			"labor"
		],
		skins: [
			{
				unified: "1f477-200d-2640-fe0f",
				native: "👷‍♀️"
			},
			{
				unified: "1f477-1f3fb-200d-2640-fe0f",
				native: "👷🏻‍♀️"
			},
			{
				unified: "1f477-1f3fc-200d-2640-fe0f",
				native: "👷🏼‍♀️"
			},
			{
				unified: "1f477-1f3fd-200d-2640-fe0f",
				native: "👷🏽‍♀️"
			},
			{
				unified: "1f477-1f3fe-200d-2640-fe0f",
				native: "👷🏾‍♀️"
			},
			{
				unified: "1f477-1f3ff-200d-2640-fe0f",
				native: "👷🏿‍♀️"
			}
		],
		version: 4
	},
	person_with_crown: {
		id: "person_with_crown",
		name: "Person with Crown",
		keywords: [
			"royalty",
			"power"
		],
		skins: [
			{
				unified: "1fac5",
				native: "🫅"
			},
			{
				unified: "1fac5-1f3fb",
				native: "🫅🏻"
			},
			{
				unified: "1fac5-1f3fc",
				native: "🫅🏼"
			},
			{
				unified: "1fac5-1f3fd",
				native: "🫅🏽"
			},
			{
				unified: "1fac5-1f3fe",
				native: "🫅🏾"
			},
			{
				unified: "1fac5-1f3ff",
				native: "🫅🏿"
			}
		],
		version: 14
	},
	prince: {
		id: "prince",
		name: "Prince",
		keywords: [
			"boy",
			"man",
			"male",
			"crown",
			"royal",
			"king"
		],
		skins: [
			{
				unified: "1f934",
				native: "🤴"
			},
			{
				unified: "1f934-1f3fb",
				native: "🤴🏻"
			},
			{
				unified: "1f934-1f3fc",
				native: "🤴🏼"
			},
			{
				unified: "1f934-1f3fd",
				native: "🤴🏽"
			},
			{
				unified: "1f934-1f3fe",
				native: "🤴🏾"
			},
			{
				unified: "1f934-1f3ff",
				native: "🤴🏿"
			}
		],
		version: 3
	},
	princess: {
		id: "princess",
		name: "Princess",
		keywords: [
			"girl",
			"woman",
			"female",
			"blond",
			"crown",
			"royal",
			"queen"
		],
		skins: [
			{
				unified: "1f478",
				native: "👸"
			},
			{
				unified: "1f478-1f3fb",
				native: "👸🏻"
			},
			{
				unified: "1f478-1f3fc",
				native: "👸🏼"
			},
			{
				unified: "1f478-1f3fd",
				native: "👸🏽"
			},
			{
				unified: "1f478-1f3fe",
				native: "👸🏾"
			},
			{
				unified: "1f478-1f3ff",
				native: "👸🏿"
			}
		],
		version: 1
	},
	man_with_turban: {
		id: "man_with_turban",
		name: "Man with Turban",
		keywords: [
			"person",
			"wearing",
			"headdress"
		],
		skins: [
			{
				unified: "1f473",
				native: "👳"
			},
			{
				unified: "1f473-1f3fb",
				native: "👳🏻"
			},
			{
				unified: "1f473-1f3fc",
				native: "👳🏼"
			},
			{
				unified: "1f473-1f3fd",
				native: "👳🏽"
			},
			{
				unified: "1f473-1f3fe",
				native: "👳🏾"
			},
			{
				unified: "1f473-1f3ff",
				native: "👳🏿"
			}
		],
		version: 1
	},
	"man-wearing-turban": {
		id: "man-wearing-turban",
		name: "Man Wearing Turban",
		keywords: [
			"wearing-turban",
			"male",
			"indian",
			"hinduism",
			"arabs"
		],
		skins: [
			{
				unified: "1f473-200d-2642-fe0f",
				native: "👳‍♂️"
			},
			{
				unified: "1f473-1f3fb-200d-2642-fe0f",
				native: "👳🏻‍♂️"
			},
			{
				unified: "1f473-1f3fc-200d-2642-fe0f",
				native: "👳🏼‍♂️"
			},
			{
				unified: "1f473-1f3fd-200d-2642-fe0f",
				native: "👳🏽‍♂️"
			},
			{
				unified: "1f473-1f3fe-200d-2642-fe0f",
				native: "👳🏾‍♂️"
			},
			{
				unified: "1f473-1f3ff-200d-2642-fe0f",
				native: "👳🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-wearing-turban": {
		id: "woman-wearing-turban",
		name: "Woman Wearing Turban",
		keywords: [
			"wearing-turban",
			"female",
			"indian",
			"hinduism",
			"arabs"
		],
		skins: [
			{
				unified: "1f473-200d-2640-fe0f",
				native: "👳‍♀️"
			},
			{
				unified: "1f473-1f3fb-200d-2640-fe0f",
				native: "👳🏻‍♀️"
			},
			{
				unified: "1f473-1f3fc-200d-2640-fe0f",
				native: "👳🏼‍♀️"
			},
			{
				unified: "1f473-1f3fd-200d-2640-fe0f",
				native: "👳🏽‍♀️"
			},
			{
				unified: "1f473-1f3fe-200d-2640-fe0f",
				native: "👳🏾‍♀️"
			},
			{
				unified: "1f473-1f3ff-200d-2640-fe0f",
				native: "👳🏿‍♀️"
			}
		],
		version: 4
	},
	man_with_gua_pi_mao: {
		id: "man_with_gua_pi_mao",
		name: "Man with Gua Pi Mao",
		keywords: [
			"skullcap",
			"male",
			"boy",
			"chinese"
		],
		skins: [
			{
				unified: "1f472",
				native: "👲"
			},
			{
				unified: "1f472-1f3fb",
				native: "👲🏻"
			},
			{
				unified: "1f472-1f3fc",
				native: "👲🏼"
			},
			{
				unified: "1f472-1f3fd",
				native: "👲🏽"
			},
			{
				unified: "1f472-1f3fe",
				native: "👲🏾"
			},
			{
				unified: "1f472-1f3ff",
				native: "👲🏿"
			}
		],
		version: 1
	},
	person_with_headscarf: {
		id: "person_with_headscarf",
		name: "Woman with Headscarf",
		keywords: [
			"person",
			"female",
			"hijab",
			"mantilla",
			"tichel"
		],
		skins: [
			{
				unified: "1f9d5",
				native: "🧕"
			},
			{
				unified: "1f9d5-1f3fb",
				native: "🧕🏻"
			},
			{
				unified: "1f9d5-1f3fc",
				native: "🧕🏼"
			},
			{
				unified: "1f9d5-1f3fd",
				native: "🧕🏽"
			},
			{
				unified: "1f9d5-1f3fe",
				native: "🧕🏾"
			},
			{
				unified: "1f9d5-1f3ff",
				native: "🧕🏿"
			}
		],
		version: 5
	},
	person_in_tuxedo: {
		id: "person_in_tuxedo",
		name: "Man in Tuxedo",
		keywords: [
			"person",
			"couple",
			"marriage",
			"wedding",
			"groom"
		],
		skins: [
			{
				unified: "1f935",
				native: "🤵"
			},
			{
				unified: "1f935-1f3fb",
				native: "🤵🏻"
			},
			{
				unified: "1f935-1f3fc",
				native: "🤵🏼"
			},
			{
				unified: "1f935-1f3fd",
				native: "🤵🏽"
			},
			{
				unified: "1f935-1f3fe",
				native: "🤵🏾"
			},
			{
				unified: "1f935-1f3ff",
				native: "🤵🏿"
			}
		],
		version: 3
	},
	man_in_tuxedo: {
		id: "man_in_tuxedo",
		name: "Man in Tuxedo",
		keywords: [
			"formal",
			"fashion"
		],
		skins: [
			{
				unified: "1f935-200d-2642-fe0f",
				native: "🤵‍♂️"
			},
			{
				unified: "1f935-1f3fb-200d-2642-fe0f",
				native: "🤵🏻‍♂️"
			},
			{
				unified: "1f935-1f3fc-200d-2642-fe0f",
				native: "🤵🏼‍♂️"
			},
			{
				unified: "1f935-1f3fd-200d-2642-fe0f",
				native: "🤵🏽‍♂️"
			},
			{
				unified: "1f935-1f3fe-200d-2642-fe0f",
				native: "🤵🏾‍♂️"
			},
			{
				unified: "1f935-1f3ff-200d-2642-fe0f",
				native: "🤵🏿‍♂️"
			}
		],
		version: 13
	},
	woman_in_tuxedo: {
		id: "woman_in_tuxedo",
		name: "Woman in Tuxedo",
		keywords: [
			"formal",
			"fashion"
		],
		skins: [
			{
				unified: "1f935-200d-2640-fe0f",
				native: "🤵‍♀️"
			},
			{
				unified: "1f935-1f3fb-200d-2640-fe0f",
				native: "🤵🏻‍♀️"
			},
			{
				unified: "1f935-1f3fc-200d-2640-fe0f",
				native: "🤵🏼‍♀️"
			},
			{
				unified: "1f935-1f3fd-200d-2640-fe0f",
				native: "🤵🏽‍♀️"
			},
			{
				unified: "1f935-1f3fe-200d-2640-fe0f",
				native: "🤵🏾‍♀️"
			},
			{
				unified: "1f935-1f3ff-200d-2640-fe0f",
				native: "🤵🏿‍♀️"
			}
		],
		version: 13
	},
	bride_with_veil: {
		id: "bride_with_veil",
		name: "Bride with Veil",
		keywords: [
			"couple",
			"marriage",
			"wedding",
			"woman"
		],
		skins: [
			{
				unified: "1f470",
				native: "👰"
			},
			{
				unified: "1f470-1f3fb",
				native: "👰🏻"
			},
			{
				unified: "1f470-1f3fc",
				native: "👰🏼"
			},
			{
				unified: "1f470-1f3fd",
				native: "👰🏽"
			},
			{
				unified: "1f470-1f3fe",
				native: "👰🏾"
			},
			{
				unified: "1f470-1f3ff",
				native: "👰🏿"
			}
		],
		version: 1
	},
	man_with_veil: {
		id: "man_with_veil",
		name: "Man with Veil",
		keywords: [
			"wedding",
			"marriage"
		],
		skins: [
			{
				unified: "1f470-200d-2642-fe0f",
				native: "👰‍♂️"
			},
			{
				unified: "1f470-1f3fb-200d-2642-fe0f",
				native: "👰🏻‍♂️"
			},
			{
				unified: "1f470-1f3fc-200d-2642-fe0f",
				native: "👰🏼‍♂️"
			},
			{
				unified: "1f470-1f3fd-200d-2642-fe0f",
				native: "👰🏽‍♂️"
			},
			{
				unified: "1f470-1f3fe-200d-2642-fe0f",
				native: "👰🏾‍♂️"
			},
			{
				unified: "1f470-1f3ff-200d-2642-fe0f",
				native: "👰🏿‍♂️"
			}
		],
		version: 13
	},
	woman_with_veil: {
		id: "woman_with_veil",
		name: "Woman with Veil",
		keywords: [
			"wedding",
			"marriage"
		],
		skins: [
			{
				unified: "1f470-200d-2640-fe0f",
				native: "👰‍♀️"
			},
			{
				unified: "1f470-1f3fb-200d-2640-fe0f",
				native: "👰🏻‍♀️"
			},
			{
				unified: "1f470-1f3fc-200d-2640-fe0f",
				native: "👰🏼‍♀️"
			},
			{
				unified: "1f470-1f3fd-200d-2640-fe0f",
				native: "👰🏽‍♀️"
			},
			{
				unified: "1f470-1f3fe-200d-2640-fe0f",
				native: "👰🏾‍♀️"
			},
			{
				unified: "1f470-1f3ff-200d-2640-fe0f",
				native: "👰🏿‍♀️"
			}
		],
		version: 13
	},
	pregnant_woman: {
		id: "pregnant_woman",
		name: "Pregnant Woman",
		keywords: [
			"baby"
		],
		skins: [
			{
				unified: "1f930",
				native: "🤰"
			},
			{
				unified: "1f930-1f3fb",
				native: "🤰🏻"
			},
			{
				unified: "1f930-1f3fc",
				native: "🤰🏼"
			},
			{
				unified: "1f930-1f3fd",
				native: "🤰🏽"
			},
			{
				unified: "1f930-1f3fe",
				native: "🤰🏾"
			},
			{
				unified: "1f930-1f3ff",
				native: "🤰🏿"
			}
		],
		version: 3
	},
	pregnant_man: {
		id: "pregnant_man",
		name: "Pregnant Man",
		keywords: [
			"baby",
			"belly"
		],
		skins: [
			{
				unified: "1fac3",
				native: "🫃"
			},
			{
				unified: "1fac3-1f3fb",
				native: "🫃🏻"
			},
			{
				unified: "1fac3-1f3fc",
				native: "🫃🏼"
			},
			{
				unified: "1fac3-1f3fd",
				native: "🫃🏽"
			},
			{
				unified: "1fac3-1f3fe",
				native: "🫃🏾"
			},
			{
				unified: "1fac3-1f3ff",
				native: "🫃🏿"
			}
		],
		version: 14
	},
	pregnant_person: {
		id: "pregnant_person",
		name: "Pregnant Person",
		keywords: [
			"baby",
			"belly"
		],
		skins: [
			{
				unified: "1fac4",
				native: "🫄"
			},
			{
				unified: "1fac4-1f3fb",
				native: "🫄🏻"
			},
			{
				unified: "1fac4-1f3fc",
				native: "🫄🏼"
			},
			{
				unified: "1fac4-1f3fd",
				native: "🫄🏽"
			},
			{
				unified: "1fac4-1f3fe",
				native: "🫄🏾"
			},
			{
				unified: "1fac4-1f3ff",
				native: "🫄🏿"
			}
		],
		version: 14
	},
	"breast-feeding": {
		id: "breast-feeding",
		name: "Breast-Feeding",
		keywords: [
			"breast",
			"feeding",
			"nursing",
			"baby"
		],
		skins: [
			{
				unified: "1f931",
				native: "🤱"
			},
			{
				unified: "1f931-1f3fb",
				native: "🤱🏻"
			},
			{
				unified: "1f931-1f3fc",
				native: "🤱🏼"
			},
			{
				unified: "1f931-1f3fd",
				native: "🤱🏽"
			},
			{
				unified: "1f931-1f3fe",
				native: "🤱🏾"
			},
			{
				unified: "1f931-1f3ff",
				native: "🤱🏿"
			}
		],
		version: 5
	},
	woman_feeding_baby: {
		id: "woman_feeding_baby",
		name: "Woman Feeding Baby",
		keywords: [
			"birth",
			"food"
		],
		skins: [
			{
				unified: "1f469-200d-1f37c",
				native: "👩‍🍼"
			},
			{
				unified: "1f469-1f3fb-200d-1f37c",
				native: "👩🏻‍🍼"
			},
			{
				unified: "1f469-1f3fc-200d-1f37c",
				native: "👩🏼‍🍼"
			},
			{
				unified: "1f469-1f3fd-200d-1f37c",
				native: "👩🏽‍🍼"
			},
			{
				unified: "1f469-1f3fe-200d-1f37c",
				native: "👩🏾‍🍼"
			},
			{
				unified: "1f469-1f3ff-200d-1f37c",
				native: "👩🏿‍🍼"
			}
		],
		version: 13
	},
	man_feeding_baby: {
		id: "man_feeding_baby",
		name: "Man Feeding Baby",
		keywords: [
			"birth",
			"food"
		],
		skins: [
			{
				unified: "1f468-200d-1f37c",
				native: "👨‍🍼"
			},
			{
				unified: "1f468-1f3fb-200d-1f37c",
				native: "👨🏻‍🍼"
			},
			{
				unified: "1f468-1f3fc-200d-1f37c",
				native: "👨🏼‍🍼"
			},
			{
				unified: "1f468-1f3fd-200d-1f37c",
				native: "👨🏽‍🍼"
			},
			{
				unified: "1f468-1f3fe-200d-1f37c",
				native: "👨🏾‍🍼"
			},
			{
				unified: "1f468-1f3ff-200d-1f37c",
				native: "👨🏿‍🍼"
			}
		],
		version: 13
	},
	person_feeding_baby: {
		id: "person_feeding_baby",
		name: "Person Feeding Baby",
		keywords: [
			"birth",
			"food"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f37c",
				native: "🧑‍🍼"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f37c",
				native: "🧑🏻‍🍼"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f37c",
				native: "🧑🏼‍🍼"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f37c",
				native: "🧑🏽‍🍼"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f37c",
				native: "🧑🏾‍🍼"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f37c",
				native: "🧑🏿‍🍼"
			}
		],
		version: 13
	},
	angel: {
		id: "angel",
		name: "Baby Angel",
		keywords: [
			"heaven",
			"wings",
			"halo"
		],
		skins: [
			{
				unified: "1f47c",
				native: "👼"
			},
			{
				unified: "1f47c-1f3fb",
				native: "👼🏻"
			},
			{
				unified: "1f47c-1f3fc",
				native: "👼🏼"
			},
			{
				unified: "1f47c-1f3fd",
				native: "👼🏽"
			},
			{
				unified: "1f47c-1f3fe",
				native: "👼🏾"
			},
			{
				unified: "1f47c-1f3ff",
				native: "👼🏿"
			}
		],
		version: 1
	},
	santa: {
		id: "santa",
		name: "Santa Claus",
		keywords: [
			"festival",
			"man",
			"male",
			"xmas",
			"father",
			"christmas"
		],
		skins: [
			{
				unified: "1f385",
				native: "🎅"
			},
			{
				unified: "1f385-1f3fb",
				native: "🎅🏻"
			},
			{
				unified: "1f385-1f3fc",
				native: "🎅🏼"
			},
			{
				unified: "1f385-1f3fd",
				native: "🎅🏽"
			},
			{
				unified: "1f385-1f3fe",
				native: "🎅🏾"
			},
			{
				unified: "1f385-1f3ff",
				native: "🎅🏿"
			}
		],
		version: 1
	},
	mrs_claus: {
		id: "mrs_claus",
		name: "Mrs. Claus",
		keywords: [
			"mrs",
			"mother",
			"christmas",
			"woman",
			"female",
			"xmas"
		],
		skins: [
			{
				unified: "1f936",
				native: "🤶"
			},
			{
				unified: "1f936-1f3fb",
				native: "🤶🏻"
			},
			{
				unified: "1f936-1f3fc",
				native: "🤶🏼"
			},
			{
				unified: "1f936-1f3fd",
				native: "🤶🏽"
			},
			{
				unified: "1f936-1f3fe",
				native: "🤶🏾"
			},
			{
				unified: "1f936-1f3ff",
				native: "🤶🏿"
			}
		],
		version: 3
	},
	mx_claus: {
		id: "mx_claus",
		name: "Mx Claus",
		keywords: [
			"christmas"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f384",
				native: "🧑‍🎄"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f384",
				native: "🧑🏻‍🎄"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f384",
				native: "🧑🏼‍🎄"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f384",
				native: "🧑🏽‍🎄"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f384",
				native: "🧑🏾‍🎄"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f384",
				native: "🧑🏿‍🎄"
			}
		],
		version: 13
	},
	superhero: {
		id: "superhero",
		name: "Superhero",
		keywords: [
			"marvel"
		],
		skins: [
			{
				unified: "1f9b8",
				native: "🦸"
			},
			{
				unified: "1f9b8-1f3fb",
				native: "🦸🏻"
			},
			{
				unified: "1f9b8-1f3fc",
				native: "🦸🏼"
			},
			{
				unified: "1f9b8-1f3fd",
				native: "🦸🏽"
			},
			{
				unified: "1f9b8-1f3fe",
				native: "🦸🏾"
			},
			{
				unified: "1f9b8-1f3ff",
				native: "🦸🏿"
			}
		],
		version: 11
	},
	male_superhero: {
		id: "male_superhero",
		name: "Man Superhero",
		keywords: [
			"male",
			"good",
			"hero",
			"superpowers"
		],
		skins: [
			{
				unified: "1f9b8-200d-2642-fe0f",
				native: "🦸‍♂️"
			},
			{
				unified: "1f9b8-1f3fb-200d-2642-fe0f",
				native: "🦸🏻‍♂️"
			},
			{
				unified: "1f9b8-1f3fc-200d-2642-fe0f",
				native: "🦸🏼‍♂️"
			},
			{
				unified: "1f9b8-1f3fd-200d-2642-fe0f",
				native: "🦸🏽‍♂️"
			},
			{
				unified: "1f9b8-1f3fe-200d-2642-fe0f",
				native: "🦸🏾‍♂️"
			},
			{
				unified: "1f9b8-1f3ff-200d-2642-fe0f",
				native: "🦸🏿‍♂️"
			}
		],
		version: 11
	},
	female_superhero: {
		id: "female_superhero",
		name: "Woman Superhero",
		keywords: [
			"female",
			"good",
			"heroine",
			"superpowers"
		],
		skins: [
			{
				unified: "1f9b8-200d-2640-fe0f",
				native: "🦸‍♀️"
			},
			{
				unified: "1f9b8-1f3fb-200d-2640-fe0f",
				native: "🦸🏻‍♀️"
			},
			{
				unified: "1f9b8-1f3fc-200d-2640-fe0f",
				native: "🦸🏼‍♀️"
			},
			{
				unified: "1f9b8-1f3fd-200d-2640-fe0f",
				native: "🦸🏽‍♀️"
			},
			{
				unified: "1f9b8-1f3fe-200d-2640-fe0f",
				native: "🦸🏾‍♀️"
			},
			{
				unified: "1f9b8-1f3ff-200d-2640-fe0f",
				native: "🦸🏿‍♀️"
			}
		],
		version: 11
	},
	supervillain: {
		id: "supervillain",
		name: "Supervillain",
		keywords: [
			"marvel"
		],
		skins: [
			{
				unified: "1f9b9",
				native: "🦹"
			},
			{
				unified: "1f9b9-1f3fb",
				native: "🦹🏻"
			},
			{
				unified: "1f9b9-1f3fc",
				native: "🦹🏼"
			},
			{
				unified: "1f9b9-1f3fd",
				native: "🦹🏽"
			},
			{
				unified: "1f9b9-1f3fe",
				native: "🦹🏾"
			},
			{
				unified: "1f9b9-1f3ff",
				native: "🦹🏿"
			}
		],
		version: 11
	},
	male_supervillain: {
		id: "male_supervillain",
		name: "Man Supervillain",
		keywords: [
			"male",
			"evil",
			"bad",
			"criminal",
			"hero",
			"superpowers"
		],
		skins: [
			{
				unified: "1f9b9-200d-2642-fe0f",
				native: "🦹‍♂️"
			},
			{
				unified: "1f9b9-1f3fb-200d-2642-fe0f",
				native: "🦹🏻‍♂️"
			},
			{
				unified: "1f9b9-1f3fc-200d-2642-fe0f",
				native: "🦹🏼‍♂️"
			},
			{
				unified: "1f9b9-1f3fd-200d-2642-fe0f",
				native: "🦹🏽‍♂️"
			},
			{
				unified: "1f9b9-1f3fe-200d-2642-fe0f",
				native: "🦹🏾‍♂️"
			},
			{
				unified: "1f9b9-1f3ff-200d-2642-fe0f",
				native: "🦹🏿‍♂️"
			}
		],
		version: 11
	},
	female_supervillain: {
		id: "female_supervillain",
		name: "Woman Supervillain",
		keywords: [
			"female",
			"evil",
			"bad",
			"criminal",
			"heroine",
			"superpowers"
		],
		skins: [
			{
				unified: "1f9b9-200d-2640-fe0f",
				native: "🦹‍♀️"
			},
			{
				unified: "1f9b9-1f3fb-200d-2640-fe0f",
				native: "🦹🏻‍♀️"
			},
			{
				unified: "1f9b9-1f3fc-200d-2640-fe0f",
				native: "🦹🏼‍♀️"
			},
			{
				unified: "1f9b9-1f3fd-200d-2640-fe0f",
				native: "🦹🏽‍♀️"
			},
			{
				unified: "1f9b9-1f3fe-200d-2640-fe0f",
				native: "🦹🏾‍♀️"
			},
			{
				unified: "1f9b9-1f3ff-200d-2640-fe0f",
				native: "🦹🏿‍♀️"
			}
		],
		version: 11
	},
	mage: {
		id: "mage",
		name: "Mage",
		keywords: [
			"magic"
		],
		skins: [
			{
				unified: "1f9d9",
				native: "🧙"
			},
			{
				unified: "1f9d9-1f3fb",
				native: "🧙🏻"
			},
			{
				unified: "1f9d9-1f3fc",
				native: "🧙🏼"
			},
			{
				unified: "1f9d9-1f3fd",
				native: "🧙🏽"
			},
			{
				unified: "1f9d9-1f3fe",
				native: "🧙🏾"
			},
			{
				unified: "1f9d9-1f3ff",
				native: "🧙🏿"
			}
		],
		version: 5
	},
	male_mage: {
		id: "male_mage",
		name: "Man Mage",
		keywords: [
			"male",
			"sorcerer"
		],
		skins: [
			{
				unified: "1f9d9-200d-2642-fe0f",
				native: "🧙‍♂️"
			},
			{
				unified: "1f9d9-1f3fb-200d-2642-fe0f",
				native: "🧙🏻‍♂️"
			},
			{
				unified: "1f9d9-1f3fc-200d-2642-fe0f",
				native: "🧙🏼‍♂️"
			},
			{
				unified: "1f9d9-1f3fd-200d-2642-fe0f",
				native: "🧙🏽‍♂️"
			},
			{
				unified: "1f9d9-1f3fe-200d-2642-fe0f",
				native: "🧙🏾‍♂️"
			},
			{
				unified: "1f9d9-1f3ff-200d-2642-fe0f",
				native: "🧙🏿‍♂️"
			}
		],
		version: 5
	},
	female_mage: {
		id: "female_mage",
		name: "Woman Mage",
		keywords: [
			"female",
			"witch"
		],
		skins: [
			{
				unified: "1f9d9-200d-2640-fe0f",
				native: "🧙‍♀️"
			},
			{
				unified: "1f9d9-1f3fb-200d-2640-fe0f",
				native: "🧙🏻‍♀️"
			},
			{
				unified: "1f9d9-1f3fc-200d-2640-fe0f",
				native: "🧙🏼‍♀️"
			},
			{
				unified: "1f9d9-1f3fd-200d-2640-fe0f",
				native: "🧙🏽‍♀️"
			},
			{
				unified: "1f9d9-1f3fe-200d-2640-fe0f",
				native: "🧙🏾‍♀️"
			},
			{
				unified: "1f9d9-1f3ff-200d-2640-fe0f",
				native: "🧙🏿‍♀️"
			}
		],
		version: 5
	},
	fairy: {
		id: "fairy",
		name: "Fairy",
		keywords: [
			"wings",
			"magical"
		],
		skins: [
			{
				unified: "1f9da",
				native: "🧚"
			},
			{
				unified: "1f9da-1f3fb",
				native: "🧚🏻"
			},
			{
				unified: "1f9da-1f3fc",
				native: "🧚🏼"
			},
			{
				unified: "1f9da-1f3fd",
				native: "🧚🏽"
			},
			{
				unified: "1f9da-1f3fe",
				native: "🧚🏾"
			},
			{
				unified: "1f9da-1f3ff",
				native: "🧚🏿"
			}
		],
		version: 5
	},
	male_fairy: {
		id: "male_fairy",
		name: "Man Fairy",
		keywords: [
			"male"
		],
		skins: [
			{
				unified: "1f9da-200d-2642-fe0f",
				native: "🧚‍♂️"
			},
			{
				unified: "1f9da-1f3fb-200d-2642-fe0f",
				native: "🧚🏻‍♂️"
			},
			{
				unified: "1f9da-1f3fc-200d-2642-fe0f",
				native: "🧚🏼‍♂️"
			},
			{
				unified: "1f9da-1f3fd-200d-2642-fe0f",
				native: "🧚🏽‍♂️"
			},
			{
				unified: "1f9da-1f3fe-200d-2642-fe0f",
				native: "🧚🏾‍♂️"
			},
			{
				unified: "1f9da-1f3ff-200d-2642-fe0f",
				native: "🧚🏿‍♂️"
			}
		],
		version: 5
	},
	female_fairy: {
		id: "female_fairy",
		name: "Woman Fairy",
		keywords: [
			"female"
		],
		skins: [
			{
				unified: "1f9da-200d-2640-fe0f",
				native: "🧚‍♀️"
			},
			{
				unified: "1f9da-1f3fb-200d-2640-fe0f",
				native: "🧚🏻‍♀️"
			},
			{
				unified: "1f9da-1f3fc-200d-2640-fe0f",
				native: "🧚🏼‍♀️"
			},
			{
				unified: "1f9da-1f3fd-200d-2640-fe0f",
				native: "🧚🏽‍♀️"
			},
			{
				unified: "1f9da-1f3fe-200d-2640-fe0f",
				native: "🧚🏾‍♀️"
			},
			{
				unified: "1f9da-1f3ff-200d-2640-fe0f",
				native: "🧚🏿‍♀️"
			}
		],
		version: 5
	},
	vampire: {
		id: "vampire",
		name: "Vampire",
		keywords: [
			"blood",
			"twilight"
		],
		skins: [
			{
				unified: "1f9db",
				native: "🧛"
			},
			{
				unified: "1f9db-1f3fb",
				native: "🧛🏻"
			},
			{
				unified: "1f9db-1f3fc",
				native: "🧛🏼"
			},
			{
				unified: "1f9db-1f3fd",
				native: "🧛🏽"
			},
			{
				unified: "1f9db-1f3fe",
				native: "🧛🏾"
			},
			{
				unified: "1f9db-1f3ff",
				native: "🧛🏿"
			}
		],
		version: 5
	},
	male_vampire: {
		id: "male_vampire",
		name: "Man Vampire",
		keywords: [
			"male",
			"dracula"
		],
		skins: [
			{
				unified: "1f9db-200d-2642-fe0f",
				native: "🧛‍♂️"
			},
			{
				unified: "1f9db-1f3fb-200d-2642-fe0f",
				native: "🧛🏻‍♂️"
			},
			{
				unified: "1f9db-1f3fc-200d-2642-fe0f",
				native: "🧛🏼‍♂️"
			},
			{
				unified: "1f9db-1f3fd-200d-2642-fe0f",
				native: "🧛🏽‍♂️"
			},
			{
				unified: "1f9db-1f3fe-200d-2642-fe0f",
				native: "🧛🏾‍♂️"
			},
			{
				unified: "1f9db-1f3ff-200d-2642-fe0f",
				native: "🧛🏿‍♂️"
			}
		],
		version: 5
	},
	female_vampire: {
		id: "female_vampire",
		name: "Woman Vampire",
		keywords: [
			"female"
		],
		skins: [
			{
				unified: "1f9db-200d-2640-fe0f",
				native: "🧛‍♀️"
			},
			{
				unified: "1f9db-1f3fb-200d-2640-fe0f",
				native: "🧛🏻‍♀️"
			},
			{
				unified: "1f9db-1f3fc-200d-2640-fe0f",
				native: "🧛🏼‍♀️"
			},
			{
				unified: "1f9db-1f3fd-200d-2640-fe0f",
				native: "🧛🏽‍♀️"
			},
			{
				unified: "1f9db-1f3fe-200d-2640-fe0f",
				native: "🧛🏾‍♀️"
			},
			{
				unified: "1f9db-1f3ff-200d-2640-fe0f",
				native: "🧛🏿‍♀️"
			}
		],
		version: 5
	},
	merperson: {
		id: "merperson",
		name: "Merperson",
		keywords: [
			"sea"
		],
		skins: [
			{
				unified: "1f9dc",
				native: "🧜"
			},
			{
				unified: "1f9dc-1f3fb",
				native: "🧜🏻"
			},
			{
				unified: "1f9dc-1f3fc",
				native: "🧜🏼"
			},
			{
				unified: "1f9dc-1f3fd",
				native: "🧜🏽"
			},
			{
				unified: "1f9dc-1f3fe",
				native: "🧜🏾"
			},
			{
				unified: "1f9dc-1f3ff",
				native: "🧜🏿"
			}
		],
		version: 5
	},
	merman: {
		id: "merman",
		name: "Merman",
		keywords: [
			"man",
			"male",
			"triton"
		],
		skins: [
			{
				unified: "1f9dc-200d-2642-fe0f",
				native: "🧜‍♂️"
			},
			{
				unified: "1f9dc-1f3fb-200d-2642-fe0f",
				native: "🧜🏻‍♂️"
			},
			{
				unified: "1f9dc-1f3fc-200d-2642-fe0f",
				native: "🧜🏼‍♂️"
			},
			{
				unified: "1f9dc-1f3fd-200d-2642-fe0f",
				native: "🧜🏽‍♂️"
			},
			{
				unified: "1f9dc-1f3fe-200d-2642-fe0f",
				native: "🧜🏾‍♂️"
			},
			{
				unified: "1f9dc-1f3ff-200d-2642-fe0f",
				native: "🧜🏿‍♂️"
			}
		],
		version: 5
	},
	mermaid: {
		id: "mermaid",
		name: "Mermaid",
		keywords: [
			"woman",
			"female",
			"merwoman",
			"ariel"
		],
		skins: [
			{
				unified: "1f9dc-200d-2640-fe0f",
				native: "🧜‍♀️"
			},
			{
				unified: "1f9dc-1f3fb-200d-2640-fe0f",
				native: "🧜🏻‍♀️"
			},
			{
				unified: "1f9dc-1f3fc-200d-2640-fe0f",
				native: "🧜🏼‍♀️"
			},
			{
				unified: "1f9dc-1f3fd-200d-2640-fe0f",
				native: "🧜🏽‍♀️"
			},
			{
				unified: "1f9dc-1f3fe-200d-2640-fe0f",
				native: "🧜🏾‍♀️"
			},
			{
				unified: "1f9dc-1f3ff-200d-2640-fe0f",
				native: "🧜🏿‍♀️"
			}
		],
		version: 5
	},
	elf: {
		id: "elf",
		name: "Elf",
		keywords: [
			"magical"
		],
		skins: [
			{
				unified: "1f9dd",
				native: "🧝"
			},
			{
				unified: "1f9dd-1f3fb",
				native: "🧝🏻"
			},
			{
				unified: "1f9dd-1f3fc",
				native: "🧝🏼"
			},
			{
				unified: "1f9dd-1f3fd",
				native: "🧝🏽"
			},
			{
				unified: "1f9dd-1f3fe",
				native: "🧝🏾"
			},
			{
				unified: "1f9dd-1f3ff",
				native: "🧝🏿"
			}
		],
		version: 5
	},
	male_elf: {
		id: "male_elf",
		name: "Man Elf",
		keywords: [
			"male"
		],
		skins: [
			{
				unified: "1f9dd-200d-2642-fe0f",
				native: "🧝‍♂️"
			},
			{
				unified: "1f9dd-1f3fb-200d-2642-fe0f",
				native: "🧝🏻‍♂️"
			},
			{
				unified: "1f9dd-1f3fc-200d-2642-fe0f",
				native: "🧝🏼‍♂️"
			},
			{
				unified: "1f9dd-1f3fd-200d-2642-fe0f",
				native: "🧝🏽‍♂️"
			},
			{
				unified: "1f9dd-1f3fe-200d-2642-fe0f",
				native: "🧝🏾‍♂️"
			},
			{
				unified: "1f9dd-1f3ff-200d-2642-fe0f",
				native: "🧝🏿‍♂️"
			}
		],
		version: 5
	},
	female_elf: {
		id: "female_elf",
		name: "Woman Elf",
		keywords: [
			"female"
		],
		skins: [
			{
				unified: "1f9dd-200d-2640-fe0f",
				native: "🧝‍♀️"
			},
			{
				unified: "1f9dd-1f3fb-200d-2640-fe0f",
				native: "🧝🏻‍♀️"
			},
			{
				unified: "1f9dd-1f3fc-200d-2640-fe0f",
				native: "🧝🏼‍♀️"
			},
			{
				unified: "1f9dd-1f3fd-200d-2640-fe0f",
				native: "🧝🏽‍♀️"
			},
			{
				unified: "1f9dd-1f3fe-200d-2640-fe0f",
				native: "🧝🏾‍♀️"
			},
			{
				unified: "1f9dd-1f3ff-200d-2640-fe0f",
				native: "🧝🏿‍♀️"
			}
		],
		version: 5
	},
	genie: {
		id: "genie",
		name: "Genie",
		keywords: [
			"magical",
			"wishes"
		],
		skins: [
			{
				unified: "1f9de",
				native: "🧞"
			}
		],
		version: 5
	},
	male_genie: {
		id: "male_genie",
		name: "Man Genie",
		keywords: [
			"male"
		],
		skins: [
			{
				unified: "1f9de-200d-2642-fe0f",
				native: "🧞‍♂️"
			}
		],
		version: 5
	},
	female_genie: {
		id: "female_genie",
		name: "Woman Genie",
		keywords: [
			"female"
		],
		skins: [
			{
				unified: "1f9de-200d-2640-fe0f",
				native: "🧞‍♀️"
			}
		],
		version: 5
	},
	zombie: {
		id: "zombie",
		name: "Zombie",
		keywords: [
			"dead"
		],
		skins: [
			{
				unified: "1f9df",
				native: "🧟"
			}
		],
		version: 5
	},
	male_zombie: {
		id: "male_zombie",
		name: "Man Zombie",
		keywords: [
			"male",
			"dracula",
			"undead",
			"walking",
			"dead"
		],
		skins: [
			{
				unified: "1f9df-200d-2642-fe0f",
				native: "🧟‍♂️"
			}
		],
		version: 5
	},
	female_zombie: {
		id: "female_zombie",
		name: "Woman Zombie",
		keywords: [
			"female",
			"undead",
			"walking",
			"dead"
		],
		skins: [
			{
				unified: "1f9df-200d-2640-fe0f",
				native: "🧟‍♀️"
			}
		],
		version: 5
	},
	troll: {
		id: "troll",
		name: "Troll",
		keywords: [
			"mystical",
			"monster"
		],
		skins: [
			{
				unified: "1f9cc",
				native: "🧌"
			}
		],
		version: 14
	},
	massage: {
		id: "massage",
		name: "Face Massage",
		keywords: [
			"person",
			"getting",
			"relax"
		],
		skins: [
			{
				unified: "1f486",
				native: "💆"
			},
			{
				unified: "1f486-1f3fb",
				native: "💆🏻"
			},
			{
				unified: "1f486-1f3fc",
				native: "💆🏼"
			},
			{
				unified: "1f486-1f3fd",
				native: "💆🏽"
			},
			{
				unified: "1f486-1f3fe",
				native: "💆🏾"
			},
			{
				unified: "1f486-1f3ff",
				native: "💆🏿"
			}
		],
		version: 1
	},
	"man-getting-massage": {
		id: "man-getting-massage",
		name: "Man Getting Massage",
		keywords: [
			"getting-massage",
			"male",
			"boy",
			"head"
		],
		skins: [
			{
				unified: "1f486-200d-2642-fe0f",
				native: "💆‍♂️"
			},
			{
				unified: "1f486-1f3fb-200d-2642-fe0f",
				native: "💆🏻‍♂️"
			},
			{
				unified: "1f486-1f3fc-200d-2642-fe0f",
				native: "💆🏼‍♂️"
			},
			{
				unified: "1f486-1f3fd-200d-2642-fe0f",
				native: "💆🏽‍♂️"
			},
			{
				unified: "1f486-1f3fe-200d-2642-fe0f",
				native: "💆🏾‍♂️"
			},
			{
				unified: "1f486-1f3ff-200d-2642-fe0f",
				native: "💆🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-getting-massage": {
		id: "woman-getting-massage",
		name: "Woman Getting Massage",
		keywords: [
			"getting-massage",
			"female",
			"girl",
			"head"
		],
		skins: [
			{
				unified: "1f486-200d-2640-fe0f",
				native: "💆‍♀️"
			},
			{
				unified: "1f486-1f3fb-200d-2640-fe0f",
				native: "💆🏻‍♀️"
			},
			{
				unified: "1f486-1f3fc-200d-2640-fe0f",
				native: "💆🏼‍♀️"
			},
			{
				unified: "1f486-1f3fd-200d-2640-fe0f",
				native: "💆🏽‍♀️"
			},
			{
				unified: "1f486-1f3fe-200d-2640-fe0f",
				native: "💆🏾‍♀️"
			},
			{
				unified: "1f486-1f3ff-200d-2640-fe0f",
				native: "💆🏿‍♀️"
			}
		],
		version: 4
	},
	haircut: {
		id: "haircut",
		name: "Haircut",
		keywords: [
			"person",
			"getting",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f487",
				native: "💇"
			},
			{
				unified: "1f487-1f3fb",
				native: "💇🏻"
			},
			{
				unified: "1f487-1f3fc",
				native: "💇🏼"
			},
			{
				unified: "1f487-1f3fd",
				native: "💇🏽"
			},
			{
				unified: "1f487-1f3fe",
				native: "💇🏾"
			},
			{
				unified: "1f487-1f3ff",
				native: "💇🏿"
			}
		],
		version: 1
	},
	"man-getting-haircut": {
		id: "man-getting-haircut",
		name: "Man Getting Haircut",
		keywords: [
			"getting-haircut",
			"male",
			"boy"
		],
		skins: [
			{
				unified: "1f487-200d-2642-fe0f",
				native: "💇‍♂️"
			},
			{
				unified: "1f487-1f3fb-200d-2642-fe0f",
				native: "💇🏻‍♂️"
			},
			{
				unified: "1f487-1f3fc-200d-2642-fe0f",
				native: "💇🏼‍♂️"
			},
			{
				unified: "1f487-1f3fd-200d-2642-fe0f",
				native: "💇🏽‍♂️"
			},
			{
				unified: "1f487-1f3fe-200d-2642-fe0f",
				native: "💇🏾‍♂️"
			},
			{
				unified: "1f487-1f3ff-200d-2642-fe0f",
				native: "💇🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-getting-haircut": {
		id: "woman-getting-haircut",
		name: "Woman Getting Haircut",
		keywords: [
			"getting-haircut",
			"female",
			"girl"
		],
		skins: [
			{
				unified: "1f487-200d-2640-fe0f",
				native: "💇‍♀️"
			},
			{
				unified: "1f487-1f3fb-200d-2640-fe0f",
				native: "💇🏻‍♀️"
			},
			{
				unified: "1f487-1f3fc-200d-2640-fe0f",
				native: "💇🏼‍♀️"
			},
			{
				unified: "1f487-1f3fd-200d-2640-fe0f",
				native: "💇🏽‍♀️"
			},
			{
				unified: "1f487-1f3fe-200d-2640-fe0f",
				native: "💇🏾‍♀️"
			},
			{
				unified: "1f487-1f3ff-200d-2640-fe0f",
				native: "💇🏿‍♀️"
			}
		],
		version: 4
	},
	walking: {
		id: "walking",
		name: "Pedestrian",
		keywords: [
			"walking",
			"person",
			"move"
		],
		skins: [
			{
				unified: "1f6b6",
				native: "🚶"
			},
			{
				unified: "1f6b6-1f3fb",
				native: "🚶🏻"
			},
			{
				unified: "1f6b6-1f3fc",
				native: "🚶🏼"
			},
			{
				unified: "1f6b6-1f3fd",
				native: "🚶🏽"
			},
			{
				unified: "1f6b6-1f3fe",
				native: "🚶🏾"
			},
			{
				unified: "1f6b6-1f3ff",
				native: "🚶🏿"
			}
		],
		version: 1
	},
	"man-walking": {
		id: "man-walking",
		name: "Man Walking",
		keywords: [
			"human",
			"feet",
			"steps"
		],
		skins: [
			{
				unified: "1f6b6-200d-2642-fe0f",
				native: "🚶‍♂️"
			},
			{
				unified: "1f6b6-1f3fb-200d-2642-fe0f",
				native: "🚶🏻‍♂️"
			},
			{
				unified: "1f6b6-1f3fc-200d-2642-fe0f",
				native: "🚶🏼‍♂️"
			},
			{
				unified: "1f6b6-1f3fd-200d-2642-fe0f",
				native: "🚶🏽‍♂️"
			},
			{
				unified: "1f6b6-1f3fe-200d-2642-fe0f",
				native: "🚶🏾‍♂️"
			},
			{
				unified: "1f6b6-1f3ff-200d-2642-fe0f",
				native: "🚶🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-walking": {
		id: "woman-walking",
		name: "Woman Walking",
		keywords: [
			"human",
			"feet",
			"steps",
			"female"
		],
		skins: [
			{
				unified: "1f6b6-200d-2640-fe0f",
				native: "🚶‍♀️"
			},
			{
				unified: "1f6b6-1f3fb-200d-2640-fe0f",
				native: "🚶🏻‍♀️"
			},
			{
				unified: "1f6b6-1f3fc-200d-2640-fe0f",
				native: "🚶🏼‍♀️"
			},
			{
				unified: "1f6b6-1f3fd-200d-2640-fe0f",
				native: "🚶🏽‍♀️"
			},
			{
				unified: "1f6b6-1f3fe-200d-2640-fe0f",
				native: "🚶🏾‍♀️"
			},
			{
				unified: "1f6b6-1f3ff-200d-2640-fe0f",
				native: "🚶🏿‍♀️"
			}
		],
		version: 4
	},
	standing_person: {
		id: "standing_person",
		name: "Standing Person",
		keywords: [
			"still"
		],
		skins: [
			{
				unified: "1f9cd",
				native: "🧍"
			},
			{
				unified: "1f9cd-1f3fb",
				native: "🧍🏻"
			},
			{
				unified: "1f9cd-1f3fc",
				native: "🧍🏼"
			},
			{
				unified: "1f9cd-1f3fd",
				native: "🧍🏽"
			},
			{
				unified: "1f9cd-1f3fe",
				native: "🧍🏾"
			},
			{
				unified: "1f9cd-1f3ff",
				native: "🧍🏿"
			}
		],
		version: 12
	},
	man_standing: {
		id: "man_standing",
		name: "Man Standing",
		keywords: [
			"still"
		],
		skins: [
			{
				unified: "1f9cd-200d-2642-fe0f",
				native: "🧍‍♂️"
			},
			{
				unified: "1f9cd-1f3fb-200d-2642-fe0f",
				native: "🧍🏻‍♂️"
			},
			{
				unified: "1f9cd-1f3fc-200d-2642-fe0f",
				native: "🧍🏼‍♂️"
			},
			{
				unified: "1f9cd-1f3fd-200d-2642-fe0f",
				native: "🧍🏽‍♂️"
			},
			{
				unified: "1f9cd-1f3fe-200d-2642-fe0f",
				native: "🧍🏾‍♂️"
			},
			{
				unified: "1f9cd-1f3ff-200d-2642-fe0f",
				native: "🧍🏿‍♂️"
			}
		],
		version: 12
	},
	woman_standing: {
		id: "woman_standing",
		name: "Woman Standing",
		keywords: [
			"still"
		],
		skins: [
			{
				unified: "1f9cd-200d-2640-fe0f",
				native: "🧍‍♀️"
			},
			{
				unified: "1f9cd-1f3fb-200d-2640-fe0f",
				native: "🧍🏻‍♀️"
			},
			{
				unified: "1f9cd-1f3fc-200d-2640-fe0f",
				native: "🧍🏼‍♀️"
			},
			{
				unified: "1f9cd-1f3fd-200d-2640-fe0f",
				native: "🧍🏽‍♀️"
			},
			{
				unified: "1f9cd-1f3fe-200d-2640-fe0f",
				native: "🧍🏾‍♀️"
			},
			{
				unified: "1f9cd-1f3ff-200d-2640-fe0f",
				native: "🧍🏿‍♀️"
			}
		],
		version: 12
	},
	kneeling_person: {
		id: "kneeling_person",
		name: "Kneeling Person",
		keywords: [
			"pray",
			"respectful"
		],
		skins: [
			{
				unified: "1f9ce",
				native: "🧎"
			},
			{
				unified: "1f9ce-1f3fb",
				native: "🧎🏻"
			},
			{
				unified: "1f9ce-1f3fc",
				native: "🧎🏼"
			},
			{
				unified: "1f9ce-1f3fd",
				native: "🧎🏽"
			},
			{
				unified: "1f9ce-1f3fe",
				native: "🧎🏾"
			},
			{
				unified: "1f9ce-1f3ff",
				native: "🧎🏿"
			}
		],
		version: 12
	},
	man_kneeling: {
		id: "man_kneeling",
		name: "Man Kneeling",
		keywords: [
			"pray",
			"respectful"
		],
		skins: [
			{
				unified: "1f9ce-200d-2642-fe0f",
				native: "🧎‍♂️"
			},
			{
				unified: "1f9ce-1f3fb-200d-2642-fe0f",
				native: "🧎🏻‍♂️"
			},
			{
				unified: "1f9ce-1f3fc-200d-2642-fe0f",
				native: "🧎🏼‍♂️"
			},
			{
				unified: "1f9ce-1f3fd-200d-2642-fe0f",
				native: "🧎🏽‍♂️"
			},
			{
				unified: "1f9ce-1f3fe-200d-2642-fe0f",
				native: "🧎🏾‍♂️"
			},
			{
				unified: "1f9ce-1f3ff-200d-2642-fe0f",
				native: "🧎🏿‍♂️"
			}
		],
		version: 12
	},
	woman_kneeling: {
		id: "woman_kneeling",
		name: "Woman Kneeling",
		keywords: [
			"respectful",
			"pray"
		],
		skins: [
			{
				unified: "1f9ce-200d-2640-fe0f",
				native: "🧎‍♀️"
			},
			{
				unified: "1f9ce-1f3fb-200d-2640-fe0f",
				native: "🧎🏻‍♀️"
			},
			{
				unified: "1f9ce-1f3fc-200d-2640-fe0f",
				native: "🧎🏼‍♀️"
			},
			{
				unified: "1f9ce-1f3fd-200d-2640-fe0f",
				native: "🧎🏽‍♀️"
			},
			{
				unified: "1f9ce-1f3fe-200d-2640-fe0f",
				native: "🧎🏾‍♀️"
			},
			{
				unified: "1f9ce-1f3ff-200d-2640-fe0f",
				native: "🧎🏿‍♀️"
			}
		],
		version: 12
	},
	person_with_probing_cane: {
		id: "person_with_probing_cane",
		name: "Person with White Cane",
		keywords: [
			"probing",
			"blind"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f9af",
				native: "🧑‍🦯"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f9af",
				native: "🧑🏻‍🦯"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f9af",
				native: "🧑🏼‍🦯"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f9af",
				native: "🧑🏽‍🦯"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f9af",
				native: "🧑🏾‍🦯"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f9af",
				native: "🧑🏿‍🦯"
			}
		],
		version: 12.1
	},
	man_with_probing_cane: {
		id: "man_with_probing_cane",
		name: "Man with White Cane",
		keywords: [
			"probing",
			"blind"
		],
		skins: [
			{
				unified: "1f468-200d-1f9af",
				native: "👨‍🦯"
			},
			{
				unified: "1f468-1f3fb-200d-1f9af",
				native: "👨🏻‍🦯"
			},
			{
				unified: "1f468-1f3fc-200d-1f9af",
				native: "👨🏼‍🦯"
			},
			{
				unified: "1f468-1f3fd-200d-1f9af",
				native: "👨🏽‍🦯"
			},
			{
				unified: "1f468-1f3fe-200d-1f9af",
				native: "👨🏾‍🦯"
			},
			{
				unified: "1f468-1f3ff-200d-1f9af",
				native: "👨🏿‍🦯"
			}
		],
		version: 12
	},
	woman_with_probing_cane: {
		id: "woman_with_probing_cane",
		name: "Woman with White Cane",
		keywords: [
			"probing",
			"blind"
		],
		skins: [
			{
				unified: "1f469-200d-1f9af",
				native: "👩‍🦯"
			},
			{
				unified: "1f469-1f3fb-200d-1f9af",
				native: "👩🏻‍🦯"
			},
			{
				unified: "1f469-1f3fc-200d-1f9af",
				native: "👩🏼‍🦯"
			},
			{
				unified: "1f469-1f3fd-200d-1f9af",
				native: "👩🏽‍🦯"
			},
			{
				unified: "1f469-1f3fe-200d-1f9af",
				native: "👩🏾‍🦯"
			},
			{
				unified: "1f469-1f3ff-200d-1f9af",
				native: "👩🏿‍🦯"
			}
		],
		version: 12
	},
	person_in_motorized_wheelchair: {
		id: "person_in_motorized_wheelchair",
		name: "Person in Motorized Wheelchair",
		keywords: [
			"disability",
			"accessibility"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f9bc",
				native: "🧑‍🦼"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f9bc",
				native: "🧑🏻‍🦼"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f9bc",
				native: "🧑🏼‍🦼"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f9bc",
				native: "🧑🏽‍🦼"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f9bc",
				native: "🧑🏾‍🦼"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f9bc",
				native: "🧑🏿‍🦼"
			}
		],
		version: 12.1
	},
	man_in_motorized_wheelchair: {
		id: "man_in_motorized_wheelchair",
		name: "Man in Motorized Wheelchair",
		keywords: [
			"disability",
			"accessibility"
		],
		skins: [
			{
				unified: "1f468-200d-1f9bc",
				native: "👨‍🦼"
			},
			{
				unified: "1f468-1f3fb-200d-1f9bc",
				native: "👨🏻‍🦼"
			},
			{
				unified: "1f468-1f3fc-200d-1f9bc",
				native: "👨🏼‍🦼"
			},
			{
				unified: "1f468-1f3fd-200d-1f9bc",
				native: "👨🏽‍🦼"
			},
			{
				unified: "1f468-1f3fe-200d-1f9bc",
				native: "👨🏾‍🦼"
			},
			{
				unified: "1f468-1f3ff-200d-1f9bc",
				native: "👨🏿‍🦼"
			}
		],
		version: 12
	},
	woman_in_motorized_wheelchair: {
		id: "woman_in_motorized_wheelchair",
		name: "Woman in Motorized Wheelchair",
		keywords: [
			"disability",
			"accessibility"
		],
		skins: [
			{
				unified: "1f469-200d-1f9bc",
				native: "👩‍🦼"
			},
			{
				unified: "1f469-1f3fb-200d-1f9bc",
				native: "👩🏻‍🦼"
			},
			{
				unified: "1f469-1f3fc-200d-1f9bc",
				native: "👩🏼‍🦼"
			},
			{
				unified: "1f469-1f3fd-200d-1f9bc",
				native: "👩🏽‍🦼"
			},
			{
				unified: "1f469-1f3fe-200d-1f9bc",
				native: "👩🏾‍🦼"
			},
			{
				unified: "1f469-1f3ff-200d-1f9bc",
				native: "👩🏿‍🦼"
			}
		],
		version: 12
	},
	person_in_manual_wheelchair: {
		id: "person_in_manual_wheelchair",
		name: "Person in Manual Wheelchair",
		keywords: [
			"disability",
			"accessibility"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f9bd",
				native: "🧑‍🦽"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f9bd",
				native: "🧑🏻‍🦽"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f9bd",
				native: "🧑🏼‍🦽"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f9bd",
				native: "🧑🏽‍🦽"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f9bd",
				native: "🧑🏾‍🦽"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f9bd",
				native: "🧑🏿‍🦽"
			}
		],
		version: 12.1
	},
	man_in_manual_wheelchair: {
		id: "man_in_manual_wheelchair",
		name: "Man in Manual Wheelchair",
		keywords: [
			"disability",
			"accessibility"
		],
		skins: [
			{
				unified: "1f468-200d-1f9bd",
				native: "👨‍🦽"
			},
			{
				unified: "1f468-1f3fb-200d-1f9bd",
				native: "👨🏻‍🦽"
			},
			{
				unified: "1f468-1f3fc-200d-1f9bd",
				native: "👨🏼‍🦽"
			},
			{
				unified: "1f468-1f3fd-200d-1f9bd",
				native: "👨🏽‍🦽"
			},
			{
				unified: "1f468-1f3fe-200d-1f9bd",
				native: "👨🏾‍🦽"
			},
			{
				unified: "1f468-1f3ff-200d-1f9bd",
				native: "👨🏿‍🦽"
			}
		],
		version: 12
	},
	woman_in_manual_wheelchair: {
		id: "woman_in_manual_wheelchair",
		name: "Woman in Manual Wheelchair",
		keywords: [
			"disability",
			"accessibility"
		],
		skins: [
			{
				unified: "1f469-200d-1f9bd",
				native: "👩‍🦽"
			},
			{
				unified: "1f469-1f3fb-200d-1f9bd",
				native: "👩🏻‍🦽"
			},
			{
				unified: "1f469-1f3fc-200d-1f9bd",
				native: "👩🏼‍🦽"
			},
			{
				unified: "1f469-1f3fd-200d-1f9bd",
				native: "👩🏽‍🦽"
			},
			{
				unified: "1f469-1f3fe-200d-1f9bd",
				native: "👩🏾‍🦽"
			},
			{
				unified: "1f469-1f3ff-200d-1f9bd",
				native: "👩🏿‍🦽"
			}
		],
		version: 12
	},
	runner: {
		id: "runner",
		name: "Runner",
		keywords: [
			"running",
			"person",
			"move"
		],
		skins: [
			{
				unified: "1f3c3",
				native: "🏃"
			},
			{
				unified: "1f3c3-1f3fb",
				native: "🏃🏻"
			},
			{
				unified: "1f3c3-1f3fc",
				native: "🏃🏼"
			},
			{
				unified: "1f3c3-1f3fd",
				native: "🏃🏽"
			},
			{
				unified: "1f3c3-1f3fe",
				native: "🏃🏾"
			},
			{
				unified: "1f3c3-1f3ff",
				native: "🏃🏿"
			}
		],
		version: 1
	},
	"man-running": {
		id: "man-running",
		name: "Man Running",
		keywords: [
			"walking",
			"exercise",
			"race"
		],
		skins: [
			{
				unified: "1f3c3-200d-2642-fe0f",
				native: "🏃‍♂️"
			},
			{
				unified: "1f3c3-1f3fb-200d-2642-fe0f",
				native: "🏃🏻‍♂️"
			},
			{
				unified: "1f3c3-1f3fc-200d-2642-fe0f",
				native: "🏃🏼‍♂️"
			},
			{
				unified: "1f3c3-1f3fd-200d-2642-fe0f",
				native: "🏃🏽‍♂️"
			},
			{
				unified: "1f3c3-1f3fe-200d-2642-fe0f",
				native: "🏃🏾‍♂️"
			},
			{
				unified: "1f3c3-1f3ff-200d-2642-fe0f",
				native: "🏃🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-running": {
		id: "woman-running",
		name: "Woman Running",
		keywords: [
			"walking",
			"exercise",
			"race",
			"female"
		],
		skins: [
			{
				unified: "1f3c3-200d-2640-fe0f",
				native: "🏃‍♀️"
			},
			{
				unified: "1f3c3-1f3fb-200d-2640-fe0f",
				native: "🏃🏻‍♀️"
			},
			{
				unified: "1f3c3-1f3fc-200d-2640-fe0f",
				native: "🏃🏼‍♀️"
			},
			{
				unified: "1f3c3-1f3fd-200d-2640-fe0f",
				native: "🏃🏽‍♀️"
			},
			{
				unified: "1f3c3-1f3fe-200d-2640-fe0f",
				native: "🏃🏾‍♀️"
			},
			{
				unified: "1f3c3-1f3ff-200d-2640-fe0f",
				native: "🏃🏿‍♀️"
			}
		],
		version: 4
	},
	dancer: {
		id: "dancer",
		name: "Dancer",
		keywords: [
			"woman",
			"dancing",
			"female",
			"girl",
			"fun"
		],
		skins: [
			{
				unified: "1f483",
				native: "💃"
			},
			{
				unified: "1f483-1f3fb",
				native: "💃🏻"
			},
			{
				unified: "1f483-1f3fc",
				native: "💃🏼"
			},
			{
				unified: "1f483-1f3fd",
				native: "💃🏽"
			},
			{
				unified: "1f483-1f3fe",
				native: "💃🏾"
			},
			{
				unified: "1f483-1f3ff",
				native: "💃🏿"
			}
		],
		version: 1
	},
	man_dancing: {
		id: "man_dancing",
		name: "Man Dancing",
		keywords: [
			"male",
			"boy",
			"fun",
			"dancer"
		],
		skins: [
			{
				unified: "1f57a",
				native: "🕺"
			},
			{
				unified: "1f57a-1f3fb",
				native: "🕺🏻"
			},
			{
				unified: "1f57a-1f3fc",
				native: "🕺🏼"
			},
			{
				unified: "1f57a-1f3fd",
				native: "🕺🏽"
			},
			{
				unified: "1f57a-1f3fe",
				native: "🕺🏾"
			},
			{
				unified: "1f57a-1f3ff",
				native: "🕺🏿"
			}
		],
		version: 3
	},
	man_in_business_suit_levitating: {
		id: "man_in_business_suit_levitating",
		name: "Person in Suit Levitating",
		keywords: [
			"man",
			"business",
			"levitate",
			"hover",
			"jump"
		],
		skins: [
			{
				unified: "1f574-fe0f",
				native: "🕴️"
			},
			{
				unified: "1f574-1f3fb",
				native: "🕴🏻"
			},
			{
				unified: "1f574-1f3fc",
				native: "🕴🏼"
			},
			{
				unified: "1f574-1f3fd",
				native: "🕴🏽"
			},
			{
				unified: "1f574-1f3fe",
				native: "🕴🏾"
			},
			{
				unified: "1f574-1f3ff",
				native: "🕴🏿"
			}
		],
		version: 1
	},
	dancers: {
		id: "dancers",
		name: "Woman with Bunny Ears",
		keywords: [
			"dancers",
			"people",
			"perform",
			"costume"
		],
		skins: [
			{
				unified: "1f46f",
				native: "👯"
			}
		],
		version: 1
	},
	"men-with-bunny-ears-partying": {
		id: "men-with-bunny-ears-partying",
		name: "Men with Bunny Ears",
		keywords: [
			"with-bunny-ears-partying",
			"man",
			"male",
			"boys"
		],
		skins: [
			{
				unified: "1f46f-200d-2642-fe0f",
				native: "👯‍♂️"
			}
		],
		version: 4
	},
	"women-with-bunny-ears-partying": {
		id: "women-with-bunny-ears-partying",
		name: "Women with Bunny Ears",
		keywords: [
			"with-bunny-ears-partying",
			"woman",
			"female",
			"girls"
		],
		skins: [
			{
				unified: "1f46f-200d-2640-fe0f",
				native: "👯‍♀️"
			}
		],
		version: 4
	},
	person_in_steamy_room: {
		id: "person_in_steamy_room",
		name: "Person in Steamy Room",
		keywords: [
			"relax",
			"spa"
		],
		skins: [
			{
				unified: "1f9d6",
				native: "🧖"
			},
			{
				unified: "1f9d6-1f3fb",
				native: "🧖🏻"
			},
			{
				unified: "1f9d6-1f3fc",
				native: "🧖🏼"
			},
			{
				unified: "1f9d6-1f3fd",
				native: "🧖🏽"
			},
			{
				unified: "1f9d6-1f3fe",
				native: "🧖🏾"
			},
			{
				unified: "1f9d6-1f3ff",
				native: "🧖🏿"
			}
		],
		version: 5
	},
	man_in_steamy_room: {
		id: "man_in_steamy_room",
		name: "Man in Steamy Room",
		keywords: [
			"male",
			"spa",
			"steamroom",
			"sauna"
		],
		skins: [
			{
				unified: "1f9d6-200d-2642-fe0f",
				native: "🧖‍♂️"
			},
			{
				unified: "1f9d6-1f3fb-200d-2642-fe0f",
				native: "🧖🏻‍♂️"
			},
			{
				unified: "1f9d6-1f3fc-200d-2642-fe0f",
				native: "🧖🏼‍♂️"
			},
			{
				unified: "1f9d6-1f3fd-200d-2642-fe0f",
				native: "🧖🏽‍♂️"
			},
			{
				unified: "1f9d6-1f3fe-200d-2642-fe0f",
				native: "🧖🏾‍♂️"
			},
			{
				unified: "1f9d6-1f3ff-200d-2642-fe0f",
				native: "🧖🏿‍♂️"
			}
		],
		version: 5
	},
	woman_in_steamy_room: {
		id: "woman_in_steamy_room",
		name: "Woman in Steamy Room",
		keywords: [
			"female",
			"spa",
			"steamroom",
			"sauna"
		],
		skins: [
			{
				unified: "1f9d6-200d-2640-fe0f",
				native: "🧖‍♀️"
			},
			{
				unified: "1f9d6-1f3fb-200d-2640-fe0f",
				native: "🧖🏻‍♀️"
			},
			{
				unified: "1f9d6-1f3fc-200d-2640-fe0f",
				native: "🧖🏼‍♀️"
			},
			{
				unified: "1f9d6-1f3fd-200d-2640-fe0f",
				native: "🧖🏽‍♀️"
			},
			{
				unified: "1f9d6-1f3fe-200d-2640-fe0f",
				native: "🧖🏾‍♀️"
			},
			{
				unified: "1f9d6-1f3ff-200d-2640-fe0f",
				native: "🧖🏿‍♀️"
			}
		],
		version: 5
	},
	person_climbing: {
		id: "person_climbing",
		name: "Person Climbing",
		keywords: [
			"sport"
		],
		skins: [
			{
				unified: "1f9d7",
				native: "🧗"
			},
			{
				unified: "1f9d7-1f3fb",
				native: "🧗🏻"
			},
			{
				unified: "1f9d7-1f3fc",
				native: "🧗🏼"
			},
			{
				unified: "1f9d7-1f3fd",
				native: "🧗🏽"
			},
			{
				unified: "1f9d7-1f3fe",
				native: "🧗🏾"
			},
			{
				unified: "1f9d7-1f3ff",
				native: "🧗🏿"
			}
		],
		version: 5
	},
	man_climbing: {
		id: "man_climbing",
		name: "Man Climbing",
		keywords: [
			"sports",
			"hobby",
			"male",
			"rock"
		],
		skins: [
			{
				unified: "1f9d7-200d-2642-fe0f",
				native: "🧗‍♂️"
			},
			{
				unified: "1f9d7-1f3fb-200d-2642-fe0f",
				native: "🧗🏻‍♂️"
			},
			{
				unified: "1f9d7-1f3fc-200d-2642-fe0f",
				native: "🧗🏼‍♂️"
			},
			{
				unified: "1f9d7-1f3fd-200d-2642-fe0f",
				native: "🧗🏽‍♂️"
			},
			{
				unified: "1f9d7-1f3fe-200d-2642-fe0f",
				native: "🧗🏾‍♂️"
			},
			{
				unified: "1f9d7-1f3ff-200d-2642-fe0f",
				native: "🧗🏿‍♂️"
			}
		],
		version: 5
	},
	woman_climbing: {
		id: "woman_climbing",
		name: "Woman Climbing",
		keywords: [
			"sports",
			"hobby",
			"female",
			"rock"
		],
		skins: [
			{
				unified: "1f9d7-200d-2640-fe0f",
				native: "🧗‍♀️"
			},
			{
				unified: "1f9d7-1f3fb-200d-2640-fe0f",
				native: "🧗🏻‍♀️"
			},
			{
				unified: "1f9d7-1f3fc-200d-2640-fe0f",
				native: "🧗🏼‍♀️"
			},
			{
				unified: "1f9d7-1f3fd-200d-2640-fe0f",
				native: "🧗🏽‍♀️"
			},
			{
				unified: "1f9d7-1f3fe-200d-2640-fe0f",
				native: "🧗🏾‍♀️"
			},
			{
				unified: "1f9d7-1f3ff-200d-2640-fe0f",
				native: "🧗🏿‍♀️"
			}
		],
		version: 5
	},
	fencer: {
		id: "fencer",
		name: "Fencer",
		keywords: [
			"person",
			"fencing",
			"sports",
			"sword"
		],
		skins: [
			{
				unified: "1f93a",
				native: "🤺"
			}
		],
		version: 3
	},
	horse_racing: {
		id: "horse_racing",
		name: "Horse Racing",
		keywords: [
			"animal",
			"betting",
			"competition",
			"gambling",
			"luck"
		],
		skins: [
			{
				unified: "1f3c7",
				native: "🏇"
			},
			{
				unified: "1f3c7-1f3fb",
				native: "🏇🏻"
			},
			{
				unified: "1f3c7-1f3fc",
				native: "🏇🏼"
			},
			{
				unified: "1f3c7-1f3fd",
				native: "🏇🏽"
			},
			{
				unified: "1f3c7-1f3fe",
				native: "🏇🏾"
			},
			{
				unified: "1f3c7-1f3ff",
				native: "🏇🏿"
			}
		],
		version: 1
	},
	skier: {
		id: "skier",
		name: "Skier",
		keywords: [
			"sports",
			"winter",
			"snow"
		],
		skins: [
			{
				unified: "26f7-fe0f",
				native: "⛷️"
			}
		],
		version: 1
	},
	snowboarder: {
		id: "snowboarder",
		name: "Snowboarder",
		keywords: [
			"sports",
			"winter"
		],
		skins: [
			{
				unified: "1f3c2",
				native: "🏂"
			},
			{
				unified: "1f3c2-1f3fb",
				native: "🏂🏻"
			},
			{
				unified: "1f3c2-1f3fc",
				native: "🏂🏼"
			},
			{
				unified: "1f3c2-1f3fd",
				native: "🏂🏽"
			},
			{
				unified: "1f3c2-1f3fe",
				native: "🏂🏾"
			},
			{
				unified: "1f3c2-1f3ff",
				native: "🏂🏿"
			}
		],
		version: 1
	},
	golfer: {
		id: "golfer",
		name: "Person Golfing",
		keywords: [
			"golfer",
			"sports",
			"business"
		],
		skins: [
			{
				unified: "1f3cc-fe0f",
				native: "🏌️"
			},
			{
				unified: "1f3cc-1f3fb",
				native: "🏌🏻"
			},
			{
				unified: "1f3cc-1f3fc",
				native: "🏌🏼"
			},
			{
				unified: "1f3cc-1f3fd",
				native: "🏌🏽"
			},
			{
				unified: "1f3cc-1f3fe",
				native: "🏌🏾"
			},
			{
				unified: "1f3cc-1f3ff",
				native: "🏌🏿"
			}
		],
		version: 1
	},
	"man-golfing": {
		id: "man-golfing",
		name: "Man Golfing",
		keywords: [
			"sport"
		],
		skins: [
			{
				unified: "1f3cc-fe0f-200d-2642-fe0f",
				native: "🏌️‍♂️"
			},
			{
				unified: "1f3cc-1f3fb-200d-2642-fe0f",
				native: "🏌🏻‍♂️"
			},
			{
				unified: "1f3cc-1f3fc-200d-2642-fe0f",
				native: "🏌🏼‍♂️"
			},
			{
				unified: "1f3cc-1f3fd-200d-2642-fe0f",
				native: "🏌🏽‍♂️"
			},
			{
				unified: "1f3cc-1f3fe-200d-2642-fe0f",
				native: "🏌🏾‍♂️"
			},
			{
				unified: "1f3cc-1f3ff-200d-2642-fe0f",
				native: "🏌🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-golfing": {
		id: "woman-golfing",
		name: "Woman Golfing",
		keywords: [
			"sports",
			"business",
			"female"
		],
		skins: [
			{
				unified: "1f3cc-fe0f-200d-2640-fe0f",
				native: "🏌️‍♀️"
			},
			{
				unified: "1f3cc-1f3fb-200d-2640-fe0f",
				native: "🏌🏻‍♀️"
			},
			{
				unified: "1f3cc-1f3fc-200d-2640-fe0f",
				native: "🏌🏼‍♀️"
			},
			{
				unified: "1f3cc-1f3fd-200d-2640-fe0f",
				native: "🏌🏽‍♀️"
			},
			{
				unified: "1f3cc-1f3fe-200d-2640-fe0f",
				native: "🏌🏾‍♀️"
			},
			{
				unified: "1f3cc-1f3ff-200d-2640-fe0f",
				native: "🏌🏿‍♀️"
			}
		],
		version: 4
	},
	surfer: {
		id: "surfer",
		name: "Surfer",
		keywords: [
			"person",
			"surfing",
			"sport",
			"sea"
		],
		skins: [
			{
				unified: "1f3c4",
				native: "🏄"
			},
			{
				unified: "1f3c4-1f3fb",
				native: "🏄🏻"
			},
			{
				unified: "1f3c4-1f3fc",
				native: "🏄🏼"
			},
			{
				unified: "1f3c4-1f3fd",
				native: "🏄🏽"
			},
			{
				unified: "1f3c4-1f3fe",
				native: "🏄🏾"
			},
			{
				unified: "1f3c4-1f3ff",
				native: "🏄🏿"
			}
		],
		version: 1
	},
	"man-surfing": {
		id: "man-surfing",
		name: "Man Surfing",
		keywords: [
			"sports",
			"ocean",
			"sea",
			"summer",
			"beach"
		],
		skins: [
			{
				unified: "1f3c4-200d-2642-fe0f",
				native: "🏄‍♂️"
			},
			{
				unified: "1f3c4-1f3fb-200d-2642-fe0f",
				native: "🏄🏻‍♂️"
			},
			{
				unified: "1f3c4-1f3fc-200d-2642-fe0f",
				native: "🏄🏼‍♂️"
			},
			{
				unified: "1f3c4-1f3fd-200d-2642-fe0f",
				native: "🏄🏽‍♂️"
			},
			{
				unified: "1f3c4-1f3fe-200d-2642-fe0f",
				native: "🏄🏾‍♂️"
			},
			{
				unified: "1f3c4-1f3ff-200d-2642-fe0f",
				native: "🏄🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-surfing": {
		id: "woman-surfing",
		name: "Woman Surfing",
		keywords: [
			"sports",
			"ocean",
			"sea",
			"summer",
			"beach",
			"female"
		],
		skins: [
			{
				unified: "1f3c4-200d-2640-fe0f",
				native: "🏄‍♀️"
			},
			{
				unified: "1f3c4-1f3fb-200d-2640-fe0f",
				native: "🏄🏻‍♀️"
			},
			{
				unified: "1f3c4-1f3fc-200d-2640-fe0f",
				native: "🏄🏼‍♀️"
			},
			{
				unified: "1f3c4-1f3fd-200d-2640-fe0f",
				native: "🏄🏽‍♀️"
			},
			{
				unified: "1f3c4-1f3fe-200d-2640-fe0f",
				native: "🏄🏾‍♀️"
			},
			{
				unified: "1f3c4-1f3ff-200d-2640-fe0f",
				native: "🏄🏿‍♀️"
			}
		],
		version: 4
	},
	rowboat: {
		id: "rowboat",
		name: "Rowboat",
		keywords: [
			"person",
			"rowing",
			"boat",
			"sport",
			"move"
		],
		skins: [
			{
				unified: "1f6a3",
				native: "🚣"
			},
			{
				unified: "1f6a3-1f3fb",
				native: "🚣🏻"
			},
			{
				unified: "1f6a3-1f3fc",
				native: "🚣🏼"
			},
			{
				unified: "1f6a3-1f3fd",
				native: "🚣🏽"
			},
			{
				unified: "1f6a3-1f3fe",
				native: "🚣🏾"
			},
			{
				unified: "1f6a3-1f3ff",
				native: "🚣🏿"
			}
		],
		version: 1
	},
	"man-rowing-boat": {
		id: "man-rowing-boat",
		name: "Man Rowing Boat",
		keywords: [
			"rowing-boat",
			"sports",
			"hobby",
			"water",
			"ship"
		],
		skins: [
			{
				unified: "1f6a3-200d-2642-fe0f",
				native: "🚣‍♂️"
			},
			{
				unified: "1f6a3-1f3fb-200d-2642-fe0f",
				native: "🚣🏻‍♂️"
			},
			{
				unified: "1f6a3-1f3fc-200d-2642-fe0f",
				native: "🚣🏼‍♂️"
			},
			{
				unified: "1f6a3-1f3fd-200d-2642-fe0f",
				native: "🚣🏽‍♂️"
			},
			{
				unified: "1f6a3-1f3fe-200d-2642-fe0f",
				native: "🚣🏾‍♂️"
			},
			{
				unified: "1f6a3-1f3ff-200d-2642-fe0f",
				native: "🚣🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-rowing-boat": {
		id: "woman-rowing-boat",
		name: "Woman Rowing Boat",
		keywords: [
			"rowing-boat",
			"sports",
			"hobby",
			"water",
			"ship",
			"female"
		],
		skins: [
			{
				unified: "1f6a3-200d-2640-fe0f",
				native: "🚣‍♀️"
			},
			{
				unified: "1f6a3-1f3fb-200d-2640-fe0f",
				native: "🚣🏻‍♀️"
			},
			{
				unified: "1f6a3-1f3fc-200d-2640-fe0f",
				native: "🚣🏼‍♀️"
			},
			{
				unified: "1f6a3-1f3fd-200d-2640-fe0f",
				native: "🚣🏽‍♀️"
			},
			{
				unified: "1f6a3-1f3fe-200d-2640-fe0f",
				native: "🚣🏾‍♀️"
			},
			{
				unified: "1f6a3-1f3ff-200d-2640-fe0f",
				native: "🚣🏿‍♀️"
			}
		],
		version: 4
	},
	swimmer: {
		id: "swimmer",
		name: "Swimmer",
		keywords: [
			"person",
			"swimming",
			"sport",
			"pool"
		],
		skins: [
			{
				unified: "1f3ca",
				native: "🏊"
			},
			{
				unified: "1f3ca-1f3fb",
				native: "🏊🏻"
			},
			{
				unified: "1f3ca-1f3fc",
				native: "🏊🏼"
			},
			{
				unified: "1f3ca-1f3fd",
				native: "🏊🏽"
			},
			{
				unified: "1f3ca-1f3fe",
				native: "🏊🏾"
			},
			{
				unified: "1f3ca-1f3ff",
				native: "🏊🏿"
			}
		],
		version: 1
	},
	"man-swimming": {
		id: "man-swimming",
		name: "Man Swimming",
		keywords: [
			"sports",
			"exercise",
			"human",
			"athlete",
			"water",
			"summer"
		],
		skins: [
			{
				unified: "1f3ca-200d-2642-fe0f",
				native: "🏊‍♂️"
			},
			{
				unified: "1f3ca-1f3fb-200d-2642-fe0f",
				native: "🏊🏻‍♂️"
			},
			{
				unified: "1f3ca-1f3fc-200d-2642-fe0f",
				native: "🏊🏼‍♂️"
			},
			{
				unified: "1f3ca-1f3fd-200d-2642-fe0f",
				native: "🏊🏽‍♂️"
			},
			{
				unified: "1f3ca-1f3fe-200d-2642-fe0f",
				native: "🏊🏾‍♂️"
			},
			{
				unified: "1f3ca-1f3ff-200d-2642-fe0f",
				native: "🏊🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-swimming": {
		id: "woman-swimming",
		name: "Woman Swimming",
		keywords: [
			"sports",
			"exercise",
			"human",
			"athlete",
			"water",
			"summer",
			"female"
		],
		skins: [
			{
				unified: "1f3ca-200d-2640-fe0f",
				native: "🏊‍♀️"
			},
			{
				unified: "1f3ca-1f3fb-200d-2640-fe0f",
				native: "🏊🏻‍♀️"
			},
			{
				unified: "1f3ca-1f3fc-200d-2640-fe0f",
				native: "🏊🏼‍♀️"
			},
			{
				unified: "1f3ca-1f3fd-200d-2640-fe0f",
				native: "🏊🏽‍♀️"
			},
			{
				unified: "1f3ca-1f3fe-200d-2640-fe0f",
				native: "🏊🏾‍♀️"
			},
			{
				unified: "1f3ca-1f3ff-200d-2640-fe0f",
				native: "🏊🏿‍♀️"
			}
		],
		version: 4
	},
	person_with_ball: {
		id: "person_with_ball",
		name: "Person Bouncing Ball",
		keywords: [
			"with",
			"sports",
			"human"
		],
		skins: [
			{
				unified: "26f9-fe0f",
				native: "⛹️"
			},
			{
				unified: "26f9-1f3fb",
				native: "⛹🏻"
			},
			{
				unified: "26f9-1f3fc",
				native: "⛹🏼"
			},
			{
				unified: "26f9-1f3fd",
				native: "⛹🏽"
			},
			{
				unified: "26f9-1f3fe",
				native: "⛹🏾"
			},
			{
				unified: "26f9-1f3ff",
				native: "⛹🏿"
			}
		],
		version: 1
	},
	"man-bouncing-ball": {
		id: "man-bouncing-ball",
		name: "Man Bouncing Ball",
		keywords: [
			"bouncing-ball",
			"sport"
		],
		skins: [
			{
				unified: "26f9-fe0f-200d-2642-fe0f",
				native: "⛹️‍♂️"
			},
			{
				unified: "26f9-1f3fb-200d-2642-fe0f",
				native: "⛹🏻‍♂️"
			},
			{
				unified: "26f9-1f3fc-200d-2642-fe0f",
				native: "⛹🏼‍♂️"
			},
			{
				unified: "26f9-1f3fd-200d-2642-fe0f",
				native: "⛹🏽‍♂️"
			},
			{
				unified: "26f9-1f3fe-200d-2642-fe0f",
				native: "⛹🏾‍♂️"
			},
			{
				unified: "26f9-1f3ff-200d-2642-fe0f",
				native: "⛹🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-bouncing-ball": {
		id: "woman-bouncing-ball",
		name: "Woman Bouncing Ball",
		keywords: [
			"bouncing-ball",
			"sports",
			"human",
			"female"
		],
		skins: [
			{
				unified: "26f9-fe0f-200d-2640-fe0f",
				native: "⛹️‍♀️"
			},
			{
				unified: "26f9-1f3fb-200d-2640-fe0f",
				native: "⛹🏻‍♀️"
			},
			{
				unified: "26f9-1f3fc-200d-2640-fe0f",
				native: "⛹🏼‍♀️"
			},
			{
				unified: "26f9-1f3fd-200d-2640-fe0f",
				native: "⛹🏽‍♀️"
			},
			{
				unified: "26f9-1f3fe-200d-2640-fe0f",
				native: "⛹🏾‍♀️"
			},
			{
				unified: "26f9-1f3ff-200d-2640-fe0f",
				native: "⛹🏿‍♀️"
			}
		],
		version: 4
	},
	weight_lifter: {
		id: "weight_lifter",
		name: "Person Lifting Weights",
		keywords: [
			"weight",
			"lifter",
			"sports",
			"training",
			"exercise"
		],
		skins: [
			{
				unified: "1f3cb-fe0f",
				native: "🏋️"
			},
			{
				unified: "1f3cb-1f3fb",
				native: "🏋🏻"
			},
			{
				unified: "1f3cb-1f3fc",
				native: "🏋🏼"
			},
			{
				unified: "1f3cb-1f3fd",
				native: "🏋🏽"
			},
			{
				unified: "1f3cb-1f3fe",
				native: "🏋🏾"
			},
			{
				unified: "1f3cb-1f3ff",
				native: "🏋🏿"
			}
		],
		version: 1
	},
	"man-lifting-weights": {
		id: "man-lifting-weights",
		name: "Man Lifting Weights",
		keywords: [
			"lifting-weights",
			"sport"
		],
		skins: [
			{
				unified: "1f3cb-fe0f-200d-2642-fe0f",
				native: "🏋️‍♂️"
			},
			{
				unified: "1f3cb-1f3fb-200d-2642-fe0f",
				native: "🏋🏻‍♂️"
			},
			{
				unified: "1f3cb-1f3fc-200d-2642-fe0f",
				native: "🏋🏼‍♂️"
			},
			{
				unified: "1f3cb-1f3fd-200d-2642-fe0f",
				native: "🏋🏽‍♂️"
			},
			{
				unified: "1f3cb-1f3fe-200d-2642-fe0f",
				native: "🏋🏾‍♂️"
			},
			{
				unified: "1f3cb-1f3ff-200d-2642-fe0f",
				native: "🏋🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-lifting-weights": {
		id: "woman-lifting-weights",
		name: "Woman Lifting Weights",
		keywords: [
			"lifting-weights",
			"sports",
			"training",
			"exercise",
			"female"
		],
		skins: [
			{
				unified: "1f3cb-fe0f-200d-2640-fe0f",
				native: "🏋️‍♀️"
			},
			{
				unified: "1f3cb-1f3fb-200d-2640-fe0f",
				native: "🏋🏻‍♀️"
			},
			{
				unified: "1f3cb-1f3fc-200d-2640-fe0f",
				native: "🏋🏼‍♀️"
			},
			{
				unified: "1f3cb-1f3fd-200d-2640-fe0f",
				native: "🏋🏽‍♀️"
			},
			{
				unified: "1f3cb-1f3fe-200d-2640-fe0f",
				native: "🏋🏾‍♀️"
			},
			{
				unified: "1f3cb-1f3ff-200d-2640-fe0f",
				native: "🏋🏿‍♀️"
			}
		],
		version: 4
	},
	bicyclist: {
		id: "bicyclist",
		name: "Bicyclist",
		keywords: [
			"person",
			"biking",
			"sport",
			"move"
		],
		skins: [
			{
				unified: "1f6b4",
				native: "🚴"
			},
			{
				unified: "1f6b4-1f3fb",
				native: "🚴🏻"
			},
			{
				unified: "1f6b4-1f3fc",
				native: "🚴🏼"
			},
			{
				unified: "1f6b4-1f3fd",
				native: "🚴🏽"
			},
			{
				unified: "1f6b4-1f3fe",
				native: "🚴🏾"
			},
			{
				unified: "1f6b4-1f3ff",
				native: "🚴🏿"
			}
		],
		version: 1
	},
	"man-biking": {
		id: "man-biking",
		name: "Man Biking",
		keywords: [
			"sports",
			"bike",
			"exercise",
			"hipster"
		],
		skins: [
			{
				unified: "1f6b4-200d-2642-fe0f",
				native: "🚴‍♂️"
			},
			{
				unified: "1f6b4-1f3fb-200d-2642-fe0f",
				native: "🚴🏻‍♂️"
			},
			{
				unified: "1f6b4-1f3fc-200d-2642-fe0f",
				native: "🚴🏼‍♂️"
			},
			{
				unified: "1f6b4-1f3fd-200d-2642-fe0f",
				native: "🚴🏽‍♂️"
			},
			{
				unified: "1f6b4-1f3fe-200d-2642-fe0f",
				native: "🚴🏾‍♂️"
			},
			{
				unified: "1f6b4-1f3ff-200d-2642-fe0f",
				native: "🚴🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-biking": {
		id: "woman-biking",
		name: "Woman Biking",
		keywords: [
			"sports",
			"bike",
			"exercise",
			"hipster",
			"female"
		],
		skins: [
			{
				unified: "1f6b4-200d-2640-fe0f",
				native: "🚴‍♀️"
			},
			{
				unified: "1f6b4-1f3fb-200d-2640-fe0f",
				native: "🚴🏻‍♀️"
			},
			{
				unified: "1f6b4-1f3fc-200d-2640-fe0f",
				native: "🚴🏼‍♀️"
			},
			{
				unified: "1f6b4-1f3fd-200d-2640-fe0f",
				native: "🚴🏽‍♀️"
			},
			{
				unified: "1f6b4-1f3fe-200d-2640-fe0f",
				native: "🚴🏾‍♀️"
			},
			{
				unified: "1f6b4-1f3ff-200d-2640-fe0f",
				native: "🚴🏿‍♀️"
			}
		],
		version: 4
	},
	mountain_bicyclist: {
		id: "mountain_bicyclist",
		name: "Mountain Bicyclist",
		keywords: [
			"person",
			"biking",
			"sport",
			"move"
		],
		skins: [
			{
				unified: "1f6b5",
				native: "🚵"
			},
			{
				unified: "1f6b5-1f3fb",
				native: "🚵🏻"
			},
			{
				unified: "1f6b5-1f3fc",
				native: "🚵🏼"
			},
			{
				unified: "1f6b5-1f3fd",
				native: "🚵🏽"
			},
			{
				unified: "1f6b5-1f3fe",
				native: "🚵🏾"
			},
			{
				unified: "1f6b5-1f3ff",
				native: "🚵🏿"
			}
		],
		version: 1
	},
	"man-mountain-biking": {
		id: "man-mountain-biking",
		name: "Man Mountain Biking",
		keywords: [
			"mountain-biking",
			"transportation",
			"sports",
			"human",
			"race",
			"bike"
		],
		skins: [
			{
				unified: "1f6b5-200d-2642-fe0f",
				native: "🚵‍♂️"
			},
			{
				unified: "1f6b5-1f3fb-200d-2642-fe0f",
				native: "🚵🏻‍♂️"
			},
			{
				unified: "1f6b5-1f3fc-200d-2642-fe0f",
				native: "🚵🏼‍♂️"
			},
			{
				unified: "1f6b5-1f3fd-200d-2642-fe0f",
				native: "🚵🏽‍♂️"
			},
			{
				unified: "1f6b5-1f3fe-200d-2642-fe0f",
				native: "🚵🏾‍♂️"
			},
			{
				unified: "1f6b5-1f3ff-200d-2642-fe0f",
				native: "🚵🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-mountain-biking": {
		id: "woman-mountain-biking",
		name: "Woman Mountain Biking",
		keywords: [
			"mountain-biking",
			"transportation",
			"sports",
			"human",
			"race",
			"bike",
			"female"
		],
		skins: [
			{
				unified: "1f6b5-200d-2640-fe0f",
				native: "🚵‍♀️"
			},
			{
				unified: "1f6b5-1f3fb-200d-2640-fe0f",
				native: "🚵🏻‍♀️"
			},
			{
				unified: "1f6b5-1f3fc-200d-2640-fe0f",
				native: "🚵🏼‍♀️"
			},
			{
				unified: "1f6b5-1f3fd-200d-2640-fe0f",
				native: "🚵🏽‍♀️"
			},
			{
				unified: "1f6b5-1f3fe-200d-2640-fe0f",
				native: "🚵🏾‍♀️"
			},
			{
				unified: "1f6b5-1f3ff-200d-2640-fe0f",
				native: "🚵🏿‍♀️"
			}
		],
		version: 4
	},
	person_doing_cartwheel: {
		id: "person_doing_cartwheel",
		name: "Person Cartwheeling",
		keywords: [
			"doing",
			"cartwheel",
			"sport",
			"gymnastic"
		],
		skins: [
			{
				unified: "1f938",
				native: "🤸"
			},
			{
				unified: "1f938-1f3fb",
				native: "🤸🏻"
			},
			{
				unified: "1f938-1f3fc",
				native: "🤸🏼"
			},
			{
				unified: "1f938-1f3fd",
				native: "🤸🏽"
			},
			{
				unified: "1f938-1f3fe",
				native: "🤸🏾"
			},
			{
				unified: "1f938-1f3ff",
				native: "🤸🏿"
			}
		],
		version: 3
	},
	"man-cartwheeling": {
		id: "man-cartwheeling",
		name: "Man Cartwheeling",
		keywords: [
			"gymnastics"
		],
		skins: [
			{
				unified: "1f938-200d-2642-fe0f",
				native: "🤸‍♂️"
			},
			{
				unified: "1f938-1f3fb-200d-2642-fe0f",
				native: "🤸🏻‍♂️"
			},
			{
				unified: "1f938-1f3fc-200d-2642-fe0f",
				native: "🤸🏼‍♂️"
			},
			{
				unified: "1f938-1f3fd-200d-2642-fe0f",
				native: "🤸🏽‍♂️"
			},
			{
				unified: "1f938-1f3fe-200d-2642-fe0f",
				native: "🤸🏾‍♂️"
			},
			{
				unified: "1f938-1f3ff-200d-2642-fe0f",
				native: "🤸🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-cartwheeling": {
		id: "woman-cartwheeling",
		name: "Woman Cartwheeling",
		keywords: [
			"gymnastics"
		],
		skins: [
			{
				unified: "1f938-200d-2640-fe0f",
				native: "🤸‍♀️"
			},
			{
				unified: "1f938-1f3fb-200d-2640-fe0f",
				native: "🤸🏻‍♀️"
			},
			{
				unified: "1f938-1f3fc-200d-2640-fe0f",
				native: "🤸🏼‍♀️"
			},
			{
				unified: "1f938-1f3fd-200d-2640-fe0f",
				native: "🤸🏽‍♀️"
			},
			{
				unified: "1f938-1f3fe-200d-2640-fe0f",
				native: "🤸🏾‍♀️"
			},
			{
				unified: "1f938-1f3ff-200d-2640-fe0f",
				native: "🤸🏿‍♀️"
			}
		],
		version: 4
	},
	wrestlers: {
		id: "wrestlers",
		name: "Wrestlers",
		keywords: [
			"people",
			"wrestling",
			"sport"
		],
		skins: [
			{
				unified: "1f93c",
				native: "🤼"
			}
		],
		version: 3
	},
	"man-wrestling": {
		id: "man-wrestling",
		name: "Men Wrestling",
		keywords: [
			"man",
			"sports",
			"wrestlers"
		],
		skins: [
			{
				unified: "1f93c-200d-2642-fe0f",
				native: "🤼‍♂️"
			}
		],
		version: 4
	},
	"woman-wrestling": {
		id: "woman-wrestling",
		name: "Women Wrestling",
		keywords: [
			"woman",
			"sports",
			"wrestlers"
		],
		skins: [
			{
				unified: "1f93c-200d-2640-fe0f",
				native: "🤼‍♀️"
			}
		],
		version: 4
	},
	water_polo: {
		id: "water_polo",
		name: "Water Polo",
		keywords: [
			"person",
			"playing",
			"sport"
		],
		skins: [
			{
				unified: "1f93d",
				native: "🤽"
			},
			{
				unified: "1f93d-1f3fb",
				native: "🤽🏻"
			},
			{
				unified: "1f93d-1f3fc",
				native: "🤽🏼"
			},
			{
				unified: "1f93d-1f3fd",
				native: "🤽🏽"
			},
			{
				unified: "1f93d-1f3fe",
				native: "🤽🏾"
			},
			{
				unified: "1f93d-1f3ff",
				native: "🤽🏿"
			}
		],
		version: 3
	},
	"man-playing-water-polo": {
		id: "man-playing-water-polo",
		name: "Man Playing Water Polo",
		keywords: [
			"playing-water-polo",
			"sports",
			"pool"
		],
		skins: [
			{
				unified: "1f93d-200d-2642-fe0f",
				native: "🤽‍♂️"
			},
			{
				unified: "1f93d-1f3fb-200d-2642-fe0f",
				native: "🤽🏻‍♂️"
			},
			{
				unified: "1f93d-1f3fc-200d-2642-fe0f",
				native: "🤽🏼‍♂️"
			},
			{
				unified: "1f93d-1f3fd-200d-2642-fe0f",
				native: "🤽🏽‍♂️"
			},
			{
				unified: "1f93d-1f3fe-200d-2642-fe0f",
				native: "🤽🏾‍♂️"
			},
			{
				unified: "1f93d-1f3ff-200d-2642-fe0f",
				native: "🤽🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-playing-water-polo": {
		id: "woman-playing-water-polo",
		name: "Woman Playing Water Polo",
		keywords: [
			"playing-water-polo",
			"sports",
			"pool"
		],
		skins: [
			{
				unified: "1f93d-200d-2640-fe0f",
				native: "🤽‍♀️"
			},
			{
				unified: "1f93d-1f3fb-200d-2640-fe0f",
				native: "🤽🏻‍♀️"
			},
			{
				unified: "1f93d-1f3fc-200d-2640-fe0f",
				native: "🤽🏼‍♀️"
			},
			{
				unified: "1f93d-1f3fd-200d-2640-fe0f",
				native: "🤽🏽‍♀️"
			},
			{
				unified: "1f93d-1f3fe-200d-2640-fe0f",
				native: "🤽🏾‍♀️"
			},
			{
				unified: "1f93d-1f3ff-200d-2640-fe0f",
				native: "🤽🏿‍♀️"
			}
		],
		version: 4
	},
	handball: {
		id: "handball",
		name: "Handball",
		keywords: [
			"person",
			"playing",
			"sport"
		],
		skins: [
			{
				unified: "1f93e",
				native: "🤾"
			},
			{
				unified: "1f93e-1f3fb",
				native: "🤾🏻"
			},
			{
				unified: "1f93e-1f3fc",
				native: "🤾🏼"
			},
			{
				unified: "1f93e-1f3fd",
				native: "🤾🏽"
			},
			{
				unified: "1f93e-1f3fe",
				native: "🤾🏾"
			},
			{
				unified: "1f93e-1f3ff",
				native: "🤾🏿"
			}
		],
		version: 3
	},
	"man-playing-handball": {
		id: "man-playing-handball",
		name: "Man Playing Handball",
		keywords: [
			"playing-handball",
			"sports"
		],
		skins: [
			{
				unified: "1f93e-200d-2642-fe0f",
				native: "🤾‍♂️"
			},
			{
				unified: "1f93e-1f3fb-200d-2642-fe0f",
				native: "🤾🏻‍♂️"
			},
			{
				unified: "1f93e-1f3fc-200d-2642-fe0f",
				native: "🤾🏼‍♂️"
			},
			{
				unified: "1f93e-1f3fd-200d-2642-fe0f",
				native: "🤾🏽‍♂️"
			},
			{
				unified: "1f93e-1f3fe-200d-2642-fe0f",
				native: "🤾🏾‍♂️"
			},
			{
				unified: "1f93e-1f3ff-200d-2642-fe0f",
				native: "🤾🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-playing-handball": {
		id: "woman-playing-handball",
		name: "Woman Playing Handball",
		keywords: [
			"playing-handball",
			"sports"
		],
		skins: [
			{
				unified: "1f93e-200d-2640-fe0f",
				native: "🤾‍♀️"
			},
			{
				unified: "1f93e-1f3fb-200d-2640-fe0f",
				native: "🤾🏻‍♀️"
			},
			{
				unified: "1f93e-1f3fc-200d-2640-fe0f",
				native: "🤾🏼‍♀️"
			},
			{
				unified: "1f93e-1f3fd-200d-2640-fe0f",
				native: "🤾🏽‍♀️"
			},
			{
				unified: "1f93e-1f3fe-200d-2640-fe0f",
				native: "🤾🏾‍♀️"
			},
			{
				unified: "1f93e-1f3ff-200d-2640-fe0f",
				native: "🤾🏿‍♀️"
			}
		],
		version: 4
	},
	juggling: {
		id: "juggling",
		name: "Juggling",
		keywords: [
			"person",
			"performance",
			"balance"
		],
		skins: [
			{
				unified: "1f939",
				native: "🤹"
			},
			{
				unified: "1f939-1f3fb",
				native: "🤹🏻"
			},
			{
				unified: "1f939-1f3fc",
				native: "🤹🏼"
			},
			{
				unified: "1f939-1f3fd",
				native: "🤹🏽"
			},
			{
				unified: "1f939-1f3fe",
				native: "🤹🏾"
			},
			{
				unified: "1f939-1f3ff",
				native: "🤹🏿"
			}
		],
		version: 3
	},
	"man-juggling": {
		id: "man-juggling",
		name: "Man Juggling",
		keywords: [
			"juggle",
			"balance",
			"skill",
			"multitask"
		],
		skins: [
			{
				unified: "1f939-200d-2642-fe0f",
				native: "🤹‍♂️"
			},
			{
				unified: "1f939-1f3fb-200d-2642-fe0f",
				native: "🤹🏻‍♂️"
			},
			{
				unified: "1f939-1f3fc-200d-2642-fe0f",
				native: "🤹🏼‍♂️"
			},
			{
				unified: "1f939-1f3fd-200d-2642-fe0f",
				native: "🤹🏽‍♂️"
			},
			{
				unified: "1f939-1f3fe-200d-2642-fe0f",
				native: "🤹🏾‍♂️"
			},
			{
				unified: "1f939-1f3ff-200d-2642-fe0f",
				native: "🤹🏿‍♂️"
			}
		],
		version: 4
	},
	"woman-juggling": {
		id: "woman-juggling",
		name: "Woman Juggling",
		keywords: [
			"juggle",
			"balance",
			"skill",
			"multitask"
		],
		skins: [
			{
				unified: "1f939-200d-2640-fe0f",
				native: "🤹‍♀️"
			},
			{
				unified: "1f939-1f3fb-200d-2640-fe0f",
				native: "🤹🏻‍♀️"
			},
			{
				unified: "1f939-1f3fc-200d-2640-fe0f",
				native: "🤹🏼‍♀️"
			},
			{
				unified: "1f939-1f3fd-200d-2640-fe0f",
				native: "🤹🏽‍♀️"
			},
			{
				unified: "1f939-1f3fe-200d-2640-fe0f",
				native: "🤹🏾‍♀️"
			},
			{
				unified: "1f939-1f3ff-200d-2640-fe0f",
				native: "🤹🏿‍♀️"
			}
		],
		version: 4
	},
	person_in_lotus_position: {
		id: "person_in_lotus_position",
		name: "Person in Lotus Position",
		keywords: [
			"meditate"
		],
		skins: [
			{
				unified: "1f9d8",
				native: "🧘"
			},
			{
				unified: "1f9d8-1f3fb",
				native: "🧘🏻"
			},
			{
				unified: "1f9d8-1f3fc",
				native: "🧘🏼"
			},
			{
				unified: "1f9d8-1f3fd",
				native: "🧘🏽"
			},
			{
				unified: "1f9d8-1f3fe",
				native: "🧘🏾"
			},
			{
				unified: "1f9d8-1f3ff",
				native: "🧘🏿"
			}
		],
		version: 5
	},
	man_in_lotus_position: {
		id: "man_in_lotus_position",
		name: "Man in Lotus Position",
		keywords: [
			"male",
			"meditation",
			"yoga",
			"serenity",
			"zen",
			"mindfulness"
		],
		skins: [
			{
				unified: "1f9d8-200d-2642-fe0f",
				native: "🧘‍♂️"
			},
			{
				unified: "1f9d8-1f3fb-200d-2642-fe0f",
				native: "🧘🏻‍♂️"
			},
			{
				unified: "1f9d8-1f3fc-200d-2642-fe0f",
				native: "🧘🏼‍♂️"
			},
			{
				unified: "1f9d8-1f3fd-200d-2642-fe0f",
				native: "🧘🏽‍♂️"
			},
			{
				unified: "1f9d8-1f3fe-200d-2642-fe0f",
				native: "🧘🏾‍♂️"
			},
			{
				unified: "1f9d8-1f3ff-200d-2642-fe0f",
				native: "🧘🏿‍♂️"
			}
		],
		version: 5
	},
	woman_in_lotus_position: {
		id: "woman_in_lotus_position",
		name: "Woman in Lotus Position",
		keywords: [
			"female",
			"meditation",
			"yoga",
			"serenity",
			"zen",
			"mindfulness"
		],
		skins: [
			{
				unified: "1f9d8-200d-2640-fe0f",
				native: "🧘‍♀️"
			},
			{
				unified: "1f9d8-1f3fb-200d-2640-fe0f",
				native: "🧘🏻‍♀️"
			},
			{
				unified: "1f9d8-1f3fc-200d-2640-fe0f",
				native: "🧘🏼‍♀️"
			},
			{
				unified: "1f9d8-1f3fd-200d-2640-fe0f",
				native: "🧘🏽‍♀️"
			},
			{
				unified: "1f9d8-1f3fe-200d-2640-fe0f",
				native: "🧘🏾‍♀️"
			},
			{
				unified: "1f9d8-1f3ff-200d-2640-fe0f",
				native: "🧘🏿‍♀️"
			}
		],
		version: 5
	},
	bath: {
		id: "bath",
		name: "Bath",
		keywords: [
			"person",
			"taking",
			"clean",
			"shower",
			"bathroom"
		],
		skins: [
			{
				unified: "1f6c0",
				native: "🛀"
			},
			{
				unified: "1f6c0-1f3fb",
				native: "🛀🏻"
			},
			{
				unified: "1f6c0-1f3fc",
				native: "🛀🏼"
			},
			{
				unified: "1f6c0-1f3fd",
				native: "🛀🏽"
			},
			{
				unified: "1f6c0-1f3fe",
				native: "🛀🏾"
			},
			{
				unified: "1f6c0-1f3ff",
				native: "🛀🏿"
			}
		],
		version: 1
	},
	sleeping_accommodation: {
		id: "sleeping_accommodation",
		name: "Person in Bed",
		keywords: [
			"sleeping",
			"accommodation",
			"rest"
		],
		skins: [
			{
				unified: "1f6cc",
				native: "🛌"
			},
			{
				unified: "1f6cc-1f3fb",
				native: "🛌🏻"
			},
			{
				unified: "1f6cc-1f3fc",
				native: "🛌🏼"
			},
			{
				unified: "1f6cc-1f3fd",
				native: "🛌🏽"
			},
			{
				unified: "1f6cc-1f3fe",
				native: "🛌🏾"
			},
			{
				unified: "1f6cc-1f3ff",
				native: "🛌🏿"
			}
		],
		version: 1
	},
	people_holding_hands: {
		id: "people_holding_hands",
		name: "People Holding Hands",
		keywords: [
			"friendship"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f91d-200d-1f9d1",
				native: "🧑‍🤝‍🧑"
			},
			{
				unified: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
				native: "🧑🏻‍🤝‍🧑🏻"
			},
			{
				unified: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
				native: "🧑🏼‍🤝‍🧑🏼"
			},
			{
				unified: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
				native: "🧑🏽‍🤝‍🧑🏽"
			},
			{
				unified: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
				native: "🧑🏾‍🤝‍🧑🏾"
			},
			{
				unified: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff",
				native: "🧑🏿‍🤝‍🧑🏿"
			}
		],
		version: 12
	},
	two_women_holding_hands: {
		id: "two_women_holding_hands",
		name: "Women Holding Hands",
		keywords: [
			"two",
			"pair",
			"friendship",
			"couple",
			"love",
			"like",
			"female",
			"people",
			"human"
		],
		skins: [
			{
				unified: "1f46d",
				native: "👭"
			},
			{
				unified: "1f46d-1f3fb",
				native: "👭🏻"
			},
			{
				unified: "1f46d-1f3fc",
				native: "👭🏼"
			},
			{
				unified: "1f46d-1f3fd",
				native: "👭🏽"
			},
			{
				unified: "1f46d-1f3fe",
				native: "👭🏾"
			},
			{
				unified: "1f46d-1f3ff",
				native: "👭🏿"
			}
		],
		version: 1
	},
	man_and_woman_holding_hands: {
		id: "man_and_woman_holding_hands",
		name: "Man and Woman Holding Hands",
		keywords: [
			"couple",
			"pair",
			"people",
			"human",
			"love",
			"date",
			"dating",
			"like",
			"affection",
			"valentines",
			"marriage"
		],
		skins: [
			{
				unified: "1f46b",
				native: "👫"
			},
			{
				unified: "1f46b-1f3fb",
				native: "👫🏻"
			},
			{
				unified: "1f46b-1f3fc",
				native: "👫🏼"
			},
			{
				unified: "1f46b-1f3fd",
				native: "👫🏽"
			},
			{
				unified: "1f46b-1f3fe",
				native: "👫🏾"
			},
			{
				unified: "1f46b-1f3ff",
				native: "👫🏿"
			}
		],
		version: 1
	},
	two_men_holding_hands: {
		id: "two_men_holding_hands",
		name: "Men Holding Hands",
		keywords: [
			"two",
			"pair",
			"couple",
			"love",
			"like",
			"bromance",
			"friendship",
			"people",
			"human"
		],
		skins: [
			{
				unified: "1f46c",
				native: "👬"
			},
			{
				unified: "1f46c-1f3fb",
				native: "👬🏻"
			},
			{
				unified: "1f46c-1f3fc",
				native: "👬🏼"
			},
			{
				unified: "1f46c-1f3fd",
				native: "👬🏽"
			},
			{
				unified: "1f46c-1f3fe",
				native: "👬🏾"
			},
			{
				unified: "1f46c-1f3ff",
				native: "👬🏿"
			}
		],
		version: 1
	},
	couplekiss: {
		id: "couplekiss",
		name: "Kiss",
		keywords: [
			"couplekiss",
			"pair",
			"valentines",
			"love",
			"like",
			"dating",
			"marriage"
		],
		skins: [
			{
				unified: "1f48f",
				native: "💏"
			},
			{
				unified: "1f48f-1f3fb",
				native: "💏🏻"
			},
			{
				unified: "1f48f-1f3fc",
				native: "💏🏼"
			},
			{
				unified: "1f48f-1f3fd",
				native: "💏🏽"
			},
			{
				unified: "1f48f-1f3fe",
				native: "💏🏾"
			},
			{
				unified: "1f48f-1f3ff",
				native: "💏🏿"
			}
		],
		version: 1
	},
	"woman-kiss-man": {
		id: "woman-kiss-man",
		name: "Kiss: Woman, Man",
		keywords: [
			"woman",
			"kiss-man",
			"kiss",
			"love"
		],
		skins: [
			{
				unified: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
				native: "👩‍❤️‍💋‍👨"
			},
			{
				unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
				native: "👩🏻‍❤️‍💋‍👨🏻"
			},
			{
				unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
				native: "👩🏼‍❤️‍💋‍👨🏼"
			},
			{
				unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
				native: "👩🏽‍❤️‍💋‍👨🏽"
			},
			{
				unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
				native: "👩🏾‍❤️‍💋‍👨🏾"
			},
			{
				unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
				native: "👩🏿‍❤️‍💋‍👨🏿"
			}
		],
		version: 2
	},
	"man-kiss-man": {
		id: "man-kiss-man",
		name: "Kiss: Man, Man",
		keywords: [
			"kiss-man",
			"kiss",
			"pair",
			"valentines",
			"love",
			"like",
			"dating",
			"marriage"
		],
		skins: [
			{
				unified: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
				native: "👨‍❤️‍💋‍👨"
			},
			{
				unified: "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
				native: "👨🏻‍❤️‍💋‍👨🏻"
			},
			{
				unified: "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
				native: "👨🏼‍❤️‍💋‍👨🏼"
			},
			{
				unified: "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
				native: "👨🏽‍❤️‍💋‍👨🏽"
			},
			{
				unified: "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
				native: "👨🏾‍❤️‍💋‍👨🏾"
			},
			{
				unified: "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
				native: "👨🏿‍❤️‍💋‍👨🏿"
			}
		],
		version: 2
	},
	"woman-kiss-woman": {
		id: "woman-kiss-woman",
		name: "Kiss: Woman, Woman",
		keywords: [
			"kiss-woman",
			"kiss",
			"pair",
			"valentines",
			"love",
			"like",
			"dating",
			"marriage"
		],
		skins: [
			{
				unified: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
				native: "👩‍❤️‍💋‍👩"
			},
			{
				unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
				native: "👩🏻‍❤️‍💋‍👩🏻"
			},
			{
				unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
				native: "👩🏼‍❤️‍💋‍👩🏼"
			},
			{
				unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
				native: "👩🏽‍❤️‍💋‍👩🏽"
			},
			{
				unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
				native: "👩🏾‍❤️‍💋‍👩🏾"
			},
			{
				unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
				native: "👩🏿‍❤️‍💋‍👩🏿"
			}
		],
		version: 2
	},
	couple_with_heart: {
		id: "couple_with_heart",
		name: "Couple with Heart",
		keywords: [
			"pair",
			"love",
			"like",
			"affection",
			"human",
			"dating",
			"valentines",
			"marriage"
		],
		skins: [
			{
				unified: "1f491",
				native: "💑"
			},
			{
				unified: "1f491-1f3fb",
				native: "💑🏻"
			},
			{
				unified: "1f491-1f3fc",
				native: "💑🏼"
			},
			{
				unified: "1f491-1f3fd",
				native: "💑🏽"
			},
			{
				unified: "1f491-1f3fe",
				native: "💑🏾"
			},
			{
				unified: "1f491-1f3ff",
				native: "💑🏿"
			}
		],
		version: 1
	},
	"woman-heart-man": {
		id: "woman-heart-man",
		name: "Couple with Heart: Woman, Man",
		keywords: [
			"woman",
			"heart-man",
			"heart",
			"love"
		],
		skins: [
			{
				unified: "1f469-200d-2764-fe0f-200d-1f468",
				native: "👩‍❤️‍👨"
			},
			{
				unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
				native: "👩🏻‍❤️‍👨🏻"
			},
			{
				unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
				native: "👩🏼‍❤️‍👨🏼"
			},
			{
				unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
				native: "👩🏽‍❤️‍👨🏽"
			},
			{
				unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
				native: "👩🏾‍❤️‍👨🏾"
			},
			{
				unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",
				native: "👩🏿‍❤️‍👨🏿"
			}
		],
		version: 2
	},
	"man-heart-man": {
		id: "man-heart-man",
		name: "Couple with Heart: Man, Man",
		keywords: [
			"heart-man",
			"heart",
			"pair",
			"love",
			"like",
			"affection",
			"human",
			"dating",
			"valentines",
			"marriage"
		],
		skins: [
			{
				unified: "1f468-200d-2764-fe0f-200d-1f468",
				native: "👨‍❤️‍👨"
			},
			{
				unified: "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
				native: "👨🏻‍❤️‍👨🏻"
			},
			{
				unified: "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
				native: "👨🏼‍❤️‍👨🏼"
			},
			{
				unified: "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
				native: "👨🏽‍❤️‍👨🏽"
			},
			{
				unified: "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
				native: "👨🏾‍❤️‍👨🏾"
			},
			{
				unified: "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",
				native: "👨🏿‍❤️‍👨🏿"
			}
		],
		version: 2
	},
	"woman-heart-woman": {
		id: "woman-heart-woman",
		name: "Couple with Heart: Woman, Woman",
		keywords: [
			"heart-woman",
			"heart",
			"pair",
			"love",
			"like",
			"affection",
			"human",
			"dating",
			"valentines",
			"marriage"
		],
		skins: [
			{
				unified: "1f469-200d-2764-fe0f-200d-1f469",
				native: "👩‍❤️‍👩"
			},
			{
				unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
				native: "👩🏻‍❤️‍👩🏻"
			},
			{
				unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
				native: "👩🏼‍❤️‍👩🏼"
			},
			{
				unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
				native: "👩🏽‍❤️‍👩🏽"
			},
			{
				unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
				native: "👩🏾‍❤️‍👩🏾"
			},
			{
				unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff",
				native: "👩🏿‍❤️‍👩🏿"
			}
		],
		version: 2
	},
	family: {
		id: "family",
		name: "Family",
		keywords: [
			"home",
			"parents",
			"child",
			"mom",
			"dad",
			"father",
			"mother",
			"people",
			"human"
		],
		skins: [
			{
				unified: "1f46a",
				native: "👪"
			}
		],
		version: 1
	},
	"man-woman-boy": {
		id: "man-woman-boy",
		name: "Family: Man, Woman, Boy",
		keywords: [
			"man",
			"woman-boy",
			"family",
			"woman",
			"love"
		],
		skins: [
			{
				unified: "1f468-200d-1f469-200d-1f466",
				native: "👨‍👩‍👦"
			}
		],
		version: 2
	},
	"man-woman-girl": {
		id: "man-woman-girl",
		name: "Family: Man, Woman, Girl",
		keywords: [
			"man",
			"woman-girl",
			"family",
			"woman",
			"home",
			"parents",
			"people",
			"human",
			"child"
		],
		skins: [
			{
				unified: "1f468-200d-1f469-200d-1f467",
				native: "👨‍👩‍👧"
			}
		],
		version: 2
	},
	"man-woman-girl-boy": {
		id: "man-woman-girl-boy",
		name: "Family: Man, Woman, Girl, Boy",
		keywords: [
			"man",
			"woman-girl-boy",
			"family",
			"woman",
			"girl",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f469-200d-1f467-200d-1f466",
				native: "👨‍👩‍👧‍👦"
			}
		],
		version: 2
	},
	"man-woman-boy-boy": {
		id: "man-woman-boy-boy",
		name: "Family: Man, Woman, Boy, Boy",
		keywords: [
			"man",
			"woman-boy-boy",
			"family",
			"woman",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f469-200d-1f466-200d-1f466",
				native: "👨‍👩‍👦‍👦"
			}
		],
		version: 2
	},
	"man-woman-girl-girl": {
		id: "man-woman-girl-girl",
		name: "Family: Man, Woman, Girl, Girl",
		keywords: [
			"man",
			"woman-girl-girl",
			"family",
			"woman",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f469-200d-1f467-200d-1f467",
				native: "👨‍👩‍👧‍👧"
			}
		],
		version: 2
	},
	"man-man-boy": {
		id: "man-man-boy",
		name: "Family: Man, Man, Boy",
		keywords: [
			"man",
			"man-boy",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f468-200d-1f466",
				native: "👨‍👨‍👦"
			}
		],
		version: 2
	},
	"man-man-girl": {
		id: "man-man-girl",
		name: "Family: Man, Man, Girl",
		keywords: [
			"man",
			"man-girl",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f468-200d-1f467",
				native: "👨‍👨‍👧"
			}
		],
		version: 2
	},
	"man-man-girl-boy": {
		id: "man-man-girl-boy",
		name: "Family: Man, Man, Girl, Boy",
		keywords: [
			"man",
			"man-girl-boy",
			"family",
			"girl",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f468-200d-1f467-200d-1f466",
				native: "👨‍👨‍👧‍👦"
			}
		],
		version: 2
	},
	"man-man-boy-boy": {
		id: "man-man-boy-boy",
		name: "Family: Man, Man, Boy, Boy",
		keywords: [
			"man",
			"man-boy-boy",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f468-200d-1f466-200d-1f466",
				native: "👨‍👨‍👦‍👦"
			}
		],
		version: 2
	},
	"man-man-girl-girl": {
		id: "man-man-girl-girl",
		name: "Family: Man, Man, Girl, Girl",
		keywords: [
			"man",
			"man-girl-girl",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f468-200d-1f467-200d-1f467",
				native: "👨‍👨‍👧‍👧"
			}
		],
		version: 2
	},
	"woman-woman-boy": {
		id: "woman-woman-boy",
		name: "Family: Woman, Woman, Boy",
		keywords: [
			"woman",
			"woman-boy",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f469-200d-1f466",
				native: "👩‍👩‍👦"
			}
		],
		version: 2
	},
	"woman-woman-girl": {
		id: "woman-woman-girl",
		name: "Family: Woman, Woman, Girl",
		keywords: [
			"woman",
			"woman-girl",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f469-200d-1f467",
				native: "👩‍👩‍👧"
			}
		],
		version: 2
	},
	"woman-woman-girl-boy": {
		id: "woman-woman-girl-boy",
		name: "Family: Woman, Woman, Girl, Boy",
		keywords: [
			"woman",
			"woman-girl-boy",
			"family",
			"girl",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f469-200d-1f467-200d-1f466",
				native: "👩‍👩‍👧‍👦"
			}
		],
		version: 2
	},
	"woman-woman-boy-boy": {
		id: "woman-woman-boy-boy",
		name: "Family: Woman, Woman, Boy, Boy",
		keywords: [
			"woman",
			"woman-boy-boy",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f469-200d-1f466-200d-1f466",
				native: "👩‍👩‍👦‍👦"
			}
		],
		version: 2
	},
	"woman-woman-girl-girl": {
		id: "woman-woman-girl-girl",
		name: "Family: Woman, Woman, Girl, Girl",
		keywords: [
			"woman",
			"woman-girl-girl",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f469-200d-1f467-200d-1f467",
				native: "👩‍👩‍👧‍👧"
			}
		],
		version: 2
	},
	"man-boy": {
		id: "man-boy",
		name: "Family: Man, Boy",
		keywords: [
			"man",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"child"
		],
		skins: [
			{
				unified: "1f468-200d-1f466",
				native: "👨‍👦"
			}
		],
		version: 4
	},
	"man-boy-boy": {
		id: "man-boy-boy",
		name: "Family: Man, Boy, Boy",
		keywords: [
			"man",
			"boy-boy",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f466-200d-1f466",
				native: "👨‍👦‍👦"
			}
		],
		version: 4
	},
	"man-girl": {
		id: "man-girl",
		name: "Family: Man, Girl",
		keywords: [
			"man",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"child"
		],
		skins: [
			{
				unified: "1f468-200d-1f467",
				native: "👨‍👧"
			}
		],
		version: 4
	},
	"man-girl-boy": {
		id: "man-girl-boy",
		name: "Family: Man, Girl, Boy",
		keywords: [
			"man",
			"girl-boy",
			"family",
			"girl",
			"home",
			"parent",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f467-200d-1f466",
				native: "👨‍👧‍👦"
			}
		],
		version: 4
	},
	"man-girl-girl": {
		id: "man-girl-girl",
		name: "Family: Man, Girl, Girl",
		keywords: [
			"man",
			"girl-girl",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f467-200d-1f467",
				native: "👨‍👧‍👧"
			}
		],
		version: 4
	},
	"woman-boy": {
		id: "woman-boy",
		name: "Family: Woman, Boy",
		keywords: [
			"woman",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"child"
		],
		skins: [
			{
				unified: "1f469-200d-1f466",
				native: "👩‍👦"
			}
		],
		version: 4
	},
	"woman-boy-boy": {
		id: "woman-boy-boy",
		name: "Family: Woman, Boy, Boy",
		keywords: [
			"woman",
			"boy-boy",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f466-200d-1f466",
				native: "👩‍👦‍👦"
			}
		],
		version: 4
	},
	"woman-girl": {
		id: "woman-girl",
		name: "Family: Woman, Girl",
		keywords: [
			"woman",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"child"
		],
		skins: [
			{
				unified: "1f469-200d-1f467",
				native: "👩‍👧"
			}
		],
		version: 4
	},
	"woman-girl-boy": {
		id: "woman-girl-boy",
		name: "Family: Woman, Girl, Boy",
		keywords: [
			"woman",
			"girl-boy",
			"family",
			"girl",
			"home",
			"parent",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f467-200d-1f466",
				native: "👩‍👧‍👦"
			}
		],
		version: 4
	},
	"woman-girl-girl": {
		id: "woman-girl-girl",
		name: "Family: Woman, Girl, Girl",
		keywords: [
			"woman",
			"girl-girl",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f467-200d-1f467",
				native: "👩‍👧‍👧"
			}
		],
		version: 4
	},
	speaking_head_in_silhouette: {
		id: "speaking_head_in_silhouette",
		name: "Speaking Head",
		keywords: [
			"in",
			"silhouette",
			"user",
			"person",
			"human",
			"sing",
			"say",
			"talk"
		],
		skins: [
			{
				unified: "1f5e3-fe0f",
				native: "🗣️"
			}
		],
		version: 1
	},
	bust_in_silhouette: {
		id: "bust_in_silhouette",
		name: "Bust in Silhouette",
		keywords: [
			"user",
			"person",
			"human"
		],
		skins: [
			{
				unified: "1f464",
				native: "👤"
			}
		],
		version: 1
	},
	busts_in_silhouette: {
		id: "busts_in_silhouette",
		name: "Busts in Silhouette",
		keywords: [
			"user",
			"person",
			"human",
			"group",
			"team"
		],
		skins: [
			{
				unified: "1f465",
				native: "👥"
			}
		],
		version: 1
	},
	people_hugging: {
		id: "people_hugging",
		name: "People Hugging",
		keywords: [
			"care"
		],
		skins: [
			{
				unified: "1fac2",
				native: "🫂"
			}
		],
		version: 13
	},
	footprints: {
		id: "footprints",
		name: "Footprints",
		keywords: [
			"feet",
			"tracking",
			"walking",
			"beach"
		],
		skins: [
			{
				unified: "1f463",
				native: "👣"
			}
		],
		version: 1
	},
	monkey_face: {
		id: "monkey_face",
		name: "Monkey Face",
		emoticons: [
			":o)"
		],
		keywords: [
			"animal",
			"nature",
			"circus"
		],
		skins: [
			{
				unified: "1f435",
				native: "🐵"
			}
		],
		version: 1
	},
	monkey: {
		id: "monkey",
		name: "Monkey",
		keywords: [
			"animal",
			"nature",
			"banana",
			"circus"
		],
		skins: [
			{
				unified: "1f412",
				native: "🐒"
			}
		],
		version: 1
	},
	gorilla: {
		id: "gorilla",
		name: "Gorilla",
		keywords: [
			"animal",
			"nature",
			"circus"
		],
		skins: [
			{
				unified: "1f98d",
				native: "🦍"
			}
		],
		version: 3
	},
	orangutan: {
		id: "orangutan",
		name: "Orangutan",
		keywords: [
			"animal"
		],
		skins: [
			{
				unified: "1f9a7",
				native: "🦧"
			}
		],
		version: 12
	},
	dog: {
		id: "dog",
		name: "Dog Face",
		keywords: [
			"animal",
			"friend",
			"nature",
			"woof",
			"puppy",
			"pet",
			"faithful"
		],
		skins: [
			{
				unified: "1f436",
				native: "🐶"
			}
		],
		version: 1
	},
	dog2: {
		id: "dog2",
		name: "Dog",
		keywords: [
			"dog2",
			"animal",
			"nature",
			"friend",
			"doge",
			"pet",
			"faithful"
		],
		skins: [
			{
				unified: "1f415",
				native: "🐕"
			}
		],
		version: 1
	},
	guide_dog: {
		id: "guide_dog",
		name: "Guide Dog",
		keywords: [
			"animal",
			"blind"
		],
		skins: [
			{
				unified: "1f9ae",
				native: "🦮"
			}
		],
		version: 12
	},
	service_dog: {
		id: "service_dog",
		name: "Service Dog",
		keywords: [
			"blind",
			"animal"
		],
		skins: [
			{
				unified: "1f415-200d-1f9ba",
				native: "🐕‍🦺"
			}
		],
		version: 12
	},
	poodle: {
		id: "poodle",
		name: "Poodle",
		keywords: [
			"dog",
			"animal",
			"101",
			"nature",
			"pet"
		],
		skins: [
			{
				unified: "1f429",
				native: "🐩"
			}
		],
		version: 1
	},
	wolf: {
		id: "wolf",
		name: "Wolf",
		keywords: [
			"animal",
			"nature",
			"wild"
		],
		skins: [
			{
				unified: "1f43a",
				native: "🐺"
			}
		],
		version: 1
	},
	fox_face: {
		id: "fox_face",
		name: "Fox",
		keywords: [
			"face",
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f98a",
				native: "🦊"
			}
		],
		version: 3
	},
	raccoon: {
		id: "raccoon",
		name: "Raccoon",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f99d",
				native: "🦝"
			}
		],
		version: 11
	},
	cat: {
		id: "cat",
		name: "Cat Face",
		keywords: [
			"animal",
			"meow",
			"nature",
			"pet",
			"kitten"
		],
		skins: [
			{
				unified: "1f431",
				native: "🐱"
			}
		],
		version: 1
	},
	cat2: {
		id: "cat2",
		name: "Cat",
		keywords: [
			"cat2",
			"animal",
			"meow",
			"pet",
			"cats"
		],
		skins: [
			{
				unified: "1f408",
				native: "🐈"
			}
		],
		version: 1
	},
	black_cat: {
		id: "black_cat",
		name: "Black Cat",
		keywords: [
			"superstition",
			"luck"
		],
		skins: [
			{
				unified: "1f408-200d-2b1b",
				native: "🐈‍⬛"
			}
		],
		version: 13
	},
	lion_face: {
		id: "lion_face",
		name: "Lion",
		keywords: [
			"face",
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f981",
				native: "🦁"
			}
		],
		version: 1
	},
	tiger: {
		id: "tiger",
		name: "Tiger Face",
		keywords: [
			"animal",
			"cat",
			"danger",
			"wild",
			"nature",
			"roar"
		],
		skins: [
			{
				unified: "1f42f",
				native: "🐯"
			}
		],
		version: 1
	},
	tiger2: {
		id: "tiger2",
		name: "Tiger",
		keywords: [
			"tiger2",
			"animal",
			"nature",
			"roar"
		],
		skins: [
			{
				unified: "1f405",
				native: "🐅"
			}
		],
		version: 1
	},
	leopard: {
		id: "leopard",
		name: "Leopard",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f406",
				native: "🐆"
			}
		],
		version: 1
	},
	horse: {
		id: "horse",
		name: "Horse Face",
		keywords: [
			"animal",
			"brown",
			"nature"
		],
		skins: [
			{
				unified: "1f434",
				native: "🐴"
			}
		],
		version: 1
	},
	moose: {
		id: "moose",
		name: "Moose",
		keywords: [
			"shrek",
			"canada",
			"sweden",
			"sven",
			"cool"
		],
		skins: [
			{
				unified: "1face",
				native: "🫎"
			}
		],
		version: 15
	},
	donkey: {
		id: "donkey",
		name: "Donkey",
		keywords: [
			"eeyore",
			"mule"
		],
		skins: [
			{
				unified: "1facf",
				native: "🫏"
			}
		],
		version: 15
	},
	racehorse: {
		id: "racehorse",
		name: "Horse",
		keywords: [
			"racehorse",
			"animal",
			"gamble",
			"luck"
		],
		skins: [
			{
				unified: "1f40e",
				native: "🐎"
			}
		],
		version: 1
	},
	unicorn_face: {
		id: "unicorn_face",
		name: "Unicorn",
		keywords: [
			"face",
			"animal",
			"nature",
			"mystical"
		],
		skins: [
			{
				unified: "1f984",
				native: "🦄"
			}
		],
		version: 1
	},
	zebra_face: {
		id: "zebra_face",
		name: "Zebra",
		keywords: [
			"face",
			"animal",
			"nature",
			"stripes",
			"safari"
		],
		skins: [
			{
				unified: "1f993",
				native: "🦓"
			}
		],
		version: 5
	},
	deer: {
		id: "deer",
		name: "Deer",
		keywords: [
			"animal",
			"nature",
			"horns",
			"venison"
		],
		skins: [
			{
				unified: "1f98c",
				native: "🦌"
			}
		],
		version: 3
	},
	bison: {
		id: "bison",
		name: "Bison",
		keywords: [
			"ox"
		],
		skins: [
			{
				unified: "1f9ac",
				native: "🦬"
			}
		],
		version: 13
	},
	cow: {
		id: "cow",
		name: "Cow Face",
		keywords: [
			"beef",
			"ox",
			"animal",
			"nature",
			"moo",
			"milk"
		],
		skins: [
			{
				unified: "1f42e",
				native: "🐮"
			}
		],
		version: 1
	},
	ox: {
		id: "ox",
		name: "Ox",
		keywords: [
			"animal",
			"cow",
			"beef"
		],
		skins: [
			{
				unified: "1f402",
				native: "🐂"
			}
		],
		version: 1
	},
	water_buffalo: {
		id: "water_buffalo",
		name: "Water Buffalo",
		keywords: [
			"animal",
			"nature",
			"ox",
			"cow"
		],
		skins: [
			{
				unified: "1f403",
				native: "🐃"
			}
		],
		version: 1
	},
	cow2: {
		id: "cow2",
		name: "Cow",
		keywords: [
			"cow2",
			"beef",
			"ox",
			"animal",
			"nature",
			"moo",
			"milk"
		],
		skins: [
			{
				unified: "1f404",
				native: "🐄"
			}
		],
		version: 1
	},
	pig: {
		id: "pig",
		name: "Pig Face",
		keywords: [
			"animal",
			"oink",
			"nature"
		],
		skins: [
			{
				unified: "1f437",
				native: "🐷"
			}
		],
		version: 1
	},
	pig2: {
		id: "pig2",
		name: "Pig",
		keywords: [
			"pig2",
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f416",
				native: "🐖"
			}
		],
		version: 1
	},
	boar: {
		id: "boar",
		name: "Boar",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f417",
				native: "🐗"
			}
		],
		version: 1
	},
	pig_nose: {
		id: "pig_nose",
		name: "Pig Nose",
		keywords: [
			"animal",
			"oink"
		],
		skins: [
			{
				unified: "1f43d",
				native: "🐽"
			}
		],
		version: 1
	},
	ram: {
		id: "ram",
		name: "Ram",
		keywords: [
			"animal",
			"sheep",
			"nature"
		],
		skins: [
			{
				unified: "1f40f",
				native: "🐏"
			}
		],
		version: 1
	},
	sheep: {
		id: "sheep",
		name: "Ewe",
		keywords: [
			"sheep",
			"animal",
			"nature",
			"wool",
			"shipit"
		],
		skins: [
			{
				unified: "1f411",
				native: "🐑"
			}
		],
		version: 1
	},
	goat: {
		id: "goat",
		name: "Goat",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f410",
				native: "🐐"
			}
		],
		version: 1
	},
	dromedary_camel: {
		id: "dromedary_camel",
		name: "Camel",
		keywords: [
			"dromedary",
			"animal",
			"hot",
			"desert",
			"hump"
		],
		skins: [
			{
				unified: "1f42a",
				native: "🐪"
			}
		],
		version: 1
	},
	camel: {
		id: "camel",
		name: "Bactrian Camel",
		keywords: [
			"two",
			"hump",
			"animal",
			"nature",
			"hot",
			"desert"
		],
		skins: [
			{
				unified: "1f42b",
				native: "🐫"
			}
		],
		version: 1
	},
	llama: {
		id: "llama",
		name: "Llama",
		keywords: [
			"animal",
			"nature",
			"alpaca"
		],
		skins: [
			{
				unified: "1f999",
				native: "🦙"
			}
		],
		version: 11
	},
	giraffe_face: {
		id: "giraffe_face",
		name: "Giraffe",
		keywords: [
			"face",
			"animal",
			"nature",
			"spots",
			"safari"
		],
		skins: [
			{
				unified: "1f992",
				native: "🦒"
			}
		],
		version: 5
	},
	elephant: {
		id: "elephant",
		name: "Elephant",
		keywords: [
			"animal",
			"nature",
			"nose",
			"th",
			"circus"
		],
		skins: [
			{
				unified: "1f418",
				native: "🐘"
			}
		],
		version: 1
	},
	mammoth: {
		id: "mammoth",
		name: "Mammoth",
		keywords: [
			"elephant",
			"tusks"
		],
		skins: [
			{
				unified: "1f9a3",
				native: "🦣"
			}
		],
		version: 13
	},
	rhinoceros: {
		id: "rhinoceros",
		name: "Rhinoceros",
		keywords: [
			"animal",
			"nature",
			"horn"
		],
		skins: [
			{
				unified: "1f98f",
				native: "🦏"
			}
		],
		version: 3
	},
	hippopotamus: {
		id: "hippopotamus",
		name: "Hippopotamus",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f99b",
				native: "🦛"
			}
		],
		version: 11
	},
	mouse: {
		id: "mouse",
		name: "Mouse Face",
		keywords: [
			"animal",
			"nature",
			"cheese",
			"wedge",
			"rodent"
		],
		skins: [
			{
				unified: "1f42d",
				native: "🐭"
			}
		],
		version: 1
	},
	mouse2: {
		id: "mouse2",
		name: "Mouse",
		keywords: [
			"mouse2",
			"animal",
			"nature",
			"rodent"
		],
		skins: [
			{
				unified: "1f401",
				native: "🐁"
			}
		],
		version: 1
	},
	rat: {
		id: "rat",
		name: "Rat",
		keywords: [
			"animal",
			"mouse",
			"rodent"
		],
		skins: [
			{
				unified: "1f400",
				native: "🐀"
			}
		],
		version: 1
	},
	hamster: {
		id: "hamster",
		name: "Hamster",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f439",
				native: "🐹"
			}
		],
		version: 1
	},
	rabbit: {
		id: "rabbit",
		name: "Rabbit Face",
		keywords: [
			"animal",
			"nature",
			"pet",
			"spring",
			"magic",
			"bunny"
		],
		skins: [
			{
				unified: "1f430",
				native: "🐰"
			}
		],
		version: 1
	},
	rabbit2: {
		id: "rabbit2",
		name: "Rabbit",
		keywords: [
			"rabbit2",
			"animal",
			"nature",
			"pet",
			"magic",
			"spring"
		],
		skins: [
			{
				unified: "1f407",
				native: "🐇"
			}
		],
		version: 1
	},
	chipmunk: {
		id: "chipmunk",
		name: "Chipmunk",
		keywords: [
			"animal",
			"nature",
			"rodent",
			"squirrel"
		],
		skins: [
			{
				unified: "1f43f-fe0f",
				native: "🐿️"
			}
		],
		version: 1
	},
	beaver: {
		id: "beaver",
		name: "Beaver",
		keywords: [
			"animal",
			"rodent"
		],
		skins: [
			{
				unified: "1f9ab",
				native: "🦫"
			}
		],
		version: 13
	},
	hedgehog: {
		id: "hedgehog",
		name: "Hedgehog",
		keywords: [
			"animal",
			"nature",
			"spiny"
		],
		skins: [
			{
				unified: "1f994",
				native: "🦔"
			}
		],
		version: 5
	},
	bat: {
		id: "bat",
		name: "Bat",
		keywords: [
			"animal",
			"nature",
			"blind",
			"vampire"
		],
		skins: [
			{
				unified: "1f987",
				native: "🦇"
			}
		],
		version: 3
	},
	bear: {
		id: "bear",
		name: "Bear",
		keywords: [
			"animal",
			"nature",
			"wild"
		],
		skins: [
			{
				unified: "1f43b",
				native: "🐻"
			}
		],
		version: 1
	},
	polar_bear: {
		id: "polar_bear",
		name: "Polar Bear",
		keywords: [
			"animal",
			"arctic"
		],
		skins: [
			{
				unified: "1f43b-200d-2744-fe0f",
				native: "🐻‍❄️"
			}
		],
		version: 13
	},
	koala: {
		id: "koala",
		name: "Koala",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f428",
				native: "🐨"
			}
		],
		version: 1
	},
	panda_face: {
		id: "panda_face",
		name: "Panda",
		keywords: [
			"face",
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f43c",
				native: "🐼"
			}
		],
		version: 1
	},
	sloth: {
		id: "sloth",
		name: "Sloth",
		keywords: [
			"animal"
		],
		skins: [
			{
				unified: "1f9a5",
				native: "🦥"
			}
		],
		version: 12
	},
	otter: {
		id: "otter",
		name: "Otter",
		keywords: [
			"animal"
		],
		skins: [
			{
				unified: "1f9a6",
				native: "🦦"
			}
		],
		version: 12
	},
	skunk: {
		id: "skunk",
		name: "Skunk",
		keywords: [
			"animal"
		],
		skins: [
			{
				unified: "1f9a8",
				native: "🦨"
			}
		],
		version: 12
	},
	kangaroo: {
		id: "kangaroo",
		name: "Kangaroo",
		keywords: [
			"animal",
			"nature",
			"australia",
			"joey",
			"hop",
			"marsupial"
		],
		skins: [
			{
				unified: "1f998",
				native: "🦘"
			}
		],
		version: 11
	},
	badger: {
		id: "badger",
		name: "Badger",
		keywords: [
			"animal",
			"nature",
			"honey"
		],
		skins: [
			{
				unified: "1f9a1",
				native: "🦡"
			}
		],
		version: 11
	},
	feet: {
		id: "feet",
		name: "Paw Prints",
		keywords: [
			"feet",
			"animal",
			"tracking",
			"footprints",
			"dog",
			"cat",
			"pet"
		],
		skins: [
			{
				unified: "1f43e",
				native: "🐾"
			}
		],
		version: 1
	},
	turkey: {
		id: "turkey",
		name: "Turkey",
		keywords: [
			"animal",
			"bird"
		],
		skins: [
			{
				unified: "1f983",
				native: "🦃"
			}
		],
		version: 1
	},
	chicken: {
		id: "chicken",
		name: "Chicken",
		keywords: [
			"animal",
			"cluck",
			"nature",
			"bird"
		],
		skins: [
			{
				unified: "1f414",
				native: "🐔"
			}
		],
		version: 1
	},
	rooster: {
		id: "rooster",
		name: "Rooster",
		keywords: [
			"animal",
			"nature",
			"chicken"
		],
		skins: [
			{
				unified: "1f413",
				native: "🐓"
			}
		],
		version: 1
	},
	hatching_chick: {
		id: "hatching_chick",
		name: "Hatching Chick",
		keywords: [
			"animal",
			"chicken",
			"egg",
			"born",
			"baby",
			"bird"
		],
		skins: [
			{
				unified: "1f423",
				native: "🐣"
			}
		],
		version: 1
	},
	baby_chick: {
		id: "baby_chick",
		name: "Baby Chick",
		keywords: [
			"animal",
			"chicken",
			"bird"
		],
		skins: [
			{
				unified: "1f424",
				native: "🐤"
			}
		],
		version: 1
	},
	hatched_chick: {
		id: "hatched_chick",
		name: "Front-Facing Baby Chick",
		keywords: [
			"hatched",
			"front",
			"facing",
			"animal",
			"chicken",
			"bird"
		],
		skins: [
			{
				unified: "1f425",
				native: "🐥"
			}
		],
		version: 1
	},
	bird: {
		id: "bird",
		name: "Bird",
		keywords: [
			"animal",
			"nature",
			"fly",
			"tweet",
			"spring"
		],
		skins: [
			{
				unified: "1f426",
				native: "🐦"
			}
		],
		version: 1
	},
	penguin: {
		id: "penguin",
		name: "Penguin",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f427",
				native: "🐧"
			}
		],
		version: 1
	},
	dove_of_peace: {
		id: "dove_of_peace",
		name: "Dove",
		keywords: [
			"of",
			"peace",
			"animal",
			"bird"
		],
		skins: [
			{
				unified: "1f54a-fe0f",
				native: "🕊️"
			}
		],
		version: 1
	},
	eagle: {
		id: "eagle",
		name: "Eagle",
		keywords: [
			"animal",
			"nature",
			"bird"
		],
		skins: [
			{
				unified: "1f985",
				native: "🦅"
			}
		],
		version: 3
	},
	duck: {
		id: "duck",
		name: "Duck",
		keywords: [
			"animal",
			"nature",
			"bird",
			"mallard"
		],
		skins: [
			{
				unified: "1f986",
				native: "🦆"
			}
		],
		version: 3
	},
	swan: {
		id: "swan",
		name: "Swan",
		keywords: [
			"animal",
			"nature",
			"bird"
		],
		skins: [
			{
				unified: "1f9a2",
				native: "🦢"
			}
		],
		version: 11
	},
	owl: {
		id: "owl",
		name: "Owl",
		keywords: [
			"animal",
			"nature",
			"bird",
			"hoot"
		],
		skins: [
			{
				unified: "1f989",
				native: "🦉"
			}
		],
		version: 3
	},
	dodo: {
		id: "dodo",
		name: "Dodo",
		keywords: [
			"animal",
			"bird"
		],
		skins: [
			{
				unified: "1f9a4",
				native: "🦤"
			}
		],
		version: 13
	},
	feather: {
		id: "feather",
		name: "Feather",
		keywords: [
			"bird",
			"fly"
		],
		skins: [
			{
				unified: "1fab6",
				native: "🪶"
			}
		],
		version: 13
	},
	flamingo: {
		id: "flamingo",
		name: "Flamingo",
		keywords: [
			"animal"
		],
		skins: [
			{
				unified: "1f9a9",
				native: "🦩"
			}
		],
		version: 12
	},
	peacock: {
		id: "peacock",
		name: "Peacock",
		keywords: [
			"animal",
			"nature",
			"peahen",
			"bird"
		],
		skins: [
			{
				unified: "1f99a",
				native: "🦚"
			}
		],
		version: 11
	},
	parrot: {
		id: "parrot",
		name: "Parrot",
		keywords: [
			"animal",
			"nature",
			"bird",
			"pirate",
			"talk"
		],
		skins: [
			{
				unified: "1f99c",
				native: "🦜"
			}
		],
		version: 11
	},
	wing: {
		id: "wing",
		name: "Wing",
		keywords: [
			"angel",
			"birds",
			"flying"
		],
		skins: [
			{
				unified: "1fabd",
				native: "🪽"
			}
		],
		version: 15
	},
	black_bird: {
		id: "black_bird",
		name: "Black Bird",
		keywords: [
			"crow"
		],
		skins: [
			{
				unified: "1f426-200d-2b1b",
				native: "🐦‍⬛"
			}
		],
		version: 15
	},
	goose: {
		id: "goose",
		name: "Goose",
		keywords: [
			"silly",
			"jemima",
			"goosebumps"
		],
		skins: [
			{
				unified: "1fabf",
				native: "🪿"
			}
		],
		version: 15
	},
	frog: {
		id: "frog",
		name: "Frog",
		keywords: [
			"animal",
			"nature",
			"croak",
			"toad"
		],
		skins: [
			{
				unified: "1f438",
				native: "🐸"
			}
		],
		version: 1
	},
	crocodile: {
		id: "crocodile",
		name: "Crocodile",
		keywords: [
			"animal",
			"nature",
			"reptile",
			"lizard",
			"alligator"
		],
		skins: [
			{
				unified: "1f40a",
				native: "🐊"
			}
		],
		version: 1
	},
	turtle: {
		id: "turtle",
		name: "Turtle",
		keywords: [
			"animal",
			"slow",
			"nature",
			"tortoise"
		],
		skins: [
			{
				unified: "1f422",
				native: "🐢"
			}
		],
		version: 1
	},
	lizard: {
		id: "lizard",
		name: "Lizard",
		keywords: [
			"animal",
			"nature",
			"reptile"
		],
		skins: [
			{
				unified: "1f98e",
				native: "🦎"
			}
		],
		version: 3
	},
	snake: {
		id: "snake",
		name: "Snake",
		keywords: [
			"animal",
			"evil",
			"nature",
			"hiss",
			"python"
		],
		skins: [
			{
				unified: "1f40d",
				native: "🐍"
			}
		],
		version: 1
	},
	dragon_face: {
		id: "dragon_face",
		name: "Dragon Face",
		keywords: [
			"animal",
			"myth",
			"nature",
			"chinese",
			"green"
		],
		skins: [
			{
				unified: "1f432",
				native: "🐲"
			}
		],
		version: 1
	},
	dragon: {
		id: "dragon",
		name: "Dragon",
		keywords: [
			"animal",
			"myth",
			"nature",
			"chinese",
			"green"
		],
		skins: [
			{
				unified: "1f409",
				native: "🐉"
			}
		],
		version: 1
	},
	sauropod: {
		id: "sauropod",
		name: "Sauropod",
		keywords: [
			"animal",
			"nature",
			"dinosaur",
			"brachiosaurus",
			"brontosaurus",
			"diplodocus",
			"extinct"
		],
		skins: [
			{
				unified: "1f995",
				native: "🦕"
			}
		],
		version: 5
	},
	"t-rex": {
		id: "t-rex",
		name: "T-Rex",
		keywords: [
			"t",
			"rex",
			"animal",
			"nature",
			"dinosaur",
			"tyrannosaurus",
			"extinct"
		],
		skins: [
			{
				unified: "1f996",
				native: "🦖"
			}
		],
		version: 5
	},
	whale: {
		id: "whale",
		name: "Spouting Whale",
		keywords: [
			"animal",
			"nature",
			"sea",
			"ocean"
		],
		skins: [
			{
				unified: "1f433",
				native: "🐳"
			}
		],
		version: 1
	},
	whale2: {
		id: "whale2",
		name: "Whale",
		keywords: [
			"whale2",
			"animal",
			"nature",
			"sea",
			"ocean"
		],
		skins: [
			{
				unified: "1f40b",
				native: "🐋"
			}
		],
		version: 1
	},
	dolphin: {
		id: "dolphin",
		name: "Dolphin",
		keywords: [
			"flipper",
			"animal",
			"nature",
			"fish",
			"sea",
			"ocean",
			"fins",
			"beach"
		],
		skins: [
			{
				unified: "1f42c",
				native: "🐬"
			}
		],
		version: 1
	},
	seal: {
		id: "seal",
		name: "Seal",
		keywords: [
			"animal",
			"creature",
			"sea"
		],
		skins: [
			{
				unified: "1f9ad",
				native: "🦭"
			}
		],
		version: 13
	},
	fish: {
		id: "fish",
		name: "Fish",
		keywords: [
			"animal",
			"food",
			"nature"
		],
		skins: [
			{
				unified: "1f41f",
				native: "🐟"
			}
		],
		version: 1
	},
	tropical_fish: {
		id: "tropical_fish",
		name: "Tropical Fish",
		keywords: [
			"animal",
			"swim",
			"ocean",
			"beach",
			"nemo"
		],
		skins: [
			{
				unified: "1f420",
				native: "🐠"
			}
		],
		version: 1
	},
	blowfish: {
		id: "blowfish",
		name: "Blowfish",
		keywords: [
			"animal",
			"nature",
			"food",
			"sea",
			"ocean"
		],
		skins: [
			{
				unified: "1f421",
				native: "🐡"
			}
		],
		version: 1
	},
	shark: {
		id: "shark",
		name: "Shark",
		keywords: [
			"animal",
			"nature",
			"fish",
			"sea",
			"ocean",
			"jaws",
			"fins",
			"beach"
		],
		skins: [
			{
				unified: "1f988",
				native: "🦈"
			}
		],
		version: 3
	},
	octopus: {
		id: "octopus",
		name: "Octopus",
		keywords: [
			"animal",
			"creature",
			"ocean",
			"sea",
			"nature",
			"beach"
		],
		skins: [
			{
				unified: "1f419",
				native: "🐙"
			}
		],
		version: 1
	},
	shell: {
		id: "shell",
		name: "Spiral Shell",
		keywords: [
			"nature",
			"sea",
			"beach"
		],
		skins: [
			{
				unified: "1f41a",
				native: "🐚"
			}
		],
		version: 1
	},
	coral: {
		id: "coral",
		name: "Coral",
		keywords: [
			"ocean",
			"sea",
			"reef"
		],
		skins: [
			{
				unified: "1fab8",
				native: "🪸"
			}
		],
		version: 14
	},
	jellyfish: {
		id: "jellyfish",
		name: "Jellyfish",
		keywords: [
			"sting",
			"tentacles"
		],
		skins: [
			{
				unified: "1fabc",
				native: "🪼"
			}
		],
		version: 15
	},
	snail: {
		id: "snail",
		name: "Snail",
		keywords: [
			"slow",
			"animal",
			"shell"
		],
		skins: [
			{
				unified: "1f40c",
				native: "🐌"
			}
		],
		version: 1
	},
	butterfly: {
		id: "butterfly",
		name: "Butterfly",
		keywords: [
			"animal",
			"insect",
			"nature",
			"caterpillar"
		],
		skins: [
			{
				unified: "1f98b",
				native: "🦋"
			}
		],
		version: 3
	},
	bug: {
		id: "bug",
		name: "Bug",
		keywords: [
			"animal",
			"insect",
			"nature",
			"worm"
		],
		skins: [
			{
				unified: "1f41b",
				native: "🐛"
			}
		],
		version: 1
	},
	ant: {
		id: "ant",
		name: "Ant",
		keywords: [
			"animal",
			"insect",
			"nature",
			"bug"
		],
		skins: [
			{
				unified: "1f41c",
				native: "🐜"
			}
		],
		version: 1
	},
	bee: {
		id: "bee",
		name: "Honeybee",
		keywords: [
			"bee",
			"animal",
			"insect",
			"nature",
			"bug",
			"spring",
			"honey"
		],
		skins: [
			{
				unified: "1f41d",
				native: "🐝"
			}
		],
		version: 1
	},
	beetle: {
		id: "beetle",
		name: "Beetle",
		keywords: [
			"insect"
		],
		skins: [
			{
				unified: "1fab2",
				native: "🪲"
			}
		],
		version: 13
	},
	ladybug: {
		id: "ladybug",
		name: "Lady Beetle",
		keywords: [
			"ladybug",
			"animal",
			"insect",
			"nature"
		],
		skins: [
			{
				unified: "1f41e",
				native: "🐞"
			}
		],
		version: 1
	},
	cricket: {
		id: "cricket",
		name: "Cricket",
		keywords: [
			"animal",
			"chirp"
		],
		skins: [
			{
				unified: "1f997",
				native: "🦗"
			}
		],
		version: 5
	},
	cockroach: {
		id: "cockroach",
		name: "Cockroach",
		keywords: [
			"insect",
			"pests"
		],
		skins: [
			{
				unified: "1fab3",
				native: "🪳"
			}
		],
		version: 13
	},
	spider: {
		id: "spider",
		name: "Spider",
		keywords: [
			"animal",
			"arachnid"
		],
		skins: [
			{
				unified: "1f577-fe0f",
				native: "🕷️"
			}
		],
		version: 1
	},
	spider_web: {
		id: "spider_web",
		name: "Spider Web",
		keywords: [
			"animal",
			"insect",
			"arachnid",
			"silk"
		],
		skins: [
			{
				unified: "1f578-fe0f",
				native: "🕸️"
			}
		],
		version: 1
	},
	scorpion: {
		id: "scorpion",
		name: "Scorpion",
		keywords: [
			"animal",
			"arachnid"
		],
		skins: [
			{
				unified: "1f982",
				native: "🦂"
			}
		],
		version: 1
	},
	mosquito: {
		id: "mosquito",
		name: "Mosquito",
		keywords: [
			"animal",
			"nature",
			"insect",
			"malaria"
		],
		skins: [
			{
				unified: "1f99f",
				native: "🦟"
			}
		],
		version: 11
	},
	fly: {
		id: "fly",
		name: "Fly",
		keywords: [
			"insect"
		],
		skins: [
			{
				unified: "1fab0",
				native: "🪰"
			}
		],
		version: 13
	},
	worm: {
		id: "worm",
		name: "Worm",
		keywords: [
			"animal"
		],
		skins: [
			{
				unified: "1fab1",
				native: "🪱"
			}
		],
		version: 13
	},
	microbe: {
		id: "microbe",
		name: "Microbe",
		keywords: [
			"amoeba",
			"bacteria",
			"germs",
			"virus",
			"covid"
		],
		skins: [
			{
				unified: "1f9a0",
				native: "🦠"
			}
		],
		version: 11
	},
	bouquet: {
		id: "bouquet",
		name: "Bouquet",
		keywords: [
			"flowers",
			"nature",
			"spring"
		],
		skins: [
			{
				unified: "1f490",
				native: "💐"
			}
		],
		version: 1
	},
	cherry_blossom: {
		id: "cherry_blossom",
		name: "Cherry Blossom",
		keywords: [
			"nature",
			"plant",
			"spring",
			"flower"
		],
		skins: [
			{
				unified: "1f338",
				native: "🌸"
			}
		],
		version: 1
	},
	white_flower: {
		id: "white_flower",
		name: "White Flower",
		keywords: [
			"japanese",
			"spring"
		],
		skins: [
			{
				unified: "1f4ae",
				native: "💮"
			}
		],
		version: 1
	},
	lotus: {
		id: "lotus",
		name: "Lotus",
		keywords: [
			"flower",
			"calm",
			"meditation"
		],
		skins: [
			{
				unified: "1fab7",
				native: "🪷"
			}
		],
		version: 14
	},
	rosette: {
		id: "rosette",
		name: "Rosette",
		keywords: [
			"flower",
			"decoration",
			"military"
		],
		skins: [
			{
				unified: "1f3f5-fe0f",
				native: "🏵️"
			}
		],
		version: 1
	},
	rose: {
		id: "rose",
		name: "Rose",
		keywords: [
			"flowers",
			"valentines",
			"love",
			"spring"
		],
		skins: [
			{
				unified: "1f339",
				native: "🌹"
			}
		],
		version: 1
	},
	wilted_flower: {
		id: "wilted_flower",
		name: "Wilted Flower",
		keywords: [
			"plant",
			"nature",
			"rose"
		],
		skins: [
			{
				unified: "1f940",
				native: "🥀"
			}
		],
		version: 3
	},
	hibiscus: {
		id: "hibiscus",
		name: "Hibiscus",
		keywords: [
			"plant",
			"vegetable",
			"flowers",
			"beach"
		],
		skins: [
			{
				unified: "1f33a",
				native: "🌺"
			}
		],
		version: 1
	},
	sunflower: {
		id: "sunflower",
		name: "Sunflower",
		keywords: [
			"nature",
			"plant",
			"fall"
		],
		skins: [
			{
				unified: "1f33b",
				native: "🌻"
			}
		],
		version: 1
	},
	blossom: {
		id: "blossom",
		name: "Blossom",
		keywords: [
			"nature",
			"flowers",
			"yellow"
		],
		skins: [
			{
				unified: "1f33c",
				native: "🌼"
			}
		],
		version: 1
	},
	tulip: {
		id: "tulip",
		name: "Tulip",
		keywords: [
			"flowers",
			"plant",
			"nature",
			"summer",
			"spring"
		],
		skins: [
			{
				unified: "1f337",
				native: "🌷"
			}
		],
		version: 1
	},
	hyacinth: {
		id: "hyacinth",
		name: "Hyacinth",
		keywords: [
			"flower",
			"lavender"
		],
		skins: [
			{
				unified: "1fabb",
				native: "🪻"
			}
		],
		version: 15
	},
	seedling: {
		id: "seedling",
		name: "Seedling",
		keywords: [
			"plant",
			"nature",
			"grass",
			"lawn",
			"spring"
		],
		skins: [
			{
				unified: "1f331",
				native: "🌱"
			}
		],
		version: 1
	},
	potted_plant: {
		id: "potted_plant",
		name: "Potted Plant",
		keywords: [
			"greenery",
			"house"
		],
		skins: [
			{
				unified: "1fab4",
				native: "🪴"
			}
		],
		version: 13
	},
	evergreen_tree: {
		id: "evergreen_tree",
		name: "Evergreen Tree",
		keywords: [
			"plant",
			"nature"
		],
		skins: [
			{
				unified: "1f332",
				native: "🌲"
			}
		],
		version: 1
	},
	deciduous_tree: {
		id: "deciduous_tree",
		name: "Deciduous Tree",
		keywords: [
			"plant",
			"nature"
		],
		skins: [
			{
				unified: "1f333",
				native: "🌳"
			}
		],
		version: 1
	},
	palm_tree: {
		id: "palm_tree",
		name: "Palm Tree",
		keywords: [
			"plant",
			"vegetable",
			"nature",
			"summer",
			"beach",
			"mojito",
			"tropical"
		],
		skins: [
			{
				unified: "1f334",
				native: "🌴"
			}
		],
		version: 1
	},
	cactus: {
		id: "cactus",
		name: "Cactus",
		keywords: [
			"vegetable",
			"plant",
			"nature"
		],
		skins: [
			{
				unified: "1f335",
				native: "🌵"
			}
		],
		version: 1
	},
	ear_of_rice: {
		id: "ear_of_rice",
		name: "Ear of Rice",
		keywords: [
			"sheaf",
			"nature",
			"plant"
		],
		skins: [
			{
				unified: "1f33e",
				native: "🌾"
			}
		],
		version: 1
	},
	herb: {
		id: "herb",
		name: "Herb",
		keywords: [
			"vegetable",
			"plant",
			"medicine",
			"weed",
			"grass",
			"lawn"
		],
		skins: [
			{
				unified: "1f33f",
				native: "🌿"
			}
		],
		version: 1
	},
	shamrock: {
		id: "shamrock",
		name: "Shamrock",
		keywords: [
			"vegetable",
			"plant",
			"nature",
			"irish",
			"clover"
		],
		skins: [
			{
				unified: "2618-fe0f",
				native: "☘️"
			}
		],
		version: 1
	},
	four_leaf_clover: {
		id: "four_leaf_clover",
		name: "Four Leaf Clover",
		keywords: [
			"vegetable",
			"plant",
			"nature",
			"lucky",
			"irish"
		],
		skins: [
			{
				unified: "1f340",
				native: "🍀"
			}
		],
		version: 1
	},
	maple_leaf: {
		id: "maple_leaf",
		name: "Maple Leaf",
		keywords: [
			"nature",
			"plant",
			"vegetable",
			"ca",
			"fall"
		],
		skins: [
			{
				unified: "1f341",
				native: "🍁"
			}
		],
		version: 1
	},
	fallen_leaf: {
		id: "fallen_leaf",
		name: "Fallen Leaf",
		keywords: [
			"nature",
			"plant",
			"vegetable",
			"leaves"
		],
		skins: [
			{
				unified: "1f342",
				native: "🍂"
			}
		],
		version: 1
	},
	leaves: {
		id: "leaves",
		name: "Leaf Fluttering in Wind",
		keywords: [
			"leaves",
			"nature",
			"plant",
			"tree",
			"vegetable",
			"grass",
			"lawn",
			"spring"
		],
		skins: [
			{
				unified: "1f343",
				native: "🍃"
			}
		],
		version: 1
	},
	empty_nest: {
		id: "empty_nest",
		name: "Empty Nest",
		keywords: [
			"bird"
		],
		skins: [
			{
				unified: "1fab9",
				native: "🪹"
			}
		],
		version: 14
	},
	nest_with_eggs: {
		id: "nest_with_eggs",
		name: "Nest with Eggs",
		keywords: [
			"bird"
		],
		skins: [
			{
				unified: "1faba",
				native: "🪺"
			}
		],
		version: 14
	},
	mushroom: {
		id: "mushroom",
		name: "Mushroom",
		keywords: [
			"plant",
			"vegetable"
		],
		skins: [
			{
				unified: "1f344",
				native: "🍄"
			}
		],
		version: 1
	},
	grapes: {
		id: "grapes",
		name: "Grapes",
		keywords: [
			"fruit",
			"food",
			"wine"
		],
		skins: [
			{
				unified: "1f347",
				native: "🍇"
			}
		],
		version: 1
	},
	melon: {
		id: "melon",
		name: "Melon",
		keywords: [
			"fruit",
			"nature",
			"food"
		],
		skins: [
			{
				unified: "1f348",
				native: "🍈"
			}
		],
		version: 1
	},
	watermelon: {
		id: "watermelon",
		name: "Watermelon",
		keywords: [
			"fruit",
			"food",
			"picnic",
			"summer"
		],
		skins: [
			{
				unified: "1f349",
				native: "🍉"
			}
		],
		version: 1
	},
	tangerine: {
		id: "tangerine",
		name: "Tangerine",
		keywords: [
			"food",
			"fruit",
			"nature",
			"orange"
		],
		skins: [
			{
				unified: "1f34a",
				native: "🍊"
			}
		],
		version: 1
	},
	lemon: {
		id: "lemon",
		name: "Lemon",
		keywords: [
			"fruit",
			"nature"
		],
		skins: [
			{
				unified: "1f34b",
				native: "🍋"
			}
		],
		version: 1
	},
	banana: {
		id: "banana",
		name: "Banana",
		keywords: [
			"fruit",
			"food",
			"monkey"
		],
		skins: [
			{
				unified: "1f34c",
				native: "🍌"
			}
		],
		version: 1
	},
	pineapple: {
		id: "pineapple",
		name: "Pineapple",
		keywords: [
			"fruit",
			"nature",
			"food"
		],
		skins: [
			{
				unified: "1f34d",
				native: "🍍"
			}
		],
		version: 1
	},
	mango: {
		id: "mango",
		name: "Mango",
		keywords: [
			"fruit",
			"food",
			"tropical"
		],
		skins: [
			{
				unified: "1f96d",
				native: "🥭"
			}
		],
		version: 11
	},
	apple: {
		id: "apple",
		name: "Red Apple",
		keywords: [
			"fruit",
			"mac",
			"school"
		],
		skins: [
			{
				unified: "1f34e",
				native: "🍎"
			}
		],
		version: 1
	},
	green_apple: {
		id: "green_apple",
		name: "Green Apple",
		keywords: [
			"fruit",
			"nature"
		],
		skins: [
			{
				unified: "1f34f",
				native: "🍏"
			}
		],
		version: 1
	},
	pear: {
		id: "pear",
		name: "Pear",
		keywords: [
			"fruit",
			"nature",
			"food"
		],
		skins: [
			{
				unified: "1f350",
				native: "🍐"
			}
		],
		version: 1
	},
	peach: {
		id: "peach",
		name: "Peach",
		keywords: [
			"fruit",
			"nature",
			"food"
		],
		skins: [
			{
				unified: "1f351",
				native: "🍑"
			}
		],
		version: 1
	},
	cherries: {
		id: "cherries",
		name: "Cherries",
		keywords: [
			"food",
			"fruit"
		],
		skins: [
			{
				unified: "1f352",
				native: "🍒"
			}
		],
		version: 1
	},
	strawberry: {
		id: "strawberry",
		name: "Strawberry",
		keywords: [
			"fruit",
			"food",
			"nature"
		],
		skins: [
			{
				unified: "1f353",
				native: "🍓"
			}
		],
		version: 1
	},
	blueberries: {
		id: "blueberries",
		name: "Blueberries",
		keywords: [
			"fruit"
		],
		skins: [
			{
				unified: "1fad0",
				native: "🫐"
			}
		],
		version: 13
	},
	kiwifruit: {
		id: "kiwifruit",
		name: "Kiwifruit",
		keywords: [
			"kiwi",
			"fruit",
			"food"
		],
		skins: [
			{
				unified: "1f95d",
				native: "🥝"
			}
		],
		version: 3
	},
	tomato: {
		id: "tomato",
		name: "Tomato",
		keywords: [
			"fruit",
			"vegetable",
			"nature",
			"food"
		],
		skins: [
			{
				unified: "1f345",
				native: "🍅"
			}
		],
		version: 1
	},
	olive: {
		id: "olive",
		name: "Olive",
		keywords: [
			"fruit"
		],
		skins: [
			{
				unified: "1fad2",
				native: "🫒"
			}
		],
		version: 13
	},
	coconut: {
		id: "coconut",
		name: "Coconut",
		keywords: [
			"fruit",
			"nature",
			"food",
			"palm"
		],
		skins: [
			{
				unified: "1f965",
				native: "🥥"
			}
		],
		version: 5
	},
	avocado: {
		id: "avocado",
		name: "Avocado",
		keywords: [
			"fruit",
			"food"
		],
		skins: [
			{
				unified: "1f951",
				native: "🥑"
			}
		],
		version: 3
	},
	eggplant: {
		id: "eggplant",
		name: "Eggplant",
		keywords: [
			"vegetable",
			"nature",
			"food",
			"aubergine"
		],
		skins: [
			{
				unified: "1f346",
				native: "🍆"
			}
		],
		version: 1
	},
	potato: {
		id: "potato",
		name: "Potato",
		keywords: [
			"food",
			"tuber",
			"vegatable",
			"starch"
		],
		skins: [
			{
				unified: "1f954",
				native: "🥔"
			}
		],
		version: 3
	},
	carrot: {
		id: "carrot",
		name: "Carrot",
		keywords: [
			"vegetable",
			"food",
			"orange"
		],
		skins: [
			{
				unified: "1f955",
				native: "🥕"
			}
		],
		version: 3
	},
	corn: {
		id: "corn",
		name: "Ear of Corn",
		keywords: [
			"food",
			"vegetable",
			"plant"
		],
		skins: [
			{
				unified: "1f33d",
				native: "🌽"
			}
		],
		version: 1
	},
	hot_pepper: {
		id: "hot_pepper",
		name: "Hot Pepper",
		keywords: [
			"food",
			"spicy",
			"chilli",
			"chili"
		],
		skins: [
			{
				unified: "1f336-fe0f",
				native: "🌶️"
			}
		],
		version: 1
	},
	bell_pepper: {
		id: "bell_pepper",
		name: "Bell Pepper",
		keywords: [
			"fruit",
			"plant"
		],
		skins: [
			{
				unified: "1fad1",
				native: "🫑"
			}
		],
		version: 13
	},
	cucumber: {
		id: "cucumber",
		name: "Cucumber",
		keywords: [
			"fruit",
			"food",
			"pickle"
		],
		skins: [
			{
				unified: "1f952",
				native: "🥒"
			}
		],
		version: 3
	},
	leafy_green: {
		id: "leafy_green",
		name: "Leafy Green",
		keywords: [
			"food",
			"vegetable",
			"plant",
			"bok",
			"choy",
			"cabbage",
			"kale",
			"lettuce"
		],
		skins: [
			{
				unified: "1f96c",
				native: "🥬"
			}
		],
		version: 11
	},
	broccoli: {
		id: "broccoli",
		name: "Broccoli",
		keywords: [
			"fruit",
			"food",
			"vegetable"
		],
		skins: [
			{
				unified: "1f966",
				native: "🥦"
			}
		],
		version: 5
	},
	garlic: {
		id: "garlic",
		name: "Garlic",
		keywords: [
			"food",
			"spice",
			"cook"
		],
		skins: [
			{
				unified: "1f9c4",
				native: "🧄"
			}
		],
		version: 12
	},
	onion: {
		id: "onion",
		name: "Onion",
		keywords: [
			"cook",
			"food",
			"spice"
		],
		skins: [
			{
				unified: "1f9c5",
				native: "🧅"
			}
		],
		version: 12
	},
	peanuts: {
		id: "peanuts",
		name: "Peanuts",
		keywords: [
			"food",
			"nut"
		],
		skins: [
			{
				unified: "1f95c",
				native: "🥜"
			}
		],
		version: 3
	},
	beans: {
		id: "beans",
		name: "Beans",
		keywords: [
			"food"
		],
		skins: [
			{
				unified: "1fad8",
				native: "🫘"
			}
		],
		version: 14
	},
	chestnut: {
		id: "chestnut",
		name: "Chestnut",
		keywords: [
			"food",
			"squirrel"
		],
		skins: [
			{
				unified: "1f330",
				native: "🌰"
			}
		],
		version: 1
	},
	ginger_root: {
		id: "ginger_root",
		name: "Ginger Root",
		keywords: [
			"spice",
			"yellow",
			"cooking",
			"gingerbread"
		],
		skins: [
			{
				unified: "1fada",
				native: "🫚"
			}
		],
		version: 15
	},
	pea_pod: {
		id: "pea_pod",
		name: "Pea Pod",
		keywords: [
			"cozy",
			"green"
		],
		skins: [
			{
				unified: "1fadb",
				native: "🫛"
			}
		],
		version: 15
	},
	bread: {
		id: "bread",
		name: "Bread",
		keywords: [
			"food",
			"wheat",
			"breakfast",
			"toast"
		],
		skins: [
			{
				unified: "1f35e",
				native: "🍞"
			}
		],
		version: 1
	},
	croissant: {
		id: "croissant",
		name: "Croissant",
		keywords: [
			"food",
			"bread",
			"french"
		],
		skins: [
			{
				unified: "1f950",
				native: "🥐"
			}
		],
		version: 3
	},
	baguette_bread: {
		id: "baguette_bread",
		name: "Baguette Bread",
		keywords: [
			"food",
			"french",
			"france",
			"bakery"
		],
		skins: [
			{
				unified: "1f956",
				native: "🥖"
			}
		],
		version: 3
	},
	flatbread: {
		id: "flatbread",
		name: "Flatbread",
		keywords: [
			"flour",
			"food",
			"bakery"
		],
		skins: [
			{
				unified: "1fad3",
				native: "🫓"
			}
		],
		version: 13
	},
	pretzel: {
		id: "pretzel",
		name: "Pretzel",
		keywords: [
			"food",
			"bread",
			"twisted",
			"germany",
			"bakery"
		],
		skins: [
			{
				unified: "1f968",
				native: "🥨"
			}
		],
		version: 5
	},
	bagel: {
		id: "bagel",
		name: "Bagel",
		keywords: [
			"food",
			"bread",
			"bakery",
			"schmear",
			"jewish"
		],
		skins: [
			{
				unified: "1f96f",
				native: "🥯"
			}
		],
		version: 11
	},
	pancakes: {
		id: "pancakes",
		name: "Pancakes",
		keywords: [
			"food",
			"breakfast",
			"flapjacks",
			"hotcakes",
			"brunch"
		],
		skins: [
			{
				unified: "1f95e",
				native: "🥞"
			}
		],
		version: 3
	},
	waffle: {
		id: "waffle",
		name: "Waffle",
		keywords: [
			"food",
			"breakfast",
			"brunch"
		],
		skins: [
			{
				unified: "1f9c7",
				native: "🧇"
			}
		],
		version: 12
	},
	cheese_wedge: {
		id: "cheese_wedge",
		name: "Cheese Wedge",
		keywords: [
			"food",
			"chadder",
			"swiss"
		],
		skins: [
			{
				unified: "1f9c0",
				native: "🧀"
			}
		],
		version: 1
	},
	meat_on_bone: {
		id: "meat_on_bone",
		name: "Meat on Bone",
		keywords: [
			"good",
			"food",
			"drumstick"
		],
		skins: [
			{
				unified: "1f356",
				native: "🍖"
			}
		],
		version: 1
	},
	poultry_leg: {
		id: "poultry_leg",
		name: "Poultry Leg",
		keywords: [
			"food",
			"meat",
			"drumstick",
			"bird",
			"chicken",
			"turkey"
		],
		skins: [
			{
				unified: "1f357",
				native: "🍗"
			}
		],
		version: 1
	},
	cut_of_meat: {
		id: "cut_of_meat",
		name: "Cut of Meat",
		keywords: [
			"food",
			"cow",
			"chop",
			"lambchop",
			"porkchop"
		],
		skins: [
			{
				unified: "1f969",
				native: "🥩"
			}
		],
		version: 5
	},
	bacon: {
		id: "bacon",
		name: "Bacon",
		keywords: [
			"food",
			"breakfast",
			"pork",
			"pig",
			"meat",
			"brunch"
		],
		skins: [
			{
				unified: "1f953",
				native: "🥓"
			}
		],
		version: 3
	},
	hamburger: {
		id: "hamburger",
		name: "Hamburger",
		keywords: [
			"meat",
			"fast",
			"food",
			"beef",
			"cheeseburger",
			"mcdonalds",
			"burger",
			"king"
		],
		skins: [
			{
				unified: "1f354",
				native: "🍔"
			}
		],
		version: 1
	},
	fries: {
		id: "fries",
		name: "French Fries",
		keywords: [
			"chips",
			"snack",
			"fast",
			"food",
			"potato"
		],
		skins: [
			{
				unified: "1f35f",
				native: "🍟"
			}
		],
		version: 1
	},
	pizza: {
		id: "pizza",
		name: "Pizza",
		keywords: [
			"food",
			"party",
			"italy"
		],
		skins: [
			{
				unified: "1f355",
				native: "🍕"
			}
		],
		version: 1
	},
	hotdog: {
		id: "hotdog",
		name: "Hot Dog",
		keywords: [
			"hotdog",
			"food",
			"frankfurter",
			"america"
		],
		skins: [
			{
				unified: "1f32d",
				native: "🌭"
			}
		],
		version: 1
	},
	sandwich: {
		id: "sandwich",
		name: "Sandwich",
		keywords: [
			"food",
			"lunch",
			"bread",
			"toast",
			"bakery"
		],
		skins: [
			{
				unified: "1f96a",
				native: "🥪"
			}
		],
		version: 5
	},
	taco: {
		id: "taco",
		name: "Taco",
		keywords: [
			"food",
			"mexican"
		],
		skins: [
			{
				unified: "1f32e",
				native: "🌮"
			}
		],
		version: 1
	},
	burrito: {
		id: "burrito",
		name: "Burrito",
		keywords: [
			"food",
			"mexican"
		],
		skins: [
			{
				unified: "1f32f",
				native: "🌯"
			}
		],
		version: 1
	},
	tamale: {
		id: "tamale",
		name: "Tamale",
		keywords: [
			"food",
			"masa"
		],
		skins: [
			{
				unified: "1fad4",
				native: "🫔"
			}
		],
		version: 13
	},
	stuffed_flatbread: {
		id: "stuffed_flatbread",
		name: "Stuffed Flatbread",
		keywords: [
			"food",
			"gyro",
			"mediterranean"
		],
		skins: [
			{
				unified: "1f959",
				native: "🥙"
			}
		],
		version: 3
	},
	falafel: {
		id: "falafel",
		name: "Falafel",
		keywords: [
			"food",
			"mediterranean"
		],
		skins: [
			{
				unified: "1f9c6",
				native: "🧆"
			}
		],
		version: 12
	},
	egg: {
		id: "egg",
		name: "Egg",
		keywords: [
			"food",
			"chicken",
			"breakfast"
		],
		skins: [
			{
				unified: "1f95a",
				native: "🥚"
			}
		],
		version: 3
	},
	fried_egg: {
		id: "fried_egg",
		name: "Cooking",
		keywords: [
			"fried",
			"egg",
			"food",
			"breakfast",
			"kitchen",
			"skillet"
		],
		skins: [
			{
				unified: "1f373",
				native: "🍳"
			}
		],
		version: 1
	},
	shallow_pan_of_food: {
		id: "shallow_pan_of_food",
		name: "Shallow Pan of Food",
		keywords: [
			"cooking",
			"casserole",
			"paella",
			"skillet"
		],
		skins: [
			{
				unified: "1f958",
				native: "🥘"
			}
		],
		version: 3
	},
	stew: {
		id: "stew",
		name: "Pot of Food",
		keywords: [
			"stew",
			"meat",
			"soup",
			"hot"
		],
		skins: [
			{
				unified: "1f372",
				native: "🍲"
			}
		],
		version: 1
	},
	fondue: {
		id: "fondue",
		name: "Fondue",
		keywords: [
			"cheese",
			"pot",
			"food"
		],
		skins: [
			{
				unified: "1fad5",
				native: "🫕"
			}
		],
		version: 13
	},
	bowl_with_spoon: {
		id: "bowl_with_spoon",
		name: "Bowl with Spoon",
		keywords: [
			"food",
			"breakfast",
			"cereal",
			"oatmeal",
			"porridge"
		],
		skins: [
			{
				unified: "1f963",
				native: "🥣"
			}
		],
		version: 5
	},
	green_salad: {
		id: "green_salad",
		name: "Green Salad",
		keywords: [
			"food",
			"healthy",
			"lettuce",
			"vegetable"
		],
		skins: [
			{
				unified: "1f957",
				native: "🥗"
			}
		],
		version: 3
	},
	popcorn: {
		id: "popcorn",
		name: "Popcorn",
		keywords: [
			"food",
			"movie",
			"theater",
			"films",
			"snack",
			"drama"
		],
		skins: [
			{
				unified: "1f37f",
				native: "🍿"
			}
		],
		version: 1
	},
	butter: {
		id: "butter",
		name: "Butter",
		keywords: [
			"food",
			"cook"
		],
		skins: [
			{
				unified: "1f9c8",
				native: "🧈"
			}
		],
		version: 12
	},
	salt: {
		id: "salt",
		name: "Salt",
		keywords: [
			"condiment",
			"shaker"
		],
		skins: [
			{
				unified: "1f9c2",
				native: "🧂"
			}
		],
		version: 11
	},
	canned_food: {
		id: "canned_food",
		name: "Canned Food",
		keywords: [
			"soup",
			"tomatoes"
		],
		skins: [
			{
				unified: "1f96b",
				native: "🥫"
			}
		],
		version: 5
	},
	bento: {
		id: "bento",
		name: "Bento Box",
		keywords: [
			"food",
			"japanese",
			"lunch"
		],
		skins: [
			{
				unified: "1f371",
				native: "🍱"
			}
		],
		version: 1
	},
	rice_cracker: {
		id: "rice_cracker",
		name: "Rice Cracker",
		keywords: [
			"food",
			"japanese",
			"snack"
		],
		skins: [
			{
				unified: "1f358",
				native: "🍘"
			}
		],
		version: 1
	},
	rice_ball: {
		id: "rice_ball",
		name: "Rice Ball",
		keywords: [
			"food",
			"japanese"
		],
		skins: [
			{
				unified: "1f359",
				native: "🍙"
			}
		],
		version: 1
	},
	rice: {
		id: "rice",
		name: "Cooked Rice",
		keywords: [
			"food",
			"asian"
		],
		skins: [
			{
				unified: "1f35a",
				native: "🍚"
			}
		],
		version: 1
	},
	curry: {
		id: "curry",
		name: "Curry Rice",
		keywords: [
			"food",
			"spicy",
			"hot",
			"indian"
		],
		skins: [
			{
				unified: "1f35b",
				native: "🍛"
			}
		],
		version: 1
	},
	ramen: {
		id: "ramen",
		name: "Steaming Bowl",
		keywords: [
			"ramen",
			"food",
			"japanese",
			"noodle",
			"chopsticks"
		],
		skins: [
			{
				unified: "1f35c",
				native: "🍜"
			}
		],
		version: 1
	},
	spaghetti: {
		id: "spaghetti",
		name: "Spaghetti",
		keywords: [
			"food",
			"italian",
			"pasta",
			"noodle"
		],
		skins: [
			{
				unified: "1f35d",
				native: "🍝"
			}
		],
		version: 1
	},
	sweet_potato: {
		id: "sweet_potato",
		name: "Roasted Sweet Potato",
		keywords: [
			"food",
			"nature",
			"plant"
		],
		skins: [
			{
				unified: "1f360",
				native: "🍠"
			}
		],
		version: 1
	},
	oden: {
		id: "oden",
		name: "Oden",
		keywords: [
			"food",
			"japanese"
		],
		skins: [
			{
				unified: "1f362",
				native: "🍢"
			}
		],
		version: 1
	},
	sushi: {
		id: "sushi",
		name: "Sushi",
		keywords: [
			"food",
			"fish",
			"japanese",
			"rice"
		],
		skins: [
			{
				unified: "1f363",
				native: "🍣"
			}
		],
		version: 1
	},
	fried_shrimp: {
		id: "fried_shrimp",
		name: "Fried Shrimp",
		keywords: [
			"food",
			"animal",
			"appetizer",
			"summer"
		],
		skins: [
			{
				unified: "1f364",
				native: "🍤"
			}
		],
		version: 1
	},
	fish_cake: {
		id: "fish_cake",
		name: "Fish Cake with Swirl",
		keywords: [
			"food",
			"japan",
			"sea",
			"beach",
			"narutomaki",
			"pink",
			"kamaboko",
			"surimi",
			"ramen"
		],
		skins: [
			{
				unified: "1f365",
				native: "🍥"
			}
		],
		version: 1
	},
	moon_cake: {
		id: "moon_cake",
		name: "Moon Cake",
		keywords: [
			"food",
			"autumn",
			"dessert"
		],
		skins: [
			{
				unified: "1f96e",
				native: "🥮"
			}
		],
		version: 11
	},
	dango: {
		id: "dango",
		name: "Dango",
		keywords: [
			"food",
			"dessert",
			"sweet",
			"japanese",
			"barbecue",
			"meat"
		],
		skins: [
			{
				unified: "1f361",
				native: "🍡"
			}
		],
		version: 1
	},
	dumpling: {
		id: "dumpling",
		name: "Dumpling",
		keywords: [
			"food",
			"empanada",
			"pierogi",
			"potsticker",
			"gyoza"
		],
		skins: [
			{
				unified: "1f95f",
				native: "🥟"
			}
		],
		version: 5
	},
	fortune_cookie: {
		id: "fortune_cookie",
		name: "Fortune Cookie",
		keywords: [
			"food",
			"prophecy",
			"dessert"
		],
		skins: [
			{
				unified: "1f960",
				native: "🥠"
			}
		],
		version: 5
	},
	takeout_box: {
		id: "takeout_box",
		name: "Takeout Box",
		keywords: [
			"food",
			"leftovers"
		],
		skins: [
			{
				unified: "1f961",
				native: "🥡"
			}
		],
		version: 5
	},
	crab: {
		id: "crab",
		name: "Crab",
		keywords: [
			"animal",
			"crustacean"
		],
		skins: [
			{
				unified: "1f980",
				native: "🦀"
			}
		],
		version: 1
	},
	lobster: {
		id: "lobster",
		name: "Lobster",
		keywords: [
			"animal",
			"nature",
			"bisque",
			"claws",
			"seafood"
		],
		skins: [
			{
				unified: "1f99e",
				native: "🦞"
			}
		],
		version: 11
	},
	shrimp: {
		id: "shrimp",
		name: "Shrimp",
		keywords: [
			"animal",
			"ocean",
			"nature",
			"seafood"
		],
		skins: [
			{
				unified: "1f990",
				native: "🦐"
			}
		],
		version: 3
	},
	squid: {
		id: "squid",
		name: "Squid",
		keywords: [
			"animal",
			"nature",
			"ocean",
			"sea"
		],
		skins: [
			{
				unified: "1f991",
				native: "🦑"
			}
		],
		version: 3
	},
	oyster: {
		id: "oyster",
		name: "Oyster",
		keywords: [
			"food"
		],
		skins: [
			{
				unified: "1f9aa",
				native: "🦪"
			}
		],
		version: 12
	},
	icecream: {
		id: "icecream",
		name: "Soft Ice Cream",
		keywords: [
			"icecream",
			"food",
			"hot",
			"dessert",
			"summer"
		],
		skins: [
			{
				unified: "1f366",
				native: "🍦"
			}
		],
		version: 1
	},
	shaved_ice: {
		id: "shaved_ice",
		name: "Shaved Ice",
		keywords: [
			"hot",
			"dessert",
			"summer"
		],
		skins: [
			{
				unified: "1f367",
				native: "🍧"
			}
		],
		version: 1
	},
	ice_cream: {
		id: "ice_cream",
		name: "Ice Cream",
		keywords: [
			"food",
			"hot",
			"dessert"
		],
		skins: [
			{
				unified: "1f368",
				native: "🍨"
			}
		],
		version: 1
	},
	doughnut: {
		id: "doughnut",
		name: "Doughnut",
		keywords: [
			"food",
			"dessert",
			"snack",
			"sweet",
			"donut"
		],
		skins: [
			{
				unified: "1f369",
				native: "🍩"
			}
		],
		version: 1
	},
	cookie: {
		id: "cookie",
		name: "Cookie",
		keywords: [
			"food",
			"snack",
			"oreo",
			"chocolate",
			"sweet",
			"dessert"
		],
		skins: [
			{
				unified: "1f36a",
				native: "🍪"
			}
		],
		version: 1
	},
	birthday: {
		id: "birthday",
		name: "Birthday Cake",
		keywords: [
			"food",
			"dessert"
		],
		skins: [
			{
				unified: "1f382",
				native: "🎂"
			}
		],
		version: 1
	},
	cake: {
		id: "cake",
		name: "Shortcake",
		keywords: [
			"cake",
			"food",
			"dessert"
		],
		skins: [
			{
				unified: "1f370",
				native: "🍰"
			}
		],
		version: 1
	},
	cupcake: {
		id: "cupcake",
		name: "Cupcake",
		keywords: [
			"food",
			"dessert",
			"bakery",
			"sweet"
		],
		skins: [
			{
				unified: "1f9c1",
				native: "🧁"
			}
		],
		version: 11
	},
	pie: {
		id: "pie",
		name: "Pie",
		keywords: [
			"food",
			"dessert",
			"pastry"
		],
		skins: [
			{
				unified: "1f967",
				native: "🥧"
			}
		],
		version: 5
	},
	chocolate_bar: {
		id: "chocolate_bar",
		name: "Chocolate Bar",
		keywords: [
			"food",
			"snack",
			"dessert",
			"sweet"
		],
		skins: [
			{
				unified: "1f36b",
				native: "🍫"
			}
		],
		version: 1
	},
	candy: {
		id: "candy",
		name: "Candy",
		keywords: [
			"snack",
			"dessert",
			"sweet",
			"lolly"
		],
		skins: [
			{
				unified: "1f36c",
				native: "🍬"
			}
		],
		version: 1
	},
	lollipop: {
		id: "lollipop",
		name: "Lollipop",
		keywords: [
			"food",
			"snack",
			"candy",
			"sweet"
		],
		skins: [
			{
				unified: "1f36d",
				native: "🍭"
			}
		],
		version: 1
	},
	custard: {
		id: "custard",
		name: "Custard",
		keywords: [
			"dessert",
			"food"
		],
		skins: [
			{
				unified: "1f36e",
				native: "🍮"
			}
		],
		version: 1
	},
	honey_pot: {
		id: "honey_pot",
		name: "Honey Pot",
		keywords: [
			"bees",
			"sweet",
			"kitchen"
		],
		skins: [
			{
				unified: "1f36f",
				native: "🍯"
			}
		],
		version: 1
	},
	baby_bottle: {
		id: "baby_bottle",
		name: "Baby Bottle",
		keywords: [
			"food",
			"container",
			"milk"
		],
		skins: [
			{
				unified: "1f37c",
				native: "🍼"
			}
		],
		version: 1
	},
	glass_of_milk: {
		id: "glass_of_milk",
		name: "Glass of Milk",
		keywords: [
			"beverage",
			"drink",
			"cow"
		],
		skins: [
			{
				unified: "1f95b",
				native: "🥛"
			}
		],
		version: 3
	},
	coffee: {
		id: "coffee",
		name: "Hot Beverage",
		keywords: [
			"coffee",
			"caffeine",
			"latte",
			"espresso",
			"mug"
		],
		skins: [
			{
				unified: "2615",
				native: "☕"
			}
		],
		version: 1
	},
	teapot: {
		id: "teapot",
		name: "Teapot",
		keywords: [
			"drink",
			"hot"
		],
		skins: [
			{
				unified: "1fad6",
				native: "🫖"
			}
		],
		version: 13
	},
	tea: {
		id: "tea",
		name: "Teacup Without Handle",
		keywords: [
			"tea",
			"drink",
			"bowl",
			"breakfast",
			"green",
			"british"
		],
		skins: [
			{
				unified: "1f375",
				native: "🍵"
			}
		],
		version: 1
	},
	sake: {
		id: "sake",
		name: "Sake",
		keywords: [
			"wine",
			"drink",
			"drunk",
			"beverage",
			"japanese",
			"alcohol",
			"booze"
		],
		skins: [
			{
				unified: "1f376",
				native: "🍶"
			}
		],
		version: 1
	},
	champagne: {
		id: "champagne",
		name: "Bottle with Popping Cork",
		keywords: [
			"champagne",
			"drink",
			"wine",
			"celebration"
		],
		skins: [
			{
				unified: "1f37e",
				native: "🍾"
			}
		],
		version: 1
	},
	wine_glass: {
		id: "wine_glass",
		name: "Wine Glass",
		keywords: [
			"drink",
			"beverage",
			"drunk",
			"alcohol",
			"booze"
		],
		skins: [
			{
				unified: "1f377",
				native: "🍷"
			}
		],
		version: 1
	},
	cocktail: {
		id: "cocktail",
		name: "Cocktail Glass",
		keywords: [
			"drink",
			"drunk",
			"alcohol",
			"beverage",
			"booze",
			"mojito"
		],
		skins: [
			{
				unified: "1f378",
				native: "🍸"
			}
		],
		version: 1
	},
	tropical_drink: {
		id: "tropical_drink",
		name: "Tropical Drink",
		keywords: [
			"beverage",
			"cocktail",
			"summer",
			"beach",
			"alcohol",
			"booze",
			"mojito"
		],
		skins: [
			{
				unified: "1f379",
				native: "🍹"
			}
		],
		version: 1
	},
	beer: {
		id: "beer",
		name: "Beer Mug",
		keywords: [
			"relax",
			"beverage",
			"drink",
			"drunk",
			"party",
			"pub",
			"summer",
			"alcohol",
			"booze"
		],
		skins: [
			{
				unified: "1f37a",
				native: "🍺"
			}
		],
		version: 1
	},
	beers: {
		id: "beers",
		name: "Clinking Beer Mugs",
		keywords: [
			"beers",
			"relax",
			"beverage",
			"drink",
			"drunk",
			"party",
			"pub",
			"summer",
			"alcohol",
			"booze"
		],
		skins: [
			{
				unified: "1f37b",
				native: "🍻"
			}
		],
		version: 1
	},
	clinking_glasses: {
		id: "clinking_glasses",
		name: "Clinking Glasses",
		keywords: [
			"beverage",
			"drink",
			"party",
			"alcohol",
			"celebrate",
			"cheers",
			"wine",
			"champagne",
			"toast"
		],
		skins: [
			{
				unified: "1f942",
				native: "🥂"
			}
		],
		version: 3
	},
	tumbler_glass: {
		id: "tumbler_glass",
		name: "Tumbler Glass",
		keywords: [
			"drink",
			"beverage",
			"drunk",
			"alcohol",
			"liquor",
			"booze",
			"bourbon",
			"scotch",
			"whisky",
			"shot"
		],
		skins: [
			{
				unified: "1f943",
				native: "🥃"
			}
		],
		version: 3
	},
	pouring_liquid: {
		id: "pouring_liquid",
		name: "Pouring Liquid",
		keywords: [
			"cup",
			"water"
		],
		skins: [
			{
				unified: "1fad7",
				native: "🫗"
			}
		],
		version: 14
	},
	cup_with_straw: {
		id: "cup_with_straw",
		name: "Cup with Straw",
		keywords: [
			"drink",
			"soda"
		],
		skins: [
			{
				unified: "1f964",
				native: "🥤"
			}
		],
		version: 5
	},
	bubble_tea: {
		id: "bubble_tea",
		name: "Bubble Tea",
		keywords: [
			"taiwan",
			"boba",
			"milk",
			"straw"
		],
		skins: [
			{
				unified: "1f9cb",
				native: "🧋"
			}
		],
		version: 13
	},
	beverage_box: {
		id: "beverage_box",
		name: "Beverage Box",
		keywords: [
			"drink"
		],
		skins: [
			{
				unified: "1f9c3",
				native: "🧃"
			}
		],
		version: 12
	},
	mate_drink: {
		id: "mate_drink",
		name: "Mate",
		keywords: [
			"drink",
			"tea",
			"beverage"
		],
		skins: [
			{
				unified: "1f9c9",
				native: "🧉"
			}
		],
		version: 12
	},
	ice_cube: {
		id: "ice_cube",
		name: "Ice",
		keywords: [
			"cube",
			"water",
			"cold"
		],
		skins: [
			{
				unified: "1f9ca",
				native: "🧊"
			}
		],
		version: 12
	},
	chopsticks: {
		id: "chopsticks",
		name: "Chopsticks",
		keywords: [
			"food"
		],
		skins: [
			{
				unified: "1f962",
				native: "🥢"
			}
		],
		version: 5
	},
	knife_fork_plate: {
		id: "knife_fork_plate",
		name: "Fork and Knife with Plate",
		keywords: [
			"food",
			"eat",
			"meal",
			"lunch",
			"dinner",
			"restaurant"
		],
		skins: [
			{
				unified: "1f37d-fe0f",
				native: "🍽️"
			}
		],
		version: 1
	},
	fork_and_knife: {
		id: "fork_and_knife",
		name: "Fork and Knife",
		keywords: [
			"cutlery",
			"kitchen"
		],
		skins: [
			{
				unified: "1f374",
				native: "🍴"
			}
		],
		version: 1
	},
	spoon: {
		id: "spoon",
		name: "Spoon",
		keywords: [
			"cutlery",
			"kitchen",
			"tableware"
		],
		skins: [
			{
				unified: "1f944",
				native: "🥄"
			}
		],
		version: 3
	},
	hocho: {
		id: "hocho",
		name: "Hocho",
		keywords: [
			"knife",
			"kitchen",
			"blade",
			"cutlery",
			"weapon"
		],
		skins: [
			{
				unified: "1f52a",
				native: "🔪"
			}
		],
		version: 1
	},
	jar: {
		id: "jar",
		name: "Jar",
		keywords: [
			"container",
			"sauce"
		],
		skins: [
			{
				unified: "1fad9",
				native: "🫙"
			}
		],
		version: 14
	},
	amphora: {
		id: "amphora",
		name: "Amphora",
		keywords: [
			"vase",
			"jar"
		],
		skins: [
			{
				unified: "1f3fa",
				native: "🏺"
			}
		],
		version: 1
	},
	earth_africa: {
		id: "earth_africa",
		name: "Earth Globe Europe-Africa",
		keywords: [
			"africa",
			"showing",
			"europe",
			"world",
			"international"
		],
		skins: [
			{
				unified: "1f30d",
				native: "🌍"
			}
		],
		version: 1
	},
	earth_americas: {
		id: "earth_americas",
		name: "Earth Globe Americas",
		keywords: [
			"showing",
			"world",
			"USA",
			"international"
		],
		skins: [
			{
				unified: "1f30e",
				native: "🌎"
			}
		],
		version: 1
	},
	earth_asia: {
		id: "earth_asia",
		name: "Earth Globe Asia-Australia",
		keywords: [
			"asia",
			"showing",
			"australia",
			"world",
			"east",
			"international"
		],
		skins: [
			{
				unified: "1f30f",
				native: "🌏"
			}
		],
		version: 1
	},
	globe_with_meridians: {
		id: "globe_with_meridians",
		name: "Globe with Meridians",
		keywords: [
			"earth",
			"international",
			"world",
			"internet",
			"interweb",
			"i18n"
		],
		skins: [
			{
				unified: "1f310",
				native: "🌐"
			}
		],
		version: 1
	},
	world_map: {
		id: "world_map",
		name: "World Map",
		keywords: [
			"location",
			"direction"
		],
		skins: [
			{
				unified: "1f5fa-fe0f",
				native: "🗺️"
			}
		],
		version: 1
	},
	japan: {
		id: "japan",
		name: "Map of Japan",
		keywords: [
			"nation",
			"country",
			"japanese",
			"asia"
		],
		skins: [
			{
				unified: "1f5fe",
				native: "🗾"
			}
		],
		version: 1
	},
	compass: {
		id: "compass",
		name: "Compass",
		keywords: [
			"magnetic",
			"navigation",
			"orienteering"
		],
		skins: [
			{
				unified: "1f9ed",
				native: "🧭"
			}
		],
		version: 11
	},
	snow_capped_mountain: {
		id: "snow_capped_mountain",
		name: "Snow-Capped Mountain",
		keywords: [
			"snow",
			"capped",
			"photo",
			"nature",
			"environment",
			"winter",
			"cold"
		],
		skins: [
			{
				unified: "1f3d4-fe0f",
				native: "🏔️"
			}
		],
		version: 1
	},
	mountain: {
		id: "mountain",
		name: "Mountain",
		keywords: [
			"photo",
			"nature",
			"environment"
		],
		skins: [
			{
				unified: "26f0-fe0f",
				native: "⛰️"
			}
		],
		version: 1
	},
	volcano: {
		id: "volcano",
		name: "Volcano",
		keywords: [
			"photo",
			"nature",
			"disaster"
		],
		skins: [
			{
				unified: "1f30b",
				native: "🌋"
			}
		],
		version: 1
	},
	mount_fuji: {
		id: "mount_fuji",
		name: "Mount Fuji",
		keywords: [
			"photo",
			"mountain",
			"nature",
			"japanese"
		],
		skins: [
			{
				unified: "1f5fb",
				native: "🗻"
			}
		],
		version: 1
	},
	camping: {
		id: "camping",
		name: "Camping",
		keywords: [
			"photo",
			"outdoors",
			"tent"
		],
		skins: [
			{
				unified: "1f3d5-fe0f",
				native: "🏕️"
			}
		],
		version: 1
	},
	beach_with_umbrella: {
		id: "beach_with_umbrella",
		name: "Beach with Umbrella",
		keywords: [
			"weather",
			"summer",
			"sunny",
			"sand",
			"mojito"
		],
		skins: [
			{
				unified: "1f3d6-fe0f",
				native: "🏖️"
			}
		],
		version: 1
	},
	desert: {
		id: "desert",
		name: "Desert",
		keywords: [
			"photo",
			"warm",
			"saharah"
		],
		skins: [
			{
				unified: "1f3dc-fe0f",
				native: "🏜️"
			}
		],
		version: 1
	},
	desert_island: {
		id: "desert_island",
		name: "Desert Island",
		keywords: [
			"photo",
			"tropical",
			"mojito"
		],
		skins: [
			{
				unified: "1f3dd-fe0f",
				native: "🏝️"
			}
		],
		version: 1
	},
	national_park: {
		id: "national_park",
		name: "National Park",
		keywords: [
			"photo",
			"environment",
			"nature"
		],
		skins: [
			{
				unified: "1f3de-fe0f",
				native: "🏞️"
			}
		],
		version: 1
	},
	stadium: {
		id: "stadium",
		name: "Stadium",
		keywords: [
			"photo",
			"place",
			"sports",
			"concert",
			"venue"
		],
		skins: [
			{
				unified: "1f3df-fe0f",
				native: "🏟️"
			}
		],
		version: 1
	},
	classical_building: {
		id: "classical_building",
		name: "Classical Building",
		keywords: [
			"art",
			"culture",
			"history"
		],
		skins: [
			{
				unified: "1f3db-fe0f",
				native: "🏛️"
			}
		],
		version: 1
	},
	building_construction: {
		id: "building_construction",
		name: "Building Construction",
		keywords: [
			"wip",
			"working",
			"progress"
		],
		skins: [
			{
				unified: "1f3d7-fe0f",
				native: "🏗️"
			}
		],
		version: 1
	},
	bricks: {
		id: "bricks",
		name: "Brick",
		keywords: [
			"bricks"
		],
		skins: [
			{
				unified: "1f9f1",
				native: "🧱"
			}
		],
		version: 11
	},
	rock: {
		id: "rock",
		name: "Rock",
		keywords: [
			"stone"
		],
		skins: [
			{
				unified: "1faa8",
				native: "🪨"
			}
		],
		version: 13
	},
	wood: {
		id: "wood",
		name: "Wood",
		keywords: [
			"nature",
			"timber",
			"trunk"
		],
		skins: [
			{
				unified: "1fab5",
				native: "🪵"
			}
		],
		version: 13
	},
	hut: {
		id: "hut",
		name: "Hut",
		keywords: [
			"house",
			"structure"
		],
		skins: [
			{
				unified: "1f6d6",
				native: "🛖"
			}
		],
		version: 13
	},
	house_buildings: {
		id: "house_buildings",
		name: "Houses",
		keywords: [
			"house",
			"buildings",
			"photo"
		],
		skins: [
			{
				unified: "1f3d8-fe0f",
				native: "🏘️"
			}
		],
		version: 1
	},
	derelict_house_building: {
		id: "derelict_house_building",
		name: "Derelict House",
		keywords: [
			"building",
			"abandon",
			"evict",
			"broken"
		],
		skins: [
			{
				unified: "1f3da-fe0f",
				native: "🏚️"
			}
		],
		version: 1
	},
	house: {
		id: "house",
		name: "House",
		keywords: [
			"building",
			"home"
		],
		skins: [
			{
				unified: "1f3e0",
				native: "🏠"
			}
		],
		version: 1
	},
	house_with_garden: {
		id: "house_with_garden",
		name: "House with Garden",
		keywords: [
			"home",
			"plant",
			"nature"
		],
		skins: [
			{
				unified: "1f3e1",
				native: "🏡"
			}
		],
		version: 1
	},
	office: {
		id: "office",
		name: "Office Building",
		keywords: [
			"bureau",
			"work"
		],
		skins: [
			{
				unified: "1f3e2",
				native: "🏢"
			}
		],
		version: 1
	},
	post_office: {
		id: "post_office",
		name: "Japanese Post Office",
		keywords: [
			"building",
			"envelope",
			"communication"
		],
		skins: [
			{
				unified: "1f3e3",
				native: "🏣"
			}
		],
		version: 1
	},
	european_post_office: {
		id: "european_post_office",
		name: "Post Office",
		keywords: [
			"european",
			"building",
			"email"
		],
		skins: [
			{
				unified: "1f3e4",
				native: "🏤"
			}
		],
		version: 1
	},
	hospital: {
		id: "hospital",
		name: "Hospital",
		keywords: [
			"building",
			"health",
			"surgery",
			"doctor"
		],
		skins: [
			{
				unified: "1f3e5",
				native: "🏥"
			}
		],
		version: 1
	},
	bank: {
		id: "bank",
		name: "Bank",
		keywords: [
			"building",
			"money",
			"sales",
			"cash",
			"business",
			"enterprise"
		],
		skins: [
			{
				unified: "1f3e6",
				native: "🏦"
			}
		],
		version: 1
	},
	hotel: {
		id: "hotel",
		name: "Hotel",
		keywords: [
			"building",
			"accomodation",
			"checkin"
		],
		skins: [
			{
				unified: "1f3e8",
				native: "🏨"
			}
		],
		version: 1
	},
	love_hotel: {
		id: "love_hotel",
		name: "Love Hotel",
		keywords: [
			"like",
			"affection",
			"dating"
		],
		skins: [
			{
				unified: "1f3e9",
				native: "🏩"
			}
		],
		version: 1
	},
	convenience_store: {
		id: "convenience_store",
		name: "Convenience Store",
		keywords: [
			"building",
			"shopping",
			"groceries"
		],
		skins: [
			{
				unified: "1f3ea",
				native: "🏪"
			}
		],
		version: 1
	},
	school: {
		id: "school",
		name: "School",
		keywords: [
			"building",
			"student",
			"education",
			"learn",
			"teach"
		],
		skins: [
			{
				unified: "1f3eb",
				native: "🏫"
			}
		],
		version: 1
	},
	department_store: {
		id: "department_store",
		name: "Department Store",
		keywords: [
			"building",
			"shopping",
			"mall"
		],
		skins: [
			{
				unified: "1f3ec",
				native: "🏬"
			}
		],
		version: 1
	},
	factory: {
		id: "factory",
		name: "Factory",
		keywords: [
			"building",
			"industry",
			"pollution",
			"smoke"
		],
		skins: [
			{
				unified: "1f3ed",
				native: "🏭"
			}
		],
		version: 1
	},
	japanese_castle: {
		id: "japanese_castle",
		name: "Japanese Castle",
		keywords: [
			"photo",
			"building"
		],
		skins: [
			{
				unified: "1f3ef",
				native: "🏯"
			}
		],
		version: 1
	},
	european_castle: {
		id: "european_castle",
		name: "Castle",
		keywords: [
			"european",
			"building",
			"royalty",
			"history"
		],
		skins: [
			{
				unified: "1f3f0",
				native: "🏰"
			}
		],
		version: 1
	},
	wedding: {
		id: "wedding",
		name: "Wedding",
		keywords: [
			"love",
			"like",
			"affection",
			"couple",
			"marriage",
			"bride",
			"groom"
		],
		skins: [
			{
				unified: "1f492",
				native: "💒"
			}
		],
		version: 1
	},
	tokyo_tower: {
		id: "tokyo_tower",
		name: "Tokyo Tower",
		keywords: [
			"photo",
			"japanese"
		],
		skins: [
			{
				unified: "1f5fc",
				native: "🗼"
			}
		],
		version: 1
	},
	statue_of_liberty: {
		id: "statue_of_liberty",
		name: "Statue of Liberty",
		keywords: [
			"american",
			"newyork"
		],
		skins: [
			{
				unified: "1f5fd",
				native: "🗽"
			}
		],
		version: 1
	},
	church: {
		id: "church",
		name: "Church",
		keywords: [
			"building",
			"religion",
			"christ"
		],
		skins: [
			{
				unified: "26ea",
				native: "⛪"
			}
		],
		version: 1
	},
	mosque: {
		id: "mosque",
		name: "Mosque",
		keywords: [
			"islam",
			"worship",
			"minaret"
		],
		skins: [
			{
				unified: "1f54c",
				native: "🕌"
			}
		],
		version: 1
	},
	hindu_temple: {
		id: "hindu_temple",
		name: "Hindu Temple",
		keywords: [
			"religion"
		],
		skins: [
			{
				unified: "1f6d5",
				native: "🛕"
			}
		],
		version: 12
	},
	synagogue: {
		id: "synagogue",
		name: "Synagogue",
		keywords: [
			"judaism",
			"worship",
			"temple",
			"jewish"
		],
		skins: [
			{
				unified: "1f54d",
				native: "🕍"
			}
		],
		version: 1
	},
	shinto_shrine: {
		id: "shinto_shrine",
		name: "Shinto Shrine",
		keywords: [
			"temple",
			"japan",
			"kyoto"
		],
		skins: [
			{
				unified: "26e9-fe0f",
				native: "⛩️"
			}
		],
		version: 1
	},
	kaaba: {
		id: "kaaba",
		name: "Kaaba",
		keywords: [
			"mecca",
			"mosque",
			"islam"
		],
		skins: [
			{
				unified: "1f54b",
				native: "🕋"
			}
		],
		version: 1
	},
	fountain: {
		id: "fountain",
		name: "Fountain",
		keywords: [
			"photo",
			"summer",
			"water",
			"fresh"
		],
		skins: [
			{
				unified: "26f2",
				native: "⛲"
			}
		],
		version: 1
	},
	tent: {
		id: "tent",
		name: "Tent",
		keywords: [
			"photo",
			"camping",
			"outdoors"
		],
		skins: [
			{
				unified: "26fa",
				native: "⛺"
			}
		],
		version: 1
	},
	foggy: {
		id: "foggy",
		name: "Foggy",
		keywords: [
			"photo",
			"mountain"
		],
		skins: [
			{
				unified: "1f301",
				native: "🌁"
			}
		],
		version: 1
	},
	night_with_stars: {
		id: "night_with_stars",
		name: "Night with Stars",
		keywords: [
			"evening",
			"city",
			"downtown"
		],
		skins: [
			{
				unified: "1f303",
				native: "🌃"
			}
		],
		version: 1
	},
	cityscape: {
		id: "cityscape",
		name: "Cityscape",
		keywords: [
			"photo",
			"night",
			"life",
			"urban"
		],
		skins: [
			{
				unified: "1f3d9-fe0f",
				native: "🏙️"
			}
		],
		version: 1
	},
	sunrise_over_mountains: {
		id: "sunrise_over_mountains",
		name: "Sunrise over Mountains",
		keywords: [
			"view",
			"vacation",
			"photo"
		],
		skins: [
			{
				unified: "1f304",
				native: "🌄"
			}
		],
		version: 1
	},
	sunrise: {
		id: "sunrise",
		name: "Sunrise",
		keywords: [
			"morning",
			"view",
			"vacation",
			"photo"
		],
		skins: [
			{
				unified: "1f305",
				native: "🌅"
			}
		],
		version: 1
	},
	city_sunset: {
		id: "city_sunset",
		name: "Cityscape at Dusk",
		keywords: [
			"city",
			"sunset",
			"photo",
			"evening",
			"sky",
			"buildings"
		],
		skins: [
			{
				unified: "1f306",
				native: "🌆"
			}
		],
		version: 1
	},
	city_sunrise: {
		id: "city_sunrise",
		name: "Sunset",
		keywords: [
			"city",
			"sunrise",
			"photo",
			"good",
			"morning",
			"dawn"
		],
		skins: [
			{
				unified: "1f307",
				native: "🌇"
			}
		],
		version: 1
	},
	bridge_at_night: {
		id: "bridge_at_night",
		name: "Bridge at Night",
		keywords: [
			"photo",
			"sanfrancisco"
		],
		skins: [
			{
				unified: "1f309",
				native: "🌉"
			}
		],
		version: 1
	},
	hotsprings: {
		id: "hotsprings",
		name: "Hot Springs",
		keywords: [
			"hotsprings",
			"bath",
			"warm",
			"relax"
		],
		skins: [
			{
				unified: "2668-fe0f",
				native: "♨️"
			}
		],
		version: 1
	},
	carousel_horse: {
		id: "carousel_horse",
		name: "Carousel Horse",
		keywords: [
			"photo",
			"carnival"
		],
		skins: [
			{
				unified: "1f3a0",
				native: "🎠"
			}
		],
		version: 1
	},
	playground_slide: {
		id: "playground_slide",
		name: "Playground Slide",
		keywords: [
			"fun",
			"park"
		],
		skins: [
			{
				unified: "1f6dd",
				native: "🛝"
			}
		],
		version: 14
	},
	ferris_wheel: {
		id: "ferris_wheel",
		name: "Ferris Wheel",
		keywords: [
			"photo",
			"carnival",
			"londoneye"
		],
		skins: [
			{
				unified: "1f3a1",
				native: "🎡"
			}
		],
		version: 1
	},
	roller_coaster: {
		id: "roller_coaster",
		name: "Roller Coaster",
		keywords: [
			"carnival",
			"playground",
			"photo",
			"fun"
		],
		skins: [
			{
				unified: "1f3a2",
				native: "🎢"
			}
		],
		version: 1
	},
	barber: {
		id: "barber",
		name: "Barber Pole",
		keywords: [
			"hair",
			"salon",
			"style"
		],
		skins: [
			{
				unified: "1f488",
				native: "💈"
			}
		],
		version: 1
	},
	circus_tent: {
		id: "circus_tent",
		name: "Circus Tent",
		keywords: [
			"festival",
			"carnival",
			"party"
		],
		skins: [
			{
				unified: "1f3aa",
				native: "🎪"
			}
		],
		version: 1
	},
	steam_locomotive: {
		id: "steam_locomotive",
		name: "Locomotive",
		keywords: [
			"steam",
			"transportation",
			"vehicle",
			"train"
		],
		skins: [
			{
				unified: "1f682",
				native: "🚂"
			}
		],
		version: 1
	},
	railway_car: {
		id: "railway_car",
		name: "Railway Car",
		keywords: [
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f683",
				native: "🚃"
			}
		],
		version: 1
	},
	bullettrain_side: {
		id: "bullettrain_side",
		name: "High-Speed Train",
		keywords: [
			"bullettrain",
			"side",
			"high",
			"speed",
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f684",
				native: "🚄"
			}
		],
		version: 1
	},
	bullettrain_front: {
		id: "bullettrain_front",
		name: "Bullet Train",
		keywords: [
			"bullettrain",
			"front",
			"transportation",
			"vehicle",
			"speed",
			"fast",
			"public",
			"travel"
		],
		skins: [
			{
				unified: "1f685",
				native: "🚅"
			}
		],
		version: 1
	},
	train2: {
		id: "train2",
		name: "Train",
		keywords: [
			"train2",
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f686",
				native: "🚆"
			}
		],
		version: 1
	},
	metro: {
		id: "metro",
		name: "Metro",
		keywords: [
			"transportation",
			"blue",
			"square",
			"mrt",
			"underground",
			"tube"
		],
		skins: [
			{
				unified: "1f687",
				native: "🚇"
			}
		],
		version: 1
	},
	light_rail: {
		id: "light_rail",
		name: "Light Rail",
		keywords: [
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f688",
				native: "🚈"
			}
		],
		version: 1
	},
	station: {
		id: "station",
		name: "Station",
		keywords: [
			"transportation",
			"vehicle",
			"public"
		],
		skins: [
			{
				unified: "1f689",
				native: "🚉"
			}
		],
		version: 1
	},
	tram: {
		id: "tram",
		name: "Tram",
		keywords: [
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f68a",
				native: "🚊"
			}
		],
		version: 1
	},
	monorail: {
		id: "monorail",
		name: "Monorail",
		keywords: [
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f69d",
				native: "🚝"
			}
		],
		version: 1
	},
	mountain_railway: {
		id: "mountain_railway",
		name: "Mountain Railway",
		keywords: [
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f69e",
				native: "🚞"
			}
		],
		version: 1
	},
	train: {
		id: "train",
		name: "Tram Car",
		keywords: [
			"train",
			"transportation",
			"vehicle",
			"carriage",
			"public",
			"travel"
		],
		skins: [
			{
				unified: "1f68b",
				native: "🚋"
			}
		],
		version: 1
	},
	bus: {
		id: "bus",
		name: "Bus",
		keywords: [
			"car",
			"vehicle",
			"transportation"
		],
		skins: [
			{
				unified: "1f68c",
				native: "🚌"
			}
		],
		version: 1
	},
	oncoming_bus: {
		id: "oncoming_bus",
		name: "Oncoming Bus",
		keywords: [
			"vehicle",
			"transportation"
		],
		skins: [
			{
				unified: "1f68d",
				native: "🚍"
			}
		],
		version: 1
	},
	trolleybus: {
		id: "trolleybus",
		name: "Trolleybus",
		keywords: [
			"bart",
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f68e",
				native: "🚎"
			}
		],
		version: 1
	},
	minibus: {
		id: "minibus",
		name: "Minibus",
		keywords: [
			"vehicle",
			"car",
			"transportation"
		],
		skins: [
			{
				unified: "1f690",
				native: "🚐"
			}
		],
		version: 1
	},
	ambulance: {
		id: "ambulance",
		name: "Ambulance",
		keywords: [
			"health",
			"911",
			"hospital"
		],
		skins: [
			{
				unified: "1f691",
				native: "🚑"
			}
		],
		version: 1
	},
	fire_engine: {
		id: "fire_engine",
		name: "Fire Engine",
		keywords: [
			"transportation",
			"cars",
			"vehicle"
		],
		skins: [
			{
				unified: "1f692",
				native: "🚒"
			}
		],
		version: 1
	},
	police_car: {
		id: "police_car",
		name: "Police Car",
		keywords: [
			"vehicle",
			"cars",
			"transportation",
			"law",
			"legal",
			"enforcement"
		],
		skins: [
			{
				unified: "1f693",
				native: "🚓"
			}
		],
		version: 1
	},
	oncoming_police_car: {
		id: "oncoming_police_car",
		name: "Oncoming Police Car",
		keywords: [
			"vehicle",
			"law",
			"legal",
			"enforcement",
			"911"
		],
		skins: [
			{
				unified: "1f694",
				native: "🚔"
			}
		],
		version: 1
	},
	taxi: {
		id: "taxi",
		name: "Taxi",
		keywords: [
			"uber",
			"vehicle",
			"cars",
			"transportation"
		],
		skins: [
			{
				unified: "1f695",
				native: "🚕"
			}
		],
		version: 1
	},
	oncoming_taxi: {
		id: "oncoming_taxi",
		name: "Oncoming Taxi",
		keywords: [
			"vehicle",
			"cars",
			"uber"
		],
		skins: [
			{
				unified: "1f696",
				native: "🚖"
			}
		],
		version: 1
	},
	car: {
		id: "car",
		name: "Automobile",
		keywords: [
			"car",
			"red",
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f697",
				native: "🚗"
			}
		],
		version: 1
	},
	oncoming_automobile: {
		id: "oncoming_automobile",
		name: "Oncoming Automobile",
		keywords: [
			"car",
			"vehicle",
			"transportation"
		],
		skins: [
			{
				unified: "1f698",
				native: "🚘"
			}
		],
		version: 1
	},
	blue_car: {
		id: "blue_car",
		name: "Recreational Vehicle",
		keywords: [
			"blue",
			"car",
			"sport",
			"utility",
			"transportation"
		],
		skins: [
			{
				unified: "1f699",
				native: "🚙"
			}
		],
		version: 1
	},
	pickup_truck: {
		id: "pickup_truck",
		name: "Pickup Truck",
		keywords: [
			"car",
			"transportation"
		],
		skins: [
			{
				unified: "1f6fb",
				native: "🛻"
			}
		],
		version: 13
	},
	truck: {
		id: "truck",
		name: "Delivery Truck",
		keywords: [
			"cars",
			"transportation"
		],
		skins: [
			{
				unified: "1f69a",
				native: "🚚"
			}
		],
		version: 1
	},
	articulated_lorry: {
		id: "articulated_lorry",
		name: "Articulated Lorry",
		keywords: [
			"vehicle",
			"cars",
			"transportation",
			"express"
		],
		skins: [
			{
				unified: "1f69b",
				native: "🚛"
			}
		],
		version: 1
	},
	tractor: {
		id: "tractor",
		name: "Tractor",
		keywords: [
			"vehicle",
			"car",
			"farming",
			"agriculture"
		],
		skins: [
			{
				unified: "1f69c",
				native: "🚜"
			}
		],
		version: 1
	},
	racing_car: {
		id: "racing_car",
		name: "Racing Car",
		keywords: [
			"sports",
			"race",
			"fast",
			"formula",
			"f1"
		],
		skins: [
			{
				unified: "1f3ce-fe0f",
				native: "🏎️"
			}
		],
		version: 1
	},
	racing_motorcycle: {
		id: "racing_motorcycle",
		name: "Motorcycle",
		keywords: [
			"racing",
			"race",
			"sports",
			"fast"
		],
		skins: [
			{
				unified: "1f3cd-fe0f",
				native: "🏍️"
			}
		],
		version: 1
	},
	motor_scooter: {
		id: "motor_scooter",
		name: "Motor Scooter",
		keywords: [
			"vehicle",
			"vespa",
			"sasha"
		],
		skins: [
			{
				unified: "1f6f5",
				native: "🛵"
			}
		],
		version: 3
	},
	manual_wheelchair: {
		id: "manual_wheelchair",
		name: "Manual Wheelchair",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9bd",
				native: "🦽"
			}
		],
		version: 12
	},
	motorized_wheelchair: {
		id: "motorized_wheelchair",
		name: "Motorized Wheelchair",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9bc",
				native: "🦼"
			}
		],
		version: 12
	},
	auto_rickshaw: {
		id: "auto_rickshaw",
		name: "Auto Rickshaw",
		keywords: [
			"move",
			"transportation"
		],
		skins: [
			{
				unified: "1f6fa",
				native: "🛺"
			}
		],
		version: 12
	},
	bike: {
		id: "bike",
		name: "Bicycle",
		keywords: [
			"bike",
			"sports",
			"exercise",
			"hipster"
		],
		skins: [
			{
				unified: "1f6b2",
				native: "🚲"
			}
		],
		version: 1
	},
	scooter: {
		id: "scooter",
		name: "Scooter",
		keywords: [
			"kick",
			"vehicle",
			"razor"
		],
		skins: [
			{
				unified: "1f6f4",
				native: "🛴"
			}
		],
		version: 3
	},
	skateboard: {
		id: "skateboard",
		name: "Skateboard",
		keywords: [
			"board"
		],
		skins: [
			{
				unified: "1f6f9",
				native: "🛹"
			}
		],
		version: 11
	},
	roller_skate: {
		id: "roller_skate",
		name: "Roller Skate",
		keywords: [
			"footwear",
			"sports"
		],
		skins: [
			{
				unified: "1f6fc",
				native: "🛼"
			}
		],
		version: 13
	},
	busstop: {
		id: "busstop",
		name: "Bus Stop",
		keywords: [
			"busstop",
			"transportation",
			"wait"
		],
		skins: [
			{
				unified: "1f68f",
				native: "🚏"
			}
		],
		version: 1
	},
	motorway: {
		id: "motorway",
		name: "Motorway",
		keywords: [
			"road",
			"cupertino",
			"interstate",
			"highway"
		],
		skins: [
			{
				unified: "1f6e3-fe0f",
				native: "🛣️"
			}
		],
		version: 1
	},
	railway_track: {
		id: "railway_track",
		name: "Railway Track",
		keywords: [
			"train",
			"transportation"
		],
		skins: [
			{
				unified: "1f6e4-fe0f",
				native: "🛤️"
			}
		],
		version: 1
	},
	oil_drum: {
		id: "oil_drum",
		name: "Oil Drum",
		keywords: [
			"barrell"
		],
		skins: [
			{
				unified: "1f6e2-fe0f",
				native: "🛢️"
			}
		],
		version: 1
	},
	fuelpump: {
		id: "fuelpump",
		name: "Fuel Pump",
		keywords: [
			"fuelpump",
			"gas",
			"station",
			"petroleum"
		],
		skins: [
			{
				unified: "26fd",
				native: "⛽"
			}
		],
		version: 1
	},
	wheel: {
		id: "wheel",
		name: "Wheel",
		keywords: [
			"car",
			"transport"
		],
		skins: [
			{
				unified: "1f6de",
				native: "🛞"
			}
		],
		version: 14
	},
	rotating_light: {
		id: "rotating_light",
		name: "Police Car Light",
		keywords: [
			"rotating",
			"ambulance",
			"911",
			"emergency",
			"alert",
			"error",
			"pinged",
			"law",
			"legal"
		],
		skins: [
			{
				unified: "1f6a8",
				native: "🚨"
			}
		],
		version: 1
	},
	traffic_light: {
		id: "traffic_light",
		name: "Horizontal Traffic Light",
		keywords: [
			"transportation",
			"signal"
		],
		skins: [
			{
				unified: "1f6a5",
				native: "🚥"
			}
		],
		version: 1
	},
	vertical_traffic_light: {
		id: "vertical_traffic_light",
		name: "Vertical Traffic Light",
		keywords: [
			"transportation",
			"driving"
		],
		skins: [
			{
				unified: "1f6a6",
				native: "🚦"
			}
		],
		version: 1
	},
	octagonal_sign: {
		id: "octagonal_sign",
		name: "Stop Sign",
		keywords: [
			"octagonal"
		],
		skins: [
			{
				unified: "1f6d1",
				native: "🛑"
			}
		],
		version: 3
	},
	construction: {
		id: "construction",
		name: "Construction",
		keywords: [
			"wip",
			"progress",
			"caution",
			"warning"
		],
		skins: [
			{
				unified: "1f6a7",
				native: "🚧"
			}
		],
		version: 1
	},
	anchor: {
		id: "anchor",
		name: "Anchor",
		keywords: [
			"ship",
			"ferry",
			"sea",
			"boat"
		],
		skins: [
			{
				unified: "2693",
				native: "⚓"
			}
		],
		version: 1
	},
	ring_buoy: {
		id: "ring_buoy",
		name: "Ring Buoy",
		keywords: [
			"life",
			"saver",
			"preserver"
		],
		skins: [
			{
				unified: "1f6df",
				native: "🛟"
			}
		],
		version: 14
	},
	boat: {
		id: "boat",
		name: "Sailboat",
		keywords: [
			"boat",
			"ship",
			"summer",
			"transportation",
			"water",
			"sailing"
		],
		skins: [
			{
				unified: "26f5",
				native: "⛵"
			}
		],
		version: 1
	},
	canoe: {
		id: "canoe",
		name: "Canoe",
		keywords: [
			"boat",
			"paddle",
			"water",
			"ship"
		],
		skins: [
			{
				unified: "1f6f6",
				native: "🛶"
			}
		],
		version: 3
	},
	speedboat: {
		id: "speedboat",
		name: "Speedboat",
		keywords: [
			"ship",
			"transportation",
			"vehicle",
			"summer"
		],
		skins: [
			{
				unified: "1f6a4",
				native: "🚤"
			}
		],
		version: 1
	},
	passenger_ship: {
		id: "passenger_ship",
		name: "Passenger Ship",
		keywords: [
			"yacht",
			"cruise",
			"ferry"
		],
		skins: [
			{
				unified: "1f6f3-fe0f",
				native: "🛳️"
			}
		],
		version: 1
	},
	ferry: {
		id: "ferry",
		name: "Ferry",
		keywords: [
			"boat",
			"ship",
			"yacht"
		],
		skins: [
			{
				unified: "26f4-fe0f",
				native: "⛴️"
			}
		],
		version: 1
	},
	motor_boat: {
		id: "motor_boat",
		name: "Motor Boat",
		keywords: [
			"ship"
		],
		skins: [
			{
				unified: "1f6e5-fe0f",
				native: "🛥️"
			}
		],
		version: 1
	},
	ship: {
		id: "ship",
		name: "Ship",
		keywords: [
			"transportation",
			"titanic",
			"deploy"
		],
		skins: [
			{
				unified: "1f6a2",
				native: "🚢"
			}
		],
		version: 1
	},
	airplane: {
		id: "airplane",
		name: "Airplane",
		keywords: [
			"vehicle",
			"transportation",
			"flight",
			"fly"
		],
		skins: [
			{
				unified: "2708-fe0f",
				native: "✈️"
			}
		],
		version: 1
	},
	small_airplane: {
		id: "small_airplane",
		name: "Small Airplane",
		keywords: [
			"flight",
			"transportation",
			"fly",
			"vehicle"
		],
		skins: [
			{
				unified: "1f6e9-fe0f",
				native: "🛩️"
			}
		],
		version: 1
	},
	airplane_departure: {
		id: "airplane_departure",
		name: "Airplane Departure",
		keywords: [
			"airport",
			"flight",
			"landing"
		],
		skins: [
			{
				unified: "1f6eb",
				native: "🛫"
			}
		],
		version: 1
	},
	airplane_arriving: {
		id: "airplane_arriving",
		name: "Airplane Arrival",
		keywords: [
			"arriving",
			"airport",
			"flight",
			"boarding"
		],
		skins: [
			{
				unified: "1f6ec",
				native: "🛬"
			}
		],
		version: 1
	},
	parachute: {
		id: "parachute",
		name: "Parachute",
		keywords: [
			"fly",
			"glide"
		],
		skins: [
			{
				unified: "1fa82",
				native: "🪂"
			}
		],
		version: 12
	},
	seat: {
		id: "seat",
		name: "Seat",
		keywords: [
			"sit",
			"airplane",
			"transport",
			"bus",
			"flight",
			"fly"
		],
		skins: [
			{
				unified: "1f4ba",
				native: "💺"
			}
		],
		version: 1
	},
	helicopter: {
		id: "helicopter",
		name: "Helicopter",
		keywords: [
			"transportation",
			"vehicle",
			"fly"
		],
		skins: [
			{
				unified: "1f681",
				native: "🚁"
			}
		],
		version: 1
	},
	suspension_railway: {
		id: "suspension_railway",
		name: "Suspension Railway",
		keywords: [
			"vehicle",
			"transportation"
		],
		skins: [
			{
				unified: "1f69f",
				native: "🚟"
			}
		],
		version: 1
	},
	mountain_cableway: {
		id: "mountain_cableway",
		name: "Mountain Cableway",
		keywords: [
			"transportation",
			"vehicle",
			"ski"
		],
		skins: [
			{
				unified: "1f6a0",
				native: "🚠"
			}
		],
		version: 1
	},
	aerial_tramway: {
		id: "aerial_tramway",
		name: "Aerial Tramway",
		keywords: [
			"transportation",
			"vehicle",
			"ski"
		],
		skins: [
			{
				unified: "1f6a1",
				native: "🚡"
			}
		],
		version: 1
	},
	satellite: {
		id: "satellite",
		name: "Satellite",
		keywords: [
			"communication",
			"gps",
			"orbit",
			"spaceflight",
			"NASA",
			"ISS"
		],
		skins: [
			{
				unified: "1f6f0-fe0f",
				native: "🛰️"
			}
		],
		version: 1
	},
	rocket: {
		id: "rocket",
		name: "Rocket",
		keywords: [
			"launch",
			"ship",
			"staffmode",
			"NASA",
			"outer",
			"space",
			"fly"
		],
		skins: [
			{
				unified: "1f680",
				native: "🚀"
			}
		],
		version: 1
	},
	flying_saucer: {
		id: "flying_saucer",
		name: "Flying Saucer",
		keywords: [
			"transportation",
			"vehicle",
			"ufo"
		],
		skins: [
			{
				unified: "1f6f8",
				native: "🛸"
			}
		],
		version: 5
	},
	bellhop_bell: {
		id: "bellhop_bell",
		name: "Bellhop Bell",
		keywords: [
			"service"
		],
		skins: [
			{
				unified: "1f6ce-fe0f",
				native: "🛎️"
			}
		],
		version: 1
	},
	luggage: {
		id: "luggage",
		name: "Luggage",
		keywords: [
			"packing",
			"travel"
		],
		skins: [
			{
				unified: "1f9f3",
				native: "🧳"
			}
		],
		version: 11
	},
	hourglass: {
		id: "hourglass",
		name: "Hourglass",
		keywords: [
			"done",
			"time",
			"clock",
			"oldschool",
			"limit",
			"exam",
			"quiz",
			"test"
		],
		skins: [
			{
				unified: "231b",
				native: "⌛"
			}
		],
		version: 1
	},
	hourglass_flowing_sand: {
		id: "hourglass_flowing_sand",
		name: "Hourglass Not Done",
		keywords: [
			"flowing",
			"sand",
			"oldschool",
			"time",
			"countdown"
		],
		skins: [
			{
				unified: "23f3",
				native: "⏳"
			}
		],
		version: 1
	},
	watch: {
		id: "watch",
		name: "Watch",
		keywords: [
			"time",
			"accessories"
		],
		skins: [
			{
				unified: "231a",
				native: "⌚"
			}
		],
		version: 1
	},
	alarm_clock: {
		id: "alarm_clock",
		name: "Alarm Clock",
		keywords: [
			"time",
			"wake"
		],
		skins: [
			{
				unified: "23f0",
				native: "⏰"
			}
		],
		version: 1
	},
	stopwatch: {
		id: "stopwatch",
		name: "Stopwatch",
		keywords: [
			"time",
			"deadline"
		],
		skins: [
			{
				unified: "23f1-fe0f",
				native: "⏱️"
			}
		],
		version: 1
	},
	timer_clock: {
		id: "timer_clock",
		name: "Timer Clock",
		keywords: [
			"alarm"
		],
		skins: [
			{
				unified: "23f2-fe0f",
				native: "⏲️"
			}
		],
		version: 1
	},
	mantelpiece_clock: {
		id: "mantelpiece_clock",
		name: "Mantelpiece Clock",
		keywords: [
			"time"
		],
		skins: [
			{
				unified: "1f570-fe0f",
				native: "🕰️"
			}
		],
		version: 1
	},
	clock12: {
		id: "clock12",
		name: "Twelve O’clock",
		keywords: [
			"clock12",
			"o",
			"clock",
			"12",
			"00:00",
			"0000",
			"12:00",
			"1200",
			"time",
			"noon",
			"midnight",
			"midday",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f55b",
				native: "🕛"
			}
		],
		version: 1
	},
	clock1230: {
		id: "clock1230",
		name: "Twelve-Thirty",
		keywords: [
			"clock1230",
			"twelve",
			"thirty",
			"00:30",
			"0030",
			"12:30",
			"1230",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f567",
				native: "🕧"
			}
		],
		version: 1
	},
	clock1: {
		id: "clock1",
		name: "One O’clock",
		keywords: [
			"clock1",
			"o",
			"clock",
			"1",
			"1:00",
			"100",
			"13:00",
			"1300",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f550",
				native: "🕐"
			}
		],
		version: 1
	},
	clock130: {
		id: "clock130",
		name: "One-Thirty",
		keywords: [
			"clock130",
			"one",
			"thirty",
			"1:30",
			"130",
			"13:30",
			"1330",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f55c",
				native: "🕜"
			}
		],
		version: 1
	},
	clock2: {
		id: "clock2",
		name: "Two O’clock",
		keywords: [
			"clock2",
			"o",
			"clock",
			"2",
			"2:00",
			"200",
			"14:00",
			"1400",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f551",
				native: "🕑"
			}
		],
		version: 1
	},
	clock230: {
		id: "clock230",
		name: "Two-Thirty",
		keywords: [
			"clock230",
			"two",
			"thirty",
			"2:30",
			"230",
			"14:30",
			"1430",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f55d",
				native: "🕝"
			}
		],
		version: 1
	},
	clock3: {
		id: "clock3",
		name: "Three O’clock",
		keywords: [
			"clock3",
			"o",
			"clock",
			"3",
			"3:00",
			"300",
			"15:00",
			"1500",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f552",
				native: "🕒"
			}
		],
		version: 1
	},
	clock330: {
		id: "clock330",
		name: "Three-Thirty",
		keywords: [
			"clock330",
			"three",
			"thirty",
			"3:30",
			"330",
			"15:30",
			"1530",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f55e",
				native: "🕞"
			}
		],
		version: 1
	},
	clock4: {
		id: "clock4",
		name: "Four O’clock",
		keywords: [
			"clock4",
			"o",
			"clock",
			"4",
			"4:00",
			"400",
			"16:00",
			"1600",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f553",
				native: "🕓"
			}
		],
		version: 1
	},
	clock430: {
		id: "clock430",
		name: "Four-Thirty",
		keywords: [
			"clock430",
			"four",
			"thirty",
			"4:30",
			"430",
			"16:30",
			"1630",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f55f",
				native: "🕟"
			}
		],
		version: 1
	},
	clock5: {
		id: "clock5",
		name: "Five O’clock",
		keywords: [
			"clock5",
			"o",
			"clock",
			"5",
			"5:00",
			"500",
			"17:00",
			"1700",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f554",
				native: "🕔"
			}
		],
		version: 1
	},
	clock530: {
		id: "clock530",
		name: "Five-Thirty",
		keywords: [
			"clock530",
			"five",
			"thirty",
			"5:30",
			"530",
			"17:30",
			"1730",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f560",
				native: "🕠"
			}
		],
		version: 1
	},
	clock6: {
		id: "clock6",
		name: "Six O’clock",
		keywords: [
			"clock6",
			"o",
			"clock",
			"6",
			"6:00",
			"600",
			"18:00",
			"1800",
			"time",
			"late",
			"early",
			"schedule",
			"dawn",
			"dusk"
		],
		skins: [
			{
				unified: "1f555",
				native: "🕕"
			}
		],
		version: 1
	},
	clock630: {
		id: "clock630",
		name: "Six-Thirty",
		keywords: [
			"clock630",
			"six",
			"thirty",
			"6:30",
			"630",
			"18:30",
			"1830",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f561",
				native: "🕡"
			}
		],
		version: 1
	},
	clock7: {
		id: "clock7",
		name: "Seven O’clock",
		keywords: [
			"clock7",
			"o",
			"clock",
			"7",
			"7:00",
			"700",
			"19:00",
			"1900",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f556",
				native: "🕖"
			}
		],
		version: 1
	},
	clock730: {
		id: "clock730",
		name: "Seven-Thirty",
		keywords: [
			"clock730",
			"seven",
			"thirty",
			"7:30",
			"730",
			"19:30",
			"1930",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f562",
				native: "🕢"
			}
		],
		version: 1
	},
	clock8: {
		id: "clock8",
		name: "Eight O’clock",
		keywords: [
			"clock8",
			"o",
			"clock",
			"8",
			"8:00",
			"800",
			"20:00",
			"2000",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f557",
				native: "🕗"
			}
		],
		version: 1
	},
	clock830: {
		id: "clock830",
		name: "Eight-Thirty",
		keywords: [
			"clock830",
			"eight",
			"thirty",
			"8:30",
			"830",
			"20:30",
			"2030",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f563",
				native: "🕣"
			}
		],
		version: 1
	},
	clock9: {
		id: "clock9",
		name: "Nine O’clock",
		keywords: [
			"clock9",
			"o",
			"clock",
			"9",
			"9:00",
			"900",
			"21:00",
			"2100",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f558",
				native: "🕘"
			}
		],
		version: 1
	},
	clock930: {
		id: "clock930",
		name: "Nine-Thirty",
		keywords: [
			"clock930",
			"nine",
			"thirty",
			"9:30",
			"930",
			"21:30",
			"2130",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f564",
				native: "🕤"
			}
		],
		version: 1
	},
	clock10: {
		id: "clock10",
		name: "Ten O’clock",
		keywords: [
			"clock10",
			"o",
			"clock",
			"10",
			"10:00",
			"1000",
			"22:00",
			"2200",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f559",
				native: "🕙"
			}
		],
		version: 1
	},
	clock1030: {
		id: "clock1030",
		name: "Ten-Thirty",
		keywords: [
			"clock1030",
			"ten",
			"thirty",
			"10:30",
			"1030",
			"22:30",
			"2230",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f565",
				native: "🕥"
			}
		],
		version: 1
	},
	clock11: {
		id: "clock11",
		name: "Eleven O’clock",
		keywords: [
			"clock11",
			"o",
			"clock",
			"11",
			"11:00",
			"1100",
			"23:00",
			"2300",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f55a",
				native: "🕚"
			}
		],
		version: 1
	},
	clock1130: {
		id: "clock1130",
		name: "Eleven-Thirty",
		keywords: [
			"clock1130",
			"eleven",
			"thirty",
			"11:30",
			"1130",
			"23:30",
			"2330",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f566",
				native: "🕦"
			}
		],
		version: 1
	},
	new_moon: {
		id: "new_moon",
		name: "New Moon",
		keywords: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f311",
				native: "🌑"
			}
		],
		version: 1
	},
	waxing_crescent_moon: {
		id: "waxing_crescent_moon",
		name: "Waxing Crescent Moon",
		keywords: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f312",
				native: "🌒"
			}
		],
		version: 1
	},
	first_quarter_moon: {
		id: "first_quarter_moon",
		name: "First Quarter Moon",
		keywords: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f313",
				native: "🌓"
			}
		],
		version: 1
	},
	moon: {
		id: "moon",
		name: "Waxing Gibbous Moon",
		keywords: [
			"nature",
			"night",
			"sky",
			"gray",
			"twilight",
			"planet",
			"space",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f314",
				native: "🌔"
			}
		],
		version: 1
	},
	full_moon: {
		id: "full_moon",
		name: "Full Moon",
		keywords: [
			"nature",
			"yellow",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f315",
				native: "🌕"
			}
		],
		version: 1
	},
	waning_gibbous_moon: {
		id: "waning_gibbous_moon",
		name: "Waning Gibbous Moon",
		keywords: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep",
			"waxing"
		],
		skins: [
			{
				unified: "1f316",
				native: "🌖"
			}
		],
		version: 1
	},
	last_quarter_moon: {
		id: "last_quarter_moon",
		name: "Last Quarter Moon",
		keywords: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f317",
				native: "🌗"
			}
		],
		version: 1
	},
	waning_crescent_moon: {
		id: "waning_crescent_moon",
		name: "Waning Crescent Moon",
		keywords: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f318",
				native: "🌘"
			}
		],
		version: 1
	},
	crescent_moon: {
		id: "crescent_moon",
		name: "Crescent Moon",
		keywords: [
			"night",
			"sleep",
			"sky",
			"evening",
			"magic"
		],
		skins: [
			{
				unified: "1f319",
				native: "🌙"
			}
		],
		version: 1
	},
	new_moon_with_face: {
		id: "new_moon_with_face",
		name: "New Moon Face",
		keywords: [
			"with",
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f31a",
				native: "🌚"
			}
		],
		version: 1
	},
	first_quarter_moon_with_face: {
		id: "first_quarter_moon_with_face",
		name: "First Quarter Moon Face",
		keywords: [
			"with",
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f31b",
				native: "🌛"
			}
		],
		version: 1
	},
	last_quarter_moon_with_face: {
		id: "last_quarter_moon_with_face",
		name: "Last Quarter Moon Face",
		keywords: [
			"with",
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f31c",
				native: "🌜"
			}
		],
		version: 1
	},
	thermometer: {
		id: "thermometer",
		name: "Thermometer",
		keywords: [
			"weather",
			"temperature",
			"hot",
			"cold"
		],
		skins: [
			{
				unified: "1f321-fe0f",
				native: "🌡️"
			}
		],
		version: 1
	},
	sunny: {
		id: "sunny",
		name: "Sun",
		keywords: [
			"sunny",
			"weather",
			"nature",
			"brightness",
			"summer",
			"beach",
			"spring"
		],
		skins: [
			{
				unified: "2600-fe0f",
				native: "☀️"
			}
		],
		version: 1
	},
	full_moon_with_face: {
		id: "full_moon_with_face",
		name: "Full Moon Face",
		keywords: [
			"with",
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f31d",
				native: "🌝"
			}
		],
		version: 1
	},
	sun_with_face: {
		id: "sun_with_face",
		name: "Sun with Face",
		keywords: [
			"nature",
			"morning",
			"sky"
		],
		skins: [
			{
				unified: "1f31e",
				native: "🌞"
			}
		],
		version: 1
	},
	ringed_planet: {
		id: "ringed_planet",
		name: "Ringed Planet",
		keywords: [
			"outerspace"
		],
		skins: [
			{
				unified: "1fa90",
				native: "🪐"
			}
		],
		version: 12
	},
	star: {
		id: "star",
		name: "Star",
		keywords: [
			"night",
			"yellow"
		],
		skins: [
			{
				unified: "2b50",
				native: "⭐"
			}
		],
		version: 1
	},
	star2: {
		id: "star2",
		name: "Glowing Star",
		keywords: [
			"star2",
			"night",
			"sparkle",
			"awesome",
			"good",
			"magic"
		],
		skins: [
			{
				unified: "1f31f",
				native: "🌟"
			}
		],
		version: 1
	},
	stars: {
		id: "stars",
		name: "Shooting Star",
		keywords: [
			"stars",
			"night",
			"photo"
		],
		skins: [
			{
				unified: "1f320",
				native: "🌠"
			}
		],
		version: 1
	},
	milky_way: {
		id: "milky_way",
		name: "Milky Way",
		keywords: [
			"photo",
			"space",
			"stars"
		],
		skins: [
			{
				unified: "1f30c",
				native: "🌌"
			}
		],
		version: 1
	},
	cloud: {
		id: "cloud",
		name: "Cloud",
		keywords: [
			"weather",
			"sky"
		],
		skins: [
			{
				unified: "2601-fe0f",
				native: "☁️"
			}
		],
		version: 1
	},
	partly_sunny: {
		id: "partly_sunny",
		name: "Sun Behind Cloud",
		keywords: [
			"partly",
			"sunny",
			"weather",
			"nature",
			"cloudy",
			"morning",
			"fall",
			"spring"
		],
		skins: [
			{
				unified: "26c5",
				native: "⛅"
			}
		],
		version: 1
	},
	thunder_cloud_and_rain: {
		id: "thunder_cloud_and_rain",
		name: "Cloud with Lightning and Rain",
		keywords: [
			"thunder",
			"weather"
		],
		skins: [
			{
				unified: "26c8-fe0f",
				native: "⛈️"
			}
		],
		version: 1
	},
	mostly_sunny: {
		id: "mostly_sunny",
		name: "Sun Behind Small Cloud",
		keywords: [
			"mostly",
			"sunny",
			"weather"
		],
		skins: [
			{
				unified: "1f324-fe0f",
				native: "🌤️"
			}
		],
		version: 1
	},
	barely_sunny: {
		id: "barely_sunny",
		name: "Sun Behind Large Cloud",
		keywords: [
			"barely",
			"sunny",
			"weather"
		],
		skins: [
			{
				unified: "1f325-fe0f",
				native: "🌥️"
			}
		],
		version: 1
	},
	partly_sunny_rain: {
		id: "partly_sunny_rain",
		name: "Sun Behind Rain Cloud",
		keywords: [
			"partly",
			"sunny",
			"weather"
		],
		skins: [
			{
				unified: "1f326-fe0f",
				native: "🌦️"
			}
		],
		version: 1
	},
	rain_cloud: {
		id: "rain_cloud",
		name: "Cloud with Rain",
		keywords: [
			"weather"
		],
		skins: [
			{
				unified: "1f327-fe0f",
				native: "🌧️"
			}
		],
		version: 1
	},
	snow_cloud: {
		id: "snow_cloud",
		name: "Cloud with Snow",
		keywords: [
			"weather"
		],
		skins: [
			{
				unified: "1f328-fe0f",
				native: "🌨️"
			}
		],
		version: 1
	},
	lightning: {
		id: "lightning",
		name: "Cloud with Lightning",
		keywords: [
			"weather",
			"thunder"
		],
		skins: [
			{
				unified: "1f329-fe0f",
				native: "🌩️"
			}
		],
		version: 1
	},
	tornado: {
		id: "tornado",
		name: "Tornado",
		keywords: [
			"cloud",
			"weather",
			"cyclone",
			"twister"
		],
		skins: [
			{
				unified: "1f32a-fe0f",
				native: "🌪️"
			}
		],
		version: 1
	},
	fog: {
		id: "fog",
		name: "Fog",
		keywords: [
			"weather"
		],
		skins: [
			{
				unified: "1f32b-fe0f",
				native: "🌫️"
			}
		],
		version: 1
	},
	wind_blowing_face: {
		id: "wind_blowing_face",
		name: "Wind Face",
		keywords: [
			"blowing",
			"gust",
			"air"
		],
		skins: [
			{
				unified: "1f32c-fe0f",
				native: "🌬️"
			}
		],
		version: 1
	},
	cyclone: {
		id: "cyclone",
		name: "Cyclone",
		keywords: [
			"weather",
			"swirl",
			"blue",
			"cloud",
			"vortex",
			"spiral",
			"whirlpool",
			"spin",
			"tornado",
			"hurricane",
			"typhoon"
		],
		skins: [
			{
				unified: "1f300",
				native: "🌀"
			}
		],
		version: 1
	},
	rainbow: {
		id: "rainbow",
		name: "Rainbow",
		keywords: [
			"nature",
			"happy",
			"unicorn",
			"face",
			"photo",
			"sky",
			"spring"
		],
		skins: [
			{
				unified: "1f308",
				native: "🌈"
			}
		],
		version: 1
	},
	closed_umbrella: {
		id: "closed_umbrella",
		name: "Closed Umbrella",
		keywords: [
			"weather",
			"rain",
			"drizzle"
		],
		skins: [
			{
				unified: "1f302",
				native: "🌂"
			}
		],
		version: 1
	},
	umbrella: {
		id: "umbrella",
		name: "Umbrella",
		keywords: [
			"weather",
			"spring"
		],
		skins: [
			{
				unified: "2602-fe0f",
				native: "☂️"
			}
		],
		version: 1
	},
	umbrella_with_rain_drops: {
		id: "umbrella_with_rain_drops",
		name: "Umbrella with Rain Drops",
		keywords: [
			"rainy",
			"weather",
			"spring"
		],
		skins: [
			{
				unified: "2614",
				native: "☔"
			}
		],
		version: 1
	},
	umbrella_on_ground: {
		id: "umbrella_on_ground",
		name: "Umbrella on Ground",
		keywords: [
			"weather",
			"summer"
		],
		skins: [
			{
				unified: "26f1-fe0f",
				native: "⛱️"
			}
		],
		version: 1
	},
	zap: {
		id: "zap",
		name: "High Voltage",
		keywords: [
			"zap",
			"thunder",
			"weather",
			"lightning",
			"bolt",
			"fast"
		],
		skins: [
			{
				unified: "26a1",
				native: "⚡"
			}
		],
		version: 1
	},
	snowflake: {
		id: "snowflake",
		name: "Snowflake",
		keywords: [
			"winter",
			"season",
			"cold",
			"weather",
			"christmas",
			"xmas"
		],
		skins: [
			{
				unified: "2744-fe0f",
				native: "❄️"
			}
		],
		version: 1
	},
	snowman: {
		id: "snowman",
		name: "Snowman",
		keywords: [
			"winter",
			"season",
			"cold",
			"weather",
			"christmas",
			"xmas",
			"frozen"
		],
		skins: [
			{
				unified: "2603-fe0f",
				native: "☃️"
			}
		],
		version: 1
	},
	snowman_without_snow: {
		id: "snowman_without_snow",
		name: "Snowman Without Snow",
		keywords: [
			"winter",
			"season",
			"cold",
			"weather",
			"christmas",
			"xmas",
			"frozen"
		],
		skins: [
			{
				unified: "26c4",
				native: "⛄"
			}
		],
		version: 1
	},
	comet: {
		id: "comet",
		name: "Comet",
		keywords: [
			"space"
		],
		skins: [
			{
				unified: "2604-fe0f",
				native: "☄️"
			}
		],
		version: 1
	},
	fire: {
		id: "fire",
		name: "Fire",
		keywords: [
			"hot",
			"cook",
			"flame"
		],
		skins: [
			{
				unified: "1f525",
				native: "🔥"
			}
		],
		version: 1
	},
	droplet: {
		id: "droplet",
		name: "Droplet",
		keywords: [
			"water",
			"drip",
			"faucet",
			"spring"
		],
		skins: [
			{
				unified: "1f4a7",
				native: "💧"
			}
		],
		version: 1
	},
	ocean: {
		id: "ocean",
		name: "Water Wave",
		keywords: [
			"ocean",
			"sea",
			"nature",
			"tsunami",
			"disaster"
		],
		skins: [
			{
				unified: "1f30a",
				native: "🌊"
			}
		],
		version: 1
	},
	jack_o_lantern: {
		id: "jack_o_lantern",
		name: "Jack-O-Lantern",
		keywords: [
			"jack",
			"o",
			"lantern",
			"halloween",
			"light",
			"pumpkin",
			"creepy",
			"fall"
		],
		skins: [
			{
				unified: "1f383",
				native: "🎃"
			}
		],
		version: 1
	},
	christmas_tree: {
		id: "christmas_tree",
		name: "Christmas Tree",
		keywords: [
			"festival",
			"vacation",
			"december",
			"xmas",
			"celebration"
		],
		skins: [
			{
				unified: "1f384",
				native: "🎄"
			}
		],
		version: 1
	},
	fireworks: {
		id: "fireworks",
		name: "Fireworks",
		keywords: [
			"photo",
			"festival",
			"carnival",
			"congratulations"
		],
		skins: [
			{
				unified: "1f386",
				native: "🎆"
			}
		],
		version: 1
	},
	sparkler: {
		id: "sparkler",
		name: "Sparkler",
		keywords: [
			"stars",
			"night",
			"shine"
		],
		skins: [
			{
				unified: "1f387",
				native: "🎇"
			}
		],
		version: 1
	},
	firecracker: {
		id: "firecracker",
		name: "Firecracker",
		keywords: [
			"dynamite",
			"boom",
			"explode",
			"explosion",
			"explosive"
		],
		skins: [
			{
				unified: "1f9e8",
				native: "🧨"
			}
		],
		version: 11
	},
	sparkles: {
		id: "sparkles",
		name: "Sparkles",
		keywords: [
			"stars",
			"shine",
			"shiny",
			"cool",
			"awesome",
			"good",
			"magic"
		],
		skins: [
			{
				unified: "2728",
				native: "✨"
			}
		],
		version: 1
	},
	balloon: {
		id: "balloon",
		name: "Balloon",
		keywords: [
			"party",
			"celebration",
			"birthday",
			"circus"
		],
		skins: [
			{
				unified: "1f388",
				native: "🎈"
			}
		],
		version: 1
	},
	tada: {
		id: "tada",
		name: "Party Popper",
		keywords: [
			"tada",
			"congratulations",
			"birthday",
			"magic",
			"circus",
			"celebration"
		],
		skins: [
			{
				unified: "1f389",
				native: "🎉"
			}
		],
		version: 1
	},
	confetti_ball: {
		id: "confetti_ball",
		name: "Confetti Ball",
		keywords: [
			"festival",
			"party",
			"birthday",
			"circus"
		],
		skins: [
			{
				unified: "1f38a",
				native: "🎊"
			}
		],
		version: 1
	},
	tanabata_tree: {
		id: "tanabata_tree",
		name: "Tanabata Tree",
		keywords: [
			"plant",
			"nature",
			"branch",
			"summer",
			"bamboo",
			"wish",
			"star",
			"festival",
			"tanzaku"
		],
		skins: [
			{
				unified: "1f38b",
				native: "🎋"
			}
		],
		version: 1
	},
	bamboo: {
		id: "bamboo",
		name: "Pine Decoration",
		keywords: [
			"bamboo",
			"japanese",
			"plant",
			"nature",
			"vegetable",
			"panda",
			"new",
			"years"
		],
		skins: [
			{
				unified: "1f38d",
				native: "🎍"
			}
		],
		version: 1
	},
	dolls: {
		id: "dolls",
		name: "Japanese Dolls",
		keywords: [
			"toy",
			"kimono"
		],
		skins: [
			{
				unified: "1f38e",
				native: "🎎"
			}
		],
		version: 1
	},
	flags: {
		id: "flags",
		name: "Carp Streamer",
		keywords: [
			"flags",
			"fish",
			"japanese",
			"koinobori",
			"banner"
		],
		skins: [
			{
				unified: "1f38f",
				native: "🎏"
			}
		],
		version: 1
	},
	wind_chime: {
		id: "wind_chime",
		name: "Wind Chime",
		keywords: [
			"nature",
			"ding",
			"spring",
			"bell"
		],
		skins: [
			{
				unified: "1f390",
				native: "🎐"
			}
		],
		version: 1
	},
	rice_scene: {
		id: "rice_scene",
		name: "Moon Viewing Ceremony",
		keywords: [
			"rice",
			"scene",
			"photo",
			"japan",
			"asia",
			"tsukimi"
		],
		skins: [
			{
				unified: "1f391",
				native: "🎑"
			}
		],
		version: 1
	},
	red_envelope: {
		id: "red_envelope",
		name: "Red Envelope",
		keywords: [
			"gift"
		],
		skins: [
			{
				unified: "1f9e7",
				native: "🧧"
			}
		],
		version: 11
	},
	ribbon: {
		id: "ribbon",
		name: "Ribbon",
		keywords: [
			"decoration",
			"pink",
			"girl",
			"bowtie"
		],
		skins: [
			{
				unified: "1f380",
				native: "🎀"
			}
		],
		version: 1
	},
	gift: {
		id: "gift",
		name: "Wrapped Gift",
		keywords: [
			"present",
			"birthday",
			"christmas",
			"xmas"
		],
		skins: [
			{
				unified: "1f381",
				native: "🎁"
			}
		],
		version: 1
	},
	reminder_ribbon: {
		id: "reminder_ribbon",
		name: "Reminder Ribbon",
		keywords: [
			"sports",
			"cause",
			"support",
			"awareness"
		],
		skins: [
			{
				unified: "1f397-fe0f",
				native: "🎗️"
			}
		],
		version: 1
	},
	admission_tickets: {
		id: "admission_tickets",
		name: "Admission Tickets",
		keywords: [
			"sports",
			"concert",
			"entrance"
		],
		skins: [
			{
				unified: "1f39f-fe0f",
				native: "🎟️"
			}
		],
		version: 1
	},
	ticket: {
		id: "ticket",
		name: "Ticket",
		keywords: [
			"event",
			"concert",
			"pass"
		],
		skins: [
			{
				unified: "1f3ab",
				native: "🎫"
			}
		],
		version: 1
	},
	medal: {
		id: "medal",
		name: "Military Medal",
		keywords: [
			"award",
			"winning",
			"army"
		],
		skins: [
			{
				unified: "1f396-fe0f",
				native: "🎖️"
			}
		],
		version: 1
	},
	trophy: {
		id: "trophy",
		name: "Trophy",
		keywords: [
			"win",
			"award",
			"contest",
			"place",
			"ftw",
			"ceremony"
		],
		skins: [
			{
				unified: "1f3c6",
				native: "🏆"
			}
		],
		version: 1
	},
	sports_medal: {
		id: "sports_medal",
		name: "Sports Medal",
		keywords: [
			"award",
			"winning"
		],
		skins: [
			{
				unified: "1f3c5",
				native: "🏅"
			}
		],
		version: 1
	},
	first_place_medal: {
		id: "first_place_medal",
		name: "1st Place Medal",
		keywords: [
			"first",
			"award",
			"winning"
		],
		skins: [
			{
				unified: "1f947",
				native: "🥇"
			}
		],
		version: 3
	},
	second_place_medal: {
		id: "second_place_medal",
		name: "2nd Place Medal",
		keywords: [
			"second",
			"award"
		],
		skins: [
			{
				unified: "1f948",
				native: "🥈"
			}
		],
		version: 3
	},
	third_place_medal: {
		id: "third_place_medal",
		name: "3rd Place Medal",
		keywords: [
			"third",
			"award"
		],
		skins: [
			{
				unified: "1f949",
				native: "🥉"
			}
		],
		version: 3
	},
	soccer: {
		id: "soccer",
		name: "Soccer Ball",
		keywords: [
			"sports",
			"football"
		],
		skins: [
			{
				unified: "26bd",
				native: "⚽"
			}
		],
		version: 1
	},
	baseball: {
		id: "baseball",
		name: "Baseball",
		keywords: [
			"sports",
			"balls"
		],
		skins: [
			{
				unified: "26be",
				native: "⚾"
			}
		],
		version: 1
	},
	softball: {
		id: "softball",
		name: "Softball",
		keywords: [
			"sports",
			"balls"
		],
		skins: [
			{
				unified: "1f94e",
				native: "🥎"
			}
		],
		version: 11
	},
	basketball: {
		id: "basketball",
		name: "Basketball",
		keywords: [
			"sports",
			"balls",
			"NBA"
		],
		skins: [
			{
				unified: "1f3c0",
				native: "🏀"
			}
		],
		version: 1
	},
	volleyball: {
		id: "volleyball",
		name: "Volleyball",
		keywords: [
			"sports",
			"balls"
		],
		skins: [
			{
				unified: "1f3d0",
				native: "🏐"
			}
		],
		version: 1
	},
	football: {
		id: "football",
		name: "American Football",
		keywords: [
			"sports",
			"balls",
			"NFL"
		],
		skins: [
			{
				unified: "1f3c8",
				native: "🏈"
			}
		],
		version: 1
	},
	rugby_football: {
		id: "rugby_football",
		name: "Rugby Football",
		keywords: [
			"sports",
			"team"
		],
		skins: [
			{
				unified: "1f3c9",
				native: "🏉"
			}
		],
		version: 1
	},
	tennis: {
		id: "tennis",
		name: "Tennis",
		keywords: [
			"sports",
			"balls",
			"green"
		],
		skins: [
			{
				unified: "1f3be",
				native: "🎾"
			}
		],
		version: 1
	},
	flying_disc: {
		id: "flying_disc",
		name: "Flying Disc",
		keywords: [
			"sports",
			"frisbee",
			"ultimate"
		],
		skins: [
			{
				unified: "1f94f",
				native: "🥏"
			}
		],
		version: 11
	},
	bowling: {
		id: "bowling",
		name: "Bowling",
		keywords: [
			"sports",
			"fun",
			"play"
		],
		skins: [
			{
				unified: "1f3b3",
				native: "🎳"
			}
		],
		version: 1
	},
	cricket_bat_and_ball: {
		id: "cricket_bat_and_ball",
		name: "Cricket Game",
		keywords: [
			"bat",
			"and",
			"ball",
			"sports"
		],
		skins: [
			{
				unified: "1f3cf",
				native: "🏏"
			}
		],
		version: 1
	},
	field_hockey_stick_and_ball: {
		id: "field_hockey_stick_and_ball",
		name: "Field Hockey",
		keywords: [
			"stick",
			"and",
			"ball",
			"sports"
		],
		skins: [
			{
				unified: "1f3d1",
				native: "🏑"
			}
		],
		version: 1
	},
	ice_hockey_stick_and_puck: {
		id: "ice_hockey_stick_and_puck",
		name: "Ice Hockey",
		keywords: [
			"stick",
			"and",
			"puck",
			"sports"
		],
		skins: [
			{
				unified: "1f3d2",
				native: "🏒"
			}
		],
		version: 1
	},
	lacrosse: {
		id: "lacrosse",
		name: "Lacrosse",
		keywords: [
			"sports",
			"ball",
			"stick"
		],
		skins: [
			{
				unified: "1f94d",
				native: "🥍"
			}
		],
		version: 11
	},
	table_tennis_paddle_and_ball: {
		id: "table_tennis_paddle_and_ball",
		name: "Ping Pong",
		keywords: [
			"table",
			"tennis",
			"paddle",
			"and",
			"ball",
			"sports",
			"pingpong"
		],
		skins: [
			{
				unified: "1f3d3",
				native: "🏓"
			}
		],
		version: 1
	},
	badminton_racquet_and_shuttlecock: {
		id: "badminton_racquet_and_shuttlecock",
		name: "Badminton",
		keywords: [
			"racquet",
			"and",
			"shuttlecock",
			"sports"
		],
		skins: [
			{
				unified: "1f3f8",
				native: "🏸"
			}
		],
		version: 1
	},
	boxing_glove: {
		id: "boxing_glove",
		name: "Boxing Glove",
		keywords: [
			"sports",
			"fighting"
		],
		skins: [
			{
				unified: "1f94a",
				native: "🥊"
			}
		],
		version: 3
	},
	martial_arts_uniform: {
		id: "martial_arts_uniform",
		name: "Martial Arts Uniform",
		keywords: [
			"judo",
			"karate",
			"taekwondo"
		],
		skins: [
			{
				unified: "1f94b",
				native: "🥋"
			}
		],
		version: 3
	},
	goal_net: {
		id: "goal_net",
		name: "Goal Net",
		keywords: [
			"sports"
		],
		skins: [
			{
				unified: "1f945",
				native: "🥅"
			}
		],
		version: 3
	},
	golf: {
		id: "golf",
		name: "Flag in Hole",
		keywords: [
			"golf",
			"sports",
			"business",
			"summer"
		],
		skins: [
			{
				unified: "26f3",
				native: "⛳"
			}
		],
		version: 1
	},
	ice_skate: {
		id: "ice_skate",
		name: "Ice Skate",
		keywords: [
			"sports"
		],
		skins: [
			{
				unified: "26f8-fe0f",
				native: "⛸️"
			}
		],
		version: 1
	},
	fishing_pole_and_fish: {
		id: "fishing_pole_and_fish",
		name: "Fishing Pole",
		keywords: [
			"and",
			"fish",
			"food",
			"hobby",
			"summer"
		],
		skins: [
			{
				unified: "1f3a3",
				native: "🎣"
			}
		],
		version: 1
	},
	diving_mask: {
		id: "diving_mask",
		name: "Diving Mask",
		keywords: [
			"sport",
			"ocean"
		],
		skins: [
			{
				unified: "1f93f",
				native: "🤿"
			}
		],
		version: 12
	},
	running_shirt_with_sash: {
		id: "running_shirt_with_sash",
		name: "Running Shirt",
		keywords: [
			"with",
			"sash",
			"play",
			"pageant"
		],
		skins: [
			{
				unified: "1f3bd",
				native: "🎽"
			}
		],
		version: 1
	},
	ski: {
		id: "ski",
		name: "Skis",
		keywords: [
			"ski",
			"sports",
			"winter",
			"cold",
			"snow"
		],
		skins: [
			{
				unified: "1f3bf",
				native: "🎿"
			}
		],
		version: 1
	},
	sled: {
		id: "sled",
		name: "Sled",
		keywords: [
			"sleigh",
			"luge",
			"toboggan"
		],
		skins: [
			{
				unified: "1f6f7",
				native: "🛷"
			}
		],
		version: 5
	},
	curling_stone: {
		id: "curling_stone",
		name: "Curling Stone",
		keywords: [
			"sports"
		],
		skins: [
			{
				unified: "1f94c",
				native: "🥌"
			}
		],
		version: 5
	},
	dart: {
		id: "dart",
		name: "Bullseye",
		keywords: [
			"dart",
			"direct",
			"hit",
			"game",
			"play",
			"bar",
			"target"
		],
		skins: [
			{
				unified: "1f3af",
				native: "🎯"
			}
		],
		version: 1
	},
	"yo-yo": {
		id: "yo-yo",
		name: "Yo-Yo",
		keywords: [
			"yo",
			"toy"
		],
		skins: [
			{
				unified: "1fa80",
				native: "🪀"
			}
		],
		version: 12
	},
	kite: {
		id: "kite",
		name: "Kite",
		keywords: [
			"wind",
			"fly"
		],
		skins: [
			{
				unified: "1fa81",
				native: "🪁"
			}
		],
		version: 12
	},
	gun: {
		id: "gun",
		name: "Pistol",
		keywords: [
			"gun",
			"violence",
			"weapon",
			"revolver"
		],
		skins: [
			{
				unified: "1f52b",
				native: "🔫"
			}
		],
		version: 1
	},
	"8ball": {
		id: "8ball",
		name: "Billiards",
		keywords: [
			"8ball",
			"pool",
			"8",
			"ball",
			"hobby",
			"game",
			"luck",
			"magic"
		],
		skins: [
			{
				unified: "1f3b1",
				native: "🎱"
			}
		],
		version: 1
	},
	crystal_ball: {
		id: "crystal_ball",
		name: "Crystal Ball",
		keywords: [
			"disco",
			"party",
			"magic",
			"circus",
			"fortune",
			"teller"
		],
		skins: [
			{
				unified: "1f52e",
				native: "🔮"
			}
		],
		version: 1
	},
	magic_wand: {
		id: "magic_wand",
		name: "Magic Wand",
		keywords: [
			"supernature",
			"power"
		],
		skins: [
			{
				unified: "1fa84",
				native: "🪄"
			}
		],
		version: 13
	},
	video_game: {
		id: "video_game",
		name: "Video Game",
		keywords: [
			"play",
			"console",
			"PS4",
			"controller"
		],
		skins: [
			{
				unified: "1f3ae",
				native: "🎮"
			}
		],
		version: 1
	},
	joystick: {
		id: "joystick",
		name: "Joystick",
		keywords: [
			"game",
			"play"
		],
		skins: [
			{
				unified: "1f579-fe0f",
				native: "🕹️"
			}
		],
		version: 1
	},
	slot_machine: {
		id: "slot_machine",
		name: "Slot Machine",
		keywords: [
			"bet",
			"gamble",
			"vegas",
			"fruit",
			"luck",
			"casino"
		],
		skins: [
			{
				unified: "1f3b0",
				native: "🎰"
			}
		],
		version: 1
	},
	game_die: {
		id: "game_die",
		name: "Game Die",
		keywords: [
			"dice",
			"random",
			"tabletop",
			"play",
			"luck"
		],
		skins: [
			{
				unified: "1f3b2",
				native: "🎲"
			}
		],
		version: 1
	},
	jigsaw: {
		id: "jigsaw",
		name: "Puzzle Piece",
		keywords: [
			"jigsaw",
			"interlocking"
		],
		skins: [
			{
				unified: "1f9e9",
				native: "🧩"
			}
		],
		version: 11
	},
	teddy_bear: {
		id: "teddy_bear",
		name: "Teddy Bear",
		keywords: [
			"plush",
			"stuffed"
		],
		skins: [
			{
				unified: "1f9f8",
				native: "🧸"
			}
		],
		version: 11
	},
	pinata: {
		id: "pinata",
		name: "Pinata",
		keywords: [
			"mexico",
			"candy",
			"celebration"
		],
		skins: [
			{
				unified: "1fa85",
				native: "🪅"
			}
		],
		version: 13
	},
	mirror_ball: {
		id: "mirror_ball",
		name: "Mirror Ball",
		keywords: [
			"disco",
			"dance",
			"party"
		],
		skins: [
			{
				unified: "1faa9",
				native: "🪩"
			}
		],
		version: 14
	},
	nesting_dolls: {
		id: "nesting_dolls",
		name: "Nesting Dolls",
		keywords: [
			"matryoshka",
			"toy"
		],
		skins: [
			{
				unified: "1fa86",
				native: "🪆"
			}
		],
		version: 13
	},
	spades: {
		id: "spades",
		name: "Spade Suit",
		keywords: [
			"spades",
			"poker",
			"cards",
			"suits",
			"magic"
		],
		skins: [
			{
				unified: "2660-fe0f",
				native: "♠️"
			}
		],
		version: 1
	},
	hearts: {
		id: "hearts",
		name: "Heart Suit",
		keywords: [
			"hearts",
			"poker",
			"cards",
			"magic",
			"suits"
		],
		skins: [
			{
				unified: "2665-fe0f",
				native: "♥️"
			}
		],
		version: 1
	},
	diamonds: {
		id: "diamonds",
		name: "Diamond Suit",
		keywords: [
			"diamonds",
			"poker",
			"cards",
			"magic",
			"suits"
		],
		skins: [
			{
				unified: "2666-fe0f",
				native: "♦️"
			}
		],
		version: 1
	},
	clubs: {
		id: "clubs",
		name: "Club Suit",
		keywords: [
			"clubs",
			"poker",
			"cards",
			"magic",
			"suits"
		],
		skins: [
			{
				unified: "2663-fe0f",
				native: "♣️"
			}
		],
		version: 1
	},
	chess_pawn: {
		id: "chess_pawn",
		name: "Chess Pawn",
		keywords: [
			"expendable"
		],
		skins: [
			{
				unified: "265f-fe0f",
				native: "♟️"
			}
		],
		version: 11
	},
	black_joker: {
		id: "black_joker",
		name: "Joker",
		keywords: [
			"black",
			"poker",
			"cards",
			"game",
			"play",
			"magic"
		],
		skins: [
			{
				unified: "1f0cf",
				native: "🃏"
			}
		],
		version: 1
	},
	mahjong: {
		id: "mahjong",
		name: "Mahjong Red Dragon",
		keywords: [
			"game",
			"play",
			"chinese",
			"kanji"
		],
		skins: [
			{
				unified: "1f004",
				native: "🀄"
			}
		],
		version: 1
	},
	flower_playing_cards: {
		id: "flower_playing_cards",
		name: "Flower Playing Cards",
		keywords: [
			"game",
			"sunset",
			"red"
		],
		skins: [
			{
				unified: "1f3b4",
				native: "🎴"
			}
		],
		version: 1
	},
	performing_arts: {
		id: "performing_arts",
		name: "Performing Arts",
		keywords: [
			"acting",
			"theater",
			"drama"
		],
		skins: [
			{
				unified: "1f3ad",
				native: "🎭"
			}
		],
		version: 1
	},
	frame_with_picture: {
		id: "frame_with_picture",
		name: "Framed Picture",
		keywords: [
			"frame",
			"with",
			"photography"
		],
		skins: [
			{
				unified: "1f5bc-fe0f",
				native: "🖼️"
			}
		],
		version: 1
	},
	art: {
		id: "art",
		name: "Artist Palette",
		keywords: [
			"art",
			"design",
			"paint",
			"draw",
			"colors"
		],
		skins: [
			{
				unified: "1f3a8",
				native: "🎨"
			}
		],
		version: 1
	},
	thread: {
		id: "thread",
		name: "Thread",
		keywords: [
			"needle",
			"sewing",
			"spool",
			"string"
		],
		skins: [
			{
				unified: "1f9f5",
				native: "🧵"
			}
		],
		version: 11
	},
	sewing_needle: {
		id: "sewing_needle",
		name: "Sewing Needle",
		keywords: [
			"stitches"
		],
		skins: [
			{
				unified: "1faa1",
				native: "🪡"
			}
		],
		version: 13
	},
	yarn: {
		id: "yarn",
		name: "Yarn",
		keywords: [
			"ball",
			"crochet",
			"knit"
		],
		skins: [
			{
				unified: "1f9f6",
				native: "🧶"
			}
		],
		version: 11
	},
	knot: {
		id: "knot",
		name: "Knot",
		keywords: [
			"rope",
			"scout"
		],
		skins: [
			{
				unified: "1faa2",
				native: "🪢"
			}
		],
		version: 13
	},
	eyeglasses: {
		id: "eyeglasses",
		name: "Glasses",
		keywords: [
			"eyeglasses",
			"fashion",
			"accessories",
			"eyesight",
			"nerdy",
			"dork",
			"geek"
		],
		skins: [
			{
				unified: "1f453",
				native: "👓"
			}
		],
		version: 1
	},
	dark_sunglasses: {
		id: "dark_sunglasses",
		name: "Sunglasses",
		keywords: [
			"dark",
			"face",
			"cool",
			"accessories"
		],
		skins: [
			{
				unified: "1f576-fe0f",
				native: "🕶️"
			}
		],
		version: 1
	},
	goggles: {
		id: "goggles",
		name: "Goggles",
		keywords: [
			"eyes",
			"protection",
			"safety"
		],
		skins: [
			{
				unified: "1f97d",
				native: "🥽"
			}
		],
		version: 11
	},
	lab_coat: {
		id: "lab_coat",
		name: "Lab Coat",
		keywords: [
			"doctor",
			"experiment",
			"scientist",
			"chemist"
		],
		skins: [
			{
				unified: "1f97c",
				native: "🥼"
			}
		],
		version: 11
	},
	safety_vest: {
		id: "safety_vest",
		name: "Safety Vest",
		keywords: [
			"protection"
		],
		skins: [
			{
				unified: "1f9ba",
				native: "🦺"
			}
		],
		version: 12
	},
	necktie: {
		id: "necktie",
		name: "Necktie",
		keywords: [
			"shirt",
			"suitup",
			"formal",
			"fashion",
			"cloth",
			"business"
		],
		skins: [
			{
				unified: "1f454",
				native: "👔"
			}
		],
		version: 1
	},
	shirt: {
		id: "shirt",
		name: "T-Shirt",
		keywords: [
			"shirt",
			"tshirt",
			"t",
			"fashion",
			"cloth",
			"casual",
			"tee"
		],
		skins: [
			{
				unified: "1f455",
				native: "👕"
			}
		],
		version: 1
	},
	jeans: {
		id: "jeans",
		name: "Jeans",
		keywords: [
			"fashion",
			"shopping"
		],
		skins: [
			{
				unified: "1f456",
				native: "👖"
			}
		],
		version: 1
	},
	scarf: {
		id: "scarf",
		name: "Scarf",
		keywords: [
			"neck",
			"winter",
			"clothes"
		],
		skins: [
			{
				unified: "1f9e3",
				native: "🧣"
			}
		],
		version: 5
	},
	gloves: {
		id: "gloves",
		name: "Gloves",
		keywords: [
			"hands",
			"winter",
			"clothes"
		],
		skins: [
			{
				unified: "1f9e4",
				native: "🧤"
			}
		],
		version: 5
	},
	coat: {
		id: "coat",
		name: "Coat",
		keywords: [
			"jacket"
		],
		skins: [
			{
				unified: "1f9e5",
				native: "🧥"
			}
		],
		version: 5
	},
	socks: {
		id: "socks",
		name: "Socks",
		keywords: [
			"stockings",
			"clothes"
		],
		skins: [
			{
				unified: "1f9e6",
				native: "🧦"
			}
		],
		version: 5
	},
	dress: {
		id: "dress",
		name: "Dress",
		keywords: [
			"clothes",
			"fashion",
			"shopping"
		],
		skins: [
			{
				unified: "1f457",
				native: "👗"
			}
		],
		version: 1
	},
	kimono: {
		id: "kimono",
		name: "Kimono",
		keywords: [
			"dress",
			"fashion",
			"women",
			"female",
			"japanese"
		],
		skins: [
			{
				unified: "1f458",
				native: "👘"
			}
		],
		version: 1
	},
	sari: {
		id: "sari",
		name: "Sari",
		keywords: [
			"dress"
		],
		skins: [
			{
				unified: "1f97b",
				native: "🥻"
			}
		],
		version: 12
	},
	"one-piece_swimsuit": {
		id: "one-piece_swimsuit",
		name: "One-Piece Swimsuit",
		keywords: [
			"one",
			"piece",
			"fashion"
		],
		skins: [
			{
				unified: "1fa71",
				native: "🩱"
			}
		],
		version: 12
	},
	briefs: {
		id: "briefs",
		name: "Briefs",
		keywords: [
			"clothing"
		],
		skins: [
			{
				unified: "1fa72",
				native: "🩲"
			}
		],
		version: 12
	},
	shorts: {
		id: "shorts",
		name: "Shorts",
		keywords: [
			"clothing"
		],
		skins: [
			{
				unified: "1fa73",
				native: "🩳"
			}
		],
		version: 12
	},
	bikini: {
		id: "bikini",
		name: "Bikini",
		keywords: [
			"swimming",
			"female",
			"woman",
			"girl",
			"fashion",
			"beach",
			"summer"
		],
		skins: [
			{
				unified: "1f459",
				native: "👙"
			}
		],
		version: 1
	},
	womans_clothes: {
		id: "womans_clothes",
		name: "Womans Clothes",
		keywords: [
			"woman",
			"s",
			"fashion",
			"shopping",
			"bags",
			"female"
		],
		skins: [
			{
				unified: "1f45a",
				native: "👚"
			}
		],
		version: 1
	},
	folding_hand_fan: {
		id: "folding_hand_fan",
		name: "Folding Hand Fan",
		keywords: [
			"flamenco",
			"hot"
		],
		skins: [
			{
				unified: "1faad",
				native: "🪭"
			}
		],
		version: 15
	},
	purse: {
		id: "purse",
		name: "Purse",
		keywords: [
			"fashion",
			"accessories",
			"money",
			"sales",
			"shopping"
		],
		skins: [
			{
				unified: "1f45b",
				native: "👛"
			}
		],
		version: 1
	},
	handbag: {
		id: "handbag",
		name: "Handbag",
		keywords: [
			"fashion",
			"accessory",
			"accessories",
			"shopping"
		],
		skins: [
			{
				unified: "1f45c",
				native: "👜"
			}
		],
		version: 1
	},
	pouch: {
		id: "pouch",
		name: "Pouch",
		keywords: [
			"clutch",
			"bag",
			"accessories",
			"shopping"
		],
		skins: [
			{
				unified: "1f45d",
				native: "👝"
			}
		],
		version: 1
	},
	shopping_bags: {
		id: "shopping_bags",
		name: "Shopping Bags",
		keywords: [
			"mall",
			"buy",
			"purchase"
		],
		skins: [
			{
				unified: "1f6cd-fe0f",
				native: "🛍️"
			}
		],
		version: 1
	},
	school_satchel: {
		id: "school_satchel",
		name: "Backpack",
		keywords: [
			"school",
			"satchel",
			"student",
			"education",
			"bag"
		],
		skins: [
			{
				unified: "1f392",
				native: "🎒"
			}
		],
		version: 1
	},
	thong_sandal: {
		id: "thong_sandal",
		name: "Thong Sandal",
		keywords: [
			"footwear",
			"summer"
		],
		skins: [
			{
				unified: "1fa74",
				native: "🩴"
			}
		],
		version: 13
	},
	mans_shoe: {
		id: "mans_shoe",
		name: "Mans Shoe",
		keywords: [
			"man",
			"s",
			"fashion",
			"male"
		],
		skins: [
			{
				unified: "1f45e",
				native: "👞"
			}
		],
		version: 1
	},
	athletic_shoe: {
		id: "athletic_shoe",
		name: "Running Shoe",
		keywords: [
			"athletic",
			"shoes",
			"sports",
			"sneakers"
		],
		skins: [
			{
				unified: "1f45f",
				native: "👟"
			}
		],
		version: 1
	},
	hiking_boot: {
		id: "hiking_boot",
		name: "Hiking Boot",
		keywords: [
			"backpacking",
			"camping"
		],
		skins: [
			{
				unified: "1f97e",
				native: "🥾"
			}
		],
		version: 11
	},
	womans_flat_shoe: {
		id: "womans_flat_shoe",
		name: "Flat Shoe",
		keywords: [
			"womans",
			"ballet",
			"slip",
			"on",
			"slipper"
		],
		skins: [
			{
				unified: "1f97f",
				native: "🥿"
			}
		],
		version: 11
	},
	high_heel: {
		id: "high_heel",
		name: "High-Heeled Shoe",
		keywords: [
			"high",
			"heel",
			"heeled",
			"fashion",
			"shoes",
			"female",
			"pumps",
			"stiletto"
		],
		skins: [
			{
				unified: "1f460",
				native: "👠"
			}
		],
		version: 1
	},
	sandal: {
		id: "sandal",
		name: "Womans Sandal",
		keywords: [
			"woman",
			"s",
			"shoes",
			"fashion",
			"flip",
			"flops"
		],
		skins: [
			{
				unified: "1f461",
				native: "👡"
			}
		],
		version: 1
	},
	ballet_shoes: {
		id: "ballet_shoes",
		name: "Ballet Shoes",
		keywords: [
			"dance"
		],
		skins: [
			{
				unified: "1fa70",
				native: "🩰"
			}
		],
		version: 12
	},
	boot: {
		id: "boot",
		name: "Womans Boots",
		keywords: [
			"boot",
			"woman",
			"s",
			"shoes",
			"fashion"
		],
		skins: [
			{
				unified: "1f462",
				native: "👢"
			}
		],
		version: 1
	},
	hair_pick: {
		id: "hair_pick",
		name: "Hair Pick",
		keywords: [
			"afro",
			"comb"
		],
		skins: [
			{
				unified: "1faae",
				native: "🪮"
			}
		],
		version: 15
	},
	crown: {
		id: "crown",
		name: "Crown",
		keywords: [
			"king",
			"kod",
			"leader",
			"royalty",
			"lord"
		],
		skins: [
			{
				unified: "1f451",
				native: "👑"
			}
		],
		version: 1
	},
	womans_hat: {
		id: "womans_hat",
		name: "Womans Hat",
		keywords: [
			"woman",
			"s",
			"fashion",
			"accessories",
			"female",
			"lady",
			"spring"
		],
		skins: [
			{
				unified: "1f452",
				native: "👒"
			}
		],
		version: 1
	},
	tophat: {
		id: "tophat",
		name: "Top Hat",
		keywords: [
			"tophat",
			"magic",
			"gentleman",
			"classy",
			"circus"
		],
		skins: [
			{
				unified: "1f3a9",
				native: "🎩"
			}
		],
		version: 1
	},
	mortar_board: {
		id: "mortar_board",
		name: "Graduation Cap",
		keywords: [
			"mortar",
			"board",
			"school",
			"college",
			"degree",
			"university",
			"hat",
			"legal",
			"learn",
			"education"
		],
		skins: [
			{
				unified: "1f393",
				native: "🎓"
			}
		],
		version: 1
	},
	billed_cap: {
		id: "billed_cap",
		name: "Billed Cap",
		keywords: [
			"baseball"
		],
		skins: [
			{
				unified: "1f9e2",
				native: "🧢"
			}
		],
		version: 5
	},
	military_helmet: {
		id: "military_helmet",
		name: "Military Helmet",
		keywords: [
			"army",
			"protection"
		],
		skins: [
			{
				unified: "1fa96",
				native: "🪖"
			}
		],
		version: 13
	},
	helmet_with_white_cross: {
		id: "helmet_with_white_cross",
		name: "Rescue Worker’s Helmet",
		keywords: [
			"with",
			"white",
			"cross",
			"worker",
			"s",
			"construction",
			"build"
		],
		skins: [
			{
				unified: "26d1-fe0f",
				native: "⛑️"
			}
		],
		version: 1
	},
	prayer_beads: {
		id: "prayer_beads",
		name: "Prayer Beads",
		keywords: [
			"dhikr",
			"religious"
		],
		skins: [
			{
				unified: "1f4ff",
				native: "📿"
			}
		],
		version: 1
	},
	lipstick: {
		id: "lipstick",
		name: "Lipstick",
		keywords: [
			"female",
			"girl",
			"fashion",
			"woman"
		],
		skins: [
			{
				unified: "1f484",
				native: "💄"
			}
		],
		version: 1
	},
	ring: {
		id: "ring",
		name: "Ring",
		keywords: [
			"wedding",
			"propose",
			"marriage",
			"valentines",
			"diamond",
			"fashion",
			"jewelry",
			"gem",
			"engagement"
		],
		skins: [
			{
				unified: "1f48d",
				native: "💍"
			}
		],
		version: 1
	},
	gem: {
		id: "gem",
		name: "Gem Stone",
		keywords: [
			"blue",
			"ruby",
			"diamond",
			"jewelry"
		],
		skins: [
			{
				unified: "1f48e",
				native: "💎"
			}
		],
		version: 1
	},
	mute: {
		id: "mute",
		name: "Muted Speaker",
		keywords: [
			"mute",
			"sound",
			"volume",
			"silence",
			"quiet"
		],
		skins: [
			{
				unified: "1f507",
				native: "🔇"
			}
		],
		version: 1
	},
	speaker: {
		id: "speaker",
		name: "Speaker",
		keywords: [
			"low",
			"volume",
			"sound",
			"silence",
			"broadcast"
		],
		skins: [
			{
				unified: "1f508",
				native: "🔈"
			}
		],
		version: 1
	},
	sound: {
		id: "sound",
		name: "Speaker Medium Volume",
		keywords: [
			"sound",
			"broadcast"
		],
		skins: [
			{
				unified: "1f509",
				native: "🔉"
			}
		],
		version: 1
	},
	loud_sound: {
		id: "loud_sound",
		name: "Speaker High Volume",
		keywords: [
			"loud",
			"sound",
			"noise",
			"noisy",
			"broadcast"
		],
		skins: [
			{
				unified: "1f50a",
				native: "🔊"
			}
		],
		version: 1
	},
	loudspeaker: {
		id: "loudspeaker",
		name: "Loudspeaker",
		keywords: [
			"volume",
			"sound"
		],
		skins: [
			{
				unified: "1f4e2",
				native: "📢"
			}
		],
		version: 1
	},
	mega: {
		id: "mega",
		name: "Megaphone",
		keywords: [
			"mega",
			"sound",
			"speaker",
			"volume"
		],
		skins: [
			{
				unified: "1f4e3",
				native: "📣"
			}
		],
		version: 1
	},
	postal_horn: {
		id: "postal_horn",
		name: "Postal Horn",
		keywords: [
			"instrument",
			"music"
		],
		skins: [
			{
				unified: "1f4ef",
				native: "📯"
			}
		],
		version: 1
	},
	bell: {
		id: "bell",
		name: "Bell",
		keywords: [
			"sound",
			"notification",
			"christmas",
			"xmas",
			"chime"
		],
		skins: [
			{
				unified: "1f514",
				native: "🔔"
			}
		],
		version: 1
	},
	no_bell: {
		id: "no_bell",
		name: "Bell with Slash",
		keywords: [
			"no",
			"sound",
			"volume",
			"mute",
			"quiet",
			"silent"
		],
		skins: [
			{
				unified: "1f515",
				native: "🔕"
			}
		],
		version: 1
	},
	musical_score: {
		id: "musical_score",
		name: "Musical Score",
		keywords: [
			"treble",
			"clef",
			"compose"
		],
		skins: [
			{
				unified: "1f3bc",
				native: "🎼"
			}
		],
		version: 1
	},
	musical_note: {
		id: "musical_note",
		name: "Musical Note",
		keywords: [
			"score",
			"tone",
			"sound"
		],
		skins: [
			{
				unified: "1f3b5",
				native: "🎵"
			}
		],
		version: 1
	},
	notes: {
		id: "notes",
		name: "Musical Notes",
		keywords: [
			"music",
			"score"
		],
		skins: [
			{
				unified: "1f3b6",
				native: "🎶"
			}
		],
		version: 1
	},
	studio_microphone: {
		id: "studio_microphone",
		name: "Studio Microphone",
		keywords: [
			"sing",
			"recording",
			"artist",
			"talkshow"
		],
		skins: [
			{
				unified: "1f399-fe0f",
				native: "🎙️"
			}
		],
		version: 1
	},
	level_slider: {
		id: "level_slider",
		name: "Level Slider",
		keywords: [
			"scale"
		],
		skins: [
			{
				unified: "1f39a-fe0f",
				native: "🎚️"
			}
		],
		version: 1
	},
	control_knobs: {
		id: "control_knobs",
		name: "Control Knobs",
		keywords: [
			"dial"
		],
		skins: [
			{
				unified: "1f39b-fe0f",
				native: "🎛️"
			}
		],
		version: 1
	},
	microphone: {
		id: "microphone",
		name: "Microphone",
		keywords: [
			"sound",
			"music",
			"PA",
			"sing",
			"talkshow"
		],
		skins: [
			{
				unified: "1f3a4",
				native: "🎤"
			}
		],
		version: 1
	},
	headphones: {
		id: "headphones",
		name: "Headphone",
		keywords: [
			"headphones",
			"music",
			"score",
			"gadgets"
		],
		skins: [
			{
				unified: "1f3a7",
				native: "🎧"
			}
		],
		version: 1
	},
	radio: {
		id: "radio",
		name: "Radio",
		keywords: [
			"communication",
			"music",
			"podcast",
			"program"
		],
		skins: [
			{
				unified: "1f4fb",
				native: "📻"
			}
		],
		version: 1
	},
	saxophone: {
		id: "saxophone",
		name: "Saxophone",
		keywords: [
			"music",
			"instrument",
			"jazz",
			"blues"
		],
		skins: [
			{
				unified: "1f3b7",
				native: "🎷"
			}
		],
		version: 1
	},
	accordion: {
		id: "accordion",
		name: "Accordion",
		keywords: [
			"music"
		],
		skins: [
			{
				unified: "1fa97",
				native: "🪗"
			}
		],
		version: 13
	},
	guitar: {
		id: "guitar",
		name: "Guitar",
		keywords: [
			"music",
			"instrument"
		],
		skins: [
			{
				unified: "1f3b8",
				native: "🎸"
			}
		],
		version: 1
	},
	musical_keyboard: {
		id: "musical_keyboard",
		name: "Musical Keyboard",
		keywords: [
			"piano",
			"instrument",
			"compose"
		],
		skins: [
			{
				unified: "1f3b9",
				native: "🎹"
			}
		],
		version: 1
	},
	trumpet: {
		id: "trumpet",
		name: "Trumpet",
		keywords: [
			"music",
			"brass"
		],
		skins: [
			{
				unified: "1f3ba",
				native: "🎺"
			}
		],
		version: 1
	},
	violin: {
		id: "violin",
		name: "Violin",
		keywords: [
			"music",
			"instrument",
			"orchestra",
			"symphony"
		],
		skins: [
			{
				unified: "1f3bb",
				native: "🎻"
			}
		],
		version: 1
	},
	banjo: {
		id: "banjo",
		name: "Banjo",
		keywords: [
			"music",
			"instructment"
		],
		skins: [
			{
				unified: "1fa95",
				native: "🪕"
			}
		],
		version: 12
	},
	drum_with_drumsticks: {
		id: "drum_with_drumsticks",
		name: "Drum",
		keywords: [
			"with",
			"drumsticks",
			"music",
			"instrument",
			"snare"
		],
		skins: [
			{
				unified: "1f941",
				native: "🥁"
			}
		],
		version: 3
	},
	long_drum: {
		id: "long_drum",
		name: "Long Drum",
		keywords: [
			"music"
		],
		skins: [
			{
				unified: "1fa98",
				native: "🪘"
			}
		],
		version: 13
	},
	maracas: {
		id: "maracas",
		name: "Maracas",
		keywords: [
			"music",
			"instrument",
			"percussion"
		],
		skins: [
			{
				unified: "1fa87",
				native: "🪇"
			}
		],
		version: 15
	},
	flute: {
		id: "flute",
		name: "Flute",
		keywords: [
			"bamboo",
			"music",
			"instrument",
			"pied",
			"piper"
		],
		skins: [
			{
				unified: "1fa88",
				native: "🪈"
			}
		],
		version: 15
	},
	iphone: {
		id: "iphone",
		name: "Mobile Phone",
		keywords: [
			"iphone",
			"technology",
			"apple",
			"gadgets",
			"dial"
		],
		skins: [
			{
				unified: "1f4f1",
				native: "📱"
			}
		],
		version: 1
	},
	calling: {
		id: "calling",
		name: "Mobile Phone with Arrow",
		keywords: [
			"calling",
			"iphone",
			"incoming"
		],
		skins: [
			{
				unified: "1f4f2",
				native: "📲"
			}
		],
		version: 1
	},
	phone: {
		id: "phone",
		name: "Telephone",
		keywords: [
			"phone",
			"technology",
			"communication",
			"dial"
		],
		skins: [
			{
				unified: "260e-fe0f",
				native: "☎️"
			}
		],
		version: 1
	},
	telephone_receiver: {
		id: "telephone_receiver",
		name: "Telephone Receiver",
		keywords: [
			"technology",
			"communication",
			"dial"
		],
		skins: [
			{
				unified: "1f4de",
				native: "📞"
			}
		],
		version: 1
	},
	pager: {
		id: "pager",
		name: "Pager",
		keywords: [
			"bbcall",
			"oldschool",
			"90s"
		],
		skins: [
			{
				unified: "1f4df",
				native: "📟"
			}
		],
		version: 1
	},
	fax: {
		id: "fax",
		name: "Fax Machine",
		keywords: [
			"communication",
			"technology"
		],
		skins: [
			{
				unified: "1f4e0",
				native: "📠"
			}
		],
		version: 1
	},
	battery: {
		id: "battery",
		name: "Battery",
		keywords: [
			"power",
			"energy",
			"sustain"
		],
		skins: [
			{
				unified: "1f50b",
				native: "🔋"
			}
		],
		version: 1
	},
	low_battery: {
		id: "low_battery",
		name: "Low Battery",
		keywords: [
			"drained",
			"dead"
		],
		skins: [
			{
				unified: "1faab",
				native: "🪫"
			}
		],
		version: 14
	},
	electric_plug: {
		id: "electric_plug",
		name: "Electric Plug",
		keywords: [
			"charger",
			"power"
		],
		skins: [
			{
				unified: "1f50c",
				native: "🔌"
			}
		],
		version: 1
	},
	computer: {
		id: "computer",
		name: "Laptop",
		keywords: [
			"computer",
			"technology",
			"screen",
			"display",
			"monitor"
		],
		skins: [
			{
				unified: "1f4bb",
				native: "💻"
			}
		],
		version: 1
	},
	desktop_computer: {
		id: "desktop_computer",
		name: "Desktop Computer",
		keywords: [
			"technology",
			"computing",
			"screen"
		],
		skins: [
			{
				unified: "1f5a5-fe0f",
				native: "🖥️"
			}
		],
		version: 1
	},
	printer: {
		id: "printer",
		name: "Printer",
		keywords: [
			"paper",
			"ink"
		],
		skins: [
			{
				unified: "1f5a8-fe0f",
				native: "🖨️"
			}
		],
		version: 1
	},
	keyboard: {
		id: "keyboard",
		name: "Keyboard",
		keywords: [
			"technology",
			"computer",
			"type",
			"input",
			"text"
		],
		skins: [
			{
				unified: "2328-fe0f",
				native: "⌨️"
			}
		],
		version: 1
	},
	three_button_mouse: {
		id: "three_button_mouse",
		name: "Computer Mouse",
		keywords: [
			"three",
			"button",
			"click"
		],
		skins: [
			{
				unified: "1f5b1-fe0f",
				native: "🖱️"
			}
		],
		version: 1
	},
	trackball: {
		id: "trackball",
		name: "Trackball",
		keywords: [
			"technology",
			"trackpad"
		],
		skins: [
			{
				unified: "1f5b2-fe0f",
				native: "🖲️"
			}
		],
		version: 1
	},
	minidisc: {
		id: "minidisc",
		name: "Minidisc",
		keywords: [
			"computer",
			"disk",
			"technology",
			"record",
			"data",
			"90s"
		],
		skins: [
			{
				unified: "1f4bd",
				native: "💽"
			}
		],
		version: 1
	},
	floppy_disk: {
		id: "floppy_disk",
		name: "Floppy Disk",
		keywords: [
			"oldschool",
			"technology",
			"save",
			"90s",
			"80s"
		],
		skins: [
			{
				unified: "1f4be",
				native: "💾"
			}
		],
		version: 1
	},
	cd: {
		id: "cd",
		name: "Optical Disc",
		keywords: [
			"cd",
			"disk",
			"technology",
			"dvd",
			"90s"
		],
		skins: [
			{
				unified: "1f4bf",
				native: "💿"
			}
		],
		version: 1
	},
	dvd: {
		id: "dvd",
		name: "Dvd",
		keywords: [
			"cd",
			"disk",
			"disc"
		],
		skins: [
			{
				unified: "1f4c0",
				native: "📀"
			}
		],
		version: 1
	},
	abacus: {
		id: "abacus",
		name: "Abacus",
		keywords: [
			"calculation"
		],
		skins: [
			{
				unified: "1f9ee",
				native: "🧮"
			}
		],
		version: 11
	},
	movie_camera: {
		id: "movie_camera",
		name: "Movie Camera",
		keywords: [
			"film",
			"record"
		],
		skins: [
			{
				unified: "1f3a5",
				native: "🎥"
			}
		],
		version: 1
	},
	film_frames: {
		id: "film_frames",
		name: "Film Frames",
		keywords: [
			"movie"
		],
		skins: [
			{
				unified: "1f39e-fe0f",
				native: "🎞️"
			}
		],
		version: 1
	},
	film_projector: {
		id: "film_projector",
		name: "Film Projector",
		keywords: [
			"video",
			"tape",
			"record",
			"movie"
		],
		skins: [
			{
				unified: "1f4fd-fe0f",
				native: "📽️"
			}
		],
		version: 1
	},
	clapper: {
		id: "clapper",
		name: "Clapper Board",
		keywords: [
			"movie",
			"film",
			"record"
		],
		skins: [
			{
				unified: "1f3ac",
				native: "🎬"
			}
		],
		version: 1
	},
	tv: {
		id: "tv",
		name: "Television",
		keywords: [
			"tv",
			"technology",
			"program",
			"oldschool",
			"show"
		],
		skins: [
			{
				unified: "1f4fa",
				native: "📺"
			}
		],
		version: 1
	},
	camera: {
		id: "camera",
		name: "Camera",
		keywords: [
			"gadgets",
			"photography"
		],
		skins: [
			{
				unified: "1f4f7",
				native: "📷"
			}
		],
		version: 1
	},
	camera_with_flash: {
		id: "camera_with_flash",
		name: "Camera with Flash",
		keywords: [
			"photography",
			"gadgets"
		],
		skins: [
			{
				unified: "1f4f8",
				native: "📸"
			}
		],
		version: 1
	},
	video_camera: {
		id: "video_camera",
		name: "Video Camera",
		keywords: [
			"film",
			"record"
		],
		skins: [
			{
				unified: "1f4f9",
				native: "📹"
			}
		],
		version: 1
	},
	vhs: {
		id: "vhs",
		name: "Videocassette",
		keywords: [
			"vhs",
			"record",
			"video",
			"oldschool",
			"90s",
			"80s"
		],
		skins: [
			{
				unified: "1f4fc",
				native: "📼"
			}
		],
		version: 1
	},
	mag: {
		id: "mag",
		name: "Magnifying Glass Tilted Left",
		keywords: [
			"mag",
			"search",
			"zoom",
			"find",
			"detective"
		],
		skins: [
			{
				unified: "1f50d",
				native: "🔍"
			}
		],
		version: 1
	},
	mag_right: {
		id: "mag_right",
		name: "Magnifying Glass Tilted Right",
		keywords: [
			"mag",
			"search",
			"zoom",
			"find",
			"detective"
		],
		skins: [
			{
				unified: "1f50e",
				native: "🔎"
			}
		],
		version: 1
	},
	candle: {
		id: "candle",
		name: "Candle",
		keywords: [
			"fire",
			"wax"
		],
		skins: [
			{
				unified: "1f56f-fe0f",
				native: "🕯️"
			}
		],
		version: 1
	},
	bulb: {
		id: "bulb",
		name: "Light Bulb",
		keywords: [
			"electricity",
			"idea"
		],
		skins: [
			{
				unified: "1f4a1",
				native: "💡"
			}
		],
		version: 1
	},
	flashlight: {
		id: "flashlight",
		name: "Flashlight",
		keywords: [
			"dark",
			"camping",
			"sight",
			"night"
		],
		skins: [
			{
				unified: "1f526",
				native: "🔦"
			}
		],
		version: 1
	},
	izakaya_lantern: {
		id: "izakaya_lantern",
		name: "Izakaya Lantern",
		keywords: [
			"red",
			"paper",
			"light",
			"halloween",
			"spooky"
		],
		skins: [
			{
				unified: "1f3ee",
				native: "🏮"
			}
		],
		version: 1
	},
	diya_lamp: {
		id: "diya_lamp",
		name: "Diya Lamp",
		keywords: [
			"lighting"
		],
		skins: [
			{
				unified: "1fa94",
				native: "🪔"
			}
		],
		version: 12
	},
	notebook_with_decorative_cover: {
		id: "notebook_with_decorative_cover",
		name: "Notebook with Decorative Cover",
		keywords: [
			"classroom",
			"notes",
			"record",
			"paper",
			"study"
		],
		skins: [
			{
				unified: "1f4d4",
				native: "📔"
			}
		],
		version: 1
	},
	closed_book: {
		id: "closed_book",
		name: "Closed Book",
		keywords: [
			"read",
			"library",
			"knowledge",
			"textbook",
			"learn"
		],
		skins: [
			{
				unified: "1f4d5",
				native: "📕"
			}
		],
		version: 1
	},
	book: {
		id: "book",
		name: "Open Book",
		keywords: [
			"read",
			"library",
			"knowledge",
			"literature",
			"learn",
			"study"
		],
		skins: [
			{
				unified: "1f4d6",
				native: "📖"
			}
		],
		version: 1
	},
	green_book: {
		id: "green_book",
		name: "Green Book",
		keywords: [
			"read",
			"library",
			"knowledge",
			"study"
		],
		skins: [
			{
				unified: "1f4d7",
				native: "📗"
			}
		],
		version: 1
	},
	blue_book: {
		id: "blue_book",
		name: "Blue Book",
		keywords: [
			"read",
			"library",
			"knowledge",
			"learn",
			"study"
		],
		skins: [
			{
				unified: "1f4d8",
				native: "📘"
			}
		],
		version: 1
	},
	orange_book: {
		id: "orange_book",
		name: "Orange Book",
		keywords: [
			"read",
			"library",
			"knowledge",
			"textbook",
			"study"
		],
		skins: [
			{
				unified: "1f4d9",
				native: "📙"
			}
		],
		version: 1
	},
	books: {
		id: "books",
		name: "Books",
		keywords: [
			"literature",
			"library",
			"study"
		],
		skins: [
			{
				unified: "1f4da",
				native: "📚"
			}
		],
		version: 1
	},
	notebook: {
		id: "notebook",
		name: "Notebook",
		keywords: [
			"stationery",
			"record",
			"notes",
			"paper",
			"study"
		],
		skins: [
			{
				unified: "1f4d3",
				native: "📓"
			}
		],
		version: 1
	},
	ledger: {
		id: "ledger",
		name: "Ledger",
		keywords: [
			"notes",
			"paper"
		],
		skins: [
			{
				unified: "1f4d2",
				native: "📒"
			}
		],
		version: 1
	},
	page_with_curl: {
		id: "page_with_curl",
		name: "Page with Curl",
		keywords: [
			"documents",
			"office",
			"paper"
		],
		skins: [
			{
				unified: "1f4c3",
				native: "📃"
			}
		],
		version: 1
	},
	scroll: {
		id: "scroll",
		name: "Scroll",
		keywords: [
			"documents",
			"ancient",
			"history",
			"paper"
		],
		skins: [
			{
				unified: "1f4dc",
				native: "📜"
			}
		],
		version: 1
	},
	page_facing_up: {
		id: "page_facing_up",
		name: "Page Facing Up",
		keywords: [
			"documents",
			"office",
			"paper",
			"information"
		],
		skins: [
			{
				unified: "1f4c4",
				native: "📄"
			}
		],
		version: 1
	},
	newspaper: {
		id: "newspaper",
		name: "Newspaper",
		keywords: [
			"press",
			"headline"
		],
		skins: [
			{
				unified: "1f4f0",
				native: "📰"
			}
		],
		version: 1
	},
	rolled_up_newspaper: {
		id: "rolled_up_newspaper",
		name: "Rolled-Up Newspaper",
		keywords: [
			"rolled",
			"up",
			"press",
			"headline"
		],
		skins: [
			{
				unified: "1f5de-fe0f",
				native: "🗞️"
			}
		],
		version: 1
	},
	bookmark_tabs: {
		id: "bookmark_tabs",
		name: "Bookmark Tabs",
		keywords: [
			"favorite",
			"save",
			"order",
			"tidy"
		],
		skins: [
			{
				unified: "1f4d1",
				native: "📑"
			}
		],
		version: 1
	},
	bookmark: {
		id: "bookmark",
		name: "Bookmark",
		keywords: [
			"favorite",
			"label",
			"save"
		],
		skins: [
			{
				unified: "1f516",
				native: "🔖"
			}
		],
		version: 1
	},
	label: {
		id: "label",
		name: "Label",
		keywords: [
			"sale",
			"tag"
		],
		skins: [
			{
				unified: "1f3f7-fe0f",
				native: "🏷️"
			}
		],
		version: 1
	},
	moneybag: {
		id: "moneybag",
		name: "Money Bag",
		keywords: [
			"moneybag",
			"dollar",
			"payment",
			"coins",
			"sale"
		],
		skins: [
			{
				unified: "1f4b0",
				native: "💰"
			}
		],
		version: 1
	},
	coin: {
		id: "coin",
		name: "Coin",
		keywords: [
			"money",
			"currency"
		],
		skins: [
			{
				unified: "1fa99",
				native: "🪙"
			}
		],
		version: 13
	},
	yen: {
		id: "yen",
		name: "Yen Banknote",
		keywords: [
			"money",
			"sales",
			"japanese",
			"dollar",
			"currency"
		],
		skins: [
			{
				unified: "1f4b4",
				native: "💴"
			}
		],
		version: 1
	},
	dollar: {
		id: "dollar",
		name: "Dollar Banknote",
		keywords: [
			"money",
			"sales",
			"bill",
			"currency"
		],
		skins: [
			{
				unified: "1f4b5",
				native: "💵"
			}
		],
		version: 1
	},
	euro: {
		id: "euro",
		name: "Euro Banknote",
		keywords: [
			"money",
			"sales",
			"dollar",
			"currency"
		],
		skins: [
			{
				unified: "1f4b6",
				native: "💶"
			}
		],
		version: 1
	},
	pound: {
		id: "pound",
		name: "Pound Banknote",
		keywords: [
			"british",
			"sterling",
			"money",
			"sales",
			"bills",
			"uk",
			"england",
			"currency"
		],
		skins: [
			{
				unified: "1f4b7",
				native: "💷"
			}
		],
		version: 1
	},
	money_with_wings: {
		id: "money_with_wings",
		name: "Money with Wings",
		keywords: [
			"dollar",
			"bills",
			"payment",
			"sale"
		],
		skins: [
			{
				unified: "1f4b8",
				native: "💸"
			}
		],
		version: 1
	},
	credit_card: {
		id: "credit_card",
		name: "Credit Card",
		keywords: [
			"money",
			"sales",
			"dollar",
			"bill",
			"payment",
			"shopping"
		],
		skins: [
			{
				unified: "1f4b3",
				native: "💳"
			}
		],
		version: 1
	},
	receipt: {
		id: "receipt",
		name: "Receipt",
		keywords: [
			"accounting",
			"expenses"
		],
		skins: [
			{
				unified: "1f9fe",
				native: "🧾"
			}
		],
		version: 11
	},
	chart: {
		id: "chart",
		name: "Chart Increasing with Yen",
		keywords: [
			"green",
			"square",
			"graph",
			"presentation",
			"stats"
		],
		skins: [
			{
				unified: "1f4b9",
				native: "💹"
			}
		],
		version: 1
	},
	email: {
		id: "email",
		name: "Envelope",
		keywords: [
			"email",
			"letter",
			"postal",
			"inbox",
			"communication"
		],
		skins: [
			{
				unified: "2709-fe0f",
				native: "✉️"
			}
		],
		version: 1
	},
	"e-mail": {
		id: "e-mail",
		name: "E-Mail",
		keywords: [
			"e",
			"mail",
			"communication",
			"inbox"
		],
		skins: [
			{
				unified: "1f4e7",
				native: "📧"
			}
		],
		version: 1
	},
	incoming_envelope: {
		id: "incoming_envelope",
		name: "Incoming Envelope",
		keywords: [
			"email",
			"inbox"
		],
		skins: [
			{
				unified: "1f4e8",
				native: "📨"
			}
		],
		version: 1
	},
	envelope_with_arrow: {
		id: "envelope_with_arrow",
		name: "Envelope with Arrow",
		keywords: [
			"email",
			"communication"
		],
		skins: [
			{
				unified: "1f4e9",
				native: "📩"
			}
		],
		version: 1
	},
	outbox_tray: {
		id: "outbox_tray",
		name: "Outbox Tray",
		keywords: [
			"inbox",
			"email"
		],
		skins: [
			{
				unified: "1f4e4",
				native: "📤"
			}
		],
		version: 1
	},
	inbox_tray: {
		id: "inbox_tray",
		name: "Inbox Tray",
		keywords: [
			"email",
			"documents"
		],
		skins: [
			{
				unified: "1f4e5",
				native: "📥"
			}
		],
		version: 1
	},
	"package": {
		id: "package",
		name: "Package",
		keywords: [
			"mail",
			"gift",
			"cardboard",
			"box",
			"moving"
		],
		skins: [
			{
				unified: "1f4e6",
				native: "📦"
			}
		],
		version: 1
	},
	mailbox: {
		id: "mailbox",
		name: "Closed Mailbox with Raised Flag",
		keywords: [
			"email",
			"inbox",
			"communication"
		],
		skins: [
			{
				unified: "1f4eb",
				native: "📫"
			}
		],
		version: 1
	},
	mailbox_closed: {
		id: "mailbox_closed",
		name: "Closed Mailbox with Lowered Flag",
		keywords: [
			"email",
			"communication",
			"inbox"
		],
		skins: [
			{
				unified: "1f4ea",
				native: "📪"
			}
		],
		version: 1
	},
	mailbox_with_mail: {
		id: "mailbox_with_mail",
		name: "Open Mailbox with Raised Flag",
		keywords: [
			"mail",
			"email",
			"inbox",
			"communication"
		],
		skins: [
			{
				unified: "1f4ec",
				native: "📬"
			}
		],
		version: 1
	},
	mailbox_with_no_mail: {
		id: "mailbox_with_no_mail",
		name: "Open Mailbox with Lowered Flag",
		keywords: [
			"no",
			"mail",
			"email",
			"inbox"
		],
		skins: [
			{
				unified: "1f4ed",
				native: "📭"
			}
		],
		version: 1
	},
	postbox: {
		id: "postbox",
		name: "Postbox",
		keywords: [
			"email",
			"letter",
			"envelope"
		],
		skins: [
			{
				unified: "1f4ee",
				native: "📮"
			}
		],
		version: 1
	},
	ballot_box_with_ballot: {
		id: "ballot_box_with_ballot",
		name: "Ballot Box with Ballot",
		keywords: [
			"election",
			"vote"
		],
		skins: [
			{
				unified: "1f5f3-fe0f",
				native: "🗳️"
			}
		],
		version: 1
	},
	pencil2: {
		id: "pencil2",
		name: "Pencil",
		keywords: [
			"pencil2",
			"stationery",
			"write",
			"paper",
			"writing",
			"school",
			"study"
		],
		skins: [
			{
				unified: "270f-fe0f",
				native: "✏️"
			}
		],
		version: 1
	},
	black_nib: {
		id: "black_nib",
		name: "Black Nib",
		keywords: [
			"pen",
			"stationery",
			"writing",
			"write"
		],
		skins: [
			{
				unified: "2712-fe0f",
				native: "✒️"
			}
		],
		version: 1
	},
	lower_left_fountain_pen: {
		id: "lower_left_fountain_pen",
		name: "Fountain Pen",
		keywords: [
			"lower",
			"left",
			"stationery",
			"writing",
			"write"
		],
		skins: [
			{
				unified: "1f58b-fe0f",
				native: "🖋️"
			}
		],
		version: 1
	},
	lower_left_ballpoint_pen: {
		id: "lower_left_ballpoint_pen",
		name: "Pen",
		keywords: [
			"lower",
			"left",
			"ballpoint",
			"stationery",
			"writing",
			"write"
		],
		skins: [
			{
				unified: "1f58a-fe0f",
				native: "🖊️"
			}
		],
		version: 1
	},
	lower_left_paintbrush: {
		id: "lower_left_paintbrush",
		name: "Paintbrush",
		keywords: [
			"lower",
			"left",
			"drawing",
			"creativity",
			"art"
		],
		skins: [
			{
				unified: "1f58c-fe0f",
				native: "🖌️"
			}
		],
		version: 1
	},
	lower_left_crayon: {
		id: "lower_left_crayon",
		name: "Crayon",
		keywords: [
			"lower",
			"left",
			"drawing",
			"creativity"
		],
		skins: [
			{
				unified: "1f58d-fe0f",
				native: "🖍️"
			}
		],
		version: 1
	},
	memo: {
		id: "memo",
		name: "Memo",
		keywords: [
			"pencil",
			"write",
			"documents",
			"stationery",
			"paper",
			"writing",
			"legal",
			"exam",
			"quiz",
			"test",
			"study",
			"compose"
		],
		skins: [
			{
				unified: "1f4dd",
				native: "📝"
			}
		],
		version: 1
	},
	briefcase: {
		id: "briefcase",
		name: "Briefcase",
		keywords: [
			"business",
			"documents",
			"work",
			"law",
			"legal",
			"job",
			"career"
		],
		skins: [
			{
				unified: "1f4bc",
				native: "💼"
			}
		],
		version: 1
	},
	file_folder: {
		id: "file_folder",
		name: "File Folder",
		keywords: [
			"documents",
			"business",
			"office"
		],
		skins: [
			{
				unified: "1f4c1",
				native: "📁"
			}
		],
		version: 1
	},
	open_file_folder: {
		id: "open_file_folder",
		name: "Open File Folder",
		keywords: [
			"documents",
			"load"
		],
		skins: [
			{
				unified: "1f4c2",
				native: "📂"
			}
		],
		version: 1
	},
	card_index_dividers: {
		id: "card_index_dividers",
		name: "Card Index Dividers",
		keywords: [
			"organizing",
			"business",
			"stationery"
		],
		skins: [
			{
				unified: "1f5c2-fe0f",
				native: "🗂️"
			}
		],
		version: 1
	},
	date: {
		id: "date",
		name: "Calendar",
		keywords: [
			"date",
			"schedule"
		],
		skins: [
			{
				unified: "1f4c5",
				native: "📅"
			}
		],
		version: 1
	},
	calendar: {
		id: "calendar",
		name: "Tear-off Calendar",
		keywords: [
			"tear",
			"off",
			"schedule",
			"date",
			"planning"
		],
		skins: [
			{
				unified: "1f4c6",
				native: "📆"
			}
		],
		version: 1
	},
	spiral_note_pad: {
		id: "spiral_note_pad",
		name: "Spiral Notepad",
		keywords: [
			"note",
			"pad",
			"memo",
			"stationery"
		],
		skins: [
			{
				unified: "1f5d2-fe0f",
				native: "🗒️"
			}
		],
		version: 1
	},
	spiral_calendar_pad: {
		id: "spiral_calendar_pad",
		name: "Spiral Calendar",
		keywords: [
			"pad",
			"date",
			"schedule",
			"planning"
		],
		skins: [
			{
				unified: "1f5d3-fe0f",
				native: "🗓️"
			}
		],
		version: 1
	},
	card_index: {
		id: "card_index",
		name: "Card Index",
		keywords: [
			"business",
			"stationery"
		],
		skins: [
			{
				unified: "1f4c7",
				native: "📇"
			}
		],
		version: 1
	},
	chart_with_upwards_trend: {
		id: "chart_with_upwards_trend",
		name: "Chart Increasing",
		keywords: [
			"with",
			"upwards",
			"trend",
			"graph",
			"presentation",
			"stats",
			"recovery",
			"business",
			"economics",
			"money",
			"sales",
			"good",
			"success"
		],
		skins: [
			{
				unified: "1f4c8",
				native: "📈"
			}
		],
		version: 1
	},
	chart_with_downwards_trend: {
		id: "chart_with_downwards_trend",
		name: "Chart Decreasing",
		keywords: [
			"with",
			"downwards",
			"trend",
			"graph",
			"presentation",
			"stats",
			"recession",
			"business",
			"economics",
			"money",
			"sales",
			"bad",
			"failure"
		],
		skins: [
			{
				unified: "1f4c9",
				native: "📉"
			}
		],
		version: 1
	},
	bar_chart: {
		id: "bar_chart",
		name: "Bar Chart",
		keywords: [
			"graph",
			"presentation",
			"stats"
		],
		skins: [
			{
				unified: "1f4ca",
				native: "📊"
			}
		],
		version: 1
	},
	clipboard: {
		id: "clipboard",
		name: "Clipboard",
		keywords: [
			"stationery",
			"documents"
		],
		skins: [
			{
				unified: "1f4cb",
				native: "📋"
			}
		],
		version: 1
	},
	pushpin: {
		id: "pushpin",
		name: "Pushpin",
		keywords: [
			"stationery",
			"mark",
			"here"
		],
		skins: [
			{
				unified: "1f4cc",
				native: "📌"
			}
		],
		version: 1
	},
	round_pushpin: {
		id: "round_pushpin",
		name: "Round Pushpin",
		keywords: [
			"stationery",
			"location",
			"map",
			"here"
		],
		skins: [
			{
				unified: "1f4cd",
				native: "📍"
			}
		],
		version: 1
	},
	paperclip: {
		id: "paperclip",
		name: "Paperclip",
		keywords: [
			"documents",
			"stationery"
		],
		skins: [
			{
				unified: "1f4ce",
				native: "📎"
			}
		],
		version: 1
	},
	linked_paperclips: {
		id: "linked_paperclips",
		name: "Linked Paperclips",
		keywords: [
			"documents",
			"stationery"
		],
		skins: [
			{
				unified: "1f587-fe0f",
				native: "🖇️"
			}
		],
		version: 1
	},
	straight_ruler: {
		id: "straight_ruler",
		name: "Straight Ruler",
		keywords: [
			"stationery",
			"calculate",
			"length",
			"math",
			"school",
			"drawing",
			"architect",
			"sketch"
		],
		skins: [
			{
				unified: "1f4cf",
				native: "📏"
			}
		],
		version: 1
	},
	triangular_ruler: {
		id: "triangular_ruler",
		name: "Triangular Ruler",
		keywords: [
			"stationery",
			"math",
			"architect",
			"sketch"
		],
		skins: [
			{
				unified: "1f4d0",
				native: "📐"
			}
		],
		version: 1
	},
	scissors: {
		id: "scissors",
		name: "Scissors",
		keywords: [
			"stationery",
			"cut"
		],
		skins: [
			{
				unified: "2702-fe0f",
				native: "✂️"
			}
		],
		version: 1
	},
	card_file_box: {
		id: "card_file_box",
		name: "Card File Box",
		keywords: [
			"business",
			"stationery"
		],
		skins: [
			{
				unified: "1f5c3-fe0f",
				native: "🗃️"
			}
		],
		version: 1
	},
	file_cabinet: {
		id: "file_cabinet",
		name: "File Cabinet",
		keywords: [
			"filing",
			"organizing"
		],
		skins: [
			{
				unified: "1f5c4-fe0f",
				native: "🗄️"
			}
		],
		version: 1
	},
	wastebasket: {
		id: "wastebasket",
		name: "Wastebasket",
		keywords: [
			"bin",
			"trash",
			"rubbish",
			"garbage",
			"toss"
		],
		skins: [
			{
				unified: "1f5d1-fe0f",
				native: "🗑️"
			}
		],
		version: 1
	},
	lock: {
		id: "lock",
		name: "Lock",
		keywords: [
			"locked",
			"security",
			"password",
			"padlock"
		],
		skins: [
			{
				unified: "1f512",
				native: "🔒"
			}
		],
		version: 1
	},
	unlock: {
		id: "unlock",
		name: "Unlocked",
		keywords: [
			"unlock",
			"privacy",
			"security"
		],
		skins: [
			{
				unified: "1f513",
				native: "🔓"
			}
		],
		version: 1
	},
	lock_with_ink_pen: {
		id: "lock_with_ink_pen",
		name: "Locked with Pen",
		keywords: [
			"lock",
			"ink",
			"security",
			"secret"
		],
		skins: [
			{
				unified: "1f50f",
				native: "🔏"
			}
		],
		version: 1
	},
	closed_lock_with_key: {
		id: "closed_lock_with_key",
		name: "Locked with Key",
		keywords: [
			"closed",
			"lock",
			"security",
			"privacy"
		],
		skins: [
			{
				unified: "1f510",
				native: "🔐"
			}
		],
		version: 1
	},
	key: {
		id: "key",
		name: "Key",
		keywords: [
			"lock",
			"door",
			"password"
		],
		skins: [
			{
				unified: "1f511",
				native: "🔑"
			}
		],
		version: 1
	},
	old_key: {
		id: "old_key",
		name: "Old Key",
		keywords: [
			"lock",
			"door",
			"password"
		],
		skins: [
			{
				unified: "1f5dd-fe0f",
				native: "🗝️"
			}
		],
		version: 1
	},
	hammer: {
		id: "hammer",
		name: "Hammer",
		keywords: [
			"tools",
			"build",
			"create"
		],
		skins: [
			{
				unified: "1f528",
				native: "🔨"
			}
		],
		version: 1
	},
	axe: {
		id: "axe",
		name: "Axe",
		keywords: [
			"tool",
			"chop",
			"cut"
		],
		skins: [
			{
				unified: "1fa93",
				native: "🪓"
			}
		],
		version: 12
	},
	pick: {
		id: "pick",
		name: "Pick",
		keywords: [
			"tools",
			"dig"
		],
		skins: [
			{
				unified: "26cf-fe0f",
				native: "⛏️"
			}
		],
		version: 1
	},
	hammer_and_pick: {
		id: "hammer_and_pick",
		name: "Hammer and Pick",
		keywords: [
			"tools",
			"build",
			"create"
		],
		skins: [
			{
				unified: "2692-fe0f",
				native: "⚒️"
			}
		],
		version: 1
	},
	hammer_and_wrench: {
		id: "hammer_and_wrench",
		name: "Hammer and Wrench",
		keywords: [
			"tools",
			"build",
			"create"
		],
		skins: [
			{
				unified: "1f6e0-fe0f",
				native: "🛠️"
			}
		],
		version: 1
	},
	dagger_knife: {
		id: "dagger_knife",
		name: "Dagger",
		keywords: [
			"knife",
			"weapon"
		],
		skins: [
			{
				unified: "1f5e1-fe0f",
				native: "🗡️"
			}
		],
		version: 1
	},
	crossed_swords: {
		id: "crossed_swords",
		name: "Crossed Swords",
		keywords: [
			"weapon"
		],
		skins: [
			{
				unified: "2694-fe0f",
				native: "⚔️"
			}
		],
		version: 1
	},
	bomb: {
		id: "bomb",
		name: "Bomb",
		keywords: [
			"boom",
			"explode",
			"explosion",
			"terrorism"
		],
		skins: [
			{
				unified: "1f4a3",
				native: "💣"
			}
		],
		version: 1
	},
	boomerang: {
		id: "boomerang",
		name: "Boomerang",
		keywords: [
			"weapon"
		],
		skins: [
			{
				unified: "1fa83",
				native: "🪃"
			}
		],
		version: 13
	},
	bow_and_arrow: {
		id: "bow_and_arrow",
		name: "Bow and Arrow",
		keywords: [
			"sports"
		],
		skins: [
			{
				unified: "1f3f9",
				native: "🏹"
			}
		],
		version: 1
	},
	shield: {
		id: "shield",
		name: "Shield",
		keywords: [
			"protection",
			"security"
		],
		skins: [
			{
				unified: "1f6e1-fe0f",
				native: "🛡️"
			}
		],
		version: 1
	},
	carpentry_saw: {
		id: "carpentry_saw",
		name: "Carpentry Saw",
		keywords: [
			"cut",
			"chop"
		],
		skins: [
			{
				unified: "1fa9a",
				native: "🪚"
			}
		],
		version: 13
	},
	wrench: {
		id: "wrench",
		name: "Wrench",
		keywords: [
			"tools",
			"diy",
			"ikea",
			"fix",
			"maintainer"
		],
		skins: [
			{
				unified: "1f527",
				native: "🔧"
			}
		],
		version: 1
	},
	screwdriver: {
		id: "screwdriver",
		name: "Screwdriver",
		keywords: [
			"tools"
		],
		skins: [
			{
				unified: "1fa9b",
				native: "🪛"
			}
		],
		version: 13
	},
	nut_and_bolt: {
		id: "nut_and_bolt",
		name: "Nut and Bolt",
		keywords: [
			"handy",
			"tools",
			"fix"
		],
		skins: [
			{
				unified: "1f529",
				native: "🔩"
			}
		],
		version: 1
	},
	gear: {
		id: "gear",
		name: "Gear",
		keywords: [
			"cog"
		],
		skins: [
			{
				unified: "2699-fe0f",
				native: "⚙️"
			}
		],
		version: 1
	},
	compression: {
		id: "compression",
		name: "Clamp",
		keywords: [
			"compression",
			"tool"
		],
		skins: [
			{
				unified: "1f5dc-fe0f",
				native: "🗜️"
			}
		],
		version: 1
	},
	scales: {
		id: "scales",
		name: "Balance Scale",
		keywords: [
			"scales",
			"law",
			"fairness",
			"weight"
		],
		skins: [
			{
				unified: "2696-fe0f",
				native: "⚖️"
			}
		],
		version: 1
	},
	probing_cane: {
		id: "probing_cane",
		name: "White Cane",
		keywords: [
			"probing",
			"accessibility"
		],
		skins: [
			{
				unified: "1f9af",
				native: "🦯"
			}
		],
		version: 12
	},
	link: {
		id: "link",
		name: "Link",
		keywords: [
			"rings",
			"url"
		],
		skins: [
			{
				unified: "1f517",
				native: "🔗"
			}
		],
		version: 1
	},
	chains: {
		id: "chains",
		name: "Chains",
		keywords: [
			"lock",
			"arrest"
		],
		skins: [
			{
				unified: "26d3-fe0f",
				native: "⛓️"
			}
		],
		version: 1
	},
	hook: {
		id: "hook",
		name: "Hook",
		keywords: [
			"tools"
		],
		skins: [
			{
				unified: "1fa9d",
				native: "🪝"
			}
		],
		version: 13
	},
	toolbox: {
		id: "toolbox",
		name: "Toolbox",
		keywords: [
			"tools",
			"diy",
			"fix",
			"maintainer",
			"mechanic"
		],
		skins: [
			{
				unified: "1f9f0",
				native: "🧰"
			}
		],
		version: 11
	},
	magnet: {
		id: "magnet",
		name: "Magnet",
		keywords: [
			"attraction",
			"magnetic"
		],
		skins: [
			{
				unified: "1f9f2",
				native: "🧲"
			}
		],
		version: 11
	},
	ladder: {
		id: "ladder",
		name: "Ladder",
		keywords: [
			"tools"
		],
		skins: [
			{
				unified: "1fa9c",
				native: "🪜"
			}
		],
		version: 13
	},
	alembic: {
		id: "alembic",
		name: "Alembic",
		keywords: [
			"distilling",
			"science",
			"experiment",
			"chemistry"
		],
		skins: [
			{
				unified: "2697-fe0f",
				native: "⚗️"
			}
		],
		version: 1
	},
	test_tube: {
		id: "test_tube",
		name: "Test Tube",
		keywords: [
			"chemistry",
			"experiment",
			"lab",
			"science"
		],
		skins: [
			{
				unified: "1f9ea",
				native: "🧪"
			}
		],
		version: 11
	},
	petri_dish: {
		id: "petri_dish",
		name: "Petri Dish",
		keywords: [
			"bacteria",
			"biology",
			"culture",
			"lab"
		],
		skins: [
			{
				unified: "1f9eb",
				native: "🧫"
			}
		],
		version: 11
	},
	dna: {
		id: "dna",
		name: "Dna",
		keywords: [
			"biologist",
			"genetics",
			"life"
		],
		skins: [
			{
				unified: "1f9ec",
				native: "🧬"
			}
		],
		version: 11
	},
	microscope: {
		id: "microscope",
		name: "Microscope",
		keywords: [
			"laboratory",
			"experiment",
			"zoomin",
			"science",
			"study"
		],
		skins: [
			{
				unified: "1f52c",
				native: "🔬"
			}
		],
		version: 1
	},
	telescope: {
		id: "telescope",
		name: "Telescope",
		keywords: [
			"stars",
			"space",
			"zoom",
			"science",
			"astronomy"
		],
		skins: [
			{
				unified: "1f52d",
				native: "🔭"
			}
		],
		version: 1
	},
	satellite_antenna: {
		id: "satellite_antenna",
		name: "Satellite Antenna",
		keywords: [
			"communication",
			"future",
			"radio",
			"space"
		],
		skins: [
			{
				unified: "1f4e1",
				native: "📡"
			}
		],
		version: 1
	},
	syringe: {
		id: "syringe",
		name: "Syringe",
		keywords: [
			"health",
			"hospital",
			"drugs",
			"blood",
			"medicine",
			"needle",
			"doctor",
			"nurse"
		],
		skins: [
			{
				unified: "1f489",
				native: "💉"
			}
		],
		version: 1
	},
	drop_of_blood: {
		id: "drop_of_blood",
		name: "Drop of Blood",
		keywords: [
			"period",
			"hurt",
			"harm",
			"wound"
		],
		skins: [
			{
				unified: "1fa78",
				native: "🩸"
			}
		],
		version: 12
	},
	pill: {
		id: "pill",
		name: "Pill",
		keywords: [
			"health",
			"medicine",
			"doctor",
			"pharmacy",
			"drug"
		],
		skins: [
			{
				unified: "1f48a",
				native: "💊"
			}
		],
		version: 1
	},
	adhesive_bandage: {
		id: "adhesive_bandage",
		name: "Adhesive Bandage",
		keywords: [
			"heal"
		],
		skins: [
			{
				unified: "1fa79",
				native: "🩹"
			}
		],
		version: 12
	},
	crutch: {
		id: "crutch",
		name: "Crutch",
		keywords: [
			"accessibility",
			"assist"
		],
		skins: [
			{
				unified: "1fa7c",
				native: "🩼"
			}
		],
		version: 14
	},
	stethoscope: {
		id: "stethoscope",
		name: "Stethoscope",
		keywords: [
			"health"
		],
		skins: [
			{
				unified: "1fa7a",
				native: "🩺"
			}
		],
		version: 12
	},
	"x-ray": {
		id: "x-ray",
		name: "X-Ray",
		keywords: [
			"x",
			"ray",
			"skeleton",
			"medicine"
		],
		skins: [
			{
				unified: "1fa7b",
				native: "🩻"
			}
		],
		version: 14
	},
	door: {
		id: "door",
		name: "Door",
		keywords: [
			"house",
			"entry",
			"exit"
		],
		skins: [
			{
				unified: "1f6aa",
				native: "🚪"
			}
		],
		version: 1
	},
	elevator: {
		id: "elevator",
		name: "Elevator",
		keywords: [
			"lift"
		],
		skins: [
			{
				unified: "1f6d7",
				native: "🛗"
			}
		],
		version: 13
	},
	mirror: {
		id: "mirror",
		name: "Mirror",
		keywords: [
			"reflection"
		],
		skins: [
			{
				unified: "1fa9e",
				native: "🪞"
			}
		],
		version: 13
	},
	window: {
		id: "window",
		name: "Window",
		keywords: [
			"scenery"
		],
		skins: [
			{
				unified: "1fa9f",
				native: "🪟"
			}
		],
		version: 13
	},
	bed: {
		id: "bed",
		name: "Bed",
		keywords: [
			"sleep",
			"rest"
		],
		skins: [
			{
				unified: "1f6cf-fe0f",
				native: "🛏️"
			}
		],
		version: 1
	},
	couch_and_lamp: {
		id: "couch_and_lamp",
		name: "Couch and Lamp",
		keywords: [
			"read",
			"chill"
		],
		skins: [
			{
				unified: "1f6cb-fe0f",
				native: "🛋️"
			}
		],
		version: 1
	},
	chair: {
		id: "chair",
		name: "Chair",
		keywords: [
			"sit",
			"furniture"
		],
		skins: [
			{
				unified: "1fa91",
				native: "🪑"
			}
		],
		version: 12
	},
	toilet: {
		id: "toilet",
		name: "Toilet",
		keywords: [
			"restroom",
			"wc",
			"washroom",
			"bathroom",
			"potty"
		],
		skins: [
			{
				unified: "1f6bd",
				native: "🚽"
			}
		],
		version: 1
	},
	plunger: {
		id: "plunger",
		name: "Plunger",
		keywords: [
			"toilet"
		],
		skins: [
			{
				unified: "1faa0",
				native: "🪠"
			}
		],
		version: 13
	},
	shower: {
		id: "shower",
		name: "Shower",
		keywords: [
			"clean",
			"water",
			"bathroom"
		],
		skins: [
			{
				unified: "1f6bf",
				native: "🚿"
			}
		],
		version: 1
	},
	bathtub: {
		id: "bathtub",
		name: "Bathtub",
		keywords: [
			"clean",
			"shower",
			"bathroom"
		],
		skins: [
			{
				unified: "1f6c1",
				native: "🛁"
			}
		],
		version: 1
	},
	mouse_trap: {
		id: "mouse_trap",
		name: "Mouse Trap",
		keywords: [
			"cheese"
		],
		skins: [
			{
				unified: "1faa4",
				native: "🪤"
			}
		],
		version: 13
	},
	razor: {
		id: "razor",
		name: "Razor",
		keywords: [
			"cut"
		],
		skins: [
			{
				unified: "1fa92",
				native: "🪒"
			}
		],
		version: 12
	},
	lotion_bottle: {
		id: "lotion_bottle",
		name: "Lotion Bottle",
		keywords: [
			"moisturizer",
			"sunscreen"
		],
		skins: [
			{
				unified: "1f9f4",
				native: "🧴"
			}
		],
		version: 11
	},
	safety_pin: {
		id: "safety_pin",
		name: "Safety Pin",
		keywords: [
			"diaper"
		],
		skins: [
			{
				unified: "1f9f7",
				native: "🧷"
			}
		],
		version: 11
	},
	broom: {
		id: "broom",
		name: "Broom",
		keywords: [
			"cleaning",
			"sweeping",
			"witch"
		],
		skins: [
			{
				unified: "1f9f9",
				native: "🧹"
			}
		],
		version: 11
	},
	basket: {
		id: "basket",
		name: "Basket",
		keywords: [
			"laundry"
		],
		skins: [
			{
				unified: "1f9fa",
				native: "🧺"
			}
		],
		version: 11
	},
	roll_of_paper: {
		id: "roll_of_paper",
		name: "Roll of Paper",
		keywords: [
		],
		skins: [
			{
				unified: "1f9fb",
				native: "🧻"
			}
		],
		version: 11
	},
	bucket: {
		id: "bucket",
		name: "Bucket",
		keywords: [
			"water",
			"container"
		],
		skins: [
			{
				unified: "1faa3",
				native: "🪣"
			}
		],
		version: 13
	},
	soap: {
		id: "soap",
		name: "Soap",
		keywords: [
			"bar",
			"bathing",
			"cleaning",
			"lather"
		],
		skins: [
			{
				unified: "1f9fc",
				native: "🧼"
			}
		],
		version: 11
	},
	bubbles: {
		id: "bubbles",
		name: "Bubbles",
		keywords: [
			"soap",
			"fun",
			"carbonation",
			"sparkling"
		],
		skins: [
			{
				unified: "1fae7",
				native: "🫧"
			}
		],
		version: 14
	},
	toothbrush: {
		id: "toothbrush",
		name: "Toothbrush",
		keywords: [
			"hygiene",
			"dental"
		],
		skins: [
			{
				unified: "1faa5",
				native: "🪥"
			}
		],
		version: 13
	},
	sponge: {
		id: "sponge",
		name: "Sponge",
		keywords: [
			"absorbing",
			"cleaning",
			"porous"
		],
		skins: [
			{
				unified: "1f9fd",
				native: "🧽"
			}
		],
		version: 11
	},
	fire_extinguisher: {
		id: "fire_extinguisher",
		name: "Fire Extinguisher",
		keywords: [
			"quench"
		],
		skins: [
			{
				unified: "1f9ef",
				native: "🧯"
			}
		],
		version: 11
	},
	shopping_trolley: {
		id: "shopping_trolley",
		name: "Shopping Cart",
		keywords: [
			"trolley"
		],
		skins: [
			{
				unified: "1f6d2",
				native: "🛒"
			}
		],
		version: 3
	},
	smoking: {
		id: "smoking",
		name: "Cigarette",
		keywords: [
			"smoking",
			"kills",
			"tobacco",
			"joint",
			"smoke"
		],
		skins: [
			{
				unified: "1f6ac",
				native: "🚬"
			}
		],
		version: 1
	},
	coffin: {
		id: "coffin",
		name: "Coffin",
		keywords: [
			"vampire",
			"dead",
			"die",
			"death",
			"rip",
			"graveyard",
			"cemetery",
			"casket",
			"funeral",
			"box"
		],
		skins: [
			{
				unified: "26b0-fe0f",
				native: "⚰️"
			}
		],
		version: 1
	},
	headstone: {
		id: "headstone",
		name: "Headstone",
		keywords: [
			"death",
			"rip",
			"grave"
		],
		skins: [
			{
				unified: "1faa6",
				native: "🪦"
			}
		],
		version: 13
	},
	funeral_urn: {
		id: "funeral_urn",
		name: "Funeral Urn",
		keywords: [
			"dead",
			"die",
			"death",
			"rip",
			"ashes"
		],
		skins: [
			{
				unified: "26b1-fe0f",
				native: "⚱️"
			}
		],
		version: 1
	},
	nazar_amulet: {
		id: "nazar_amulet",
		name: "Nazar Amulet",
		keywords: [
			"bead",
			"charm"
		],
		skins: [
			{
				unified: "1f9ff",
				native: "🧿"
			}
		],
		version: 11
	},
	hamsa: {
		id: "hamsa",
		name: "Hamsa",
		keywords: [
			"religion",
			"protection"
		],
		skins: [
			{
				unified: "1faac",
				native: "🪬"
			}
		],
		version: 14
	},
	moyai: {
		id: "moyai",
		name: "Moai",
		keywords: [
			"moyai",
			"rock",
			"easter",
			"island"
		],
		skins: [
			{
				unified: "1f5ff",
				native: "🗿"
			}
		],
		version: 1
	},
	placard: {
		id: "placard",
		name: "Placard",
		keywords: [
			"announcement"
		],
		skins: [
			{
				unified: "1faa7",
				native: "🪧"
			}
		],
		version: 13
	},
	identification_card: {
		id: "identification_card",
		name: "Identification Card",
		keywords: [
			"document"
		],
		skins: [
			{
				unified: "1faaa",
				native: "🪪"
			}
		],
		version: 14
	},
	atm: {
		id: "atm",
		name: "Atm Sign",
		keywords: [
			"money",
			"sales",
			"cash",
			"blue",
			"square",
			"payment",
			"bank"
		],
		skins: [
			{
				unified: "1f3e7",
				native: "🏧"
			}
		],
		version: 1
	},
	put_litter_in_its_place: {
		id: "put_litter_in_its_place",
		name: "Litter in Bin Sign",
		keywords: [
			"put",
			"its",
			"place",
			"blue",
			"square",
			"human",
			"info"
		],
		skins: [
			{
				unified: "1f6ae",
				native: "🚮"
			}
		],
		version: 1
	},
	potable_water: {
		id: "potable_water",
		name: "Potable Water",
		keywords: [
			"blue",
			"square",
			"liquid",
			"restroom",
			"cleaning",
			"faucet"
		],
		skins: [
			{
				unified: "1f6b0",
				native: "🚰"
			}
		],
		version: 1
	},
	wheelchair: {
		id: "wheelchair",
		name: "Wheelchair Symbol",
		keywords: [
			"blue",
			"square",
			"disabled",
			"accessibility"
		],
		skins: [
			{
				unified: "267f",
				native: "♿"
			}
		],
		version: 1
	},
	mens: {
		id: "mens",
		name: "Men’s Room",
		keywords: [
			"mens",
			"men",
			"s",
			"toilet",
			"restroom",
			"wc",
			"blue",
			"square",
			"gender",
			"male"
		],
		skins: [
			{
				unified: "1f6b9",
				native: "🚹"
			}
		],
		version: 1
	},
	womens: {
		id: "womens",
		name: "Women’s Room",
		keywords: [
			"womens",
			"women",
			"s",
			"purple",
			"square",
			"woman",
			"female",
			"toilet",
			"loo",
			"restroom",
			"gender"
		],
		skins: [
			{
				unified: "1f6ba",
				native: "🚺"
			}
		],
		version: 1
	},
	restroom: {
		id: "restroom",
		name: "Restroom",
		keywords: [
			"blue",
			"square",
			"toilet",
			"refresh",
			"wc",
			"gender"
		],
		skins: [
			{
				unified: "1f6bb",
				native: "🚻"
			}
		],
		version: 1
	},
	baby_symbol: {
		id: "baby_symbol",
		name: "Baby Symbol",
		keywords: [
			"orange",
			"square",
			"child"
		],
		skins: [
			{
				unified: "1f6bc",
				native: "🚼"
			}
		],
		version: 1
	},
	wc: {
		id: "wc",
		name: "Water Closet",
		keywords: [
			"wc",
			"toilet",
			"restroom",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f6be",
				native: "🚾"
			}
		],
		version: 1
	},
	passport_control: {
		id: "passport_control",
		name: "Passport Control",
		keywords: [
			"custom",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f6c2",
				native: "🛂"
			}
		],
		version: 1
	},
	customs: {
		id: "customs",
		name: "Customs",
		keywords: [
			"passport",
			"border",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f6c3",
				native: "🛃"
			}
		],
		version: 1
	},
	baggage_claim: {
		id: "baggage_claim",
		name: "Baggage Claim",
		keywords: [
			"blue",
			"square",
			"airport",
			"transport"
		],
		skins: [
			{
				unified: "1f6c4",
				native: "🛄"
			}
		],
		version: 1
	},
	left_luggage: {
		id: "left_luggage",
		name: "Left Luggage",
		keywords: [
			"blue",
			"square",
			"travel"
		],
		skins: [
			{
				unified: "1f6c5",
				native: "🛅"
			}
		],
		version: 1
	},
	warning: {
		id: "warning",
		name: "Warning",
		keywords: [
			"exclamation",
			"wip",
			"alert",
			"error",
			"problem",
			"issue"
		],
		skins: [
			{
				unified: "26a0-fe0f",
				native: "⚠️"
			}
		],
		version: 1
	},
	children_crossing: {
		id: "children_crossing",
		name: "Children Crossing",
		keywords: [
			"school",
			"warning",
			"danger",
			"sign",
			"driving",
			"yellow",
			"diamond"
		],
		skins: [
			{
				unified: "1f6b8",
				native: "🚸"
			}
		],
		version: 1
	},
	no_entry: {
		id: "no_entry",
		name: "No Entry",
		keywords: [
			"limit",
			"security",
			"privacy",
			"bad",
			"denied",
			"stop",
			"circle"
		],
		skins: [
			{
				unified: "26d4",
				native: "⛔"
			}
		],
		version: 1
	},
	no_entry_sign: {
		id: "no_entry_sign",
		name: "Prohibited",
		keywords: [
			"no",
			"entry",
			"sign",
			"forbid",
			"stop",
			"limit",
			"denied",
			"disallow",
			"circle"
		],
		skins: [
			{
				unified: "1f6ab",
				native: "🚫"
			}
		],
		version: 1
	},
	no_bicycles: {
		id: "no_bicycles",
		name: "No Bicycles",
		keywords: [
			"cyclist",
			"prohibited",
			"circle"
		],
		skins: [
			{
				unified: "1f6b3",
				native: "🚳"
			}
		],
		version: 1
	},
	no_smoking: {
		id: "no_smoking",
		name: "No Smoking",
		keywords: [
			"cigarette",
			"blue",
			"square",
			"smell",
			"smoke"
		],
		skins: [
			{
				unified: "1f6ad",
				native: "🚭"
			}
		],
		version: 1
	},
	do_not_litter: {
		id: "do_not_litter",
		name: "No Littering",
		keywords: [
			"do",
			"not",
			"litter",
			"trash",
			"bin",
			"garbage",
			"circle"
		],
		skins: [
			{
				unified: "1f6af",
				native: "🚯"
			}
		],
		version: 1
	},
	"non-potable_water": {
		id: "non-potable_water",
		name: "Non-Potable Water",
		keywords: [
			"non",
			"potable",
			"drink",
			"faucet",
			"tap",
			"circle"
		],
		skins: [
			{
				unified: "1f6b1",
				native: "🚱"
			}
		],
		version: 1
	},
	no_pedestrians: {
		id: "no_pedestrians",
		name: "No Pedestrians",
		keywords: [
			"rules",
			"crossing",
			"walking",
			"circle"
		],
		skins: [
			{
				unified: "1f6b7",
				native: "🚷"
			}
		],
		version: 1
	},
	no_mobile_phones: {
		id: "no_mobile_phones",
		name: "No Mobile Phones",
		keywords: [
			"iphone",
			"mute",
			"circle"
		],
		skins: [
			{
				unified: "1f4f5",
				native: "📵"
			}
		],
		version: 1
	},
	underage: {
		id: "underage",
		name: "No One Under Eighteen",
		keywords: [
			"underage",
			"18",
			"drink",
			"pub",
			"night",
			"minor",
			"circle"
		],
		skins: [
			{
				unified: "1f51e",
				native: "🔞"
			}
		],
		version: 1
	},
	radioactive_sign: {
		id: "radioactive_sign",
		name: "Radioactive",
		keywords: [
			"sign",
			"nuclear",
			"danger"
		],
		skins: [
			{
				unified: "2622-fe0f",
				native: "☢️"
			}
		],
		version: 1
	},
	biohazard_sign: {
		id: "biohazard_sign",
		name: "Biohazard",
		keywords: [
			"sign",
			"danger"
		],
		skins: [
			{
				unified: "2623-fe0f",
				native: "☣️"
			}
		],
		version: 1
	},
	arrow_up: {
		id: "arrow_up",
		name: "Up Arrow",
		keywords: [
			"blue",
			"square",
			"continue",
			"top",
			"direction"
		],
		skins: [
			{
				unified: "2b06-fe0f",
				native: "⬆️"
			}
		],
		version: 1
	},
	arrow_upper_right: {
		id: "arrow_upper_right",
		name: "Up-Right Arrow",
		keywords: [
			"upper",
			"right",
			"up",
			"blue",
			"square",
			"point",
			"direction",
			"diagonal",
			"northeast"
		],
		skins: [
			{
				unified: "2197-fe0f",
				native: "↗️"
			}
		],
		version: 1
	},
	arrow_right: {
		id: "arrow_right",
		name: "Right Arrow",
		keywords: [
			"blue",
			"square",
			"next"
		],
		skins: [
			{
				unified: "27a1-fe0f",
				native: "➡️"
			}
		],
		version: 1
	},
	arrow_lower_right: {
		id: "arrow_lower_right",
		name: "South East Arrow",
		keywords: [
			"lower",
			"right",
			"down",
			"blue",
			"square",
			"direction",
			"diagonal",
			"southeast"
		],
		skins: [
			{
				unified: "2198-fe0f",
				native: "↘️"
			}
		],
		version: 1
	},
	arrow_down: {
		id: "arrow_down",
		name: "Down Arrow",
		keywords: [
			"blue",
			"square",
			"direction",
			"bottom"
		],
		skins: [
			{
				unified: "2b07-fe0f",
				native: "⬇️"
			}
		],
		version: 1
	},
	arrow_lower_left: {
		id: "arrow_lower_left",
		name: "Down-Left Arrow",
		keywords: [
			"lower",
			"left",
			"down",
			"blue",
			"square",
			"direction",
			"diagonal",
			"southwest"
		],
		skins: [
			{
				unified: "2199-fe0f",
				native: "↙️"
			}
		],
		version: 1
	},
	arrow_left: {
		id: "arrow_left",
		name: "Left Arrow",
		keywords: [
			"blue",
			"square",
			"previous",
			"back"
		],
		skins: [
			{
				unified: "2b05-fe0f",
				native: "⬅️"
			}
		],
		version: 1
	},
	arrow_upper_left: {
		id: "arrow_upper_left",
		name: "Up-Left Arrow",
		keywords: [
			"upper",
			"left",
			"up",
			"blue",
			"square",
			"point",
			"direction",
			"diagonal",
			"northwest"
		],
		skins: [
			{
				unified: "2196-fe0f",
				native: "↖️"
			}
		],
		version: 1
	},
	arrow_up_down: {
		id: "arrow_up_down",
		name: "Up Down Arrow",
		keywords: [
			"blue",
			"square",
			"direction",
			"way",
			"vertical"
		],
		skins: [
			{
				unified: "2195-fe0f",
				native: "↕️"
			}
		],
		version: 1
	},
	left_right_arrow: {
		id: "left_right_arrow",
		name: "Left Right Arrow",
		keywords: [
			"shape",
			"direction",
			"horizontal",
			"sideways"
		],
		skins: [
			{
				unified: "2194-fe0f",
				native: "↔️"
			}
		],
		version: 1
	},
	leftwards_arrow_with_hook: {
		id: "leftwards_arrow_with_hook",
		name: "Right Arrow Curving Left",
		keywords: [
			"leftwards",
			"with",
			"hook",
			"back",
			"return",
			"blue",
			"square",
			"undo",
			"enter"
		],
		skins: [
			{
				unified: "21a9-fe0f",
				native: "↩️"
			}
		],
		version: 1
	},
	arrow_right_hook: {
		id: "arrow_right_hook",
		name: "Left Arrow Curving Right",
		keywords: [
			"hook",
			"blue",
			"square",
			"return",
			"rotate",
			"direction"
		],
		skins: [
			{
				unified: "21aa-fe0f",
				native: "↪️"
			}
		],
		version: 1
	},
	arrow_heading_up: {
		id: "arrow_heading_up",
		name: "Right Arrow Curving Up",
		keywords: [
			"heading",
			"blue",
			"square",
			"direction",
			"top"
		],
		skins: [
			{
				unified: "2934-fe0f",
				native: "⤴️"
			}
		],
		version: 1
	},
	arrow_heading_down: {
		id: "arrow_heading_down",
		name: "Right Arrow Curving Down",
		keywords: [
			"heading",
			"blue",
			"square",
			"direction",
			"bottom"
		],
		skins: [
			{
				unified: "2935-fe0f",
				native: "⤵️"
			}
		],
		version: 1
	},
	arrows_clockwise: {
		id: "arrows_clockwise",
		name: "Clockwise Vertical Arrows",
		keywords: [
			"sync",
			"cycle",
			"round",
			"repeat"
		],
		skins: [
			{
				unified: "1f503",
				native: "🔃"
			}
		],
		version: 1
	},
	arrows_counterclockwise: {
		id: "arrows_counterclockwise",
		name: "Counterclockwise Arrows Button",
		keywords: [
			"blue",
			"square",
			"sync",
			"cycle"
		],
		skins: [
			{
				unified: "1f504",
				native: "🔄"
			}
		],
		version: 1
	},
	back: {
		id: "back",
		name: "Back Arrow",
		keywords: [
			"words",
			"return"
		],
		skins: [
			{
				unified: "1f519",
				native: "🔙"
			}
		],
		version: 1
	},
	end: {
		id: "end",
		name: "End Arrow",
		keywords: [
			"words"
		],
		skins: [
			{
				unified: "1f51a",
				native: "🔚"
			}
		],
		version: 1
	},
	on: {
		id: "on",
		name: "On! Arrow",
		keywords: [
			"on",
			"words"
		],
		skins: [
			{
				unified: "1f51b",
				native: "🔛"
			}
		],
		version: 1
	},
	soon: {
		id: "soon",
		name: "Soon Arrow",
		keywords: [
			"words"
		],
		skins: [
			{
				unified: "1f51c",
				native: "🔜"
			}
		],
		version: 1
	},
	top: {
		id: "top",
		name: "Top Arrow",
		keywords: [
			"words",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f51d",
				native: "🔝"
			}
		],
		version: 1
	},
	place_of_worship: {
		id: "place_of_worship",
		name: "Place of Worship",
		keywords: [
			"religion",
			"church",
			"temple",
			"prayer"
		],
		skins: [
			{
				unified: "1f6d0",
				native: "🛐"
			}
		],
		version: 1
	},
	atom_symbol: {
		id: "atom_symbol",
		name: "Atom Symbol",
		keywords: [
			"science",
			"physics",
			"chemistry"
		],
		skins: [
			{
				unified: "269b-fe0f",
				native: "⚛️"
			}
		],
		version: 1
	},
	om_symbol: {
		id: "om_symbol",
		name: "Om",
		keywords: [
			"symbol",
			"hinduism",
			"buddhism",
			"sikhism",
			"jainism"
		],
		skins: [
			{
				unified: "1f549-fe0f",
				native: "🕉️"
			}
		],
		version: 1
	},
	star_of_david: {
		id: "star_of_david",
		name: "Star of David",
		keywords: [
			"judaism"
		],
		skins: [
			{
				unified: "2721-fe0f",
				native: "✡️"
			}
		],
		version: 1
	},
	wheel_of_dharma: {
		id: "wheel_of_dharma",
		name: "Wheel of Dharma",
		keywords: [
			"hinduism",
			"buddhism",
			"sikhism",
			"jainism"
		],
		skins: [
			{
				unified: "2638-fe0f",
				native: "☸️"
			}
		],
		version: 1
	},
	yin_yang: {
		id: "yin_yang",
		name: "Yin Yang",
		keywords: [
			"balance"
		],
		skins: [
			{
				unified: "262f-fe0f",
				native: "☯️"
			}
		],
		version: 1
	},
	latin_cross: {
		id: "latin_cross",
		name: "Latin Cross",
		keywords: [
			"christianity"
		],
		skins: [
			{
				unified: "271d-fe0f",
				native: "✝️"
			}
		],
		version: 1
	},
	orthodox_cross: {
		id: "orthodox_cross",
		name: "Orthodox Cross",
		keywords: [
			"suppedaneum",
			"religion"
		],
		skins: [
			{
				unified: "2626-fe0f",
				native: "☦️"
			}
		],
		version: 1
	},
	star_and_crescent: {
		id: "star_and_crescent",
		name: "Star and Crescent",
		keywords: [
			"islam"
		],
		skins: [
			{
				unified: "262a-fe0f",
				native: "☪️"
			}
		],
		version: 1
	},
	peace_symbol: {
		id: "peace_symbol",
		name: "Peace Symbol",
		keywords: [
			"hippie"
		],
		skins: [
			{
				unified: "262e-fe0f",
				native: "☮️"
			}
		],
		version: 1
	},
	menorah_with_nine_branches: {
		id: "menorah_with_nine_branches",
		name: "Menorah",
		keywords: [
			"with",
			"nine",
			"branches",
			"hanukkah",
			"candles",
			"jewish"
		],
		skins: [
			{
				unified: "1f54e",
				native: "🕎"
			}
		],
		version: 1
	},
	six_pointed_star: {
		id: "six_pointed_star",
		name: "Dotted Six-Pointed Star",
		keywords: [
			"six",
			"pointed",
			"purple",
			"square",
			"religion",
			"jewish",
			"hexagram"
		],
		skins: [
			{
				unified: "1f52f",
				native: "🔯"
			}
		],
		version: 1
	},
	khanda: {
		id: "khanda",
		name: "Khanda",
		keywords: [
			"Sikhism",
			"religion"
		],
		skins: [
			{
				unified: "1faaf",
				native: "🪯"
			}
		],
		version: 15
	},
	aries: {
		id: "aries",
		name: "Aries",
		keywords: [
			"sign",
			"purple",
			"square",
			"zodiac",
			"astrology"
		],
		skins: [
			{
				unified: "2648",
				native: "♈"
			}
		],
		version: 1
	},
	taurus: {
		id: "taurus",
		name: "Taurus",
		keywords: [
			"purple",
			"square",
			"sign",
			"zodiac",
			"astrology"
		],
		skins: [
			{
				unified: "2649",
				native: "♉"
			}
		],
		version: 1
	},
	gemini: {
		id: "gemini",
		name: "Gemini",
		keywords: [
			"sign",
			"zodiac",
			"purple",
			"square",
			"astrology"
		],
		skins: [
			{
				unified: "264a",
				native: "♊"
			}
		],
		version: 1
	},
	cancer: {
		id: "cancer",
		name: "Cancer",
		keywords: [
			"sign",
			"zodiac",
			"purple",
			"square",
			"astrology"
		],
		skins: [
			{
				unified: "264b",
				native: "♋"
			}
		],
		version: 1
	},
	leo: {
		id: "leo",
		name: "Leo",
		keywords: [
			"sign",
			"purple",
			"square",
			"zodiac",
			"astrology"
		],
		skins: [
			{
				unified: "264c",
				native: "♌"
			}
		],
		version: 1
	},
	virgo: {
		id: "virgo",
		name: "Virgo",
		keywords: [
			"sign",
			"zodiac",
			"purple",
			"square",
			"astrology"
		],
		skins: [
			{
				unified: "264d",
				native: "♍"
			}
		],
		version: 1
	},
	libra: {
		id: "libra",
		name: "Libra",
		keywords: [
			"sign",
			"purple",
			"square",
			"zodiac",
			"astrology"
		],
		skins: [
			{
				unified: "264e",
				native: "♎"
			}
		],
		version: 1
	},
	scorpius: {
		id: "scorpius",
		name: "Scorpio",
		keywords: [
			"scorpius",
			"sign",
			"zodiac",
			"purple",
			"square",
			"astrology"
		],
		skins: [
			{
				unified: "264f",
				native: "♏"
			}
		],
		version: 1
	},
	sagittarius: {
		id: "sagittarius",
		name: "Sagittarius",
		keywords: [
			"sign",
			"zodiac",
			"purple",
			"square",
			"astrology"
		],
		skins: [
			{
				unified: "2650",
				native: "♐"
			}
		],
		version: 1
	},
	capricorn: {
		id: "capricorn",
		name: "Capricorn",
		keywords: [
			"sign",
			"zodiac",
			"purple",
			"square",
			"astrology"
		],
		skins: [
			{
				unified: "2651",
				native: "♑"
			}
		],
		version: 1
	},
	aquarius: {
		id: "aquarius",
		name: "Aquarius",
		keywords: [
			"sign",
			"purple",
			"square",
			"zodiac",
			"astrology"
		],
		skins: [
			{
				unified: "2652",
				native: "♒"
			}
		],
		version: 1
	},
	pisces: {
		id: "pisces",
		name: "Pisces",
		keywords: [
			"purple",
			"square",
			"sign",
			"zodiac",
			"astrology"
		],
		skins: [
			{
				unified: "2653",
				native: "♓"
			}
		],
		version: 1
	},
	ophiuchus: {
		id: "ophiuchus",
		name: "Ophiuchus",
		keywords: [
			"sign",
			"purple",
			"square",
			"constellation",
			"astrology"
		],
		skins: [
			{
				unified: "26ce",
				native: "⛎"
			}
		],
		version: 1
	},
	twisted_rightwards_arrows: {
		id: "twisted_rightwards_arrows",
		name: "Shuffle Tracks Button",
		keywords: [
			"twisted",
			"rightwards",
			"arrows",
			"blue",
			"square",
			"music",
			"random"
		],
		skins: [
			{
				unified: "1f500",
				native: "🔀"
			}
		],
		version: 1
	},
	repeat: {
		id: "repeat",
		name: "Repeat Button",
		keywords: [
			"loop",
			"record"
		],
		skins: [
			{
				unified: "1f501",
				native: "🔁"
			}
		],
		version: 1
	},
	repeat_one: {
		id: "repeat_one",
		name: "Repeat Single Button",
		keywords: [
			"one",
			"blue",
			"square",
			"loop"
		],
		skins: [
			{
				unified: "1f502",
				native: "🔂"
			}
		],
		version: 1
	},
	arrow_forward: {
		id: "arrow_forward",
		name: "Play Button",
		keywords: [
			"arrow",
			"forward",
			"blue",
			"square",
			"right",
			"direction"
		],
		skins: [
			{
				unified: "25b6-fe0f",
				native: "▶️"
			}
		],
		version: 1
	},
	fast_forward: {
		id: "fast_forward",
		name: "Fast-Forward Button",
		keywords: [
			"fast",
			"forward",
			"blue",
			"square",
			"play",
			"speed",
			"continue"
		],
		skins: [
			{
				unified: "23e9",
				native: "⏩"
			}
		],
		version: 1
	},
	black_right_pointing_double_triangle_with_vertical_bar: {
		id: "black_right_pointing_double_triangle_with_vertical_bar",
		name: "Next Track Button",
		keywords: [
			"black",
			"right",
			"pointing",
			"double",
			"triangle",
			"with",
			"vertical",
			"bar",
			"forward",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "23ed-fe0f",
				native: "⏭️"
			}
		],
		version: 1
	},
	black_right_pointing_triangle_with_double_vertical_bar: {
		id: "black_right_pointing_triangle_with_double_vertical_bar",
		name: "Play or Pause Button",
		keywords: [
			"black",
			"right",
			"pointing",
			"triangle",
			"with",
			"double",
			"vertical",
			"bar",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "23ef-fe0f",
				native: "⏯️"
			}
		],
		version: 1
	},
	arrow_backward: {
		id: "arrow_backward",
		name: "Reverse Button",
		keywords: [
			"arrow",
			"backward",
			"blue",
			"square",
			"left",
			"direction"
		],
		skins: [
			{
				unified: "25c0-fe0f",
				native: "◀️"
			}
		],
		version: 1
	},
	rewind: {
		id: "rewind",
		name: "Fast Reverse Button",
		keywords: [
			"rewind",
			"play",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "23ea",
				native: "⏪"
			}
		],
		version: 1
	},
	black_left_pointing_double_triangle_with_vertical_bar: {
		id: "black_left_pointing_double_triangle_with_vertical_bar",
		name: "Last Track Button",
		keywords: [
			"black",
			"left",
			"pointing",
			"double",
			"triangle",
			"with",
			"vertical",
			"bar",
			"backward"
		],
		skins: [
			{
				unified: "23ee-fe0f",
				native: "⏮️"
			}
		],
		version: 1
	},
	arrow_up_small: {
		id: "arrow_up_small",
		name: "Upwards Button",
		keywords: [
			"arrow",
			"up",
			"small",
			"blue",
			"square",
			"triangle",
			"direction",
			"point",
			"forward",
			"top"
		],
		skins: [
			{
				unified: "1f53c",
				native: "🔼"
			}
		],
		version: 1
	},
	arrow_double_up: {
		id: "arrow_double_up",
		name: "Fast Up Button",
		keywords: [
			"arrow",
			"double",
			"blue",
			"square",
			"direction",
			"top"
		],
		skins: [
			{
				unified: "23eb",
				native: "⏫"
			}
		],
		version: 1
	},
	arrow_down_small: {
		id: "arrow_down_small",
		name: "Downwards Button",
		keywords: [
			"arrow",
			"down",
			"small",
			"blue",
			"square",
			"direction",
			"bottom"
		],
		skins: [
			{
				unified: "1f53d",
				native: "🔽"
			}
		],
		version: 1
	},
	arrow_double_down: {
		id: "arrow_double_down",
		name: "Fast Down Button",
		keywords: [
			"arrow",
			"double",
			"blue",
			"square",
			"direction",
			"bottom"
		],
		skins: [
			{
				unified: "23ec",
				native: "⏬"
			}
		],
		version: 1
	},
	double_vertical_bar: {
		id: "double_vertical_bar",
		name: "Pause Button",
		keywords: [
			"double",
			"vertical",
			"bar",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "23f8-fe0f",
				native: "⏸️"
			}
		],
		version: 1
	},
	black_square_for_stop: {
		id: "black_square_for_stop",
		name: "Stop Button",
		keywords: [
			"black",
			"square",
			"for",
			"blue"
		],
		skins: [
			{
				unified: "23f9-fe0f",
				native: "⏹️"
			}
		],
		version: 1
	},
	black_circle_for_record: {
		id: "black_circle_for_record",
		name: "Record Button",
		keywords: [
			"black",
			"circle",
			"for",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "23fa-fe0f",
				native: "⏺️"
			}
		],
		version: 1
	},
	eject: {
		id: "eject",
		name: "Eject Button",
		keywords: [
			"blue",
			"square"
		],
		skins: [
			{
				unified: "23cf-fe0f",
				native: "⏏️"
			}
		],
		version: 1
	},
	cinema: {
		id: "cinema",
		name: "Cinema",
		keywords: [
			"blue",
			"square",
			"record",
			"film",
			"movie",
			"curtain",
			"stage",
			"theater"
		],
		skins: [
			{
				unified: "1f3a6",
				native: "🎦"
			}
		],
		version: 1
	},
	low_brightness: {
		id: "low_brightness",
		name: "Dim Button",
		keywords: [
			"low",
			"brightness",
			"sun",
			"afternoon",
			"warm",
			"summer"
		],
		skins: [
			{
				unified: "1f505",
				native: "🔅"
			}
		],
		version: 1
	},
	high_brightness: {
		id: "high_brightness",
		name: "Bright Button",
		keywords: [
			"high",
			"brightness",
			"sun",
			"light"
		],
		skins: [
			{
				unified: "1f506",
				native: "🔆"
			}
		],
		version: 1
	},
	signal_strength: {
		id: "signal_strength",
		name: "Antenna Bars",
		keywords: [
			"signal",
			"strength",
			"blue",
			"square",
			"reception",
			"phone",
			"internet",
			"connection",
			"wifi",
			"bluetooth"
		],
		skins: [
			{
				unified: "1f4f6",
				native: "📶"
			}
		],
		version: 1
	},
	wireless: {
		id: "wireless",
		name: "Wireless",
		keywords: [
			"wifi",
			"internet",
			"contactless",
			"signal"
		],
		skins: [
			{
				unified: "1f6dc",
				native: "🛜"
			}
		],
		version: 15
	},
	vibration_mode: {
		id: "vibration_mode",
		name: "Vibration Mode",
		keywords: [
			"orange",
			"square",
			"phone"
		],
		skins: [
			{
				unified: "1f4f3",
				native: "📳"
			}
		],
		version: 1
	},
	mobile_phone_off: {
		id: "mobile_phone_off",
		name: "Mobile Phone off",
		keywords: [
			"mute",
			"orange",
			"square",
			"silence",
			"quiet"
		],
		skins: [
			{
				unified: "1f4f4",
				native: "📴"
			}
		],
		version: 1
	},
	female_sign: {
		id: "female_sign",
		name: "Female Sign",
		keywords: [
			"woman",
			"women",
			"lady",
			"girl"
		],
		skins: [
			{
				unified: "2640-fe0f",
				native: "♀️"
			}
		],
		version: 4
	},
	male_sign: {
		id: "male_sign",
		name: "Male Sign",
		keywords: [
			"man",
			"boy",
			"men"
		],
		skins: [
			{
				unified: "2642-fe0f",
				native: "♂️"
			}
		],
		version: 4
	},
	transgender_symbol: {
		id: "transgender_symbol",
		name: "Transgender Symbol",
		keywords: [
			"lgbtq"
		],
		skins: [
			{
				unified: "26a7-fe0f",
				native: "⚧️"
			}
		],
		version: 13
	},
	heavy_multiplication_x: {
		id: "heavy_multiplication_x",
		name: "Multiply",
		keywords: [
			"heavy",
			"multiplication",
			"x",
			"sign",
			"math",
			"calculation"
		],
		skins: [
			{
				unified: "2716-fe0f",
				native: "✖️"
			}
		],
		version: 1
	},
	heavy_plus_sign: {
		id: "heavy_plus_sign",
		name: "Plus",
		keywords: [
			"heavy",
			"sign",
			"math",
			"calculation",
			"addition",
			"more",
			"increase"
		],
		skins: [
			{
				unified: "2795",
				native: "➕"
			}
		],
		version: 1
	},
	heavy_minus_sign: {
		id: "heavy_minus_sign",
		name: "Minus",
		keywords: [
			"heavy",
			"sign",
			"math",
			"calculation",
			"subtract",
			"less"
		],
		skins: [
			{
				unified: "2796",
				native: "➖"
			}
		],
		version: 1
	},
	heavy_division_sign: {
		id: "heavy_division_sign",
		name: "Divide",
		keywords: [
			"heavy",
			"division",
			"sign",
			"math",
			"calculation"
		],
		skins: [
			{
				unified: "2797",
				native: "➗"
			}
		],
		version: 1
	},
	heavy_equals_sign: {
		id: "heavy_equals_sign",
		name: "Heavy Equals Sign",
		keywords: [
			"math"
		],
		skins: [
			{
				unified: "1f7f0",
				native: "🟰"
			}
		],
		version: 14
	},
	infinity: {
		id: "infinity",
		name: "Infinity",
		keywords: [
			"forever"
		],
		skins: [
			{
				unified: "267e-fe0f",
				native: "♾️"
			}
		],
		version: 11
	},
	bangbang: {
		id: "bangbang",
		name: "Double Exclamation Mark",
		keywords: [
			"bangbang",
			"surprise"
		],
		skins: [
			{
				unified: "203c-fe0f",
				native: "‼️"
			}
		],
		version: 1
	},
	interrobang: {
		id: "interrobang",
		name: "Exclamation Question Mark",
		keywords: [
			"interrobang",
			"wat",
			"punctuation",
			"surprise"
		],
		skins: [
			{
				unified: "2049-fe0f",
				native: "⁉️"
			}
		],
		version: 1
	},
	question: {
		id: "question",
		name: "Red Question Mark",
		keywords: [
			"doubt",
			"confused"
		],
		skins: [
			{
				unified: "2753",
				native: "❓"
			}
		],
		version: 1
	},
	grey_question: {
		id: "grey_question",
		name: "White Question Mark",
		keywords: [
			"grey",
			"doubts",
			"gray",
			"huh",
			"confused"
		],
		skins: [
			{
				unified: "2754",
				native: "❔"
			}
		],
		version: 1
	},
	grey_exclamation: {
		id: "grey_exclamation",
		name: "White Exclamation Mark",
		keywords: [
			"grey",
			"surprise",
			"punctuation",
			"gray",
			"wow",
			"warning"
		],
		skins: [
			{
				unified: "2755",
				native: "❕"
			}
		],
		version: 1
	},
	exclamation: {
		id: "exclamation",
		name: "Red Exclamation Mark",
		keywords: [
			"heavy",
			"danger",
			"surprise",
			"punctuation",
			"wow",
			"warning"
		],
		skins: [
			{
				unified: "2757",
				native: "❗"
			}
		],
		version: 1
	},
	wavy_dash: {
		id: "wavy_dash",
		name: "Wavy Dash",
		keywords: [
			"draw",
			"line",
			"moustache",
			"mustache",
			"squiggle",
			"scribble"
		],
		skins: [
			{
				unified: "3030-fe0f",
				native: "〰️"
			}
		],
		version: 1
	},
	currency_exchange: {
		id: "currency_exchange",
		name: "Currency Exchange",
		keywords: [
			"money",
			"sales",
			"dollar",
			"travel"
		],
		skins: [
			{
				unified: "1f4b1",
				native: "💱"
			}
		],
		version: 1
	},
	heavy_dollar_sign: {
		id: "heavy_dollar_sign",
		name: "Heavy Dollar Sign",
		keywords: [
			"money",
			"sales",
			"payment",
			"currency",
			"buck"
		],
		skins: [
			{
				unified: "1f4b2",
				native: "💲"
			}
		],
		version: 1
	},
	medical_symbol: {
		id: "medical_symbol",
		name: "Medical Symbol",
		keywords: [
			"staff",
			"of",
			"aesculapius",
			"health",
			"hospital"
		],
		skins: [
			{
				unified: "2695-fe0f",
				native: "⚕️"
			}
		],
		version: 4
	},
	recycle: {
		id: "recycle",
		name: "Recycling Symbol",
		keywords: [
			"recycle",
			"arrow",
			"environment",
			"garbage",
			"trash"
		],
		skins: [
			{
				unified: "267b-fe0f",
				native: "♻️"
			}
		],
		version: 1
	},
	fleur_de_lis: {
		id: "fleur_de_lis",
		name: "Fleur-De-Lis",
		keywords: [
			"fleur",
			"de",
			"lis",
			"decorative",
			"scout"
		],
		skins: [
			{
				unified: "269c-fe0f",
				native: "⚜️"
			}
		],
		version: 1
	},
	trident: {
		id: "trident",
		name: "Trident Emblem",
		keywords: [
			"weapon",
			"spear"
		],
		skins: [
			{
				unified: "1f531",
				native: "🔱"
			}
		],
		version: 1
	},
	name_badge: {
		id: "name_badge",
		name: "Name Badge",
		keywords: [
			"fire",
			"forbid"
		],
		skins: [
			{
				unified: "1f4db",
				native: "📛"
			}
		],
		version: 1
	},
	beginner: {
		id: "beginner",
		name: "Japanese Symbol for Beginner",
		keywords: [
			"badge",
			"shield"
		],
		skins: [
			{
				unified: "1f530",
				native: "🔰"
			}
		],
		version: 1
	},
	o: {
		id: "o",
		name: "Hollow Red Circle",
		keywords: [
			"o",
			"round"
		],
		skins: [
			{
				unified: "2b55",
				native: "⭕"
			}
		],
		version: 1
	},
	white_check_mark: {
		id: "white_check_mark",
		name: "Check Mark Button",
		keywords: [
			"white",
			"green",
			"square",
			"ok",
			"agree",
			"vote",
			"election",
			"answer",
			"tick"
		],
		skins: [
			{
				unified: "2705",
				native: "✅"
			}
		],
		version: 1
	},
	ballot_box_with_check: {
		id: "ballot_box_with_check",
		name: "Check Box with Check",
		keywords: [
			"ballot",
			"ok",
			"agree",
			"confirm",
			"black",
			"square",
			"vote",
			"election",
			"yes",
			"tick"
		],
		skins: [
			{
				unified: "2611-fe0f",
				native: "☑️"
			}
		],
		version: 1
	},
	heavy_check_mark: {
		id: "heavy_check_mark",
		name: "Check Mark",
		keywords: [
			"heavy",
			"ok",
			"nike",
			"answer",
			"yes",
			"tick"
		],
		skins: [
			{
				unified: "2714-fe0f",
				native: "✔️"
			}
		],
		version: 1
	},
	x: {
		id: "x",
		name: "Cross Mark",
		keywords: [
			"x",
			"no",
			"delete",
			"remove",
			"cancel",
			"red"
		],
		skins: [
			{
				unified: "274c",
				native: "❌"
			}
		],
		version: 1
	},
	negative_squared_cross_mark: {
		id: "negative_squared_cross_mark",
		name: "Cross Mark Button",
		keywords: [
			"negative",
			"squared",
			"x",
			"green",
			"square",
			"no",
			"deny"
		],
		skins: [
			{
				unified: "274e",
				native: "❎"
			}
		],
		version: 1
	},
	curly_loop: {
		id: "curly_loop",
		name: "Curly Loop",
		keywords: [
			"scribble",
			"draw",
			"shape",
			"squiggle"
		],
		skins: [
			{
				unified: "27b0",
				native: "➰"
			}
		],
		version: 1
	},
	loop: {
		id: "loop",
		name: "Double Curly Loop",
		keywords: [
			"tape",
			"cassette"
		],
		skins: [
			{
				unified: "27bf",
				native: "➿"
			}
		],
		version: 1
	},
	part_alternation_mark: {
		id: "part_alternation_mark",
		name: "Part Alternation Mark",
		keywords: [
			"graph",
			"presentation",
			"stats",
			"business",
			"economics",
			"bad"
		],
		skins: [
			{
				unified: "303d-fe0f",
				native: "〽️"
			}
		],
		version: 1
	},
	eight_spoked_asterisk: {
		id: "eight_spoked_asterisk",
		name: "Eight Spoked Asterisk",
		keywords: [
			"star",
			"sparkle",
			"green",
			"square"
		],
		skins: [
			{
				unified: "2733-fe0f",
				native: "✳️"
			}
		],
		version: 1
	},
	eight_pointed_black_star: {
		id: "eight_pointed_black_star",
		name: "Eight-Pointed Star",
		keywords: [
			"eight",
			"pointed",
			"black",
			"orange",
			"square",
			"shape",
			"polygon"
		],
		skins: [
			{
				unified: "2734-fe0f",
				native: "✴️"
			}
		],
		version: 1
	},
	sparkle: {
		id: "sparkle",
		name: "Sparkle",
		keywords: [
			"stars",
			"green",
			"square",
			"awesome",
			"good",
			"fireworks"
		],
		skins: [
			{
				unified: "2747-fe0f",
				native: "❇️"
			}
		],
		version: 1
	},
	copyright: {
		id: "copyright",
		name: "Copyright",
		keywords: [
			"ip",
			"license",
			"circle",
			"law",
			"legal"
		],
		skins: [
			{
				unified: "00a9-fe0f",
				native: "©️"
			}
		],
		version: 1
	},
	registered: {
		id: "registered",
		name: "Registered",
		keywords: [
			"alphabet",
			"circle"
		],
		skins: [
			{
				unified: "00ae-fe0f",
				native: "®️"
			}
		],
		version: 1
	},
	tm: {
		id: "tm",
		name: "Trade Mark",
		keywords: [
			"tm",
			"trademark",
			"brand",
			"law",
			"legal"
		],
		skins: [
			{
				unified: "2122-fe0f",
				native: "™️"
			}
		],
		version: 1
	},
	hash: {
		id: "hash",
		name: "Hash Key",
		keywords: [
			"keycap",
			"",
			"symbol",
			"blue",
			"square",
			"twitter"
		],
		skins: [
			{
				unified: "0023-fe0f-20e3",
				native: "#️⃣"
			}
		],
		version: 1
	},
	keycap_star: {
		id: "keycap_star",
		name: "Keycap: *",
		keywords: [
			"keycap",
			"star",
			""
		],
		skins: [
			{
				unified: "002a-fe0f-20e3",
				native: "*️⃣"
			}
		],
		version: 2
	},
	zero: {
		id: "zero",
		name: "Keycap 0",
		keywords: [
			"zero",
			"numbers",
			"blue",
			"square",
			"null"
		],
		skins: [
			{
				unified: "0030-fe0f-20e3",
				native: "0️⃣"
			}
		],
		version: 1
	},
	one: {
		id: "one",
		name: "Keycap 1",
		keywords: [
			"one",
			"blue",
			"square",
			"numbers"
		],
		skins: [
			{
				unified: "0031-fe0f-20e3",
				native: "1️⃣"
			}
		],
		version: 1
	},
	two: {
		id: "two",
		name: "Keycap 2",
		keywords: [
			"two",
			"numbers",
			"prime",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "0032-fe0f-20e3",
				native: "2️⃣"
			}
		],
		version: 1
	},
	three: {
		id: "three",
		name: "Keycap 3",
		keywords: [
			"three",
			"numbers",
			"prime",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "0033-fe0f-20e3",
				native: "3️⃣"
			}
		],
		version: 1
	},
	four: {
		id: "four",
		name: "Keycap 4",
		keywords: [
			"four",
			"numbers",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "0034-fe0f-20e3",
				native: "4️⃣"
			}
		],
		version: 1
	},
	five: {
		id: "five",
		name: "Keycap 5",
		keywords: [
			"five",
			"numbers",
			"blue",
			"square",
			"prime"
		],
		skins: [
			{
				unified: "0035-fe0f-20e3",
				native: "5️⃣"
			}
		],
		version: 1
	},
	six: {
		id: "six",
		name: "Keycap 6",
		keywords: [
			"six",
			"numbers",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "0036-fe0f-20e3",
				native: "6️⃣"
			}
		],
		version: 1
	},
	seven: {
		id: "seven",
		name: "Keycap 7",
		keywords: [
			"seven",
			"numbers",
			"blue",
			"square",
			"prime"
		],
		skins: [
			{
				unified: "0037-fe0f-20e3",
				native: "7️⃣"
			}
		],
		version: 1
	},
	eight: {
		id: "eight",
		name: "Keycap 8",
		keywords: [
			"eight",
			"blue",
			"square",
			"numbers"
		],
		skins: [
			{
				unified: "0038-fe0f-20e3",
				native: "8️⃣"
			}
		],
		version: 1
	},
	nine: {
		id: "nine",
		name: "Keycap 9",
		keywords: [
			"nine",
			"blue",
			"square",
			"numbers"
		],
		skins: [
			{
				unified: "0039-fe0f-20e3",
				native: "9️⃣"
			}
		],
		version: 1
	},
	keycap_ten: {
		id: "keycap_ten",
		name: "Keycap 10",
		keywords: [
			"ten",
			"numbers",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f51f",
				native: "🔟"
			}
		],
		version: 1
	},
	capital_abcd: {
		id: "capital_abcd",
		name: "Input Latin Uppercase",
		keywords: [
			"capital",
			"abcd",
			"alphabet",
			"words",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f520",
				native: "🔠"
			}
		],
		version: 1
	},
	abcd: {
		id: "abcd",
		name: "Input Latin Lowercase",
		keywords: [
			"abcd",
			"blue",
			"square",
			"alphabet"
		],
		skins: [
			{
				unified: "1f521",
				native: "🔡"
			}
		],
		version: 1
	},
	symbols: {
		id: "symbols",
		name: "Input Symbols",
		keywords: [
			"blue",
			"square",
			"music",
			"note",
			"ampersand",
			"percent",
			"glyphs",
			"characters"
		],
		skins: [
			{
				unified: "1f523",
				native: "🔣"
			}
		],
		version: 1
	},
	abc: {
		id: "abc",
		name: "Input Latin Letters",
		keywords: [
			"abc",
			"blue",
			"square",
			"alphabet"
		],
		skins: [
			{
				unified: "1f524",
				native: "🔤"
			}
		],
		version: 1
	},
	a: {
		id: "a",
		name: "A Button (blood Type)",
		keywords: [
			"red",
			"square",
			"alphabet",
			"letter"
		],
		skins: [
			{
				unified: "1f170-fe0f",
				native: "🅰️"
			}
		],
		version: 1
	},
	ab: {
		id: "ab",
		name: "Negative Squared Ab",
		keywords: [
			"button",
			"red",
			"square",
			"alphabet"
		],
		skins: [
			{
				unified: "1f18e",
				native: "🆎"
			}
		],
		version: 1
	},
	b: {
		id: "b",
		name: "B Button (blood Type)",
		keywords: [
			"red",
			"square",
			"alphabet",
			"letter"
		],
		skins: [
			{
				unified: "1f171-fe0f",
				native: "🅱️"
			}
		],
		version: 1
	},
	cl: {
		id: "cl",
		name: "Cl Button",
		keywords: [
			"alphabet",
			"words",
			"red",
			"square"
		],
		skins: [
			{
				unified: "1f191",
				native: "🆑"
			}
		],
		version: 1
	},
	cool: {
		id: "cool",
		name: "Cool Button",
		keywords: [
			"words",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f192",
				native: "🆒"
			}
		],
		version: 1
	},
	free: {
		id: "free",
		name: "Free Button",
		keywords: [
			"blue",
			"square",
			"words"
		],
		skins: [
			{
				unified: "1f193",
				native: "🆓"
			}
		],
		version: 1
	},
	information_source: {
		id: "information_source",
		name: "Information",
		keywords: [
			"source",
			"blue",
			"square",
			"alphabet",
			"letter"
		],
		skins: [
			{
				unified: "2139-fe0f",
				native: "ℹ️"
			}
		],
		version: 1
	},
	id: {
		id: "id",
		name: "Id Button",
		keywords: [
			"purple",
			"square",
			"words"
		],
		skins: [
			{
				unified: "1f194",
				native: "🆔"
			}
		],
		version: 1
	},
	m: {
		id: "m",
		name: "Circled M",
		keywords: [
			"alphabet",
			"blue",
			"circle",
			"letter"
		],
		skins: [
			{
				unified: "24c2-fe0f",
				native: "Ⓜ️"
			}
		],
		version: 1
	},
	"new": {
		id: "new",
		name: "New Button",
		keywords: [
			"blue",
			"square",
			"words",
			"start"
		],
		skins: [
			{
				unified: "1f195",
				native: "🆕"
			}
		],
		version: 1
	},
	ng: {
		id: "ng",
		name: "Ng Button",
		keywords: [
			"blue",
			"square",
			"words",
			"shape",
			"icon"
		],
		skins: [
			{
				unified: "1f196",
				native: "🆖"
			}
		],
		version: 1
	},
	o2: {
		id: "o2",
		name: "O Button (blood Type)",
		keywords: [
			"o2",
			"alphabet",
			"red",
			"square",
			"letter"
		],
		skins: [
			{
				unified: "1f17e-fe0f",
				native: "🅾️"
			}
		],
		version: 1
	},
	ok: {
		id: "ok",
		name: "Ok Button",
		keywords: [
			"good",
			"agree",
			"yes",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f197",
				native: "🆗"
			}
		],
		version: 1
	},
	parking: {
		id: "parking",
		name: "P Button",
		keywords: [
			"parking",
			"cars",
			"blue",
			"square",
			"alphabet",
			"letter"
		],
		skins: [
			{
				unified: "1f17f-fe0f",
				native: "🅿️"
			}
		],
		version: 1
	},
	sos: {
		id: "sos",
		name: "Sos Button",
		keywords: [
			"help",
			"red",
			"square",
			"words",
			"emergency",
			"911"
		],
		skins: [
			{
				unified: "1f198",
				native: "🆘"
			}
		],
		version: 1
	},
	up: {
		id: "up",
		name: "Up! Button",
		keywords: [
			"up",
			"blue",
			"square",
			"above",
			"high"
		],
		skins: [
			{
				unified: "1f199",
				native: "🆙"
			}
		],
		version: 1
	},
	vs: {
		id: "vs",
		name: "Vs Button",
		keywords: [
			"words",
			"orange",
			"square"
		],
		skins: [
			{
				unified: "1f19a",
				native: "🆚"
			}
		],
		version: 1
	},
	koko: {
		id: "koko",
		name: "Squared Katakana Koko",
		keywords: [
			"japanese",
			"here",
			"button",
			"blue",
			"square",
			"destination"
		],
		skins: [
			{
				unified: "1f201",
				native: "🈁"
			}
		],
		version: 1
	},
	sa: {
		id: "sa",
		name: "Squared Katakana Sa",
		keywords: [
			"japanese",
			"service",
			"charge",
			"button",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f202-fe0f",
				native: "🈂️"
			}
		],
		version: 1
	},
	u6708: {
		id: "u6708",
		name: "Japanese “monthly Amount” Button",
		keywords: [
			"u6708",
			"monthly",
			"amount",
			"chinese",
			"month",
			"moon",
			"orange",
			"square",
			"kanji"
		],
		skins: [
			{
				unified: "1f237-fe0f",
				native: "🈷️"
			}
		],
		version: 1
	},
	u6709: {
		id: "u6709",
		name: "Squared Cjk Unified Ideograph-6709",
		keywords: [
			"u6709",
			"japanese",
			"not",
			"free",
			"of",
			"charge",
			"button",
			"orange",
			"square",
			"chinese",
			"have",
			"kanji"
		],
		skins: [
			{
				unified: "1f236",
				native: "🈶"
			}
		],
		version: 1
	},
	u6307: {
		id: "u6307",
		name: "Japanese “reserved” Button",
		keywords: [
			"u6307",
			"reserved",
			"chinese",
			"point",
			"green",
			"square",
			"kanji"
		],
		skins: [
			{
				unified: "1f22f",
				native: "🈯"
			}
		],
		version: 1
	},
	ideograph_advantage: {
		id: "ideograph_advantage",
		name: "Japanese “bargain” Button",
		keywords: [
			"ideograph",
			"advantage",
			"bargain",
			"chinese",
			"kanji",
			"obtain",
			"get",
			"circle"
		],
		skins: [
			{
				unified: "1f250",
				native: "🉐"
			}
		],
		version: 1
	},
	u5272: {
		id: "u5272",
		name: "Japanese “discount” Button",
		keywords: [
			"u5272",
			"discount",
			"cut",
			"divide",
			"chinese",
			"kanji",
			"pink",
			"square"
		],
		skins: [
			{
				unified: "1f239",
				native: "🈹"
			}
		],
		version: 1
	},
	u7121: {
		id: "u7121",
		name: "Japanese “free of Charge” Button",
		keywords: [
			"u7121",
			"free",
			"charge",
			"nothing",
			"chinese",
			"kanji",
			"orange",
			"square"
		],
		skins: [
			{
				unified: "1f21a",
				native: "🈚"
			}
		],
		version: 1
	},
	u7981: {
		id: "u7981",
		name: "Japanese “prohibited” Button",
		keywords: [
			"u7981",
			"prohibited",
			"kanji",
			"chinese",
			"forbidden",
			"limit",
			"restricted",
			"red",
			"square"
		],
		skins: [
			{
				unified: "1f232",
				native: "🈲"
			}
		],
		version: 1
	},
	accept: {
		id: "accept",
		name: "Circled Ideograph Accept",
		keywords: [
			"japanese",
			"acceptable",
			"button",
			"ok",
			"good",
			"chinese",
			"kanji",
			"agree",
			"yes",
			"orange",
			"circle"
		],
		skins: [
			{
				unified: "1f251",
				native: "🉑"
			}
		],
		version: 1
	},
	u7533: {
		id: "u7533",
		name: "Japanese “application” Button",
		keywords: [
			"u7533",
			"application",
			"chinese",
			"kanji",
			"orange",
			"square"
		],
		skins: [
			{
				unified: "1f238",
				native: "🈸"
			}
		],
		version: 1
	},
	u5408: {
		id: "u5408",
		name: "Japanese “passing Grade” Button",
		keywords: [
			"u5408",
			"passing",
			"grade",
			"chinese",
			"join",
			"kanji",
			"red",
			"square"
		],
		skins: [
			{
				unified: "1f234",
				native: "🈴"
			}
		],
		version: 1
	},
	u7a7a: {
		id: "u7a7a",
		name: "Japanese “vacancy” Button",
		keywords: [
			"u7a7a",
			"vacancy",
			"kanji",
			"chinese",
			"empty",
			"sky",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f233",
				native: "🈳"
			}
		],
		version: 1
	},
	congratulations: {
		id: "congratulations",
		name: "Circled Ideograph Congratulation",
		keywords: [
			"congratulations",
			"japanese",
			"button",
			"chinese",
			"kanji",
			"red",
			"circle"
		],
		skins: [
			{
				unified: "3297-fe0f",
				native: "㊗️"
			}
		],
		version: 1
	},
	secret: {
		id: "secret",
		name: "Circled Ideograph Secret",
		keywords: [
			"japanese",
			"button",
			"privacy",
			"chinese",
			"sshh",
			"kanji",
			"red",
			"circle"
		],
		skins: [
			{
				unified: "3299-fe0f",
				native: "㊙️"
			}
		],
		version: 1
	},
	u55b6: {
		id: "u55b6",
		name: "Squared Cjk Unified Ideograph-55b6",
		keywords: [
			"u55b6",
			"japanese",
			"open",
			"for",
			"business",
			"button",
			"opening",
			"hours",
			"orange",
			"square"
		],
		skins: [
			{
				unified: "1f23a",
				native: "🈺"
			}
		],
		version: 1
	},
	u6e80: {
		id: "u6e80",
		name: "Japanese “no Vacancy” Button",
		keywords: [
			"u6e80",
			"no",
			"vacancy",
			"full",
			"chinese",
			"red",
			"square",
			"kanji"
		],
		skins: [
			{
				unified: "1f235",
				native: "🈵"
			}
		],
		version: 1
	},
	red_circle: {
		id: "red_circle",
		name: "Red Circle",
		keywords: [
			"shape",
			"error",
			"danger"
		],
		skins: [
			{
				unified: "1f534",
				native: "🔴"
			}
		],
		version: 1
	},
	large_orange_circle: {
		id: "large_orange_circle",
		name: "Orange Circle",
		keywords: [
			"large",
			"round"
		],
		skins: [
			{
				unified: "1f7e0",
				native: "🟠"
			}
		],
		version: 12
	},
	large_yellow_circle: {
		id: "large_yellow_circle",
		name: "Yellow Circle",
		keywords: [
			"large",
			"round"
		],
		skins: [
			{
				unified: "1f7e1",
				native: "🟡"
			}
		],
		version: 12
	},
	large_green_circle: {
		id: "large_green_circle",
		name: "Green Circle",
		keywords: [
			"large",
			"round"
		],
		skins: [
			{
				unified: "1f7e2",
				native: "🟢"
			}
		],
		version: 12
	},
	large_blue_circle: {
		id: "large_blue_circle",
		name: "Blue Circle",
		keywords: [
			"large",
			"shape",
			"icon",
			"button"
		],
		skins: [
			{
				unified: "1f535",
				native: "🔵"
			}
		],
		version: 1
	},
	large_purple_circle: {
		id: "large_purple_circle",
		name: "Purple Circle",
		keywords: [
			"large",
			"round"
		],
		skins: [
			{
				unified: "1f7e3",
				native: "🟣"
			}
		],
		version: 12
	},
	large_brown_circle: {
		id: "large_brown_circle",
		name: "Brown Circle",
		keywords: [
			"large",
			"round"
		],
		skins: [
			{
				unified: "1f7e4",
				native: "🟤"
			}
		],
		version: 12
	},
	black_circle: {
		id: "black_circle",
		name: "Black Circle",
		keywords: [
			"shape",
			"button",
			"round"
		],
		skins: [
			{
				unified: "26ab",
				native: "⚫"
			}
		],
		version: 1
	},
	white_circle: {
		id: "white_circle",
		name: "White Circle",
		keywords: [
			"shape",
			"round"
		],
		skins: [
			{
				unified: "26aa",
				native: "⚪"
			}
		],
		version: 1
	},
	large_red_square: {
		id: "large_red_square",
		name: "Red Square",
		keywords: [
			"large"
		],
		skins: [
			{
				unified: "1f7e5",
				native: "🟥"
			}
		],
		version: 12
	},
	large_orange_square: {
		id: "large_orange_square",
		name: "Orange Square",
		keywords: [
			"large"
		],
		skins: [
			{
				unified: "1f7e7",
				native: "🟧"
			}
		],
		version: 12
	},
	large_yellow_square: {
		id: "large_yellow_square",
		name: "Yellow Square",
		keywords: [
			"large"
		],
		skins: [
			{
				unified: "1f7e8",
				native: "🟨"
			}
		],
		version: 12
	},
	large_green_square: {
		id: "large_green_square",
		name: "Green Square",
		keywords: [
			"large"
		],
		skins: [
			{
				unified: "1f7e9",
				native: "🟩"
			}
		],
		version: 12
	},
	large_blue_square: {
		id: "large_blue_square",
		name: "Blue Square",
		keywords: [
			"large"
		],
		skins: [
			{
				unified: "1f7e6",
				native: "🟦"
			}
		],
		version: 12
	},
	large_purple_square: {
		id: "large_purple_square",
		name: "Purple Square",
		keywords: [
			"large"
		],
		skins: [
			{
				unified: "1f7ea",
				native: "🟪"
			}
		],
		version: 12
	},
	large_brown_square: {
		id: "large_brown_square",
		name: "Brown Square",
		keywords: [
			"large"
		],
		skins: [
			{
				unified: "1f7eb",
				native: "🟫"
			}
		],
		version: 12
	},
	black_large_square: {
		id: "black_large_square",
		name: "Black Large Square",
		keywords: [
			"shape",
			"icon",
			"button"
		],
		skins: [
			{
				unified: "2b1b",
				native: "⬛"
			}
		],
		version: 1
	},
	white_large_square: {
		id: "white_large_square",
		name: "White Large Square",
		keywords: [
			"shape",
			"icon",
			"stone",
			"button"
		],
		skins: [
			{
				unified: "2b1c",
				native: "⬜"
			}
		],
		version: 1
	},
	black_medium_square: {
		id: "black_medium_square",
		name: "Black Medium Square",
		keywords: [
			"shape",
			"button",
			"icon"
		],
		skins: [
			{
				unified: "25fc-fe0f",
				native: "◼️"
			}
		],
		version: 1
	},
	white_medium_square: {
		id: "white_medium_square",
		name: "White Medium Square",
		keywords: [
			"shape",
			"stone",
			"icon"
		],
		skins: [
			{
				unified: "25fb-fe0f",
				native: "◻️"
			}
		],
		version: 1
	},
	black_medium_small_square: {
		id: "black_medium_small_square",
		name: "Black Medium Small Square",
		keywords: [
			"icon",
			"shape",
			"button"
		],
		skins: [
			{
				unified: "25fe",
				native: "◾"
			}
		],
		version: 1
	},
	white_medium_small_square: {
		id: "white_medium_small_square",
		name: "White Medium Small Square",
		keywords: [
			"shape",
			"stone",
			"icon",
			"button"
		],
		skins: [
			{
				unified: "25fd",
				native: "◽"
			}
		],
		version: 1
	},
	black_small_square: {
		id: "black_small_square",
		name: "Black Small Square",
		keywords: [
			"shape",
			"icon"
		],
		skins: [
			{
				unified: "25aa-fe0f",
				native: "▪️"
			}
		],
		version: 1
	},
	white_small_square: {
		id: "white_small_square",
		name: "White Small Square",
		keywords: [
			"shape",
			"icon"
		],
		skins: [
			{
				unified: "25ab-fe0f",
				native: "▫️"
			}
		],
		version: 1
	},
	large_orange_diamond: {
		id: "large_orange_diamond",
		name: "Large Orange Diamond",
		keywords: [
			"shape",
			"jewel",
			"gem"
		],
		skins: [
			{
				unified: "1f536",
				native: "🔶"
			}
		],
		version: 1
	},
	large_blue_diamond: {
		id: "large_blue_diamond",
		name: "Large Blue Diamond",
		keywords: [
			"shape",
			"jewel",
			"gem"
		],
		skins: [
			{
				unified: "1f537",
				native: "🔷"
			}
		],
		version: 1
	},
	small_orange_diamond: {
		id: "small_orange_diamond",
		name: "Small Orange Diamond",
		keywords: [
			"shape",
			"jewel",
			"gem"
		],
		skins: [
			{
				unified: "1f538",
				native: "🔸"
			}
		],
		version: 1
	},
	small_blue_diamond: {
		id: "small_blue_diamond",
		name: "Small Blue Diamond",
		keywords: [
			"shape",
			"jewel",
			"gem"
		],
		skins: [
			{
				unified: "1f539",
				native: "🔹"
			}
		],
		version: 1
	},
	small_red_triangle: {
		id: "small_red_triangle",
		name: "Red Triangle Pointed Up",
		keywords: [
			"small",
			"shape",
			"direction",
			"top"
		],
		skins: [
			{
				unified: "1f53a",
				native: "🔺"
			}
		],
		version: 1
	},
	small_red_triangle_down: {
		id: "small_red_triangle_down",
		name: "Red Triangle Pointed Down",
		keywords: [
			"small",
			"shape",
			"direction",
			"bottom"
		],
		skins: [
			{
				unified: "1f53b",
				native: "🔻"
			}
		],
		version: 1
	},
	diamond_shape_with_a_dot_inside: {
		id: "diamond_shape_with_a_dot_inside",
		name: "Diamond with a Dot",
		keywords: [
			"shape",
			"inside",
			"jewel",
			"blue",
			"gem",
			"crystal",
			"fancy"
		],
		skins: [
			{
				unified: "1f4a0",
				native: "💠"
			}
		],
		version: 1
	},
	radio_button: {
		id: "radio_button",
		name: "Radio Button",
		keywords: [
			"input",
			"old",
			"music",
			"circle"
		],
		skins: [
			{
				unified: "1f518",
				native: "🔘"
			}
		],
		version: 1
	},
	white_square_button: {
		id: "white_square_button",
		name: "White Square Button",
		keywords: [
			"shape",
			"input"
		],
		skins: [
			{
				unified: "1f533",
				native: "🔳"
			}
		],
		version: 1
	},
	black_square_button: {
		id: "black_square_button",
		name: "Black Square Button",
		keywords: [
			"shape",
			"input",
			"frame"
		],
		skins: [
			{
				unified: "1f532",
				native: "🔲"
			}
		],
		version: 1
	},
	checkered_flag: {
		id: "checkered_flag",
		name: "Chequered Flag",
		keywords: [
			"checkered",
			"contest",
			"finishline",
			"race",
			"gokart"
		],
		skins: [
			{
				unified: "1f3c1",
				native: "🏁"
			}
		],
		version: 1
	},
	triangular_flag_on_post: {
		id: "triangular_flag_on_post",
		name: "Triangular Flag",
		keywords: [
			"on",
			"post",
			"mark",
			"milestone",
			"place"
		],
		skins: [
			{
				unified: "1f6a9",
				native: "🚩"
			}
		],
		version: 1
	},
	crossed_flags: {
		id: "crossed_flags",
		name: "Crossed Flags",
		keywords: [
			"japanese",
			"nation",
			"country",
			"border"
		],
		skins: [
			{
				unified: "1f38c",
				native: "🎌"
			}
		],
		version: 1
	},
	waving_black_flag: {
		id: "waving_black_flag",
		name: "Black Flag",
		keywords: [
			"waving",
			"pirate"
		],
		skins: [
			{
				unified: "1f3f4",
				native: "🏴"
			}
		],
		version: 1
	},
	waving_white_flag: {
		id: "waving_white_flag",
		name: "White Flag",
		keywords: [
			"waving",
			"losing",
			"loser",
			"lost",
			"surrender",
			"give",
			"up",
			"fail"
		],
		skins: [
			{
				unified: "1f3f3-fe0f",
				native: "🏳️"
			}
		],
		version: 1
	},
	"rainbow-flag": {
		id: "rainbow-flag",
		name: "Rainbow Flag",
		keywords: [
			"pride",
			"gay",
			"lgbt",
			"glbt",
			"queer",
			"homosexual",
			"lesbian",
			"bisexual",
			"transgender"
		],
		skins: [
			{
				unified: "1f3f3-fe0f-200d-1f308",
				native: "🏳️‍🌈"
			}
		],
		version: 4
	},
	transgender_flag: {
		id: "transgender_flag",
		name: "Transgender Flag",
		keywords: [
			"lgbtq"
		],
		skins: [
			{
				unified: "1f3f3-fe0f-200d-26a7-fe0f",
				native: "🏳️‍⚧️"
			}
		],
		version: 13
	},
	pirate_flag: {
		id: "pirate_flag",
		name: "Pirate Flag",
		keywords: [
			"skull",
			"crossbones",
			"banner"
		],
		skins: [
			{
				unified: "1f3f4-200d-2620-fe0f",
				native: "🏴‍☠️"
			}
		],
		version: 11
	},
	"flag-ac": {
		id: "flag-ac",
		name: "Ascension Island Flag",
		keywords: [
			"ac"
		],
		skins: [
			{
				unified: "1f1e6-1f1e8",
				native: "🇦🇨"
			}
		],
		version: 2
	},
	"flag-ad": {
		id: "flag-ad",
		name: "Andorra Flag",
		keywords: [
			"ad",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1e9",
				native: "🇦🇩"
			}
		],
		version: 2
	},
	"flag-ae": {
		id: "flag-ae",
		name: "United Arab Emirates Flag",
		keywords: [
			"ae",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1ea",
				native: "🇦🇪"
			}
		],
		version: 2
	},
	"flag-af": {
		id: "flag-af",
		name: "Afghanistan Flag",
		keywords: [
			"af",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1eb",
				native: "🇦🇫"
			}
		],
		version: 2
	},
	"flag-ag": {
		id: "flag-ag",
		name: "Antigua & Barbuda Flag",
		keywords: [
			"ag",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1ec",
				native: "🇦🇬"
			}
		],
		version: 2
	},
	"flag-ai": {
		id: "flag-ai",
		name: "Anguilla Flag",
		keywords: [
			"ai",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1ee",
				native: "🇦🇮"
			}
		],
		version: 2
	},
	"flag-al": {
		id: "flag-al",
		name: "Albania Flag",
		keywords: [
			"al",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1f1",
				native: "🇦🇱"
			}
		],
		version: 2
	},
	"flag-am": {
		id: "flag-am",
		name: "Armenia Flag",
		keywords: [
			"am",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1f2",
				native: "🇦🇲"
			}
		],
		version: 2
	},
	"flag-ao": {
		id: "flag-ao",
		name: "Angola Flag",
		keywords: [
			"ao",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1f4",
				native: "🇦🇴"
			}
		],
		version: 2
	},
	"flag-aq": {
		id: "flag-aq",
		name: "Antarctica Flag",
		keywords: [
			"aq",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1f6",
				native: "🇦🇶"
			}
		],
		version: 2
	},
	"flag-ar": {
		id: "flag-ar",
		name: "Argentina Flag",
		keywords: [
			"ar",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1f7",
				native: "🇦🇷"
			}
		],
		version: 2
	},
	"flag-as": {
		id: "flag-as",
		name: "American Samoa Flag",
		keywords: [
			"as",
			"ws",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1f8",
				native: "🇦🇸"
			}
		],
		version: 2
	},
	"flag-at": {
		id: "flag-at",
		name: "Austria Flag",
		keywords: [
			"at",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1f9",
				native: "🇦🇹"
			}
		],
		version: 2
	},
	"flag-au": {
		id: "flag-au",
		name: "Australia Flag",
		keywords: [
			"au",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1fa",
				native: "🇦🇺"
			}
		],
		version: 2
	},
	"flag-aw": {
		id: "flag-aw",
		name: "Aruba Flag",
		keywords: [
			"aw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1fc",
				native: "🇦🇼"
			}
		],
		version: 2
	},
	"flag-ax": {
		id: "flag-ax",
		name: "Åland Islands Flag",
		keywords: [
			"ax",
			"aland",
			"Aland",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1fd",
				native: "🇦🇽"
			}
		],
		version: 2
	},
	"flag-az": {
		id: "flag-az",
		name: "Azerbaijan Flag",
		keywords: [
			"az",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1ff",
				native: "🇦🇿"
			}
		],
		version: 2
	},
	"flag-ba": {
		id: "flag-ba",
		name: "Bosnia & Herzegovina Flag",
		keywords: [
			"ba",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1e6",
				native: "🇧🇦"
			}
		],
		version: 2
	},
	"flag-bb": {
		id: "flag-bb",
		name: "Barbados Flag",
		keywords: [
			"bb",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1e7",
				native: "🇧🇧"
			}
		],
		version: 2
	},
	"flag-bd": {
		id: "flag-bd",
		name: "Bangladesh Flag",
		keywords: [
			"bd",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1e9",
				native: "🇧🇩"
			}
		],
		version: 2
	},
	"flag-be": {
		id: "flag-be",
		name: "Belgium Flag",
		keywords: [
			"be",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1ea",
				native: "🇧🇪"
			}
		],
		version: 2
	},
	"flag-bf": {
		id: "flag-bf",
		name: "Burkina Faso Flag",
		keywords: [
			"bf",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1eb",
				native: "🇧🇫"
			}
		],
		version: 2
	},
	"flag-bg": {
		id: "flag-bg",
		name: "Bulgaria Flag",
		keywords: [
			"bg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1ec",
				native: "🇧🇬"
			}
		],
		version: 2
	},
	"flag-bh": {
		id: "flag-bh",
		name: "Bahrain Flag",
		keywords: [
			"bh",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1ed",
				native: "🇧🇭"
			}
		],
		version: 2
	},
	"flag-bi": {
		id: "flag-bi",
		name: "Burundi Flag",
		keywords: [
			"bi",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1ee",
				native: "🇧🇮"
			}
		],
		version: 2
	},
	"flag-bj": {
		id: "flag-bj",
		name: "Benin Flag",
		keywords: [
			"bj",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1ef",
				native: "🇧🇯"
			}
		],
		version: 2
	},
	"flag-bl": {
		id: "flag-bl",
		name: "St. Barthélemy Flag",
		keywords: [
			"bl",
			"st",
			"barthelemy",
			"saint",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f1",
				native: "🇧🇱"
			}
		],
		version: 2
	},
	"flag-bm": {
		id: "flag-bm",
		name: "Bermuda Flag",
		keywords: [
			"bm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f2",
				native: "🇧🇲"
			}
		],
		version: 2
	},
	"flag-bn": {
		id: "flag-bn",
		name: "Brunei Flag",
		keywords: [
			"bn",
			"darussalam",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f3",
				native: "🇧🇳"
			}
		],
		version: 2
	},
	"flag-bo": {
		id: "flag-bo",
		name: "Bolivia Flag",
		keywords: [
			"bo",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f4",
				native: "🇧🇴"
			}
		],
		version: 2
	},
	"flag-bq": {
		id: "flag-bq",
		name: "Caribbean Netherlands Flag",
		keywords: [
			"bq",
			"bonaire",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f6",
				native: "🇧🇶"
			}
		],
		version: 2
	},
	"flag-br": {
		id: "flag-br",
		name: "Brazil Flag",
		keywords: [
			"br",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f7",
				native: "🇧🇷"
			}
		],
		version: 2
	},
	"flag-bs": {
		id: "flag-bs",
		name: "Bahamas Flag",
		keywords: [
			"bs",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f8",
				native: "🇧🇸"
			}
		],
		version: 2
	},
	"flag-bt": {
		id: "flag-bt",
		name: "Bhutan Flag",
		keywords: [
			"bt",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f9",
				native: "🇧🇹"
			}
		],
		version: 2
	},
	"flag-bv": {
		id: "flag-bv",
		name: "Bouvet Island Flag",
		keywords: [
			"bv",
			"norway"
		],
		skins: [
			{
				unified: "1f1e7-1f1fb",
				native: "🇧🇻"
			}
		],
		version: 2
	},
	"flag-bw": {
		id: "flag-bw",
		name: "Botswana Flag",
		keywords: [
			"bw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1fc",
				native: "🇧🇼"
			}
		],
		version: 2
	},
	"flag-by": {
		id: "flag-by",
		name: "Belarus Flag",
		keywords: [
			"by",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1fe",
				native: "🇧🇾"
			}
		],
		version: 2
	},
	"flag-bz": {
		id: "flag-bz",
		name: "Belize Flag",
		keywords: [
			"bz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1ff",
				native: "🇧🇿"
			}
		],
		version: 2
	},
	"flag-ca": {
		id: "flag-ca",
		name: "Canada Flag",
		keywords: [
			"ca",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1e6",
				native: "🇨🇦"
			}
		],
		version: 2
	},
	"flag-cc": {
		id: "flag-cc",
		name: "Cocos (keeling) Islands Flag",
		keywords: [
			"cc",
			"keeling",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1e8",
				native: "🇨🇨"
			}
		],
		version: 2
	},
	"flag-cd": {
		id: "flag-cd",
		name: "Congo - Kinshasa Flag",
		keywords: [
			"cd",
			"democratic",
			"republic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1e9",
				native: "🇨🇩"
			}
		],
		version: 2
	},
	"flag-cf": {
		id: "flag-cf",
		name: "Central African Republic Flag",
		keywords: [
			"cf",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1eb",
				native: "🇨🇫"
			}
		],
		version: 2
	},
	"flag-cg": {
		id: "flag-cg",
		name: "Congo - Brazzaville Flag",
		keywords: [
			"cg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1ec",
				native: "🇨🇬"
			}
		],
		version: 2
	},
	"flag-ch": {
		id: "flag-ch",
		name: "Switzerland Flag",
		keywords: [
			"ch",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1ed",
				native: "🇨🇭"
			}
		],
		version: 2
	},
	"flag-ci": {
		id: "flag-ci",
		name: "Côte D’ivoire Flag",
		keywords: [
			"ci",
			"cote",
			"d",
			"ivoire",
			"ivory",
			"coast",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1ee",
				native: "🇨🇮"
			}
		],
		version: 2
	},
	"flag-ck": {
		id: "flag-ck",
		name: "Cook Islands Flag",
		keywords: [
			"ck",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1f0",
				native: "🇨🇰"
			}
		],
		version: 2
	},
	"flag-cl": {
		id: "flag-cl",
		name: "Chile Flag",
		keywords: [
			"cl",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1f1",
				native: "🇨🇱"
			}
		],
		version: 2
	},
	"flag-cm": {
		id: "flag-cm",
		name: "Cameroon Flag",
		keywords: [
			"cm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1f2",
				native: "🇨🇲"
			}
		],
		version: 2
	},
	cn: {
		id: "cn",
		name: "China Flag",
		keywords: [
			"cn",
			"chinese",
			"prc",
			"country",
			"nation",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1f3",
				native: "🇨🇳"
			}
		],
		version: 1
	},
	"flag-co": {
		id: "flag-co",
		name: "Colombia Flag",
		keywords: [
			"co",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1f4",
				native: "🇨🇴"
			}
		],
		version: 2
	},
	"flag-cp": {
		id: "flag-cp",
		name: "Clipperton Island Flag",
		keywords: [
			"cp"
		],
		skins: [
			{
				unified: "1f1e8-1f1f5",
				native: "🇨🇵"
			}
		],
		version: 2
	},
	"flag-cr": {
		id: "flag-cr",
		name: "Costa Rica Flag",
		keywords: [
			"cr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1f7",
				native: "🇨🇷"
			}
		],
		version: 2
	},
	"flag-cu": {
		id: "flag-cu",
		name: "Cuba Flag",
		keywords: [
			"cu",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1fa",
				native: "🇨🇺"
			}
		],
		version: 2
	},
	"flag-cv": {
		id: "flag-cv",
		name: "Cape Verde Flag",
		keywords: [
			"cv",
			"cabo",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1fb",
				native: "🇨🇻"
			}
		],
		version: 2
	},
	"flag-cw": {
		id: "flag-cw",
		name: "Curaçao Flag",
		keywords: [
			"cw",
			"curacao",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1fc",
				native: "🇨🇼"
			}
		],
		version: 2
	},
	"flag-cx": {
		id: "flag-cx",
		name: "Christmas Island Flag",
		keywords: [
			"cx",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1fd",
				native: "🇨🇽"
			}
		],
		version: 2
	},
	"flag-cy": {
		id: "flag-cy",
		name: "Cyprus Flag",
		keywords: [
			"cy",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1fe",
				native: "🇨🇾"
			}
		],
		version: 2
	},
	"flag-cz": {
		id: "flag-cz",
		name: "Czechia Flag",
		keywords: [
			"cz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1ff",
				native: "🇨🇿"
			}
		],
		version: 2
	},
	de: {
		id: "de",
		name: "Germany Flag",
		keywords: [
			"de",
			"german",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e9-1f1ea",
				native: "🇩🇪"
			}
		],
		version: 1
	},
	"flag-dg": {
		id: "flag-dg",
		name: "Diego Garcia Flag",
		keywords: [
			"dg"
		],
		skins: [
			{
				unified: "1f1e9-1f1ec",
				native: "🇩🇬"
			}
		],
		version: 2
	},
	"flag-dj": {
		id: "flag-dj",
		name: "Djibouti Flag",
		keywords: [
			"dj",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e9-1f1ef",
				native: "🇩🇯"
			}
		],
		version: 2
	},
	"flag-dk": {
		id: "flag-dk",
		name: "Denmark Flag",
		keywords: [
			"dk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e9-1f1f0",
				native: "🇩🇰"
			}
		],
		version: 2
	},
	"flag-dm": {
		id: "flag-dm",
		name: "Dominica Flag",
		keywords: [
			"dm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e9-1f1f2",
				native: "🇩🇲"
			}
		],
		version: 2
	},
	"flag-do": {
		id: "flag-do",
		name: "Dominican Republic Flag",
		keywords: [
			"do",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e9-1f1f4",
				native: "🇩🇴"
			}
		],
		version: 2
	},
	"flag-dz": {
		id: "flag-dz",
		name: "Algeria Flag",
		keywords: [
			"dz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e9-1f1ff",
				native: "🇩🇿"
			}
		],
		version: 2
	},
	"flag-ea": {
		id: "flag-ea",
		name: "Ceuta & Melilla Flag",
		keywords: [
			"ea"
		],
		skins: [
			{
				unified: "1f1ea-1f1e6",
				native: "🇪🇦"
			}
		],
		version: 2
	},
	"flag-ec": {
		id: "flag-ec",
		name: "Ecuador Flag",
		keywords: [
			"ec",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1e8",
				native: "🇪🇨"
			}
		],
		version: 2
	},
	"flag-ee": {
		id: "flag-ee",
		name: "Estonia Flag",
		keywords: [
			"ee",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1ea",
				native: "🇪🇪"
			}
		],
		version: 2
	},
	"flag-eg": {
		id: "flag-eg",
		name: "Egypt Flag",
		keywords: [
			"eg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1ec",
				native: "🇪🇬"
			}
		],
		version: 2
	},
	"flag-eh": {
		id: "flag-eh",
		name: "Western Sahara Flag",
		keywords: [
			"eh",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1ed",
				native: "🇪🇭"
			}
		],
		version: 2
	},
	"flag-er": {
		id: "flag-er",
		name: "Eritrea Flag",
		keywords: [
			"er",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1f7",
				native: "🇪🇷"
			}
		],
		version: 2
	},
	es: {
		id: "es",
		name: "Spain Flag",
		keywords: [
			"es",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1f8",
				native: "🇪🇸"
			}
		],
		version: 1
	},
	"flag-et": {
		id: "flag-et",
		name: "Ethiopia Flag",
		keywords: [
			"et",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1f9",
				native: "🇪🇹"
			}
		],
		version: 2
	},
	"flag-eu": {
		id: "flag-eu",
		name: "European Union Flag",
		keywords: [
			"eu",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1fa",
				native: "🇪🇺"
			}
		],
		version: 2
	},
	"flag-fi": {
		id: "flag-fi",
		name: "Finland Flag",
		keywords: [
			"fi",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1eb-1f1ee",
				native: "🇫🇮"
			}
		],
		version: 2
	},
	"flag-fj": {
		id: "flag-fj",
		name: "Fiji Flag",
		keywords: [
			"fj",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1eb-1f1ef",
				native: "🇫🇯"
			}
		],
		version: 2
	},
	"flag-fk": {
		id: "flag-fk",
		name: "Falkland Islands Flag",
		keywords: [
			"fk",
			"malvinas",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1eb-1f1f0",
				native: "🇫🇰"
			}
		],
		version: 2
	},
	"flag-fm": {
		id: "flag-fm",
		name: "Micronesia Flag",
		keywords: [
			"fm",
			"federated",
			"states",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1eb-1f1f2",
				native: "🇫🇲"
			}
		],
		version: 2
	},
	"flag-fo": {
		id: "flag-fo",
		name: "Faroe Islands Flag",
		keywords: [
			"fo",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1eb-1f1f4",
				native: "🇫🇴"
			}
		],
		version: 2
	},
	fr: {
		id: "fr",
		name: "France Flag",
		keywords: [
			"fr",
			"banner",
			"nation",
			"french",
			"country"
		],
		skins: [
			{
				unified: "1f1eb-1f1f7",
				native: "🇫🇷"
			}
		],
		version: 1
	},
	"flag-ga": {
		id: "flag-ga",
		name: "Gabon Flag",
		keywords: [
			"ga",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1e6",
				native: "🇬🇦"
			}
		],
		version: 2
	},
	gb: {
		id: "gb",
		name: "United Kingdom Flag",
		keywords: [
			"gb",
			"uk",
			"great",
			"britain",
			"northern",
			"ireland",
			"nation",
			"country",
			"banner",
			"british",
			"UK",
			"english",
			"england",
			"union",
			"jack"
		],
		skins: [
			{
				unified: "1f1ec-1f1e7",
				native: "🇬🇧"
			}
		],
		version: 1
	},
	"flag-gd": {
		id: "flag-gd",
		name: "Grenada Flag",
		keywords: [
			"gd",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1e9",
				native: "🇬🇩"
			}
		],
		version: 2
	},
	"flag-ge": {
		id: "flag-ge",
		name: "Georgia Flag",
		keywords: [
			"ge",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1ea",
				native: "🇬🇪"
			}
		],
		version: 2
	},
	"flag-gf": {
		id: "flag-gf",
		name: "French Guiana Flag",
		keywords: [
			"gf",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1eb",
				native: "🇬🇫"
			}
		],
		version: 2
	},
	"flag-gg": {
		id: "flag-gg",
		name: "Guernsey Flag",
		keywords: [
			"gg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1ec",
				native: "🇬🇬"
			}
		],
		version: 2
	},
	"flag-gh": {
		id: "flag-gh",
		name: "Ghana Flag",
		keywords: [
			"gh",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1ed",
				native: "🇬🇭"
			}
		],
		version: 2
	},
	"flag-gi": {
		id: "flag-gi",
		name: "Gibraltar Flag",
		keywords: [
			"gi",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1ee",
				native: "🇬🇮"
			}
		],
		version: 2
	},
	"flag-gl": {
		id: "flag-gl",
		name: "Greenland Flag",
		keywords: [
			"gl",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f1",
				native: "🇬🇱"
			}
		],
		version: 2
	},
	"flag-gm": {
		id: "flag-gm",
		name: "Gambia Flag",
		keywords: [
			"gm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f2",
				native: "🇬🇲"
			}
		],
		version: 2
	},
	"flag-gn": {
		id: "flag-gn",
		name: "Guinea Flag",
		keywords: [
			"gn",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f3",
				native: "🇬🇳"
			}
		],
		version: 2
	},
	"flag-gp": {
		id: "flag-gp",
		name: "Guadeloupe Flag",
		keywords: [
			"gp",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f5",
				native: "🇬🇵"
			}
		],
		version: 2
	},
	"flag-gq": {
		id: "flag-gq",
		name: "Equatorial Guinea Flag",
		keywords: [
			"gq",
			"gn",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f6",
				native: "🇬🇶"
			}
		],
		version: 2
	},
	"flag-gr": {
		id: "flag-gr",
		name: "Greece Flag",
		keywords: [
			"gr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f7",
				native: "🇬🇷"
			}
		],
		version: 2
	},
	"flag-gs": {
		id: "flag-gs",
		name: "South Georgia & South Sandwich Islands Flag",
		keywords: [
			"gs",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f8",
				native: "🇬🇸"
			}
		],
		version: 2
	},
	"flag-gt": {
		id: "flag-gt",
		name: "Guatemala Flag",
		keywords: [
			"gt",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f9",
				native: "🇬🇹"
			}
		],
		version: 2
	},
	"flag-gu": {
		id: "flag-gu",
		name: "Guam Flag",
		keywords: [
			"gu",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1fa",
				native: "🇬🇺"
			}
		],
		version: 2
	},
	"flag-gw": {
		id: "flag-gw",
		name: "Guinea-Bissau Flag",
		keywords: [
			"gw",
			"guinea",
			"bissau",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1fc",
				native: "🇬🇼"
			}
		],
		version: 2
	},
	"flag-gy": {
		id: "flag-gy",
		name: "Guyana Flag",
		keywords: [
			"gy",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1fe",
				native: "🇬🇾"
			}
		],
		version: 2
	},
	"flag-hk": {
		id: "flag-hk",
		name: "Hong Kong Sar China Flag",
		keywords: [
			"hk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ed-1f1f0",
				native: "🇭🇰"
			}
		],
		version: 2
	},
	"flag-hm": {
		id: "flag-hm",
		name: "Heard & Mcdonald Islands Flag",
		keywords: [
			"hm"
		],
		skins: [
			{
				unified: "1f1ed-1f1f2",
				native: "🇭🇲"
			}
		],
		version: 2
	},
	"flag-hn": {
		id: "flag-hn",
		name: "Honduras Flag",
		keywords: [
			"hn",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ed-1f1f3",
				native: "🇭🇳"
			}
		],
		version: 2
	},
	"flag-hr": {
		id: "flag-hr",
		name: "Croatia Flag",
		keywords: [
			"hr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ed-1f1f7",
				native: "🇭🇷"
			}
		],
		version: 2
	},
	"flag-ht": {
		id: "flag-ht",
		name: "Haiti Flag",
		keywords: [
			"ht",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ed-1f1f9",
				native: "🇭🇹"
			}
		],
		version: 2
	},
	"flag-hu": {
		id: "flag-hu",
		name: "Hungary Flag",
		keywords: [
			"hu",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ed-1f1fa",
				native: "🇭🇺"
			}
		],
		version: 2
	},
	"flag-ic": {
		id: "flag-ic",
		name: "Canary Islands Flag",
		keywords: [
			"ic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1e8",
				native: "🇮🇨"
			}
		],
		version: 2
	},
	"flag-id": {
		id: "flag-id",
		name: "Indonesia Flag",
		keywords: [
			"id",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1e9",
				native: "🇮🇩"
			}
		],
		version: 2
	},
	"flag-ie": {
		id: "flag-ie",
		name: "Ireland Flag",
		keywords: [
			"ie",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1ea",
				native: "🇮🇪"
			}
		],
		version: 2
	},
	"flag-il": {
		id: "flag-il",
		name: "Israel Flag",
		keywords: [
			"il",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f1",
				native: "🇮🇱"
			}
		],
		version: 2
	},
	"flag-im": {
		id: "flag-im",
		name: "Isle of Man Flag",
		keywords: [
			"im",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f2",
				native: "🇮🇲"
			}
		],
		version: 2
	},
	"flag-in": {
		id: "flag-in",
		name: "India Flag",
		keywords: [
			"in",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f3",
				native: "🇮🇳"
			}
		],
		version: 2
	},
	"flag-io": {
		id: "flag-io",
		name: "British Indian Ocean Territory Flag",
		keywords: [
			"io",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f4",
				native: "🇮🇴"
			}
		],
		version: 2
	},
	"flag-iq": {
		id: "flag-iq",
		name: "Iraq Flag",
		keywords: [
			"iq",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f6",
				native: "🇮🇶"
			}
		],
		version: 2
	},
	"flag-ir": {
		id: "flag-ir",
		name: "Iran Flag",
		keywords: [
			"ir",
			"islamic",
			"republic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f7",
				native: "🇮🇷"
			}
		],
		version: 2
	},
	"flag-is": {
		id: "flag-is",
		name: "Iceland Flag",
		keywords: [
			"is",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f8",
				native: "🇮🇸"
			}
		],
		version: 2
	},
	it: {
		id: "it",
		name: "Italy Flag",
		keywords: [
			"it",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f9",
				native: "🇮🇹"
			}
		],
		version: 1
	},
	"flag-je": {
		id: "flag-je",
		name: "Jersey Flag",
		keywords: [
			"je",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ef-1f1ea",
				native: "🇯🇪"
			}
		],
		version: 2
	},
	"flag-jm": {
		id: "flag-jm",
		name: "Jamaica Flag",
		keywords: [
			"jm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ef-1f1f2",
				native: "🇯🇲"
			}
		],
		version: 2
	},
	"flag-jo": {
		id: "flag-jo",
		name: "Jordan Flag",
		keywords: [
			"jo",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ef-1f1f4",
				native: "🇯🇴"
			}
		],
		version: 2
	},
	jp: {
		id: "jp",
		name: "Japan Flag",
		keywords: [
			"jp",
			"japanese",
			"nation",
			"country",
			"banner",
			"ja"
		],
		skins: [
			{
				unified: "1f1ef-1f1f5",
				native: "🇯🇵"
			}
		],
		version: 1
	},
	"flag-ke": {
		id: "flag-ke",
		name: "Kenya Flag",
		keywords: [
			"ke",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1ea",
				native: "🇰🇪"
			}
		],
		version: 2
	},
	"flag-kg": {
		id: "flag-kg",
		name: "Kyrgyzstan Flag",
		keywords: [
			"kg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1ec",
				native: "🇰🇬"
			}
		],
		version: 2
	},
	"flag-kh": {
		id: "flag-kh",
		name: "Cambodia Flag",
		keywords: [
			"kh",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1ed",
				native: "🇰🇭"
			}
		],
		version: 2
	},
	"flag-ki": {
		id: "flag-ki",
		name: "Kiribati Flag",
		keywords: [
			"ki",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1ee",
				native: "🇰🇮"
			}
		],
		version: 2
	},
	"flag-km": {
		id: "flag-km",
		name: "Comoros Flag",
		keywords: [
			"km",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1f2",
				native: "🇰🇲"
			}
		],
		version: 2
	},
	"flag-kn": {
		id: "flag-kn",
		name: "St. Kitts & Nevis Flag",
		keywords: [
			"kn",
			"st",
			"saint",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1f3",
				native: "🇰🇳"
			}
		],
		version: 2
	},
	"flag-kp": {
		id: "flag-kp",
		name: "North Korea Flag",
		keywords: [
			"kp",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1f5",
				native: "🇰🇵"
			}
		],
		version: 2
	},
	kr: {
		id: "kr",
		name: "South Korea Flag",
		keywords: [
			"kr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1f7",
				native: "🇰🇷"
			}
		],
		version: 1
	},
	"flag-kw": {
		id: "flag-kw",
		name: "Kuwait Flag",
		keywords: [
			"kw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1fc",
				native: "🇰🇼"
			}
		],
		version: 2
	},
	"flag-ky": {
		id: "flag-ky",
		name: "Cayman Islands Flag",
		keywords: [
			"ky",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1fe",
				native: "🇰🇾"
			}
		],
		version: 2
	},
	"flag-kz": {
		id: "flag-kz",
		name: "Kazakhstan Flag",
		keywords: [
			"kz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1ff",
				native: "🇰🇿"
			}
		],
		version: 2
	},
	"flag-la": {
		id: "flag-la",
		name: "Laos Flag",
		keywords: [
			"la",
			"lao",
			"democratic",
			"republic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1e6",
				native: "🇱🇦"
			}
		],
		version: 2
	},
	"flag-lb": {
		id: "flag-lb",
		name: "Lebanon Flag",
		keywords: [
			"lb",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1e7",
				native: "🇱🇧"
			}
		],
		version: 2
	},
	"flag-lc": {
		id: "flag-lc",
		name: "St. Lucia Flag",
		keywords: [
			"lc",
			"st",
			"saint",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1e8",
				native: "🇱🇨"
			}
		],
		version: 2
	},
	"flag-li": {
		id: "flag-li",
		name: "Liechtenstein Flag",
		keywords: [
			"li",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1ee",
				native: "🇱🇮"
			}
		],
		version: 2
	},
	"flag-lk": {
		id: "flag-lk",
		name: "Sri Lanka Flag",
		keywords: [
			"lk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1f0",
				native: "🇱🇰"
			}
		],
		version: 2
	},
	"flag-lr": {
		id: "flag-lr",
		name: "Liberia Flag",
		keywords: [
			"lr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1f7",
				native: "🇱🇷"
			}
		],
		version: 2
	},
	"flag-ls": {
		id: "flag-ls",
		name: "Lesotho Flag",
		keywords: [
			"ls",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1f8",
				native: "🇱🇸"
			}
		],
		version: 2
	},
	"flag-lt": {
		id: "flag-lt",
		name: "Lithuania Flag",
		keywords: [
			"lt",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1f9",
				native: "🇱🇹"
			}
		],
		version: 2
	},
	"flag-lu": {
		id: "flag-lu",
		name: "Luxembourg Flag",
		keywords: [
			"lu",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1fa",
				native: "🇱🇺"
			}
		],
		version: 2
	},
	"flag-lv": {
		id: "flag-lv",
		name: "Latvia Flag",
		keywords: [
			"lv",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1fb",
				native: "🇱🇻"
			}
		],
		version: 2
	},
	"flag-ly": {
		id: "flag-ly",
		name: "Libya Flag",
		keywords: [
			"ly",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1fe",
				native: "🇱🇾"
			}
		],
		version: 2
	},
	"flag-ma": {
		id: "flag-ma",
		name: "Morocco Flag",
		keywords: [
			"ma",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1e6",
				native: "🇲🇦"
			}
		],
		version: 2
	},
	"flag-mc": {
		id: "flag-mc",
		name: "Monaco Flag",
		keywords: [
			"mc",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1e8",
				native: "🇲🇨"
			}
		],
		version: 2
	},
	"flag-md": {
		id: "flag-md",
		name: "Moldova Flag",
		keywords: [
			"md",
			"republic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1e9",
				native: "🇲🇩"
			}
		],
		version: 2
	},
	"flag-me": {
		id: "flag-me",
		name: "Montenegro Flag",
		keywords: [
			"me",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1ea",
				native: "🇲🇪"
			}
		],
		version: 2
	},
	"flag-mf": {
		id: "flag-mf",
		name: "St. Martin Flag",
		keywords: [
			"mf",
			"st"
		],
		skins: [
			{
				unified: "1f1f2-1f1eb",
				native: "🇲🇫"
			}
		],
		version: 2
	},
	"flag-mg": {
		id: "flag-mg",
		name: "Madagascar Flag",
		keywords: [
			"mg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1ec",
				native: "🇲🇬"
			}
		],
		version: 2
	},
	"flag-mh": {
		id: "flag-mh",
		name: "Marshall Islands Flag",
		keywords: [
			"mh",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1ed",
				native: "🇲🇭"
			}
		],
		version: 2
	},
	"flag-mk": {
		id: "flag-mk",
		name: "North Macedonia Flag",
		keywords: [
			"mk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f0",
				native: "🇲🇰"
			}
		],
		version: 2
	},
	"flag-ml": {
		id: "flag-ml",
		name: "Mali Flag",
		keywords: [
			"ml",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f1",
				native: "🇲🇱"
			}
		],
		version: 2
	},
	"flag-mm": {
		id: "flag-mm",
		name: "Myanmar (burma) Flag",
		keywords: [
			"mm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f2",
				native: "🇲🇲"
			}
		],
		version: 2
	},
	"flag-mn": {
		id: "flag-mn",
		name: "Mongolia Flag",
		keywords: [
			"mn",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f3",
				native: "🇲🇳"
			}
		],
		version: 2
	},
	"flag-mo": {
		id: "flag-mo",
		name: "Macao Sar China Flag",
		keywords: [
			"mo",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f4",
				native: "🇲🇴"
			}
		],
		version: 2
	},
	"flag-mp": {
		id: "flag-mp",
		name: "Northern Mariana Islands Flag",
		keywords: [
			"mp",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f5",
				native: "🇲🇵"
			}
		],
		version: 2
	},
	"flag-mq": {
		id: "flag-mq",
		name: "Martinique Flag",
		keywords: [
			"mq",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f6",
				native: "🇲🇶"
			}
		],
		version: 2
	},
	"flag-mr": {
		id: "flag-mr",
		name: "Mauritania Flag",
		keywords: [
			"mr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f7",
				native: "🇲🇷"
			}
		],
		version: 2
	},
	"flag-ms": {
		id: "flag-ms",
		name: "Montserrat Flag",
		keywords: [
			"ms",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f8",
				native: "🇲🇸"
			}
		],
		version: 2
	},
	"flag-mt": {
		id: "flag-mt",
		name: "Malta Flag",
		keywords: [
			"mt",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f9",
				native: "🇲🇹"
			}
		],
		version: 2
	},
	"flag-mu": {
		id: "flag-mu",
		name: "Mauritius Flag",
		keywords: [
			"mu",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1fa",
				native: "🇲🇺"
			}
		],
		version: 2
	},
	"flag-mv": {
		id: "flag-mv",
		name: "Maldives Flag",
		keywords: [
			"mv",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1fb",
				native: "🇲🇻"
			}
		],
		version: 2
	},
	"flag-mw": {
		id: "flag-mw",
		name: "Malawi Flag",
		keywords: [
			"mw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1fc",
				native: "🇲🇼"
			}
		],
		version: 2
	},
	"flag-mx": {
		id: "flag-mx",
		name: "Mexico Flag",
		keywords: [
			"mx",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1fd",
				native: "🇲🇽"
			}
		],
		version: 2
	},
	"flag-my": {
		id: "flag-my",
		name: "Malaysia Flag",
		keywords: [
			"my",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1fe",
				native: "🇲🇾"
			}
		],
		version: 2
	},
	"flag-mz": {
		id: "flag-mz",
		name: "Mozambique Flag",
		keywords: [
			"mz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1ff",
				native: "🇲🇿"
			}
		],
		version: 2
	},
	"flag-na": {
		id: "flag-na",
		name: "Namibia Flag",
		keywords: [
			"na",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1e6",
				native: "🇳🇦"
			}
		],
		version: 2
	},
	"flag-nc": {
		id: "flag-nc",
		name: "New Caledonia Flag",
		keywords: [
			"nc",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1e8",
				native: "🇳🇨"
			}
		],
		version: 2
	},
	"flag-ne": {
		id: "flag-ne",
		name: "Niger Flag",
		keywords: [
			"ne",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1ea",
				native: "🇳🇪"
			}
		],
		version: 2
	},
	"flag-nf": {
		id: "flag-nf",
		name: "Norfolk Island Flag",
		keywords: [
			"nf",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1eb",
				native: "🇳🇫"
			}
		],
		version: 2
	},
	"flag-ng": {
		id: "flag-ng",
		name: "Nigeria Flag",
		keywords: [
			"ng",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1ec",
				native: "🇳🇬"
			}
		],
		version: 2
	},
	"flag-ni": {
		id: "flag-ni",
		name: "Nicaragua Flag",
		keywords: [
			"ni",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1ee",
				native: "🇳🇮"
			}
		],
		version: 2
	},
	"flag-nl": {
		id: "flag-nl",
		name: "Netherlands Flag",
		keywords: [
			"nl",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1f1",
				native: "🇳🇱"
			}
		],
		version: 2
	},
	"flag-no": {
		id: "flag-no",
		name: "Norway Flag",
		keywords: [
			"no",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1f4",
				native: "🇳🇴"
			}
		],
		version: 2
	},
	"flag-np": {
		id: "flag-np",
		name: "Nepal Flag",
		keywords: [
			"np",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1f5",
				native: "🇳🇵"
			}
		],
		version: 2
	},
	"flag-nr": {
		id: "flag-nr",
		name: "Nauru Flag",
		keywords: [
			"nr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1f7",
				native: "🇳🇷"
			}
		],
		version: 2
	},
	"flag-nu": {
		id: "flag-nu",
		name: "Niue Flag",
		keywords: [
			"nu",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1fa",
				native: "🇳🇺"
			}
		],
		version: 2
	},
	"flag-nz": {
		id: "flag-nz",
		name: "New Zealand Flag",
		keywords: [
			"nz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1ff",
				native: "🇳🇿"
			}
		],
		version: 2
	},
	"flag-om": {
		id: "flag-om",
		name: "Oman Flag",
		keywords: [
			"om",
			"symbol",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f4-1f1f2",
				native: "🇴🇲"
			}
		],
		version: 2
	},
	"flag-pa": {
		id: "flag-pa",
		name: "Panama Flag",
		keywords: [
			"pa",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1e6",
				native: "🇵🇦"
			}
		],
		version: 2
	},
	"flag-pe": {
		id: "flag-pe",
		name: "Peru Flag",
		keywords: [
			"pe",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1ea",
				native: "🇵🇪"
			}
		],
		version: 2
	},
	"flag-pf": {
		id: "flag-pf",
		name: "French Polynesia Flag",
		keywords: [
			"pf",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1eb",
				native: "🇵🇫"
			}
		],
		version: 2
	},
	"flag-pg": {
		id: "flag-pg",
		name: "Papua New Guinea Flag",
		keywords: [
			"pg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1ec",
				native: "🇵🇬"
			}
		],
		version: 2
	},
	"flag-ph": {
		id: "flag-ph",
		name: "Philippines Flag",
		keywords: [
			"ph",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1ed",
				native: "🇵🇭"
			}
		],
		version: 2
	},
	"flag-pk": {
		id: "flag-pk",
		name: "Pakistan Flag",
		keywords: [
			"pk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1f0",
				native: "🇵🇰"
			}
		],
		version: 2
	},
	"flag-pl": {
		id: "flag-pl",
		name: "Poland Flag",
		keywords: [
			"pl",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1f1",
				native: "🇵🇱"
			}
		],
		version: 2
	},
	"flag-pm": {
		id: "flag-pm",
		name: "St. Pierre & Miquelon Flag",
		keywords: [
			"pm",
			"st",
			"saint",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1f2",
				native: "🇵🇲"
			}
		],
		version: 2
	},
	"flag-pn": {
		id: "flag-pn",
		name: "Pitcairn Islands Flag",
		keywords: [
			"pn",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1f3",
				native: "🇵🇳"
			}
		],
		version: 2
	},
	"flag-pr": {
		id: "flag-pr",
		name: "Puerto Rico Flag",
		keywords: [
			"pr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1f7",
				native: "🇵🇷"
			}
		],
		version: 2
	},
	"flag-ps": {
		id: "flag-ps",
		name: "Palestinian Territories Flag",
		keywords: [
			"ps",
			"palestine",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1f8",
				native: "🇵🇸"
			}
		],
		version: 2
	},
	"flag-pt": {
		id: "flag-pt",
		name: "Portugal Flag",
		keywords: [
			"pt",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1f9",
				native: "🇵🇹"
			}
		],
		version: 2
	},
	"flag-pw": {
		id: "flag-pw",
		name: "Palau Flag",
		keywords: [
			"pw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1fc",
				native: "🇵🇼"
			}
		],
		version: 2
	},
	"flag-py": {
		id: "flag-py",
		name: "Paraguay Flag",
		keywords: [
			"py",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1fe",
				native: "🇵🇾"
			}
		],
		version: 2
	},
	"flag-qa": {
		id: "flag-qa",
		name: "Qatar Flag",
		keywords: [
			"qa",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f6-1f1e6",
				native: "🇶🇦"
			}
		],
		version: 2
	},
	"flag-re": {
		id: "flag-re",
		name: "Réunion Flag",
		keywords: [
			"re",
			"reunion",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f7-1f1ea",
				native: "🇷🇪"
			}
		],
		version: 2
	},
	"flag-ro": {
		id: "flag-ro",
		name: "Romania Flag",
		keywords: [
			"ro",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f7-1f1f4",
				native: "🇷🇴"
			}
		],
		version: 2
	},
	"flag-rs": {
		id: "flag-rs",
		name: "Serbia Flag",
		keywords: [
			"rs",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f7-1f1f8",
				native: "🇷🇸"
			}
		],
		version: 2
	},
	ru: {
		id: "ru",
		name: "Russia Flag",
		keywords: [
			"ru",
			"russian",
			"federation",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f7-1f1fa",
				native: "🇷🇺"
			}
		],
		version: 1
	},
	"flag-rw": {
		id: "flag-rw",
		name: "Rwanda Flag",
		keywords: [
			"rw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f7-1f1fc",
				native: "🇷🇼"
			}
		],
		version: 2
	},
	"flag-sa": {
		id: "flag-sa",
		name: "Saudi Arabia Flag",
		keywords: [
			"sa",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1e6",
				native: "🇸🇦"
			}
		],
		version: 2
	},
	"flag-sb": {
		id: "flag-sb",
		name: "Solomon Islands Flag",
		keywords: [
			"sb",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1e7",
				native: "🇸🇧"
			}
		],
		version: 2
	},
	"flag-sc": {
		id: "flag-sc",
		name: "Seychelles Flag",
		keywords: [
			"sc",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1e8",
				native: "🇸🇨"
			}
		],
		version: 2
	},
	"flag-sd": {
		id: "flag-sd",
		name: "Sudan Flag",
		keywords: [
			"sd",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1e9",
				native: "🇸🇩"
			}
		],
		version: 2
	},
	"flag-se": {
		id: "flag-se",
		name: "Sweden Flag",
		keywords: [
			"se",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1ea",
				native: "🇸🇪"
			}
		],
		version: 2
	},
	"flag-sg": {
		id: "flag-sg",
		name: "Singapore Flag",
		keywords: [
			"sg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1ec",
				native: "🇸🇬"
			}
		],
		version: 2
	},
	"flag-sh": {
		id: "flag-sh",
		name: "St. Helena Flag",
		keywords: [
			"sh",
			"st",
			"saint",
			"ascension",
			"tristan",
			"cunha",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1ed",
				native: "🇸🇭"
			}
		],
		version: 2
	},
	"flag-si": {
		id: "flag-si",
		name: "Slovenia Flag",
		keywords: [
			"si",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1ee",
				native: "🇸🇮"
			}
		],
		version: 2
	},
	"flag-sj": {
		id: "flag-sj",
		name: "Svalbard & Jan Mayen Flag",
		keywords: [
			"sj"
		],
		skins: [
			{
				unified: "1f1f8-1f1ef",
				native: "🇸🇯"
			}
		],
		version: 2
	},
	"flag-sk": {
		id: "flag-sk",
		name: "Slovakia Flag",
		keywords: [
			"sk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f0",
				native: "🇸🇰"
			}
		],
		version: 2
	},
	"flag-sl": {
		id: "flag-sl",
		name: "Sierra Leone Flag",
		keywords: [
			"sl",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f1",
				native: "🇸🇱"
			}
		],
		version: 2
	},
	"flag-sm": {
		id: "flag-sm",
		name: "San Marino Flag",
		keywords: [
			"sm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f2",
				native: "🇸🇲"
			}
		],
		version: 2
	},
	"flag-sn": {
		id: "flag-sn",
		name: "Senegal Flag",
		keywords: [
			"sn",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f3",
				native: "🇸🇳"
			}
		],
		version: 2
	},
	"flag-so": {
		id: "flag-so",
		name: "Somalia Flag",
		keywords: [
			"so",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f4",
				native: "🇸🇴"
			}
		],
		version: 2
	},
	"flag-sr": {
		id: "flag-sr",
		name: "Suriname Flag",
		keywords: [
			"sr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f7",
				native: "🇸🇷"
			}
		],
		version: 2
	},
	"flag-ss": {
		id: "flag-ss",
		name: "South Sudan Flag",
		keywords: [
			"ss",
			"sd",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f8",
				native: "🇸🇸"
			}
		],
		version: 2
	},
	"flag-st": {
		id: "flag-st",
		name: "São Tomé & Príncipe Flag",
		keywords: [
			"st",
			"sao",
			"tome",
			"principe",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f9",
				native: "🇸🇹"
			}
		],
		version: 2
	},
	"flag-sv": {
		id: "flag-sv",
		name: "El Salvador Flag",
		keywords: [
			"sv",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1fb",
				native: "🇸🇻"
			}
		],
		version: 2
	},
	"flag-sx": {
		id: "flag-sx",
		name: "Sint Maarten Flag",
		keywords: [
			"sx",
			"dutch",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1fd",
				native: "🇸🇽"
			}
		],
		version: 2
	},
	"flag-sy": {
		id: "flag-sy",
		name: "Syria Flag",
		keywords: [
			"sy",
			"syrian",
			"arab",
			"republic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1fe",
				native: "🇸🇾"
			}
		],
		version: 2
	},
	"flag-sz": {
		id: "flag-sz",
		name: "Eswatini Flag",
		keywords: [
			"sz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1ff",
				native: "🇸🇿"
			}
		],
		version: 2
	},
	"flag-ta": {
		id: "flag-ta",
		name: "Tristan Da Cunha Flag",
		keywords: [
			"ta"
		],
		skins: [
			{
				unified: "1f1f9-1f1e6",
				native: "🇹🇦"
			}
		],
		version: 2
	},
	"flag-tc": {
		id: "flag-tc",
		name: "Turks & Caicos Islands Flag",
		keywords: [
			"tc",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1e8",
				native: "🇹🇨"
			}
		],
		version: 2
	},
	"flag-td": {
		id: "flag-td",
		name: "Chad Flag",
		keywords: [
			"td",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1e9",
				native: "🇹🇩"
			}
		],
		version: 2
	},
	"flag-tf": {
		id: "flag-tf",
		name: "French Southern Territories Flag",
		keywords: [
			"tf",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1eb",
				native: "🇹🇫"
			}
		],
		version: 2
	},
	"flag-tg": {
		id: "flag-tg",
		name: "Togo Flag",
		keywords: [
			"tg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1ec",
				native: "🇹🇬"
			}
		],
		version: 2
	},
	"flag-th": {
		id: "flag-th",
		name: "Thailand Flag",
		keywords: [
			"th",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1ed",
				native: "🇹🇭"
			}
		],
		version: 2
	},
	"flag-tj": {
		id: "flag-tj",
		name: "Tajikistan Flag",
		keywords: [
			"tj",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1ef",
				native: "🇹🇯"
			}
		],
		version: 2
	},
	"flag-tk": {
		id: "flag-tk",
		name: "Tokelau Flag",
		keywords: [
			"tk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1f0",
				native: "🇹🇰"
			}
		],
		version: 2
	},
	"flag-tl": {
		id: "flag-tl",
		name: "Timor-Leste Flag",
		keywords: [
			"tl",
			"timor",
			"leste",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1f1",
				native: "🇹🇱"
			}
		],
		version: 2
	},
	"flag-tm": {
		id: "flag-tm",
		name: "Turkmenistan Flag",
		keywords: [
			"tm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1f2",
				native: "🇹🇲"
			}
		],
		version: 2
	},
	"flag-tn": {
		id: "flag-tn",
		name: "Tunisia Flag",
		keywords: [
			"tn",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1f3",
				native: "🇹🇳"
			}
		],
		version: 2
	},
	"flag-to": {
		id: "flag-to",
		name: "Tonga Flag",
		keywords: [
			"to",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1f4",
				native: "🇹🇴"
			}
		],
		version: 2
	},
	"flag-tr": {
		id: "flag-tr",
		name: "Turkey Flag",
		keywords: [
			"tr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1f7",
				native: "🇹🇷"
			}
		],
		version: 2
	},
	"flag-tt": {
		id: "flag-tt",
		name: "Trinidad & Tobago Flag",
		keywords: [
			"tt",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1f9",
				native: "🇹🇹"
			}
		],
		version: 2
	},
	"flag-tv": {
		id: "flag-tv",
		name: "Tuvalu Flag",
		keywords: [
			"tv",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1fb",
				native: "🇹🇻"
			}
		],
		version: 2
	},
	"flag-tw": {
		id: "flag-tw",
		name: "Taiwan Flag",
		keywords: [
			"tw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1fc",
				native: "🇹🇼"
			}
		],
		version: 2
	},
	"flag-tz": {
		id: "flag-tz",
		name: "Tanzania Flag",
		keywords: [
			"tz",
			"united",
			"republic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1ff",
				native: "🇹🇿"
			}
		],
		version: 2
	},
	"flag-ua": {
		id: "flag-ua",
		name: "Ukraine Flag",
		keywords: [
			"ua",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fa-1f1e6",
				native: "🇺🇦"
			}
		],
		version: 2
	},
	"flag-ug": {
		id: "flag-ug",
		name: "Uganda Flag",
		keywords: [
			"ug",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fa-1f1ec",
				native: "🇺🇬"
			}
		],
		version: 2
	},
	"flag-um": {
		id: "flag-um",
		name: "U.s. Outlying Islands Flag",
		keywords: [
			"um",
			"u",
			"s"
		],
		skins: [
			{
				unified: "1f1fa-1f1f2",
				native: "🇺🇲"
			}
		],
		version: 2
	},
	"flag-un": {
		id: "flag-un",
		name: "United Nations Flag",
		keywords: [
			"un",
			"banner"
		],
		skins: [
			{
				unified: "1f1fa-1f1f3",
				native: "🇺🇳"
			}
		],
		version: 4
	},
	us: {
		id: "us",
		name: "United States Flag",
		keywords: [
			"us",
			"america",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fa-1f1f8",
				native: "🇺🇸"
			}
		],
		version: 1
	},
	"flag-uy": {
		id: "flag-uy",
		name: "Uruguay Flag",
		keywords: [
			"uy",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fa-1f1fe",
				native: "🇺🇾"
			}
		],
		version: 2
	},
	"flag-uz": {
		id: "flag-uz",
		name: "Uzbekistan Flag",
		keywords: [
			"uz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fa-1f1ff",
				native: "🇺🇿"
			}
		],
		version: 2
	},
	"flag-va": {
		id: "flag-va",
		name: "Vatican City Flag",
		keywords: [
			"va",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fb-1f1e6",
				native: "🇻🇦"
			}
		],
		version: 2
	},
	"flag-vc": {
		id: "flag-vc",
		name: "St. Vincent & Grenadines Flag",
		keywords: [
			"vc",
			"st",
			"saint",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fb-1f1e8",
				native: "🇻🇨"
			}
		],
		version: 2
	},
	"flag-ve": {
		id: "flag-ve",
		name: "Venezuela Flag",
		keywords: [
			"ve",
			"bolivarian",
			"republic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fb-1f1ea",
				native: "🇻🇪"
			}
		],
		version: 2
	},
	"flag-vg": {
		id: "flag-vg",
		name: "British Virgin Islands Flag",
		keywords: [
			"vg",
			"bvi",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fb-1f1ec",
				native: "🇻🇬"
			}
		],
		version: 2
	},
	"flag-vi": {
		id: "flag-vi",
		name: "U.s. Virgin Islands Flag",
		keywords: [
			"vi",
			"u",
			"s",
			"us",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fb-1f1ee",
				native: "🇻🇮"
			}
		],
		version: 2
	},
	"flag-vn": {
		id: "flag-vn",
		name: "Vietnam Flag",
		keywords: [
			"vn",
			"viet",
			"nam",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fb-1f1f3",
				native: "🇻🇳"
			}
		],
		version: 2
	},
	"flag-vu": {
		id: "flag-vu",
		name: "Vanuatu Flag",
		keywords: [
			"vu",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fb-1f1fa",
				native: "🇻🇺"
			}
		],
		version: 2
	},
	"flag-wf": {
		id: "flag-wf",
		name: "Wallis & Futuna Flag",
		keywords: [
			"wf",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fc-1f1eb",
				native: "🇼🇫"
			}
		],
		version: 2
	},
	"flag-ws": {
		id: "flag-ws",
		name: "Samoa Flag",
		keywords: [
			"ws",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fc-1f1f8",
				native: "🇼🇸"
			}
		],
		version: 2
	},
	"flag-xk": {
		id: "flag-xk",
		name: "Kosovo Flag",
		keywords: [
			"xk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fd-1f1f0",
				native: "🇽🇰"
			}
		],
		version: 2
	},
	"flag-ye": {
		id: "flag-ye",
		name: "Yemen Flag",
		keywords: [
			"ye",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fe-1f1ea",
				native: "🇾🇪"
			}
		],
		version: 2
	},
	"flag-yt": {
		id: "flag-yt",
		name: "Mayotte Flag",
		keywords: [
			"yt",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fe-1f1f9",
				native: "🇾🇹"
			}
		],
		version: 2
	},
	"flag-za": {
		id: "flag-za",
		name: "South Africa Flag",
		keywords: [
			"za",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ff-1f1e6",
				native: "🇿🇦"
			}
		],
		version: 2
	},
	"flag-zm": {
		id: "flag-zm",
		name: "Zambia Flag",
		keywords: [
			"zm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ff-1f1f2",
				native: "🇿🇲"
			}
		],
		version: 2
	},
	"flag-zw": {
		id: "flag-zw",
		name: "Zimbabwe Flag",
		keywords: [
			"zw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ff-1f1fc",
				native: "🇿🇼"
			}
		],
		version: 2
	},
	"flag-england": {
		id: "flag-england",
		name: "England Flag",
		keywords: [
			"english"
		],
		skins: [
			{
				unified: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
				native: "🏴󠁧󠁢󠁥󠁮󠁧󠁿"
			}
		],
		version: 5
	},
	"flag-scotland": {
		id: "flag-scotland",
		name: "Scotland Flag",
		keywords: [
			"scottish"
		],
		skins: [
			{
				unified: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
				native: "🏴󠁧󠁢󠁳󠁣󠁴󠁿"
			}
		],
		version: 5
	},
	"flag-wales": {
		id: "flag-wales",
		name: "Wales Flag",
		keywords: [
			"welsh"
		],
		skins: [
			{
				unified: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
				native: "🏴󠁧󠁢󠁷󠁬󠁳󠁿"
			}
		],
		version: 5
	}
};
var aliases = {
	satisfied: "laughing",
	grinning_face_with_star_eyes: "star-struck",
	grinning_face_with_one_large_and_one_small_eye: "zany_face",
	smiling_face_with_smiling_eyes_and_hand_covering_mouth: "face_with_hand_over_mouth",
	face_with_finger_covering_closed_lips: "shushing_face",
	face_with_one_eyebrow_raised: "face_with_raised_eyebrow",
	face_with_open_mouth_vomiting: "face_vomiting",
	shocked_face_with_exploding_head: "exploding_head",
	serious_face_with_symbols_covering_mouth: "face_with_symbols_on_mouth",
	poop: "hankey",
	shit: "hankey",
	collision: "boom",
	raised_hand: "hand",
	hand_with_index_and_middle_fingers_crossed: "crossed_fingers",
	sign_of_the_horns: "the_horns",
	reversed_hand_with_middle_finger_extended: "middle_finger",
	thumbsup: "+1",
	thumbsdown: "-1",
	punch: "facepunch",
	mother_christmas: "mrs_claus",
	running: "runner",
	"man-with-bunny-ears-partying": "men-with-bunny-ears-partying",
	"woman-with-bunny-ears-partying": "women-with-bunny-ears-partying",
	women_holding_hands: "two_women_holding_hands",
	woman_and_man_holding_hands: "man_and_woman_holding_hands",
	couple: "man_and_woman_holding_hands",
	men_holding_hands: "two_men_holding_hands",
	paw_prints: "feet",
	flipper: "dolphin",
	honeybee: "bee",
	lady_beetle: "ladybug",
	cooking: "fried_egg",
	knife: "hocho",
	red_car: "car",
	sailboat: "boat",
	waxing_gibbous_moon: "moon",
	sun_small_cloud: "mostly_sunny",
	sun_behind_cloud: "barely_sunny",
	sun_behind_rain_cloud: "partly_sunny_rain",
	lightning_cloud: "lightning",
	tornado_cloud: "tornado",
	tshirt: "shirt",
	shoe: "mans_shoe",
	telephone: "phone",
	lantern: "izakaya_lantern",
	open_book: "book",
	envelope: "email",
	pencil: "memo",
	heavy_exclamation_mark: "exclamation",
	staff_of_aesculapius: "medical_symbol",
	"flag-cn": "cn",
	"flag-de": "de",
	"flag-es": "es",
	"flag-fr": "fr",
	uk: "gb",
	"flag-gb": "gb",
	"flag-it": "it",
	"flag-jp": "jp",
	"flag-kr": "kr",
	"flag-ru": "ru",
	"flag-us": "us"
};
var sheet = {
	cols: 61,
	rows: 61
};
var data = {
	categories: categories,
	emojis: emojis,
	aliases: aliases,
	sheet: sheet
};

var ChatEmoji = function (_a) {
    var t = _a.t, addEmoji = _a.addEmoji, sendMessage = _a.sendMessage, selectEmoji = _a.selectEmoji, emojiContainerRef = _a.emojiContainerRef, isTypingNotAllowed = _a.isTypingNotAllowed, setEmojiPickerOpened = _a.setEmojiPickerOpened, _b = _a.iconsPerLine, iconsPerLine = _b === void 0 ? 7 : _b, _c = _a.emojiSize, emojiSize = _c === void 0 ? 18 : _c;
    var Search = TranslationKeys.Search, Clear = TranslationKeys.Clear, Flags = TranslationKeys.Flags, Custom = TranslationKeys.Custom, Symbols = TranslationKeys.Symbols, Objects = TranslationKeys.Objects, Activity = TranslationKeys.Activity, NoEmojiFound = TranslationKeys.NoEmojiFound, SearchResults = TranslationKeys.SearchResults, FoodAndDrink = TranslationKeys.FoodAndDrink, FrequentlyUsed = TranslationKeys.FrequentlyUsed, TravelAndPlaces = TranslationKeys.TravelAndPlaces, AnimalsAndNature = TranslationKeys.AnimalsAndNature, SmileysAndPeople = TranslationKeys.SmileysAndPeople;
    var sendEmoji = function (e) {
        var emojiPic = selectEmoji(e);
        sendMessage(emojiPic, MessageTypes.TextOrEmoji);
        setEmojiPickerOpened(function (prev) { return !prev; });
    };
    return (React.createElement("div", { className: 'chat-popover', ref: emojiContainerRef },
        React.createElement($e5534fc185f7111e$export$2e2bcd8739ae039
        // showPreview={false}
        // showSkinTones={false}
        // set='google'
        , { 
            // showPreview={false}
            // showSkinTones={false}
            // set='google'
            data: data, perLine: iconsPerLine, previewPosition: 'none', navPosition: 'none', emojiSize: emojiSize, skinTonePosition: 'none', onEmojiSelect: function (e) { return (!isTypingNotAllowed ? addEmoji(e) : sendEmoji(e)); }, skin: '1', i18n: {
                search: t(Search),
                clear: t(Clear),
                notfound: t(NoEmojiFound),
                // skintext: t(ChooseYourDefaultSkinTone),
                categories: {
                    search: t(SearchResults),
                    frequent: t(FrequentlyUsed),
                    people: t(SmileysAndPeople),
                    nature: t(AnimalsAndNature),
                    foods: t(FoodAndDrink),
                    activity: t(Activity),
                    places: t(TravelAndPlaces),
                    objects: t(Objects),
                    symbols: t(Symbols),
                    flags: t(Flags),
                    custom: t(Custom),
                },
                // categorieslabel: t(EmojiCategories),
                // skins: {
                //   1: t(DefaultSkinTone),
                //   2: t(LightSkinTone),
                //   3: t(MediumLightSkinTone),
                //   4: t(MediumSkinTone),
                //   5: t(MediumDarkSkinTone),
                //   6: t(DarkSkinTone),
                // },
            } })));
};

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

var __defProp$3 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
var Logger = {
  ENABLED: typeof window !== "undefined" && typeof location !== "undefined" && location.search.indexOf("giphy-debug") !== -1,
  LEVEL: 0,
  PREFIX: "GiphyJS",
  debug: (...msg) => {
    if (Logger.ENABLED && Logger.LEVEL <= 0 /* DEBUG */) {
      console.debug(Logger.PREFIX, ...msg);
    }
  },
  info: (...msg) => {
    if (Logger.ENABLED && Logger.LEVEL <= 1 /* INFO */) {
      console.info(Logger.PREFIX, ...msg);
    }
  },
  warn: (...msg) => {
    if (Logger.ENABLED && Logger.LEVEL <= 2 /* WARN */) {
      console.warn(Logger.PREFIX, ...msg);
    }
  },
  error: (...msg) => {
    if (Logger.ENABLED && Logger.LEVEL <= 3 /* ERROR */) {
      console.error(Logger.PREFIX, ...msg);
    }
  }
};

// src/bestfit.ts
var closestArea = (width, height, renditions) => {
  let currentBest = Infinity;
  let result;
  renditions.forEach((rendition) => {
    const widthPercentage = rendition.width / width;
    const heightPercentage = rendition.height / height;
    const areaPercentage = widthPercentage * heightPercentage;
    const testBest = Math.abs(1 - areaPercentage);
    if (testBest < currentBest) {
      currentBest = testBest;
      result = rendition;
    }
  });
  return result;
};
var SCALE_UP_MAX_PIXELS = 50;
function bestfit(renditions, width, height, scaleUpMaxPixels = SCALE_UP_MAX_PIXELS) {
  let [largestRendition] = renditions;
  const testRenditions = renditions.filter((rendition) => {
    if (rendition.width * rendition.height > largestRendition.width * largestRendition.height) {
      largestRendition = rendition;
    }
    return width - rendition.width <= scaleUpMaxPixels && height - rendition.height <= scaleUpMaxPixels;
  });
  if (testRenditions.length === 0) {
    return largestRendition;
  }
  return closestArea(width, height, testRenditions);
}
var bestfit_default = bestfit;
function take(arr, count = 0) {
  return arr.slice(0, count);
}
function without(arr, values) {
  return arr.filter((val) => values.indexOf(val) === -1);
}
function pick(object, pick2) {
  const res = {};
  pick2.forEach((key) => {
    if (object[key] !== void 0) {
      res[key] = object[key];
    }
  });
  return res;
}

// src/get-client-rect-from-el.ts
var getClientRect = (el) => {
  let left = 0;
  let top = 0;
  const width = el.offsetWidth;
  const height = el.offsetHeight;
  do {
    left += el.offsetLeft;
    top += el.offsetTop;
    el = el.offsetParent;
  } while (el);
  const result = {
    left,
    top,
    width,
    height,
    right: left + width,
    bottom: top + height,
    x: left,
    y: top
  };
  return __spreadProps$2(__spreadValues$3({}, result), { toJSON: () => JSON.stringify(result) });
};
var get_client_rect_from_el_default = getClientRect;
var pingbackId = "";
var idLength = 16;
var noUUIDRandom = () => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < idLength; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
var getPingbackId = () => {
  if (!pingbackId) {
    try {
      pingbackId = sessionStorage.getItem("giphyPingbackId");
    } catch (_) {
    }
    if (!pingbackId) {
      const hexTime = (/* @__PURE__ */ new Date()).getTime().toString(16);
      try {
        pingbackId = `${hexTime}${v4().replace(/-/g, "")}`.substring(0, idLength);
      } catch (error) {
        pingbackId = noUUIDRandom();
      }
      try {
        sessionStorage.setItem("giphyPingbackId", pingbackId);
      } catch (_) {
      }
    }
  }
  return pingbackId;
};
var get_pingback_id_default = getPingbackId;

// src/webp-check.ts
var SUPPORTS_WEBP = null;
new Promise((resolve) => {
  if (typeof Image === "undefined") {
    resolve(false);
  }
  const webp = new Image();
  webp.onload = () => {
    SUPPORTS_WEBP = true;
    resolve(SUPPORTS_WEBP);
  };
  webp.onerror = () => {
    SUPPORTS_WEBP = false;
    resolve(SUPPORTS_WEBP);
  };
  webp.src = "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
});
var getBestVideo = (video, width, height) => {
  let assets = video == null ? void 0 : video.assets;
  if (assets) {
    assets = __spreadValues$3({}, assets);
    delete assets.source;
    const filteredAssets = Object.values(assets).sort((a, b) => a.width - b.width);
    return bestfit_default(filteredAssets, width, height);
  }
};
var getBestRendition = (images, gifWidth, gifHeight, scaleUpMaxPixels) => {
  const checkRenditions = pick(images, [
    "original",
    "fixed_width",
    "fixed_height",
    "fixed_width_small",
    "fixed_height_small"
  ]);
  const testImages = Object.entries(checkRenditions).map(([renditionName, val]) => __spreadValues$3({
    renditionName
  }, val));
  return bestfit_default(testImages, gifWidth, gifHeight, scaleUpMaxPixels);
};
var getGifHeight = ({ images }, gifWidth) => {
  const { fixed_width } = images;
  if (fixed_width) {
    const { width, height } = fixed_width;
    const aspectRatio = width / height;
    return Math.round(gifWidth / aspectRatio);
  }
  return 0;
};
var getGifWidth = ({ images }, gifHeight) => {
  const { fixed_width } = images;
  if (fixed_width) {
    const { width, height } = fixed_width;
    const aspectRatio = width / height;
    return Math.round(gifHeight * aspectRatio);
  }
  return 0;
};
var getAltText = ({ alt_text, user, tags = [], is_sticker = false, title = "" }) => {
  if (alt_text) {
    return alt_text;
  }
  if (title) {
    return title;
  }
  const username = user && user.username || "";
  const filteredTags = take(without(tags, ["transparent"]), username ? 4 : 5);
  return `${username ? `${username} ` : ``}${filteredTags.join(" ")} ${is_sticker ? "Sticker" : "GIF"}`;
};

// src/sdk-headers.ts
var gl$1 = (typeof window !== "undefined" ? window : global) || {};
gl$1._GIPHY_SDK_HEADERS_ = gl$1._GIPHY_SDK_HEADERS_ || (gl$1.Headers ? new gl$1.Headers({
  "X-GIPHY-SDK-PLATFORM": "web"
}) : void 0);
var getGiphySDKRequestHeaders = () => gl$1._GIPHY_SDK_HEADERS_;
var appendGiphySDKRequestHeader = (key, value) => {
  var _a;
  return (_a = getGiphySDKRequestHeaders()) == null ? void 0 : _a.set(key, value);
};

var __defProp$2 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined")
    return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});
var __commonJS = (cb, mod) => function __require2() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __async$1 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// package.json
var require_package = __commonJS({
  "package.json"(exports, module) {
    module.exports = {
      scripts: {
        lint: "run -T eslint . --ext .ts,.tsx",
        clean: "rm -rf ./dist",
        dev: "parcel public/test.html",
        docs: "typedoc src/index.ts",
        build: "run -T tsup src/index.ts --format cjs,esm --dts && run -T publint",
        prepublish: "npm run clean && npm run build",
        test: "run -T jest --config ./jestconfig.js",
        "test:watch": "run -T jest --config ./jestconfig.js --watchAll"
      },
      name: "@giphy/js-fetch-api",
      version: "5.7.0",
      description: "Javascript API to fetch gifs and stickers from the GIPHY API.",
      homepage: "https://github.com/Giphy/giphy-js/tree/master/packages/fetch-api",
      main: "dist/index.cjs",
      types: "dist/index.d.ts",
      module: "dist/index.js",
      type: "module",
      sideEffects: false,
      exports: {
        ".": {
          types: "./dist/index.d.ts",
          import: "./dist/index.js",
          require: "./dist/index.cjs"
        },
        "./package.json": "./package.json"
      },
      files: [
        "dist/",
        "src/**/*"
      ],
      license: "MIT",
      publishConfig: {
        access: "public"
      },
      dependencies: {
        "@giphy/js-types": "*",
        "@giphy/js-util": "*"
      },
      devDependencies: {
        "jest-fetch-mock": "^3.0.3",
        "parcel-bundler": "latest",
        typedoc: "^0.20.37",
        "typedoc-thunder-theme": "^0.0.3",
        typescript: "^5.0.4"
      }
    };
  }
});

// src/normalize/gif.ts
var BOOL_PROPS = [
  "is_anonymous",
  "is_community",
  "is_featured",
  "is_hidden",
  "is_indexable",
  "is_preserve_size",
  "is_realtime",
  "is_removed",
  "is_sticker",
  "is_dynamic"
  // not finalized, and not adding to Gif type until type RFC is finished
];
var USER_BOOL_PROPS = ["suppress_chrome", "is_public", "is_verified"];
var makeBool = (obj) => (prop) => obj[prop] = !!obj[prop];
var getTag = (tag) => typeof tag === "string" ? tag : tag.text;
var normalize = (gif, responseId = "") => {
  const newGif = __spreadValues$2({}, gif);
  newGif.id = String(newGif.id);
  newGif.tags = (newGif.tags || []).map(getTag);
  if (!newGif.bottle_data) {
    newGif.bottle_data = {};
  }
  newGif.response_id = responseId;
  BOOL_PROPS.forEach(makeBool(newGif));
  Object.keys(newGif.images || {}).forEach((name) => {
    const img = newGif.images[name];
    img.width = parseInt(img.width);
    img.height = parseInt(img.height);
  });
  const { user } = newGif;
  if (user) {
    const newUser = __spreadValues$2({}, user);
    USER_BOOL_PROPS.forEach(makeBool(newUser));
    newGif.user = newUser;
  }
  return newGif;
};
var normalizeGif = (result) => {
  const { response_id } = result.meta;
  result.data = normalize(result.data, response_id);
  return result;
};
var normalizeGifs = (result) => {
  const { response_id } = result.meta;
  result.data = result.data.map((gif) => normalize(gif, response_id));
  return result;
};

// src/constants.ts
var gl = (typeof window !== "undefined" ? window : global) || {};
var serverUrl = gl.GIPHY_API_URL || "https://api.giphy.com/v1/";

// src/fetch-error.ts
var FetchError$1 = class extends Error {
  constructor(message, url, status = 0, statusText = "") {
    super(message);
    this.url = url;
    this.status = status;
    this.statusText = statusText;
  }
};
var GeoFetchError = class extends FetchError$1 {
};
var fetch_error_default$1 = FetchError$1;

// src/request.ts
var ERROR_PREFIX = `@giphy/js-fetch-api: `;
var DEFAULT_ERROR = "Error fetching";
var identity = (i) => i;
var requestMap = {};
var maxLife = 6e4;
var errorMaxLife = 6e3;
var purgeCache = () => {
  const now = Date.now();
  Object.keys(requestMap).forEach((key) => {
    const ttl = requestMap[key].isError ? errorMaxLife : maxLife;
    if (now - requestMap[key].ts >= ttl) {
      delete requestMap[key];
    }
  });
};
function request(url, options = {}) {
  const { apiVersion = 1, noCache = false, normalizer = identity } = options;
  const serverUrl_ = serverUrl.replace(/\/v\d+\/$/, `/v${apiVersion}/`);
  purgeCache();
  if (!requestMap[url] || noCache) {
    const fullUrl = `${serverUrl_}${url}`;
    const makeRequest = () => __async$1(this, null, function* () {
      var _a2, _b;
      let fetchError;
      try {
        const response = yield fetch(fullUrl, {
          method: "get"
        });
        if (response.ok) {
          const result = yield response.json();
          if (!((_a2 = result.meta) == null ? void 0 : _a2.response_id)) {
            throw { message: `synthetic response` };
          } else {
            return normalizer(result);
          }
        } else {
          let message = DEFAULT_ERROR;
          try {
            const result = yield response.json();
            if (result.message)
              message = result.message;
            if ((_b = result.meta) == null ? void 0 : _b.msg)
              message = result.meta.msg;
          } catch (_) {
          }
          if (requestMap[url]) {
            requestMap[url].isError = true;
          }
          let Cls = fetch_error_default$1;
          if (message === "This content is not available in your location") {
            Cls = GeoFetchError;
          }
          fetchError = new Cls(`${ERROR_PREFIX}${message}`, fullUrl, response.status, response.statusText);
        }
      } catch (unexpectedError) {
        fetchError = new fetch_error_default$1(unexpectedError.message, fullUrl);
        if (requestMap[url]) {
          requestMap[url].isError = true;
        }
      }
      throw fetchError;
    });
    requestMap[url] = { request: makeRequest(), ts: Date.now() };
  }
  return requestMap[url].request;
}
var request_default = request;

// src/api.ts
var getType = (options) => options && options.type ? options.type : "gifs";
var GiphyFetch = class {
  constructor(apiKey, qsParams = {}) {
    /**
     * @hidden
     */
    this.getQS = (options = {}) => {
      const searchParams = new URLSearchParams(__spreadValues$2(__spreadProps$1(__spreadValues$2({}, options), {
        api_key: this.apiKey,
        pingback_id: get_pingback_id_default()
      }), this.qsParams));
      return searchParams.toString();
    };
    this.apiKey = apiKey;
    this.qsParams = qsParams;
  }
  /**
   * A list of categories
   *
   * @param {CategoriesOptions} [options]
   * @returns {Promise<CategoriesResult>}
   */
  categories(options) {
    return request_default(`gifs/categories?${this.getQS(options)}`);
  }
  /**
   * Get a single gif by a id
   * @param {string} id
   * @returns {Promise<GifsResult>}
   **/
  gif(id, options) {
    const prefix = (options == null ? void 0 : options.internal) ? "internal/" : "";
    return request_default(`${prefix}gifs/${id}?${this.getQS()}`, { normalizer: normalizeGif });
  }
  gifs(arg1, arg2) {
    if (Array.isArray(arg1)) {
      return request_default(`gifs?${this.getQS({ ids: arg1.join(",") })}`, {
        normalizer: normalizeGifs
      });
    }
    return request_default(`gifs/categories/${arg1}/${arg2}?${this.getQS()}`, {
      normalizer: normalizeGifs
    });
  }
  emoji(options) {
    return request_default(`emoji?${this.getQS(options)}`, { normalizer: normalizeGifs });
  }
  /**
   * Returns a list of all the default emoji variations
   *
   * @param {PaginationOptions} options
   * @returns {Promise<GifsResult>}
   **/
  emojiDefaultVariations(options) {
    return request_default(`emoji?${this.getQS(options)}`, {
      apiVersion: 2,
      normalizer: normalizeGifs
    });
  }
  /**
   * Returns a list of gifs representing all the variations for the emoji
   *
   * @param {string} id
   * @returns {Promise<NonPaginatedGifsResult>}
   **/
  emojiVariations(id) {
    return request_default(`emoji/${id}/variations?${this.getQS()}`, {
      apiVersion: 2,
      normalizer: normalizeGifs
    });
  }
  animate(text, options = {}) {
    const qsParams = this.getQS(__spreadProps$1(__spreadValues$2({}, options), { m: text }));
    return request_default(`text/animate?${qsParams}`, { normalizer: normalizeGifs });
  }
  /**
   * @param term: string The term you're searching for
   * @param options: SearchOptions
   * @returns {Promise<GifsResult>}
   **/
  search(term, options = {}) {
    const q = options.channel ? `@${options.channel} ${term}` : term;
    let excludeDynamicResults;
    if (options.type === "text") {
      excludeDynamicResults = true;
    }
    const qsParams = this.getQS(__spreadProps$1(__spreadValues$2({ rating: "pg-13" }, options), { q, excludeDynamicResults }));
    return request_default(`${getType(options)}/search?${qsParams}`, { normalizer: normalizeGifs });
  }
  /**
   * Get a list of subcategories
   * @param {string} category
   * @param {SubcategoriesOptions} options
   * @returns {Promise<CategoriesResult>}
   */
  subcategories(category, options) {
    return request_default(`gifs/categories/${category}?${this.getQS(options)}`);
  }
  /**
   * Get trending gifs
   *
   * @param {TrendingOptions} options
   * @returns {Promise<GifsResult>}
   */
  trending(options = {}) {
    return request_default(`${getType(options)}/trending?${this.getQS(__spreadValues$2({ rating: "pg-13" }, options))}`, {
      normalizer: normalizeGifs
    });
  }
  /**
   * Get a random gif
   * @param {RandomOptions} options
   * @returns {Promise<GifResult>}
   **/
  random(options) {
    return request_default(`${getType(options)}/random?${this.getQS(__spreadValues$2({ rating: "pg-13" }, options))}`, {
      noCache: true,
      normalizer: normalizeGif
    });
  }
  /**
   * Get related gifs by a id
   * @param {string} id
   * @param {SubcategoriesOptions} options
   * @returns {Promise<GifsResult>}
   **/
  related(id, options = {}) {
    const { type = "gifs" } = options;
    return request_default(
      `${type}/related?${this.getQS(__spreadValues$2({
        gif_id: id,
        rating: "pg-13"
      }, options))}`,
      { normalizer: normalizeGifs }
    );
  }
  /**
   * Search for channels based on a term
   * @param {string} term
   * @param options: SearchOptions
   * @returns {Promise<ChannelsResult>}
   **/
  channels(term, options = {}) {
    return request_default(
      `channels/search?${this.getQS(__spreadValues$2({ q: term, rating: "pg-13" }, options))}`
    );
  }
};
var api_default = GiphyFetch;

// src/paginator.ts
var invisibleGifsFlag = Symbol("has inivisible gifs");
var gifPaginator = (fetchGifs, initialGifs = []) => {
  let gifs = [...initialGifs];
  let gifIds = initialGifs.map((g) => g.id);
  let offset = initialGifs.length;
  let isDoneFetching = false;
  return (externalGifs) => __async$1(void 0, null, function* () {
    if (externalGifs) {
      gifs = externalGifs;
      gifIds = externalGifs.map((g2) => g2.id);
    }
    if (isDoneFetching) {
      return gifs;
    }
    const result = yield fetchGifs(offset);
    const { pagination, data: newGifs } = result;
    offset = pagination.count + pagination.offset;
    isDoneFetching = offset === pagination.total_count;
    newGifs.forEach((gif) => {
      const { id } = gif;
      if (!gifIds.includes(id)) {
        gifs.push(gif);
        gifIds.push(id);
      }
    });
    const g = [...gifs];
    if (pagination.hasMoreGifs) {
      g.skipCountCheck = invisibleGifsFlag;
    }
    return g;
  });
};

// src/index.ts
var _a$2;
if (typeof __require !== "undefined") {
  const { version } = require_package();
  if (!((_a$2 = getGiphySDKRequestHeaders()) == null ? void 0 : _a$2.get(`X-GIPHY-SDK-NAME`))) {
    appendGiphySDKRequestHeader(`X-GIPHY-SDK-NAME`, "FetchAPI");
    appendGiphySDKRequestHeader(`X-GIPHY-SDK-VERSION`, version);
  }
}

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @param {number} position
 * @return {number}
 */
function indexof (value, search, position) {
	return value.indexOf(search, position)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

/**
 * @param {string[]} array
 * @param {RegExp} pattern
 * @return {string[]}
 */
function filter (array, pattern) {
	return array.filter(function (value) { return !match(value, pattern) })
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {object[]} siblings
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length, siblings) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: '', siblings: siblings}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign(node('', null, null, '', null, null, 0, root.siblings), root, {length: -root.length}, props)
}

/**
 * @param {object} root
 */
function lift (root) {
	while (root.root)
		root = copy(root.root, {children: [root]});

	append(root, root.siblings);
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f', abs(index ? points[index - 1] : 0)) != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent, declarations), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace(characters, /\f/g, '');
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1, declarations) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @param {object[]} siblings
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length, siblings)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @param {object[]} siblings
 * @return {object}
 */
function comment (value, root, parent, siblings) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0, siblings)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @param {object[]} siblings
 * @return {object}
 */
function declaration (value, root, parent, length, siblings) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length, siblings)
}

/**
 * @param {string} value
 * @param {number} length
 * @param {object[]} children
 * @return {string}
 */
function prefix (value, length, children) {
	switch (hash(value, length)) {
		// color-adjust
		case 5103:
			return WEBKIT + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return WEBKIT + value + value
		// tab-size
		case 4789:
			return MOZ + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// writing-mode
		case 5936:
			switch (charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
				// default: fallthrough to below
			}
		// flex, flex-direction, scroll-snap-type, writing-mode
		case 6828: case 4268: case 2903:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/g, '') + (!match(value, /flex-|baseline/) ? MS + 'grid-row-' + replace(value, /flex-|-self/g, '') : '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/g, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
		// justify-self
		case 4200:
			if (!match(value, /flex-|baseline/)) return MS + 'grid-column-align' + substr(value, length) + value
			break
		// grid-template-(columns|rows)
		case 2592: case 3360:
			return MS + replace(value, 'template-', '') + value
		// grid-(row|column)-start
		case 4384: case 3616:
			if (children && children.some(function (element, index) { return length = index, match(element.props, /grid-\w+-end/) })) {
				return ~indexof(value + (children = children[length].value), 'span', 0) ? value : (MS + replace(value, '-start', '') + value + MS + 'grid-row-span:' + (~indexof(children, 'span', 0) ? match(children, /\d+/) : +match(children, /\d+/) - +match(value, /\d+/)) + ';')
			}
			return MS + replace(value, '-start', '') + value
		// grid-(row|column)-end
		case 4896: case 4128:
			return (children && children.some(function (element) { return match(element.props, /grid-\w+-start/) })) ? value : MS + replace(replace(value, '-end', '-span'), 'span ', '') + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (strlen(value) - 1 - length > 6)
				switch (charat(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if (charat(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch', 0) ? prefix(replace(value, 'stretch', 'fill-available'), length, children) + value : value
				}
			break
		// grid-(column|row)
		case 5152: case 5920:
			return replace(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function (_, a, b, c, d, e, f) { return (MS + a + ':' + b + f) + (c ? (MS + a + '-span:' + (d ? e : +e - +b)) + f : '') + value })
		// position: sticky
		case 4949:
			// stick(y)?
			if (charat(value, length + 6) === 121)
				return replace(value, ':', ':' + WEBKIT) + value
			break
		// display: (flex|inline-flex|grid|inline-grid)
		case 6444:
			switch (charat(value, charat(value, 14) === 45 ? 18 : 11)) {
				// (inline-)?fle(x)
				case 120:
					return replace(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
				// (inline-)?gri(d)
				case 100:
					return replace(value, ':', ':' + MS) + value
			}
			break
		// scroll-margin, scroll-margin-(top|right|bottom|left)
		case 5719: case 2647: case 2135: case 3927: case 2391:
			return replace(value, 'scroll-', 'scroll-snap-') + value
	}

	return value
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';

	for (var i = 0; i < children.length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: if (!strlen(element.value = element.props.join(','))) return ''
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children);
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(children = element.props, function (value) {
							switch (match(value, callback = /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									lift(copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]}));
									lift(copy(element, {props: [value]}));
									assign(element, {props: filter(children, callback)});
									break
								// :placeholder
								case '::placeholder':
									lift(copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}));
									lift(copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}));
									lift(copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]}));
									lift(copy(element, {props: [value]}));
									assign(element, {props: filter(children, callback)});
									break
							}

							return ''
						})
			}
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var f="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",m="active",y="data-styled-version",v="6.1.19",g="/*!sc*/\n",S="undefined"!=typeof window&&"undefined"!=typeof document,w=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!==process.env.NODE_ENV),E=/invalid hook call/i,N=new Set,P=function(t,n){if("production"!==process.env.NODE_ENV){var o=n?' with the id of "'.concat(n,'"'):"",s="The component ".concat(t).concat(o," has been created dynamically.\n")+"You may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.\nSee https://styled-components.com/docs/basics#define-styled-components-outside-of-the-render-method for more info.\n",i=console.error;try{var a=!0;console.error=function(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];E.test(t)?(a=!1,N.delete(s)):i.apply(void 0,__spreadArray([t],n,!1));},useRef(),a&&!N.has(s)&&(console.warn(s),N.add(s));}catch(e){E.test(e.message)&&N.delete(s);}finally{console.error=i;}}},_=Object.freeze([]),C=Object.freeze({});function I(e,t,n){return void 0===n&&(n=C),e.theme!==n.theme&&e.theme||t||n.theme}var A=new Set(["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","track","u","ul","use","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","tspan"]),O=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,D=/(^-|-$)/g;function R(e){return e.replace(O,"-").replace(D,"")}var T=/(a)(d)/gi,k=52,j=function(e){return String.fromCharCode(e+(e>25?39:97))};function x(e){var t,n="";for(t=Math.abs(e);t>k;t=t/k|0)n=j(t%k)+n;return (j(t%k)+n).replace(T,"$1-$2")}var V,F=5381,z=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},M=function(e){return z(F,e)};function $(e){return x(M(e)>>>0)}function B(e){return "production"!==process.env.NODE_ENV&&"string"==typeof e&&e||e.displayName||e.name||"Component"}function G(e){return "string"==typeof e&&("production"===process.env.NODE_ENV||e.charAt(0)===e.charAt(0).toLowerCase())}var L="function"==typeof Symbol&&Symbol.for,Y=L?Symbol.for("react.memo"):60115,q=L?Symbol.for("react.forward_ref"):60112,W={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},H={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},U={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},J=((V={})[q]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},V[Y]=U,V);function X(e){return ("type"in(t=e)&&t.type.$$typeof)===Y?U:"$$typeof"in e?J[e.$$typeof]:W;var t;}var Z=Object.defineProperty,K=Object.getOwnPropertyNames,Q=Object.getOwnPropertySymbols,ee=Object.getOwnPropertyDescriptor,te=Object.getPrototypeOf,ne=Object.prototype;function oe(e,t,n){if("string"!=typeof t){if(ne){var o=te(t);o&&o!==ne&&oe(e,o,n);}var r=K(t);Q&&(r=r.concat(Q(t)));for(var s=X(e),i=X(t),a=0;a<r.length;++a){var c=r[a];if(!(c in H||n&&n[c]||i&&c in i||s&&c in s)){var l=ee(t,c);try{Z(e,c,l);}catch(e){}}}}return e}function re(e){return "function"==typeof e}function se(e){return "object"==typeof e&&"styledComponentId"in e}function ie(e,t){return e&&t?"".concat(e," ").concat(t):e||t||""}function ae(e,t){if(0===e.length)return "";for(var n=e[0],o=1;o<e.length;o++)n+=t?t+e[o]:e[o];return n}function ce(e){return null!==e&&"object"==typeof e&&e.constructor.name===Object.name&&!("props"in e&&e.$$typeof)}function le(e,t,n){if(void 0===n&&(n=!1),!n&&!ce(e)&&!Array.isArray(e))return t;if(Array.isArray(t))for(var o=0;o<t.length;o++)e[o]=le(e[o],t[o]);else if(ce(t))for(var o in t)e[o]=le(e[o],t[o]);return e}function ue(e,t){Object.defineProperty(e,"toString",{value:t});}var pe="production"!==process.env.NODE_ENV?{1:"Cannot create styled-component for component: %s.\n\n",2:"Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",3:"Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",4:"The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",5:"The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",6:"Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",7:'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',8:'ThemeProvider: Please make your "theme" prop an object.\n\n',9:"Missing document `<head>`\n\n",10:"Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",11:"_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",12:"It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",13:"%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",14:'ThemeProvider: "theme" prop is required.\n\n',15:"A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",16:"Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",17:"CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n",18:"ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`"}:{};function de(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];for(var n=e[0],o=[],r=1,s=e.length;r<s;r+=1)o.push(e[r]);return o.forEach(function(e){n=n.replace(/%[a-z]/,e);}),n}function he(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];return "production"===process.env.NODE_ENV?new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t," for more information.").concat(n.length>0?" Args: ".concat(n.join(", ")):"")):new Error(de.apply(void 0,__spreadArray([pe[t]],n,!1)).trim())}var fe=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e;}return e.prototype.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},e.prototype.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,o=n.length,r=o;e>=r;)if((r<<=1)<0)throw he(16,"".concat(e));this.groupSizes=new Uint32Array(r),this.groupSizes.set(n),this.length=r;for(var s=o;s<r;s++)this.groupSizes[s]=0;}for(var i=this.indexOfGroup(e+1),a=(s=0,t.length);s<a;s++)this.tag.insertRule(i,t[s])&&(this.groupSizes[e]++,i++);},e.prototype.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),o=n+t;this.groupSizes[e]=0;for(var r=n;r<o;r++)this.tag.deleteRule(n);}},e.prototype.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],o=this.indexOfGroup(e),r=o+n,s=o;s<r;s++)t+="".concat(this.tag.getRule(s)).concat(g);return t},e}(),me=1<<30,ye=new Map,ve=new Map,ge=1,Se=function(e){if(ye.has(e))return ye.get(e);for(;ve.has(ge);)ge++;var t=ge++;if("production"!==process.env.NODE_ENV&&((0|t)<0||t>me))throw he(16,"".concat(t));return ye.set(e,t),ve.set(t,e),t},we=function(e,t){ge=t+1,ye.set(e,t),ve.set(t,e);},be="style[".concat(f,"][").concat(y,'="').concat(v,'"]'),Ee=new RegExp("^".concat(f,'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')),Ne=function(e,t,n){for(var o,r=n.split(","),s=0,i=r.length;s<i;s++)(o=r[s])&&e.registerName(t,o);},Pe=function(e,t){for(var n,o=(null!==(n=t.textContent)&&void 0!==n?n:"").split(g),r=[],s=0,i=o.length;s<i;s++){var a=o[s].trim();if(a){var c=a.match(Ee);if(c){var l=0|parseInt(c[1],10),u=c[2];0!==l&&(we(u,l),Ne(e,u,c[3]),e.getTag().insertRules(l,r)),r.length=0;}else r.push(a);}}},_e=function(e){for(var t=document.querySelectorAll(be),n=0,o=t.length;n<o;n++){var r=t[n];r&&r.getAttribute(f)!==m&&(Pe(e,r),r.parentNode&&r.parentNode.removeChild(r));}};function Ce(){return "undefined"!=typeof __webpack_nonce__?__webpack_nonce__:null}var Ie=function(e){var t=document.head,n=e||t,o=document.createElement("style"),r=function(e){var t=Array.from(e.querySelectorAll("style[".concat(f,"]")));return t[t.length-1]}(n),s=void 0!==r?r.nextSibling:null;o.setAttribute(f,m),o.setAttribute(y,v);var i=Ce();return i&&o.setAttribute("nonce",i),n.insertBefore(o,s),o},Ae=function(){function e(e){this.element=Ie(e),this.element.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,o=t.length;n<o;n++){var r=t[n];if(r.ownerNode===e)return r}throw he(17)}(this.element),this.length=0;}return e.prototype.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return !1}},e.prototype.deleteRule=function(e){this.sheet.deleteRule(e),this.length--;},e.prototype.getRule=function(e){var t=this.sheet.cssRules[e];return t&&t.cssText?t.cssText:""},e}(),Oe=function(){function e(e){this.element=Ie(e),this.nodes=this.element.childNodes,this.length=0;}return e.prototype.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t);return this.element.insertBefore(n,this.nodes[e]||null),this.length++,!0}return !1},e.prototype.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--;},e.prototype.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),De=function(){function e(e){this.rules=[],this.length=0;}return e.prototype.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},e.prototype.deleteRule=function(e){this.rules.splice(e,1),this.length--;},e.prototype.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),Re=S,Te={isServer:!S,useCSSOMInjection:!w},ke=function(){function e(e,n,o){void 0===e&&(e=C),void 0===n&&(n={});var r=this;this.options=__assign(__assign({},Te),e),this.gs=n,this.names=new Map(o),this.server=!!e.isServer,!this.server&&S&&Re&&(Re=!1,_e(this)),ue(this,function(){return function(e){for(var t=e.getTag(),n=t.length,o="",r=function(n){var r=function(e){return ve.get(e)}(n);if(void 0===r)return "continue";var s=e.names.get(r),i=t.getGroup(n);if(void 0===s||!s.size||0===i.length)return "continue";var a="".concat(f,".g").concat(n,'[id="').concat(r,'"]'),c="";void 0!==s&&s.forEach(function(e){e.length>0&&(c+="".concat(e,","));}),o+="".concat(i).concat(a,'{content:"').concat(c,'"}').concat(g);},s=0;s<n;s++)r(s);return o}(r)});}return e.registerId=function(e){return Se(e)},e.prototype.rehydrate=function(){!this.server&&S&&_e(this);},e.prototype.reconstructWithOptions=function(n,o){return void 0===o&&(o=!0),new e(__assign(__assign({},this.options),n),this.gs,o&&this.names||void 0)},e.prototype.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},e.prototype.getTag=function(){return this.tag||(this.tag=(e=function(e){var t=e.useCSSOMInjection,n=e.target;return e.isServer?new De(n):t?new Ae(n):new Oe(n)}(this.options),new fe(e)));var e;},e.prototype.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},e.prototype.registerName=function(e,t){if(Se(e),this.names.has(e))this.names.get(e).add(t);else {var n=new Set;n.add(t),this.names.set(e,n);}},e.prototype.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(Se(e),n);},e.prototype.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear();},e.prototype.clearRules=function(e){this.getTag().clearGroup(Se(e)),this.clearNames(e);},e.prototype.clearTag=function(){this.tag=void 0;},e}(),je=/&/g,xe=/^\s*\/\/.*$/gm;function Ve(e,t){return e.map(function(e){return "rule"===e.type&&(e.value="".concat(t," ").concat(e.value),e.value=e.value.replaceAll(",",",".concat(t," ")),e.props=e.props.map(function(e){return "".concat(t," ").concat(e)})),Array.isArray(e.children)&&"@keyframes"!==e.type&&(e.children=Ve(e.children,t)),e})}function Fe(e){var t,n,o,r=void 0===e?C:e,s=r.options,i=void 0===s?C:s,a=r.plugins,c=void 0===a?_:a,l=function(e,o,r){return r.startsWith(n)&&r.endsWith(n)&&r.replaceAll(n,"").length>0?".".concat(t):e},u=c.slice();u.push(function(e){e.type===RULESET&&e.value.includes("&")&&(e.props[0]=e.props[0].replace(je,n).replace(o,l));}),i.prefix&&u.push(prefixer),u.push(stringify);var p=function(e,r,s,a){void 0===r&&(r=""),void 0===s&&(s=""),void 0===a&&(a="&"),t=a,n=r,o=new RegExp("\\".concat(n,"\\b"),"g");var c=e.replace(xe,""),l=compile(s||r?"".concat(s," ").concat(r," { ").concat(c," }"):c);i.namespace&&(l=Ve(l,i.namespace));var p=[];return serialize(l,middleware(u.concat(rulesheet(function(e){return p.push(e)})))),p};return p.hash=c.length?c.reduce(function(e,t){return t.name||he(15),z(e,t.name)},F).toString():"",p}var ze=new ke,Me=Fe(),$e=React.createContext({shouldForwardProp:void 0,styleSheet:ze,stylis:Me});$e.Consumer;React.createContext(void 0);function Le(){return useContext($e)}var qe=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=Me);var o=n.name+t.hash;e.hasNameForId(n.id,o)||e.insertRules(n.id,o,t(n.rules,o,"@keyframes"));},this.name=e,this.id="sc-keyframes-".concat(e),this.rules=t,ue(this,function(){throw he(12,String(n.name))});}return e.prototype.getName=function(e){return void 0===e&&(e=Me),this.name+e.hash},e}(),We=function(e){return e>="A"&&e<="Z"};function He(e){for(var t="",n=0;n<e.length;n++){var o=e[n];if(1===n&&"-"===o&&"-"===e[0])return e;We(o)?t+="-"+o.toLowerCase():t+=o;}return t.startsWith("ms-")?"-"+t:t}var Ue=function(e){return null==e||!1===e||""===e},Je=function(t){var n,o,r=[];for(var s in t){var i=t[s];t.hasOwnProperty(s)&&!Ue(i)&&(Array.isArray(i)&&i.isCss||re(i)?r.push("".concat(He(s),":"),i,";"):ce(i)?r.push.apply(r,__spreadArray(__spreadArray(["".concat(s," {")],Je(i),!1),["}"],!1)):r.push("".concat(He(s),": ").concat((n=s,null==(o=i)||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||n in unitlessKeys||n.startsWith("--")?String(o).trim():"".concat(o,"px")),";")));}return r};function Xe(e,t,n,o){if(Ue(e))return [];if(se(e))return [".".concat(e.styledComponentId)];if(re(e)){if(!re(s=e)||s.prototype&&s.prototype.isReactComponent||!t)return [e];var r=e(t);return "production"===process.env.NODE_ENV||"object"!=typeof r||Array.isArray(r)||r instanceof qe||ce(r)||null===r||console.error("".concat(B(e)," is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")),Xe(r,t,n,o)}var s;return e instanceof qe?n?(e.inject(n,o),[e.getName(o)]):[e]:ce(e)?Je(e):Array.isArray(e)?Array.prototype.concat.apply(_,e.map(function(e){return Xe(e,t,n,o)})):[e.toString()]}function Ze(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(re(n)&&!se(n))return !1}return !0}var Ke=M(v),Qe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic="production"===process.env.NODE_ENV&&(void 0===n||n.isStatic)&&Ze(e),this.componentId=t,this.baseHash=z(Ke,t),this.baseStyle=n,ke.registerId(t);}return e.prototype.generateAndInjectStyles=function(e,t,n){var o=this.baseStyle?this.baseStyle.generateAndInjectStyles(e,t,n):"";if(this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(this.componentId,this.staticRulesId))o=ie(o,this.staticRulesId);else {var r=ae(Xe(this.rules,e,t,n)),s=x(z(this.baseHash,r)>>>0);if(!t.hasNameForId(this.componentId,s)){var i=n(r,".".concat(s),void 0,this.componentId);t.insertRules(this.componentId,s,i);}o=ie(o,s),this.staticRulesId=s;}else {for(var a=z(this.baseHash,n.hash),c="",l=0;l<this.rules.length;l++){var u=this.rules[l];if("string"==typeof u)c+=u,"production"!==process.env.NODE_ENV&&(a=z(a,u));else if(u){var p=ae(Xe(u,e,t,n));a=z(a,p+l),c+=p;}}if(c){var d=x(a>>>0);t.hasNameForId(this.componentId,d)||t.insertRules(this.componentId,d,n(c,".".concat(d),void 0,this.componentId)),o=ie(o,d);}}return o},e}(),et=React.createContext(void 0);et.Consumer;var rt={},st=new Set;function it(e,r,s){var i=se(e),a=e,c=!G(e),p=r.attrs,d=void 0===p?_:p,h=r.componentId,f=void 0===h?function(e,t){var n="string"!=typeof e?"sc":R(e);rt[n]=(rt[n]||0)+1;var o="".concat(n,"-").concat($(v+n+rt[n]));return t?"".concat(t,"-").concat(o):o}(r.displayName,r.parentComponentId):h,m=r.displayName,y=void 0===m?function(e){return G(e)?"styled.".concat(e):"Styled(".concat(B(e),")")}(e):m,g=r.displayName&&r.componentId?"".concat(R(r.displayName),"-").concat(r.componentId):r.componentId||f,S=i&&a.attrs?a.attrs.concat(d).filter(Boolean):d,w=r.shouldForwardProp;if(i&&a.shouldForwardProp){var b=a.shouldForwardProp;if(r.shouldForwardProp){var E=r.shouldForwardProp;w=function(e,t){return b(e,t)&&E(e,t)};}else w=b;}var N=new Qe(s,g,i?a.componentStyle:void 0);function O(e,r){return function(e,r,s){var i=e.attrs,a=e.componentStyle,c=e.defaultProps,p=e.foldedComponentIds,d=e.styledComponentId,h=e.target,f=React.useContext(et),m=Le(),y=e.shouldForwardProp||m.shouldForwardProp;"production"!==process.env.NODE_ENV&&useDebugValue(d);var v=I(r,f,c)||C,g=function(e,n,o){for(var r,s=__assign(__assign({},n),{className:void 0,theme:o}),i=0;i<e.length;i+=1){var a=re(r=e[i])?r(s):r;for(var c in a)s[c]="className"===c?ie(s[c],a[c]):"style"===c?__assign(__assign({},s[c]),a[c]):a[c];}return n.className&&(s.className=ie(s.className,n.className)),s}(i,r,v),S=g.as||h,w={};for(var b in g)void 0===g[b]||"$"===b[0]||"as"===b||"theme"===b&&g.theme===v||("forwardedAs"===b?w.as=g.forwardedAs:y&&!y(b,S)||(w[b]=g[b],y||"development"!==process.env.NODE_ENV||isPropValid(b)||st.has(b)||!A.has(S)||(st.add(b),console.warn('styled-components: it looks like an unknown prop "'.concat(b,'" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));var E=function(e,t){var n=Le(),o=e.generateAndInjectStyles(t,n.styleSheet,n.stylis);return "production"!==process.env.NODE_ENV&&useDebugValue(o),o}(a,g);"production"!==process.env.NODE_ENV&&e.warnTooManyClasses&&e.warnTooManyClasses(E);var N=ie(p,d);return E&&(N+=" "+E),g.className&&(N+=" "+g.className),w[G(S)&&!A.has(S)?"class":"className"]=N,s&&(w.ref=s),createElement(S,w)}(D,e,r)}O.displayName=y;var D=React.forwardRef(O);return D.attrs=S,D.componentStyle=N,D.displayName=y,D.shouldForwardProp=w,D.foldedComponentIds=i?ie(a.foldedComponentIds,a.styledComponentId):"",D.styledComponentId=g,D.target=i?a.target:e,Object.defineProperty(D,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(e){this._foldedDefaultProps=i?function(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];for(var o=0,r=t;o<r.length;o++)le(e,r[o],!0);return e}({},a.defaultProps,e):e;}}),"production"!==process.env.NODE_ENV&&(P(y,g),D.warnTooManyClasses=function(e,t){var n={},o=!1;return function(r){if(!o&&(n[r]=!0,Object.keys(n).length>=200)){var s=t?' with the id of "'.concat(t,'"'):"";console.warn("Over ".concat(200," classes were generated for component ").concat(e).concat(s,".\n")+"Consider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"),o=!0,n={};}}}(y,g)),ue(D,function(){return ".".concat(D.styledComponentId)}),c&&oe(D,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0}),D}function at(e,t){for(var n=[e[0]],o=0,r=t.length;o<r;o+=1)n.push(t[o],e[o+1]);return n}var ct=function(e){return Object.assign(e,{isCss:!0})};function lt(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];if(re(t)||ce(t))return ct(Xe(at(_,__spreadArray([t],n,!0))));var r=t;return 0===n.length&&1===r.length&&"string"==typeof r[0]?Xe(r):ct(Xe(at(r,n)))}function ut(n,o,r){if(void 0===r&&(r=C),!o)throw he(1,o);var s=function(t){for(var s=[],i=1;i<arguments.length;i++)s[i-1]=arguments[i];return n(o,r,lt.apply(void 0,__spreadArray([t],s,!1)))};return s.attrs=function(e){return ut(n,o,__assign(__assign({},r),{attrs:Array.prototype.concat(r.attrs,e).filter(Boolean)}))},s.withConfig=function(e){return ut(n,o,__assign(__assign({},r),e))},s}var pt=function(e){return ut(it,e)},dt=pt;A.forEach(function(e){dt[e]=pt(e);});function mt(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];"production"!==process.env.NODE_ENV&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");var r=ae(lt.apply(void 0,__spreadArray([t],n,!1))),s=$(r);return new qe(s,r)}"production"!==process.env.NODE_ENV&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native");var wt="__sc-".concat(f,"__");"production"!==process.env.NODE_ENV&&"test"!==process.env.NODE_ENV&&"undefined"!=typeof window&&(window[wt]||(window[wt]=0),1===window[wt]&&console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."),window[wt]+=1);

// src/index.ts
var giphyBlack = "#121212";
var giphyDarkestGrey = "#212121";
var giphyDarkCharcoal = "#3e3e3e";
var giphyCharcoal = "#4a4a4a";
var giphyLightGrey = "#a6a6a6";
var giphyWhiteSmoke = "#ececec";
var giphyWhite = "#ffffff";
var giphyBlue = "#00ccff";
var giphyGreen = "#00ff99";
var giphyPurple = "#9933ff";
var giphyRed = "#ff6666";
var giphyYellow = "#fff35c";
var giphyIndigo = "#6157ff";

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset).
 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function}  A new, throttled, function.
 */
function throttle (delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    var self = this;
    var elapsed = Date.now() - lastExec;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

/* eslint-disable no-undefined */
/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @returns {Function} A new, debounced function.
 */

function debounce (delay, atBegin, callback) {
  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
}

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function() {

// Exit early if we're not running in a browser.
if (typeof window !== 'object') {
  return;
}

// Exit early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}

/**
 * Returns the embedding frame element, if any.
 * @param {!Document} doc
 * @return {!Element}
 */
function getFrameElement(doc) {
  try {
    return doc.defaultView && doc.defaultView.frameElement || null;
  } catch (e) {
    // Ignore the error.
    return null;
  }
}

/**
 * A local reference to the root document.
 */
var document = (function(startDoc) {
  var doc = startDoc;
  var frame = getFrameElement(doc);
  while (frame) {
    doc = frame.ownerDocument;
    frame = getFrameElement(doc);
  }
  return doc;
})(window.document);

/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];

/**
 * The signal updater for cross-origin intersection. When not null, it means
 * that the polyfill is configured to work in a cross-origin mode.
 * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
var crossOriginUpdater = null;

/**
 * The current cross-origin intersection. Only used in the cross-origin mode.
 * @type {DOMRect|ClientRect}
 */
var crossOriginRect = null;


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = ensureDOMRect(entry.rootBounds);
  this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
  this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (
    options.root &&
    options.root.nodeType != 1 &&
    options.root.nodeType != 9
  ) {
    throw new Error('root must be a Document or Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');

  /** @private @const {!Array<!Document>} */
  this._monitoringDocuments = [];
  /** @private @const {!Array<function()>} */
  this._monitoringUnsubscribes = [];
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Sets up the polyfill in the cross-origin mode. The result is the
 * updater function that accepts two arguments: `boundingClientRect` and
 * `intersectionRect` - just as these fields would be available to the
 * parent via `IntersectionObserverEntry`. This function should be called
 * each time the iframe receives intersection information from the parent
 * window, e.g. via messaging.
 * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
IntersectionObserver._setupCrossOriginUpdater = function() {
  if (!crossOriginUpdater) {
    /**
     * @param {DOMRect|ClientRect} boundingClientRect
     * @param {DOMRect|ClientRect} intersectionRect
     */
    crossOriginUpdater = function(boundingClientRect, intersectionRect) {
      if (!boundingClientRect || !intersectionRect) {
        crossOriginRect = getEmptyRect();
      } else {
        crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
      }
      registry.forEach(function(observer) {
        observer._checkForIntersections();
      });
    };
  }
  return crossOriginUpdater;
};


/**
 * Resets the cross-origin mode.
 */
IntersectionObserver._resetCrossOriginUpdater = function() {
  crossOriginUpdater = null;
  crossOriginRect = null;
};


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections(target.ownerDocument);
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {
        return item.element != target;
      });
  this._unmonitorIntersections(target.ownerDocument);
  if (this._observationTargets.length == 0) {
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorAllIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function(doc) {
  var win = doc.defaultView;
  if (!win) {
    // Already destroyed.
    return;
  }
  if (this._monitoringDocuments.indexOf(doc) != -1) {
    // Already monitoring.
    return;
  }

  // Private state for monitoring.
  var callback = this._checkForIntersections;
  var monitoringInterval = null;
  var domObserver = null;

  // If a poll interval is set, use polling instead of listening to
  // resize and scroll events or DOM mutations.
  if (this.POLL_INTERVAL) {
    monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
  } else {
    addEvent(win, 'resize', callback, true);
    addEvent(doc, 'scroll', callback, true);
    if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
      domObserver = new win.MutationObserver(callback);
      domObserver.observe(doc, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  this._monitoringDocuments.push(doc);
  this._monitoringUnsubscribes.push(function() {
    // Get the window object again. When a friendly iframe is destroyed, it
    // will be null.
    var win = doc.defaultView;

    if (win) {
      if (monitoringInterval) {
        win.clearInterval(monitoringInterval);
      }
      removeEvent(win, 'resize', callback, true);
    }

    removeEvent(doc, 'scroll', callback, true);
    if (domObserver) {
      domObserver.disconnect();
    }
  });

  // Also monitor the parent.
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._monitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function(doc) {
  var index = this._monitoringDocuments.indexOf(doc);
  if (index == -1) {
    return;
  }

  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;

  // Check if any dependent targets are still remaining.
  var hasDependentTargets =
      this._observationTargets.some(function(item) {
        var itemDoc = item.element.ownerDocument;
        // Target is in this context.
        if (itemDoc == doc) {
          return true;
        }
        // Target is nested in this context.
        while (itemDoc && itemDoc != rootDoc) {
          var frame = getFrameElement(itemDoc);
          itemDoc = frame && frame.ownerDocument;
          if (itemDoc == doc) {
            return true;
          }
        }
        return false;
      });
  if (hasDependentTargets) {
    return;
  }

  // Unsubscribe.
  var unsubscribe = this._monitoringUnsubscribes[index];
  this._monitoringDocuments.splice(index, 1);
  this._monitoringUnsubscribes.splice(index, 1);
  unsubscribe();

  // Also unmonitor the parent.
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._unmonitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorAllIntersections = function() {
  var unsubscribes = this._monitoringUnsubscribes.slice(0);
  this._monitoringDocuments.length = 0;
  this._monitoringUnsubscribes.length = 0;
  for (var i = 0; i < unsubscribes.length; i++) {
    unsubscribes[i]();
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  if (!this.root && crossOriginUpdater && !crossOriginRect) {
    // Cross origin monitoring, but no initial data available yet.
    return;
  }

  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, targetRect, rootRect);

    var rootBounds = null;
    if (!this._rootContainsTarget(target)) {
      rootBounds = getEmptyRect();
    } else if (!crossOriginUpdater || this.root) {
      rootBounds = rootRect;
    }

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootBounds,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} targetRect The bounding rect of the target.
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, targetRect, rootRect) {
  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot && parent) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return null;

    if (parent == this.root || parent.nodeType == /* DOCUMENT */ 9) {
      atRoot = true;
      if (parent == this.root || parent == document) {
        if (crossOriginUpdater && !this.root) {
          if (!crossOriginRect ||
              crossOriginRect.width == 0 && crossOriginRect.height == 0) {
            // A 0-size cross-origin intersection means no-intersection.
            parent = null;
            parentRect = null;
            intersectionRect = null;
          } else {
            parentRect = crossOriginRect;
          }
        } else {
          parentRect = rootRect;
        }
      } else {
        // Check if there's a frame that can be navigated to.
        var frame = getParentNode(parent);
        var frameRect = frame && getBoundingClientRect(frame);
        var frameIntersect =
            frame &&
            this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
        if (frameRect && frameIntersect) {
          parent = frame;
          parentRect = convertFromParentRect(frameRect, frameIntersect);
        } else {
          parent = null;
          intersectionRect = null;
        }
      }
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      var doc = parent.ownerDocument;
      if (parent != doc.body &&
          parent != doc.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);
    }
    if (!intersectionRect) break;
    parent = parent && getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {ClientRect} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root && !isDoc(this.root)) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var doc = isDoc(this.root) ? this.root : document;
    var html = doc.documentElement;
    var body = doc.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {DOMRect|ClientRect} rect The rect object to expand.
 * @return {ClientRect} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  return (
    containsDeep(rootDoc, target) &&
    (!this.root || rootDoc == target.ownerDocument)
  );
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detachEvent == 'function') {
    node.detachEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object|?ClientRect} The intersection rect or undefined if no
 *     intersection is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  } || null;
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {ClientRect} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}


/**
 * Ensure that the result has all of the necessary fields of the DOMRect.
 * Specifically this ensures that `x` and `y` fields are set.
 *
 * @param {?DOMRect|?ClientRect} rect
 * @return {?DOMRect}
 */
function ensureDOMRect(rect) {
  // A `DOMRect` object has `x` and `y` fields.
  if (!rect || 'x' in rect) {
    return rect;
  }
  // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
  // for internally calculated Rect objects. For the purposes of
  // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
  // for these fields.
  return {
    top: rect.top,
    y: rect.top,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    right: rect.right,
    width: rect.width,
    height: rect.height
  };
}


/**
 * Inverts the intersection and bounding rect from the parent (frame) BCR to
 * the local BCR space.
 * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
 * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
 * @return {ClientRect} The local root bounding rect for the parent's children.
 */
function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
  var top = parentIntersectionRect.top - parentBoundingRect.top;
  var left = parentIntersectionRect.left - parentBoundingRect.left;
  return {
    top: top,
    left: left,
    height: parentIntersectionRect.height,
    width: parentIntersectionRect.width,
    bottom: top + parentIntersectionRect.height,
    right: left + parentIntersectionRect.width
  };
}


/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (node.nodeType == /* DOCUMENT */ 9 && node != document) {
    // If this node is a document node, look for the embedding frame.
    return getFrameElement(node);
  }

  // If the parent has element that is assigned through shadow root slot
  if (parent && parent.assignedSlot) {
    parent = parent.assignedSlot.parentNode;
  }

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }

  return parent;
}

/**
 * Returns true if `node` is a Document.
 * @param {!Node} node
 * @returns {boolean}
 */
function isDoc(node) {
  return node && node.nodeType === 9;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}());

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var mergeAttribute = (attributes, newAttributes, key) => {
  const result1 = pick(attributes, [key]);
  const result2 = pick(newAttributes, [key]);
  if (result1[key] && result2[key]) {
    return __spreadValues$1(__spreadValues$1(__spreadValues$1({}, attributes), newAttributes), { [key]: result1[key] + ", " + result2[key] });
  }
  return __spreadValues$1(__spreadValues$1({}, attributes), newAttributes);
};
var merge_attributes_default = mergeAttribute;

// src/global.ts
var global_default = (typeof window !== "undefined" ? window : global) || {};
var _a$1;
var environment = ((_a$1 = global_default) == null ? void 0 : _a$1.GIPHY_PINGBACK_URL) || "https://pingback.giphy.com";
var pingBackUrl = `${environment}/v2/pingback?apikey=l0HlIwPWyBBUDAUgM`;
var sendPingback = (events) => {
  const headers = getGiphySDKRequestHeaders();
  headers == null ? void 0 : headers.set("Content-Type", "application/json");
  Logger.debug(`Pingback session`, events);
  if (!events.length) {
    return new Promise((resolve) => resolve());
  }
  return fetch(pingBackUrl, {
    method: "POST",
    body: JSON.stringify({ events }),
    headers
  }).catch((error) => {
    Logger.warn(`pingbacks failing to post ${error}`);
  });
};

// src/pingback.ts
var queuedPingbackEvents = [];
global_default.giphyRandomId = get_pingback_id_default();
var loggedInUserId = "";
function sendPingbacks() {
  const sendEvents = [...queuedPingbackEvents];
  queuedPingbackEvents = [];
  sendPingback(sendEvents);
}
var debouncedPingbackEvent = debounce(1e3, sendPingbacks);
var _a2, _b;
(_b = (_a2 = global_default).addEventListener) == null ? void 0 : _b.call(_a2, "beforeunload", sendPingbacks);
var pingback = ({
  userId,
  eventType,
  actionType,
  attributes,
  queueEvents = true,
  analyticsResponsePayload
}) => {
  loggedInUserId = userId ? String(userId) : loggedInUserId;
  const newEvent = {
    ts: Date.now(),
    attributes,
    action_type: actionType,
    user_id: get_pingback_id_default(),
    analytics_response_payload: analyticsResponsePayload
  };
  if (loggedInUserId) {
    newEvent.logged_in_user_id = loggedInUserId;
  }
  if (newEvent.analytics_response_payload) {
    newEvent.analytics_response_payload = `${newEvent.analytics_response_payload}${Logger.ENABLED ? "&mode=verification" : ""}`;
  }
  if (eventType) {
    newEvent.event_type = eventType;
  }
  queuedPingbackEvents.push(newEvent);
  queueEvents ? debouncedPingbackEvent() : sendPingbacks();
};
var pingback_default = pingback;

var require$$0 = /*@__PURE__*/getAugmentedNamespace(_tslib);

var useTimeoutFn$1 = {};

Object.defineProperty(useTimeoutFn$1, "__esModule", { value: true });
var react_1$1 = React;
function useTimeoutFn(fn, ms) {
    if (ms === void 0) { ms = 0; }
    var ready = react_1$1.useRef(false);
    var timeout = react_1$1.useRef();
    var callback = react_1$1.useRef(fn);
    var isReady = react_1$1.useCallback(function () { return ready.current; }, []);
    var set = react_1$1.useCallback(function () {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function () {
            ready.current = true;
            callback.current();
        }, ms);
    }, [ms]);
    var clear = react_1$1.useCallback(function () {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    react_1$1.useEffect(function () {
        callback.current = fn;
    }, [fn]);
    // set on mount, clear on unmount
    react_1$1.useEffect(function () {
        set();
        return clear;
    }, [ms]);
    return [isReady, clear, set];
}
var _default$1 = useTimeoutFn$1.default = useTimeoutFn;

var useRaf$1 = {};

var useIsomorphicLayoutEffect = {};

var util = {};

var hasRequiredUtil;

function requireUtil () {
	if (hasRequiredUtil) return util;
	hasRequiredUtil = 1;
	Object.defineProperty(util, "__esModule", { value: true });
	util.isNavigator = util.isBrowser = util.off = util.on = util.noop = void 0;
	var noop = function () { };
	util.noop = noop;
	function on(obj) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    if (obj && obj.addEventListener) {
	        obj.addEventListener.apply(obj, args);
	    }
	}
	util.on = on;
	function off(obj) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    if (obj && obj.removeEventListener) {
	        obj.removeEventListener.apply(obj, args);
	    }
	}
	util.off = off;
	util.isBrowser = typeof window !== 'undefined';
	util.isNavigator = typeof navigator !== 'undefined';
	return util;
}

var hasRequiredUseIsomorphicLayoutEffect;

function requireUseIsomorphicLayoutEffect () {
	if (hasRequiredUseIsomorphicLayoutEffect) return useIsomorphicLayoutEffect;
	hasRequiredUseIsomorphicLayoutEffect = 1;
	Object.defineProperty(useIsomorphicLayoutEffect, "__esModule", { value: true });
	var react_1 = React;
	var util_1 = requireUtil();
	var useIsomorphicLayoutEffect$1 = util_1.isBrowser ? react_1.useLayoutEffect : react_1.useEffect;
	useIsomorphicLayoutEffect.default = useIsomorphicLayoutEffect$1;
	return useIsomorphicLayoutEffect;
}

Object.defineProperty(useRaf$1, "__esModule", { value: true });
var tslib_1 = require$$0;
var react_1 = React;
var useIsomorphicLayoutEffect_1 = tslib_1.__importDefault(requireUseIsomorphicLayoutEffect());
var useRaf = function (ms, delay) {
    if (ms === void 0) { ms = 1e12; }
    if (delay === void 0) { delay = 0; }
    var _a = react_1.useState(0), elapsed = _a[0], set = _a[1];
    useIsomorphicLayoutEffect_1.default(function () {
        var raf;
        var timerStop;
        var start;
        var onFrame = function () {
            var time = Math.min(1, (Date.now() - start) / ms);
            set(time);
            loop();
        };
        var loop = function () {
            raf = requestAnimationFrame(onFrame);
        };
        var onStart = function () {
            timerStop = setTimeout(function () {
                cancelAnimationFrame(raf);
                set(1);
            }, ms);
            start = Date.now();
            loop();
        };
        var timerDelay = setTimeout(onStart, delay);
        return function () {
            clearTimeout(timerStop);
            clearTimeout(timerDelay);
            cancelAnimationFrame(raf);
        };
    }, [ms, delay]);
    return elapsed;
};
var _default = useRaf$1.default = useRaf;

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var getSmallAvatar = (avatar) => {
  var _a, _b;
  if (!avatar)
    return "";
  const ext = (_b = (_a = avatar == null ? void 0 : avatar.split(".")) == null ? void 0 : _a.pop()) == null ? void 0 : _b.toLowerCase();
  return avatar.replace(`.${ext}`, `/80h.${ext}`);
};
var Img = dt.img`
    object-fit: cover;
    width: 32px;
    height: 32px;
    margin-right: 8px;
`;
var Avatar = ({ user, className = "" }) => {
  const defaultAvatarId = useRef(Math.floor(Math.random() * 5) + 1);
  const url = user.avatar_url ? getSmallAvatar(user.avatar_url) : `https://media.giphy.com/avatars/default${defaultAvatarId.current}.gif`;
  return /* @__PURE__ */ React.createElement(Img, { src: url, className });
};
var avatar_default = Avatar;
var VerifiedBadge = ({ className = "", size = 17, fill = "#15CDFF" }) => /* @__PURE__ */ React.createElement("svg", { className: [VerifiedBadge.className, className].join(" "), height: size, width: "19px", viewBox: "0 0 19 17" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    className: VerifiedBadge.checkMarkClassName,
    d: "M9.32727273,9.44126709 L9.32727273,3.03016561 L6.55027155,3.03016561 L6.55027155,10.8150746 L6.55027155,12.188882 L12.1042739,12.188882 L12.1042739,9.44126709 L9.32727273,9.44126709 Z",
    fill: giphyBlack,
    transform: "translate(9.327273, 7.609524) scale(-1, 1) rotate(-45.000000) translate(-9.327273, -7.609524) "
  }
), /* @__PURE__ */ React.createElement("g", { transform: "translate(-532.000000, -466.000000)", fill }, /* @__PURE__ */ React.createElement("g", { transform: "translate(141.000000, 235.000000)" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(264.000000, 0.000000)" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(10.000000, 224.000000)" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(114.000000, 2.500000)" }, /* @__PURE__ */ React.createElement("path", { d: "M15.112432,4.80769231 L16.8814194,6.87556817 L19.4157673,7.90116318 L19.6184416,10.6028916 L21.0594951,12.9065042 L19.6184416,15.2101168 L19.4157673,17.9118452 L16.8814194,18.9374402 L15.112432,21.0053161 L12.4528245,20.3611511 L9.79321699,21.0053161 L8.02422954,18.9374402 L5.48988167,17.9118452 L5.28720734,15.2101168 L3.84615385,12.9065042 L5.28720734,10.6028916 L5.48988167,7.90116318 L8.02422954,6.87556817 L9.79321699,4.80769231 L12.4528245,5.4518573 L15.112432,4.80769231 Z M17.8163503,10.8991009 L15.9282384,9.01098901 L11.5681538,13.3696923 L9.68115218,11.4818515 L7.81302031,13.3499833 L9.7011322,15.2380952 L11.5892441,17.1262071 L17.8163503,10.8991009 Z" })))))));
VerifiedBadge.className = "giphy-verified-badge";
VerifiedBadge.checkMarkClassName = "giphy-verified-checkmark";
var verified_badge_default = VerifiedBadge;

// src/components/attribution/user.tsx
var Username = dt.div`
    color: white;
    font-size: 16px;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-font-smoothing: antialiased;
`;
var VerifiedBadge2 = dt(verified_badge_default)`
    margin-left: 4px;
    flex-shrink: 0;
`;
var Container = dt.div`
    display: flex;
    align-items: center;
    min-width: 0;
`;
var User = ({ user }) => {
  const { display_name, username } = user;
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Username, null, display_name || `@${username}`), user.is_verified ? /* @__PURE__ */ React.createElement(VerifiedBadge2, { size: 14 }) : null);
};
var user_default = User;

// src/components/attribution/index.tsx
var Container2 = dt.div`
    display: flex;
    align-items: center;
    font-family: interface, helvetica, arial;
`;
var Avatar2 = dt(avatar_default)`
    flex-shrink: 0;
`;
var Attribution = ({ gif, className, onClick }) => {
  const { user } = gif;
  if (!(user == null ? void 0 : user.username) && !(user == null ? void 0 : user.display_name)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    Container2,
    {
      className: [Attribution.className, className].join(" "),
      onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) {
          onClick(gif);
        } else {
          const url = user.profile_url;
          if (url)
            window.open(url, "_blank");
        }
      }
    },
    /* @__PURE__ */ React.createElement(Avatar2, { user }),
    /* @__PURE__ */ React.createElement(user_default, { user: gif.user })
  );
};
Attribution.className = "giphy-attribution";
var attribution_default = Attribution;
var Background = dt.div`
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(18, 18, 18, 0.6));
    cursor: default;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 75px;
    pointer-events: none;
`;
var Attribution2 = dt(attribution_default)`
    position: absolute;
    bottom: 10px;
    left: 10px;
    right: 10px;
`;
var Container3 = dt.div`
    transition: opacity 150ms ease-in;
`;
var AttributionOverlay = ({ gif, isHovered, onClick }) => {
  const hasHovered = useRef(isHovered);
  if (isHovered) {
    hasHovered.current = true;
  }
  return gif.user && hasHovered.current ? /* @__PURE__ */ React.createElement(Container3, { style: { opacity: isHovered ? 1 : 0 } }, /* @__PURE__ */ React.createElement(Background, null), /* @__PURE__ */ React.createElement(Attribution2, { gif, onClick })) : null;
};
var overlay_default = AttributionOverlay;
var Observer = ({ children, className, onVisibleChange, config }) => {
  const container = useRef(null);
  useEffect(() => {
    let io;
    if (container.current) {
      io = new IntersectionObserver(([entry]) => {
        if (onVisibleChange)
          onVisibleChange(entry.isIntersecting);
      }, config);
      io.observe(container.current);
    }
    return () => io == null ? void 0 : io.disconnect();
  }, [onVisibleChange, container, config]);
  return /* @__PURE__ */ React.createElement("div", { ref: container, className }, children);
};
var observer_default = Observer;
var firePingback = (actionType) => (gif, userId, target, attributes = {}) => {
  if (!gif.analytics_response_payload) {
    return;
  }
  pingback_default({
    analyticsResponsePayload: gif.analytics_response_payload,
    userId,
    actionType,
    attributes: __spreadValues({ position: JSON.stringify(get_client_rect_from_el_default(target)) }, attributes)
  });
};
var onGifSeen = (gif, userId, position, attributes = {}) => {
  if (!gif.analytics_response_payload) {
    return;
  }
  pingback_default({
    analyticsResponsePayload: gif.analytics_response_payload,
    userId,
    actionType: "SEEN",
    attributes: __spreadValues({ position: JSON.stringify(position) }, attributes)
  });
};
var onGifClick = firePingback("CLICK");
var onGifHover = firePingback("HOVER");
function processTag(tag) {
  tag = tag.replace(`%%CACHEBUSTER%%`, noUUIDRandom());
  tag = tag.replace("%%TIMESTAMP%%", `${Date.now()}`);
  tag = tag.replace("%%APPBUNDLE%%", `web`);
  if (typeof window !== "undefined") {
    tag = tag.replace("%%APP_WINDOW_SIZE%%", `${window.innerWidth},${window.innerHeight}`);
    tag = tag.replace("%%DEVICE_LANGUAGE%%", `${navigator.language}`);
  }
  return tag;
}
function BottleData({ src }) {
  const processedSrc = useRef(processTag(src));
  const [render, setRender] = useState(false);
  useEffect(() => {
    setRender(true);
  }, []);
  return render ? /* @__PURE__ */ React.createElement("img", { src: processedSrc.current, width: 0, height: 0 }) : null;
}
var bottle_data_default = BottleData;
var PingbackContext = createContext({});
var PingbackContextManager = ({ attributes, children }) => {
  const { attributes: parentAttributes = {} } = useContext(PingbackContext);
  return /* @__PURE__ */ React.createElement(
    PingbackContext.Provider,
    {
      value: {
        attributes: merge_attributes_default(parentAttributes, attributes, "layout_type")
      }
    },
    children
  );
};
var pingback_context_manager_default = PingbackContextManager;

// src/components/gif.tsx
var Container4 = dt.div`
    position: relative;
    display: block;
    picture {
        display: block;
        width: 100%;
        height: 100%;
    }
    img {
        display: block;
    }
    .${verified_badge_default.className} {
        g {
            fill: white;
        }
    }
    .${verified_badge_default.checkMarkClassName} {
        opacity: 0;
    }
`;
var GRID_COLORS = [giphyBlue, giphyGreen, giphyPurple, giphyRed, giphyYellow];
var getColor = () => GRID_COLORS[Math.round(Math.random() * (GRID_COLORS.length - 1))];
var hoverTimeoutDelay = 200;
var placeholder = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var noop = () => {
};
var RenderOnClient = ({ children }) => {
  const [render, setRender] = useState(false);
  useEffect(() => {
    setRender(true);
  }, []);
  return render ? /* @__PURE__ */ React.createElement(React.Fragment, null, children) : null;
};
var Gif = ({
  gif,
  gif: { bottle_data: bottleData = {} },
  width,
  percentWidth,
  percentHeight,
  height: forcedHeight,
  onGifRightClick = noop,
  className = "",
  onGifClick: onGifClick2 = noop,
  onGifKeyPress = noop,
  onGifSeen: onGifSeen2 = noop,
  onGifVisible = noop,
  user = {},
  backgroundColor,
  overlay,
  hideAttribution = false,
  noLink = false,
  borderRadius = 4,
  style,
  tabIndex,
  lazyLoad = true
}) => {
  var _a;
  const [hasFiredSeen, setHasFiredSeen] = useState(false);
  const [isHovered, setHovered] = useState(false);
  const [shouldShowMedia, setShouldShowMedia] = useState(!canUseDOM || !lazyLoad);
  const [loadedClassname, setLoadedClassName] = useState("");
  const defaultBgColor = useRef(getColor());
  const container = useRef(null);
  const image = useRef(null);
  const showGifObserver = useRef();
  const fullGifObserver = useRef();
  const hoverTimeout = useRef();
  const sendOnSeen = useRef(noop);
  const isAd = Object.keys(bottleData).length > 0;
  const { attributes } = useContext(PingbackContext);
  let Overlay = overlay;
  if (!Overlay && !hideAttribution) {
    Overlay = overlay_default;
  }
  const onMouseOver = (e) => {
    clearTimeout(hoverTimeout.current);
    e.persist();
    setHovered(true);
    hoverTimeout.current = window.setTimeout(() => {
      onGifHover(gif, user == null ? void 0 : user.id, e.target, attributes);
    }, hoverTimeoutDelay);
  };
  const onMouseLeave = () => {
    clearTimeout(hoverTimeout.current);
    setHovered(false);
  };
  const onClick = (e) => {
    onGifClick(gif, user == null ? void 0 : user.id, e.target, attributes);
    onGifClick2(gif, e);
  };
  const onKeyPress = (e) => {
    onGifKeyPress(gif, e);
  };
  sendOnSeen.current = (entry) => {
    setHasFiredSeen(true);
    Logger.debug(`GIF ${gif.id} seen. ${gif.title}`);
    onGifSeen(gif, user == null ? void 0 : user.id, entry.boundingClientRect, attributes);
    onGifSeen2 == null ? void 0 : onGifSeen2(gif, entry.boundingClientRect);
    if (fullGifObserver.current) {
      fullGifObserver.current.disconnect();
    }
  };
  const watchGif = () => {
    if (!fullGifObserver.current) {
      fullGifObserver.current = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            sendOnSeen.current(entry);
          }
        },
        { threshold: [0.99] }
      );
    }
    if (!hasFiredSeen && container.current && fullGifObserver.current) {
      fullGifObserver.current.observe(container.current);
    }
  };
  const onImageLoad = (e) => {
    watchGif();
    onGifVisible(gif, e);
    setLoadedClassName(Gif.imgLoadedClassName);
  };
  useEffect(() => {
    var _a2, _b;
    if ((_a2 = image.current) == null ? void 0 : _a2.complete) {
      watchGif();
      onGifVisible(gif);
    }
    (_b = fullGifObserver.current) == null ? void 0 : _b.disconnect();
    setHasFiredSeen(false);
  }, [gif.id]);
  useEffect(() => {
    showGifObserver.current = new IntersectionObserver(([entry]) => {
      const { isIntersecting } = entry;
      setShouldShowMedia(isIntersecting);
      if (!isIntersecting && fullGifObserver.current) {
        fullGifObserver.current.disconnect();
      }
    });
    showGifObserver.current.observe(container.current);
    return () => {
      if (showGifObserver.current)
        showGifObserver.current.disconnect();
      if (fullGifObserver.current)
        fullGifObserver.current.disconnect();
      if (hoverTimeout.current)
        clearTimeout(hoverTimeout.current);
    };
  }, []);
  const heightBasedOnWidth = getGifHeight(gif, width);
  let height = forcedHeight;
  if (!(style == null ? void 0 : style.aspectRatio) && !forcedHeight) {
    height = heightBasedOnWidth;
  }
  const bestRendition = getBestRendition(gif.images, width, forcedHeight || heightBasedOnWidth);
  if (!bestRendition) {
    if (gif.images) {
      console.error(`no rendition for ${gif.id}, rendition names: ${Object.keys(gif.images).join(", ")}`);
    } else {
      console.error(`no rendition for ${gif.id} - no images`);
    }
    return null;
  }
  const rendition = gif.images[bestRendition.renditionName];
  const removeBackground = loadedClassname === Gif.imgLoadedClassName && !gif.is_sticker;
  const background = removeBackground ? "unset" : backgroundColor || // <- specified background prop
  // sticker has black if no backgroundColor is specified
  (gif.is_sticker ? `url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4AQMAAACSSKldAAAABlBMVEUhIiIWFhYoSqvJAAAAGElEQVQY02MAAv7///8PWxqIPwDZw5UGABtgwz2xhFKxAAAAAElFTkSuQmCC') 0 0` : defaultBgColor.current);
  const overflow = borderRadius ? "hidden" : "unset";
  return /* @__PURE__ */ React.createElement(
    Container4,
    {
      as: noLink ? "div" : "a",
      href: noLink ? void 0 : gif.url,
      "data-giphy-id": gif.id,
      "data-giphy-is-sticker": gif.is_sticker,
      style: __spreadValues({
        width: percentWidth || width,
        height: percentHeight || height,
        overflow,
        borderRadius
      }, style),
      className: [Gif.className, className].join(" "),
      onMouseOver,
      onMouseLeave,
      onClick,
      onContextMenu: (e) => onGifRightClick(gif, e),
      onKeyPress,
      tabIndex,
      ref: container
    },
    /* @__PURE__ */ React.createElement("picture", null, /* @__PURE__ */ React.createElement(
      "source",
      {
        type: "image/webp",
        srcSet: shouldShowMedia ? rendition.webp : placeholder,
        suppressHydrationWarning: true
      }
    ), /* @__PURE__ */ React.createElement(
      "img",
      {
        ref: image,
        suppressHydrationWarning: true,
        className: [Gif.imgClassName, loadedClassname].join(" "),
        src: shouldShowMedia ? rendition.url : placeholder,
        style: { background },
        width: "100%",
        height: "100%",
        alt: getAltText(gif),
        onLoad: shouldShowMedia ? onImageLoad : () => {
        }
      }
    )),
    isAd && ((_a = bottleData == null ? void 0 : bottleData.tags) == null ? void 0 : _a.map((tag, index) => /* @__PURE__ */ React.createElement(bottle_data_default, { src: tag, key: index }))),
    Overlay && // only render the overlay on the client since it depends on shouldShowMedia
    /* @__PURE__ */ React.createElement(RenderOnClient, null, shouldShowMedia && /* @__PURE__ */ React.createElement(Overlay, { gif, isHovered, width, height }))
  );
};
Gif.className = "giphy-gif";
Gif.imgClassName = "giphy-gif-img";
Gif.imgLoadedClassName = "giphy-img-loaded";
var gif_default = Gif;

// src/components/carousel.tsx
var Container5 = dt.div`
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    position: relative;
`;
var Gif2 = dt(gif_default)`
    position: relative;
    display: inline-block;
    list-style: none;
    margin-left: ${(props) => props.$ml}px;
    /* make sure gifs are fully visible with a scrollbar */
    margin-bottom: 1px;

    &:first-of-type {
        margin-left: 0;
    }
    .${gif_default.imgClassName} {
        position: absolute;
        top: 0;
        left: 0;
    }
`;
var Observer2 = dt(observer_default)`
    display: inline-block;
`;
var Loader = dt.div`
    width: 30px;
    display: inline-block;
    opacity: ${(props) => props.$isFirstLoad ? 0 : 1};
    height: ${(props) => props.$height}px;
`;
var defaultProps = Object.freeze({ gutter: 6, user: {}, initialGifs: [] });
var initialState = Object.freeze({
  isFetching: false,
  gifs: [],
  isLoaderVisible: false,
  isDoneFetching: false
});
var _Carousel = class _Carousel extends PureComponent {
  constructor() {
    super(...arguments);
    this.state = __spreadProps(__spreadValues({}, initialState), { gifs: this.props.initialGifs || [] });
    this.unmounted = false;
    this.paginator = gifPaginator(this.props.fetchGifs, this.state.gifs);
    this.onLoaderVisible = (isVisible) => {
      if (this.unmounted)
        return;
      this.setState({ isLoaderVisible: isVisible }, this.onFetch);
    };
    this.onFetch = debounce(100, () => __async(this, null, function* () {
      if (this.unmounted)
        return;
      const { isFetching, isLoaderVisible, gifs: existingGifs } = this.state;
      if (!isFetching && isLoaderVisible) {
        this.setState({ isFetching: true });
        let gifs;
        try {
          gifs = yield this.paginator();
        } catch (error) {
          this.setState({ isFetching: false });
        }
        if (gifs) {
          const skipCountCheck = !!(gifs == null ? void 0 : gifs.skipCountCheck);
          if (!skipCountCheck && existingGifs.length === gifs.length) {
            this.setState({ isDoneFetching: true });
          } else {
            this.setState({ gifs, isFetching: false });
            const { onGifsFetched } = this.props;
            if (onGifsFetched)
              onGifsFetched(gifs);
            this.onFetch();
          }
        }
      }
    }));
  }
  componentDidMount() {
    this.unmounted = false;
    this.onFetch();
  }
  componentWillUnmount() {
    this.unmounted = true;
  }
  render() {
    const {
      onGifVisible,
      onGifRightClick,
      gifHeight,
      gifWidth,
      gutter,
      className = _Carousel.className,
      onGifSeen: onGifSeen2,
      onGifClick: onGifClick2,
      onGifKeyPress,
      user,
      overlay,
      hideAttribution,
      noLink,
      noResultsMessage,
      backgroundColor,
      borderRadius,
      tabIndex = 0,
      loaderConfig
    } = this.props;
    const { gifs, isDoneFetching } = this.state;
    const showLoader = !isDoneFetching;
    const isFirstLoad = gifs.length === 0;
    return /* @__PURE__ */ React.createElement(pingback_context_manager_default, { attributes: { layout_type: "CAROUSEL" } }, /* @__PURE__ */ React.createElement(Container5, { className }, gifs.map((gif) => {
      return /* @__PURE__ */ React.createElement(
        Gif2,
        {
          gif,
          key: gif.id,
          tabIndex,
          width: gifWidth || getGifWidth(gif, gifHeight),
          height: gifHeight,
          onGifClick: onGifClick2,
          onGifKeyPress,
          onGifSeen: onGifSeen2,
          onGifVisible,
          onGifRightClick,
          user,
          $ml: gutter,
          overlay,
          hideAttribution,
          noLink,
          borderRadius,
          backgroundColor
        }
      );
    }), !showLoader && gifs.length === 0 && noResultsMessage, showLoader && /* @__PURE__ */ React.createElement(Observer2, { onVisibleChange: this.onLoaderVisible, config: loaderConfig }, /* @__PURE__ */ React.createElement(Loader, { $isFirstLoad: isFirstLoad, $height: gifHeight }))));
  }
};
_Carousel.className = "giphy-carousel";
_Carousel.defaultProps = defaultProps;
var Message = dt.div`
    color: ${giphyLightGrey};
    display: flex;
    justify-content: center;
    margin: 30px 0;
    font-family: interface, Helvetica Neue, helvetica, sans-serif;
    font-size: 16px;
    font-weight: 600;
    a {
        color: ${giphyBlue};
        cursor: pointer;
        &:hover {
            color: white;
        }
    }
`;
var FetchError = ({ onClick }) => /* @__PURE__ */ React.createElement(Message, null, "Error loading GIFs.\xA0", /* @__PURE__ */ React.createElement("a", { onClick }, "Try again?"));
var fetch_error_default = FetchError;
var DIVIDER_RELATIVE_HEIGHT = 0.75;
dt.div`
    align-items: center;
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    border-radius: 16px;
    display: flex;
    max-width: fit-content;
    overflow: hidden;
    padding: 4px 5px 5px 6px;
`;
dt.div`
    overflow-x: auto;
    overflow-y: hidden;
    position: relative;
    -webkit-overflow-scrolling: touch;
`;
dt.div`
    display: inline-flex;
    justify-content: space-between;
    overflow: hidden;
    white-space: nowrap;
    width: ${({ $width }) => `${$width}px`};
`;
dt.div`
    background-color: ${({ $color: color }) => color};
    box-sizing: border-box;
    height: ${({ $gifHeight }) => `${Math.round($gifHeight * DIVIDER_RELATIVE_HEIGHT)}px`};
    margin: ${({ $gutter }) => `0 ${$gutter}px`};
    width: 2px;
`;
dt(gif_default)`
    display: inline-block;
    flex-shrink: 0;
    list-style: none;
    /* make sure gifs are fully visible with a scrollbar */
    margin-bottom: 1px;
    position: relative;

    .${gif_default.imgClassName} {
        position: absolute;
        top: 0;
        left: 0;
    }
`;
var bouncer = mt`
     to {
    transform: scale(1.75) translateY(-20px);
  }
`;
var loaderHeight = 52;
var Container6 = dt.div`
    display: flex;
    align-items: center;
    height: ${loaderHeight}px;
    margin: 0 auto;
    text-align: center;
    justify-content: center;
    animation: pulse 0.8s ease-in-out 0s infinite alternate backwards;
`;
var Dot = dt.div`
    display: inline-block;
    height: 10px;
    width: 10px;
    margin: ${loaderHeight}px 10px 10px 10px;
    position: relative;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.3);
    animation: ${bouncer} cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.75s infinite alternate;
    background: ${(props) => props.$color};
    animation-delay: ${(props) => props.$delay};
`;
var Loader2 = ({ className = "" }) => /* @__PURE__ */ React.createElement(Container6, { className }, /* @__PURE__ */ React.createElement(Dot, { $color: giphyGreen, $delay: "0" }), /* @__PURE__ */ React.createElement(Dot, { $color: giphyBlue, $delay: ".1s" }), /* @__PURE__ */ React.createElement(Dot, { $color: giphyPurple, $delay: ".2s" }), /* @__PURE__ */ React.createElement(Dot, { $color: giphyRed, $delay: ".3s" }), /* @__PURE__ */ React.createElement(Dot, { $color: giphyYellow, $delay: ".4s" }));
var loader_default = Loader2;

// src/components/grid.tsx
var Loader3 = dt.div`
    opacity: ${(props) => props.$isFirstLoad ? 0 : 1};
`;
function fillArray(length, defaultValue, initArray = []) {
  return Array.apply(null, Array(length)).map((_, index) => initArray[index] || defaultValue);
}
function getColumns(columns, columnOffsets, gifs, gifWidth) {
  const sorter = fillArray(columns, []);
  const columnHeights = fillArray(columns, 0, columnOffsets);
  gifs.forEach((gif) => {
    const columnTarget = columnHeights.indexOf(Math.min(...columnHeights));
    sorter[columnTarget] = [...sorter[columnTarget], gif];
    columnHeights[columnTarget] += getGifHeight(gif, gifWidth);
  });
  return sorter;
}
var defaultProps2 = Object.freeze({ gutter: 6, user: {}, initialGifs: [] });
var initialState2 = Object.freeze({
  isFetching: false,
  isError: false,
  gifs: [],
  isLoaderVisible: false,
  isDoneFetching: false
});
var _Grid = class _Grid extends PureComponent {
  constructor() {
    super(...arguments);
    this.state = __spreadProps(__spreadValues({}, initialState2), { gifs: this.props.initialGifs || [] });
    this.unmounted = false;
    this.paginator = gifPaginator(this.props.fetchGifs, this.state.gifs);
    this.onLoaderVisible = (isVisible) => {
      if (this.unmounted)
        return;
      this.setState({ isLoaderVisible: isVisible }, this.onFetch);
    };
    this.onFetch = debounce(_Grid.fetchDebounce, () => __async(this, null, function* () {
      if (this.unmounted)
        return;
      const { isFetching, isLoaderVisible } = this.state;
      const { externalGifs } = this.props;
      const prefetchCount = (externalGifs || this.state.gifs).length;
      if (!isFetching && isLoaderVisible) {
        this.setState({ isFetching: true, isError: false });
        let gifs;
        try {
          gifs = yield this.paginator(externalGifs);
          if (this.unmounted)
            return;
        } catch (error) {
          if (this.unmounted)
            return;
          this.setState({ isFetching: false, isError: true });
          const { onGifsFetchError } = this.props;
          if (onGifsFetchError)
            onGifsFetchError(error);
        }
        if (gifs) {
          const skipCountCheck = !!(gifs == null ? void 0 : gifs.skipCountCheck);
          if (!skipCountCheck && prefetchCount === gifs.length) {
            this.setState({ isDoneFetching: true });
          } else {
            this.setState({ gifs, isFetching: false });
            const { onGifsFetched } = this.props;
            if (onGifsFetched)
              onGifsFetched(gifs);
            this.onFetch();
          }
        }
      }
    }));
  }
  componentDidMount() {
    this.unmounted = false;
    this.onFetch();
  }
  componentWillUnmount() {
    this.unmounted = true;
  }
  render() {
    const {
      onGifVisible,
      onGifRightClick,
      className = _Grid.className,
      onGifSeen: onGifSeen2,
      onGifClick: onGifClick2,
      onGifKeyPress,
      user,
      overlay,
      hideAttribution,
      noLink,
      borderRadius,
      noResultsMessage,
      columns,
      width,
      gutter,
      percentWidth,
      columnOffsets,
      backgroundColor,
      loaderConfig,
      tabIndex = 0,
      layoutType = "GRID",
      loader: LoaderVisual = loader_default,
      eagerIds
    } = this.props;
    const { gifs, isError, isDoneFetching } = this.state;
    const showLoader = !isDoneFetching;
    const isFirstLoad = gifs.length === 0;
    const totalGutterPx = gutter * (columns - 1);
    const gifWidth = (width - totalGutterPx) / columns;
    const sortedIntoColumns = getColumns(columns, columnOffsets, gifs, gifWidth);
    return /* @__PURE__ */ React.createElement(pingback_context_manager_default, { attributes: { layout_type: layoutType } }, /* @__PURE__ */ React.createElement("div", { className }, /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          width: percentWidth || width,
          display: "flex",
          gap: gutter
        }
      },
      sortedIntoColumns.map((columnGifs = [], columnIndex) => /* @__PURE__ */ React.createElement(
        "div",
        {
          key: columnIndex,
          style: {
            display: "flex",
            flexDirection: "column",
            gap: gutter,
            width: percentWidth ? `100%` : gifWidth,
            marginTop: columnOffsets == null ? void 0 : columnOffsets[columnIndex]
          }
        },
        columnGifs.map((gif) => /* @__PURE__ */ React.createElement(
          gif_default,
          {
            style: {
              aspectRatio: gif.images.original.width / gif.images.original.height
            },
            gif,
            tabIndex,
            key: gif.id,
            width: gifWidth,
            percentWidth: percentWidth ? "100%" : void 0,
            onGifClick: onGifClick2,
            onGifKeyPress,
            onGifSeen: onGifSeen2,
            onGifVisible,
            onGifRightClick,
            user,
            overlay,
            backgroundColor,
            hideAttribution,
            noLink,
            borderRadius,
            lazyLoad: !(eagerIds == null ? void 0 : eagerIds.includes(gif.id))
          }
        ))
      ))
    ), !showLoader && gifs.length === 0 && noResultsMessage, isError ? /* @__PURE__ */ React.createElement(fetch_error_default, { onClick: this.onFetch }) : showLoader && /* @__PURE__ */ React.createElement(observer_default, { onVisibleChange: this.onLoaderVisible, config: loaderConfig }, /* @__PURE__ */ React.createElement(Loader3, { $isFirstLoad: isFirstLoad }, /* @__PURE__ */ React.createElement(LoaderVisual, { className: _Grid.loaderClassName })))));
  }
};
_Grid.className = "giphy-grid";
_Grid.loaderClassName = "loader";
_Grid.fetchDebounce = 250;
_Grid.defaultProps = defaultProps2;
_Grid.getDerivedStateFromProps = ({ externalGifs }, prevState) => {
  if (externalGifs && externalGifs !== prevState.gifs) {
    return { gifs: externalGifs };
  }
  return null;
};
var Grid = _Grid;
var grid_default = Grid;
var CssVars = {
  searchbarHeight: `--searchbar-height`,
  bgColor: `--searchbar-bg-color`,
  bgColor2: `--searchbar-bg-color-2`,
  fgColor: `--searchbar-fg-color`,
  cancelButtonDisplay: `--searchbar-cancel-button-display`
};
dt.div`
    ${CssVars.searchbarHeight}: ${(props) => props.$searchbarHeight || 42}px;
    @media (${(props) => props.$mobileMediaQuery}) {
        ${CssVars.searchbarHeight}: ${(props) => props.$mobileSearchbarHeight || 35}px;
    }
    ${CssVars.bgColor}: ${giphyWhite};
    ${CssVars.bgColor2}: ${giphyWhite};
    ${CssVars.fgColor}: ${giphyBlack};
    ${(props) => props.$darkMode && lt`
            ${CssVars.fgColor}: ${giphyWhite};
            ${CssVars.bgColor}: ${giphyBlack};
            ${CssVars.bgColor2}: ${giphyCharcoal};
        `}
    ${CssVars.cancelButtonDisplay}: ${(props) => props.$hideCancelButton ? "none" : "block"};
`;
createContext({});
createContext({});

// src/components/search-bar/cancel-icon.tsx
dt.svg`
    position: relative;
    right: 10px;
    margin-left: 5px;
    cursor: pointer;
    display: var(${CssVars.cancelButtonDisplay});
`;
var channelMargin = 6;
var innerHeight = `calc(var(${CssVars.searchbarHeight}) - ${channelMargin * 2}px)`;
var animateAvatar = mt`
to {
    width: ${innerHeight};
}
`;
dt(avatar_default)`
    height: ${innerHeight};
    margin: 0;
    width: 0;
    animation: ${animateAvatar} 100ms ease-in-out forwards;
`;
dt.div`
    background: var(${CssVars.bgColor2});
    display: flex;
    align-items: center;
    padding-left: ${channelMargin}px;
`;
dt.div`
    background: ${giphyWhiteSmoke};
    display: flex;
    padding: 0 4px;
    color: ${giphyDarkCharcoal};
    font-family: interface, Helvetica Neue, helvetica, sans-serif;
    font-weight: 600;
    font-size: 12px;
    align-items: center;
    height: ${innerHeight};
    @media (max-width: 480px) {
        display: none;
    }
`;
var SearchIcon = ({ className = "" }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 30 30", version: "1.1", className }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M11.5482521,20.4090671 L4.24727698,28.2009189 C3.68084207,28.8054377 2.73159653,28.8363108 2.12707771,28.2698759 C1.5225589,27.703441 1.4916858,26.7541954 2.0581207,26.1496766 L9.40599838,18.3077689 C7.95982241,16.4371424 7.0978836,14.0789715 7.0978836,11.5181818 C7.0978836,5.44914339 11.9392549,0.518181818 17.9252787,0.518181818 C23.9113026,0.518181818 28.7526738,5.44914339 28.7526738,11.5181818 C28.7526738,17.5872202 23.9113026,22.5181818 17.9252787,22.5181818 C15.539851,22.5181818 13.3361963,21.7351359 11.5482521,20.4090671 Z M17.9252787,19.5181818 C22.242011,19.5181818 25.7526738,15.9425536 25.7526738,11.5181818 C25.7526738,7.09381 22.242011,3.51818182 17.9252787,3.51818182 C13.6085464,3.51818182 10.0978836,7.09381 10.0978836,11.5181818 C10.0978836,15.9425536 13.6085464,19.5181818 17.9252787,19.5181818 Z",
    id: "giphy-search-icon-path-1"
  }
)), /* @__PURE__ */ React.createElement("g", { id: "search", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { id: "icons/search" }, /* @__PURE__ */ React.createElement("mask", { id: "giphy-search-icon-mask-2", fill: "white" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#giphy-search-icon-path-1" })), /* @__PURE__ */ React.createElement("use", { id: "Mask", fill: "#FFFFFF", fillRule: "nonzero", xlinkHref: "#giphy-search-icon-path-1" }), /* @__PURE__ */ React.createElement("g", { mask: "url(#giphy-search-icon-mask-2)" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(0.250000, 0.250000)" }, /* @__PURE__ */ React.createElement("g", null))))));
var search_icon_default = SearchIcon;

// src/components/search-bar/search-button.tsx
var time = "2s";
var purp = "#E646B6";
var pink = "#FF6666";
var strongEasing = "cubic-bezier(0.920, 0.240, 0.185, 0.730)";
var searchFx = mt`
    0% {
      transform: rotate(34deg) translate(-10px, 80px);
    };
    
    100% {
      transform: rotate(34deg) translate(-10px, -20px);
    }
`;
var plus = mt`
    0% { 
      transform: translate(0px, 0px);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: translate(10px, -17px);
      opacity: 0;
    }
`;
var gradientFade = mt`
    0% {
      opacity: 0;
      transform: translateX(-400%);
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateX(0);
    }
`;
dt.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
        display: none;
    }
    height: var(${CssVars.searchbarHeight});
    width: var(${CssVars.searchbarHeight});
`;
dt.div`
    position: absolute;
    height: 100%;
    width: 100%;
    background: linear-gradient(45deg, ${purp} 0%, ${pink} 100%);
    border-radius: 0 4px 4px 0;
    overflow: hidden;
    &:before {
        animation: ${gradientFade} ${time} linear 0s infinite;
        background-image: linear-gradient(45deg, ${purp} 0%, ${pink} 50%, ${purp} 100%);
        background-size: 400%;
        background-position: 0% 100%;
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        width: 400%;
    }
`;
dt.div`
    width: 100%;
    height: 100%;
    position: absolute;
    overflow: hidden;
    &::after {
        content: '+';
        color: white;
        font-family: 'SS Standard';
        font-size: 8px;
        position: absolute;
        top: 65%;
        left: 66%;
        animation: ${plus} 1s ${strongEasing} 0s 1 forwards;
    }
`;
dt.div`
    position: absolute;
    width: 200%;
    height: 20px;
    background: rgba(255, 255, 255, 0.5);
    transform: rotate(34deg) translate(-10px, -20px);
    animation: ${searchFx} 1s ${strongEasing} 0s 1;
    filter: blur(1px);
`;
dt(search_icon_default)`
    z-index: 1;
    display: flex;
    width: 50%;
    height: 50%;
`;
dt.div`
    display: flex;
    background: white;
    align-items: center;
    border-radius: 4px;
    height: var(${CssVars.searchbarHeight});
    background: var(${CssVars.bgColor2});
`;
dt.input`
    background: inherit;
    box-sizing: border-box;
    border: 0;
    appearance: none;
    font-weight: normal;
    font-family: interface, Helvetica Neue, helvetica, sans-serif;
    outline: 0;
    font-size: 15px;
    padding: 0 10px;
    border-radius: 0;
    text-overflow: ellipsis;
    color: var(${CssVars.fgColor});
    &::placeholder {
        color: ${giphyLightGrey};
    }
    min-width: 150px;
    flex: 1;
    ${(props) => props.$isUsernameSearch && lt`
            color: ${giphyIndigo};
        `}
`;
var TrendingIcon = ({ size = 18, className }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 18 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    className
  },
  /* @__PURE__ */ React.createElement("g", { id: "trending", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
    "rect",
    {
      id: "Rectangle",
      stroke: "#979797",
      fill: "#D8D8D8",
      opacity: "0",
      x: "0.5",
      y: "0.5",
      width: "17",
      height: "17"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.6093329,3.12057664 L15.156896,3.12057664 L9.64199318,9.04253019 L6.88133868,6.8175119 C6.7544587,6.67603813 6.56616874,6.60087259 6.38404017,6.61897279 C6.2490402,6.63288422 6.11891631,6.69661171 6.02063992,6.79697337 C2.21226835,10.5943119 0.308082561,12.4929812 0.308082561,12.4929812 C0.308082561,12.4929812 0.527106106,12.8074292 0.710953088,13.0215425 C0.833517743,13.1642848 0.975497751,13.3098497 1.13689311,13.4582373 L6.47329888,8.13191205 L9.16381134,10.2953038 C9.40800276,10.5710787 9.68933701,10.7021044 10.019278,10.4570223 L16.0239805,4.04474473 C16.0239805,5.87956383 16.0239805,6.79697337 16.0239805,6.79697337 C16.0239805,6.79697337 16.4320205,6.79697337 17.2481004,6.79697337 L17.2481004,1.80604505 C14.1555887,1.80604505 12.6093329,1.80604505 12.6093329,1.80604505 C12.6093329,1.80604505 12.6093329,2.24422225 12.6093329,3.12057664 Z",
      id: "Shape",
      stroke: "#00CCFF",
      strokeWidth: "0.4",
      fill: "#00CCFF",
      fillRule: "nonzero",
      transform: "translate(8.778091, 7.632141) rotate(-2.000000) translate(-8.778091, -7.632141) "
    }
  )))
);
var trending_icon_default = TrendingIcon;

// src/components/search-bar/suggestion-bar/pills.tsx
var margin = 9;
dt.div`
    background: ${giphyDarkestGrey};
    display: flex;
    padding-right: 4px;
    align-items: center;
    margin-right: ${margin}px;
    cursor: pointer;
`;
dt.div`
    background: ${giphyDarkestGrey};
    display: flex;
    padding: 14px;
    align-items: center;
    margin-right: ${margin}px;
    white-space: nowrap;
    cursor: pointer;
    font-style: italic;
    border-radius: 20px;
`;
dt(avatar_default)`
    height: var(${CssVars.searchbarHeight});
    width: var(${CssVars.searchbarHeight});
`;
dt(trending_icon_default)`
    margin-right: 2px;
`;

// src/components/search-bar/suggestion-bar/index.tsx
dt.div`
    display: flex;
    color: white;
    flex-direction: row;
    font-family: 'interface';
    font-weight: 600;
    font-size: 14px;
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 10px;
    height: var(${CssVars.searchbarHeight});
`;
var GIPHYClips = ({ onClick }) => /* @__PURE__ */ React.createElement("svg", { width: "66px", height: "13px", viewBox: "0 0 66 13", onClick }, /* @__PURE__ */ React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(-1060.000000, -462.000000)", fill: "#FFFFFF", fillRule: "nonzero" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(931.000000, 286.375671)" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(86.000000, 136.124329)" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M47.968,49.1962322 C49.588,49.1962322 51.052,48.6202322 51.58,47.5522322 L51.58,43.8202322 L47.476,43.8202322 L47.476,45.6802322 L49.6,45.6802322 L49.6,46.7602322 C49.12,47.1082322 48.424,47.1922322 47.98,47.1922322 C46.288,47.1922322 45.724,45.8602322 45.724,44.7802322 C45.724,43.1362322 46.612,42.3202322 47.98,42.3202322 C48.544,42.3202322 49.288,42.4762322 49.9,43.0522322 L51.28,41.6842322 C50.176,40.5682322 49.144,40.3282322 47.98,40.3282322 C44.824,40.3282322 43.384,42.5842322 43.384,44.7802322 C43.384,46.9762322 44.644,49.1962322 47.968,49.1962322 Z M54.928,48.9682322 L54.928,40.5682322 L52.564,40.5682322 L52.564,48.9682322 L54.928,48.9682322 Z M58.648,48.9682322 L58.648,46.7002322 L60.352,46.7002322 C62.596,46.6762322 63.724,45.3442322 63.724,43.6282322 C63.724,41.9842322 62.608,40.5682322 60.352,40.5682322 L56.272,40.5682322 L56.272,48.9682322 L58.648,48.9682322 Z M60.352,44.6962322 L58.648,44.6962322 L58.648,42.6082322 L60.352,42.6082322 C61,42.6082322 61.348,43.1122322 61.348,43.6642322 C61.348,44.2162322 61.012,44.6962322 60.352,44.6962322 Z M66.796,48.9802322 L66.796,45.8002322 L69.82,45.8002322 L69.82,48.9802322 L72.172,48.9802322 L72.172,40.5802322 L69.82,40.5802322 L69.82,43.7722322 L66.796,43.7722322 L66.796,40.5802322 L64.42,40.5802322 L64.42,48.9802322 L66.796,48.9802322 Z M78.16,48.9682322 L78.16,45.6202322 L81.496,40.6762322 L81.496,40.5682322 L78.82,40.5682322 L77.008,43.4482322 L75.268,40.5682322 L72.592,40.5682322 L72.592,40.6642322 L75.784,45.6202322 L75.784,48.9682322 L78.16,48.9682322 Z M87.796,49.1362322 C88.972,49.1362322 90.088,48.7402322 90.952,47.8882322 L90.028,46.9642322 C89.44,47.5522322 88.576,47.8762322 87.796,47.8762322 C85.624,47.8762322 84.712,46.3522322 84.7,44.8162322 C84.688,43.2682322 85.66,41.6962322 87.796,41.6962322 C88.576,41.6962322 89.368,41.9722322 89.968,42.5602322 L90.868,41.6962322 C90.016,40.8442322 88.924,40.4242322 87.796,40.4242322 C84.796,40.4242322 83.356,42.6202322 83.3679256,44.8282322 C83.38,47.0362322 84.748,49.1362322 87.796,49.1362322 Z M93.028,48.9682322 L93.028,40.5802322 L91.792,40.5802322 L91.792,48.9682322 L93.028,48.9682322 Z M94.252,41.3122322 C94.252,42.3322322 95.788,42.3322322 95.788,41.3122322 C95.788,40.3042322 94.252,40.3042322 94.252,41.3122322 Z M95.632,48.9682322 L95.632,43.0282322 L94.396,43.0282322 L94.396,48.9682322 L95.632,48.9682322 Z M98.188,51.7162322 L98.188,48.1042322 C98.632,48.8362322 99.556,49.1002322 100.276,49.1002322 C102.112,49.1002322 103.264,47.8042322 103.264,46.0162322 C103.264,44.2282322 102.04,42.9442322 100.276,42.9322322 C99.484,42.9322322 98.644,43.2922322 98.188,44.0122322 L98.116,43.0522322 L96.952,43.0522322 L96.952,51.7162322 L98.188,51.7162322 Z M100.156,47.9002322 C99.076,47.9002322 98.296,47.0722322 98.296,46.0162322 C98.296,44.9602322 99.016,44.1322322 100.156,44.1322322 C101.284,44.1322322 102.028,44.9002322 102.028,46.0162322 C102.028,47.1202322 101.236,47.9002322 100.156,47.9002322 Z M106.456,49.1482322 C107.992,49.1482322 108.964,48.3802322 108.976,47.2762322 C108.988,45.7522322 107.56,45.5122322 106.468,45.4162322 C105.712,45.3442322 105.196,45.1522322 105.184,44.6602322 C105.184,44.1922322 105.688,43.9402322 106.444,43.9522322 C107.032,43.9522322 107.536,44.0722322 108.004,44.5042322 L108.7,43.6882322 C108.04,43.1002322 107.332,42.8962322 106.42,42.8962322 C105.316,42.8962322 103.96,43.3882322 103.96,44.6962322 C103.972,46.0042322 105.256,46.3642322 106.372,46.4722322 C107.248,46.5562322 107.752,46.7602322 107.74,47.2882322 C107.728,47.8402322 107.068,48.0562322 106.48,48.0562322 C105.784,48.0442322 104.956,47.7922322 104.404,47.1802322 L103.756,48.0562322 C104.536,48.9322322 105.496,49.1482322 106.456,49.1482322 Z",
    id: "GIPHYClips"
  }
))))));
var clips_branding_default = GIPHYClips;

// src/components/video/attribution.tsx
var Container11 = dt.div`
    display: flex;
    align-items: center;
    font-family: interface, helvetica, arial;
    cursor: pointer;
`;
var Avatar5 = dt(avatar_default)`
    flex-shrink: 0;
`;
var Right = dt.div`
    display: flex;
    flex-direction: column;
`;
var Attribution3 = ({ gif, className, onClick }) => {
  const { user } = gif;
  if (!(user == null ? void 0 : user.username) && !(user == null ? void 0 : user.display_name)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    Container11,
    {
      className: [Attribution3.className, className].join(" "),
      onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) {
          onClick(gif);
        } else {
          const url = user.profile_url;
          if (url)
            window.open(url, "_blank");
        }
      }
    },
    /* @__PURE__ */ React.createElement(Avatar5, { user }),
    /* @__PURE__ */ React.createElement(Right, null, /* @__PURE__ */ React.createElement(
      clips_branding_default,
      {
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (onClick) {
            onClick(gif);
          } else if (gif.url) {
            window.open(gif.url, "_blank");
          }
        }
      }
    ), /* @__PURE__ */ React.createElement(user_default, { user }))
  );
};
Attribution3.className = "giphy-attribution";
var attribution_default2 = Attribution3;
var VolumeSize = 25;
var VolumeOnIcon = ({ size = VolumeSize, onClick = () => {
} }) => /* @__PURE__ */ React.createElement("svg", { width: size, height: size, viewBox: "0 0 26 23", onClick }, /* @__PURE__ */ React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(1.000000, 0.000000)", fill: "#FFF", fillRule: "nonzero" }, /* @__PURE__ */ React.createElement("path", { d: "M11.9625091,0.572584405 L11.9625091,22.2272644 C11.9625091,22.4856644 11.8466091,22.6635044 11.6151891,22.7611644 C11.3480491,22.8413444 11.1390491,22.7968844 10.9878091,22.6277844 L4.8732291,15.9143244 L0.573909096,15.9143244 C0.413549096,15.9143244 0.277509096,15.8588444 0.166549096,15.7475044 C0.0573082348,15.6406091 -0.00292164572,15.4933347 -1.77635684e-15,15.3405244 L-1.77635684e-15,7.45058441 C-1.77635684e-15,7.29022441 0.0555890961,7.15456441 0.167309096,7.04322441 C0.278269096,6.93226441 0.414309096,6.87640441 0.573909096,6.87640441 L4.8732291,6.87640441 L10.9874291,0.172064405 C11.1390491,0.00296440549 11.3484291,-0.0414955945 11.6151891,0.0386844055 C11.8466091,0.136344405 11.9621291,0.314564405 11.9621291,0.572584405 L11.9625091,0.572584405 Z" }), /* @__PURE__ */ React.createElement("path", { d: "M15.7579491,16.0914044 L14.6798891,13.6594044 C15.5739159,13.2635547 16.1503537,12.3776671 16.1501091,11.3999244 C16.150386,10.4242626 15.5763999,9.53983269 14.6852091,9.14272441 L15.7697291,6.71376441 C17.6193585,7.53872062 18.810518,9.37466359 18.8101092,11.3999244 C18.8105521,13.4298903 17.6139475,15.2691931 15.7579491,16.0914044 L15.7579491,16.0914044 Z" }), /* @__PURE__ */ React.createElement("path", { d: "M18.3647491,20.2619044 L17.2863091,17.8299044 C19.8302925,16.7031661 21.4705725,14.1822599 21.4701091,11.3999244 C21.4701091,8.59818441 19.8167291,6.09892441 17.3022691,4.97678441 L18.3864091,2.54782441 C21.8804724,4.10607079 24.1307363,7.57414217 24.1301093,11.3999244 C24.1308375,15.2343934 21.8705556,18.7086904 18.3647491,20.2619044 Z" }))));
var VolumeOffIcon = ({ size = VolumeSize, onClick = () => {
} }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    onClick,
    height: size,
    width: size,
    viewBox: "0 0 26 23",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { id: "Group", transform: "translate(1.000000, 0.000000)", fill: "#FFFFFF", fillRule: "nonzero" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.9625091,0.572584405 L11.9625091,22.2272644 C11.9625091,22.4856644 11.8466091,22.6635044 11.6151891,22.7611644 C11.3480491,22.8413444 11.1390491,22.7968844 10.9878091,22.6277844 L4.8732291,15.9143244 L0.573909096,15.9143244 C0.413549096,15.9143244 0.277509096,15.8588444 0.166549096,15.7475044 C0.0573082348,15.6406091 -0.00292164572,15.4933347 0,15.3405244 L0,7.45058441 C0,7.29022441 0.0555890961,7.15456441 0.167309096,7.04322441 C0.278269096,6.93226441 0.414309096,6.87640441 0.573909096,6.87640441 L4.8732291,6.87640441 L10.9874291,0.172064405 C11.1390491,0.00296440549 11.3484291,-0.0414955945 11.6151891,0.0386844055 C11.8466091,0.136344405 11.9621291,0.314564405 11.9621291,0.572584405 L11.9625091,0.572584405 Z",
      id: "Path"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Group", transform: "translate(14.887009, 6.947630)", fill: "#FFFFFF", fillRule: "nonzero" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.88199149,6.27905236 C7.94693088,6.35707599 7.94693088,6.47033309 7.88199149,6.54835671 L6.54835671,7.88199149 C6.47033309,7.94693088 6.35707599,7.94693088 6.27905236,7.88199149 L3.96534802,5.56828715 L1.65164367,7.88199149 C1.57362004,7.94693088 1.46036294,7.94693088 1.38233932,7.88199149 L0.0487045381,6.54835671 C-0.016234846,6.47033309 -0.016234846,6.35707599 0.0487045381,6.27905236 L2.36240889,3.96534802 L0.0487045381,1.65164367 C-0.016234846,1.57362004 -0.016234846,1.46036294 0.0487045381,1.38233932 L1.38233932,0.0487045381 C1.46036294,-0.016234846 1.57362004,-0.016234846 1.65164367,0.0487045381 L3.96534802,2.36240889 L6.27905236,0.0487045381 C6.35707599,-0.016234846 6.47033309,-0.016234846 6.54835671,0.0487045381 L7.88199149,1.38233932 C7.94693088,1.46036294 7.94693088,1.57362004 7.88199149,1.65164367 L5.56828715,3.96534802 L7.88199149,6.27905236 Z",
      id: "Shape"
    }
  )))
);
var Bar = dt.div`
    background: ${giphyWhite};
    height: ${(props) => props.$barHeight}px;
    position: absolute;
    width: 5px;
    bottom: 0;
    left: 0;
    opacity: 0.95;
`;
var ProgressBar = ({ videoEl }) => {
  _default(2147483647, 100);
  const time2 = (videoEl == null ? void 0 : videoEl.currentTime) || 0;
  const duration = (videoEl == null ? void 0 : videoEl.duration) || 0;
  const val = time2 / duration;
  let percentage = Math.round(val * 100);
  let barHeight = 5;
  if ((videoEl == null ? void 0 : videoEl.height) < 200) {
    barHeight = 3;
  } else if ((videoEl == null ? void 0 : videoEl.height) < 300) {
    barHeight = 4;
  }
  percentage = duration < 10 && percentage > 98 ? 100 : percentage;
  return /* @__PURE__ */ React.createElement(Bar, { style: { width: `${percentage}%` }, $barHeight: barHeight, className: "hide-in-percy" });
};
var progress_bar_default = ProgressBar;

// src/components/video/util.ts
var getErrorMessage = (code, src = "") => {
  switch (code) {
    case 1:
      return "Aborted. The fetching process for the media resource was aborted by the user agent at the user's request.";
    case 2:
      return "Network Error. A network error of some description caused the user agent to stop fetching the media resource, after the resource was established to be usable.";
    case 3:
      return "Decode Error. An error of some description occurred while decoding the media resource, after the resource was established to be usable.";
    case 4:
      return `Can not play a video of type "${src.split(".").pop()}" on this platform.`;
    default:
      return "";
  }
};
var shouldFireQuartile = (quartile, playhead, duration, quartilesFired, loopNumber) => {
  const currentQuartile = loopNumber + quartile;
  if (!quartilesFired.has(currentQuartile) && duration > 0 && playhead > duration * quartile) {
    quartilesFired.add(currentQuartile);
    return true;
  }
  return false;
};

// src/components/video/video.tsx
var quartileEvents = [0.25, 0.5, 0.75];
var videoClassName = "giphy-video";
var Network = {
  // The element has not yet been initialized. All attributes are in their initial states.
  EMPTY: 0,
  // The element's resource selection algorithm is active and has selected a resource, but it is not actually using the network at this time.
  IDLE: 1,
  // The user agent is actively trying to download data.
  LOADING: 2,
  // The element's resource selection algorithm is active, but it has not yet found a resource to use.
  NO_SOURCE: 3
};
var Video = ({
  muted,
  ccEnabled = false,
  ccLanguage = "en",
  loop = true,
  onStateChange,
  onTimeUpdate,
  onCanPlay,
  onFirstPlay,
  onWaiting,
  onMuted,
  onError,
  onEnded,
  onLoop,
  onQuartile,
  onEndFullscreen,
  setVideoEl,
  gif,
  width,
  percentWidth,
  height: height_,
  volume = 0.7,
  className = videoClassName,
  isInPlayer
}) => {
  var _a, _b, _c;
  const height = height_ || getGifHeight(gif, width);
  let percentHeight;
  if (percentWidth) {
    const ratio = Math.round(height / width * 100);
    percentHeight = `${ratio}%`;
  }
  const [media, setMedia] = useState(getBestVideo(gif.video, width, height));
  const seek = useRef(0);
  if (!media) {
    console.warn(`GiphyJS No video content for id: ${gif.id}`);
  }
  const mountTime = useRef(Date.now());
  const hasPlayingFired = useRef(false);
  const loopNumber = useRef(0);
  const waitingCount = useRef(0);
  const quartilesFired = useRef(/* @__PURE__ */ new Set());
  useEffect(() => {
    mountTime.current = Date.now();
    hasPlayingFired.current = false;
    loopNumber.current = 1;
    waitingCount.current = 0;
    quartilesFired.current = /* @__PURE__ */ new Set();
  }, [gif.id]);
  const videoEl = useRef(null);
  useEffect(() => {
    const newMedia = getBestVideo(gif.video, width, height);
    if (videoEl.current && (media == null ? void 0 : media.url) && newMedia.url !== media.url) {
      if (media.url.indexOf(String(gif.id)) !== -1) {
        seek.current = videoEl.current.currentTime;
      }
      setMedia(newMedia);
    }
  }, [width, height_, gif.video, height, media == null ? void 0 : media.url, gif.id]);
  useEffect(() => {
    if (videoEl.current && (media == null ? void 0 : media.url) && seek.current) {
      videoEl.current.currentTime = seek.current;
      seek.current = 0;
    }
  }, [media == null ? void 0 : media.url, seek]);
  const _onError = useCallback(() => {
    var _a2;
    const el = videoEl.current;
    const code = (_a2 = el == null ? void 0 : el.error) == null ? void 0 : _a2.code;
    if (code && (el == null ? void 0 : el.src)) {
      const message = getErrorMessage(code, el == null ? void 0 : el.src);
      console.error(message);
      onError == null ? void 0 : onError(code);
    }
  }, [onError]);
  const _onPlaying = useCallback(() => {
    onStateChange == null ? void 0 : onStateChange("playing");
    if (!hasPlayingFired.current) {
      hasPlayingFired.current = true;
      if (gif.analytics_response_payload) {
        pingback_default({ actionType: "START", analyticsResponsePayload: gif.analytics_response_payload });
      }
      onFirstPlay == null ? void 0 : onFirstPlay(Date.now() - mountTime.current);
    }
  }, [onFirstPlay, onStateChange, gif]);
  const _onPaused = useCallback(() => onStateChange == null ? void 0 : onStateChange("paused"), [onStateChange]);
  const _onTimeUpdate = useCallback(() => {
    const el = videoEl.current;
    if (el) {
      const playhead = el.currentTime;
      quartileEvents.some((q) => {
        if (shouldFireQuartile(q, playhead, el.duration, quartilesFired.current, loopNumber.current)) {
          onQuartile == null ? void 0 : onQuartile(q);
          return true;
        }
        return false;
      });
      onTimeUpdate == null ? void 0 : onTimeUpdate(playhead || 0);
    }
  }, [onQuartile, onTimeUpdate]);
  const _onCanPlay = useCallback(() => onCanPlay == null ? void 0 : onCanPlay(), [onCanPlay]);
  const _onWaiting = useCallback(() => {
    const el = videoEl.current;
    if ((el == null ? void 0 : el.currentTime) !== 0 && (el == null ? void 0 : el.networkState) !== Network.IDLE) {
      onWaiting == null ? void 0 : onWaiting(++waitingCount.current);
    }
  }, [onWaiting]);
  const _onEnded = useCallback(() => {
    if (loop && videoEl.current) {
      videoEl.current.play();
    }
    onLoop == null ? void 0 : onLoop(loopNumber.current);
    loopNumber.current = loopNumber.current + 1;
    if (!hasPlayingFired.current) {
      return;
    }
    onEnded == null ? void 0 : onEnded();
  }, [onEnded, loop, onLoop]);
  const _onEndFullscreen = useCallback(() => onEndFullscreen == null ? void 0 : onEndFullscreen(), [onEndFullscreen]);
  const tryAutoPlayWithSound = useCallback(
    (videoEl2) => __async(void 0, null, function* () {
      if (videoEl2) {
        const promisePlay = videoEl2.play();
        if (promisePlay !== void 0) {
          try {
            yield promisePlay;
            onMuted == null ? void 0 : onMuted(false);
          } catch (error) {
            videoEl2.muted = true;
            onMuted == null ? void 0 : onMuted(true);
            videoEl2.play();
          }
        }
      }
    }),
    [onMuted]
  );
  useEffect(() => {
    const el = videoEl.current;
    if (el) {
      tryAutoPlayWithSound(el);
      setVideoEl == null ? void 0 : setVideoEl(el);
      if (!isNaN(volume)) {
        el.volume = volume;
      }
    }
  }, []);
  useEffect(() => {
    const el = videoEl.current;
    if (el) {
      el.addEventListener("play", _onPlaying);
      el.addEventListener("pause", _onPaused);
      el.addEventListener("error", _onError);
      el.addEventListener("timeupdate", _onTimeUpdate);
      el.addEventListener("canplay", _onCanPlay);
      el.addEventListener("ended", _onEnded);
      el.addEventListener("waiting", _onWaiting);
      el.addEventListener("webkitendfullscreen", _onEndFullscreen);
    }
    return () => {
      if (el) {
        el.removeEventListener("play", _onPlaying);
        el.removeEventListener("pause", _onPaused);
        el.removeEventListener("error", _onError);
        el.removeEventListener("timeupdate", _onTimeUpdate);
        el.removeEventListener("canplay", _onCanPlay);
        el.removeEventListener("ended", _onEnded);
        el.removeEventListener("waiting", _onWaiting);
        el.removeEventListener("webkitendfullscreen", _onEndFullscreen);
      }
    };
  }, [_onPlaying, _onPaused, _onError, _onTimeUpdate, _onCanPlay, _onEnded, _onWaiting, _onEndFullscreen]);
  const captionSrc = (_c = (_b = (_a = gif.video) == null ? void 0 : _a.captions) == null ? void 0 : _b[ccLanguage]) == null ? void 0 : _c.vtt;
  return (media == null ? void 0 : media.url) ? /* @__PURE__ */ React.createElement(
    "video",
    {
      crossOrigin: "anonymous",
      draggable: true,
      className,
      width: isInPlayer ? "100%" : percentWidth || width,
      height: isInPlayer ? "100%" : percentHeight || height,
      muted,
      autoPlay: true,
      playsInline: true,
      ref: videoEl,
      src: media == null ? void 0 : media.url,
      "data-giphy-id": gif.id
    },
    ccEnabled && captionSrc && /* @__PURE__ */ React.createElement("track", { label: "English", kind: "subtitles", srcLang: ccLanguage, src: captionSrc, default: true })
  ) : null;
};
Video.className = videoClassName;
var video_default = Video;

// src/components/video/index.tsx
var Container12 = dt.div`
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: black;
    font-family: interface, helvetica, arial;
    -webkit-font-smoothing: antialiased;
`;
var Volume = dt.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
`;
var Controls = dt.div`
    position: absolute;
    top: 10px;
    right: 10px;
    left: 10px;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    opacity: ${(props) => props.$isHovered ? 1 : 0};
    transition: opacity ease-out 250ms;
    align-items: flex-start;
`;
var Title = dt.div`
    font-size: 22px;
    color: white;
    margin-bottom: 5px;
    font-weight: bold;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
`;
var TitleContainer = dt.div`
    position: relative;
    min-width: 0;
`;
var Gradient = dt.div`
    &:before {
        background: linear-gradient(rgba(18, 18, 18, 0.6), rgba(0, 0, 0, 0));
        content: '';
        height: ${(props) => props.$isLargePlayer ? 125 : 75}px;
        left: 0;
        pointer-events: none;
        position: absolute;
        top: 0;
        width: 100%;
    }
    &:after {
        background: linear-gradient(rgba(0, 0, 0, 0), rgba(18, 18, 18, 0.6));
        content: '';
        height: ${(props) => props.$isLargePlayer ? 125 : 75}px;
        left: 0;
        pointer-events: none;
        position: absolute;
        bottom: 0;
        width: 100%;
    }
`;
var LARGE_PLAYER_HEIGHT = 300;
var AUTO_HIDE_TIMEOUT = 4e3;
var VideoPlayer = (props) => {
  const {
    style,
    width,
    percentWidth,
    hideMute,
    hideAttribution,
    hideProgressBar,
    hideTitle,
    className,
    persistentControls,
    gif,
    overlay: Overlay
  } = props;
  const [isHovered, setIsHovered] = useState(false);
  const [videoEl, _setVideoEl] = useState(null);
  const [muted, setMuted] = useState(props.muted);
  const [mutedByBrowser, setMutedByBrowser] = useState(false);
  const { setVideoEl, onMuted, onUserMuted } = props;
  const height = props.height || getGifHeight(gif, width);
  let percentHeight;
  if (percentWidth) {
    const ratio = Math.round(height / width * 100);
    percentHeight = `${ratio}%`;
  }
  const [, cancelHideTimeout, resetHideTimeout] = _default$1(() => {
    setIsHovered(false);
  }, AUTO_HIDE_TIMEOUT);
  const combinedOnMuted = useCallback(
    (args) => {
      onMuted == null ? void 0 : onMuted(args);
      setMutedByBrowser(args);
    },
    [setMutedByBrowser, onMuted]
  );
  const combinedSetVideoEl = useCallback(
    (args) => {
      setVideoEl == null ? void 0 : setVideoEl(args);
      _setVideoEl(args);
    },
    [setVideoEl, _setVideoEl]
  );
  const toggleMute = () => {
    if (mutedByBrowser) {
      setMutedByBrowser(false);
      setMuted(false);
    } else {
      setMuted(!muted);
    }
  };
  useEffect(() => {
    setMuted(props.muted);
  }, [props.muted]);
  const showControls = persistentControls || isHovered;
  const isLargePlayer = height >= LARGE_PLAYER_HEIGHT;
  useEffect(() => {
    if (showControls) {
      resetHideTimeout();
    } else {
      cancelHideTimeout();
    }
    return () => cancelHideTimeout();
  }, [showControls, cancelHideTimeout, resetHideTimeout]);
  return /* @__PURE__ */ React.createElement(
    Container12,
    {
      className,
      style: __spreadValues({ width: percentWidth || width, height: percentHeight || height }, style),
      onMouseOver: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      onMouseMove: () => {
        setIsHovered(true);
        resetHideTimeout();
      },
      onClick: (e) => {
        onUserMuted == null ? void 0 : onUserMuted(!(muted || mutedByBrowser));
        videoEl == null ? void 0 : videoEl.play();
        e.preventDefault();
        toggleMute();
      }
    },
    /* @__PURE__ */ React.createElement(video_default, __spreadProps(__spreadValues({}, props), { isInPlayer: true, onMuted: combinedOnMuted, setVideoEl: combinedSetVideoEl, muted })),
    showControls && /* @__PURE__ */ React.createElement(Gradient, { $isLargePlayer: isLargePlayer }),
    /* @__PURE__ */ React.createElement(Controls, { $isHovered: showControls }, /* @__PURE__ */ React.createElement(TitleContainer, null, !hideTitle && isLargePlayer && /* @__PURE__ */ React.createElement(
      Title,
      {
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          window.open(gif.url, "_blank");
        }
      },
      gif.title
    ), videoEl && !hideAttribution ? /* @__PURE__ */ React.createElement(attribution_default2, { gif }) : null), !hideMute && /* @__PURE__ */ React.createElement(Volume, null, muted || mutedByBrowser ? /* @__PURE__ */ React.createElement(VolumeOffIcon, null) : /* @__PURE__ */ React.createElement(VolumeOnIcon, null))),
    showControls && !hideProgressBar && videoEl ? /* @__PURE__ */ React.createElement(progress_bar_default, { videoEl }) : null,
    Overlay && /* @__PURE__ */ React.createElement(Overlay, { gif, isHovered, width, height })
  );
};
var VideoWrapper = (props) => {
  if (props.overlay && !props.controls) {
    console.warn(`${Logger.PREFIX}: Overlays only work when controls are enabled`);
  }
  return props.controls ? /* @__PURE__ */ React.createElement(VideoPlayer, __spreadValues({}, props)) : /* @__PURE__ */ React.createElement(video_default, __spreadValues({}, props));
};
var video_default2 = VideoWrapper;
dt.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
`;
dt(video_default2)`
    height: 100%;
    display: inline-block;
    object-fit: fill;
    pointer-events: none;
    background: rgb(0, 0, 0, 0);
`;
dt.div`
    position: absolute;
    top: 6px;
    right: 6px;
    cursor: pointer;
    opacity: ${(props) => props.$isHovered ? 1 : 0.8};
    transition: opacity ease-out 800ms;
`;

// src/index.ts
appendGiphySDKRequestHeader(`X-GIPHY-SDK-NAME`, "ReactSDK");

var API_KEY = '2fqf7HK0sD0FAUXWGmdAz5uGSbnNlF0c';
var giphyFetch = new api_default(API_KEY);
var GiphyGrid = function (_a) {
    var giphyContainerRef = _a.giphyContainerRef, addGiphy = _a.addGiphy, t = _a.t;
    var _b = __read(useState(''), 2), searchTerm = _b[0], setSearchTerm = _b[1];
    var SearchForGifs = TranslationKeys.SearchForGifs; TranslationKeys.Loading; var NoMatchesFound = TranslationKeys.NoMatchesFound; TranslationKeys.SomethingWentWrong;
    var fetchGifs = useCallback(function (offset) {
        if (searchTerm.trim()) {
            return giphyFetch.search(searchTerm, { offset: offset, limit: 15 });
        }
        return giphyFetch.trending({ offset: offset, limit: 15 });
    }, [searchTerm]);
    var handleInputChange = function (e) {
        setSearchTerm(e.target.value);
    };
    return (React.createElement("div", { className: 'giphy-chat-wraaper', ref: giphyContainerRef },
        React.createElement("input", { type: 'text', placeholder: t(SearchForGifs), value: searchTerm, onChange: handleInputChange }),
        React.createElement(grid_default, { key: searchTerm, fetchGifs: fetchGifs, width: 300, columns: 1, gutter: 6, onGifClick: addGiphy, noLink: true, noResultsMessage: t(NoMatchesFound) })));
};

var ChatPopovers = function (_a) {
    var t = _a.t, addEmoji = _a.addEmoji, addGiphy = _a.addGiphy, sendMessage = _a.sendMessage, selectEmoji = _a.selectEmoji, giphyOpened = _a.giphyOpened, emojiPickerOpened = _a.emojiPickerOpened, emojiContainerRef = _a.emojiContainerRef, giphyContainerRef = _a.giphyContainerRef, isTypingNotAllowed = _a.isTypingNotAllowed, setEmojiPickerOpened = _a.setEmojiPickerOpened, iconsPerLine = _a.iconsPerLine, emojiSize = _a.emojiSize;
    return (React.createElement(React.Fragment, null,
        emojiPickerOpened && (!isMobile() || (isMobile() && isTypingNotAllowed)) && (React.createElement(ChatEmoji, { t: t, addEmoji: addEmoji, sendMessage: sendMessage, selectEmoji: selectEmoji, emojiContainerRef: emojiContainerRef, isTypingNotAllowed: isTypingNotAllowed, setEmojiPickerOpened: setEmojiPickerOpened, iconsPerLine: iconsPerLine, emojiSize: emojiSize })),
        giphyOpened && React.createElement(GiphyGrid, { giphyContainerRef: giphyContainerRef, addGiphy: addGiphy, t: t })));
};

var CHAT_MESSAGE_MAX_LENGTH = 200;
var KEYBOARD_EVENT_CODES = {
    ENTER: 13,
    ESC: 27,
};
var Chat = observer(function (_a) {
    var children = _a.children, iconsPerLine = _a.iconsPerLine, emojiSize = _a.emojiSize;
    var t = useTranslation();
    var _b = __read(useState(false), 2), isOpenChat = _b[0], setIsOpenChat = _b[1];
    var _c = __read(useState(false), 2), isExpanded = _c[0], setIsExpanded = _c[1];
    var _d = __read(useState(''), 2), message = _d[0], setMessage = _d[1];
    var _e = __read(useState(false), 2), emojiPickerOpened = _e[0], setEmojiPickerOpened = _e[1];
    var _f = __read(useState(false), 2), giphyOpened = _f[0], setGiphyOpened = _f[1];
    var quickWords = chatStore.quickWords, unReadCount = chatStore.unReadCount, chatMessageData = chatStore.chatMessageData, updateUnReadCount = chatStore.updateUnReadCount, isTypingNotAllowed = chatStore.isTypingNotAllowed, isMessagesReceived = chatStore.isMessagesReceived, isQuickWordsScrolling = chatStore.isQuickWordsScrolling;
    var avatarId = profileAvatarStore.avatarId;
    var userId = userInfoStore.userId;
    var _g = __read(useClickOutside(), 2), emojiButtonRef = _g[0], hasEmojiButtonClickedOutside = _g[1];
    var _h = __read(useClickOutside(), 2), emojiContainerRef = _h[0], hasEmojiContainerClickedOutside = _h[1];
    var _j = __read(useClickOutside(), 2), giphyButtonRef = _j[0], hasGiphyButtonClickedOutside = _j[1];
    var _k = __read(useClickOutside(), 2), giphyContainerRef = _k[0], hasGiphyContainerClickedOutside = _k[1];
    useEffect(function () {
        hasEmojiButtonClickedOutside && hasEmojiContainerClickedOutside && setEmojiPickerOpened(false);
    }, [hasEmojiButtonClickedOutside, hasEmojiContainerClickedOutside]);
    useEffect(function () {
        hasGiphyContainerClickedOutside && hasGiphyButtonClickedOutside && setGiphyOpened(false);
    }, [hasGiphyContainerClickedOutside, hasGiphyButtonClickedOutside]);
    useEffect(function () {
        if (isOpenChat) {
            updateUnReadCount(0);
        }
    }, [isOpenChat, chatMessageData.length]);
    var selectEmoji = function (e) {
        var sym = e.unified.split('-');
        var codesArray = [];
        sym.forEach(function (el) { return codesArray.push("0x".concat(el)); });
        return String.fromCodePoint.apply(String, __spreadArray([], __read(codesArray), false));
    };
    var addEmoji = function (e) {
        var emojiPic = selectEmoji(e);
        setMessage(message + emojiPic);
    };
    var sendMessage = function (message, type) {
        var gameTypeId = gameConfigStore.gameTypeId;
        !isQuickWordsScrolling &&
            chatService.sendMessage({
                gameTypeId: gameTypeId,
                content: message === null || message === void 0 ? void 0 : message.trim(),
                type: type,
                additionalData: avatarId,
            });
    };
    var handleMessageSend = function () {
        var _a;
        if (((_a = message.trim()) === null || _a === void 0 ? void 0 : _a.length) !== 0) {
            sendMessage(message, MessageTypes.TextOrEmoji);
            setMessage('');
        }
    };
    var addGiphy = function (entry) {
        if (entry !== undefined && entry !== '') {
            sendMessage("https://media.giphy.com/media/".concat(entry.id, "/giphy.gif"), MessageTypes.Gif);
            setMessage('');
            setGiphyOpened(false);
        }
    };
    var handleMessageSendOnEnter = function (event) {
        var _a;
        if (((_a = message.trim()) === null || _a === void 0 ? void 0 : _a.length) &&
            event.which === KEYBOARD_EVENT_CODES.ENTER &&
            event.target.value.length < CHAT_MESSAGE_MAX_LENGTH) {
            handleMessageSend();
        }
    };
    var handleCloseChatOnEsc = function (event) {
        if (event.which === KEYBOARD_EVENT_CODES.ESC) {
            setEmojiPickerOpened(false);
            setGiphyOpened(false);
        }
    };
    var handleMessageTyping = function (e) {
        if (e.target.value.length < CHAT_MESSAGE_MAX_LENGTH) {
            setMessage(e.target.value);
        }
    };
    return (React.createElement(React.Fragment, null, children ? (React.cloneElement(children, {
        userId: userId,
        message: message,
        addEmoji: addEmoji,
        avatarId: avatarId,
        addGiphy: addGiphy,
        isOpenChat: isOpenChat,
        isExpanded: isExpanded,
        setMessage: setMessage,
        quickWords: quickWords,
        sendMessage: sendMessage,
        giphyOpened: giphyOpened,
        unReadCount: unReadCount,
        selectEmoji: selectEmoji,
        setIsExpanded: setIsExpanded,
        setIsOpenChat: setIsOpenChat,
        setGiphyOpened: setGiphyOpened,
        chatMessageData: chatMessageData,
        emojiButtonRef: emojiButtonRef,
        giphyButtonRef: giphyButtonRef,
        emojiPickerOpened: emojiPickerOpened,
        handleMessageSend: handleMessageSend,
        giphyContainerRef: giphyContainerRef,
        emojiContainerRef: emojiContainerRef,
        isTypingNotAllowed: isTypingNotAllowed,
        isMessagesReceived: isMessagesReceived,
        handleMessageTyping: handleMessageTyping,
        handleCloseChatOnEsc: handleCloseChatOnEsc,
        setEmojiPickerOpened: setEmojiPickerOpened,
        isQuickWordsScrolling: isQuickWordsScrolling,
        handleMessageSendOnEnter: handleMessageSendOnEnter,
    })) : (React.createElement("div", { className: 'column-chat-holder' },
        React.createElement("div", { className: 'column-chat-holder-inside' },
            React.createElement("div", { className: "chat ".concat(isOpenChat ? 'open' : '', " ").concat(isOpenChat && isExpanded ? 'expanded' : '') },
                React.createElement("div", { className: 'chat-inside' },
                    React.createElement(ChatHeader, { t: t, isOpen: isOpenChat, onClick: function () { return setIsOpenChat(function (prevState) { return !prevState; }); }, isExpanded: isExpanded, unReadCount: unReadCount, setIsExpanded: setIsExpanded }),
                    React.createElement("div", { className: 'chat-bottom' },
                        React.createElement("div", { className: 'chat-holder' },
                            React.createElement("div", { className: "chat-content ".concat(isMessagesReceived ? '' : 'chat-loader') }, isMessagesReceived ? (React.createElement("div", { className: 'chat-content-inside' },
                                React.createElement(QuickMessages, { isMobile: isMobile(), giphyOpened: giphyOpened, sendMessage: sendMessage, emojiButtonRef: emojiButtonRef, giphyButtonRef: giphyButtonRef, setGiphyOpened: setGiphyOpened, emojiPickerOpened: emojiPickerOpened, handleMessageSend: handleMessageSend, quickMessagesList: quickWords, isTypingNotAllowed: isTypingNotAllowed, setEmojiPickerOpened: setEmojiPickerOpened }),
                                (chatMessageData === null || chatMessageData === void 0 ? void 0 : chatMessageData.length) ? (React.createElement(UserMessageList, { messages: chatMessageData, isOpenChat: isOpenChat, giphyOpened: giphyOpened, userId: userId, avatarId: avatarId })) : (React.createElement(React.Fragment, null)))) : (React.createElement(ChatLoader, null))),
                            React.createElement(ChatPopovers, { t: t, addGiphy: addGiphy, addEmoji: addEmoji, emojiPickerOpened: emojiPickerOpened, giphyOpened: giphyOpened, giphyContainerRef: giphyContainerRef, emojiContainerRef: emojiContainerRef, sendMessage: sendMessage, selectEmoji: selectEmoji, isTypingNotAllowed: isTypingNotAllowed, setEmojiPickerOpened: setEmojiPickerOpened, iconsPerLine: iconsPerLine, emojiSize: emojiSize }),
                            React.createElement(ChatFooter, { t: t, message: message, isMobile: isMobile(), giphyOpened: giphyOpened, giphyButtonRef: giphyButtonRef, emojiButtonRef: emojiButtonRef, setGiphyOpened: setGiphyOpened, handleMessageSend: handleMessageSend, emojiPickerOpened: emojiPickerOpened, isTypingNotAllowed: isTypingNotAllowed, handleMessageTyping: handleMessageTyping, setEmojiPickerOpened: setEmojiPickerOpened, handleMessageSendOnEnter: handleMessageSendOnEnter }))))),
            !isMobile() && React.createElement("div", { className: 'chat-imitation' }))))));
});

var ChatWr = observer(function (_a) {
    var children = _a.children, iconsPerLine = _a.iconsPerLine, emojiSize = _a.emojiSize;
    var isDemo = applicationStore.isDemo, isAuthDataReceived = applicationStore.isAuthDataReceived;
    var gameTypeId = gameConfigStore.gameTypeId;
    var isShowChat = chatStore.isShowChat;
    useEffect(function () {
        if (!isMobile() && !isDemo && isAuthDataReceived && gameTypeId) {
            chatService.init();
        }
    }, [isDemo, isAuthDataReceived, gameTypeId]);
    return !isDemo && isShowChat ? (React.createElement(Chat, { iconsPerLine: iconsPerLine, emojiSize: emojiSize }, children)) : (React.createElement(React.Fragment, null));
});

var SortTypesName = ["ui-lib-".concat(IconTypes.AllSort), "ui-lib-".concat(IconTypes.Sort), "ui-lib-".concat(IconTypes.SortDown)];
var Statistics = observer(function (_a) {
    var renderStatisticsItem = _a.renderStatisticsItem, _b = _a.lastRoundValues, lastRoundValues = _b === void 0 ? [100, 200, 500] : _b;
    var t = useTranslation();
    var LastRounds = TranslationKeys.LastRounds;
    var statistics = statisticsStore.statistics, getHttpStatistics = statisticsStore.getHttpStatistics, sortStatisticsDataBySortType = statisticsStore.sortStatisticsDataBySortType;
    var _c = __read(useState(0), 2), statisticsSortType = _c[0], updateStatisticsSortType = _c[1];
    var _d = __read(useState(lastRoundValues[0]), 2), statisticsLastRoundValue = _d[0], updateStatisticsLastRoundValue = _d[1];
    var _e = __read(useState(statistics), 2), sortedStatisticsData = _e[0], setSortedStatisticsData = _e[1];
    useEffect(function () {
        var _a;
        if (!((_a = statistics[statisticsLastRoundValue]) === null || _a === void 0 ? void 0 : _a.length)) {
            getHttpStatistics();
        }
    }, []);
    useEffect(function () {
        setSortedStatisticsData(sortStatisticsDataBySortType(statisticsSortType, statisticsLastRoundValue));
    }, [statisticsSortType, statisticsLastRoundValue, statistics]);
    return (React.createElement(List, { forStatistics: true },
        React.createElement(ListHeaderFilter, null,
            React.createElement(ListFilterHeaderItem, { onClick: function () { return updateStatisticsSortType(function (state) { return ++state % 3; }); } },
                React.createElement("i", { className: "all-statistics ".concat(SortTypesName[statisticsSortType], " ") })),
            lastRoundValues && (React.createElement("div", { className: 'd-f-custom' },
                React.createElement(ListHeaderItem, { title: t(LastRounds) }, t(LastRounds)),
                lastRoundValues.map(function (item) { return (React.createElement(ListFilterHeaderItem, { key: item, isActive: statisticsLastRoundValue === item, onClick: function () { return updateStatisticsLastRoundValue(item); } }, item)); })))),
        React.createElement("div", { className: 'bottom-of-lists-wrapper' },
            React.createElement("div", { className: 'scrollable-container' },
                React.createElement("div", { className: 'statistics-block' }, sortedStatisticsData[statisticsLastRoundValue].map(function (item, index, list) {
                    return renderStatisticsItem(item, index, list, statisticsLastRoundValue);
                }))))));
});

var RightContainerHeader = observer(function (_a) {
    var hasFreeBets = _a.hasFreeBets, _b = _a.hasAvatarsBlock, hasAvatarsBlock = _b === void 0 ? true : _b, demoSwitcherAdditionalFunction = _a.demoSwitcherAdditionalFunction, isNeedShowRulesIcon = _a.isNeedShowRulesIcon, hasCustomSideBar = _a.hasCustomSideBar, hasHalfCashOut = _a.hasHalfCashOut, haveDarkMode = _a.haveDarkMode, hasAnimation = _a.hasAnimation, _c = _a.hasMusicControllerRow, hasMusicControllerRow = _c === void 0 ? true : _c, _d = _a.hasSoundControllerRow, hasSoundControllerRow = _d === void 0 ? true : _d;
    var t = useTranslation();
    var isDemo = applicationStore.isDemo, isTestPlatform = applicationStore.isTestPlatform, demoSwitcher = applicationStore.demoSwitcher;
    var gameThemeConfigs = userSettingsStore.gameThemeConfigs;
    var isRepliedGame = platformMessageStore.isRepliedGame;
    var isShowSideBarButton = gameConfigStore.isShowSideBarButton, sideBarButtonNotificationCount = gameConfigStore.sideBarButtonNotificationCount;
    var _e = parseQuery(window.location.search), _f = DefaultQueryParams.RealModeSwitcher, hasRealModeSwitcher = _e[_f];
    var _g = __read(useState(false), 2), isCollapsibleSettingsListOpened = _g[0], setIsCollapsibleSettingsListOpened = _g[1];
    var handleRulesIconClick = function () {
        platformMessageStore.setIsOpenOddsSection(true);
        popupStore.popupToggle ? popupStore.close() : popupStore.open({});
    };
    return (React.createElement(WebGameColHeaderWr, null,
        React.createElement(ColHeader, null,
            React.createElement(ColHeaderBlock, { isIconBlock: true },
                React.createElement(ColHeaderBlockInner, { isLeft: true },
                    React.createElement(UserBlockImage, { t: t, hasAvatarsBlock: hasAvatarsBlock, winterModeActive: gameThemeConfigs.isEnabled && GameTheme[gameThemeConfigs.themeType] === GameThemeNames.Winter }))),
            React.createElement(ColHeaderBlock, { isNeedSetOpacityClass: isCollapsibleSettingsListOpened },
                React.createElement(UserContent, null,
                    !isRepliedGame && (React.createElement(UserInfo, null,
                        React.createElement(UserId, null),
                        React.createElement(UserBalance, null))),
                    isDemo && !isTestPlatform && !Number(hasRealModeSwitcher) && (React.createElement(PlayForRealButton$1, { text: t(TranslationKeys.PlayForReal), onClick: function () { return demoSwitcher(demoSwitcherAdditionalFunction); } })),
                    hasFreeBets && React.createElement(FreeBetsWrapper, null),
                    isNeedShowRulesIcon && (React.createElement("div", { className: 'rules-in-header', style: { fontSize: '15px' }, onClick: handleRulesIconClick },
                        React.createElement(IconBlock, { iconType: IconTypes.Question }))))),
            hasCustomSideBar && (React.createElement(TopCollapsibleSettingsWrapper, { hasHalfCashOut: hasHalfCashOut, haveDarkMode: haveDarkMode, hasAnimation: hasAnimation, hasMusicControllerRow: hasMusicControllerRow, hasSoundControllerRow: hasSoundControllerRow, isCollapsibleSettingsListOpened: isCollapsibleSettingsListOpened, setIsCollapsibleSettingsListOpened: setIsCollapsibleSettingsListOpened })),
            !hasCustomSideBar && isShowSideBarButton && (React.createElement(ColHeaderBlock, { isIconBlock: true },
                !!sideBarButtonNotificationCount && (React.createElement("span", { className: classNames('side-bar-notifications', sideBarButtonNotificationCount.toString().length >= 2 ? 'small' : '') }, sideBarButtonNotificationCount)),
                React.createElement(ColHeaderBlockInner, { onClick: function () { return iframeService.sendOpenSidebar(); } },
                    React.createElement(IconBlock, { iconType: IconTypes.PlatformSideBar })))))));
});

var rightContainerFooterInitialActiveTabIndex = 0;
var RightContainerFooter = observer(function (_a) {
    var tabs = _a.tabs, onTabChange = _a.onTabChange, tabContainers = _a.tabContainers;
    var _b = __read(useState(rightContainerFooterInitialActiveTabIndex), 2), activeTabIndex = _b[0], setActiveTabIndex = _b[1];
    var gameTypeId = gameConfigStore.gameTypeId;
    var handleTabChange = useOpenBetHistory({ tabs: tabs, onTabChange: onTabChange, setActiveTabIndex: setActiveTabIndex }).handleTabChange;
    var t = useTranslation();
    useEffect(function () {
        handleTabChange(rightContainerFooterInitialActiveTabIndex);
        statisticsStore.resetStatistics();
        statisticsStore.resetHighestOddsData();
    }, [gameTypeId]);
    var InnerComponent = useMemo(function () {
        return (React.createElement(ColBodyInner, null,
            React.createElement(ColBodyInnerTopWr, null,
                React.createElement(Tabs, { activeIndex: activeTabIndex }, tabs.map(function (item, index) { return (React.createElement(TabItem, { onClick: function () { return handleTabChange(index); }, text: t(item.name), key: "".concat(index, "_").concat(item.name) })); }))),
            React.createElement(ColBodyInnerBottomWr, null, tabContainers[activeTabIndex])));
    }, [tabs, activeTabIndex, t]);
    if (isMobile()) {
        return InnerComponent;
    }
    return React.createElement(WebGameColBodyWr, null, InnerComponent);
});

var RightContainer = observer(function (_a) {
    var tabs = _a.tabs, hasChat = _a.hasChat, children = _a.children, hasFreeBets = _a.hasFreeBets, onTabChange = _a.onTabChange, tabContainers = _a.tabContainers, demoSwitcherAdditionalFunction = _a.demoSwitcherAdditionalFunction, hasAvatarsBlock = _a.hasAvatarsBlock, hasSoundControllerRow = _a.hasSoundControllerRow, hasMusicControllerRow = _a.hasMusicControllerRow, hasAnimation = _a.hasAnimation, hasHalfCashOut = _a.hasHalfCashOut, haveDarkMode = _a.haveDarkMode, isNeedShowRulesIcon = _a.isNeedShowRulesIcon, hasCustomSideBar = _a.hasCustomSideBar;
    return isMobile() ? (React.createElement(RightContainerFooter, { tabs: tabs, onTabChange: onTabChange, tabContainers: tabContainers })) : (React.createElement(WebGameColumn, { position: 'right' },
        React.createElement(WebGameColumnInner, { position: 'right' },
            React.createElement(RightContainerHeader, { hasAvatarsBlock: hasAvatarsBlock, isNeedShowRulesIcon: isNeedShowRulesIcon, hasFreeBets: hasFreeBets, demoSwitcherAdditionalFunction: demoSwitcherAdditionalFunction, hasSoundControllerRow: hasSoundControllerRow, hasMusicControllerRow: hasMusicControllerRow, hasAnimation: hasAnimation, hasHalfCashOut: hasHalfCashOut, haveDarkMode: haveDarkMode, hasCustomSideBar: hasCustomSideBar }),
            children && React.createElement(WebGameColMiddleWr, null, children),
            React.createElement(RightContainerFooter, { tabs: tabs, onTabChange: onTabChange, tabContainers: tabContainers }),
            hasChat && React.createElement(ChatWr, null))));
});

var TopAndCurrentWinners = function (_a) {
    var winnersData = _a.winnersData, handleScroll = _a.handleScroll, renderCurrentOrTopWinnerItem = _a.renderCurrentOrTopWinnerItem;
    return (React.createElement(List, null,
        React.createElement(ListBody, { onScroll: handleScroll }, winnersData.map(function (data, index, list) { return renderCurrentOrTopWinnerItem(data, index, list); }))));
};

var CurrentWinnersContainer = observer(function (_a) {
    var renderCurrentOrTopWinnerItem = _a.renderCurrentOrTopWinnerItem;
    var currentWinners = betStore.currentWinners;
    return (React.createElement(TopAndCurrentWinners, { winnersData: currentWinners, renderCurrentOrTopWinnerItem: renderCurrentOrTopWinnerItem }));
});

var TopWinnersContainer = observer(function (_a) {
    var renderCurrentOrTopWinnerItem = _a.renderCurrentOrTopWinnerItem, customTopWinnersParser = _a.customTopWinnersParser, _b = _a.customTopWinnersFetchParams, customTopWinnersFetchParams = _b === void 0 ? {} : _b;
    var data = betStore.topWinners.data, getTopWinners = betStore.getTopWinners, resetTopWinners = betStore.resetTopWinners;
    useEffect(function () {
        getTopWinners(customTopWinnersFetchParams, customTopWinnersParser);
        return function () {
            resetTopWinners();
        };
    }, []);
    var handleScroll = useCallback(function (e) {
        if (checkScrollToBottom(e)) {
            getTopWinners(customTopWinnersFetchParams, customTopWinnersParser);
        }
    }, [customTopWinnersFetchParams, customTopWinnersParser]);
    return (React.createElement(TopAndCurrentWinners, { winnersData: data, renderCurrentOrTopWinnerItem: renderCurrentOrTopWinnerItem, handleScroll: handleScroll }));
});

var LiveBetsContainer = observer(function (_a) {
    var headerNames = _a.headerNames, renderMyLiveBetItem = _a.renderMyLiveBetItem, renderOtherLiveBetItem = _a.renderOtherLiveBetItem, customSortFunctional = _a.customSortFunctional, liveBetsLoader = _a.liveBetsLoader, isFilterDependOnMinAndMaxLimit = _a.isFilterDependOnMinAndMaxLimit;
    var _b = __read(useTransition(), 2); _b[0]; _b[1];
    var bets = betStore.liveBets;
    var isDemo = applicationStore.isDemo;
    var _c = gameConfigStore.limits, minBet = _c.minBet, maxBet = _c.maxBet, maxWin = _c.maxWin;
    var userId = userInfoStore.userId, realCurrencyCode = userInfoStore.realCurrencyCode;
    var _d = useMemo(function () {
        var currentUserBets;
        var otherUserBets;
        if (customSortFunctional) {
            var _a = __read(customSortFunctional(bets), 2), currents = _a[0], others = _a[1];
            currentUserBets = currents;
            otherUserBets = others;
        }
        else {
            otherUserBets = bets.filter(function (_a) {
                var currentUserId = _a.userId;
                return currentUserId !== userId;
            });
            // if (isDemo) {
            //   currentUserBets = bets.filter(({ playerExternalId }) => !playerExternalId);
            // } else {
            currentUserBets = bets.filter(function (_a) {
                var currentUserId = _a.userId;
                return currentUserId === userId;
            });
            // }
            if (isFilterDependOnMinAndMaxLimit) {
                otherUserBets = otherUserBets.map(function (bet) {
                    var exchangedAmount = exchangeAmountByRate(bet).amount;
                    var exchangedWinAmount = (bet === null || bet === void 0 ? void 0 : bet.winAmount) ? exchangeAmountByRate(bet === null || bet === void 0 ? void 0 : bet.winAmount).winAmount : bet === null || bet === void 0 ? void 0 : bet.winAmount;
                    var decidedCurrentAmount = exchangedAmount < minBet ? minBet : exchangedAmount > maxBet ? maxBet : bet === null || bet === void 0 ? void 0 : bet.amount;
                    var decidedCurrentWinAmount = exchangedWinAmount && exchangedAmount < minBet
                        ? toFixed(multiply(minBet, (bet === null || bet === void 0 ? void 0 : bet.odd) || bogLineMinOdd))
                        : exchangedWinAmount && exchangedWinAmount > maxWin
                            ? maxWin
                            : exchangedWinAmount;
                    return __assign(__assign({}, bet), (exchangedAmount < minBet || exchangedAmount > maxBet
                        ? { currencyCode: realCurrencyCode, amount: decidedCurrentAmount, winAmount: decidedCurrentWinAmount }
                        : {}));
                });
            }
            currentUserBets.sort(function (a, b) { return (b === null || b === void 0 ? void 0 : b.amount) - (a === null || a === void 0 ? void 0 : a.amount); });
            otherUserBets.sort(function (a, b) { return (b === null || b === void 0 ? void 0 : b.coinAmount) - (a === null || a === void 0 ? void 0 : a.coinAmount); });
        }
        return { myBets: currentUserBets, otherBets: otherUserBets };
    }, [
        isDemo,
        bets,
        userId,
        realCurrencyCode,
        minBet,
        customSortFunctional,
        maxBet,
        maxWin,
        isFilterDependOnMinAndMaxLimit,
    ]), myBets = _d.myBets, otherBets = _d.otherBets;
    return (React.createElement(List, null,
        React.createElement(ListHeader, null, headerNames.map(function (item, index) { return (React.createElement(ListHeaderItem, { key: "".concat(index, "_").concat(item.name), title: item.name }, item.name)); })),
        liveBetsLoader ? (liveBetsLoader) : (React.createElement(ListBody, null,
            myBets.map(function (data, index, list) { return renderMyLiveBetItem(data, index, list); }),
            otherBets.map(function (data, index, list) { return renderOtherLiveBetItem(data, index, list); })))));
});

var _a;
var filterNamesDefault = (_a = {},
    _a[BetHistoryFilterTypes.All] = TranslationKeys.All,
    _a[BetHistoryFilterTypes.Win] = TranslationKeys.Win,
    _a[BetHistoryFilterTypes.Lose] = TranslationKeys.Lose,
    _a);
var BetHistoryContainer = observer(function (_a) {
    var renderBetHistoryItem = _a.renderBetHistoryItem, filtersVersion2Ui = _a.filtersVersion2Ui, filterNames = _a.filterNames; _a.keyExtractor; var customStatus = _a.customStatus, customBetHistoryParser = _a.customBetHistoryParser, _c = _a.requestAdditionalParams, requestAdditionalParams = _c === void 0 ? null : _c, _d = _a.isGetViaSocket, isGetViaSocket = _d === void 0 ? false : _d;
    var _e = __read(useState(true), 2), isCancelScroll = _e[0], setIsCancelScroll = _e[1];
    var t = useTranslation();
    var betHistoryData = betStore.betHistory.data, betHistoryFilter = betStore.betHistoryFilter, getBetHistory = betStore.getBetHistory, resetBetHistory = betStore.resetBetHistory, setBetHistoryFilter = betStore.setBetHistoryFilter;
    // useEffect(() => {
    //   if (requestAdditionalParams) {
    //     betStore.setBetHistoryRequestAdditionalParams(requestAdditionalParams);
    //   }
    // }, [requestAdditionalParams]);
    useEffect(function () {
        if (requestAdditionalParams) {
            betStore.setBetHistoryRequestAdditionalParams(requestAdditionalParams);
        }
        getBetHistory({}, customStatus, customBetHistoryParser, isGetViaSocket);
        return function () {
            resetBetHistory();
        };
    }, [customStatus, requestAdditionalParams]);
    var handleScroll = useCallback(function (e) {
        if (!isCancelScroll) {
            setIsCancelScroll(true);
            return;
        }
        if (checkScrollToBottom(e)) {
            getBetHistory({}, customStatus, customBetHistoryParser, isGetViaSocket);
        }
    }, [customStatus, customBetHistoryParser, isCancelScroll]);
    return (React.createElement(List, null,
        React.createElement(ListHeaderFilter, { isVersion2: filtersVersion2Ui }, filterNames.map(function (el) { return (React.createElement(ListFilterHeaderItem, { key: el, isActive: betHistoryFilter === el, title: t(filterNamesDefault[el]), onClick: function () {
                if (betHistoryFilter !== el) {
                    setIsCancelScroll(false);
                    setBetHistoryFilter(el, customStatus, customBetHistoryParser, isGetViaSocket);
                }
            } }, t(filterNamesDefault[el]))); })),
        React.createElement(ListBody, { onScroll: handleScroll }, betHistoryData.map(function (bet, index, list) { return renderBetHistoryItem(bet, index, list, handleScroll); }))));
});

var NavItems = observer(function (_a) {
    var navItemsPropsArr = _a.navItemsPropsArr, isVersion2 = _a.isVersion2;
    var t = useTranslation();
    var gameTypeId = gameConfigStore.gameTypeId;
    var isShowChat = chatStore.isShowChat;
    var lobbyNavItems = useMemo(function () {
        return navItemsPropsArr.filter(function (item) { return item.isCommon; });
    }, [navItemsPropsArr]);
    var renderNavItems = useMemo(function () { return (gameTypeId ? navItemsPropsArr : lobbyNavItems); }, [gameTypeId, lobbyNavItems]);
    return (React.createElement(React.Fragment, null, renderNavItems.map(function (_a, index) {
        var text = _a.text, isActive = _a.isActive, alt = _a.alt, inActiveImageSrc = _a.inActiveImageSrc, activeImageSrc = _a.activeImageSrc, onClick = _a.onClick, scene = _a.scene;
        return scene !== GameScenes.Chat || (scene === GameScenes.Chat && isShowChat) ? (React.createElement(NavItem, { isVersion2: isVersion2, key: "".concat(text, "_").concat(index), text: t(text), imageSrc: isActive ? activeImageSrc : inActiveImageSrc, isActive: isActive, alt: t(alt || text), onClick: function () { return onClick(text); } })) : (React.createElement(React.Fragment, null));
    })));
});

var MobileNavigation = function (_a) {
    var navItemsPropsArr = _a.navItemsPropsArr, isVersion2 = _a.isVersion2;
    return (React.createElement(NavRow, { isVersion2: isVersion2 },
        React.createElement(NavItems, { navItemsPropsArr: navItemsPropsArr, isVersion2: isVersion2 })));
};

var HeaderCenter = observer(function (_a) {
    var hasFreeBets = _a.hasFreeBets, demoSwitcherAdditionalFunction = _a.demoSwitcherAdditionalFunction, isFromSettings = _a.isFromSettings, isOpenedFromParentComponent = _a.isOpenedFromParentComponent, changeIsOpenedFromParentComponent = _a.changeIsOpenedFromParentComponent, userBalanceAdditionalChildren = _a.userBalanceAdditionalChildren;
    var isDemo = applicationStore.isDemo, isTestPlatform = applicationStore.isTestPlatform, demoSwitcher = applicationStore.demoSwitcher;
    var _b = parseQuery(window.location.search), _c = DefaultQueryParams.RealModeSwitcher, hasRealModeSwitcher = _b[_c];
    var t = useTranslation();
    return (React.createElement(UserContent, null,
        React.createElement(UserInfo, null,
            React.createElement(UserBalance, { userBalanceAdditionalChildren: userBalanceAdditionalChildren })),
        isDemo && !isTestPlatform && !Number(hasRealModeSwitcher) && (React.createElement(PlayForRealButton$1, { text: t(TranslationKeys.PlayForReal), onClick: function () { return demoSwitcher(demoSwitcherAdditionalFunction); } })),
        hasFreeBets && (React.createElement(FreeBetsWrapper, { isFromSettings: isFromSettings, isOpenedFromParentComponent: isOpenedFromParentComponent, changeIsOpenedFromParentComponent: changeIsOpenedFromParentComponent }))));
});

var MobileHeader = observer(function (_a) {
    var children = _a.children, hasFreeBets = _a.hasFreeBets, haveDarkMode = _a.haveDarkMode, hasAnimation = _a.hasAnimation, hasLobby = _a.hasLobby, hasHalfCashOut = _a.hasHalfCashOut, hasAvatarsBlock = _a.hasAvatarsBlock, hasMobileInfoPopUp = _a.hasMobileInfoPopUp, hasMusicControllerRow = _a.hasMusicControllerRow, hasSoundControllerRow = _a.hasSoundControllerRow, userBalanceAdditionalChildren = _a.userBalanceAdditionalChildren, demoSwitcherAdditionalFunction = _a.demoSwitcherAdditionalFunction;
    var currentData = popupStore.currentData;
    var settingContainerRef = useRef();
    var _b = __read(useState(false), 2), isFreeBetBlockOpenedFromSettings = _b[0], setIsFreeBetBlockOpenedFromSettings = _b[1];
    var isShowLobbySelectGameType = lobbyStore.isShowLobbySelectGameType;
    var isRepliedGame = platformMessageStore.isRepliedGame;
    var isShowSideBarButton = gameConfigStore.isShowSideBarButton, sideBarButtonNotificationCount = gameConfigStore.sideBarButtonNotificationCount;
    var handleChangeGameType = useCallback(function () {
        if (currentData) {
            popupStore.close();
        }
        else {
            if (isShowLobbySelectGameType) {
                iframeService.exitGame();
            }
            else {
                lobbyStore.setIsShowLobbySelectGameType(true);
            }
        }
    }, [currentData, isShowLobbySelectGameType]);
    return (React.createElement(ColHeader, null,
        React.createElement(ColHeaderBlock, { isIconBlock: true },
            React.createElement(ColHeaderBlockInner, { isLeft: !isShowLobbySelectGameType && !currentData, additionalRef: settingContainerRef, onClick: !isRepliedGame && (isShowLobbySelectGameType || currentData) ? handleChangeGameType : undefined }, !isRepliedGame && (isShowLobbySelectGameType || currentData) ? (React.createElement(IconBlock, { iconType: isShowLobbySelectGameType ? IconTypes.Home : IconTypes.ArrowBack })) : (React.createElement(SettingsContainer, { hasLobby: hasLobby, haveDarkMode: haveDarkMode, hasAnimation: hasAnimation, hasHalfCashOut: hasHalfCashOut, hasAvatarsBlock: hasAvatarsBlock, hasMobileInfoPopUp: hasMobileInfoPopUp, handleChangeGameType: handleChangeGameType, settingsBlockRefInParent: settingContainerRef, hasMusicControllerRow: hasMusicControllerRow, hasSoundControllerRow: hasSoundControllerRow, isFreeBetBlockOpenedFromSettings: isFreeBetBlockOpenedFromSettings, setIsFreeBetBlockOpenedFromSettings: setIsFreeBetBlockOpenedFromSettings })))),
        React.createElement(ColHeaderBlock, null, !isRepliedGame && (React.createElement(HeaderCenter, { children: children, hasFreeBets: hasFreeBets, userBalanceAdditionalChildren: userBalanceAdditionalChildren, demoSwitcherAdditionalFunction: demoSwitcherAdditionalFunction, isFromSettings: isFreeBetBlockOpenedFromSettings, isOpenedFromParentComponent: isFreeBetBlockOpenedFromSettings, changeIsOpenedFromParentComponent: isFreeBetBlockOpenedFromSettings ? function () { return setIsFreeBetBlockOpenedFromSettings(false); } : null }))),
        !isRepliedGame && isShowSideBarButton && (React.createElement(ColHeaderBlock, { isIconBlock: true },
            !!sideBarButtonNotificationCount && (React.createElement("span", { className: classNames('side-bar-notifications', sideBarButtonNotificationCount.toString().length >= 2 ? 'small' : '') }, sideBarButtonNotificationCount)),
            React.createElement(ColHeaderBlockInner, { onClick: function () { return iframeService.sendOpenSidebar(); } },
                React.createElement(IconBlock, { iconType: IconTypes.PlatformSideBar }))))));
});

var MobileWrapper = observer(function (_a) {
    var hasFreeBets = _a.hasFreeBets, haveDarkMode = _a.haveDarkMode, navItemsPropsArr = _a.navItemsPropsArr, userBalanceAdditionalChildren = _a.userBalanceAdditionalChildren, demoSwitcherAdditionalFunction = _a.demoSwitcherAdditionalFunction, hasHalfCashOut = _a.hasHalfCashOut, handleGameSceneChange = _a.handleGameSceneChange, _b = _a.hasChat, hasChat = _b === void 0 ? true : _b, _c = _a.hasDemoPopup, hasDemoPopup = _c === void 0 ? true : _c, _d = _a.hasAnimation, hasAnimation = _d === void 0 ? false : _d, _e = _a.hasAvatarsBlock, hasAvatarsBlock = _e === void 0 ? true : _e, _f = _a.hasMusicControllerRow, hasMusicControllerRow = _f === void 0 ? true : _f, _g = _a.hasSoundControllerRow, hasSoundControllerRow = _g === void 0 ? true : _g, _h = _a.hasGameTypeLoading, hasGameTypeLoading = _h === void 0 ? true : _h, _j = _a.hasLobby, hasLobby = _j === void 0 ? true : _j, _k = _a.hasNavigation, hasNavigation = _k === void 0 ? true : _k, _l = _a.hasMobileInfoPopUp, hasMobileInfoPopUp = _l === void 0 ? false : _l, isShowIconTag = _a.isShowIconTag, navigationVersion2Ui = _a.navigationVersion2Ui, isShowBogLineLobby = _a.isShowBogLineLobby, playForRealPopupImgSrc = _a.playForRealPopupImgSrc, children = _a.children;
    var gameThemeConfigs = userSettingsStore.gameThemeConfigs;
    var gameTypeId = gameConfigStore.gameTypeId;
    var isDemo = applicationStore.isDemo, isAuthDataReceived = applicationStore.isAuthDataReceived;
    var isRepliedGame = platformMessageStore.isRepliedGame, isOpenBetHistorySection = platformMessageStore.isOpenBetHistorySection, isOpenGameHelpSection = platformMessageStore.isOpenGameHelpSection, isOpenOddsSection = platformMessageStore.isOpenOddsSection;
    var isShowLobbySelectGameType = lobbyStore.isShowLobbySelectGameType;
    useEffect(function () {
        if (hasChat && gameTypeId && !isDemo && isAuthDataReceived) {
            chatService.init();
        }
    }, [hasChat, gameTypeId, isDemo, isAuthDataReceived]);
    useEffect(function () {
        if (isOpenBetHistorySection && handleGameSceneChange) {
            handleGameSceneChange(GameScenes.Bets);
        }
    }, [isOpenBetHistorySection, handleGameSceneChange]);
    useEffect(function () {
        if ((isOpenGameHelpSection || isOpenOddsSection) && handleGameSceneChange) {
            handleGameSceneChange(GameScenes.Info);
        }
    }, [isOpenGameHelpSection, isOpenOddsSection, handleGameSceneChange]);
    return (React.createElement(React.Fragment, null,
        React.createElement(MobileGameMainCont, null,
            gameThemeConfigs.isEnabled && GameTheme[gameThemeConfigs.themeType] === GameThemeNames.Winter ? (React.createElement(SnowFlakes, null)) : null,
            React.createElement(MobileGameColumn, { position: 'top' },
                React.createElement(MobileHeader, { hasLobby: hasLobby, userBalanceAdditionalChildren: userBalanceAdditionalChildren, hasFreeBets: hasFreeBets, hasAnimation: hasAnimation, haveDarkMode: haveDarkMode, hasHalfCashOut: hasHalfCashOut, hasMobileInfoPopUp: hasMobileInfoPopUp, hasAvatarsBlock: hasAvatarsBlock, hasSoundControllerRow: hasSoundControllerRow, hasMusicControllerRow: hasMusicControllerRow, demoSwitcherAdditionalFunction: demoSwitcherAdditionalFunction })),
            React.createElement(MobileGameColumn, { position: 'middle' }, children),
            hasLobby && !isRepliedGame && (React.createElement(LobbyWrapper, { isShowBogLineLobby: isShowBogLineLobby, isShowIconTag: isShowIconTag })),
            hasNavigation && (isRepliedGame || !isShowLobbySelectGameType) && (React.createElement(MobileGameColumn, { position: 'bottom' },
                React.createElement(MobileNavigation, { navItemsPropsArr: navItemsPropsArr, isVersion2: navigationVersion2Ui }))),
            hasDemoPopup && (React.createElement(PlayForRealPopup, { demoSwitcherAdditionalFunction: demoSwitcherAdditionalFunction, popupLogo: playForRealPopupImgSrc, forBogLine: true }))),
        hasGameTypeLoading && React.createElement(GameTypeLoading, null)));
});

var ConnectionPopupsWr = observer(function (_a) {
    var 
    // hasGameOpenPopup = true,
    // hasConnectionErrorPopup = true,
    // isShowReloadButton = true,
    _b = _a.hasReconnectPopup, 
    // hasGameOpenPopup = true,
    // hasConnectionErrorPopup = true,
    // isShowReloadButton = true,
    hasReconnectPopup = _b === void 0 ? true : _b;
    // const { connectionError, reconnect } = popupStore;
    var reconnect = popupStore.reconnect;
    platformMessageStore.isShowAllNotification;
    // const { gameIsOpen } = applicationStore;
    var t = useTranslation();
    if (hasReconnectPopup && reconnect) {
        return (React.createElement(ConnectionPopup, { title: t(TranslationKeys.PleaseWait), subTitle: t(TranslationKeys.Reconnect), isReconnecting: true }));
    }
    return null;
});

var UnderMaintenanceWr = observer(function () {
    var underMaintenance = popupStore.underMaintenance, underMaintenanceSeconds = popupStore.underMaintenanceSeconds, toggleUnderMaintenance = popupStore.toggleUnderMaintenance;
    var t = useTranslation();
    if (underMaintenance) {
        var handleClose = function () { return toggleUnderMaintenance(false); };
        return (React.createElement(UnderMaintenance, { text: setTranslationValues(t(TranslationKeys.UnderMaintenanceInGame), { value: underMaintenanceSeconds }), handleClose: handleClose }));
    }
    return null;
});

var SlowConnectionWr = observer(function () {
    var slowConnection = popupStore.slowConnection, toggleSlowConnection = popupStore.toggleSlowConnection;
    var isRepliedGame = platformMessageStore.isRepliedGame;
    var t = useTranslation();
    if (slowConnection && !isRepliedGame) {
        var handleClose = function () { return toggleSlowConnection(false); };
        var SlowConnectionTitle = TranslationKeys.SlowConnection;
        return (React.createElement("div", { className: 'slow-connection-wr' },
            React.createElement(SlowConnection, { onClick: handleClose, title: t(SlowConnectionTitle) })));
    }
    return null;
});

var CoreBetErrorMessages = BetErrorMessages;
var CoreNotificationByResponseCode = notificationByResponseCode;
var CoreBetResponseCode = __assign({}, BetResponseCode);
var generateMessage = function (_a) {
    var _b;
    var t = _a.t, code = _a.code, limits = _a.limits, autoCashOutMinOdd = _a.autoCashOutMinOdd, autoCashOutMaxOdd = _a.autoCashOutMaxOdd, freeBetMaxPayout = _a.freeBetMaxPayout, _c = _a.translationDynamicValues, translationDynamicValues = _c === void 0 ? null : _c;
    var message = t(CoreBetErrorMessages[CoreBetResponseCode[code]], __assign({ freeBetCount: ((_b = freeBetStore.activeFreeBet) === null || _b === void 0 ? void 0 : _b.freeBetCount) || 0 }, translationDynamicValues));
    var _d = parseQuery(window.location.search), _e = DefaultQueryParams.Culture, culture = _d[_e];
    var isShowWithoutChange = rtlLanguages.includes(culture);
    switch (code) {
        case CoreBetResponseCode[responseType.InValidMinBet]:
            return {
                message: "".concat(message, " ").concat(getAmountWithCurrency({ amount: limits.minBet, isShowWithoutChange: isShowWithoutChange })),
                code: code,
            };
        case CoreBetResponseCode[responseType.InValidMaxBet]:
            return {
                message: "".concat(message, " ").concat(getAmountWithCurrency({ amount: limits.maxBet, isShowWithoutChange: isShowWithoutChange })),
                code: code,
            };
        case CoreBetResponseCode[responseType.InValidAutoCashOutOdd]:
            return {
                message: "".concat(t(TranslationKeys.Min), " ").concat(message, " ").concat(t(TranslationKeys.Odd), " ").concat(autoCashOutMinOdd),
                code: code,
            };
        case CoreBetResponseCode[responseType.InValidMaxAutoCashOutOdd]:
            return {
                message: "".concat(t(TranslationKeys.Max), " ").concat(message, " ").concat(t(TranslationKeys.Odd), " ").concat(autoCashOutMaxOdd),
                code: code,
            };
        case CoreBetResponseCode[responseType.MaxWinNote]:
            return {
                message: "".concat(t(TranslationKeys.MaxWinNote), " ").concat(getAmountWithCurrency({
                    amount: limits.maxWin,
                    isShowWithoutChange: isShowWithoutChange,
                })),
                code: code,
            };
        case CoreBetResponseCode[responseType.FreeBetMaxWinPayout]:
            return {
                message: "".concat(t(TranslationKeys.FreeBetMaxWinPayout), " ").concat(getAmountWithCurrency({
                    amount: freeBetMaxPayout,
                    isShowWithoutChange: isShowWithoutChange,
                })),
                code: code,
            };
        case CoreBetResponseCode[responseType.NotEnoughFreeBets]:
            return {
                message: message,
                code: code,
            };
        default:
            if (translationDynamicValues && Object.values(translationDynamicValues).length) {
                return {
                    message: message,
                    code: code,
                };
            }
            return { message: message, code: code };
    }
};
var BetNotificationWr = observer(function (_a) {
    var autoCashOutMinOdd = _a.autoCashOutMinOdd, autoCashOutMaxOdd = _a.autoCashOutMaxOdd, _b = _a.maxNotificationsLength, maxNotificationsLength = _b === void 0 ? 5 : _b, _c = _a.delayTime, delayTime = _c === void 0 ? 2000 : _c, translationDynamicValues = _a.translationDynamicValues, _d = _a.AdditionalErrorMessages, AdditionalErrorMessages = _d === void 0 ? {} : _d, _e = _a.AdditionalNotificationByResponseCode, AdditionalNotificationByResponseCode = _e === void 0 ? {} : _e, _f = _a.AdditionalResponseCode, AdditionalResponseCode = _f === void 0 ? {} : _f;
    var notification = notificationStore.notificationCode, operatorErrorMessage = notificationStore.operatorErrorMessage;
    var isShowAllNotification = platformMessageStore.isShowAllNotification, isDoBetResultValidated = platformMessageStore.isDoBetResultValidated, isUsedPlatformIntegrationLogic = platformMessageStore.bogLineGameTypeData.isUsedPlatformIntegrationLogic;
    var _g = gameConfigStore.limits, limits = _g === void 0 ? {} : _g, maxAutoCashOutOdd = gameConfigStore.maxAutoCashOutOdd;
    var _h = __read(useState([]), 2), notifications = _h[0], setNotifications = _h[1];
    var _j = __read(useState([]), 2), timeOutIds = _j[0], setTimeOutIds = _j[1];
    var t = useTranslation();
    CoreBetErrorMessages = __assign(__assign({}, CoreBetErrorMessages), AdditionalErrorMessages);
    CoreNotificationByResponseCode = __assign(__assign({}, CoreNotificationByResponseCode), AdditionalNotificationByResponseCode);
    CoreBetResponseCode = __assign(__assign({}, CoreBetResponseCode), AdditionalResponseCode);
    useEffect(function () {
        var timeOutId;
        if (notification && Object.keys(notification).length) {
            var newNotification_1 = __assign(__assign({}, notification), { key: generateUId(), notificationData: generateMessage({
                    code: notification === null || notification === void 0 ? void 0 : notification.responseCode,
                    freeBetMaxPayout: notification === null || notification === void 0 ? void 0 : notification.freeBetMaxPayout,
                    limits: limits,
                    autoCashOutMinOdd: autoCashOutMinOdd,
                    autoCashOutMaxOdd: maxAutoCashOutOdd || autoCashOutMaxOdd,
                    translationDynamicValues: translationDynamicValues,
                    t: t,
                }) });
            setNotifications(function (prevState) {
                var newState = __spreadArray([], __read(prevState), false);
                if (newState.length >= maxNotificationsLength) {
                    var key_1 = newState.pop().key;
                    setTimeOutIds(function (state) {
                        return state.filter(function (item) { return key_1 !== item.key; });
                    });
                    newState.unshift(newNotification_1);
                    return __spreadArray([], __read(newState), false);
                }
                newState.unshift(newNotification_1);
                timeOutId = setTimeout(function () {
                    setNotifications(function (oldState) {
                        var newNotifications = __spreadArray([], __read(oldState), false);
                        if (newNotifications.length) {
                            var key_2 = newNotifications.pop().key;
                            setTimeOutIds(function (preState) {
                                return preState.filter(function (item) { return key_2 !== item.key; });
                            });
                            return __spreadArray([], __read(newNotifications), false);
                        }
                        return __spreadArray([], __read(newNotifications), false);
                    });
                }, delayTime);
                setTimeOutIds(function (pevState) {
                    return __spreadArray(__spreadArray([], __read(pevState), false), [{ timeOutId: timeOutId, key: newNotification_1.key }], false);
                });
                return __spreadArray([], __read(newState), false);
            });
        }
        else {
            if (timeOutIds.length) {
                timeOutIds.forEach(function (_a) {
                    var timeOutId = _a.timeOutId;
                    return clearTimeout(timeOutId);
                });
            }
            setNotifications([]);
        }
    }, [notification]);
    useEffect(function () {
        if (!isShowAllNotification && isDoBetResultValidated && isUsedPlatformIntegrationLogic) {
            var sentNotification = generateMessage({
                code: notification === null || notification === void 0 ? void 0 : notification.responseCode,
                freeBetMaxPayout: notification === null || notification === void 0 ? void 0 : notification.freeBetMaxPayout,
                limits: limits,
                autoCashOutMinOdd: autoCashOutMinOdd,
                autoCashOutMaxOdd: maxAutoCashOutOdd || autoCashOutMaxOdd,
                translationDynamicValues: translationDynamicValues,
                t: t,
            });
            iframeService.sendErrorReceived({
                errorCode: sentNotification === null || sentNotification === void 0 ? void 0 : sentNotification.code,
                errorMessage: sentNotification === null || sentNotification === void 0 ? void 0 : sentNotification.message,
            });
            platformMessageStore.setIsDoBetResultValidated(false);
        }
    }, [notification, isShowAllNotification, isDoBetResultValidated, isUsedPlatformIntegrationLogic]);
    if (((notifications === null || notifications === void 0 ? void 0 : notifications.length) && isShowAllNotification && !isDoBetResultValidated) || operatorErrorMessage) {
        return (React.createElement("div", { className: 'core-g-bet-notif-wrp' },
            !!operatorErrorMessage && isShowAllNotification && (React.createElement(BetNotification, { notification: { message: operatorErrorMessage, code: BetResponseCode.GeneralError } }) // GeneralError NEED SHOW ERROR STYLES
            ), notifications === null || notifications === void 0 ? void 0 :
            notifications.map(function (item) { return (React.createElement(BetNotification, { key: item.key, notification: item === null || item === void 0 ? void 0 : item.notificationData })); })));
    }
    return React.createElement(React.Fragment, null);
});
var BetNotification = memo(function (_a) {
    var notification = _a.notification;
    return (React.createElement("div", { className: 'core-g-bet-notif-item' },
        React.createElement("div", { className: 'core-g-bet-notif' },
            React.createElement("div", { className: "core-game-btn-c ".concat(CoreNotificationByResponseCode[CoreBetResponseCode[notification.code]]) },
                React.createElement("i", { className: "ui-lib-".concat(CoreNotificationByResponseCode[CoreBetResponseCode[notification.code]]) }),
                React.createElement("p", { className: 'core-game-btn-c-text' }, notification.message)))));
});

var AvatarsWr = observer(function (_a) {
    var avatarsBlockRef = _a.avatarsBlockRef;
    var t = useTranslation();
    var ChooseYourAvatar = TranslationKeys.ChooseYourAvatar;
    var currentAvatarId = profileAvatarStore.avatarId;
    var userId = userInfoStore.userId;
    var isDemo = applicationStore.isDemo;
    var handelChangeAvatar = useCallback(function (id) {
        profileAvatarStore.updateAvatarId(id);
        if (id !== currentAvatarId && !isDemo) {
            profileAvatarStore.sendAvatarIdToBackend(userId);
        }
    }, [userId, currentAvatarId, isDemo]);
    return (React.createElement(Avatars, { t: t, translationKey: ChooseYourAvatar, avatarsBlockRef: avatarsBlockRef, updateAvatarId: handelChangeAvatar, currentAvatarID: currentAvatarId }));
});

var UserBlockImage = observer(function (_a) {
    _a.t; var onClick = _a.onClick, hasAvatarsBlock = _a.hasAvatarsBlock; _a.winterModeActive; var isAvatarsBlockOpenedFromParent = _a.isAvatarsBlockOpenedFromParent, setIsAvatarsBlockOpenedFromParent = _a.setIsAvatarsBlockOpenedFromParent;
    var avatarId = profileAvatarStore.avatarId;
    var _b = __read(useState(false), 2), isAvatarsBlockOpened = _b[0], setIsAvatarsBlockOpened = _b[1];
    var _c = __read(useClickOutside(), 2), avatarsBlockRef = _c[0], hasAvatarsBlockClickedOutside = _c[1];
    var _d = __read(useClickOutside(), 2), avatarsPopoverOpenerRef = _d[0], hasAvatarsPopoverOpenerClickedOutside = _d[1];
    useEffect(function () {
        if (hasAvatarsBlockClickedOutside && hasAvatarsPopoverOpenerClickedOutside) {
            if (setIsAvatarsBlockOpenedFromParent) {
                setIsAvatarsBlockOpenedFromParent(false);
            }
            else {
                setIsAvatarsBlockOpened(false);
            }
        }
    }, [hasAvatarsBlockClickedOutside, hasAvatarsPopoverOpenerClickedOutside]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "user-profile ".concat(avatarId ? "av-".concat(avatarId) : 'default'), ref: avatarsPopoverOpenerRef, onClick: function () {
                if (onClick) {
                    onClick();
                }
                if (!setIsAvatarsBlockOpenedFromParent) {
                    setIsAvatarsBlockOpened(function (prev) { return !prev; });
                }
            } }, hasAvatarsBlock && React.createElement("div", { className: 'user-profile-action' })),
        (isAvatarsBlockOpenedFromParent || isAvatarsBlockOpened) && React.createElement(AvatarsWr, { avatarsBlockRef: avatarsBlockRef })));
});

var SlowConnection = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, onClick = _a.onClick;
    return (React.createElement("div", { className: 'core-game-m-con-slow' },
        React.createElement("div", { className: 'core-game-m-con-slow-ic left' },
            React.createElement("i", { className: "ui-lib-".concat(IconTypes.AlertTriangle) })),
        React.createElement("p", { className: 'core-con-sl-p' }, title),
        React.createElement("div", { onClick: onClick, className: 'core-game-m-con-slow-ic right' },
            React.createElement("i", { className: "ui-lib-".concat(IconTypes.PopupClose) }))));
};

var UnderMaintenance = function (_a) {
    var text = _a.text, handleClose = _a.handleClose, rest = __rest(_a, ["text", "handleClose"]);
    return (React.createElement("div", __assign({ className: "core-maintenance-top-message" }, rest),
        React.createElement("p", { className: "core-maintenance-top-message-text" }, text),
        React.createElement("button", { onClick: handleClose, type: "button", className: "core-maintenance-top-message-close ui-lib-".concat(IconTypes.CloseX) })));
};

var defaultNumPadDigitsArray = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0'];
var NumPad = function (_a) {
    var t = _a.t, isOpen = _a.isOpen, limits = _a.limits, onSubmit = _a.onSubmit, amountValue = _a.amountValue, setAmountValue = _a.setAmountValue, _b = _a.precision, precision = _b === void 0 ? 2 : _b, _c = _a.inputMaxLength, inputMaxLength = _c === void 0 ? 9 : _c, _d = _a.numPadDigitsArray, numPadDigitsArray = _d === void 0 ? defaultNumPadDigitsArray : _d;
    var ref = useRef();
    var numPadLimits = useMemo(function () { return (__assign(__assign({}, limits), { step: limits.step || limits.minBet })); }, [limits]);
    var onChange = useCallback(function (event) {
        var value = event.target.value;
        if (/^([0]{1}|([1-9]{1}\d*))(?:\.\d{0,2})?$/.test(value)) {
            return setAmountValue(value);
        }
        if (value === '') {
            return setAmountValue(value);
        }
    }, [setAmountValue]);
    var handleClick = useCallback(function (e) {
        // @ts-ignore
        if (!(ref.current && ref.current.contains(e.target))) {
            onSubmit(null);
        }
    }, [onSubmit]);
    useEffect(function () {
        if (isOpen) {
            document.addEventListener('click', handleClick);
            document.addEventListener('touchstart', handleClick);
            return function () {
                document.removeEventListener('click', handleClick);
                document.removeEventListener('touchstart', handleClick);
            };
        }
    }, [handleClick, isOpen]);
    var handleAddOrMinusBetAmount = function (action) {
        if (action === void 0) { action = undefined; }
        var changedBetAmount;
        if (action === '-') {
            changedBetAmount = +amountValue - numPadLimits.step;
            changedBetAmount = changedBetAmount > numPadLimits.minBet ? changedBetAmount : numPadLimits.minBet;
        }
        else {
            changedBetAmount = +amountValue + numPadLimits.step;
            if (numPadLimits.maxBet) {
                changedBetAmount = changedBetAmount < numPadLimits.maxBet ? changedBetAmount : numPadLimits.maxBet;
            }
        }
        setAmountValue(parseNumberByPrecision(1, changedBetAmount));
    };
    var parseNumberByPrecision = useCallback(function (odd, betAmount) {
        var oddArr = odd.toString().split('.')[1];
        var digitsAfterDotAtOdd = (oddArr && oddArr.length) || 0;
        var digitsAfterDotAtBetAmount = betAmount.toString().split('.').length || 0;
        var digitsCountAfterDot = digitsAfterDotAtBetAmount + digitsAfterDotAtOdd;
        var result;
        var re = new RegExp("^-?\\d+(?:.\\d{0,".concat(precision || 2, "})?"));
        var numMulty = (Math.round(odd * Math.pow(10, digitsCountAfterDot)) * Math.round(betAmount * Math.pow(10, digitsCountAfterDot))) /
            Math.pow(10, (digitsCountAfterDot + digitsCountAfterDot));
        // eslint-disable-next-line prefer-const
        result = +numMulty.toString().match(re) && +numMulty.toString().match(re)[0];
        return result;
    }, []);
    var addDigit = function (digit) {
        if ("".concat(amountValue).concat(digit).length <= inputMaxLength) {
            onChange({ target: { value: "".concat(amountValue).concat(digit) } });
        }
    };
    var deleteDigit = function () {
        onChange({ target: { value: "".concat(amountValue).slice(0, -1) } });
    };
    return (React.createElement("div", { className: "numpad-wrapper ".concat(isOpen ? 'active' : ''), ref: ref },
        React.createElement("div", { className: 'numpad-holder' },
            React.createElement("div", { className: 'num-head-row-holder' },
                React.createElement("div", { className: 'numb-calculate-container' },
                    React.createElement("div", { className: 'calc-result-numb-row' },
                        React.createElement("div", { className: 'calc-result-numb-row-bg' },
                            React.createElement("div", { className: "num-head-button-top ".concat(Number(amountValue) <= numPadLimits.minBet ? 'disabled' : ''), onClick: function () { return handleAddOrMinusBetAmount('-'); } },
                                React.createElement("div", { className: 'num-head-button-inner' },
                                    React.createElement("span", { className: 'left-button-item' }, "-"))),
                            React.createElement("div", { className: 'middle-container-numb' },
                                React.createElement("span", { className: 'money-text' }, amountValue)),
                            React.createElement("div", { className: "num-head-button-top ".concat(Number(amountValue) >= numPadLimits.maxBet ? 'disabled' : ''), onClick: function () { return handleAddOrMinusBetAmount(); } },
                                React.createElement("div", { className: 'num-head-button-inner' },
                                    React.createElement("span", { className: 'left-button-item' }, "+")))))),
                React.createElement("div", { className: 'num-head-button', onClick: onSubmit },
                    React.createElement("button", { className: 'button' },
                        " ",
                        t(TranslationKeys.Ok)))),
            React.createElement("div", { className: 'num-button-wrapper' },
                React.createElement("div", { className: 'num-button-holder' },
                    numPadDigitsArray.map(function (digit) { return (React.createElement("div", { className: 'nub-buttons', key: digit, onClick: function () { return addDigit(digit); } },
                        React.createElement("div", { className: 'nub-buttons-inner' },
                            React.createElement("span", { className: 'boxes-text' }, digit)))); }),
                    React.createElement("div", { className: 'nub-buttons', onClick: function () { return deleteDigit(); } },
                        React.createElement("div", { className: 'nub-buttons-inner' },
                            React.createElement("i", { className: "ui-lib-".concat(IconTypes.Backspace, " boxes-icon") }))))))));
};

var CheckHashPopup = observer(function (_a) {
    var gameSpecificTopSection = _a.gameSpecificTopSection, aboutHashInnerContent = _a.aboutHashInnerContent;
    var currentData = popupStore.currentData, getHashResult = popupStore.getHashResult, setHashResult = popupStore.setHashResult, hashResult = popupStore.hashResult, isFromBetHistory = popupStore.isFromBetHistory;
    var _b = currentData || {}, resultHash = _b.resultHash, resultKey = _b.resultKey, resultSalt = _b.resultSalt, roundId = _b.roundId, beforeBetBalance = _b.beforeBetBalance, betFinishedBalance = _b.betFinishedBalance;
    var _c = __read(useState(''), 2), checkKeyValue = _c[0], setCheckKeyValue = _c[1];
    var _d = __read(useState(''), 2), checkSaltValue = _d[0], setCheckSaltValue = _d[1];
    var _e = __read(useState(false), 2), toggle = _e[0], setToggle = _e[1];
    var _f = __read(useState(false), 2), isRequestPending = _f[0], setIsRequestPending = _f[1];
    var scrollRef = useRef(null);
    var t = useTranslation();
    var handleCheckHash = useCallback(function () {
        setIsRequestPending(true);
        getHashResult({ resultIdentityString: checkKeyValue, salt: checkSaltValue }).finally(function () {
            setIsRequestPending(false);
        });
    }, [checkKeyValue, checkSaltValue]);
    useEffect(function () {
        if (toggle && scrollRef.current) {
            scrollRef.current.scrollIntoView();
        }
    }, [toggle]);
    useEffect(function () {
        setCheckKeyValue('');
        setCheckSaltValue('');
        return function () {
            setHashResult();
        };
    }, [resultKey]);
    useEffect(function () {
        setToggle(false);
    }, [roundId]);
    var isCheckHashBtnDisabled = isRequestPending || !(checkKeyValue && checkSaltValue);
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { className: 'result-content-b', onSubmit: function (ev) { return ev.preventDefault(); } },
            gameSpecificTopSection,
            isFromBetHistory && (beforeBetBalance || betFinishedBalance) ? (React.createElement("div", { className: 'res-round-wrp balance-info' },
                React.createElement("div", { className: 'res-round' },
                    React.createElement("p", { className: 'res-round-p' }, t(TranslationKeys.BalanceBefore)),
                    React.createElement("p", { className: 'res-round-p' }, t(TranslationKeys.BalanceAfter))),
                React.createElement("div", { className: 'res-r-inp-wrp' },
                    React.createElement("div", { className: 'res-r-inp-clm' },
                        React.createElement("input", { type: 'text', className: 'res-r-input', disabled: true, value: getAmountWithCurrency({ amount: convertAmount(beforeBetBalance) }) || '', onChange: function () { return void 0; }, placeholder: t(TranslationKeys.BalanceBefore) })),
                    React.createElement("div", { className: 'res-r-inp-clm' },
                        React.createElement("input", { type: 'text', className: 'res-r-input', disabled: true, value: getAmountWithCurrency({ amount: convertAmount(betFinishedBalance) }) || '', onChange: function () { return void 0; }, placeholder: t(TranslationKeys.BalanceAfter) }))))) : (React.createElement(React.Fragment, null)),
            React.createElement("div", { className: 'res-round-wrp' },
                React.createElement("div", { className: 'res-round' },
                    React.createElement("p", { className: 'res-round-p' }, t(TranslationKeys.CheckHashCode))),
                React.createElement("div", { className: 'res-r-inp-wrp' },
                    React.createElement("div", { className: 'res-r-inp-clm' },
                        resultKey && (React.createElement("div", { className: 'res-r-inp-copy-icon', onClick: function () {
                                setCheckKeyValue(resultKey);
                                copyToClipboard(resultKey);
                            } },
                            React.createElement("i", { className: "ui-lib-".concat(IconTypes.Copy) }))),
                        React.createElement("input", { type: 'text', className: 'res-r-input', disabled: true, value: resultKey || '', onChange: function () { return void 0; }, placeholder: t(TranslationKeys.Key) })),
                    React.createElement("div", { className: 'res-r-inp-clm' },
                        resultSalt && (React.createElement("div", { className: 'res-r-inp-copy-icon', onClick: function () {
                                setCheckSaltValue(resultSalt);
                                copyToClipboard(resultSalt);
                            } },
                            React.createElement("i", { className: "ui-lib-".concat(IconTypes.Copy) }))),
                        React.createElement("input", { type: 'text', className: 'res-r-input', disabled: true, value: resultSalt || '', onChange: function () { return void 0; }, placeholder: t(TranslationKeys.Salt) }))),
                React.createElement("div", { className: 'res-r-inp-wrp' },
                    React.createElement("div", { className: 'res-r-inp-clm' },
                        resultHash && (React.createElement("div", { className: 'res-r-inp-copy-icon', onClick: function () {
                                copyToClipboard(resultHash);
                            } },
                            React.createElement("i", { className: "ui-lib-".concat(IconTypes.Copy) }))),
                        React.createElement("input", { disabled: true, type: 'text', className: 'res-r-input', value: resultHash || '', onChange: function () { return void 0; }, placeholder: t(TranslationKeys.HashCode) })))),
            React.createElement("div", { className: 'res-round-wrp' },
                React.createElement("div", { className: 'res-round' },
                    React.createElement("p", { className: 'res-round-p' }, t(TranslationKeys.CheckHashCode))),
                React.createElement("div", { className: 'res-r-inp-wrp' },
                    React.createElement("div", { className: 'res-r-inp-clm' },
                        React.createElement("input", { inputMode: isMobile() ? 'none' : 'text', className: 'res-r-input', required: true, value: checkKeyValue, onChange: function (_a) {
                                var value = _a.target.value;
                                return setCheckKeyValue(value);
                            }, title: t(TranslationKeys.Key), placeholder: t(TranslationKeys.Key) })),
                    React.createElement("div", { className: 'res-r-inp-clm' },
                        React.createElement("input", { inputMode: isMobile() ? 'none' : 'text', className: 'res-r-input', required: true, value: checkSaltValue, onChange: function (_a) {
                                var value = _a.target.value;
                                return setCheckSaltValue(value);
                            }, title: t(TranslationKeys.Salt), placeholder: t(TranslationKeys.Salt) }))),
                React.createElement("div", { className: 'res-r-inp-wrp' },
                    React.createElement("div", { className: 'res-r-inp-clm' },
                        React.createElement("input", { type: 'text', value: hashResult || '', onChange: function () { return void 0; }, disabled: true, className: 'res-r-input', title: t(TranslationKeys.HashCode), placeholder: t(TranslationKeys.HashCode) })))),
            React.createElement("div", { className: 'res-about-wrp' },
                React.createElement("div", { className: 'res-about-wrp-item' },
                    React.createElement("div", { className: 'ab-hash-code', onClick: function () { return setToggle(!toggle); } },
                        React.createElement("div", { className: 'ab-hash-code-item left' },
                            React.createElement("i", { className: "ui-lib-".concat(IconTypes.Question1) })),
                        React.createElement("div", { className: 'ab-hash-code-item right' },
                            React.createElement("p", { className: 'ab-hash-code-item-p' }, t(TranslationKeys.AboutHashCode))))),
                React.createElement("div", { className: 'res-about-btn-wrp' },
                    React.createElement("button", { type: 'submit', disabled: isCheckHashBtnDisabled, className: "btn-check ".concat(isCheckHashBtnDisabled ? 'disabled' : ''), onClick: handleCheckHash },
                        React.createElement("span", { className: 'btn-check-sp' }, t(TranslationKeys.Check)))))),
        toggle && React.createElement(AboutHash, { scrollRef: scrollRef, aboutHashInnerContent: aboutHashInnerContent })));
});

var FairnessPopup = observer(function (_a) {
    var aboutHashInnerContent = _a.aboutHashInnerContent;
    var _b = __read(useState(''), 2), checkKeyValue = _b[0], setCheckKeyValue = _b[1];
    var _c = __read(useState(''), 2), checkSaltValue = _c[0], setCheckSaltValue = _c[1];
    var _d = __read(useState(false), 2), isRequestPending = _d[0], setIsRequestPending = _d[1];
    var getHashResult = popupStore.getHashResult, setHashResult = popupStore.setHashResult, hashResult = popupStore.hashResult;
    var t = useTranslation();
    useEffect(function () {
        setCheckKeyValue('');
        setCheckSaltValue('');
        return function () {
            setHashResult();
        };
    }, []);
    var handleCheckHash = useCallback(function () {
        setIsRequestPending(true);
        getHashResult({ resultIdentityString: checkKeyValue, salt: checkSaltValue }).finally(function () {
            return setIsRequestPending(false);
        });
    }, [checkKeyValue, checkSaltValue]);
    var isCheckHashBtnDisabled = isRequestPending || !(checkKeyValue && checkSaltValue);
    return (React.createElement("div", { className: 'result-content-b' },
        React.createElement("form", { className: 'provably-wrp', onSubmit: function (e) { return e.preventDefault(); } },
            React.createElement(AboutHash, { aboutHashInnerContent: aboutHashInnerContent }),
            React.createElement("div", { className: 'res-round-wrp' },
                React.createElement("div", { className: 'res-round' },
                    React.createElement("p", { className: 'res-round-p' }, t(TranslationKeys.CheckHashCode))),
                React.createElement("div", { className: 'res-r-inp-wrp' },
                    React.createElement("div", { className: 'res-r-inp-clm' },
                        React.createElement("input", { className: 'res-r-input', inputMode: isMobile() ? 'none' : 'text', required: true, value: checkKeyValue, onChange: function (_a) {
                                var value = _a.target.value;
                                return setCheckKeyValue(value);
                            }, title: t(TranslationKeys.Key), placeholder: t(TranslationKeys.Key) })),
                    React.createElement("div", { className: 'res-r-inp-clm' },
                        React.createElement("input", { className: 'res-r-input', inputMode: isMobile() ? 'none' : 'text', required: true, title: t(TranslationKeys.Salt), value: checkSaltValue, onChange: function (_a) {
                                var value = _a.target.value;
                                return setCheckSaltValue(value);
                            }, placeholder: t(TranslationKeys.Salt) }))),
                React.createElement("div", { className: 'res-r-inp-wrp' },
                    React.createElement("div", { className: 'res-r-inp-clm' },
                        React.createElement("input", { type: 'text', 
                            // eslint-disable-next-line no-void
                            onChange: function () { return void 0; }, disabled: true, className: 'res-r-input', placeholder: t(TranslationKeys.HashCode), title: t(TranslationKeys.HashCode), value: hashResult || '' })))),
            React.createElement("div", { className: 'res-about-btn-wrp' },
                React.createElement("button", { type: 'submit', disabled: isCheckHashBtnDisabled, className: "btn-check ".concat(isCheckHashBtnDisabled ? 'disabled' : ''), onClick: handleCheckHash },
                    React.createElement("span", { className: 'btn-check-sp' }, t(TranslationKeys.Check)))))));
});

var Avatars = function (_a) {
    var t = _a.t, translationKey = _a.translationKey, updateAvatarId = _a.updateAvatarId, avatarsBlockRef = _a.avatarsBlockRef, currentAvatarID = _a.currentAvatarID;
    var availableAvatarsType = profileAvatarStore.availableAvatarsType;
    return (React.createElement("div", { className: 'avatars-popover-holder', ref: avatarsBlockRef },
        React.createElement("div", { className: 'avatars-popover' },
            React.createElement("div", { className: 'avatars-popover-arrow' },
                React.createElement("svg", { className: 'avatars-popover-arrow-svg', viewBox: '0 0 18 13', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
                    React.createElement("path", { className: 'avatars-popover-arrow-svg-path', d: 'M0.900542 12.75L0.900162 12.75C0.779742 12.7502 0.662114 12.7185 0.560146 12.6591C0.458241 12.5997 0.376363 12.5153 0.322373 12.4158C0.268431 12.3165 0.24406 12.2055 0.251224 12.0948C0.258389 11.984 0.296909 11.8764 0.363584 11.7839L0.363828 11.7835L8.4639 0.496959C8.57563 0.341634 8.77792 0.25 9.00156 0.25C9.22522 0.25 9.42711 0.341628 9.53836 0.496701L9.53839 0.496741L17.638 11.7827C17.6381 11.7829 17.6383 11.7831 17.6384 11.7832C17.7042 11.876 17.7421 11.9834 17.7489 12.0939C17.7557 12.2046 17.7311 12.3155 17.6772 12.4147C17.6232 12.5141 17.5414 12.5985 17.4397 12.658C17.3381 12.7175 17.2208 12.7496 17.1005 12.75C17.1004 12.75 17.1003 12.75 17.1002 12.75L0.900542 12.75Z', fillOpacity: '1', stroke: 'url(#arrow-svg-gradient)', strokeWidth: '0.5' }),
                    React.createElement("defs", null,
                        React.createElement("linearGradient", { id: 'arrow-svg-gradient', x1: '9', y1: '0', x2: '9', y2: '13', gradientUnits: 'userSpaceOnUse' },
                            React.createElement("stop", { className: 'arrow-svg-gradient-stop' }),
                            React.createElement("stop", { className: 'arrow-svg-gradient-stop', offset: '1', stopOpacity: '0' }))))),
            React.createElement("div", { className: 'avatars-popover-content' },
                React.createElement("div", { className: 'avatars-popover-content-title' }, t(translationKey)),
                React.createElement("div", { className: 'popover-avatars' }, availableAvatarsType.map(function (id) { return (React.createElement("div", { key: id, className: "avatar-b ".concat(id ? "av-".concat(id) : 'default', " ").concat(+id === +currentAvatarID ? 'active' : ''), onClick: function () { return updateAvatarId(id); } })); }))))));
};

var defaultFillColors = {
    1: '#3131f7',
    2: '#069506',
    3: '#e7a01c',
};
var LobbyItemBottomBlock = function (_a) {
    var type = _a.type;
    var generatedId1 = generateUId();
    var generatedId2 = generateUId();
    var generatedId3 = generateUId();
    var generatedId4 = generateUId();
    var generatedId5 = generateUId();
    var generatedId6 = generateUId();
    var generatedId7 = generateUId();
    var generatedId8 = generateUId();
    var generatedId9 = generateUId();
    return isMobile() ? (React.createElement("svg", { width: '100%', height: '100%', viewBox: '0 0 338 100', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M39.9878 0C38.3377 0 37 1.34314 37 3V7.01266C37.1806 7.00425 37.3612 7 37.5416 7C38.4577 7 39.3805 7.10326 40.2699 7.31622L62.2633 12.4532C71.137 14.5248 77.2956 22.4175 76.9078 31.2201L75.3297 67.4373C75.1692 71.161 73.1096 74.5491 69.8196 76.5045L43.6201 92.0769C41.7897 93.1664 39.6925 93.7407 37.5416 93.7419C37.3607 93.7418 37.1801 93.7377 37 93.7295V97C37 98.6569 38.3377 100 39.9878 100H312.106C316.178 100 319.84 97.5105 321.353 93.7139L337.288 53.7139C338.237 51.3298 338.237 48.6702 337.288 46.2861L321.353 6.28609C319.84 2.48951 316.178 0 312.106 0H39.9878ZM37.5416 93.7419C37.5394 93.7419 37.5372 93.7419 37.5349 93.7419H37.5483C37.5461 93.7419 37.5438 93.7419 37.5416 93.7419Z', className: 'l-svg-color2' }),
        React.createElement("path", { d: 'M37.3884 91.5C35.3446 91.5 33.3516 90.957 31.6124 89.926L6.74398 75.2049C3.62114 73.3564 1.67253 70.1535 1.51385 66.6334L0.0159057 32.3961C-0.345887 24.0747 5.49992 16.6196 13.9164 14.6551L34.7924 9.79893C35.6366 9.60371 36.5125 9.5 37.3821 9.5C38.2517 9.5 39.1276 9.59761 39.9718 9.79893L60.8478 14.6551C69.2706 16.6135 75.1164 24.0747 74.7483 32.3961L73.2503 66.6334C73.098 70.1535 71.143 73.3564 68.0202 75.2049L43.1517 89.926C41.4126 90.957 39.4195 91.5 37.3757 91.5H37.3884Z', fill: "url(#paint0_linear_78_".concat(generatedId1, ") ").concat(defaultFillColors[type]) }),
        React.createElement("path", { d: 'M72.4501 66.6693L73.9456 32.6826C74.2878 24.9247 68.8444 18.0147 60.9423 16.1919L40.1002 11.3712C38.5794 11.02 36.9888 11.02 35.468 11.3712L14.6259 16.1919C6.73016 18.0208 1.28678 24.9247 1.62263 32.6826L3.11814 66.6693C3.25755 69.7942 5.00653 72.6466 7.78842 74.2818L32.6164 88.8951C35.7848 90.7604 39.7771 90.7604 42.9392 88.8951L67.7671 74.2818C70.549 72.6406 72.3043 69.7882 72.4374 66.6693H72.4501Z', fill: "url(#paint1_linear_78_".concat(generatedId2, ")") }),
        React.createElement("g", { filter: "url(#filter0_d_78_".concat(generatedId6, ")") },
            React.createElement("path", { d: 'M37.6968 87.2151C36.5581 87.2151 35.4451 86.9112 34.4737 86.3342L9.26825 71.3643C7.53127 70.3283 6.43762 68.5354 6.35398 66.5687L4.83574 31.7528C4.56554 25.5923 8.88225 20.0709 15.0903 18.6254L36.2493 13.6872C36.7189 13.5755 37.2078 13.5197 37.6968 13.5197C38.1857 13.5197 38.6682 13.5755 39.1443 13.6872L60.3032 18.6254C66.5177 20.0771 70.828 25.5985 70.5578 31.7528L69.0396 66.5687C68.9559 68.5354 67.8623 70.3283 66.1253 71.3643L40.9198 86.3342C39.9484 86.9112 38.8355 87.2151 37.6968 87.2151Z', fill: "url(#paint2_linear_78_".concat(generatedId3, ")") })),
        React.createElement("path", { d: 'M37.7843 86.4134C36.6704 86.4134 35.5817 86.116 34.6315 85.5516L9.97513 70.9079C8.27599 69.8944 7.20617 68.1406 7.12436 66.2168L5.63919 32.1594C5.37488 26.1331 9.59754 20.732 15.6704 19.318L36.3684 14.4873C36.8278 14.3781 37.306 14.3235 37.7843 14.3235C38.2626 14.3235 38.7346 14.3781 39.2002 14.4873L59.8982 19.318C65.9773 20.7381 70.1937 26.1392 69.9294 32.1594L68.4442 66.2168C68.3624 68.1406 67.2926 69.8944 65.5935 70.9079L40.9371 85.5516C39.9869 86.116 38.8982 86.4134 37.7843 86.4134Z', fill: "url(#paint3_linear_78_".concat(generatedId4, ")") }),
        React.createElement("path", { d: 'M39.8817 18.7091C39.8817 19.486 39.2264 20.1181 38.4211 20.1181C37.6158 20.1181 36.9604 19.486 36.9604 18.7091C36.9604 17.9322 37.6158 17.3 38.4211 17.3C39.2264 17.3 39.8817 17.9322 39.8817 18.7091Z', className: 'l-svg-color1' }),
        React.createElement("path", { opacity: '0.5', d: 'M56.5391 23.2091C56.5391 23.986 57.1944 24.6181 57.9998 24.6181C58.8051 24.6181 59.4604 23.986 59.4604 23.2091C59.4604 22.4322 58.8051 21.8 57.9998 21.8C57.1944 21.8 56.5391 22.4322 56.5391 23.2091Z', className: 'l-svg-color1' }),
        React.createElement("path", { d: 'M50.0391 21.7091C50.0391 22.486 50.6944 23.1181 51.4998 23.1181C52.3051 23.1181 52.9604 22.486 52.9604 21.7091C52.9604 20.9322 52.3051 20.3 51.4998 20.3C50.6944 20.3 50.0391 20.9322 50.0391 21.7091Z', className: 'l-svg-color1' }),
        React.createElement("path", { opacity: '0.5', d: 'M46.4606 19.891C46.4606 20.6679 45.8053 21.3 45 21.3C44.1947 21.3 43.5394 20.6679 43.5394 19.891C43.5394 19.1141 44.1947 18.4819 45 18.4819C45.8053 18.4819 46.4606 19.1141 46.4606 19.891Z', className: 'l-svg-color1' }),
        React.createElement("path", { opacity: '0.5', d: 'M20.3212 23.2091C20.3212 23.986 19.6659 24.6181 18.8606 24.6181C18.0553 24.6181 17.4 23.986 17.4 23.2091C17.4 22.4322 18.0553 21.8 18.8606 21.8C19.6659 21.8 20.3212 22.4322 20.3212 23.2091Z', className: 'l-svg-color1' }),
        React.createElement("path", { d: 'M26.8212 21.7091C26.8212 22.486 26.1659 23.1181 25.3606 23.1181C24.5553 23.1181 23.9 22.486 23.9 21.7091C23.9 20.9322 24.5553 20.3 25.3606 20.3C26.1659 20.3 26.8212 20.9322 26.8212 21.7091Z', className: 'l-svg-color1' }),
        React.createElement("path", { opacity: '0.5', d: 'M30.4007 19.891C30.4007 20.6679 31.056 21.3 31.8613 21.3C32.6667 21.3 33.322 20.6679 33.322 19.891C33.322 19.1141 32.6667 18.4819 31.8613 18.4819C31.056 18.4819 30.4007 19.1141 30.4007 19.891Z', className: 'l-svg-color1' }),
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M37 3C37 1.34314 38.3378 0 39.9878 0H312.105C316.178 0 319.84 2.4895 321.353 6.28607L337.288 46.2861C338.237 48.6702 338.237 51.3298 337.288 53.7139L321.353 93.7139C319.84 97.5105 316.178 100 312.105 100H39.9878C38.3378 100 37 98.6569 37 97V93.7295C37.1799 93.7377 37.3608 93.7418 37.5417 93.7419C39.6926 93.7407 41.7895 93.1664 43.6199 92.0769L69.8195 76.5045C73.1098 74.5491 75.1692 71.161 75.3297 67.4373L76.9077 31.2201C77.2958 22.4175 71.1369 14.5248 62.2635 12.4532L40.2698 7.31622C39.3804 7.10327 38.4579 7 37.5417 7C37.3613 7 37.1804 7.00427 37 7.01263V3ZM37.9959 3C37.9959 2.34314 38.3378 1 39.9878 1H312.105C316.178 1 318.844 3.4895 320.357 7.28607L336.292 46.2861C337.242 48.6702 337.242 51.3298 336.292 53.7139L320.357 92.7139C318.844 96.5105 315.182 99 311.109 99H40.9837C39.3337 99 37.9959 98.6569 37.9959 97V94.7295L38.1423 94.7352C38.2741 94.7396 38.4059 94.7419 38.5377 94.7419C40.6885 94.7407 43.7814 93.1664 45.6118 92.0769L71.8114 76.5045C75.1016 74.5491 76.1652 71.161 76.3256 67.4373L77.9037 31.2201C78.3311 21.5 71.8576 13.5 62.2635 11.4532L40.2698 6.31622C39.9931 6.24994 39.8093 6.19427 39.66 6.14905C39.3303 6.04895 39.1689 6 38.5377 6C38.3572 6 38.1763 6.00427 37.9959 6.01263V3Z', fill: "url(#paint4_linear_78_".concat(generatedId5, ")") }),
        React.createElement("defs", null,
            React.createElement("filter", { id: "filter0_d_78_".concat(generatedId6), x: '4.82373', y: '13.5197', width: '65.7461', height: '74.0974', filterUnits: 'userSpaceOnUse', colorInterpolationFilters: 'sRGB' },
                React.createElement("feFlood", { floodOpacity: '0', result: 'BackgroundImageFix' }),
                React.createElement("feColorMatrix", { in: 'SourceAlpha', type: 'matrix', values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0', result: 'hardAlpha' }),
                React.createElement("feOffset", { dy: '0.401961' }),
                React.createElement("feComposite", { in2: 'hardAlpha', operator: 'out' }),
                React.createElement("feColorMatrix", { type: 'matrix', values: '0 0 0 0 0.0392157 0 0 0 0 0.0823529 0 0 0 0 0.517647 0 0 0 0.8 0' }),
                React.createElement("feBlend", { mode: 'normal', in2: 'BackgroundImageFix', result: 'effect1_dropShadow_78_62' }),
                React.createElement("feBlend", { mode: 'normal', in: 'SourceGraphic', in2: 'effect1_dropShadow_78_62', result: 'shape' })),
            React.createElement("linearGradient", { id: "paint0_linear_78_".concat(generatedId1), x1: '37.3884', y1: '5.57723', x2: '37.3884', y2: '82.0805', gradientUnits: 'userSpaceOnUse' },
                React.createElement("stop", { offset: '0.48', className: 'l-stop-color3' }),
                React.createElement("stop", { offset: '1', className: 'l-stop-color4' }),
                React.createElement("stop", { offset: '1', className: 'l-stop-color4' })),
            React.createElement("linearGradient", { id: "paint1_linear_78_".concat(generatedId2), x1: '37.7844', y1: '11.1078', x2: '37.7844', y2: '90.2941', gradientUnits: 'userSpaceOnUse' },
                React.createElement("stop", { className: 'l-stop-color5' }),
                React.createElement("stop", { offset: '0.344441', className: 'l-stop-color6' }),
                React.createElement("stop", { offset: '1', className: 'l-stop-color7' })),
            React.createElement("linearGradient", { id: "paint2_linear_78_".concat(generatedId3), x1: '37.6968', y1: '16.299', x2: '37.6968', y2: '115.163', gradientUnits: 'userSpaceOnUse' },
                React.createElement("stop", { className: 'l-stop-color8' }),
                React.createElement("stop", { offset: '1', className: 'l-stop-color9' })),
            React.createElement("linearGradient", { id: "paint3_linear_78_".concat(generatedId4), x1: '37.7843', y1: '12.4564', x2: '37.5102', y2: '86.0347', gradientUnits: 'userSpaceOnUse' },
                React.createElement("stop", { className: 'l-stop-color10' }),
                React.createElement("stop", { offset: '0.343442', className: 'l-stop-color11' }),
                React.createElement("stop", { offset: '0.511465', className: 'l-stop-color12' }),
                React.createElement("stop", { offset: '0.772339', className: 'l-stop-color13' }),
                React.createElement("stop", { offset: '1', className: 'l-stop-color4' })),
            React.createElement("linearGradient", { id: "paint4_linear_78_".concat(generatedId5), x1: '37.1173', y1: '50', x2: '338.099', y2: '52.3385', gradientUnits: 'userSpaceOnUse' },
                React.createElement("stop", { className: 'l-stop-color1' }),
                React.createElement("stop", { offset: '0.338542', className: 'l-stop-color2' }),
                React.createElement("stop", { offset: '0.895833', className: 'l-stop-color1' }),
                React.createElement("stop", { offset: '1', className: 'l-stop-color1', stopOpacity: '0' }))))) : (React.createElement("svg", { width: '100%', height: '100%', viewBox: '0 0 184 271', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M91.9996 104.831C89.5077 104.829 87.0833 104.167 84.9705 102.914L51.3748 83.02C47.5784 80.7721 45.2347 76.8967 45.0436 72.6609L43.309 33H11.5C5.14868 33 0 38.1487 0 44.5V227.01C0 231.745 2.90247 235.996 7.31262 237.72L87.8639 269.213C90.5209 270.251 93.4691 270.266 96.136 269.252L176.585 238.686C181.049 236.99 184 232.711 184 227.936V44.5C184 38.1487 178.851 33 172.5 33H140.69L138.956 72.6621C138.772 76.8944 136.423 80.771 132.625 83.02L99.0287 102.914C96.916 104.167 94.4916 104.829 91.9996 104.831Z', className: 'l-svg-color2' }),
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M84.9705 102.914C87.0832 104.167 89.5077 104.829 91.9996 104.831C94.4915 104.829 96.9161 104.167 99.0287 102.914L132.625 83.0201L133.389 84.3107L99.7939 104.204C97.4469 105.596 94.7576 106.329 91.9996 106.331C89.2416 106.329 86.5524 105.596 84.2054 104.204L50.6105 84.3107L51.3748 83.0201L84.9705 102.914ZM43.5451 72.7277C43.7594 77.4846 46.3918 81.8128 50.6105 84.3107L51.3748 83.0201C47.5784 80.7721 45.2347 76.8968 45.0436 72.6609L43.3089 33H11.5C5.14873 33 0 38.1487 0 44.5V227.009C0 231.745 2.90245 235.996 7.31257 237.72L87.8639 269.213C90.5209 270.252 93.4691 270.266 96.1359 269.252L176.585 238.686C181.049 236.99 184 232.711 184 227.936V44.5C184 38.1487 178.851 33 172.5 33H140.69L138.956 72.6622C138.773 76.8944 136.423 80.771 132.625 83.0201L133.389 84.3107C137.607 81.8128 140.248 77.4846 140.454 72.7277L142.126 34.5H172.5C178.023 34.5 182.5 38.9772 182.5 44.5V227.936C182.5 232.088 179.934 235.809 176.052 237.284L95.6032 267.85C93.2842 268.731 90.7205 268.719 88.4101 267.816L7.85876 236.323C4.02387 234.824 1.5 231.127 1.5 227.009V44.5C1.5 38.9772 5.97715 34.5 11.5 34.5H41.8731L43.5451 72.7277Z', fill: "url(#paint0_linear_35_".concat(generatedId1, ")") }),
        React.createElement("path", { d: 'M92.0076 102C89.4653 102 86.9861 101.325 84.8228 100.042L53.8889 81.7305C50.0043 79.4311 47.5805 75.4471 47.3831 71.0684L45.5198 28.4805C45.0698 18.1295 52.3414 8.85604 62.8106 6.41247L88.7784 0.371846C89.8284 0.129007 90.918 0 91.9997 0C93.0813 0 94.1709 0.121418 95.221 0.371846L121.189 6.41247C131.666 8.84845 138.937 18.1295 138.48 28.4805L136.616 71.0684C136.427 75.4471 133.995 79.4311 130.11 81.7305L99.1765 100.042C97.0132 101.325 94.5341 102 91.9918 102H92.0076Z', fill: "url(#paint1_linear_35_".concat(generatedId2, ")") }),
        React.createElement("g", { filter: "url(#filter0_d_35_".concat(generatedId7, ")") },
            React.createElement("path", { d: 'M92.3909 96.67C90.9744 96.67 89.59 96.2919 88.3817 95.5742L57.0285 76.9531C54.8679 75.6644 53.5075 73.4342 53.4035 70.9879L51.5149 27.6802C51.1788 20.0172 56.5484 13.1491 64.2707 11.3511L90.5903 5.20836C91.1745 5.06945 91.7827 5 92.3909 5C92.999 5 93.5992 5.06945 94.1914 5.20836L120.511 11.3511C128.241 13.1568 133.603 20.025 133.267 27.6802L131.378 70.9879C131.274 73.4342 129.914 75.6644 127.753 76.9531L96.4 95.5742C95.1917 96.2919 93.8073 96.67 92.3909 96.67Z', fill: "url(#paint3_linear_35_".concat(generatedId4, ")") })),
        React.createElement("path", { d: 'M92.5 95.6728C91.1144 95.6728 89.7602 95.3029 88.5782 94.6009L57.9081 76.3855C55.7945 75.1248 54.4638 72.9432 54.362 70.5502L52.5146 28.1861C52.1858 20.6901 57.4384 13.9716 64.9924 12.2127L90.7387 6.20382C91.3101 6.06794 91.9051 6 92.5 6C93.0949 6 93.682 6.06794 94.2613 6.20382L120.008 12.2127C127.569 13.9791 132.814 20.6976 132.485 28.1861L130.638 70.5502C130.536 72.9432 129.205 75.1248 127.092 76.3855L96.4218 94.6009C95.2398 95.3029 93.8855 95.6728 92.5 95.6728Z', fill: "url(#paint4_linear_35_".concat(generatedId5, ")") }),
        React.createElement("path", { d: 'M93.4213 10.409C93.4213 11.1859 92.766 11.8181 91.9606 11.8181C91.1553 11.8181 90.5 11.1859 90.5 10.409C90.5 9.63216 91.1553 9 91.9606 9C92.766 9 93.4213 9.63216 93.4213 10.409Z', className: 'l-svg-color1' }),
        React.createElement("path", { opacity: '0.5', d: 'M111.539 15.091C111.539 15.8678 112.195 16.5 113 16.5C113.805 16.5 114.461 15.8678 114.461 15.091C114.461 14.3141 113.805 13.6819 113 13.6819C112.195 13.6819 111.539 14.3141 111.539 15.091Z', className: 'l-svg-color1' }),
        React.createElement("path", { d: 'M104.579 13.5C104.579 14.2769 105.234 14.909 106.039 14.909C106.845 14.909 107.5 14.2769 107.5 13.5C107.5 12.7231 106.845 12.091 106.039 12.091C105.234 12.091 104.579 12.7231 104.579 13.5Z', className: 'l-svg-color1' }),
        React.createElement("path", { opacity: '0.5', d: 'M100.461 11.909C100.461 12.6859 99.8052 13.3181 98.9999 13.3181C98.1946 13.3181 97.5392 12.6859 97.5392 11.909C97.5392 11.1322 98.1946 10.5 98.9999 10.5C99.8052 10.5 100.461 11.1322 100.461 11.909Z', className: 'l-svg-color1' }),
        React.createElement("path", { opacity: '0.5', d: 'M72.4605 15.091C72.4605 15.8678 71.8052 16.5 70.9999 16.5C70.1946 16.5 69.5392 15.8678 69.5392 15.091C69.5392 14.3141 70.1946 13.6819 70.9999 13.6819C71.8052 13.6819 72.4605 14.3141 72.4605 15.091Z', className: 'l-svg-color1' }),
        React.createElement("path", { d: 'M79.4213 13.5C79.4213 14.2769 78.766 14.909 77.9606 14.909C77.1553 14.909 76.5 14.2769 76.5 13.5C76.5 12.7231 77.1553 12.091 77.9606 12.091C78.766 12.091 79.4213 12.7231 79.4213 13.5Z', className: 'l-svg-color1' }),
        React.createElement("path", { opacity: '0.5', d: 'M83.5395 11.909C83.5395 12.6859 84.1948 13.3181 85.0001 13.3181C85.8054 13.3181 86.4608 12.6859 86.4608 11.909C86.4608 11.1322 85.8054 10.5 85.0001 10.5C84.1948 10.5 83.5395 11.1322 83.5395 11.909Z', className: 'l-svg-color1' }),
        React.createElement("g", { filter: "url(#filter1_d_35_".concat(generatedId9, ")") },
            React.createElement("circle", { cx: '8', cy: '8', r: '7.5', transform: 'matrix(1 0 0 -1 84 250)', stroke: "url(#paint5_linear_35_".concat(generatedId6, ")") })),
        React.createElement("path", { d: 'M97.5 242C97.5 238.962 95.0376 236.5 92 236.5C88.9624 236.5 86.5 238.962 86.5 242C86.5 245.038 88.9624 247.5 92 247.5C95.0376 247.5 97.5 245.038 97.5 242Z', fill: "url(#paint6_linear_35_".concat(generatedId7, ")"), className: 'circle-active' }),
        React.createElement("defs", null,
            React.createElement("filter", { id: "filter0_d_35_".concat(generatedId8), x: '51.5', y: '5', width: '81.7817', height: '92.17', filterUnits: 'userSpaceOnUse', colorInterpolationFilters: 'sRGB' },
                React.createElement("feFlood", { floodOpacity: '0', result: 'BackgroundImageFix' }),
                React.createElement("feColorMatrix", { in: 'SourceAlpha', type: 'matrix', values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0', result: 'hardAlpha' }),
                React.createElement("feOffset", { dy: '0.5' }),
                React.createElement("feComposite", { in2: 'hardAlpha', operator: 'out' }),
                React.createElement("feColorMatrix", { type: 'matrix', values: '0 0 0 0 0.0392157 0 0 0 0 0.0823529 0 0 0 0 0.517647 0 0 0 0.8 0' }),
                React.createElement("feBlend", { mode: 'normal', in2: 'BackgroundImageFix', result: 'effect1_dropShadow_35_2724' }),
                React.createElement("feBlend", { mode: 'normal', in: 'SourceGraphic', in2: 'effect1_dropShadow_35_2724', result: 'shape' })),
            React.createElement("filter", { id: "filter1_d_35_".concat(generatedId9), x: '83', y: '233', width: '18', height: '18', filterUnits: 'userSpaceOnUse', colorInterpolationFilters: 'sRGB' },
                React.createElement("feFlood", { floodOpacity: '0', result: 'BackgroundImageFix' }),
                React.createElement("feColorMatrix", { in: 'SourceAlpha', type: 'matrix', values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0', result: 'hardAlpha' }),
                React.createElement("feOffset", null),
                React.createElement("feGaussianBlur", { stdDeviation: '0.5' }),
                React.createElement("feComposite", { in2: 'hardAlpha', operator: 'out' }),
                React.createElement("feColorMatrix", { type: 'matrix', values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0' }),
                React.createElement("feBlend", { mode: 'normal', in2: 'BackgroundImageFix', result: 'effect1_dropShadow_35_2724' }),
                React.createElement("feBlend", { mode: 'normal', in: 'SourceGraphic', in2: 'effect1_dropShadow_35_2724', result: 'shape' })),
            React.createElement("linearGradient", { id: "paint0_linear_35_".concat(generatedId1), x1: '92', y1: '33', x2: '92.5045', y2: '270', gradientUnits: 'userSpaceOnUse' },
                React.createElement("stop", { className: 'l-stop-color1' }),
                React.createElement("stop", { offset: '0.338542', className: 'l-stop-color2' }),
                React.createElement("stop", { offset: '0.895833', className: 'l-stop-color1' }),
                React.createElement("stop", { offset: '1', className: 'l-stop-color1', stopOpacity: '0' })),
            React.createElement("linearGradient", { id: "paint1_linear_35_".concat(generatedId2), x1: '92.0076', y1: '-4.87955', x2: '92.0076', y2: '90.283', gradientUnits: 'userSpaceOnUse' },
                React.createElement("stop", { offset: '0.48', className: 'l-stop-color3' }),
                React.createElement("stop", { offset: '1', className: 'l-stop-color4' }),
                React.createElement("stop", { offset: '1', className: 'l-stop-color4' })),
            React.createElement("linearGradient", { id: "paint3_linear_35_".concat(generatedId4), x1: '92.3909', y1: '8.45721', x2: '92.3909', y2: '131.435', gradientUnits: 'userSpaceOnUse' },
                React.createElement("stop", { className: 'l-stop-color8' }),
                React.createElement("stop", { offset: '1', className: 'l-stop-color9' })),
            React.createElement("linearGradient", { id: "paint4_linear_35_".concat(generatedId5), x1: '92.5', y1: '3.67755', x2: '92.159', y2: '95.2017', gradientUnits: 'userSpaceOnUse' },
                React.createElement("stop", { className: 'l-stop-color10' }),
                React.createElement("stop", { offset: '0.343442', className: 'l-stop-color11' }),
                React.createElement("stop", { offset: '0.511465', className: 'l-stop-color12' }),
                React.createElement("stop", { offset: '0.772339', className: 'l-stop-color13' }),
                React.createElement("stop", { offset: '1', className: 'l-stop-color4' })),
            React.createElement("linearGradient", { id: "paint5_linear_35_".concat(generatedId6), x1: '8', y1: '0', x2: '8', y2: '16', gradientUnits: 'userSpaceOnUse' },
                React.createElement("stop", { className: 'l-stop-color14' }),
                React.createElement("stop", { offset: '0.51881', className: 'l-stop-color15' }),
                React.createElement("stop", { offset: '1', className: 'l-stop-color14' })),
            React.createElement("linearGradient", { id: "paint6_linear_35_".concat(generatedId7), x1: '92.5', y1: '247', x2: '92.5', y2: '236', gradientUnits: 'userSpaceOnUse' },
                React.createElement("stop", { className: 'l-stop-color16' }),
                React.createElement("stop", { offset: '0.516128', className: 'l-stop-color17' }),
                React.createElement("stop", { offset: '1', className: 'l-stop-color16' })))));
};

var LobbyItemTopBlock = function (_a) {
    var t = _a.t, minBet = _a.minBet, maxWin = _a.maxWin, maxBet = _a.maxBet, duration = _a.duration, lobbyTitle = _a.lobbyTitle, isShowIconTag = _a.isShowIconTag, activeUsersCount = _a.activeUsersCount, currencySymbolOrCode = _a.currencySymbolOrCode;
    return (React.createElement("div", { className: 'lobby-item-content' },
        React.createElement("div", { className: 'lobby-item-contest-type' },
            React.createElement("div", { className: 'lobby-item-timer' },
                React.createElement("p", { className: 'lobby-item-timer-txt' }, duration),
                isShowIconTag && React.createElement("i", { className: "ui-lib-".concat(IconTypes.LobbyTimer) })),
            React.createElement("p", { className: 'lobby-item-contest-title' }, lobbyTitle),
            React.createElement("div", { className: 'lobby-item-contest-icon-user' },
                React.createElement("i", { className: "ui-lib-".concat(IconTypes.User) }),
                React.createElement("span", { className: 'contest-user-count' }, activeUsersCount))),
        React.createElement("div", { className: 'lobby-item-max-block' },
            React.createElement("div", { className: 'lobby-item-max-win-block' },
                React.createElement("p", { className: 'lobby-item-max-win-title' }, t(TranslationKeys.MaximumWin)),
                React.createElement("p", { className: 'lobby-item-amount' }, getAmountWithCurrency({ isReturnPreValue: true, isShowRealCurrency: true }) ? (React.createElement(React.Fragment, null,
                    React.createElement("span", null, currencySymbolOrCode),
                    convertAmount(maxWin))) : (React.createElement(React.Fragment, null,
                    convertAmount(maxWin),
                    React.createElement("span", null, currencySymbolOrCode))))),
            React.createElement("div", { className: 'lobby-item-max-bet-row-wrp' },
                React.createElement("div", { className: 'lobby-item-max-bet-row' },
                    React.createElement("p", { className: 'l-i-m-bet-title' }, t(TranslationKeys.MinimumBet)),
                    React.createElement("p", { className: 'l-i-m-bet-amount' }, getAmountWithCurrency({ isReturnPreValue: true, isShowRealCurrency: true }) ? (React.createElement(React.Fragment, null,
                        React.createElement("span", null, currencySymbolOrCode),
                        convertAmount(minBet))) : (React.createElement(React.Fragment, null,
                        convertAmount(minBet),
                        React.createElement("span", null, currencySymbolOrCode))))),
                React.createElement("div", { className: 'lobby-item-max-bet-row' },
                    React.createElement("p", { className: 'l-i-m-bet-title' }, t(TranslationKeys.MaximumBet)),
                    React.createElement("p", { className: 'l-i-m-bet-amount' }, getAmountWithCurrency({ isReturnPreValue: true, isShowRealCurrency: true }) ? (React.createElement(React.Fragment, null,
                        React.createElement("span", null, currencySymbolOrCode),
                        convertAmount(maxBet))) : (React.createElement(React.Fragment, null,
                        convertAmount(maxBet),
                        React.createElement("span", null, currencySymbolOrCode)))))))));
};

var LobbyItem = function (_a) {
    var t = _a.t, type = _a.type, minBet = _a.minBet, maxWin = _a.maxWin, maxBet = _a.maxBet, duration = _a.duration, lobbyTitle = _a.lobbyTitle, isShowIconTag = _a.isShowIconTag, activeUsersCount = _a.activeUsersCount, isGameTypeSelected = _a.isGameTypeSelected, currencySymbolOrCode = _a.currencySymbolOrCode, setSelectedGameTypeId = _a.setSelectedGameTypeId;
    return (React.createElement("div", { className: "lobby-item ".concat(isGameTypeSelected ? 'active' : '', " type-").concat(type), onClick: setSelectedGameTypeId },
        React.createElement(LobbyItemTopBlock, { t: t, minBet: minBet, maxWin: maxWin, maxBet: maxBet, duration: duration, lobbyTitle: lobbyTitle, activeUsersCount: activeUsersCount, currencySymbolOrCode: currencySymbolOrCode, isShowIconTag: isShowIconTag }),
        React.createElement(LobbyItemBottomBlock, { type: type })));
};

var titleDependOnItemType$1 = {
    0: 'Classic',
    1: 'Pro',
    2: 'Vip',
};
var BogLobby = function (_a) {
    var t = _a.t, isSilentMode = _a.isSilentMode, isShowIconTag = _a.isShowIconTag, gameTypes = _a.gameTypes, handleContinue = _a.handleContinue, lobbyLogoImageSrc = _a.lobbyLogoImageSrc, hasSilentModeSwitcher = _a.hasSilentModeSwitcher, realCurrencySymbolOrCode = _a.realCurrencySymbolOrCode, localSelectedGameTypeId = _a.localSelectedGameTypeId, toggleIsSilentMode = _a.toggleIsSilentMode, setLocalSelectedGameTypeId = _a.setLocalSelectedGameTypeId;
    return (React.createElement("div", { className: 'lobby-wrp' },
        !isMobile() && (React.createElement("div", { className: 'lobby-wrp-header-btn-home', onClick: function () { return iframeService.exitGame(); } },
            React.createElement(IconBlock, { iconType: IconTypes.Home }))),
        !isMobile() && (React.createElement("div", { className: 'lobby-img-logo' },
            React.createElement("img", { src: lobbyLogoImageSrc, alt: 'lobby-logo' }))),
        React.createElement("p", { className: 'lobby-title' }, t(TranslationKeys.ChooseContest)),
        React.createElement("div", { className: 'lobby-item-wrp' },
            React.createElement("div", { className: 'lobby-item-holder' }, gameTypes.map(function (_a, index) {
                var minBet = _a.minBet, maxWin = _a.maxWin, maxBet = _a.maxBet, gameTypeId = _a.gameTypeId, duration = _a.duration, activeUsersCount = _a.activeUsersCount;
                return (React.createElement(LobbyItem, { t: t, key: gameTypeId, type: index + 1, minBet: minBet, maxWin: maxWin, maxBet: maxBet, duration: duration, isShowIconTag: isShowIconTag, activeUsersCount: activeUsersCount, lobbyTitle: titleDependOnItemType$1[index], currencySymbolOrCode: realCurrencySymbolOrCode, isGameTypeSelected: +localSelectedGameTypeId === +gameTypeId, setSelectedGameTypeId: function () { return setLocalSelectedGameTypeId(+gameTypeId); } }));
            }))),
        React.createElement("div", { className: 'lobby-btn-wrp' },
            React.createElement("button", { type: 'submit', className: 'btn-check', onClick: handleContinue },
                React.createElement("span", { className: 'btn-check-sp' }, t(TranslationKeys.Continue)))),
        hasSilentModeSwitcher && (React.createElement(SettingsBlock.Row, { isModeSwitcher: true, text: t(TranslationKeys.SilentMode), handler: toggleIsSilentMode, switcherIconType: isSilentMode ? IconTypes.VolumeOff : IconTypes.VolumeUp, isChecked: isSilentMode }))));
};

var MaxWinPopup = observer(function () {
    var limits = gameConfigStore.limits;
    var extraFreeBetData = freeBetStore.extraFreeBetData;
    var t = useTranslation();
    var firstAvailableMaxWinData = Object.values(extraFreeBetData).find(function (data) { return data.isShowPopUp && !data.isAlreadySeenPopUp && !data.freeBetId; });
    if (!firstAvailableMaxWinData) {
        return React.createElement(React.Fragment, null);
    }
    var currentIndex = firstAvailableMaxWinData.currentIndex;
    return (React.createElement("div", { className: 'max-win-popups', key: currentIndex },
        React.createElement("p", { className: 'max-win-pop-text' }, t(TranslationKeys.MaxWinPayout)),
        React.createElement("p", { className: 'max-win-pop-amount' }, getAmountWithCurrency({
            amount: convertAmount((limits === null || limits === void 0 ? void 0 : limits.maxWin) || ''),
        }))));
});

var FreeBetMaxPayoutPopUp = observer(function () {
    var t = useTranslation();
    var extraFreeBetData = freeBetStore.extraFreeBetData;
    var firstAvailableMaxPayoutData = Object.values(extraFreeBetData).find(function (data) { return data.isShowPopUp && !data.isAlreadySeenPopUp && data.freeBetId; });
    if (!firstAvailableMaxPayoutData) {
        return React.createElement(React.Fragment, null);
    }
    var currentIndex = firstAvailableMaxPayoutData.currentIndex, maxPayout = firstAvailableMaxPayoutData.maxPayout;
    return (React.createElement("div", { className: 'free-bet-popup max-payout', key: currentIndex },
        React.createElement("div", { className: 'free-bet-popup-content cashout' },
            React.createElement("div", { className: 'free-bet-popup-content-inner' },
                React.createElement("div", { className: 'free-bat-cashout-bl' },
                    React.createElement("p", null, t(TranslationKeys.FreeBetMaxWinPayout)),
                    React.createElement("span", null, getAmountWithCurrency({ amount: maxPayout })),
                    React.createElement("button", { className: 'cashout-btn', onClick: function () {
                            var _a;
                            freeBetStore.updateExtraFreeBetData({
                                sectionId: Number(currentIndex),
                                updatedDataByKeys: (_a = {},
                                    _a[UpdatedFreeBetDataItemKeys.IS_SHOW_POP_UP] = false,
                                    _a[UpdatedFreeBetDataItemKeys.IS_ALREADY_SEEN_POP_UP] = true,
                                    _a),
                            });
                        } }, t(TranslationKeys.Ok)))))));
});

var LimitsBlock = observer(function () {
    var t = useTranslation();
    var _a = gameConfigStore.limits, limits = _a === void 0 ? {} : _a;
    var _b = parseQuery(window.location.search), _c = DefaultQueryParams.Culture, culture = _b[_c];
    var isShowWithoutChange = rtlLanguages.includes(culture);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'top-row-min-max-txt' },
            t(TranslationKeys.MinBet),
            " -",
            getAmountWithCurrency({ amount: convertAmount(limits.minBet || ''), isShowWithoutChange: isShowWithoutChange })),
        React.createElement("div", { className: 'top-row-min-max-txt' },
            t(TranslationKeys.MaxBet),
            " -",
            getAmountWithCurrency({ amount: convertAmount(limits.maxBet || ''), isShowWithoutChange: isShowWithoutChange }))));
});

var CollapsibleSettingsList = observer(function (_a) {
    var children = _a.children, isCollapsibleSettingsListOpened = _a.isCollapsibleSettingsListOpened, setCollapsibleFreeBetComponentsType = _a.setCollapsibleFreeBetComponentsType, setCollapsibleSettingComponentsType = _a.setCollapsibleSettingComponentsType, isSettingsBlockOpened = _a.isSettingsBlockOpened, isFreeBetsBlockOpened = _a.isFreeBetsBlockOpened, isShowFreeBetIcon = _a.isShowFreeBetIcon;
    var isMusicOn = userSettingsStore.isMusicOn, isSoundOn = userSettingsStore.isSoundOn;
    var popupToggle = popupStore.popupToggle;
    return (React.createElement("div", { className: "open-settings-wrp ".concat(isCollapsibleSettingsListOpened ? 'active' : '') },
        React.createElement("div", { className: 'open-settings-inner' },
            React.createElement("div", { className: 'open-settings-block', onClick: function () { return userSettingsStore.setIsMusicOnAndIsSoundOn(); } },
                React.createElement("i", { className: "ui-lib-".concat(isMusicOn || isSoundOn ? IconTypes.VolumeUp : IconTypes.VolumeOff) })),
            isShowFreeBetIcon && (React.createElement("div", { className: "open-settings-block ".concat(isFreeBetsBlockOpened ? 'active' : ''), onClick: setCollapsibleFreeBetComponentsType },
                React.createElement("i", { className: "ui-lib-".concat(IconTypes.Gift) }))),
            React.createElement("div", { className: "open-settings-block ".concat(isSettingsBlockOpened ? 'active' : ''), onClick: setCollapsibleSettingComponentsType },
                React.createElement("i", { className: "ui-lib-".concat(IconTypes.Settings1) })),
            React.createElement("div", { className: "open-settings-block ".concat(popupToggle ? 'active' : ''), onClick: function () { return popupStore.open(); } },
                React.createElement("i", { className: "ui-lib-".concat(IconTypes.Question) }))),
        children));
});

var GameTypeItem = function (_a) {
    var t = _a.t, minBet = _a.minBet, maxBet = _a.maxBet, onClick = _a.onClick, gameTypeTitle = _a.gameTypeTitle, gameTypeColor = _a.gameTypeColor, activeUsersCount = _a.activeUsersCount, currencySymbolOrCode = _a.currencySymbolOrCode;
    return (React.createElement("div", { className: "game-type-item ".concat(gameTypeColor), onClick: onClick },
        React.createElement("div", { className: 'content-centered' },
            React.createElement("p", { className: 'price' },
                t(TranslationKeys.Min),
                "/",
                t(TranslationKeys.Max),
                " ",
                currencySymbolOrCode),
            React.createElement("p", { className: 'count' },
                minBet,
                " / ",
                maxBet)),
        React.createElement("h3", { className: 'game-title' }, gameTypeTitle),
        React.createElement("div", { className: 'content-bottom' },
            React.createElement("p", { className: 'num' }, activeUsersCount),
            React.createElement("i", { className: 'icon-group group' }))));
};

var titleDependOnItemType = {
    0: { title: 'CLASSIC', color: 'blue' },
    1: { title: 'PRO', color: 'green' },
    2: { title: 'VIP', color: 'orange' },
};
var GameTypesPopup = function (_a) {
    var t = _a.t, isMusicOn = _a.isMusicOn, isSoundOn = _a.isSoundOn, gameTypes = _a.gameTypes, closePopup = _a.closePopup, handleContinue = _a.handleContinue, lobbyLogoImageSrc = _a.lobbyLogoImageSrc, hasSilentModeSwitcher = _a.hasSilentModeSwitcher, realCurrencySymbolOrCode = _a.realCurrencySymbolOrCode, setIsMusicOnAndIsSoundOn = _a.setIsMusicOnAndIsSoundOn;
    return (React.createElement("div", { className: 'game-type-container' },
        React.createElement("div", { className: 'heading-wrapper' },
            React.createElement("div", { className: 'positioned-icon left', onClick: function () { return iframeService.exitGame(); } },
                React.createElement("span", { className: 'icon-home3' })),
            React.createElement("div", { className: 'positioned-icon right', onClick: closePopup },
                React.createElement("div", { className: 'positioned-icon-inner' },
                    React.createElement("span", { className: 'icon-close-thin' })))),
        React.createElement("div", { className: 'game-type-logo' },
            React.createElement("img", { className: 'logo-img', src: lobbyLogoImageSrc, alt: 'lobby-logo' })),
        React.createElement("div", { className: 'game-type-heading' },
            React.createElement("p", { className: 'game-type-title' }, t(TranslationKeys.ChooseContest))),
        React.createElement("div", { className: 'game-type-wrapper' }, gameTypes.map(function (_a, index) {
            var minBet = _a.minBet, maxBet = _a.maxBet, gameTypeId = _a.gameTypeId, activeUsersCount = _a.activeUsersCount;
            return (React.createElement(GameTypeItem, { t: t, onClick: function () { return handleContinue(gameTypeId); }, key: gameTypeId, minBet: minBet, maxBet: maxBet, activeUsersCount: activeUsersCount, gameTypeTitle: titleDependOnItemType[index].title, gameTypeColor: titleDependOnItemType[index].color, currencySymbolOrCode: realCurrencySymbolOrCode }));
        })),
        hasSilentModeSwitcher && (React.createElement(SettingRow, null,
            React.createElement(SettingRowColumn, { position: 'left' },
                React.createElement(SettingRowColumn.Span, { text: t(TranslationKeys.SilentMode) })),
            React.createElement(SettingRowColumn, { position: 'right', onClick: setIsMusicOnAndIsSoundOn },
                React.createElement(SettingRowColumn.Switcher, { isChecked: !isMusicOn && !isSoundOn }))))));
};

var Lobby = observer(function (_a) {
    var _b;
    var lobbyLogoImageSrc = _a.lobbyLogoImageSrc, _c = _a.hasSilentModeSwitcher, hasSilentModeSwitcher = _c === void 0 ? true : _c, isShowBogLineLobby = _a.isShowBogLineLobby, isShowIconTag = _a.isShowIconTag;
    var setGameTypeId = gameConfigStore.setGameTypeId, gameTypeId = gameConfigStore.gameTypeId, gameConfigs = gameConfigStore.gameConfigs;
    var realCurrencySymbolOrCode = userInfoStore.realCurrencySymbolOrCode;
    var gameTypes = lobbyStore.gameTypes, setIsShowLobbySelectGameType = lobbyStore.setIsShowLobbySelectGameType;
    var alreadyRedirectedToGame = applicationStore.alreadyRedirectedToGame, setAlreadyRedirectedToGame = applicationStore.setAlreadyRedirectedToGame, isBogLine = applicationStore.isBogLine;
    var setGameTypeIdInLocalStorage = userSettingsStore.setGameTypeIdInLocalStorage, setIsMusicOnAndIsSoundOn = userSettingsStore.setIsMusicOnAndIsSoundOn, toggleIsSilentMode = userSettingsStore.toggleIsSilentMode, isMusicOn = userSettingsStore.isMusicOn, isSoundOn = userSettingsStore.isSoundOn, selectedGameTypeId = userSettingsStore.selectedGameTypeId, isSilentMode = userSettingsStore.isSilentMode;
    var _d = __read(useState(selectedGameTypeId || gameTypeId || ((_b = gameTypes === null || gameTypes === void 0 ? void 0 : gameTypes[0]) === null || _b === void 0 ? void 0 : _b.gameTypeId)), 2), localSelectedGameTypeId = _d[0], setLocalSelectedGameTypeId = _d[1];
    var t = useTranslation();
    useEffect(function () {
        if (!alreadyRedirectedToGame || isBogLine) {
            setIsMusicOnAndIsSoundOn(true);
            toggleIsSilentMode(true);
        }
    }, [alreadyRedirectedToGame, isBogLine]);
    var handleContinue = useCallback(function (clickedGameTypeId) {
        var changedGameTypeId = +clickedGameTypeId || +localSelectedGameTypeId;
        if (+selectedGameTypeId !== changedGameTypeId) {
            setGameTypeIdInLocalStorage(changedGameTypeId);
            setGameTypeId(changedGameTypeId);
            setAlreadyRedirectedToGame(true);
            if (isBogLine) {
                if (selectedGameTypeId) {
                    chatService.leaveRoom(selectedGameTypeId);
                    chatStore.setIsMessagesReceived(false);
                }
            }
            if (gameConfigs && gameConfigs.onGameTypeChangeCallback && !!selectedGameTypeId) {
                gameConfigs.onGameTypeChangeCallback();
            }
        }
        else {
            if (isBogLine) {
                userSettingsStore.setIsMusicOnAndIsSoundOn(isSilentMode);
            }
        }
        setIsShowLobbySelectGameType(false);
    }, [
        selectedGameTypeId,
        localSelectedGameTypeId,
        setGameTypeIdInLocalStorage,
        setGameTypeId,
        setAlreadyRedirectedToGame,
        isBogLine,
        gameConfigs,
        isSilentMode,
        setIsShowLobbySelectGameType,
    ]);
    return (React.createElement(React.Fragment, null, gameTypes && gameTypes.length ? (isShowBogLineLobby ? (React.createElement(BogLobby, { t: t, isSilentMode: isSilentMode, isShowIconTag: isShowIconTag, gameTypes: gameTypes, handleContinue: handleContinue, lobbyLogoImageSrc: lobbyLogoImageSrc, hasSilentModeSwitcher: hasSilentModeSwitcher, realCurrencySymbolOrCode: realCurrencySymbolOrCode, localSelectedGameTypeId: localSelectedGameTypeId, toggleIsSilentMode: function () { return toggleIsSilentMode(); }, setLocalSelectedGameTypeId: setLocalSelectedGameTypeId })) : (React.createElement(GameTypesPopup, { t: t, isMusicOn: isMusicOn, isSoundOn: isSoundOn, gameTypes: gameTypes, closePopup: function () { return setIsShowLobbySelectGameType(false); }, handleContinue: handleContinue, lobbyLogoImageSrc: lobbyLogoImageSrc, hasSilentModeSwitcher: hasSilentModeSwitcher, realCurrencySymbolOrCode: realCurrencySymbolOrCode, setIsMusicOnAndIsSoundOn: function () { return setIsMusicOnAndIsSoundOn(); } }))) : (React.createElement(React.Fragment, null))));
});

var LobbyWrapper = observer(function (_a) {
    var lobbyLogoImageSrc = _a.lobbyLogoImageSrc, hasSilentModeSwitcher = _a.hasSilentModeSwitcher, isShowBogLineLobby = _a.isShowBogLineLobby, isShowIconTag = _a.isShowIconTag;
    var isShowLobbySelectGameType = lobbyStore.isShowLobbySelectGameType;
    return isShowLobbySelectGameType ? (React.createElement(Lobby, { isShowIconTag: isShowIconTag, lobbyLogoImageSrc: lobbyLogoImageSrc, hasSilentModeSwitcher: hasSilentModeSwitcher, isShowBogLineLobby: isShowBogLineLobby })) : (React.createElement(React.Fragment, null));
});

var bodyRef = null;
var LoadingContainer = observer(function (_a) {
    var appDefaultValuesEnum = _a.appDefaultValuesEnum, gameSpecificRepliedCallback = _a.gameSpecificRepliedCallback, _b = _a.defaultLanguageName, defaultLanguageName = _b === void 0 ? 'defaultLanguage.json' : _b, gameLoadingImages = _a.gameLoadingImages, _c = _a.isNeedRtlChecker, isNeedRtlChecker = _c === void 0 ? true : _c, _d = _a.isNeedLoadTranslations, isNeedLoadTranslations = _d === void 0 ? true : _d, /// FOR DEVELOPMENT TIME
    children = _a.children;
    var updateLoading = loadingStore.updateLoading, isOneTimeTableLoads = loadingStore.isOneTimeTableLoads, timerFinished = loadingStore.timerFinished, progress = loadingStore.progress;
    var isRepliedGame = platformMessageStore.isRepliedGame, isBetShop = platformMessageStore.isBetShop;
    var repliedBetData = betStore.repliedBetData;
    var _e = __read(useState({}), 2), translations = _e[0], setTranslations = _e[1];
    var _f = __read(useState(false), 2), isDefaultLangJsonDataLoaded = _f[0], setIsDefaultLangJsonDataLoaded = _f[1];
    var _g = __read(useState(''), 2), language = _g[0], setLanguage = _g[1];
    useAssetsLoadedState(bodyRef);
    if (isBetShop) {
        useDisableFullScreenShortcuts();
    }
    useEffect(function () {
        bodyRef = document.querySelector('body');
        var loadJsonData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getFileByName(defaultLanguageName)];
                    case 1:
                        data = _a.sent();
                        setTranslations(data);
                        setIsDefaultLangJsonDataLoaded(true);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error loading JSON data:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        loadJsonData();
    }, []);
    useEffect(function () {
        if (isDefaultLangJsonDataLoaded) {
            if (isNeedLoadTranslations) {
                getTranslationsWithRetry(setTranslations, setLanguage, appDefaultValuesEnum, isNeedRtlChecker);
            }
            else {
                loadingStore.updateLoading({ isTranslationsLoaded: true });
                setLanguage(appDefaultValuesEnum.LANGUAGE);
            }
        }
    }, [isDefaultLangJsonDataLoaded, isNeedLoadTranslations, appDefaultValuesEnum, isNeedRtlChecker]);
    useEffect(function () {
        if (language) {
            userSettingsStore.soundService.init({ language: language }).then(function () {
                updateLoading({ isSoundLoaded: true });
            });
        }
    }, [language]);
    useEffect(function () {
        if (repliedBetData && gameSpecificRepliedCallback) {
            gameSpecificRepliedCallback();
        }
        if (isRepliedGame) {
            updateLoading({ isGameInitialLoaded: true });
        }
    }, [isRepliedGame, repliedBetData, updateLoading]);
    return (React.createElement(TranslationContext.Provider, { value: translations },
        gameLoadingImages && !timerFinished && !isOneTimeTableLoads && (React.createElement(TableLoading, { forLoading: true, progress: progress, logoPG: gameLoadingImages.logoPG, bgImage: gameLoadingImages.bgImage, gameLogo: gameLoadingImages.gameLogo })),
        children));
});

var mobileWrRef;
var BettingPart = observer(function (_a) {
    _a.extraChildren;
    var betsSectionsData = betDataStore.betsSectionsData, isDoubleSectionsOpen = betDataStore.isDoubleSectionsOpen, setBetAmount = betDataStore.setBetAmount, setAutoCashOutOdd = betDataStore.setAutoCashOutOdd, setIsAmountChangeCustom = betDataStore.setIsAmountChangeCustom;
    var _c = gameStore.numPadData, sectionName = _c.sectionName, isOpenNumpad = _c.isOpenNumpad;
    var _d = __read(useClickOutside(), 2), ref = _d[0], hasClickedOutside = _d[1];
    var limits = gameConfigStore.limits;
    var t = useTranslation();
    var _e = __read(useState(limits.minBet), 2), namPudInputValue = _e[0], updateNumPudInputValue = _e[1];
    var _f = __read(useState({
        minBet: limits === null || limits === void 0 ? void 0 : limits.minBet,
        maxBet: limits === null || limits === void 0 ? void 0 : limits.maxBet,
    }), 2), dynamicNamPudLimits = _f[0], updateDynamicNumPudLimits = _f[1];
    useLayoutEffect(function () {
        mobileWrRef = document.querySelector('.mobile-wr');
    }, []);
    useEffect(function () {
        if (hasClickedOutside) {
            gameStore.setNumPadData({
                isOpen: false,
                sectionName: null,
                sectionIndex: null,
                currentInputValue: null,
            });
        }
    }, [hasClickedOutside]);
    var handleSubmit = function (isConfirmed) {
        var _a;
        var _b;
        var betAmount = numPadTypes.betAmount, autoCashOutOdd = numPadTypes.autoCashOutOdd;
        var setNumPudValueBySectionName = (_a = {},
            _a[betAmount] = function () {
                return inputValidationStore.setDefaultValueNumpad(namPudInputValue, setBetAmount, gameStore.numPadData.numPadLimits, gameStore.numPadData.sectionIndex, { invalidMin: BetResponseCode.InValidMinBet, invalidMax: BetResponseCode.InValidMaxBet });
            },
            _a[autoCashOutOdd] = function () {
                return inputValidationStore.setDefaultValueNumpad(namPudInputValue, setAutoCashOutOdd, gameStore.numPadData.numPadLimits, gameStore.numPadData.sectionIndex, {
                    invalidMin: BetResponseCode.InValidAutoCashOutOdd,
                    invalidMax: BetResponseCode.InValidMaxAutoCashOutOdd,
                });
            },
            _a);
        if (isConfirmed) {
            setNumPudValueBySectionName === null || setNumPudValueBySectionName === void 0 ? void 0 : setNumPudValueBySectionName[sectionName]();
            if (!((_b = betsSectionsData[gameStore.numPadData.sectionIndex]) === null || _b === void 0 ? void 0 : _b.isAmountChangeCustom)) {
                setIsAmountChangeCustom(true, gameStore.numPadData.sectionIndex);
            }
            gameStore.setNumPadData({
                isOpen: false,
                sectionName: null,
                sectionMarket: null,
                currentInputValue: null,
                numPadLimits: {},
            });
        }
    };
    var handleOpenNumPad = useCallback(function (event, openedNumpadName, index, numPadLimits) {
        if (index === void 0) { index = null; }
        if (numPadLimits === void 0) { numPadLimits = null; }
        updateDynamicNumPudLimits(function (state) {
            return __assign(__assign({}, state), { minBet: numPadLimits.incDec, maxBet: numPadLimits.maxValue });
        });
        if (isMobile()) {
            updateNumPudInputValue(event.target.value);
            gameStore.setNumPadData({
                isOpenNumpad: true,
                sectionName: openedNumpadName,
                sectionIndex: index,
                currentInputValue: event.target.value,
                numPadLimits: numPadLimits,
            });
        }
    }, [isOpenNumpad]);
    return (React.createElement("div", { className: 'aviabet-bet-section-wrp' },
        React.createElement(NumPadWr, { containerRef: mobileWrRef },
            React.createElement("div", { ref: ref, className: 'numpad-wr-for-outside-click' },
                React.createElement(NumPad, { t: t, isOpen: isOpenNumpad, limits: dynamicNamPudLimits, onSubmit: handleSubmit, amountValue: namPudInputValue, setAmountValue: updateNumPudInputValue }))),
        betsSectionsData.map(function (sectionData) {
            return (React.createElement(BetSectionsAvia, { key: sectionData.index, sectionData: sectionData, handleOpenNumPad: handleOpenNumPad, isDoubleSectionsOpen: isDoubleSectionsOpen })
            // <BetSectionsWrapper
            //   extraChildren={extraChildren}
            //   key={sectionData.index}
            //   sectionIndex={sectionData.index}
            //   handleOpenNumPad={handleOpenNumPad}
            //   isDoubleSectionsOpen={isDoubleSectionsOpen}
            // />
            );
        })));
});

var PlayForRealPopup = observer(function (_a) {
    var _b = _a.countForShowPopUp, countForShowPopUp = _b === void 0 ? 5 : _b, demoSwitcherAdditionalFunction = _a.demoSwitcherAdditionalFunction, popupLogo = _a.popupLogo, forBogLine = _a.forBogLine;
    var t = useTranslation();
    var demoSwitcher = applicationStore.demoSwitcher;
    var setDemoBetsCount = popupStore.setDemoBetsCount, demoBetsCount = popupStore.demoBetsCount;
    var PlayForReal = TranslationKeys.PlayForReal, Play = TranslationKeys.Play;
    var Close = IconTypes.Close, CloseX = IconTypes.CloseX;
    useEffect(function () {
        return function () { return setDemoBetsCount(0); };
    }, [setDemoBetsCount]);
    return (React.createElement(React.Fragment, null, demoBetsCount >= countForShowPopUp ? (React.createElement("div", { className: 'pgc-demo-popup-holder' },
        React.createElement("div", { className: 'pgc-demo-popup' },
            React.createElement("div", { className: 'pgc-demo-logo-holder' },
                React.createElement("img", { src: popupLogo, alt: 'logo' })),
            React.createElement("div", { className: 'pgc-close-demo-popup', onClick: function () { return setDemoBetsCount(0); } },
                React.createElement("i", { className: forBogLine ? "ui-lib-".concat(CloseX) : "icon-".concat(Close) })),
            React.createElement("div", { className: 'pgc-demo-txt-holder' },
                React.createElement("p", { className: 'pgc-demo-txt', title: 'play for real' }, t(PlayForReal))),
            React.createElement("div", { className: 'pgc-demo-btn-holder' },
                React.createElement("button", { type: 'button', className: 'pgc-demo-btn', onClick: function () { return demoSwitcher(demoSwitcherAdditionalFunction); } }, t(Play)))))) : (React.createElement(React.Fragment, null, " "))));
});

var FreeBetSlider = observer(function (_a) {
    var thumbnails = _a.thumbnails, isBigSliderView = _a.isBigSliderView;
    var httpFilesUrl = environmentBuilder().httpFilesUrl;
    var t = useTranslation();
    var _b = __read(useState(0), 2), selectedIndex = _b[0], setSelectedIndex = _b[1];
    var _c = __read(useState(0), 2), allItemIndex = _c[0], setAllItemIndex = _c[1];
    var checkNext = useCallback(function () {
        var labels = document.querySelectorAll('#slider label');
        setAllItemIndex(function (prev) {
            return prev === thumbnails.length - 1 ? 0 : prev + 1;
        });
        setSelectedIndex(function (prev) { return (prev === labels.length - 1 ? 0 : prev + 1); });
    }, [thumbnails.length]);
    var checkPrev = useCallback(function () {
        var labels = document.querySelectorAll('#slider label');
        setAllItemIndex(function (prev) {
            return prev === 0 ? thumbnails.length - 1 : prev - 1;
        });
        setSelectedIndex(function (prev) { return (prev === 0 ? labels.length - 1 : prev - 1); });
    }, [thumbnails.length]);
    var slideImages = useMemo(function () {
        if (!allItemIndex) {
            return [thumbnails[thumbnails.length - 1], thumbnails[allItemIndex], thumbnails[allItemIndex + 1]];
        }
        if (allItemIndex + 1 === thumbnails.length) {
            return [thumbnails[allItemIndex - 1], thumbnails[allItemIndex], thumbnails[0]];
        }
        return [thumbnails[allItemIndex - 1], thumbnails[allItemIndex], thumbnails[allItemIndex + 1]];
    }, [allItemIndex, thumbnails]);
    var sortedSlideImage = useMemo(function () {
        if (selectedIndex === 1) {
            return [slideImages[0], slideImages[1], slideImages[2]];
        }
        if (selectedIndex === 2) {
            return [slideImages[2], slideImages[0], slideImages[1]];
        }
        return [slideImages[1], slideImages[2], slideImages[0]];
    }, [slideImages, selectedIndex]);
    var handleChangeGame = useCallback(function (gameId) {
        iframeService.sendPgChangeGame(gameId);
    }, []);
    var freeChipSliderWrpClassNames = classNames('free-chip-slider-wrp', {
        'big-view': isBigSliderView,
        'small-view': !isBigSliderView,
    });
    return (React.createElement("div", { className: freeChipSliderWrpClassNames },
        React.createElement("p", { className: 'free-bet-slider-txt' }, t(TranslationKeys.YouCanAlsoPlayFollowingGames)),
        React.createElement("div", { className: 'free-bet-slider-main-wrp' }, thumbnails.length > 3 ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'free-bet-slider-btn left', onClick: checkPrev },
                React.createElement("span", { className: 'arrow-left' })),
            React.createElement("div", { className: 'free-chip-slider-cont' },
                React.createElement("div", { id: 'slider', className: 'free-chip-slider-bl' },
                    slideImages.map(function (item, index) { return (React.createElement("input", { key: "s".concat(index + 1), onChange: function () { }, type: 'radio', name: 'slider', id: "s".concat(index + 1), checked: selectedIndex === index })); }),
                    slideImages.map(function (item, index) { return (React.createElement("label", { htmlFor: "s".concat(index + 1), id: "slide".concat(index + 1), key: "slide".concat(index + 1) },
                        React.createElement("img", { onClick: function () { return handleChangeGame(sortedSlideImage[index].gameId); }, src: "".concat(httpFilesUrl, "/").concat(sortedSlideImage[index].thumbnail), alt: 'thumbnail', height: '100%', width: '100%' }))); }))),
            React.createElement("div", { className: 'free-bet-slider-btn right', onClick: checkNext },
                React.createElement("span", { className: 'arrow-right' })))) : (React.createElement("div", { className: "not-slide count-".concat(thumbnails.length) }, thumbnails.map(function (item) { return (React.createElement("img", { id: item.thumbnail, key: item.thumbnail, onClick: function () { return handleChangeGame(item.gameId); }, src: "".concat(httpFilesUrl, "/").concat(item.thumbnail), alt: 'thumbnail', height: '100%', width: '100%' })); }))))));
});

var FreeBetPopup = observer(function (_a) {
    var count = _a.count, betAmount = _a.betAmount, minOdd = _a.minOdd, maxPayout = _a.maxPayout, selectFreeBet = _a.selectFreeBet, handleClosePopUp = _a.handleClosePopUp, notificationFreeBet = _a.notificationFreeBet, expiredDateNotification = _a.expiredDateNotification, freeBetId = _a.freeBetId, isFreeChip = _a.isFreeChip, thumbnails = _a.thumbnails;
    var t = useTranslation();
    var freeChipContainerClassNames = classNames('free-chip-container', {
        freebet: !isFreeChip,
    });
    return (React.createElement("div", { className: 'free-bet-popup-wr' },
        React.createElement("div", { className: freeChipContainerClassNames },
            React.createElement("div", { className: 'box-container' },
                React.createElement("span", null, count)),
            React.createElement("div", { className: 'chips-bg-block' }),
            React.createElement("div", { className: 'free-chip-info' },
                React.createElement("h3", null, t(isFreeChip ? TranslationKeys.FreeChip : TranslationKeys.FreeBet)),
                React.createElement("div", { className: 'congrat-text' }, notificationFreeBet),
                React.createElement("h4", null, getAmountWithCurrency({ amount: betAmount, isShowRealCurrency: true })),
                minOdd && (React.createElement("p", { className: 'odd-info' },
                    t(TranslationKeys.MinOdd),
                    ": x",
                    minOdd)),
                maxPayout && (React.createElement("p", { className: 'odd-info' },
                    t(TranslationKeys.MaxPayout),
                    ": ",
                    maxPayout)),
                React.createElement("p", { className: 'use-date-i' }, expiredDateNotification),
                React.createElement("div", { className: 'btn-area-bl' },
                    React.createElement("button", { className: 'green-btn-ok', onClick: function () { return selectFreeBet(freeBetId); } },
                        React.createElement("span", null, t(TranslationKeys.UseNow)))),
                React.createElement("div", { className: 'use-later' },
                    React.createElement("span", { onClick: function () { return handleClosePopUp(freeBetId); } }, t(TranslationKeys.UseLater)))),
            !!(thumbnails === null || thumbnails === void 0 ? void 0 : thumbnails.length) && React.createElement(FreeBetSlider, { thumbnails: thumbnails }))));
});

var FreeBetStatus = observer(function (_a) {
    var amount = _a.amount, useLater = _a.useLater, freeBetId = _a.freeBetId, thumbnails = _a.thumbnails, useLaterText = _a.useLaterText, showUseNowBtn = _a.showUseNowBtn, selectFreeBet = _a.selectFreeBet, useFreeBetText = _a.useFreeBetText, handleUseLater = _a.handleUseLater, isFreeBetEnded = _a.isFreeBetEnded, freeBetTextBool = _a.freeBetTextBool, freeBetEndedTitle = _a.freeBetEndedTitle, finishedFreeBetText = _a.finishedFreeBetText, freeBetMessageTitle = _a.freeBetMessageTitle, freeBetFinishedTitle = _a.freeBetFinishedTitle;
    return (React.createElement("div", { className: "free-bet-status active ".concat(isFreeBetEnded ? 'ended' : 'cost', " ").concat(!(thumbnails === null || thumbnails === void 0 ? void 0 : thumbnails.length) ? 'without-thumbnails' : '') },
        freeBetEndedTitle ? React.createElement("p", { className: 'free-bet-status-title' }, freeBetFinishedTitle) : '',
        React.createElement("p", { className: 'free-bet-status-text' }, freeBetMessageTitle),
        React.createElement("p", { className: 'free-bet-status-win-count' }, getAmountWithCurrency({ amount: amount, isShowRealCurrency: true })),
        showUseNowBtn ? (React.createElement("button", { className: 'free-bet-status-button', type: 'button', onClick: function () { return selectFreeBet(freeBetId); } }, useFreeBetText)) : (''),
        freeBetTextBool ? React.createElement("p", { className: 'free-bet-status-txt' }, finishedFreeBetText) : '',
        useLater ? (React.createElement("div", { onClick: function () { return handleUseLater(freeBetId); } },
            React.createElement("p", { className: 'free-bet-status-use-txt' }, useLaterText))) : (''),
        !!(thumbnails === null || thumbnails === void 0 ? void 0 : thumbnails.length) && React.createElement(FreeBetSlider, { thumbnails: thumbnails })));
});

var PopupInnerActions;
(function (PopupInnerActions) {
    PopupInnerActions["Next"] = "NEXT";
})(PopupInnerActions || (PopupInnerActions = {}));
var FreeBetsListInfoWrapper = observer(function (_a) {
    var freeBetsList = _a.freeBetsList, selectFreeBet = _a.selectFreeBet, handleClosePopUp = _a.handleClosePopUp, selectedFreeBetId = _a.selectedFreeBetId, freeBetsRef = _a.freeBetsRef, additionalSliderComponents = _a.additionalSliderComponents, isFreeChip = _a.isFreeChip, isBogLine = _a.isBogLine;
    var t = useTranslation();
    var _b = __read(useState(null), 2), infoData = _b[0], setInfoData = _b[1];
    var _c = __read(useState(0), 2), infoSliderIndex = _c[0], setInfoSliderIndex = _c[1];
    var handleInfoData = useCallback(function (evt, item, actionName) {
        if (actionName !== PopupInnerActions.Next && !infoSliderIndex) {
            evt.stopPropagation();
            setInfoData(item);
        }
        else {
            setInfoSliderIndex(function (prevState) { return (actionName === PopupInnerActions.Next ? prevState + 1 : prevState - 1); });
        }
    }, [setInfoData, infoSliderIndex]);
    var activeSliderComps = useMemo(function () {
        var _a;
        var sliderComps = [
            React.createElement(FreeBetInfo, { t: t, infoData: infoData, selectFreeBet: selectFreeBet, selectedFreeBetId: selectedFreeBetId }),
        ];
        if (((_a = infoData === null || infoData === void 0 ? void 0 : infoData.thumbnails) === null || _a === void 0 ? void 0 : _a.length) &&
            (infoData === null || infoData === void 0 ? void 0 : infoData.status) !== FreeBetsStatus.Finished &&
            (infoData === null || infoData === void 0 ? void 0 : infoData.status) !== FreeBetsStatus.Expired &&
            (infoData === null || infoData === void 0 ? void 0 : infoData.remainingCount)) {
            sliderComps.push(React.createElement(FreeBetSlider, { thumbnails: infoData.thumbnails }));
        }
        if (additionalSliderComponents) {
            var index = additionalSliderComponents.index, component = additionalSliderComponents.component;
            sliderComps.splice(+index, 0, component);
        }
        return sliderComps;
    }, [t, infoData, selectFreeBet, selectedFreeBetId, additionalSliderComponents]);
    var freeBetsWrapClassNames = classNames('free-bets-wrap active', {
        'chip-bg': isFreeChip,
    });
    return (React.createElement("div", { className: freeBetsWrapClassNames, ref: freeBetsRef },
        React.createElement("div", { className: 'free-bets-wr-top' },
            infoData && (React.createElement("div", { className: 'free-bet-info-left-icon', onClick: function (evt) { return handleInfoData(evt, null); } },
                React.createElement("i", { className: 'ui-lib-back' }))),
            React.createElement("div", { className: "free-bets-wr-title ".concat(infoData ? 'no-padding' : '') }, t(infoData ? TranslationKeys.FreeBetInfo : TranslationKeys.FreeBets)),
            (infoSliderIndex === activeSliderComps.length - 1 || !infoData) && (React.createElement("div", { className: 'free-bets-close-icon', onClick: handleClosePopUp },
                React.createElement("i", { className: 'ui-lib-close-x' }))),
            infoData && infoSliderIndex < activeSliderComps.length - 1 && (React.createElement("div", { className: 'free-bet-info-left-icon', onClick: function (evt) { return handleInfoData(evt, null, PopupInnerActions.Next); } },
                React.createElement("i", { className: "ui-lib-next" })))),
        !infoData ? (React.createElement(FreeBetsList, { t: t, isBogLine: isBogLine, freeBetsList: freeBetsList, selectFreeBet: selectFreeBet, handleInfoData: handleInfoData, selectedFreeBetId: selectedFreeBetId })) : (activeSliderComps[infoSliderIndex])));
});

var LobbyFreeBetsPopUpWrapper = observer(function (_a) {
    var gameTypeId = _a.gameTypeId, redirectInGamePath = _a.redirectInGamePath, isFreeChip = _a.isFreeChip;
    var freeBets = freeBetStore.freeBets, awardedFreeBet = freeBetStore.awardedFreeBet, freeBetsStatusChanger = freeBetStore.freeBetsStatusChanger, setActivateFreeBet = freeBetStore.setActivateFreeBet, setAwardedFreeBet = freeBetStore.setAwardedFreeBet;
    var userId = userInfoStore.userId;
    var gameTypes = lobbyStore.gameTypes;
    var _b = useLocation(), search = _b.search, pathname = _b.pathname;
    var navigate = useNavigate();
    var t = useTranslation();
    var _c = __read(useState(false), 2), openFreeBetPopUp = _c[0], setOpenFreeBetPopUp = _c[1];
    useEffect(function () {
        if (awardedFreeBet) {
            setTimeout(function () {
                setOpenFreeBetPopUp(true);
            }, 50);
        }
    }, [awardedFreeBet]);
    var handleCloseLobbyPopUp = useCallback(function () {
        setOpenFreeBetPopUp(false);
    }, [setOpenFreeBetPopUp]);
    var selectFreeBet = function (freeBetId) {
        var useFreeBetItem = freeBets.find(function (freeBetItem) { return freeBetItem.id === freeBetId; });
        if (useFreeBetItem.status === FreeBetsStatus.Pending) {
            freeBetsStatusChanger(freeBetId);
            setActivateFreeBet(useFreeBetItem);
        }
        handleCloseLobbyPopUp();
        navigate(redirectInGamePath || "".concat(pathname, "game").concat(search, "&gameTypeId=").concat(gameTypeId || gameTypes[0].gameTypeId));
    };
    var handlePopUpUseLater = function (freeBetId) {
        var useFreeBetItem = freeBets.find(function (freeBetItem) { return freeBetItem.id === freeBetId; });
        if (useFreeBetItem === null || useFreeBetItem === void 0 ? void 0 : useFreeBetItem.remainingCount) {
            freeBetsStatusChanger(freeBetId);
        }
        else {
            setAwardedFreeBet(null);
        }
        handleCloseLobbyPopUp();
    };
    return (React.createElement(React.Fragment, null, openFreeBetPopUp && userId && awardedFreeBet ? (React.createElement(FreeBetPopup, { thumbnails: awardedFreeBet.thumbnails, count: awardedFreeBet.count, isFreeChip: isFreeChip, selectFreeBet: selectFreeBet, freeBetId: awardedFreeBet.id, minOdd: awardedFreeBet.minOdd, maxPayout: awardedFreeBet === null || awardedFreeBet === void 0 ? void 0 : awardedFreeBet.maxPayout, handleClosePopUp: handlePopUpUseLater, betAmount: awardedFreeBet.amount * awardedFreeBet.count, expiredDateNotification: setTranslationValues(t(TranslationKeys.YouCanUseItTill), {
            endDate: "".concat(awardedFreeBet.expireDateFreeBet, " ").concat(awardedFreeBet.expiredTime),
        }), notificationFreeBet: setTranslationValues(t(TranslationKeys.CongratulationsFreeBetsInTotalCost), {
            freeBetCount: awardedFreeBet.count,
        }) })) : (React.createElement(React.Fragment, null))));
});

var hasFreeBetsOrAtLeastOneFreeBetNotExpired = function (isFromSettings) {
    var freeBets = freeBetStore.freeBets;
    var isDemo = applicationStore.isDemo;
    if (isDemo) {
        return false;
    }
    if (freeBets && freeBets.length) {
        var isNotExpiredFreeBetExist = freeBets.some(function (item) { return item.status !== FreeBetsStatus.Expired; });
        return (isFromSettings && !isNotExpiredFreeBetExist) || (!isFromSettings && isNotExpiredFreeBetExist);
    }
    return false;
};
var FreeBetInnerComponent = observer(function (_a) {
    var additionalSliderComponents = _a.additionalSliderComponents, isFromSettings = _a.isFromSettings, isOpenedFromParentComponent = _a.isOpenedFromParentComponent, changeIsOpenedFromParentComponent = _a.changeIsOpenedFromParentComponent;
    var t = useTranslation();
    var _b = __read(useClickOutside(), 2), freeBetsRef = _b[0], hasFreeBetsContainerClickedOutside = _b[1];
    var _c = __read(useState(false), 2), freeBetContainerOpened = _c[0], setFreeBetContainerOpened = _c[1];
    var freeBets = freeBetStore.freeBets, freeBetEnded = freeBetStore.freeBetEnded, selectFreeBet = freeBetStore.selectFreeBet, activeFreeBet = freeBetStore.activeFreeBet, awardedFreeBet = freeBetStore.awardedFreeBet, handleUseLater = freeBetStore.handleUseLater, unUseFreeBetCount = freeBetStore.unUseFreeBetCount, selectFreeBetInStatus = freeBetStore.selectFreeBetInStatus, isFreeChip = freeBetStore.isFreeChip;
    var isBogLine = applicationStore.isBogLine;
    var handleFreeBetContainerOpenerClick = useCallback(function () {
        setFreeBetContainerOpened(function (prevState) { return !prevState; });
    }, []);
    useEffect(function () {
        if (hasFreeBetsContainerClickedOutside) {
            setFreeBetContainerOpened(false);
            if (changeIsOpenedFromParentComponent) {
                changeIsOpenedFromParentComponent();
            }
        }
    }, [hasFreeBetsContainerClickedOutside, changeIsOpenedFromParentComponent]);
    return (React.createElement(React.Fragment, null,
        !isFromSettings && (React.createElement(UserBlockFreeBet, { freeBetCount: unUseFreeBetCount, handleFreeBetOpen: handleFreeBetContainerOpenerClick, notAllowToClick: freeBetContainerOpened })),
        (isOpenedFromParentComponent || freeBetContainerOpened) && !awardedFreeBet && (React.createElement(FreeBetsListInfoWrapper, { additionalSliderComponents: additionalSliderComponents, freeBetsList: freeBets, isFreeChip: isFreeChip, isBogLine: isBogLine, selectFreeBet: selectFreeBet, handleClosePopUp: function () {
                return changeIsOpenedFromParentComponent
                    ? changeIsOpenedFromParentComponent()
                    : handleFreeBetContainerOpenerClick();
            }, selectedFreeBetId: activeFreeBet.id, freeBetsRef: freeBetsRef })),
        awardedFreeBet && (React.createElement(FreeBetStatus, { useLater: true, showUseNowBtn: true, thumbnails: awardedFreeBet.thumbnails, freeBetId: awardedFreeBet.id, handleUseLater: handleUseLater, useFreeBetText: t(TranslationKeys.UseNow), useLaterText: t(TranslationKeys.UseLater), selectFreeBet: selectFreeBetInStatus, freeBetMessageTitle: "".concat(awardedFreeBet.count, " ").concat(t(TranslationKeys.FreeBetsInCost)), amount: "".concat(parseNumberByPrecision(awardedFreeBet.count, awardedFreeBet.amount)) })),
        freeBetEnded && (React.createElement(FreeBetStatus, { freeBetTextBool: true, freeBetEndedTitle: true, amount: freeBetEnded.totalWin, freeBetMessageTitle: t(TranslationKeys.YouHaveWon), freeBetFinishedTitle: t(TranslationKeys.FreeBetHasEnded), finishedFreeBetText: t(TranslationKeys.YouWillBeNowPlayingWithRealMoney) }))));
});
var FreeBetsWrapper = observer(function (_a) {
    var FreeBetParentWrapper = _a.parentWrapper, additionalSliderComponents = _a.additionalSliderComponents, isFromSettings = _a.isFromSettings, isOpenedFromParentComponent = _a.isOpenedFromParentComponent, changeIsOpenedFromParentComponent = _a.changeIsOpenedFromParentComponent;
    return hasFreeBetsOrAtLeastOneFreeBetNotExpired(isFromSettings) ? (FreeBetParentWrapper ? (React.createElement(FreeBetParentWrapper, null,
        React.createElement(FreeBetInnerComponent, { isFromSettings: isFromSettings, additionalSliderComponents: additionalSliderComponents, isOpenedFromParentComponent: isOpenedFromParentComponent, changeIsOpenedFromParentComponent: changeIsOpenedFromParentComponent }))) : (React.createElement(FreeBetInnerComponent, { isFromSettings: isFromSettings, additionalSliderComponents: additionalSliderComponents, isOpenedFromParentComponent: isOpenedFromParentComponent, changeIsOpenedFromParentComponent: changeIsOpenedFromParentComponent }))) : (React.createElement(React.Fragment, null));
});

export { BetNotification as $, Avatars as A, BettingPart as B, CollapsibleSettingsList as C, SettingsContainer as D, CurrentWinnersContainer as E, FreeBetPopup as F, GameResults as G, TopWinnersContainer as H, TopAndCurrentWinners as I, LiveBetsContainer as J, BetHistoryContainer as K, LobbyWrapper as L, MaxWinPopup as M, NumPad as N, MobileNavigation as O, PlayForRealPopup as P, MobileWrapper as Q, RightContainer as R, SliderWrapper as S, Timer as T, UserId as U, MobileHeader as V, WebGameMainCont as W, HeaderCenter as X, ConnectionPopupsWr as Y, UnderMaintenanceWr as Z, SlowConnectionWr as _, LoadingContainer as a, BetNotificationWr as a0, generateMessage as a1, AvatarsWr as a2, ChatWr as a3, TopCollapsibleSettingsWrapper as a4, CurrentWinners as a5, MobileLobbyHeader as a6, LobbyRoom as a7, MainWr as a8, RoundId as a9, MobileFooter as aA, PlayForRealButton as aB, WebFooter as aC, OverlayContainer as aD, MobileChangeGameTypeSection as aE, BetHistoryHeader as aF, BetHistoryContent as aG, SelectedRowWr as aH, CollapsibleListComponentsType as aI, ChatHeader as aJ, ChatFooter as aK, QuickMessages as aL, UserMessage as aM, UserMessageList as aN, ChatEmoji as aO, GiphyGrid as aP, ChatPopovers as aQ, Chat as aR, NavItems as aS, GameTypeItem as aT, GameTypesPopup as aU, Lobby as aV, FreeBetSlider as aW, CurrentTime as aa, PlayingUsersCount as ab, ChangeGameTypeSection as ac, OverlayItemHeader as ad, TablePopUpWr as ae, RightSideHolder as af, TableMobileNavigation as ag, FairnessFormGroupWr as ah, TableUsersWinBets as ai, UserWinBet as aj, Header as ak, TableFooter as al, Settings as am, Sidebar as an, TableMobileHeader as ao, TablePopUpContainer as ap, GameControllers as aq, FairnessFormGroup as ar, LobbyRoomsContainer as as, TableConnectionPopupsWr as at, BetHistory as au, ChipsContainer as av, TableBetNotification as aw, FreeChipsWinPopup as ax, LobbyTimer as ay, LobbyRoomRow as az, FreeBetStatus as b, FreeBetsWrapper as c, FreeBetsListInfoWrapper as d, LobbyFreeBetsPopUpWrapper as e, FreeBetMaxPayoutPopUp as f, LimitsBlock as g, hasFreeBetsOrAtLeastOneFreeBetNotExpired as h, PopupWr as i, SettingsBlock as j, UserBalance as k, UserBlockImage as l, SlowConnection as m, UnderMaintenance as n, CheckHashPopup as o, FairnessPopup as p, LobbyItemBottomBlock as q, LobbyItemTopBlock as r, LobbyItem as s, BogLobby as t, GameHighestResults as u, LeftContainerFooter as v, LeftContainerHeader as w, Statistics as x, RightContainerHeader as y, RightContainerFooter as z };
